import { ActionTypes } from "../Action Types"

const data = {
    HI: {
        STATE_RJ_CITY_0: "आभानेरी",
        STATE_AS_CITY_1: "अभयपुरी",
        STATE_TN_CITY_2: "अबीरामम",
        STATE_PB_CITY_3: "अबोहर",
        STATE_GJ_CITY_4: "अब्रामा",
        STATE_RJ_CITY_5: "अबू",
        STATE_RJ_CITY_6: "आबूरोड",
        STATE_MH_CITY_7: "अचलपुर",
        STATE_UP_CITY_8: "अछनेरा",
        STATE_GJ_CITY_9: "अडालज",
        STATE_PB_CITY_10: "आदमपुर",
        STATE_MH_CITY_11: "अदवद",
        STATE_AP_CITY_12: "Addanki",
        STATE_TG_CITY_13: "आदिलाबाद",
        STATE_TN_CITY_14: "आदिरामपट्टिनम",
        STATE_AP_CITY_15: "अदोनी",
        STATE_KL_CITY_16: "Adur",
        STATE_TN_CITY_17: "अदुथुराई",
        STATE_UP_CITY_18: "अफजलगढ़",
        STATE_KA_CITY_19: "अफजलपुर",
        STATE_MP_CITY_20: "आगर",
        STATE_MH_CITY_21: "आगर पंचैतन",
        STATE_TR_CITY_22: "अगरतला",
        STATE_GJ_CITY_23: "अगोल",
        STATE_UP_CITY_24: "आगरा",
        STATE_MH_CITY_25: "अहेरी",
        STATE_MH_CITY_26: "अहिरी",
        STATE_MH_CITY_27: "अहमदनगर",
        STATE_MH_CITY_28: "अहमदपुर",
        STATE_GJ_CITY_29: "अहमदाबाद",
        STATE_MH_CITY_30: "अहमदनगर",
        STATE_WB_CITY_31: "अहमदपुर",
        STATE_UP_CITY_32: "अहरौरा",
        STATE_GJ_CITY_33: "अहवा",
        STATE_UP_CITY_34: "ऐदलपुर",
        STATE_MH_CITY_35: "ऐरोली",
        STATE_UP_CITY_36: "ऐरवा",
        STATE_WB_CITY_37: "ऐस्ताला",
        STATE_MZ_CITY_38: "आइजोल",
        STATE_MP_CITY_39: "अजयगढ़",
        STATE_PB_CITY_40: "अजीतगढ़",
        STATE_KA_CITY_41: "अज्जम्पुर",
        STATE_RJ_CITY_42: "अजमेर",
        STATE_PB_CITY_43: "अजनाला",
        STATE_MH_CITY_44: "अजरा",
        STATE_PB_CITY_45: "अकालगढ़",
        STATE_MH_CITY_46: "अकालकोट",
        STATE_CT_CITY_47: "अकलतरा",
        STATE_AP_CITY_48: "अकासाहेबपेट",
        STATE_UP_CITY_49: "अकबरपुर",
        STATE_JK_CITY_50: "अखनूर",
        STATE_AP_CITY_51: "अकिविडु",
        STATE_MH_CITY_52: "अक्कलकोट",
        STATE_AP_CITY_53: "अक्करमपल्ले",
        STATE_RJ_CITY_54: "अकलेरा",
        STATE_MH_CITY_55: "अकलुज",
        STATE_WB_CITY_56: "अकनापुर",
        STATE_MP_CITY_57: "अकोदिया",
        STATE_MH_CITY_58: "अकोला",
        STATE_UP_CITY_59: "अकोला",
        STATE_MH_CITY_60: "अकोलनेर",
        STATE_MH_CITY_61: "अकोट",
        STATE_MH_CITY_62: "अक्रानी",
        STATE_GJ_CITY_63: "अक्रुंद",
        STATE_TN_CITY_64: "अलगापुरम",
        STATE_MP_CITY_65: "आलमपुर",
        STATE_TG_CITY_66: "आलमपुर",
        STATE_KA_CITY_67: "भूमि",
        STATE_MH_CITY_68: "आलंदी",
        STATE_TN_CITY_69: "अलान्दुर",
        STATE_TN_CITY_70: "अलंगनल्लूर",
        STATE_TN_CITY_71: "अलंगयम",
        STATE_TN_CITY_72: "अलंगुडी",
        STATE_TN_CITY_73: "अलंगुलम",
        STATE_TN_CITY_74: "Alapakkam",
        STATE_KL_CITY_75: "अलपुझा",
        STATE_PB_CITY_76: "अलावलपुर",
        STATE_GA_CITY_77: "एल्डोना",
        STATE_MH_CITY_78: "यवसुरा",
        STATE_MH_CITY_79: "अलीबाग",
        STATE_UP_CITY_80: "अलीगंज",
        STATE_UP_CITY_81: "अलीगढ",
        STATE_DL_CITY_82: "अलीपुर",
        STATE_WB_CITY_83: "अलीपुरद्वार",
        STATE_MP_CITY_84: "आलीराजपुर",
        STATE_MH_CITY_85: "अलकुटी",
        STATE_UP_CITY_86: "इलाहाबाद",
        STATE_UP_CITY_87: "अल्लाहगंज",
        STATE_MH_CITY_88: "अल्लापल्ली",
        STATE_UT_CITY_89: "अल्मोडा",
        STATE_KA_CITY_90: "अलनावर",
        STATE_AR_CITY_91: "साथ में",
        STATE_MP_CITY_92: "बहुत",
        STATE_KA_CITY_93: "अलूर",
        STATE_KL_CITY_94: "अलुवा",
        STATE_TN_CITY_95: "अलवा तिरुनगरी",
        STATE_RJ_CITY_96: "अलवर",
        STATE_KL_CITY_97: "अलवाए",
        STATE_AP_CITY_98: "अमलापुरम",
        STATE_MH_CITY_99: "अमलनेर",
        STATE_MP_CITY_100: "अमानगंज",
        STATE_UP_CITY_101: "अमांपुर",
        STATE_MP_CITY_102: "अमरकंटक",
        STATE_MH_CITY_103: "अमरनाथ",
        STATE_MP_CITY_104: "अमरपाटन",
        STATE_BR_CITY_105: "अमरपुर",
        STATE_TR_CITY_106: "अमरपुर",
        STATE_MP_CITY_107: "अमरवाड़ा",
        STATE_UP_CITY_108: "अमौली",
        STATE_MH_CITY_109: "अम्बाद",
        STATE_CT_CITY_110: "अम्बागढ़ चौकी",
        STATE_MP_CITY_111: "अम्बाह",
        STATE_UP_CITY_112: "अंबाहटा",
        STATE_MH_CITY_113: "अंबाजोगाई",
        STATE_HR_CITY_114: "अंबाला",
        STATE_MH_CITY_115: "अम्बरनाथ",
        STATE_TR_CITY_116: "अंबासा",
        STATE_TN_CITY_117: "अम्बसमुद्रम",
        STATE_TN_CITY_118: "अंबात्तुर",
        STATE_UP_CITY_119: "अंबेडकरनगर",
        STATE_MH_CITY_120: "अंबेगांव",
        STATE_CT_CITY_121: "अंबिकापुर",
        STATE_TN_CITY_122: "अम्बुर",
        STATE_RJ_CITY_123: "अमेट",
        STATE_UP_CITY_124: "अमेठी",
        STATE_MH_CITY_125: "आमगांव",
        STATE_AS_CITY_126: "अमगुरी",
        STATE_MP_CITY_127: "अमला",
        STATE_WB_CITY_128: "अमलगोरा",
        STATE_DN_CITY_129: "अमली",
        STATE_PB_CITY_130: "अमलोह",
        STATE_TN_CITY_131: "अम्मापेट्टई",
        STATE_GJ_CITY_132: "अमोद",
        STATE_GJ_CITY_133: "आमोद,",
        STATE_MH_CITY_134: "अमरावती",
        STATE_MH_CITY_135: "अमरावती प्रभाग",
        STATE_GJ_CITY_136: "अमरेली",
        STATE_PB_CITY_137: "अमृतसर",
        STATE_UP_CITY_138: "अमरोहा",
        STATE_GJ_CITY_139: "अमरोली",
        STATE_WB_CITY_140: "अमता",
        STATE_WB_CITY_141: "अमतला",
        STATE_AP_CITY_142: "अमुदालावलसा",
        STATE_AP_CITY_143: "अनकापल्ली",
        STATE_TN_CITY_144: "अनामलाई",
        STATE_GJ_CITY_145: "आनंद",
        STATE_UP_CITY_146: "आनंदनगर",
        STATE_PB_CITY_147: "आनंदपुर साहिब",
        STATE_AP_CITY_148: "अनंतपुर",
        STATE_JK_CITY_149: "अनंतनाग",
        STATE_WB_CITY_150: "अंदल",
        STATE_MH_CITY_151: "अंधेरी",
        STATE_TN_CITY_152: "अंडीपट्टी",
        STATE_TG_CITY_153: "अंडोल",
        STATE_MH_CITY_154: "अन्दुरा",
        STATE_KA_CITY_155: "अनेकाल",
        STATE_KL_CITY_156: "अंगमाली",
        STATE_OR_CITY_157: "अंगुल",
        STATE_OR_CITY_158: "अंगुल जिला",
        STATE_MP_CITY_159: "अंजड़",
        STATE_MH_CITY_160: "अंजनगांव",
        STATE_GJ_CITY_161: "अंजार",
        STATE_MH_CITY_162: "अंजरले",
        STATE_AR_CITY_163: "अंजाव",
        STATE_GJ_CITY_164: "अंकलेश्वर",
        STATE_KA_CITY_165: "अंकोला",
        STATE_TN_CITY_166: "अन्नामलाई नगर",
        STATE_TN_CITY_167: "अन्नवासल",
        STATE_KA_CITY_168: "अन्निगेरी",
        STATE_TN_CITY_169: "अन्नूर",
        STATE_MH_CITY_170: "अंशिंग",
        STATE_RJ_CITY_171: "अन्ता",
        STATE_TN_CITY_172: "Anthiyur",
        STATE_MP_CITY_173: "आंत्री",
        STATE_UP_CITY_174: "अंतू",
        STATE_RJ_CITY_175: "अनूपगढ़",
        STATE_MP_CITY_176: "अनुपपुर",
        STATE_UP_CITY_177: "अनूपशहर",
        STATE_UP_CITY_178: "आंवला",
        STATE_MH_CITY_179: "मज़ाक",
        STATE_TN_CITY_180: "अराकोणम",
        STATE_WB_CITY_181: "आरामबाग सामुदायिक विकास खंड",
        STATE_GA_CITY_182: "अरामबोल",
        STATE_CT_CITY_183: "आरंग",
        STATE_MH_CITY_184: "अरनगांव",
        STATE_TN_CITY_185: "Aranthangi",
        STATE_BR_CITY_186: "अररिया",
        STATE_UP_CITY_187: "अरौल",
        STATE_TN_CITY_188: "अर्काट",
        STATE_MH_CITY_189: "अर्धपुर",
        STATE_MH_CITY_190: "अरगांव",
        STATE_TN_CITY_191: "अरिमलम",
        STATE_TN_CITY_192: "अरियालूर",
        STATE_KA_CITY_193: "अरकलागुद",
        STATE_HP_CITY_194: "अर्की",
        STATE_TN_CITY_195: "अर्नी",
        STATE_MP_CITY_196: "एरन",
        STATE_KL_CITY_197: "अरूर",
        STATE_BR_CITY_198: "आरा",
        STATE_KA_CITY_199: "अर्सिकेरे",
        STATE_MH_CITY_200: "कलाकार गांव",
        STATE_KL_CITY_201: "अरुकुट्टी",
        STATE_TN_CITY_202: "अरुम्बावुर",
        STATE_TN_CITY_203: "अरुमुगनेरी",
        STATE_TN_CITY_204: "अरुप्पुक्कोट्टई",
        STATE_TN_CITY_205: "अरुवंकड",
        STATE_MH_CITY_206: "अरवी",
        STATE_BR_CITY_207: "अरवल",
        STATE_UP_CITY_208: "असालतगंज",
        STATE_HR_CITY_209: "असंध",
        STATE_WB_CITY_210: "आसनसोल",
        STATE_BR_CITY_211: "असरगंज",
        STATE_MP_CITY_212: "अशोकनगर",
        STATE_WB_CITY_213: "अशोकनगर कल्याणगढ़",
        STATE_MH_CITY_214: "अष्ट",
        STATE_MP_CITY_215: "अष्ट",
        STATE_MH_CITY_216: "आष्टी",
        STATE_TG_CITY_217: "आसिफाबाद",
        STATE_OR_CITY_218: "असिका",
        STATE_RJ_CITY_219: "आसींद",
        STATE_MH_CITY_220: "आसौदा",
        STATE_MH_CITY_221: "परख",
        STATE_MH_CITY_222: "अस्तगांव",
        STATE_UP_CITY_223: "अतर्रा",
        STATE_HR_CITY_224: "अटेली मंडी",
        STATE_OR_CITY_225: "अथागढ़",
        STATE_KA_CITY_226: "अथनी",
        STATE_AP_CITY_227: "आत्मकुर",
        STATE_UP_CITY_228: "अतरौली",
        STATE_UP_CITY_229: "अतरौलिया",
        STATE_TN_CITY_230: "अट्टाय्यमपट्टी",
        STATE_AP_CITY_231: "अत्तिली",
        STATE_KL_CITY_232: "अट्टिंगल",
        STATE_TN_CITY_233: "अत्तूर",
        STATE_MH_CITY_234: "औंध, सतारा",
        STATE_KA_CITY_235: "औराद",
        STATE_UP_CITY_236: "औरैया",
        STATE_MH_CITY_237: "औरंगाबाद",
        STATE_BR_CITY_238: "औरंगाबाद",
        STATE_UP_CITY_239: "औरस",
        STATE_TN_CITY_240: "ऑरोविले",
        STATE_MH_CITY_241: "औसा",
        STATE_TN_CITY_242: "अवादी",
        STATE_AP_CITY_243: "अवनिगड्डा",
        STATE_KL_CITY_244: "अवनूर",
        STATE_TN_CITY_245: "अविनाशी",
        STATE_JK_CITY_246: "अवंतीपुर",
        STATE_TN_CITY_247: "अयाकुडी",
        STATE_UP_CITY_248: "अयोध्या",
        STATE_TN_CITY_249: "अय्यमपेट्टई",
        STATE_UP_CITY_250: "आजमगढ़",
        STATE_KL_CITY_251: "अझिक्कल",
        STATE_UP_CITY_252: "अजीजपुर",
        STATE_MP_CITY_253: "बाबई",
        STATE_UP_CITY_254: "बबेरू",
        STATE_UP_CITY_255: "बबीना",
        STATE_GJ_CITY_256: "बाबरा",
        STATE_UP_CITY_257: "बबराला",
        STATE_UP_CITY_258: "बाबूगढ़",
        STATE_UP_CITY_259: "बछरांव",
        STATE_UP_CITY_260: "बछरावां",
        STATE_OR_CITY_261: "बड़ा बाराबिल",
        STATE_KL_CITY_262: "बडगरा",
        STATE_KA_CITY_263: "बादामी",
        STATE_AS_CITY_264: "बदरपुर",
        STATE_MP_CITY_265: "बदरवास",
        STATE_HP_CITY_266: "बद्दी",
        STATE_JK_CITY_267: "बड़गाम",
        STATE_PB_CITY_268: "बधनी कलां",
        STATE_WB_CITY_269: "बड़कुल्ला",
        STATE_MH_CITY_270: "बदलापुर",
        STATE_MH_CITY_271: "बदनापुर",
        STATE_MP_CITY_272: "बदनावर",
        STATE_MH_CITY_273: "बडनेरा",
        STATE_WB_CITY_274: "बदुरिया",
        STATE_AP_CITY_275: "बडवेल",
        STATE_MP_CITY_276: "थैला",
        STATE_GA_CITY_277: "बागा",
        STATE_BR_CITY_278: "बगहा",
        STATE_KA_CITY_279: "बागलकोट",
        STATE_RJ_CITY_280: "बगड़",
        STATE_GJ_CITY_281: "बगसरा",
        STATE_GJ_CITY_282: "बगसरा",
        STATE_WB_CITY_283: "बागडोगरा",
        STATE_KA_CITY_284: "बागेपल्ली",
        STATE_UT_CITY_285: "बागेश्वर",
        STATE_MH_CITY_286: "बागेवाड़ी",
        STATE_PB_CITY_287: "बाघ पुराण",
        STATE_UP_CITY_288: "बागपत",
        STATE_UP_CITY_289: "बघरा",
        STATE_MP_CITY_290: "बागली",
        STATE_WB_CITY_291: "बगनान",
        STATE_JH_CITY_292: "बागरा",
        STATE_WB_CITY_293: "बगुला",
        STATE_UP_CITY_294: "बाह",
        STATE_BR_CITY_295: "बहादुरगंज",
        STATE_HR_CITY_296: "बहादुरगढ़",
        STATE_UP_CITY_297: "बहेड़ी",
        STATE_UP_CITY_298: "बहज़ोई",
        STATE_UP_CITY_299: "बहराईच",
        STATE_UP_CITY_300: "बहराइघ",
        STATE_UP_CITY_301: "बहसूमा",
        STATE_UP_CITY_302: "बहुआ",
        STATE_WB_CITY_303: "बहुला",
        STATE_WB_CITY_304: "बैद्यबती",
        STATE_MP_CITY_305: "बैहर",
        STATE_CT_CITY_306: "बैकुंठपुर",
        STATE_MP_CITY_307: "बैकुंठपुर",
        STATE_KA_CITY_308: "बेल-होंगल",
        STATE_BR_CITY_309: "बैरगनिया",
        STATE_BR_CITY_310: "बैसी",
        STATE_UP_CITY_311: "बाजना",
        STATE_RJ_CITY_312: "बकानी",
        STATE_UP_CITY_313: "बकेवर",
        STATE_GJ_CITY_314: "बखरला",
        STATE_BR_CITY_315: "बख्तियारपुर",
        STATE_PB_CITY_316: "बकलोह",
        STATE_WB_CITY_317: "बकरेश्वर",
        STATE_AS_CITY_318: "बक्सा",
        STATE_UP_CITY_319: "बक्शर",
        STATE_MP_CITY_320: "बक्शवाहो",
        STATE_PB_CITY_321: "बलाचौर",
        STATE_GJ_CITY_322: "बालागाम",
        STATE_MP_CITY_323: "बालाघाट",
        STATE_UP_CITY_324: "बालामऊ",
        STATE_OR_CITY_325: "बलांगीर",
        STATE_TG_CITY_326: "बालापुर",
        STATE_MH_CITY_327: "बालापुर",
        STATE_MH_CITY_328: "बालापुर, अकोला जिला",
        STATE_WB_CITY_329: "बलरामपुर",
        STATE_GJ_CITY_330: "बालासिनोर",
        STATE_OR_CITY_331: "बालासोर",
        STATE_UP_CITY_332: "बलदेव",
        STATE_MP_CITY_333: "बल्देवगढ़",
        STATE_UP_CITY_334: "बलदेव",
        STATE_OR_CITY_335: "बालेश्वर",
        STATE_RJ_CITY_336: "बाली",
        STATE_WB_CITY_337: "बालीचक",
        STATE_OR_CITY_338: "बालीमिला",
        STATE_GJ_CITY_339: "बालिसाना",
        STATE_MH_CITY_340: "बल्लालपुर",
        STATE_MH_CITY_341: "बैलार्ड एस्टेट",
        STATE_KA_CITY_342: "बल्लारी",
        STATE_MH_CITY_343: "बल्लारपुर",
        STATE_UP_CITY_344: "बलिया",
        STATE_WB_CITY_345: "बेअदबी से",
        STATE_CT_CITY_346: "बालोद",
        STATE_CT_CITY_347: "बलोदा",
        STATE_CT_CITY_348: "बलौदाबाजार",
        STATE_RJ_CITY_349: "बालोतरा",
        STATE_UP_CITY_350: "बलरामपुर",
        STATE_OR_CITY_351: "बालूगांव",
        STATE_WB_CITY_352: "बेलूरघाट",
        STATE_GJ_CITY_353: "बामनबोर",
        STATE_WB_CITY_354: "बामनगोला सामुदायिक विकास खंड",
        STATE_GA_CITY_355: "Bambolim",
        STATE_AN_CITY_356: "बांस का फ्लैट",
        STATE_MP_CITY_357: "बमना",
        STATE_MP_CITY_358: "बमोरकलां",
        STATE_MP_CITY_359: "बामोरा",
        STATE_OR_CITY_360: "बानापुर",
        STATE_GJ_CITY_361: "बनास कंथा",
        STATE_UP_CITY_362: "बनत",
        STATE_KA_CITY_363: "बनावर",
        STATE_UP_CITY_364: "बनबसा",
        STATE_MP_CITY_365: "बाँदा",
        STATE_UP_CITY_366: "बाँदा",
        STATE_MH_CITY_367: "बांदा, महाराष्ट्र",
        STATE_GJ_CITY_368: "बंदिया",
        STATE_RJ_CITY_369: "बांदीकुई",
        STATE_JK_CITY_370: "बांदीपुरा",
        STATE_JK_CITY_371: "बांदीपुरा",
        STATE_GA_CITY_372: "बंडोरा",
        STATE_MH_CITY_373: "बांद्रा",
        STATE_MH_CITY_374: "बानर",
        STATE_WB_CITY_375: "बाणेश्वर",
        STATE_PB_CITY_376: "बंगा",
        STATE_KA_CITY_377: "बेंगलुरु ग्रामीण",
        STATE_KA_CITY_378: "बैंगलोर शहरी",
        STATE_AP_CITY_379: "बंगानापल्ले",
        STATE_BR_CITY_380: "बनगांव",
        STATE_WB_CITY_381: "बनगांव",
        STATE_KA_CITY_382: "बंगारपेट",
        STATE_UP_CITY_383: "बांगरमऊ",
        STATE_JK_CITY_384: "बनिहाल",
        STATE_HP_CITY_385: "बंजर",
        STATE_BR_CITY_386: "बांका",
        STATE_OR_CITY_387: "बांकी",
        STATE_MH_CITY_388: "बनकोट",
        STATE_WB_CITY_389: "बांकड़ा",
        STATE_WB_CITY_390: "बांकुड़ा",
        STATE_BR_CITY_391: "बनमनखी",
        STATE_KA_CITY_392: "बन्नूर",
        STATE_OR_CITY_393: "पानपोश",
        STATE_WB_CITY_394: "Bansberia",
        STATE_UP_CITY_395: "बांसडीह",
        STATE_UP_CITY_396: "बांसगांव",
        STATE_UP_CITY_397: "बांसी",
        STATE_WB_CITY_398: "बंसीहारी सामुदायिक विकास खंड",
        STATE_TG_CITY_399: "बांसवाड़ा",
        STATE_RJ_CITY_400: "बांसवाड़ा",
        STATE_UP_CITY_401: "बंथरा",
        STATE_GJ_CITY_402: "बंटवा",
        STATE_KA_CITY_403: "बंटवाल",
        STATE_PB_CITY_404: "बनूर",
        STATE_AP_CITY_405: "बापतला",
        STATE_BR_CITY_406: "बार बिगहा",
        STATE_UP_CITY_407: "बारा बांकी",
        STATE_HR_CITY_408: "बारा उचाना",
        STATE_WB_CITY_409: "बड़ाबाजार",
        STATE_UP_CITY_410: "बारागॉंव",
        STATE_OR_CITY_411: "बैरागढ़",
        STATE_MH_CITY_412: "बारामती",
        STATE_JK_CITY_413: "बारामुला",
        STATE_RJ_CITY_414: "बारां",
        STATE_WB_CITY_415: "बारानगर",
        STATE_WB_CITY_416: "बारासात",
        STATE_BR_CITY_417: "बरौली",
        STATE_UP_CITY_418: "बड़ौत",
        STATE_OR_CITY_419: "बारबिल",
        STATE_WB_CITY_420: "बर्धमान",
        STATE_GJ_CITY_421: "बारडोली",
        STATE_UP_CITY_422: "बरेली",
        STATE_MP_CITY_423: "बरैला",
        STATE_OR_CITY_424: "बारगढ़",
        STATE_MP_CITY_425: "बरघाट",
        STATE_MP_CITY_426: "बरगी",
        STATE_BR_CITY_427: "बाढ़",
        STATE_UP_CITY_428: "बड़हलगंज",
        STATE_MP_CITY_429: "बरही",
        STATE_BR_CITY_430: "बड़हिया",
        STATE_RJ_CITY_431: "बरी",
        STATE_RJ_CITY_432: "बड़ी सादड़ी",
        STATE_BR_CITY_433: "बरियारपुर",
        STATE_TR_CITY_434: "बरजला",
        STATE_WB_CITY_435: "Barjora",
        STATE_JH_CITY_436: "बड़का काना",
        STATE_UP_CITY_437: "बरखेरा",
        STATE_UP_CITY_438: "बरखेड़ा कलां",
        STATE_JH_CITY_439: "बड़की सरिया",
        STATE_UT_CITY_440: "बड़कोट",
        STATE_RJ_CITY_441: "बाड़मेर",
        STATE_PB_CITY_442: "बरनाला",
        STATE_UP_CITY_443: "बड़ोखर",
        STATE_OR_CITY_444: "बरपाली",
        STATE_AS_CITY_445: "बारपथार",
        STATE_AS_CITY_446: "बारपेटा",
        STATE_AS_CITY_447: "बारपेटा रोड",
        STATE_WB_CITY_448: "बैरकपुर",
        STATE_UP_CITY_449: "बरसाना",
        STATE_MH_CITY_450: "बरसी",
        STATE_WB_CITY_451: "बरूईपुर",
        STATE_BR_CITY_452: "बैरुनी",
        STATE_JH_CITY_453: "बरवाडीह",
        STATE_HR_CITY_454: "बरवाला",
        STATE_MP_CITY_455: "बड़वानी",
        STATE_UP_CITY_456: "बरवर (लखीमपुर खीरी)",
        STATE_WB_CITY_457: "बसंती",
        STATE_AR_CITY_458: "बसर",
        STATE_KA_CITY_459: "बसवकल्याण",
        STATE_KA_CITY_460: "बसवना बागेवाडी",
        STATE_RJ_CITY_461: "बसी",
        STATE_WB_CITY_462: "बशीरहाट",
        STATE_MH_CITY_463: "बासमात",
        STATE_MH_CITY_464: "बासमथ",
        STATE_CT_CITY_465: "बसना",
        STATE_RJ_CITY_466: "बासनी",
        STATE_MP_CITY_467: "बासौदा",
        STATE_CT_CITY_468: "बस्तर",
        STATE_UP_CITY_469: "बस्ती",
        STATE_OR_CITY_470: "Basudebpur",
        STATE_AS_CITY_471: "बासुगांव",
        STATE_RJ_CITY_472: "बसवा",
        STATE_PB_CITY_473: "बटाला",
        STATE_JK_CITY_474: "बटोती",
        STATE_OR_CITY_475: "बॉड",
        STATE_OR_CITY_476: "बौध",
        STATE_MH_CITY_477: "बावधन",
        STATE_HR_CITY_478: "बावल",
        STATE_WB_CITY_479: "बवाली",
        STATE_DL_CITY_480: "बवाना",
        STATE_MH_CITY_481: "बावनबीर",
        STATE_RJ_CITY_482: "बयाना",
        STATE_UT_CITY_483: "बाजपुर",
        STATE_RJ_CITY_484: "ब्यावर",
        STATE_GJ_CITY_485: "बेदी",
        STATE_MH_CITY_486: "बीड",
        STATE_MP_CITY_487: "बेगमगंज",
        STATE_WB_CITY_488: "बेगमपुर",
        STATE_PB_CITY_489: "बेगोवाल",
        STATE_RJ_CITY_490: "शुरू कर दिया",
        STATE_BR_CITY_491: "बेगूसराय",
        STATE_UP_CITY_492: "बीहट",
        STATE_RJ_CITY_493: "बहरोड़",
        STATE_UP_CITY_494: "बेला",
        STATE_OR_CITY_495: "बेलागुंठा",
        STATE_WB_CITY_496: "बेल्दा",
        STATE_WB_CITY_497: "बेलदांगा",
        STATE_KA_CITY_498: "बेलगाम",
        STATE_WB_CITY_499: "बेलियातोर",
        STATE_TG_CITY_500: "बेल्लमपल्ली",
        STATE_KA_CITY_501: "बेल्लारी",
        STATE_KA_CITY_502: "बेलुरु",
        STATE_TR_CITY_503: "बेलोनिया",
        STATE_BR_CITY_504: "बेलसंड",
        STATE_KA_CITY_505: "बेल्तांगढी",
        STATE_UP_CITY_506: "बेल्थरा",
        STATE_TN_CITY_507: "बेलूर",
        STATE_KA_CITY_508: "बेलूर",
        STATE_CT_CITY_509: "बेमेतरा",
        STATE_GA_CITY_510: "बेनौलिम",
        STATE_KA_CITY_511: "बेंगलुरु",
        STATE_UP_CITY_512: "बेनीगंज",
        STATE_MP_CITY_513: "ब्यौहारी",
        STATE_MP_CITY_514: "बैरसिया",
        STATE_WB_CITY_515: "बरहामपुर",
        STATE_HR_CITY_516: "बेरी खास",
        STATE_UP_CITY_517: "बेसवां",
        STATE_AP_CITY_518: "बेताम्चेर्ला",
        STATE_MP_CITY_519: "बेटमा",
        STATE_BR_CITY_520: "बेतिया",
        STATE_MP_CITY_521: "बेतुल",
        STATE_MP_CITY_522: "बैतूलबाजार",
        STATE_UP_CITY_523: "बेवर",
        STATE_KL_CITY_524: "बेपोर",
        STATE_MP_CITY_525: "भाभरा",
        STATE_BR_CITY_526: "भाभुआ",
        STATE_GJ_CITY_527: "भचाऊ",
        STATE_UP_CITY_528: "भदरसा",
        STATE_JK_CITY_529: "भद्रवाह",
        STATE_RJ_CITY_530: "भादासर",
        STATE_PB_CITY_531: "भदौर",
        STATE_MH_CITY_532: "भडगांव, महाराष्ट्र",
        STATE_UP_CITY_533: "भदोही",
        STATE_RJ_CITY_534: "भद्र",
        STATE_TG_CITY_535: "भद्राचलम",
        STATE_TG_CITY_536: "भद्राद्रि कोठागुडेम",
        STATE_OR_CITY_537: "भद्रक",
        STATE_OR_CITY_538: "भद्रख",
        STATE_GJ_CITY_539: "भद्रन",
        STATE_KA_CITY_540: "भद्रावती",
        STATE_WB_CITY_541: "भद्रेश्वर",
        STATE_BR_CITY_542: "भागलपुर",
        STATE_BR_CITY_543: "भगीरथपुर",
        STATE_UP_CITY_544: "भगवंतनगर",
        STATE_MP_CITY_545: "भैंसदेही",
        STATE_TG_CITY_546: "भैसा",
        STATE_KA_CITY_547: "भालकी",
        STATE_MH_CITY_548: "भंडारा",
        STATE_WB_CITY_549: "भंडारदाहा",
        STATE_MH_CITY_550: "भंडारदरा",
        STATE_MP_CITY_551: "भांडेर",
        STATE_GJ_CITY_552: "भांडू",
        STATE_MH_CITY_553: "भांडुप",
        STATE_OR_CITY_554: "भंजनगर",
        STATE_MP_CITY_555: "भानपुरा",
        STATE_CT_CITY_556: "भानपुरी",
        STATE_GJ_CITY_557: "भाणवड़",
        STATE_RJ_CITY_558: "भरतपुर",
        STATE_UP_CITY_559: "भरतपुरा",
        STATE_UP_CITY_560: "भरगैन",
        STATE_UP_CITY_561: "भरथना",
        STATE_GJ_CITY_562: "भरूच",
        STATE_UP_CITY_563: "भरवारी",
        STATE_RJ_CITY_564: "भासावर",
        STATE_CT_CITY_565: "भाटापारा",
        STATE_CT_CITY_566: "भटगांव",
        STATE_GJ_CITY_567: "भाठा",
        STATE_PB_CITY_568: "भटिंडा",
        STATE_KA_CITY_569: "भटकल",
        STATE_WB_CITY_570: "भतपारा",
        STATE_AP_CITY_571: "भट्टीप्रोलु",
        STATE_UP_CITY_572: "भाऊपुर",
        STATE_TN_CITY_573: "भवानी",
        STATE_GJ_CITY_574: "भावनगर",
        STATE_MP_CITY_575: "भवानीगंज",
        STATE_PB_CITY_576: "भवानीगढ़",
        STATE_OR_CITY_577: "भवानीपटना",
        STATE_BR_CITY_578: "भवानीपुर",
        STATE_MH_CITY_579: "भयंदर",
        STATE_GJ_CITY_580: "भयावदर",
        STATE_MH_CITY_581: "Bhigwan",
        STATE_MP_CITY_582: "भीकनगांव",
        STATE_PB_CITY_583: "भीखी",
        STATE_CT_CITY_584: "भिलाई",
        STATE_GJ_CITY_585: "भीलड़ी",
        STATE_RJ_CITY_586: "भीलवाड़ा",
        STATE_UT_CITY_587: "भीम ताल",
        STATE_AP_CITY_588: "भीमावरम",
        STATE_UP_CITY_589: "भीमताल",
        STATE_AP_CITY_590: "भीमुनिपट्टनम",
        STATE_MP_CITY_591: "भिंड",
        STATE_RJ_CITY_592: "भिण्डर",
        STATE_UP_CITY_593: "भिनगा",
        STATE_RJ_CITY_594: "भीनमाल",
        STATE_MP_CITY_595: "भितरवार",
        STATE_RJ_CITY_596: "भिवाड़ी",
        STATE_MH_CITY_597: "भिवंडी",
        STATE_HR_CITY_598: "भिवानी",
        STATE_MH_CITY_599: "भिवापुर",
        STATE_UP_CITY_600: "भोगनीपुर",
        STATE_PB_CITY_601: "भोगपुर",
        STATE_BR_CITY_602: "भोजपुर",
        STATE_GJ_CITY_603: "भोजपुर धरमपुर",
        STATE_JH_CITY_604: "भोजूडीह",
        STATE_MH_CITY_605: "भोकर",
        STATE_MH_CITY_606: "भोकरदन",
        STATE_PB_CITY_607: "भोलाथ",
        STATE_UP_CITY_608: "भोंगांव",
        STATE_TG_CITY_609: "भोंगीर",
        STATE_MH_CITY_610: "भूम",
        STATE_MP_CITY_611: "भोपाल",
        STATE_MH_CITY_612: "भोर",
        STATE_UT_CITY_613: "भवाली",
        STATE_OR_CITY_614: "भुबन",
        STATE_OR_CITY_615: "भुवनेश्वर",
        STATE_MH_CITY_616: "भूड़गांव",
        STATE_MH_CITY_617: "भूगांव",
        STATE_GJ_CITY_618: "भुज",
        STATE_MH_CITY_619: "भूम",
        STATE_RJ_CITY_620: "भूमा",
        STATE_MH_CITY_621: "भुसावल",
        STATE_MH_CITY_622: "भुसावल",
        STATE_MP_CITY_623: "ब्यावरा",
        STATE_MH_CITY_624: "बोली",
        STATE_KA_CITY_625: "बीदर",
        STATE_UP_CITY_626: "बिधनू",
        STATE_UP_CITY_627: "बिधूना",
        STATE_UP_CITY_628: "बीघापुर",
        STATE_UP_CITY_629: "बीघापुर खुर्द",
        STATE_BR_CITY_630: "बिहारशरीफ",
        STATE_BR_CITY_631: "बिहारीगंज",
        STATE_AS_CITY_632: "बिहपुरियागांव",
        STATE_KA_CITY_633: "बीजापुर",
        STATE_CT_CITY_634: "बीजापुर",
        STATE_MP_CITY_635: "बिजावर",
        STATE_JK_CITY_636: "बिजबेहरा",
        STATE_AS_CITY_637: "बिजनी",
        STATE_UP_CITY_638: "बिजनौर",
        STATE_MP_CITY_639: "बिजरौनी",
        STATE_MH_CITY_640: "बिजूर",
        STATE_RJ_CITY_641: "बीकानेर",
        STATE_UP_CITY_642: "बीकापुर",
        STATE_BR_CITY_643: "बिक्रमगंज",
        STATE_RJ_CITY_644: "बिलाड़ा",
        STATE_UP_CITY_645: "बिलारी",
        STATE_UP_CITY_646: "बिलरियागंज",
        STATE_MH_CITY_647: "बिलाशी",
        STATE_AS_CITY_648: "बिलासीपारा",
        STATE_HP_CITY_649: "बिलासपुर",
        STATE_HR_CITY_650: "बिलासपुर",
        STATE_CT_CITY_651: "बिलासपुर",
        STATE_UP_CITY_652: "बिलासपुर",
        STATE_KA_CITY_653: "बिलगी",
        STATE_UP_CITY_654: "बिलग्राम",
        STATE_UP_CITY_655: "बिल्हौर",
        STATE_GJ_CITY_656: "बिलिमोरा",
        STATE_GJ_CITY_657: "बिलखा",
        STATE_MH_CITY_658: "बिलौली",
        STATE_UP_CITY_659: "बिलसंडा",
        STATE_UP_CITY_660: "बिल्सी",
        STATE_UP_CITY_661: "बिल्थरा",
        STATE_UP_CITY_662: "बिनौली",
        STATE_UP_CITY_663: "बिनौर",
        STATE_UP_CITY_664: "बिंदकी",
        STATE_OR_CITY_665: "बिंका",
        STATE_UT_CITY_666: "बीरभद्दर",
        STATE_WB_CITY_667: "बीरभूम जिला",
        STATE_UP_CITY_668: "बर्डपुर",
        STATE_OR_CITY_669: "बीरमित्रपुर",
        STATE_WB_CITY_670: "बीरपाड़ा",
        STATE_BR_CITY_671: "बीरपुर",
        STATE_UP_CITY_672: "बीरपुर",
        STATE_KA_CITY_673: "बिरुर",
        STATE_UP_CITY_674: "बीसलपुर",
        STATE_UP_CITY_675: "बिसंडा बुजुर्ग",
        STATE_UP_CITY_676: "बिसौली",
        STATE_UP_CITY_677: "बिसेंडा बुजुर्ग",
        STATE_JK_CITY_678: "बिश्नाह",
        STATE_MN_CITY_679: "बिश्नुपुर",
        STATE_WB_CITY_680: "बिश्नुपुर",
        STATE_UP_CITY_681: "बिशुनपुर उर्फ ​​महराजगंज",
        STATE_RJ_CITY_682: "बिसाऊ",
        STATE_UP_CITY_683: "बिसवां",
        STATE_UP_CITY_684: "बिठूर",
        STATE_AP_CITY_685: "बोब्बिली",
        STATE_TG_CITY_686: "बोधन",
        STATE_TN_CITY_687: "बोडिनायक्कनूर",
        STATE_MP_CITY_688: "बोदरी",
        STATE_MH_CITY_689: "बोईसर",
        STATE_AS_CITY_690: "बोकाजान",
        STATE_AS_CITY_691: "बोकाखाट",
        STATE_JH_CITY_692: "बोकारो",
        STATE_OR_CITY_693: "बोलानिखोडन",
        STATE_WB_CITY_694: "बोलपुर",
        STATE_AR_CITY_695: "बोमडिला",
        STATE_AS_CITY_696: "बोंगईगांव",
        STATE_MH_CITY_697: "बोरगांव मांजू",
        STATE_MH_CITY_698: "बोरीवली",
        STATE_MH_CITY_699: "बोरीवली",
        STATE_RJ_CITY_700: "बोरखेड़ा",
        STATE_GJ_CITY_701: "बोरसद",
        STATE_GJ_CITY_702: "बोटाड",
        STATE_OR_CITY_703: "ब्रह्मपुर",
        STATE_MH_CITY_704: "ब्रह्मपुरी",
        STATE_OR_CITY_705: "ब्रजराजनगर",
        STATE_MH_CITY_706: "ब्रीच कैंडी",
        STATE_UP_CITY_707: "शाहजहांपुर",
        STATE_BR_CITY_708: "बौद्धगया",
        STATE_WB_CITY_709: "बज बज",
        STATE_UP_CITY_710: "Budhana",
        STATE_PB_CITY_711: "बुढलाडा",
        STATE_OR_CITY_712: "बुगुडा",
        STATE_UP_CITY_713: "बुलन्दशहर",
        STATE_MH_CITY_714: "बुलढाणा",
        STATE_MH_CITY_715: "बुलढाना",
        STATE_RJ_CITY_716: "बूंदी",
        STATE_JH_CITY_717: "बुंडू",
        STATE_MP_CITY_718: "बुरहानपुर",
        STATE_MP_CITY_719: "बुढ़ार",
        STATE_HR_CITY_720: "बुरिया",
        STATE_OR_CITY_721: "बुर्ला",
        STATE_BR_CITY_722: "बक्सर",
        STATE_KA_CITY_723: "Byadgi",
        STATE_MH_CITY_724: "बाइकुला",
        STATE_KA_CITY_725: "बिंदूर",
        STATE_AS_CITY_726: "कछार",
        STATE_GA_CITY_727: "Calangute",
        STATE_KA_CITY_728: "कानाकोना",
        STATE_GA_CITY_729: "कैंडोलिम",
        STATE_WB_CITY_730: "कैनिंग",
        STATE_UP_CITY_731: "कप्तानगंज",
        STATE_GA_CITY_732: "कैरापुर",
        STATE_GA_CITY_733: "कैवेलोसिम",
        STATE_DL_CITY_734: "मध्य दिल्ली",
        STATE_AS_CITY_735: "छाबुआ",
        STATE_JH_CITY_736: "चाईबासा",
        STATE_UP_CITY_737: "चैल",
        STATE_MH_CITY_738: "चाकन",
        STATE_WB_CITY_739: "चकपाड़ा",
        STATE_WB_CITY_740: "चकदहा",
        STATE_UP_CITY_741: "चकिया",
        STATE_BR_CITY_742: "चकिया",
        STATE_GJ_CITY_743: "चकलासी",
        STATE_JH_CITY_744: "चक्रधरपुर",
        STATE_UT_CITY_745: "चकराता",
        STATE_RJ_CITY_746: "चाकसू",
        STATE_JH_CITY_747: "चाकुलिया",
        STATE_MH_CITY_748: "चाकुर",
        STATE_GJ_CITY_749: "चलाला",
        STATE_MH_CITY_750: "चालीसगांव",
        STATE_KA_CITY_751: "छल्लाकेरे",
        STATE_AP_CITY_752: "चल्लापल्ले",
        STATE_GJ_CITY_753: "चालोदा",
        STATE_HP_CITY_754: "चंबा",
        STATE_UT_CITY_755: "चमोली",
        STATE_CT_CITY_756: "चंपा",
        STATE_WB_CITY_757: "Champadanga",
        STATE_WB_CITY_758: "चंपाहाटी",
        STATE_GJ_CITY_759: "चांपानेर",
        STATE_UT_CITY_760: "चम्पावत",
        STATE_WB_CITY_761: "चांपदानी",
        STATE_MZ_CITY_762: "चम्फाई",
        STATE_OR_CITY_763: "चंपुआ",
        STATE_KA_CITY_764: "चामराजनगर",
        STATE_GJ_CITY_765: "चनास्मा",
        STATE_MH_CITY_766: "चंदा",
        STATE_WB_CITY_767: "चन्दन",
        STATE_UP_CITY_768: "चंदौली",
        STATE_UP_CITY_769: "चंदौली जिला",
        STATE_UP_CITY_770: "चंदौसी",
        STATE_OR_CITY_771: "चांदबाली",
        STATE_MP_CITY_772: "चंदेरी",
        STATE_MH_CITY_773: "चांदगढ़",
        STATE_MP_CITY_774: "चंदिया",
        STATE_CH_CITY_775: "चंडीगढ़",
        STATE_JH_CITY_776: "चांडिल",
        STATE_MP_CITY_777: "चंदला",
        STATE_MH_CITY_778: "चंदोर",
        STATE_UP_CITY_779: "चांदपुर",
        STATE_WB_CITY_780: "चंद्राकोना",
        STATE_MH_CITY_781: "चंद्रपुर",
        STATE_UP_CITY_782: "चंदुआसी",
        STATE_TG_CITY_783: "चांदूर",
        STATE_MH_CITY_784: "चांदूर",
        STATE_MH_CITY_785: "चांदूर बाजार",
        STATE_KL_CITY_786: "चंगनाचेरी",
        STATE_AR_CITY_787: "चांगलांग",
        STATE_KA_CITY_788: "चन्नगिरि",
        STATE_KA_CITY_789: "चन्नापटना",
        STATE_KA_CITY_790: "चन्नारायपत्ना",
        STATE_AS_CITY_791: "छापर",
        STATE_BR_CITY_792: "छपरा",
        STATE_UP_CITY_793: "चरखारी",
        STATE_HR_CITY_794: "चरखी दादरी",
        STATE_UP_CITY_795: "चरथावल",
        STATE_JH_CITY_796: "चास",
        STATE_TG_CITY_797: "चटकोंडा",
        STATE_JH_CITY_798: "चतरा",
        STATE_OR_CITY_799: "छत्रपुर",
        STATE_HP_CITY_800: "चौपाल",
        STATE_MH_CITY_801: "चौसाला",
        STATE_RJ_CITY_802: "चेचट",
        STATE_KL_CITY_803: "चेलकारा",
        STATE_MH_CITY_804: "चेंबूर",
        STATE_AP_CITY_805: "चेम्मुमियापेट",
        STATE_TN_CITY_806: "चंगम",
        STATE_KL_CITY_807: "Chengannur",
        STATE_TN_CITY_808: "चेन्नई",
        STATE_TN_CITY_809: "Chennimalai",
        STATE_KL_CITY_810: "Cherpulassery",
        STATE_ML_CITY_811: "चेरापूंजी",
        STATE_KL_CITY_812: "Cherthala",
        STATE_TN_CITY_813: "चेटपुट",
        STATE_TN_CITY_814: "चेट्टीपलायम",
        STATE_KL_CITY_815: "चेतवई",
        STATE_TN_CITY_816: "चेय्यर",
        STATE_TN_CITY_817: "चेयूर",
        STATE_RJ_CITY_818: "छाबड़ा",
        STATE_HR_CITY_819: "Chhachhrauli",
        STATE_GJ_CITY_820: "छला",
        STATE_RJ_CITY_821: "छापर",
        STATE_UP_CITY_822: "Chhaprauli",
        STATE_UP_CITY_823: "छर्रा",
        STATE_UP_CITY_824: "छाता",
        STATE_BR_CITY_825: "छातापुर",
        STATE_MP_CITY_826: "छतरपुर",
        STATE_UP_CITY_827: "छिबरामऊ",
        STATE_MP_CITY_828: "छिंदवाड़ा",
        STATE_UP_CITY_829: "छितौनी",
        STATE_GJ_CITY_830: "छोटा उदेपुर",
        STATE_RJ_CITY_831: "छोटी सादड़ी",
        STATE_CT_CITY_832: "छुईखदान",
        STATE_UP_CITY_833: "छुटमलपुर",
        STATE_GA_CITY_834: "चिकलिम",
        STATE_MP_CITY_835: "चीचली",
        STATE_MH_CITY_836: "चिचोली",
        STATE_MH_CITY_837: "चिचोंडी पाटिल",
        STATE_TN_CITY_838: "चिदंबरम",
        STATE_RJ_CITY_839: "चिडावा",
        STATE_KA_CITY_840: "चिक बल्लापुर",
        STATE_GJ_CITY_841: "चिखली",
        STATE_MH_CITY_842: "चिखली (बुलढाणा)",
        STATE_MH_CITY_843: "चिखली (जालना)",
        STATE_OR_CITY_844: "चिकटीगढ़",
        STATE_KA_CITY_845: "चिकबलपुर",
        STATE_KA_CITY_846: "चिकमंगलूर",
        STATE_KA_CITY_847: "चिक्कानायाकनाहल्ली",
        STATE_KA_CITY_848: "चिकोडी",
        STATE_AP_CITY_849: "Chilakaluripet",
        STATE_UP_CITY_850: "चिल्लूपार",
        STATE_PB_CITY_851: "चीमा",
        STATE_MH_CITY_852: "चिमुर",
        STATE_MH_CITY_853: "चिंचाणी",
        STATE_GA_CITY_854: "चिनचिनिम",
        STATE_KA_CITY_855: "चिंचोली",
        STATE_MH_CITY_856: "चिंचपोकली",
        STATE_TN_CITY_857: "चिंगलेपुट",
        STATE_TN_CITY_858: "चिन्ना सलेम",
        STATE_AP_CITY_859: "चिन्नाचौक",
        STATE_TN_CITY_860: "चिन्नामनूर",
        STATE_TN_CITY_861: "चिन्नासेक्काडु",
        STATE_KA_CITY_862: "चिंतामणि",
        STATE_MH_CITY_863: "चिपलुन",
        STATE_AP_CITY_864: "चिपुरुपल्ले",
        STATE_AP_CITY_865: "चिराला",
        STATE_AS_CITY_866: "चिरांग",
        STATE_UP_CITY_867: "चिरगांव",
        STATE_JH_CITY_868: "चिरिया",
        STATE_KA_CITY_869: "चितापुर",
        STATE_KA_CITY_870: "चित्रदुर्ग",
        STATE_UP_CITY_871: "चित्रकूट",
        STATE_UP_CITY_872: "चित्रकोट धाम",
        STATE_WB_CITY_873: "चितरंजन",
        STATE_OR_CITY_874: "चित्तरकोंडा",
        STATE_RJ_CITY_875: "चितौड़गढ़",
        STATE_AP_CITY_876: "चित्तूर",
        STATE_KL_CITY_877: "चित्तूर",
        STATE_AP_CITY_878: "चोदावरम",
        STATE_TN_CITY_879: "चोलपुरम",
        STATE_UP_CITY_880: "चोपन",
        STATE_MH_CITY_881: "चोपड़ा",
        STATE_MP_CITY_882: "चोरहट",
        STATE_GJ_CITY_883: "चोटिला",
        STATE_HP_CITY_884: "चौरी",
        STATE_HP_CITY_885: "चुआरी खास",
        STATE_GJ_CITY_886: "चूड़ा",
        STATE_UP_CITY_887: "चुनार",
        STATE_MN_CITY_888: "छुरछंदपुर",
        STATE_UP_CITY_889: "चुर्क",
        STATE_RJ_CITY_890: "चुरू",
        STATE_WB_CITY_891: "चुरूलिया",
        STATE_UT_CITY_892: "क्लेमेंट टाउन",
        STATE_KA_CITY_893: "क्लोजपेट",
        STATE_KL_CITY_894: "कोचीन",
        STATE_TN_CITY_895: "कोयंबटूर",
        STATE_MH_CITY_896: "कोलाबा",
        STATE_TN_CITY_897: "कोलाचेल",
        STATE_BR_CITY_898: "कोलगोंग",
        STATE_UP_CITY_899: "कर्नलगंज",
        STATE_GA_CITY_900: "कोलोवाले",
        STATE_GA_CITY_901: "कोल्वा",
        STATE_WB_CITY_902: "कोंताई",
        STATE_WB_CITY_903: "कूचबिहार",
        STATE_KA_CITY_904: "कुन्दापुर",
        STATE_GA_CITY_905: "Cortalim",
        STATE_WB_CITY_906: "कासिम बाजार",
        STATE_TN_CITY_907: "कुड्डालोर",
        STATE_AP_CITY_908: "कडप्पा",
        STATE_AP_CITY_909: "कम्बम",
        STATE_TN_CITY_910: "कम्बम",
        STATE_GA_CITY_911: "क्यूनकोलिम",
        STATE_GA_CITY_912: "कर्चोरेम",
        STATE_GA_CITY_913: "कर्टि",
        STATE_OR_CITY_914: "कटक",
        STATE_GJ_CITY_915: "दभोदा",
        STATE_GJ_CITY_916: "दाभोई",
        STATE_MH_CITY_917: "दाभोल",
        STATE_MP_CITY_918: "दबोह",
        STATE_MP_CITY_919: "डबरा",
        STATE_HR_CITY_920: "डबवाली",
        STATE_MH_CITY_921: "डैडी",
        STATE_DN_CITY_922: "दादर",
        STATE_DN_CITY_923: "दादरा एवं नगर हवेली",
        STATE_UP_CITY_924: "दादरी",
        STATE_HP_CITY_925: "डगशाई",
        STATE_MH_CITY_926: "दहानु",
        STATE_GJ_CITY_927: "दहेगाम",
        STATE_MH_CITY_928: "दहिवेल",
        STATE_GJ_CITY_929: "दाहोद",
        STATE_OR_CITY_930: "दैतारी",
        STATE_GJ_CITY_931: "डकोर",
        STATE_WB_CITY_932: "दक्षिण दिनाजपुर जिला",
        STATE_KA_CITY_933: "दक्षिण कन्नड़",
        STATE_HP_CITY_934: "डलहौजी",
        STATE_WB_CITY_935: "Dalkhola",
        STATE_UP_CITY_936: "डलमऊ",
        STATE_BR_CITY_937: "दलसिंहसराय",
        STATE_JH_CITY_938: "डाल्टनगंज",
        STATE_WB_CITY_939: "बांध बांध",
        STATE_DD_CITY_940: "दमन",
        STATE_DD_CITY_941: "दमन जिला",
        STATE_GJ_CITY_942: "दमनगर",
        STATE_MP_CITY_943: "दमोह",
        STATE_KA_CITY_944: "Dandeli",
        STATE_GJ_CITY_945: "दांडी",
        STATE_GJ_CITY_946: "डांग्स (भारत)",
        STATE_UP_CITY_947: "Dankaur",
        STATE_GJ_CITY_948: "दंता",
        STATE_MH_CITY_949: "दापोली",
        STATE_UP_CITY_950: "दारागंज",
        STATE_UP_CITY_951: "दारानगर",
        STATE_BR_CITY_952: "दरभंगा",
        STATE_RJ_CITY_953: "दरीबा",
        STATE_WB_CITY_954: "दार्जिलिंग",
        STATE_MZ_CITY_955: "डारलॉन",
        STATE_AS_CITY_956: "दरांग",
        STATE_AP_CITY_957: "दारसी",
        STATE_MH_CITY_958: "दारव्हा",
        STATE_MH_CITY_959: "दर्यापुर",
        STATE_UP_CITY_960: "दसना",
        STATE_TG_CITY_961: "दसनापुर",
        STATE_PB_CITY_962: "दसुया",
        STATE_UP_CITY_963: "दातागंज",
        STATE_MP_CITY_964: "दतिया",
        STATE_MH_CITY_965: "दत्तपुर",
        STATE_BR_CITY_966: "दौडनगर",
        STATE_MH_CITY_967: "दौलताबाद",
        STATE_HP_CITY_968: "दौलतपुर",
        STATE_WB_CITY_969: "दौलतपुर",
        STATE_MH_CITY_970: "दौंड",
        STATE_UP_CITY_971: "दौराला",
        STATE_RJ_CITY_972: "दौसा",
        STATE_KA_CITY_973: "दावनगेरे",
        STATE_GA_CITY_974: "Davorlim",
        STATE_UP_CITY_975: "दयालबाग",
        STATE_GJ_CITY_976: "दयापार",
        STATE_WB_CITY_977: "देबाग्राम",
        STATE_WB_CITY_978: "देबीपुर",
        STATE_MH_CITY_979: "डेक्कन जिमखाना",
        STATE_MH_CITY_980: "डेग्लुर",
        STATE_UT_CITY_981: "देहरादून",
        STATE_BR_CITY_982: "डेहरी",
        STATE_MH_CITY_983: "देहु",
        STATE_DL_CITY_984: "दिल्ली",
        STATE_GJ_CITY_985: "देलवाड़ा",
        STATE_GJ_CITY_986: "देलवाड़ा",
        STATE_TN_CITY_987: "डेंकानिकोटा",
        STATE_UP_CITY_988: "देवबंद",
        STATE_OR_CITY_989: "देवगढ़",
        STATE_JH_CITY_990: "देवगढ़",
        STATE_UP_CITY_991: "देवगढ़",
        STATE_MH_CITY_992: "देवलाली",
        STATE_MH_CITY_993: "देवलापार",
        STATE_RJ_CITY_994: "देवली",
        STATE_MH_CITY_995: "देवली",
        STATE_DL_CITY_996: "देवली",
        STATE_MH_CITY_997: "देवनी",
        STATE_UP_CITY_998: "देवरानी",
        STATE_CT_CITY_999: "देवरी",
        STATE_MP_CITY_1000: "देवरी खास",
        STATE_UP_CITY_1001: "देवरिया",
        STATE_MP_CITY_1002: "देपालपुर",
        STATE_PB_CITY_1003: "डेरा बाबा नानक",
        STATE_PB_CITY_1004: "डेरा बस्सी",
        STATE_HP_CITY_1005: "डेरा गोपीपुर",
        STATE_UP_CITY_1006: "डेरापुर",
        STATE_AS_CITY_1007: "डेरगांव",
        STATE_RJ_CITY_1008: "देशनोक",
        STATE_TN_CITY_1009: "देसूर",
        STATE_GJ_CITY_1010: "डेट्रोज",
        STATE_MH_CITY_1011: "देऊलगांव राजा",
        STATE_TN_CITY_1012: "देवदानप्पट्टी",
        STATE_TN_CITY_1013: "देवाकोत्तई",
        STATE_KA_CITY_1014: "देवनहल्ली",
        STATE_UT_CITY_1015: "देवप्रयाग",
        STATE_TG_CITY_1016: "देवाराकोंदा",
        STATE_GJ_CITY_1017: "देवभूमि द्वारका",
        STATE_GJ_CITY_1018: "देवगढ़ बैरिया",
        STATE_RJ_CITY_1019: "देवगढ़",
        STATE_MH_CITY_1020: "देवरुख",
        STATE_UP_CITY_1021: "देव",
        STATE_MP_CITY_1022: "देवास",
        STATE_BR_CITY_1023: "ढाका",
        STATE_TR_CITY_1024: "धलाई",
        STATE_TN_CITY_1025: "ढली",
        STATE_MP_CITY_1026: "धामनोद",
        STATE_UP_CITY_1027: "धामपुर",
        STATE_CT_CITY_1028: "धमतरी",
        STATE_MP_CITY_1029: "धना",
        STATE_PB_CITY_1030: "धनौला",
        STATE_UP_CITY_1031: "धनौरा",
        STATE_JH_CITY_1032: "धनबाद",
        STATE_GJ_CITY_1033: "Dhandhuka",
        STATE_GJ_CITY_1034: "धनेरा",
        STATE_UP_CITY_1035: "धनघटा",
        STATE_WB_CITY_1036: "धनियाखाली सामुदायिक विकास खंड",
        STATE_GJ_CITY_1037: "धनसुरा",
        STATE_JH_CITY_1038: "धनवार",
        STATE_MP_CITY_1039: "धार",
        STATE_GJ_CITY_1040: "धरमपुर",
        STATE_MP_CITY_1041: "धरमपुरी",
        STATE_HP_CITY_1042: "धर्मशाला",
        STATE_MH_CITY_1043: "धरणगांव",
        STATE_TN_CITY_1044: "धारापुरम",
        STATE_GJ_CITY_1045: "धरसाना",
        STATE_UP_CITY_1046: "धारौ",
        STATE_MH_CITY_1047: "धारावी",
        STATE_UT_CITY_1048: "धारचूला",
        STATE_GJ_CITY_1049: "धरी",
        STATE_PB_CITY_1050: "धारीवाल",
        STATE_MH_CITY_1051: "धर्माबाद",
        STATE_KL_CITY_1052: "धर्मदाम",
        STATE_TR_CITY_1053: "धर्मनगर",
        STATE_TN_CITY_1054: "धर्मपुरी",
        STATE_AP_CITY_1055: "धर्मावरम",
        STATE_HR_CITY_1056: "धारूहेड़ा",
        STATE_MH_CITY_1057: "धारुर",
        STATE_KA_CITY_1058: "धारवाड़",
        STATE_GJ_CITY_1059: "ढासा",
        STATE_RJ_CITY_1060: "धौलपुर",
        STATE_UP_CITY_1061: "धौरहरा",
        STATE_MH_CITY_1062: "धवलपुरी",
        STATE_AS_CITY_1063: "Dhekiajuli",
        STATE_AS_CITY_1064: "धेमाजी",
        STATE_OR_CITY_1065: "ढेंकनाल",
        STATE_PB_CITY_1066: "ढिलवां",
        STATE_AS_CITY_1067: "ढिंग",
        STATE_GJ_CITY_1068: "ढोला",
        STATE_GJ_CITY_1069: "धोलेरा",
        STATE_GJ_CITY_1070: "ढोलका",
        STATE_AP_CITY_1071: "धोने",
        STATE_GJ_CITY_1072: "धोराजी",
        STATE_GJ_CITY_1073: "ध्रांगधरा",
        STATE_GJ_CITY_1074: "ध्रोल",
        STATE_AS_CITY_1075: "धुबरी",
        STATE_PB_CITY_1076: "धूडी",
        STATE_WB_CITY_1077: "धुलागरी",
        STATE_MH_CITY_1078: "धुले",
        STATE_MH_CITY_1079: "धुलिया",
        STATE_WB_CITY_1080: "धूलिया",
        STATE_WB_CITY_1081: "धुपगुड़ी",
        STATE_PB_CITY_1082: "धुरी",
        STATE_GJ_CITY_1083: "धुवारन",
        STATE_WB_CITY_1084: "डायमंड हार्बर",
        STATE_UP_CITY_1085: "डिबाई",
        STATE_AR_CITY_1086: "दिबांग घाटी",
        STATE_AS_CITY_1087: "डिब्रूगढ़",
        STATE_GA_CITY_1088: "दिचौली",
        STATE_RJ_CITY_1089: "डीडवाना",
        STATE_RJ_CITY_1090: "खोदना",
        STATE_OR_CITY_1091: "डिगपहंडी",
        STATE_AS_CITY_1092: "डिगबोई",
        STATE_WB_CITY_1093: "दीघा",
        STATE_MH_CITY_1094: "दिघोरी",
        STATE_BR_CITY_1095: "दिघवारा",
        STATE_MH_CITY_1096: "दिग्लुर",
        STATE_MH_CITY_1097: "दिग्रास",
        STATE_AP_CITY_1098: "दिगुवामेट्टा",
        STATE_AS_CITY_1099: "दीमा हसाओ जिला",
        STATE_NL_CITY_1100: "दीमापुर",
        STATE_PB_CITY_1101: "दीनानगर",
        STATE_BR_CITY_1102: "दीनापुर",
        STATE_TN_CITY_1103: "डिंडीगुल",
        STATE_MP_CITY_1104: "डिंडोरी",
        STATE_MH_CITY_1105: "डिंडोरी, महाराष्ट्र",
        STATE_WB_CITY_1106: "दिनहाटा",
        STATE_AS_CITY_1107: "दिफू",
        STATE_PB_CITY_1108: "दिर्बा",
        STATE_GJ_CITY_1109: "दिसा",
        STATE_AS_CITY_1110: "दिसपुर",
        STATE_DD_CITY_1111: "दीव",
        STATE_MH_CITY_1112: "diveagar",
        STATE_UP_CITY_1113: "दिवरासाई",
        STATE_KA_CITY_1114: "डोड बल्लापुर",
        STATE_JK_CITY_1115: "डोडा",
        STATE_GJ_CITY_1116: "दाहोद",
        STATE_UP_CITY_1117: "दोहरीघाट",
        STATE_UT_CITY_1118: "डोईवाला",
        STATE_UP_CITY_1119: "डुमरियागंज",
        STATE_MH_CITY_1120: "डोंबिवली",
        STATE_WB_CITY_1121: "डोम्जुर",
        STATE_MH_CITY_1122: "दोंडाइचा",
        STATE_CT_CITY_1123: "डोंगरगांव",
        STATE_CT_CITY_1124: "डोंगरगढ़",
        STATE_MH_CITY_1125: "डोंगरी",
        STATE_PB_CITY_1126: "दोराहा",
        STATE_TG_CITY_1127: "दोर्नाकल",
        STATE_UP_CITY_1128: "दोस्तपुर",
        STATE_WB_CITY_1129: "दुबराजपुर",
        STATE_MH_CITY_1130: "दुधानी",
        STATE_UP_CITY_1131: "दुदही",
        STATE_UT_CITY_1132: "दुगड्डा",
        STATE_JH_CITY_1133: "दुग्दा",
        STATE_AS_CITY_1134: "दुलियागांव",
        STATE_AS_CITY_1135: "दम दम",
        STATE_JH_CITY_1136: "दुमका",
        STATE_GJ_CITY_1137: "डुमखाल",
        STATE_BR_CITY_1138: "डुमरा",
        STATE_BR_CITY_1139: "दुमरांव",
        STATE_GJ_CITY_1140: "डूंगरपुर",
        STATE_RJ_CITY_1141: "डूंगरपुर",
        STATE_CT_CITY_1142: "दुर्ग",
        STATE_MH_CITY_1143: "दुर्गापुर",
        STATE_WB_CITY_1144: "दुर्गापुर",
        STATE_MH_CITY_1145: "दुर्गापुर, चंद्रपुर",
        STATE_TN_CITY_1146: "दुसी",
        STATE_UT_CITY_1147: "द्वारहाट",
        STATE_GJ_CITY_1148: "द्वारका",
        STATE_DL_CITY_1149: "पूर्वी दिल्ली",
        STATE_SK_CITY_1150: "पूर्वी जिला",
        STATE_ML_CITY_1151: "पूर्वी गारो हिल्स",
        STATE_AP_CITY_1152: "पूर्वी गोदावरी",
        STATE_ML_CITY_1153: "पूर्वी जैंतिया हिल्स",
        STATE_AR_CITY_1154: "पूर्वी कामेंग",
        STATE_ML_CITY_1155: "पूर्वी खासी हिल्स",
        STATE_AR_CITY_1156: "पूर्वी सियांग",
        STATE_KL_CITY_1157: "एडक्कुलम",
        STATE_WB_CITY_1158: "एगरा",
        STATE_AP_CITY_1159: "एलामंचिली",
        STATE_TN_CITY_1160: "एलायिरम्पन्नई",
        STATE_HR_CITY_1161: "ऐलनाबाद",
        STATE_AP_CITY_1162: "एलोर",
        STATE_TN_CITY_1163: "एलुमलाई",
        STATE_KL_CITY_1164: "एलूर",
        STATE_AP_CITY_1165: "एम्मिगनूर",
        STATE_TN_CITY_1166: "आम ए",
        STATE_MH_CITY_1167: "एरंडोल",
        STATE_TN_CITY_1168: "एरानिएल",
        STATE_KL_CITY_1169: "Erattupetta",
        STATE_KL_CITY_1170: "एर्नाकुलम",
        STATE_TN_CITY_1171: "इरोड",
        STATE_AP_CITY_1172: "एर्रागुंटला",
        STATE_TN_CITY_1173: "एरुमैपट्टी",
        STATE_UP_CITY_1174: "एटा",
        STATE_MP_CITY_1175: "इटावा",
        STATE_UP_CITY_1176: "इटावा",
        STATE_AP_CITY_1177: "एटिकोप्पाका",
        STATE_UP_CITY_1178: "एतमादपुर",
        STATE_TN_CITY_1179: "एट्टैयापुरम",
        STATE_UP_CITY_1180: "फैजाबाद",
        STATE_MH_CITY_1181: "फैजपुर",
        STATE_WB_CITY_1182: "फालाकाटा",
        STATE_UP_CITY_1183: "फराह",
        STATE_WB_CITY_1184: "फरक्का",
        STATE_HR_CITY_1185: "फरीदाबाद",
        STATE_HR_CITY_1186: "फ़रीदाबाद जिला",
        STATE_PB_CITY_1187: "फरीदकोट",
        STATE_UP_CITY_1188: "फरीदनगर",
        STATE_UP_CITY_1189: "फरीदपुर",
        STATE_UP_CITY_1190: "फर्रुखाबाद",
        STATE_HR_CITY_1191: "फर्रुखनगर",
        STATE_TG_CITY_1192: "फर्रुखनगर",
        STATE_UP_CITY_1193: "फतेहाबाद",
        STATE_HR_CITY_1194: "फतेहाबाद",
        STATE_HR_CITY_1195: "फतेहाबाद जिला",
        STATE_UP_CITY_1196: "फतेहगंज पश्चिमी",
        STATE_UP_CITY_1197: "फतेहगढ़",
        STATE_PB_CITY_1198: "फतेहगढ़ चूड़ियां",
        STATE_PB_CITY_1199: "फतेहगढ़ साहिब",
        STATE_RJ_CITY_1200: "फ़तेहपुर",
        STATE_UP_CITY_1201: "फ़तेहपुर",
        STATE_UP_CITY_1202: "फ़तेहपुर (बाराबंकी)",
        STATE_UP_CITY_1203: "फ़तेहपुर चौरासी",
        STATE_UP_CITY_1204: "फ़तेहपुर सीकरी",
        STATE_BR_CITY_1205: "फतवा",
        STATE_PB_CITY_1206: "फाजिल्का",
        STATE_KL_CITY_1207: "फ़िरोख",
        STATE_UP_CITY_1208: "फिरोजाबाद",
        STATE_PB_CITY_1209: "फिरोजपुर",
        STATE_PB_CITY_1210: "फिरोजपुर जिला",
        STATE_HR_CITY_1211: "फिरोजपुर झिरका",
        STATE_BR_CITY_1212: "फोर्बेस्गंज",
        STATE_MH_CITY_1213: "किला",
        STATE_WB_CITY_1214: "फोर्ट ग्लोस्टर",
        STATE_KA_CITY_1215: "फ्रेंच चट्टानें",
        STATE_UP_CITY_1216: "फैजाबाद",
        STATE_KA_CITY_1217: "गदग",
        STATE_KA_CITY_1218: "गडग",
        STATE_MP_CITY_1219: "गाडरवारा",
        STATE_MH_CITY_1220: "गडचिरोली",
        STATE_TG_CITY_1221: "गद्दी अन्नाराम",
        STATE_GJ_CITY_1222: "गढ़दा",
        STATE_MH_CITY_1223: "गढ़िंग्लज",
        STATE_TG_CITY_1224: "गढ़वाल",
        STATE_HP_CITY_1225: "गगरेट",
        STATE_UP_CITY_1226: "गहलों",
        STATE_UP_CITY_1227: "गहमर",
        STATE_WB_CITY_1228: "गायघाटा सामुदायिक विकास खंड",
        STATE_UP_CITY_1229: "गैनी",
        STATE_WB_CITY_1230: "गैरकाटा",
        STATE_OR_CITY_1231: "गजपति",
        STATE_KA_CITY_1232: "गजेन्द्रगढ़",
        STATE_UP_CITY_1233: "गजरौला",
        STATE_AP_CITY_1234: "गजुवाका",
        STATE_RJ_CITY_1235: "गलियाकोट",
        STATE_CT_CITY_1236: "गंडई",
        STATE_JK_CITY_1237: "गांदरबल",
        STATE_JK_CITY_1238: "गांदरबल",
        STATE_GJ_CITY_1239: "गणदेवी",
        STATE_TN_CITY_1240: "गांधीनगर",
        STATE_GJ_CITY_1241: "गांधीधाम",
        STATE_GJ_CITY_1242: "गांधीनगर",
        STATE_WB_CITY_1243: "गंगाधरपुर",
        STATE_TN_CITY_1244: "Gangaikondan",
        STATE_MH_CITY_1245: "गंगाखेर",
        STATE_RJ_CITY_1246: "गंगानगर",
        STATE_RJ_CITY_1247: "गंगापुर",
        STATE_MH_CITY_1248: "गंगापुर",
        STATE_WB_CITY_1249: "गंगारामपुर",
        STATE_TN_CITY_1250: "गंगावल्ली",
        STATE_KA_CITY_1251: "गंगावती",
        STATE_UP_CITY_1252: "गंगोह",
        STATE_KA_CITY_1253: "गंगोली",
        STATE_SK_CITY_1254: "गंगटोक",
        STATE_AP_CITY_1255: "गंगुवाड़ा",
        STATE_UP_CITY_1256: "गंज डूंडावाड़ा",
        STATE_UP_CITY_1257: "गंज डुंडवारा",
        STATE_UP_CITY_1258: "गंजमुरादाबाद",
        STATE_OR_CITY_1259: "गंजम",
        STATE_AP_CITY_1260: "Gannavaram",
        STATE_MH_CITY_1261: "गणपतिपुले",
        STATE_UP_CITY_1262: "गरौठा",
        STATE_PB_CITY_1263: "गढ़ीवाला",
        STATE_MP_CITY_1264: "गढ़ ब्राह्मण",
        STATE_MP_CITY_1265: "गढ़ाकोटा",
        STATE_UP_CITY_1266: "गढ़ी पुख्ता",
        STATE_UP_CITY_1267: "गढ़मुक्तेसर",
        STATE_PB_CITY_1268: "Garhshankar",
        STATE_JH_CITY_1269: "गढ़वा",
        STATE_UP_CITY_1270: "गढ़वा",
        STATE_UT_CITY_1271: "गढ़वाल",
        STATE_CT_CITY_1272: "गरियाबंद",
        STATE_GJ_CITY_1273: "गरियाधार",
        STATE_WB_CITY_1274: "गरुई",
        STATE_WB_CITY_1275: "गारुलिया",
        STATE_CT_CITY_1276: "गौरेला",
        STATE_UP_CITY_1277: "गौरीगंज",
        STATE_AS_CITY_1278: "गौरीपुर",
        STATE_UP_CITY_1279: "गौतमबुद्धनगर",
        STATE_MP_CITY_1280: "गौतमपुरा",
        STATE_UP_CITY_1281: "गावां",
        STATE_BR_CITY_1282: "गया",
        STATE_MH_CITY_1283: "गोरे",
        STATE_PB_CITY_1284: "घनौर",
        STATE_MP_CITY_1285: "घंसौर",
        STATE_HR_CITY_1286: "घरौंडा",
        STATE_MH_CITY_1287: "घरगांव",
        STATE_CT_CITY_1288: "घरघोडा",
        STATE_WB_CITY_1289: "घाटल",
        STATE_UP_CITY_1290: "घाटमपुर",
        STATE_MH_CITY_1291: "घाटंजी",
        STATE_TG_CITY_1292: "Ghatkesar",
        STATE_MH_CITY_1293: "घाटकोपर",
        STATE_JH_CITY_1294: "घाटशिला",
        STATE_UP_CITY_1295: "गाज़ियाबाद",
        STATE_UP_CITY_1296: "गाजीपुर",
        STATE_UP_CITY_1297: "घिरोर",
        STATE_JK_CITY_1298: "घो ब्रह्मनान दे",
        STATE_GJ_CITY_1299: "घोड़ासर",
        STATE_BR_CITY_1300: "घोगा",
        STATE_GJ_CITY_1301: "घोघा",
        STATE_UP_CITY_1302: "घोरावल",
        STATE_UP_CITY_1303: "घोसी",
        STATE_MH_CITY_1304: "घोटी बुद्रुख",
        STATE_MH_CITY_1305: "घुघुस",
        STATE_HP_CITY_1306: "घुमारवीं",
        STATE_CT_CITY_1307: "गीदम",
        STATE_AP_CITY_1308: "गिद्दलूर",
        STATE_PB_CITY_1309: "गिद्दड़बाहा",
        STATE_TN_CITY_1310: "गिंगी",
        STATE_GJ_CITY_1311: "गिर सोमनाथ",
        STATE_MH_CITY_1312: "गिरगांव",
        STATE_WB_CITY_1313: "गिरिया",
        STATE_JH_CITY_1314: "गिरिडीह",
        STATE_GA_CITY_1315: "गोवा वेल्हा",
        STATE_AS_CITY_1316: "गोलपाड़ा",
        STATE_WB_CITY_1317: "गोबर्दंगा",
        STATE_TN_CITY_1318: "गोबिचेट्टीपलायम",
        STATE_WB_CITY_1319: "गोविंदपुर",
        STATE_JH_CITY_1320: "गोबिंदपुर",
        STATE_JH_CITY_1321: "गोड्डा",
        STATE_GJ_CITY_1322: "गोधरा",
        STATE_MP_CITY_1323: "गोगापुर",
        STATE_MP_CITY_1324: "गोहदी",
        STATE_HR_CITY_1325: "गोहाना",
        STATE_UP_CITY_1326: "गोहाण्ड",
        STATE_AS_CITY_1327: "गोहपुर",
        STATE_KA_CITY_1328: "गोकक",
        STATE_KA_CITY_1329: "गोकर्ण",
        STATE_AP_CITY_1330: "गोकवरम",
        STATE_UP_CITY_1331: "गोकुल",
        STATE_UP_CITY_1332: "गोला बाजार",
        STATE_UP_CITY_1333: "गोला गोकर्णनाथ",
        STATE_AS_CITY_1334: "गोलाघाट",
        STATE_AS_CITY_1335: "गोलकगंज",
        STATE_TR_CITY_1336: "गोमती",
        STATE_JH_CITY_1337: "गोमो",
        STATE_UP_CITY_1338: "गोंडा",
        STATE_UP_CITY_1339: "गोंडा (अलीगढ़)",
        STATE_UP_CITY_1340: "गोण्डा शहर",
        STATE_GJ_CITY_1341: "गोंडल",
        STATE_MH_CITY_1342: "गोंदिया",
        STATE_MH_CITY_1343: "गोंदिया",
        STATE_BR_CITY_1344: "गोपालगंज",
        STATE_OR_CITY_1345: "गोपालपुर",
        STATE_WB_CITY_1346: "गोपालपुर",
        STATE_TG_CITY_1347: "गोपालुर",
        STATE_UP_CITY_1348: "गोपामऊ",
        STATE_JH_CITY_1349: "गोपीनाथपुर",
        STATE_WB_CITY_1350: "गोपीनाथपुर",
        STATE_MH_CITY_1351: "गोराई",
        STATE_HR_CITY_1352: "गोरखपुर",
        STATE_UP_CITY_1353: "गोरखपुर",
        STATE_AP_CITY_1354: "गोरंटला",
        STATE_MH_CITY_1355: "गोरेगांव",
        STATE_KA_CITY_1356: "गोरिबिदनूर",
        STATE_WB_CITY_1357: "गोरुबथान",
        STATE_KA_CITY_1358: "गोरूर",
        STATE_GJ_CITY_1359: "गोरवा",
        STATE_WB_CITY_1360: "गोसाबा",
        STATE_UP_CITY_1361: "गोसैनगंज",
        STATE_WB_CITY_1362: "गोसानिमारी",
        STATE_UP_CITY_1363: "गोशाईंगंज",
        STATE_AS_CITY_1364: "गोसाईंगांव",
        STATE_UP_CITY_1365: "गोवर्धन",
        STATE_AP_CITY_1366: "गोविंदपुरम, चिलकलुरिपेट, गुंटूर",
        STATE_MP_CITY_1367: "गोविन्दगढ़",
        STATE_RJ_CITY_1368: "गोविन्दगढ़",
        STATE_UP_CITY_1369: "ग्रेटर नोएडा",
        STATE_JH_CITY_1370: "गुआ",
        STATE_KA_CITY_1371: "गुब्बी",
        STATE_TN_CITY_1372: "गुडलूर",
        STATE_OR_CITY_1373: "गुदड़ी",
        STATE_KA_CITY_1374: "गुड़ीबांदा",
        STATE_AP_CITY_1375: "गुड़ीवाड़ा",
        STATE_TN_CITY_1376: "गुडियाथम",
        STATE_AP_CITY_1377: "गुद्लावेल्लेरू",
        STATE_AP_CITY_1378: "गुडूर",
        STATE_TG_CITY_1379: "गुडूर",
        STATE_TN_CITY_1380: "गुडुवनचेरी",
        STATE_MH_CITY_1381: "गुहागर",
        STATE_GA_CITY_1382: "गुइरिम",
        STATE_RJ_CITY_1383: "गुलाबपुरा",
        STATE_UP_CITY_1384: "गुलौठी",
        STATE_KA_CITY_1385: "गुलबर्गा",
        STATE_KA_CITY_1386: "गुलेदागुड्डा",
        STATE_JH_CITY_1387: "गुमिया",
        STATE_JH_CITY_1388: "गुमला",
        STATE_TN_CITY_1389: "गुम्मिडिपुंडी",
        STATE_MP_CITY_1390: "गुना",
        STATE_KA_CITY_1391: "गुंडलुपेट",
        STATE_UP_CITY_1392: "गुन्नौर",
        STATE_AP_CITY_1393: "गुंतकल जंक्शन",
        STATE_AP_CITY_1394: "गुंटूर",
        STATE_OR_CITY_1395: "गुनुपुर",
        STATE_WB_CITY_1396: "गुरदहा",
        STATE_PB_CITY_1397: "गुरदासपुर",
        STATE_HR_CITY_1398: "गुडगाँव",
        STATE_MP_CITY_1399: "गुढ़",
        STATE_KA_CITY_1400: "Gurmatkal",
        STATE_UP_CITY_1401: "गुरसहायगंज",
        STATE_UP_CITY_1402: "गुरसराय",
        STATE_PB_CITY_1403: "गुरु हर सहाय",
        STATE_KL_CITY_1404: "गुरूवायूर",
        STATE_WB_CITY_1405: "गुशखारा",
        STATE_AS_CITY_1406: "गुवाहाटी",
        STATE_MP_CITY_1407: "ग्वालियर",
        STATE_SK_CITY_1408: "गेजिंग",
        STATE_UP_CITY_1409: "ज्ञानपुर",
        STATE_WB_CITY_1410: "हाबरा",
        STATE_KA_CITY_1411: "हदगल्ली",
        STATE_MH_CITY_1412: "हडपसर, पुणे",
        STATE_MH_CITY_1413: "हदगांव",
        STATE_AS_CITY_1414: "हाफलोंग",
        STATE_AS_CITY_1415: "हैलाकांडी",
        STATE_JK_CITY_1416: "हजान",
        STATE_PB_CITY_1417: "हाजीपुर",
        STATE_BR_CITY_1418: "हाजीपुर",
        STATE_AS_CITY_1419: "हाजो",
        STATE_UP_CITY_1420: "हल्दौर",
        STATE_WB_CITY_1421: "हल्दिया",
        STATE_WB_CITY_1422: "हल्दीबारी",
        STATE_UT_CITY_1423: "Haldwani",
        STATE_GJ_CITY_1424: "हलेंडा",
        STATE_WB_CITY_1425: "हालिसहर",
        STATE_KA_CITY_1426: "हलियाल",
        STATE_MH_CITY_1427: "हलकर्णी",
        STATE_GJ_CITY_1428: "हलोल",
        STATE_GJ_CITY_1429: "हलवद",
        STATE_UP_CITY_1430: "हमीरपुर",
        STATE_HP_CITY_1431: "हमीरपुर",
        STATE_KA_CITY_1432: "हम्पी",
        STATE_UP_CITY_1433: "हंडिया",
        STATE_KA_CITY_1434: "हंगल",
        STATE_HR_CITY_1435: "हांसी",
        STATE_GJ_CITY_1436: "हंसोत",
        STATE_RJ_CITY_1437: "हनुमानगढ़",
        STATE_UP_CITY_1438: "हापुड़",
        STATE_UP_CITY_1439: "हरईपुर",
        STATE_UP_CITY_1440: "हरैया",
        STATE_MH_CITY_1441: "हारंगुल",
        STATE_UT_CITY_1442: "हर्बटपुर",
        STATE_UP_CITY_1443: "हरचंदपुर",
        STATE_MP_CITY_1444: "हरदा",
        STATE_MP_CITY_1445: "हरदा खास",
        STATE_UP_CITY_1446: "हरदोई",
        STATE_UP_CITY_1447: "हरदुआगंज",
        STATE_PB_CITY_1448: "हरियाना",
        STATE_UT_CITY_1449: "हरिद्वार",
        STATE_KA_CITY_1450: "हरिहर",
        STATE_GJ_CITY_1451: "हारिज",
        STATE_WB_CITY_1452: "हरिणडांगा",
        STATE_WB_CITY_1453: "हरिनघाटा",
        STATE_WB_CITY_1454: "हरिपुर",
        STATE_MH_CITY_1455: "हरनाई",
        STATE_MP_CITY_1456: "हरपालपुर",
        STATE_KA_CITY_1457: "हरपनहल्ली",
        STATE_MP_CITY_1458: "हर्रई",
        STATE_GJ_CITY_1459: "हरसोल",
        STATE_MP_CITY_1460: "हरसूद",
        STATE_TN_CITY_1461: "हरुर",
        STATE_HR_CITY_1462: "हसनपुर",
        STATE_UP_CITY_1463: "हसनपुर",
        STATE_WB_CITY_1464: "हासीमारा",
        STATE_KA_CITY_1465: "हसन",
        STATE_UP_CITY_1466: "हस्तिनापुर",
        STATE_UP_CITY_1467: "हठ",
        STATE_UP_CITY_1468: "हटा (भारत)",
        STATE_UP_CITY_1469: "हाथरस",
        STATE_GJ_CITY_1470: "हथुरान",
        STATE_MP_CITY_1471: "हातोद",
        STATE_MP_CITY_1472: "हट्टा",
        STATE_KA_CITY_1473: "हावेरी",
        STATE_AR_CITY_1474: "हयुलियांग",
        STATE_JH_CITY_1475: "हज़ारीबाग",
        STATE_JH_CITY_1476: "हजारीबाग",
        STATE_KA_CITY_1477: "हेग्गादादेवनकोटे",
        STATE_MH_CITY_1478: "हेल्वाक",
        STATE_JH_CITY_1479: "हेस्ला",
        STATE_BR_CITY_1480: "हिलसा",
        STATE_GJ_CITY_1481: "हिम्मतनगर",
        STATE_RJ_CITY_1482: "हिण्डौन",
        STATE_MP_CITY_1483: "हिंडोरिया",
        STATE_AP_CITY_1484: "हिन्दुपुर",
        STATE_WB_CITY_1485: "हिंदुस्तान केबल्स टाउन",
        STATE_MH_CITY_1486: "हिंगणघाट",
        STATE_MH_CITY_1487: "हिंगोली",
        STATE_OR_CITY_1488: "हिन्जिलिकतु",
        STATE_OR_CITY_1489: "हीराकुंड",
        STATE_JK_CITY_1490: "हीरानगर",
        STATE_MH_CITY_1491: "हीरापुर",
        STATE_MH_CITY_1492: "हीरापुर हमेशा",
        STATE_KA_CITY_1493: "हिरेकेरूर",
        STATE_KA_CITY_1494: "हिरियुर",
        STATE_HR_CITY_1495: "हिसार",
        STATE_BR_CITY_1496: "हिसुआ",
        STATE_HR_CITY_1497: "होडल",
        STATE_AS_CITY_1498: "होजाई",
        STATE_KA_CITY_1499: "होलालकेरे",
        STATE_KA_CITY_1500: "छेद नरसीपुर",
        STATE_KA_CITY_1501: "Humnabad",
        STATE_KA_CITY_1502: "होनावर",
        STATE_KA_CITY_1503: "होन्नाली",
        STATE_WB_CITY_1504: "हुगली जिला",
        STATE_KA_CITY_1505: "होसानगर",
        STATE_KA_CITY_1506: "होसनगाडी",
        STATE_KA_CITY_1507: "होसदुर्गा",
        STATE_MP_CITY_1508: "होशंगाबाद",
        STATE_PB_CITY_1509: "होशियारपुर",
        STATE_KA_CITY_1510: "होसकोटे",
        STATE_KA_CITY_1511: "होसपेट",
        STATE_TN_CITY_1512: "होसुर",
        STATE_MH_CITY_1513: "होत्गी",
        STATE_AS_CITY_1514: "हाउली",
        STATE_WB_CITY_1515: "हावड़ा",
        STATE_KA_CITY_1516: "हुबली",
        STATE_KA_CITY_1517: "हुकेरी",
        STATE_UP_CITY_1518: "हुलास",
        STATE_KA_CITY_1519: "हुंगुंड",
        STATE_KA_CITY_1520: "हुन्सुर",
        STATE_JH_CITY_1521: "हुसैनाबाद",
        STATE_TG_CITY_1522: "हैदराबाद",
        STATE_MP_CITY_1523: "Iawar",
        STATE_UP_CITY_1524: "इब्राहिमपुर",
        STATE_MH_CITY_1525: "इचलकरंजी",
        STATE_WB_CITY_1526: "इच्छापुर",
        STATE_AP_CITY_1527: "इच्छापुरम",
        STATE_MP_CITY_1528: "Ichhawar",
        STATE_TN_CITY_1529: "इडाप्पडी",
        STATE_GJ_CITY_1530: "इदर",
        STATE_KL_CITY_1531: "इडुक्की",
        STATE_MH_CITY_1532: "इगतपुरी",
        STATE_UP_CITY_1533: "इगलास",
        STATE_UP_CITY_1534: "इकौना",
        STATE_MP_CITY_1535: "इकलेहरा",
        STATE_TN_CITY_1536: "इलमपिल्लई",
        STATE_KA_CITY_1537: "इलकल",
        STATE_TN_CITY_1538: "इलुप्पुर",
        STATE_MN_CITY_1539: "इंफाल",
        STATE_HR_CITY_1540: "इंदा छोई",
        STATE_MH_CITY_1541: "इंदापुर",
        STATE_UP_CITY_1542: "इंदरगढ़",
        STATE_KA_CITY_1543: "इंडी",
        STATE_MP_CITY_1544: "इंदौर",
        STATE_WB_CITY_1545: "इंदपुर सामुदायिक विकास खंड",
        STATE_UP_CITY_1546: "इन्द्रगढ़",
        STATE_HR_CITY_1547: "इंद्री",
        STATE_WB_CITY_1548: "इंगराज बाजार",
        STATE_TN_CITY_1549: "इंजंबक्कम",
        STATE_KL_CITY_1550: "इरिंगल",
        STATE_KL_CITY_1551: "Irinjalakuda",
        STATE_TN_CITY_1552: "इरुगुर",
        STATE_MP_CITY_1553: "ईसागढ़",
        STATE_PB_CITY_1554: "Isanpur",
        STATE_UP_CITY_1555: "इस्लामनगर",
        STATE_UP_CITY_1556: "इस्लामनगर (बदायूं)",
        STATE_BR_CITY_1557: "इस्लामपुर",
        STATE_WB_CITY_1558: "इस्लामपुर",
        STATE_AR_CITY_1559: "ईटानगर",
        STATE_MP_CITY_1560: "इटारसी",
        STATE_UP_CITY_1561: "इटौंजा",
        STATE_UP_CITY_1562: "इतिमादपुर",
        STATE_MP_CITY_1563: "जबलपुर",
        STATE_WB_CITY_1564: "जाफरपुर",
        STATE_HR_CITY_1565: "जगाधरी",
        STATE_KA_CITY_1566: "जगलूर",
        STATE_JH_CITY_1567: "जगन्नाथपुर",
        STATE_OR_CITY_1568: "जगतसिंहपुर",
        STATE_OR_CITY_1569: "जगतसिंहपुर",
        STATE_CT_CITY_1570: "जगदलपुर",
        STATE_UP_CITY_1571: "जगदीशपुर",
        STATE_BR_CITY_1572: "जगदीशपुर",
        STATE_AP_CITY_1573: "जग्गय्यापेटा",
        STATE_UP_CITY_1574: "जगनाैर",
        STATE_PB_CITY_1575: "जगराओं",
        STATE_TG_CITY_1576: "Jagtial",
        STATE_UP_CITY_1577: "जहानाबाद",
        STATE_BR_CITY_1578: "जहानाबाद",
        STATE_UP_CITY_1579: "जहानाबाद (पीलीभीत)।",
        STATE_UP_CITY_1580: "जहांगीराबाद",
        STATE_UP_CITY_1581: "जहांगीरपुर",
        STATE_RJ_CITY_1582: "जहाजपुर",
        STATE_WB_CITY_1583: "जयगांव",
        STATE_UP_CITY_1584: "जैनपुर",
        STATE_RJ_CITY_1585: "जयपुर",
        STATE_UP_CITY_1586: "जैस",
        STATE_RJ_CITY_1587: "जैसलमेर",
        STATE_MP_CITY_1588: "जयसिंहनगर",
        STATE_MH_CITY_1589: "जयसिंहपुर",
        STATE_MH_CITY_1590: "जैतापुर",
        STATE_RJ_CITY_1591: "जैतारण",
        STATE_MP_CITY_1592: "जैतहरी",
        STATE_PB_CITY_1593: "जैतो",
        STATE_OR_CITY_1594: "जाजपुर",
        STATE_HR_CITY_1595: "जाखल",
        STATE_MH_CITY_1596: "जखनगांव",
        STATE_GJ_CITY_1597: "जखाऊ",
        STATE_TN_CITY_1598: "जलकंदपुरम",
        STATE_UP_CITY_1599: "जलालाबाद",
        STATE_PB_CITY_1600: "जलालाबाद",
        STATE_UP_CITY_1601: "जलाली",
        STATE_GJ_CITY_1602: "जलालपोर",
        STATE_GJ_CITY_1603: "जलालपुर",
        STATE_UP_CITY_1604: "जलालपुर",
        STATE_PB_CITY_1605: "जालंधर",
        STATE_TN_CITY_1606: "जलारपेट",
        STATE_UP_CITY_1607: "जालौन",
        STATE_UP_CITY_1608: "जलेसर",
        STATE_OR_CITY_1609: "जलेश्वर",
        STATE_MH_CITY_1610: "जलगांव",
        STATE_MH_CITY_1611: "जलगांव जामोद",
        STATE_GJ_CITY_1612: "जालिया",
        STATE_MH_CITY_1613: "जलकोट",
        STATE_MH_CITY_1614: "जलना",
        STATE_RJ_CITY_1615: "जालोर",
        STATE_RJ_CITY_1616: "जालौर",
        STATE_WB_CITY_1617: "जलपाईगुड़ी",
        STATE_JH_CITY_1618: "जमाडोबा",
        STATE_MP_CITY_1619: "जमाई",
        STATE_BR_CITY_1620: "जमालपुर",
        STATE_GJ_CITY_1621: "जम्बुदा",
        STATE_GJ_CITY_1622: "जम्बूसर",
        STATE_KA_CITY_1623: "जामखंडी",
        STATE_MH_CITY_1624: "जामखेड",
        STATE_AP_CITY_1625: "जम्मालमादुगु",
        STATE_JK_CITY_1626: "जम्मू",
        STATE_GJ_CITY_1627: "जामनगर",
        STATE_MH_CITY_1628: "जामोद",
        STATE_JH_CITY_1629: "जमशेदपुर",
        STATE_JH_CITY_1630: "जामताड़ा",
        STATE_BR_CITY_1631: "जमुई",
        STATE_WB_CITY_1632: "जमुरिया",
        STATE_PB_CITY_1633: "जंडियाला",
        STATE_PB_CITY_1634: "जंडियाला गुरु",
        STATE_MH_CITY_1635: "जनेफल",
        STATE_TG_CITY_1636: "जनगांव",
        STATE_UP_CITY_1637: "जंघई",
        STATE_WB_CITY_1638: "जंगीपुर",
        STATE_TG_CITY_1639: "जनगांव",
        STATE_CT_CITY_1640: "जांजगीर",
        STATE_CT_CITY_1641: "जांजगीर-चंपा",
        STATE_UP_CITY_1642: "जानसठ",
        STATE_MH_CITY_1643: "जाओली",
        STATE_MP_CITY_1644: "जावरा",
        STATE_GJ_CITY_1645: "जारोद,",
        STATE_UP_CITY_1646: "जरवा",
        STATE_UP_CITY_1647: "जरवल",
        STATE_GJ_CITY_1648: "जसदण",
        STATE_CT_CITY_1649: "जशपुर",
        STATE_CT_CITY_1650: "जशपुर",
        STATE_JH_CITY_1651: "जसीडीह",
        STATE_UT_CITY_1652: "जसपुर",
        STATE_UP_CITY_1653: "जसराना",
        STATE_UP_CITY_1654: "जसवन्तनगर",
        STATE_MH_CITY_1655: "जाट, सांगली",
        STATE_OR_CITY_1656: "जाटणी",
        STATE_MP_CITY_1657: "जतारा",
        STATE_MH_CITY_1658: "जटेगांव",
        STATE_UP_CITY_1659: "जौनपुर",
        STATE_JK_CITY_1660: "जौरियन",
        STATE_MP_CITY_1661: "जवाद",
        STATE_HP_CITY_1662: "ज्वाला मुखी",
        STATE_MH_CITY_1663: "जवाहर",
        STATE_TN_CITY_1664: "जयमकोंडाचोलपुरम",
        STATE_TG_CITY_1665: "जयशंकर भूपलपल्ली",
        STATE_BR_CITY_1666: "जयनगर",
        STATE_WB_CITY_1667: "जयनगर माजिलपुर",
        STATE_MH_CITY_1668: "जयसिंगपुर",
        STATE_BR_CITY_1669: "जहानाबाद",
        STATE_WB_CITY_1670: "जेजुर",
        STATE_MH_CITY_1671: "जेजुरी",
        STATE_GJ_CITY_1672: "जेतलपुर",
        STATE_GJ_CITY_1673: "जेताल्सर",
        STATE_GJ_CITY_1674: "जेतपुर",
        STATE_GJ_CITY_1675: "जेतपुर (नवागढ़)",
        STATE_KA_CITY_1676: "जेवर्गी",
        STATE_UP_CITY_1677: "जेवर",
        STATE_OR_CITY_1678: "जयपोर",
        STATE_BR_CITY_1679: "झा-झा",
        STATE_MP_CITY_1680: "झाबुआ",
        STATE_UP_CITY_1681: "झज्जर",
        STATE_HR_CITY_1682: "झज्जर",
        STATE_RJ_CITY_1683: "झालावाड़",
        STATE_WB_CITY_1684: "झालिदा",
        STATE_GJ_CITY_1685: "झालोद",
        STATE_RJ_CITY_1686: "झालरापाटन",
        STATE_UP_CITY_1687: "झालू",
        STATE_BR_CITY_1688: "झंझारपुर",
        STATE_UP_CITY_1689: "झांसी",
        STATE_WB_CITY_1690: "झारग्राम",
        STATE_JH_CITY_1691: "झरिया",
        STATE_OR_CITY_1692: "झारसुगुडा",
        STATE_OR_CITY_1693: "झारसुगुड़ा जिला",
        STATE_WB_CITY_1694: "झिलिमिली",
        STATE_UP_CITY_1695: "झींझक",
        STATE_UP_CITY_1696: "झिंझाना",
        STATE_GJ_CITY_1697: "झुलासन",
        STATE_RJ_CITY_1698: "झुंझुनूं",
        STATE_UP_CITY_1699: "झूसी",
        STATE_HR_CITY_1700: "जींद",
        STATE_MH_CITY_1701: "जिंतुर",
        STATE_MP_CITY_1702: "जीरन",
        STATE_UP_CITY_1703: "जीयनपुर",
        STATE_MP_CITY_1704: "जोबट",
        STATE_RJ_CITY_1705: "जोबनेर",
        STATE_GJ_CITY_1706: "जोधपुर",
        STATE_RJ_CITY_1707: "जोधपुर",
        STATE_GJ_CITY_1708: "जोधपुर (अहमदाबाद)",
        STATE_GJ_CITY_1709: "जोडिया",
        STATE_GJ_CITY_1710: "जोड़िया बंदर",
        STATE_BR_CITY_1711: "जोगबनी",
        STATE_MH_CITY_1712: "जोगेश्वरी",
        STATE_AS_CITY_1713: "जोगीघोपा",
        STATE_HP_CITY_1714: "जोगिंदरनगर",
        STATE_TG_CITY_1715: "जोगुलाम्बा गडवाल",
        STATE_SK_CITY_1716: "जोरेथांग",
        STATE_AS_CITY_1717: "जोरहाट",
        STATE_UT_CITY_1718: "जोशीमठ",
        STATE_GA_CITY_1719: "जुआ",
        STATE_HP_CITY_1720: "जुब्बल",
        STATE_JH_CITY_1721: "जुगसलाई",
        STATE_MH_CITY_1722: "जुहू",
        STATE_JH_CITY_1723: "जुमरी तिलैया",
        STATE_GJ_CITY_1724: "जूनागढ़",
        STATE_CT_CITY_1725: "जूनागढ़",
        STATE_MH_CITY_1726: "जुन्नर",
        STATE_HP_CITY_1727: "जुतोघ",
        STATE_UP_CITY_1728: "ज्योतिबा फुले नगर",
        STATE_CT_CITY_1729: "कबीरधाम",
        STATE_UP_CITY_1730: "कबरई",
        STATE_GJ_CITY_1731: "कच्छ",
        STATE_GJ_CITY_1732: "कछौली",
        STATE_UP_CITY_1733: "कछवा",
        STATE_MH_CITY_1734: "कचूरवाही",
        STATE_KL_CITY_1735: "कडक्कवूर",
        STATE_TN_CITY_1736: "कदम्बुर",
        STATE_UP_CITY_1737: "कदौरा",
        STATE_TN_CITY_1738: "कडयानल्लूर",
        STATE_MH_CITY_1739: "कडेगांव",
        STATE_GJ_CITY_1740: "कादी",
        STATE_UP_CITY_1741: "कादीपुर",
        STATE_AP_CITY_1742: "कादिरी",
        STATE_GJ_CITY_1743: "कड़ोद",
        STATE_KA_CITY_1744: "कडुर",
        STATE_MH_CITY_1745: "कडुस",
        STATE_MH_CITY_1746: "कागल",
        STATE_UP_CITY_1747: "कागारौल",
        STATE_TG_CITY_1748: "कागजनगर",
        STATE_MH_CITY_1749: "कैज",
        STATE_AP_CITY_1750: "कैकलूर",
        STATE_MP_CITY_1751: "कैलारस",
        STATE_TR_CITY_1752: "कैलाशहर",
        STATE_UP_CITY_1753: "कायमगंज",
        STATE_MP_CITY_1754: "कैमोरी",
        STATE_BR_CITY_1755: "कैमूर जिला",
        STATE_OR_CITY_1756: "कैंत्रगढ़",
        STATE_UP_CITY_1757: "कैराना",
        STATE_HR_CITY_1758: "कैथल",
        STATE_MN_CITY_1759: "काकचिंग",
        STATE_WB_CITY_1760: "काकद्वीप",
        STATE_AP_CITY_1761: "काकीनाडा",
        STATE_UP_CITY_1762: "काकोरी",
        STATE_UP_CITY_1763: "ककराला",
        STATE_UT_CITY_1764: "Kaladhungi",
        STATE_UT_CITY_1765: "कालागढ़ प्रोजेक्ट कॉलोनी",
        STATE_OR_CITY_1766: "कालाहांडी",
        STATE_WB_CITY_1767: "कलाईकुंडा",
        STATE_TN_CITY_1768: "कलक्कडु",
        STATE_KL_CITY_1769: "Kalamassery",
        STATE_MH_CITY_1770: "कलंब",
        STATE_MH_CITY_1771: "कलंब, उस्मानाबाद",
        STATE_MH_CITY_1772: "कलंबोली",
        STATE_MH_CITY_1773: "कलमनुरी",
        STATE_PB_CITY_1774: "कालानौर",
        STATE_HR_CITY_1775: "कालानौर",
        STATE_HR_CITY_1776: "कालांवाली",
        STATE_MH_CITY_1777: "कलास",
        STATE_GJ_CITY_1778: "कालावड",
        STATE_TN_CITY_1779: "कलावई",
        STATE_KL_CITY_1780: "कलावूर",
        STATE_KA_CITY_1781: "कलघटगी",
        STATE_MH_CITY_1782: "काली(डीके)",
        STATE_WB_CITY_1783: "कालियागंज",
        STATE_JH_CITY_1784: "कालिकापुर",
        STATE_WB_CITY_1785: "कलिम्पोंग",
        STATE_UP_CITY_1786: "कलीनगर",
        STATE_HP_CITY_1787: "कालका",
        STATE_TN_CITY_1788: "कल्लक्कुरिची",
        STATE_TN_CITY_1789: "कल्लिदैकुरिची",
        STATE_TN_CITY_1790: "कल्लुपट्टी",
        STATE_MH_CITY_1791: "कलमेश्वर",
        STATE_WB_CITY_1792: "काल्ना",
        STATE_GJ_CITY_1793: "कलोल",
        STATE_KL_CITY_1794: "कलपट्टा",
        STATE_UP_CITY_1795: "कालपी",
        STATE_TN_CITY_1796: "कलुगुमलाई",
        STATE_MH_CITY_1797: "कलुंद्री",
        STATE_MH_CITY_1798: "कल्याण",
        STATE_AP_CITY_1799: "कल्याण",
        STATE_WB_CITY_1800: "कल्याणी",
        STATE_MH_CITY_1801: "कल्याणी नगर",
        STATE_UP_CITY_1802: "कल्याणपुर",
        STATE_OR_CITY_1803: "कमाख्यानगर",
        STATE_AP_CITY_1804: "कमलापुरम",
        STATE_UP_CITY_1805: "कमालगंज",
        STATE_TR_CITY_1806: "कमालपुर",
        STATE_RJ_CITY_1807: "कमान",
        STATE_TG_CITY_1808: "कामारेड्डी",
        STATE_TG_CITY_1809: "कामारेड्डी",
        STATE_MH_CITY_1810: "कमरगांव",
        STATE_WB_CITY_1811: "कमरहाटी",
        STATE_WB_CITY_1812: "कामारपुकुर",
        STATE_MH_CITY_1813: "कामतगी",
        STATE_UP_CITY_1814: "कंपिल",
        STATE_KA_CITY_1815: "कांपली",
        STATE_MH_CITY_1816: "कैम्पटी",
        STATE_AS_CITY_1817: "कामरूप",
        STATE_AS_CITY_1818: "कामरूप महानगर",
        STATE_MH_CITY_1819: "कामठी",
        STATE_TN_CITY_1820: "कामुथि",
        STATE_TN_CITY_1821: "कनाडुकट्टन",
        STATE_TN_CITY_1822: "कांचीपुरम",
        STATE_TN_CITY_1823: "कांचीपुरम",
        STATE_WB_CITY_1824: "कांचरापाड़ा",
        STATE_OR_CITY_1825: "कंधमाल",
        STATE_UP_CITY_1826: "कांधला",
        STATE_WB_CITY_1827: "कंडी",
        STATE_GJ_CITY_1828: "कांडला",
        STATE_GJ_CITY_1829: "कांडला बंदरगाह",
        STATE_JH_CITY_1830: "कांड्रा",
        STATE_MH_CITY_1831: "कांदरी",
        STATE_AP_CITY_1832: "कन्दुकुर",
        STATE_HP_CITY_1833: "कांगड़",
        STATE_TN_CITY_1834: "कंगायम",
        STATE_HP_CITY_1835: "कांगड़ा",
        STATE_AP_CITY_1836: "कनिगिरि",
        STATE_HR_CITY_1837: "कनीना खास",
        STATE_KA_CITY_1838: "कंकणहल्ली",
        STATE_MH_CITY_1839: "Kankavli",
        STATE_MH_CITY_1840: "Kankavli",
        STATE_JH_CITY_1841: "कांके",
        STATE_CT_CITY_1842: "कांकेर",
        STATE_AP_CITY_1843: "कनकीपदु",
        STATE_GA_CITY_1844: "कांकोन",
        STATE_MH_CITY_1845: "कन्नड़",
        STATE_KL_CITY_1846: "कन्नंगाड",
        STATE_UP_CITY_1847: "कन्नौज",
        STATE_KL_CITY_1848: "कन्नवम",
        STATE_TN_CITY_1849: "कन्नियाकुमारी",
        STATE_MP_CITY_1850: "कन्नोड",
        STATE_KL_CITY_1851: "कन्नूर",
        STATE_GJ_CITY_1852: "कानोदर",
        STATE_RJ_CITY_1853: "कानोर",
        STATE_UP_CITY_1854: "कानपुर",
        STATE_UP_CITY_1855: "कानपुर देहात",
        STATE_UP_CITY_1856: "कांत",
        STATE_OR_CITY_1857: "कांटाबांजी",
        STATE_UP_CITY_1858: "कांठ",
        STATE_OR_CITY_1859: "कंटिलो",
        STATE_AP_CITY_1860: "कनुरू",
        STATE_GJ_CITY_1861: "Kapadvanj",
        STATE_RJ_CITY_1862: "कापरेन",
        STATE_UP_CITY_1863: "कप्तानगंज",
        STATE_PB_CITY_1864: "कपूरथला",
        STATE_UP_CITY_1865: "काड़ा",
        STATE_MH_CITY_1866: "कराड",
        STATE_PY_CITY_1867: "कराईकल",
        STATE_TN_CITY_1868: "कराईकुडी",
        STATE_MH_CITY_1869: "करजगी",
        STATE_TN_CITY_1870: "करामदाई",
        STATE_TN_CITY_1871: "करंबक्कुडी",
        STATE_GJ_CITY_1872: "करमसाद",
        STATE_MH_CITY_1873: "करंजा",
        STATE_MH_CITY_1874: "करंजा लाड",
        STATE_RJ_CITY_1875: "करणपुर",
        STATE_UP_CITY_1876: "करारी",
        STATE_RJ_CITY_1877: "करौली",
        STATE_AS_CITY_1878: "कार्बी आंगलोंग",
        STATE_UP_CITY_1879: "करबिगवां",
        STATE_UP_CITY_1880: "करछना",
        STATE_MP_CITY_1881: "करेली",
        STATE_MP_CITY_1882: "करेरा",
        STATE_LA_CITY_1883: "कारगिल",
        STATE_UP_CITY_1884: "करहल",
        STATE_GJ_CITY_1885: "करियाना",
        STATE_TN_CITY_1886: "करियापट्टी",
        STATE_AS_CITY_1887: "करीमगंज",
        STATE_TG_CITY_1888: "करीमनगर",
        STATE_WB_CITY_1889: "करीमपुर",
        STATE_GJ_CITY_1890: "कर्जन",
        STATE_MH_CITY_1891: "कर्जत",
        STATE_KA_CITY_1892: "करकला",
        STATE_MH_CITY_1893: "करकंब",
        STATE_MH_CITY_1894: "करमाला",
        STATE_HR_CITY_1895: "करनाल",
        STATE_DL_CITY_1896: "करोल बाग",
        STATE_MP_CITY_1897: "कर्रापुर",
        STATE_PB_CITY_1898: "करतारपुर",
        STATE_TN_CITY_1899: "करुंबक्कम",
        STATE_TN_CITY_1900: "करूर",
        STATE_KA_CITY_1901: "कारवार",
        STATE_MH_CITY_1902: "कसारा",
        STATE_KL_CITY_1903: "कासरगोड",
        STATE_KL_CITY_1904: "कासरगोड जिला",
        STATE_HP_CITY_1905: "कसौली",
        STATE_BR_CITY_1906: "कस्बा",
        STATE_UP_CITY_1907: "कासगंज",
        STATE_UT_CITY_1908: "काशीपुर",
        STATE_MH_CITY_1909: "कसौदा",
        STATE_MP_CITY_1910: "कसरावद",
        STATE_MP_CITY_1911: "कटंगी",
        STATE_CT_CITY_1912: "कटघोरा",
        STATE_GJ_CITY_1913: "कथोर",
        STATE_JK_CITY_1914: "कठुआ",
        STATE_MH_CITY_1915: "कटी",
        STATE_BR_CITY_1916: "कटिहार",
        STATE_MP_CITY_1917: "कटनी",
        STATE_MH_CITY_1918: "काटोल",
        STATE_TN_CITY_1919: "कट्पडी",
        STATE_GJ_CITY_1920: "काटपुर",
        STATE_UP_CITY_1921: "कटरा",
        STATE_JK_CITY_1922: "कटरा",
        STATE_MH_CITY_1923: "कतराल",
        STATE_JH_CITY_1924: "कतरास",
        STATE_KL_CITY_1925: "कट्टानम",
        STATE_TN_CITY_1926: "कट्टीवक्कम",
        STATE_TN_CITY_1927: "कट्टुपुत्तूर",
        STATE_WB_CITY_1928: "कटवा",
        STATE_UP_CITY_1929: "कौसानी",
        STATE_UP_CITY_1930: "कौशांबी जिला",
        STATE_AP_CITY_1931: "कवाली",
        STATE_KA_CITY_1932: "कावलोर",
        STATE_GJ_CITY_1933: "कावंत",
        STATE_LD_CITY_1934: "कावारत्ती",
        STATE_TN_CITY_1935: "कावेरीपट्टनम",
        STATE_GJ_CITY_1936: "कावंत",
        STATE_CT_CITY_1937: "कवर्धा",
        STATE_TN_CITY_1938: "कयालपट्टिनम",
        STATE_KL_CITY_1939: "कायमकुलम",
        STATE_TN_CITY_1940: "कायत्तर",
        STATE_GJ_CITY_1941: "कायावरोहण",
        STATE_TN_CITY_1942: "कीलाकरै",
        STATE_RJ_CITY_1943: "केकड़ी",
        STATE_TN_CITY_1944: "केलमंगलम",
        STATE_UP_CITY_1945: "केमरी",
        STATE_WB_CITY_1946: "केंदा",
        STATE_OR_CITY_1947: "केंद्रपाड़ा",
        STATE_OR_CITY_1948: "केन्द्रपाड़ा",
        STATE_JH_CITY_1949: "केंदुआडीह",
        STATE_OR_CITY_1950: "केंदुझर",
        STATE_KA_CITY_1951: "केरूर",
        STATE_GJ_CITY_1952: "केरवाडा",
        STATE_WB_CITY_1953: "केशवपुर",
        STATE_GJ_CITY_1954: "केशोद",
        STATE_RJ_CITY_1955: "केशोराय पाटन",
        STATE_OR_CITY_1956: "केसिंगा",
        STATE_MP_CITY_1957: "खाचरौद",
        STATE_UP_CITY_1958: "खड़ा",
        STATE_MH_CITY_1959: "खड़की",
        STATE_UP_CITY_1960: "खागा",
        STATE_BR_CITY_1961: "खगरिया",
        STATE_BR_CITY_1962: "खगौल",
        STATE_MP_CITY_1963: "खैलार",
        STATE_UP_CITY_1964: "खैलार",
        STATE_UP_CITY_1965: "खैर",
        STATE_UP_CITY_1966: "खैराबाद",
        STATE_CT_CITY_1967: "खैरागढ़",
        STATE_MP_CITY_1968: "खजुराहो स्मारक समूह",
        STATE_MH_CITY_1969: "खालापुर",
        STATE_UP_CITY_1970: "खलीलाबाद",
        STATE_MH_CITY_1971: "खल्लार",
        STATE_OR_CITY_1972: "खलीकोट",
        STATE_PB_CITY_1973: "खमानों",
        STATE_MP_CITY_1974: "खमरिया",
        STATE_GJ_CITY_1975: "खंभालिया",
        STATE_GJ_CITY_1976: "खंभात",
        STATE_MH_CITY_1977: "खामगांव",
        STATE_CT_CITY_1978: "खम्हरिया",
        STATE_TG_CITY_1979: "खम्मम",
        STATE_KA_CITY_1980: "खानापुर",
        STATE_MH_CITY_1981: "खानापुर",
        STATE_MH_CITY_1982: "खंडाला",
        STATE_RJ_CITY_1983: "खंडेला",
        STATE_MP_CITY_1984: "खंडवा",
        STATE_MP_CITY_1985: "खंडवा जिला",
        STATE_MH_CITY_1986: "खानगांव",
        STATE_PB_CITY_1987: "खन्ना",
        STATE_UP_CITY_1988: "खानपुर",
        STATE_RJ_CITY_1989: "खानपुर",
        STATE_MH_CITY_1990: "खापा",
        STATE_BR_CITY_1991: "खड़गपुर",
        STATE_WB_CITY_1992: "खड़गपुर",
        STATE_MH_CITY_1993: "खरकवासला",
        STATE_PB_CITY_1994: "खरड़",
        STATE_WB_CITY_1995: "खरड़",
        STATE_WB_CITY_1996: "खरबा",
        STATE_MH_CITY_1997: "खारड़ा",
        STATE_WB_CITY_1998: "खरदाहा",
        STATE_UP_CITY_1999: "खरेला",
        STATE_MP_CITY_2000: "खरगापुर",
        STATE_MH_CITY_2001: "खारघर",
        STATE_MP_CITY_2002: "खरगोन",
        STATE_UP_CITY_2003: "खरगूपुर",
        STATE_OR_CITY_2004: "खरहियाल",
        STATE_HR_CITY_2005: "खरखौदा",
        STATE_UP_CITY_2006: "खरखौदा",
        STATE_CT_CITY_2007: "खरौद",
        STATE_JH_CITY_2008: "खरसावां",
        STATE_CT_CITY_2009: "खरसिया",
        STATE_MH_CITY_2010: "खरसुंडी",
        STATE_AS_CITY_2011: "खरुपटिया",
        STATE_UP_CITY_2012: "खतौली",
        STATE_MP_CITY_2013: "खातेगांव",
        STATE_UT_CITY_2014: "खटीमा",
        STATE_WB_CITY_2015: "खतरा",
        STATE_JK_CITY_2016: "खौड़",
        STATE_GJ_CITY_2017: "खावडा",
        STATE_MZ_CITY_2018: "खवहाई",
        STATE_MH_CITY_2019: "खेड़",
        STATE_GJ_CITY_2020: "खेड़ा",
        STATE_GJ_CITY_2021: "खेडब्रह्मा",
        STATE_MH_CITY_2022: "खेड़े",
        STATE_GJ_CITY_2023: "खेदोई",
        STATE_UP_CITY_2024: "खेकड़ा",
        STATE_PB_CITY_2025: "खेमकरण",
        STATE_GJ_CITY_2026: "खेराली",
        STATE_GJ_CITY_2027: "खेरालु",
        STATE_UP_CITY_2028: "खेरी",
        STATE_HR_CITY_2029: "खीरी सांपला",
        STATE_MH_CITY_2030: "खेतिया",
        STATE_RJ_CITY_2031: "खेतड़ी",
        STATE_MP_CITY_2032: "खिलचीपुर",
        STATE_MP_CITY_2033: "खिड़कियां",
        STATE_MH_CITY_2034: "खोनी",
        STATE_AR_CITY_2035: "खोंसा",
        STATE_MH_CITY_2036: "खोपोली",
        STATE_OR_CITY_2037: "खोरधा",
        STATE_TR_CITY_2038: "खोवाई",
        STATE_UP_CITY_2039: "खुदागंज",
        STATE_MP_CITY_2040: "खुजनेर",
        STATE_MH_CITY_2041: "Khuldabad",
        STATE_JH_CITY_2042: "खूंटी",
        STATE_MP_CITY_2043: "खुरई",
        STATE_OR_CITY_2044: "खुर्दा",
        STATE_UP_CITY_2045: "खुर्जा",
        STATE_BR_CITY_2046: "खुसरोपुर",
        STATE_UP_CITY_2047: "खुटार",
        STATE_UT_CITY_2048: "किच्छा",
        STATE_TN_CITY_2049: "किल भुवनगिरी",
        STATE_TN_CITY_2050: "किलवेलूर",
        STATE_HP_CITY_2051: "किन्नौर",
        STATE_MH_CITY_2052: "किनवट",
        STATE_UP_CITY_2053: "किराकत",
        STATE_CT_CITY_2054: "किरन्दुल",
        STATE_TN_CITY_2055: "किरणूर",
        STATE_UP_CITY_2056: "किरौली",
        STATE_UP_CITY_2057: "किरतपुर",
        STATE_OR_CITY_2058: "किरी बुरू",
        STATE_WB_CITY_2059: "किरनाहार",
        STATE_BR_CITY_2060: "किशनगंज",
        STATE_RJ_CITY_2061: "किशनगढ़",
        STATE_UP_CITY_2062: "किशनपुर",
        STATE_UP_CITY_2063: "किशनपुर बराल",
        STATE_UP_CITY_2064: "किशनी",
        STATE_JK_CITY_2065: "किश्तवाड़",
        STATE_UP_CITY_2066: "किठौर",
        STATE_KL_CITY_2067: "किझाके चलाकुडी",
        STATE_BR_CITY_2068: "कोआथ",
        STATE_KA_CITY_2069: "कोडागू",
        STATE_TN_CITY_2070: "कोडईकनाल",
        STATE_OR_CITY_2071: "कोडाला",
        STATE_TG_CITY_2072: "कोडर",
        STATE_JH_CITY_2073: "कोडरमा",
        STATE_KA_CITY_2074: "कोडिगेनहल्ली",
        STATE_GJ_CITY_2075: "कोडिनार",
        STATE_KA_CITY_2076: "कोडलिपेट",
        STATE_MH_CITY_2077: "कोडोली",
        STATE_TN_CITY_2078: "कोडुमुडी",
        STATE_KL_CITY_2079: "कोडुन्गल्लुर",
        STATE_BR_CITY_2080: "कोईलवर",
        STATE_NL_CITY_2081: "कोहिमा",
        STATE_AS_CITY_2082: "कोकराझार",
        STATE_AP_CITY_2083: "कोलानुकोंडा",
        STATE_KA_CITY_2084: "कोलार",
        STATE_MP_CITY_2085: "कोलारस",
        STATE_MZ_CITY_2086: "कोलासिब",
        STATE_MZ_CITY_2087: "कोलासिब जिला",
        STATE_MH_CITY_2088: "कोल्हापुर",
        STATE_WB_CITY_2089: "कोलकाता",
        STATE_KL_CITY_2090: "कोल्लम",
        STATE_KA_CITY_2091: "कोल्लेगल",
        STATE_TN_CITY_2092: "कोम्बाई",
        STATE_KA_CITY_2093: "कोनानूर",
        STATE_OR_CITY_2094: "कोणार्क",
        STATE_UP_CITY_2095: "कोंच",
        STATE_CT_CITY_2096: "कोंडागांव",
        STATE_MH_CITY_2097: "कोंडलवाड़ी",
        STATE_AP_CITY_2098: "कोंडापल्ले",
        STATE_MH_CITY_2099: "कोंढाली",
        STATE_TN_CITY_2100: "कोंगनापुरम",
        STATE_WB_CITY_2101: "कोन्नगर",
        STATE_KA_CITY_2102: "कोन्नूर",
        STATE_TN_CITY_2103: "Koothanallur",
        STATE_UP_CITY_2104: "कोपागंज",
        STATE_MH_CITY_2105: "कॉपर खैराने",
        STATE_MH_CITY_2106: "कोपरगांव",
        STATE_MH_CITY_2107: "कोपेला",
        STATE_KA_CITY_2108: "कोप्पा",
        STATE_KA_CITY_2109: "कोप्पल",
        STATE_TN_CITY_2110: "कोराडाचेरी",
        STATE_MH_CITY_2111: "कोराडी",
        STATE_TN_CITY_2112: "कोरामपल्लम",
        STATE_OR_CITY_2113: "कोरापुट",
        STATE_KA_CITY_2114: "कोराटागेरे",
        STATE_TG_CITY_2115: "कोरात्ला",
        STATE_CT_CITY_2116: "कोरबा",
        STATE_MH_CITY_2117: "कोरेगांव",
        STATE_CT_CITY_2118: "कोरिया",
        STATE_AP_CITY_2119: "कोरुकोल्लु",
        STATE_MP_CITY_2120: "कोरवाई",
        STATE_GJ_CITY_2121: "कोसम्बा",
        STATE_UP_CITY_2122: "कोसी",
        STATE_AP_CITY_2123: "कोसिगी",
        STATE_PB_CITY_2124: "कोट ईसा खान",
        STATE_UP_CITY_2125: "कोटा",
        STATE_RJ_CITY_2126: "कोटा",
        STATE_CT_CITY_2127: "कोटा",
        STATE_TN_CITY_2128: "कोटागिरी",
        STATE_KL_CITY_2129: "कोटामंगलम",
        STATE_CT_CITY_2130: "कोटापरह",
        STATE_MP_CITY_2131: "कोटर",
        STATE_UT_CITY_2132: "कोटद्वार",
        STATE_TG_CITY_2133: "Kothapet",
        STATE_GJ_CITY_2134: "कोठरा",
        STATE_GJ_CITY_2135: "कोठारिया",
        STATE_MP_CITY_2136: "कोठी",
        STATE_PB_CITY_2137: "Kotkapura",
        STATE_HP_CITY_2138: "कोटखाई",
        STATE_HP_CITY_2139: "कोटला",
        STATE_MP_CITY_2140: "कोतमा",
        STATE_RJ_CITY_2141: "कोटपुतली",
        STATE_UP_CITY_2142: "कोट्रा",
        STATE_TG_CITY_2143: "कोट्टागुडेम",
        STATE_TN_CITY_2144: "कोट्टैयुर",
        STATE_TG_CITY_2145: "कोट्टापल्ली",
        STATE_KL_CITY_2146: "कोट्टायम",
        STATE_KA_CITY_2147: "कोट्टूरू",
        STATE_MP_CITY_2148: "कोटवा",
        STATE_KL_CITY_2149: "कोवलम",
        STATE_TN_CITY_2150: "कोविलपट्टी",
        STATE_AP_CITY_2151: "कोव्वुर",
        STATE_MH_CITY_2152: "कोयनानगर",
        STATE_KL_CITY_2153: "कोझिकोड",
        STATE_AP_CITY_2154: "कृष्णा",
        STATE_TN_CITY_2155: "कृष्णागिरी",
        STATE_WB_CITY_2156: "कृष्णनगर",
        STATE_WB_CITY_2157: "कृष्णापुर",
        STATE_KA_CITY_2158: "कृष्णराजपेट",
        STATE_WB_CITY_2159: "क्षीरपाई",
        STATE_OR_CITY_2160: "कुचाईबुरी",
        STATE_RJ_CITY_2161: "कुचामन",
        STATE_RJ_CITY_2162: "कुचेरा",
        STATE_UP_CITY_2163: "कुचेसर",
        STATE_OR_CITY_2164: "कुचिंदा",
        STATE_JK_CITY_2165: "कुड",
        STATE_KA_CITY_2166: "कुदाची",
        STATE_MH_CITY_2167: "कुदाल",
        STATE_UP_CITY_2168: "कुदरकोट",
        STATE_KA_CITY_2169: "कुडलिगी",
        STATE_MH_CITY_2170: "कुही",
        STATE_JH_CITY_2171: "कुजू",
        STATE_GJ_CITY_2172: "कुकरमुंडा",
        STATE_TG_CITY_2173: "Kūkatpalli",
        STATE_GJ_CITY_2174: "कुकमा",
        STATE_MP_CITY_2175: "कुक्षी",
        STATE_TN_CITY_2176: "कुलात्तुर",
        STATE_JK_CITY_2177: "कुलगाम",
        STATE_TN_CITY_2178: "कुलिटतलाई",
        STATE_UP_CITY_2179: "कुलपहाड़",
        STATE_WB_CITY_2180: "कुलपी",
        STATE_WB_CITY_2181: "कुलतली",
        STATE_WB_CITY_2182: "कुल्टी",
        STATE_HP_CITY_2183: "कुल्लू",
        STATE_TN_CITY_2184: "कुमारलिंगम",
        STATE_TN_CITY_2185: "कुम्भकोणम",
        STATE_KL_CITY_2186: "कुम्बलम",
        STATE_MP_CITY_2187: "Kumbhraj",
        STATE_CT_CITY_2188: "कुम्हारी",
        STATE_RJ_CITY_2189: "कुम्हेर",
        STATE_KA_CITY_2190: "कुम्सी",
        STATE_KA_CITY_2191: "कुमटा",
        STATE_UP_CITY_2192: "कुंदा",
        STATE_UP_CITY_2193: "कुंदरखी",
        STATE_UP_CITY_2194: "कुंदरकी",
        STATE_KA_CITY_2195: "कुंडगोल",
        STATE_GJ_CITY_2196: "कुंडला",
        STATE_KA_CITY_2197: "कुनिगल",
        STATE_KL_CITY_2198: "कुन्नामंगलम",
        STATE_KL_CITY_2199: "कुन्नम्कुलम",
        STATE_TN_CITY_2200: "कुन्नत्तुर",
        STATE_KL_CITY_2201: "कुन्नुम्मा",
        STATE_AP_CITY_2202: "कुप्पम",
        STATE_JK_CITY_2203: "कुपवाड़ा",
        STATE_MH_CITY_2204: "कुरंदवाड",
        STATE_MH_CITY_2205: "कुरनखेड़",
        STATE_UP_CITY_2206: "कुरारा",
        STATE_MH_CITY_2207: "कुर्दुवाडी",
        STATE_UP_CITY_2208: "कूरेभार,सैदखानपुर",
        STATE_KA_CITY_2209: "कुरगुंटा",
        STATE_TN_CITY_2210: "कुरिंजिपदी",
        STATE_AP_CITY_2211: "कुरनूल",
        STATE_WB_CITY_2212: "कुर्सियांग",
        STATE_CT_CITY_2213: "कुरुद",
        STATE_HR_CITY_2214: "कुरूक्षेत्र",
        STATE_AR_CITY_2215: "कुरुंग कुमेय",
        STATE_RJ_CITY_2216: "कुशलगढ़",
        STATE_KA_CITY_2217: "कुशलनगर",
        STATE_UP_CITY_2218: "कुशीनगर",
        STATE_KA_CITY_2219: "कुश्तगी",
        STATE_UP_CITY_2220: "कुसमरा",
        STATE_MH_CITY_2221: "कुसुंबा",
        STATE_GJ_CITY_2222: "कच्छ जिला",
        STATE_UP_CITY_2223: "कुठौंद",
        STATE_KL_CITY_2224: "कुटियाटोडु",
        STATE_GJ_CITY_2225: "कुटियाना",
        STATE_TN_CITY_2226: "कुट्टलम",
        STATE_KL_CITY_2227: "कुट्टमपुझा",
        STATE_TN_CITY_2228: "कुझीथुराई",
        STATE_TG_CITY_2229: "Kyathampalle",
        STATE_HP_CITY_2230: "क्येलंग",
        STATE_RJ_CITY_2231: "लक्ष्मणगढ़ सीकर",
        STATE_JK_CITY_2232: "लद्दाख",
        STATE_RJ_CITY_2233: "लाडनूं",
        STATE_GJ_CITY_2234: "लाडोल",
        STATE_HR_CITY_2235: "लाडवा",
        STATE_MP_CITY_2236: "लहार",
        STATE_UP_CITY_2237: "लहरपुर",
        STATE_HP_CITY_2238: "लाहुल और स्पीति",
        STATE_MH_CITY_2239: "लाखांदूर",
        STATE_RJ_CITY_2240: "लखेरी",
        STATE_AS_CITY_2241: "लखीमपुर",
        STATE_UP_CITY_2242: "लखीमपुर",
        STATE_AS_CITY_2243: "लखीपुर",
        STATE_BR_CITY_2244: "लखीसराय",
        STATE_UP_CITY_2245: "लखना",
        STATE_MP_CITY_2246: "लखनादौन",
        STATE_GJ_CITY_2247: "लखपत",
        STATE_GJ_CITY_2248: "लखतर",
        STATE_UT_CITY_2249: "लक्सर",
        STATE_LD_CITY_2250: "लक्षद्वीप",
        STATE_TG_CITY_2251: "लक्शेट्टीपेट",
        STATE_KA_CITY_2252: "लक्ष्मेश्वर",
        STATE_TG_CITY_2253: "लाल बहादुर नगर",
        STATE_AS_CITY_2254: "लाला",
        STATE_KL_CITY_2255: "लालम",
        STATE_BR_CITY_2256: "लालगंज",
        STATE_UP_CITY_2257: "लालगंज",
        STATE_WB_CITY_2258: "लालगढ़",
        STATE_WB_CITY_2259: "लालगोला",
        STATE_TN_CITY_2260: "लालगुडी",
        STATE_UP_CITY_2261: "Lalitpur",
        STATE_GJ_CITY_2262: "लालपुर",
        STATE_RJ_CITY_2263: "लालसोट",
        STATE_UP_CITY_2264: "लम्भुआ",
        STATE_GJ_CITY_2265: "लंघनाज",
        STATE_MH_CITY_2266: "लांजा",
        STATE_UT_CITY_2267: "लैंसडाउन",
        STATE_UP_CITY_2268: "लार",
        STATE_MH_CITY_2269: "लासलगांव",
        STATE_JH_CITY_2270: "लातेहार",
        STATE_GJ_CITY_2271: "लाठी",
        STATE_MH_CITY_2272: "लातूर",
        STATE_PB_CITY_2273: "लौंगोवाल",
        STATE_MH_CITY_2274: "लवासा",
        STATE_UP_CITY_2275: "लावार",
        STATE_UP_CITY_2276: "लावार खास",
        STATE_MZ_CITY_2277: "लॉन्गत्लाई",
        STATE_LA_CITY_2278: "लेह",
        STATE_MP_CITY_2279: "लेटेरि",
        STATE_GJ_CITY_2280: "लिम्बडी",
        STATE_GJ_CITY_2281: "लीमखेड़ा",
        STATE_KA_CITY_2282: "लिंगसुगुर",
        STATE_MP_CITY_2283: "लोधिखेदा",
        STATE_UT_CITY_2284: "लोहाघाट",
        STATE_JH_CITY_2285: "लोहरदगा",
        STATE_HR_CITY_2286: "लोहारू",
        STATE_AR_CITY_2287: "लोहित जिला",
        STATE_MH_CITY_2288: "लोहोगांव",
        STATE_MH_CITY_2289: "लोनार",
        STATE_MH_CITY_2290: "लोनावला",
        STATE_KA_CITY_2291: "लोंदा",
        STATE_UP_CITY_2292: "लोनी",
        STATE_CT_CITY_2293: "लोरमी",
        STATE_RJ_CITY_2294: "लोसल",
        STATE_AR_CITY_2295: "निचली दिबांग घाटी",
        STATE_AR_CITY_2296: "निचला सुबनसिरी",
        STATE_WB_CITY_2297: "लोयाबाद",
        STATE_BR_CITY_2298: "लक्खीसराय",
        STATE_UP_CITY_2299: "लखनऊ",
        STATE_UP_CITY_2300: "लखनऊ जिला",
        STATE_PB_CITY_2301: "लुधियाना",
        STATE_AS_CITY_2302: "लुमडिंग रेलवे कॉलोनी",
        STATE_GJ_CITY_2303: "Lunawada",
        STATE_MZ_CITY_2304: "लुंगलेई",
        STATE_MP_CITY_2305: "माचलपुर",
        STATE_AP_CITY_2306: "माचेरला",
        STATE_UP_CITY_2307: "मछलीशहर",
        STATE_PB_CITY_2308: "Machhiwara",
        STATE_UP_CITY_2309: "मछलीशहर",
        STATE_AP_CITY_2310: "मछलीपट्टनम",
        STATE_TN_CITY_2311: "मदमबक्कम",
        STATE_AP_CITY_2312: "मदनपल्ली",
        STATE_WB_CITY_2313: "मदनपुर",
        STATE_KA_CITY_2314: "मद्दागिरी",
        STATE_KA_CITY_2315: "मद्दूर",
        STATE_GA_CITY_2316: "मडगांव",
        STATE_GJ_CITY_2317: "माधवपुर घेड",
        STATE_BR_CITY_2318: "मधेपुरा",
        STATE_GJ_CITY_2319: "मढ़ी",
        STATE_BR_CITY_2320: "मधिपुरा",
        STATE_UP_CITY_2321: "माधोगंज",
        STATE_MP_CITY_2322: "माधोगढ़",
        STATE_UP_CITY_2323: "माधोगढ़",
        STATE_BR_CITY_2324: "मधुबनी",
        STATE_JH_CITY_2325: "मधुपुर",
        STATE_WB_CITY_2326: "मध्यमग्राम",
        STATE_KA_CITY_2327: "Madikeri",
        STATE_TN_CITY_2328: "मदिपक्कम",
        STATE_AP_CITY_2329: "मदुगुला",
        STATE_TN_CITY_2330: "मदुक्कराई",
        STATE_TN_CITY_2331: "मदुक्कुर",
        STATE_TN_CITY_2332: "मदुरै",
        STATE_TN_CITY_2333: "मदुरन्थकम",
        STATE_KA_CITY_2334: "मगदी",
        STATE_JK_CITY_2335: "मागम",
        STATE_UP_CITY_2336: "मगहर",
        STATE_MH_CITY_2337: "महाबलेश्वर",
        STATE_UP_CITY_2338: "महाबन",
        STATE_TG_CITY_2339: "महबुबाबाद",
        STATE_MH_CITY_2340: "महाड",
        STATE_KA_CITY_2341: "महालिंगपुर",
        STATE_HR_CITY_2342: "महम",
        STATE_MH_CITY_2343: "महापे",
        STATE_BR_CITY_2344: "महराजगानी",
        STATE_UP_CITY_2345: "महाराजगंज",
        STATE_CT_CITY_2346: "महासमुंद",
        STATE_TG_CITY_2347: "महबूबनगर",
        STATE_PY_CITY_2348: "माहे",
        STATE_KL_CITY_2349: "महे",
        STATE_GJ_CITY_2350: "महमदावाद",
        STATE_HR_CITY_2351: "महेंद्रगढ़",
        STATE_GJ_CITY_2352: "महेसाणा",
        STATE_MP_CITY_2353: "महेश्वर",
        STATE_MP_CITY_2354: "महगवां",
        STATE_WB_CITY_2355: "महियारी",
        STATE_MH_CITY_2356: "माहिम",
        STATE_GJ_CITY_2357: "महिसा",
        STATE_WB_CITY_2358: "महिषादल सामुदायिक विकास खंड",
        STATE_UP_CITY_2359: "महमूदाबाद",
        STATE_UP_CITY_2360: "महोबा",
        STATE_UP_CITY_2361: "महोली",
        STATE_UP_CITY_2362: "महराजगंज",
        STATE_UP_CITY_2363: "महराजगंज (रायबरेली)।",
        STATE_UP_CITY_2364: "महरौनी",
        STATE_GJ_CITY_2365: "महुधा",
        STATE_UP_CITY_2366: "माहुल",
        STATE_AS_CITY_2367: "महुर",
        STATE_GJ_CITY_2368: "महुवा",
        STATE_GJ_CITY_2369: "महुवा (सूरत)",
        STATE_RJ_CITY_2370: "महवा",
        STATE_AS_CITY_2371: "माईबोंग",
        STATE_MP_CITY_2372: "मैहर",
        STATE_UP_CITY_2373: "मैलानी",
        STATE_WB_CITY_2374: "मैनागुड़ी",
        STATE_MH_CITY_2375: "मेनदर्गी",
        STATE_UP_CITY_2376: "मैनपुरी",
        STATE_ML_CITY_2377: "मैरंग",
        STATE_BR_CITY_2378: "मैरवा",
        STATE_MH_CITY_2379: "माजलगांव",
        STATE_MP_CITY_2380: "मझौली",
        STATE_UP_CITY_2381: "मझुपुर",
        STATE_PB_CITY_2382: "मजीठा",
        STATE_UP_CITY_2383: "मकनपुर",
        STATE_MH_CITY_2384: "मखजान",
        STATE_PB_CITY_2385: "मक्खू",
        STATE_RJ_CITY_2386: "मकराना",
        STATE_MP_CITY_2387: "मक्सी",
        STATE_AS_CITY_2388: "मकुम",
        STATE_MH_CITY_2389: "मालाबार हिल",
        STATE_MH_CITY_2390: "मलाड",
        STATE_OR_CITY_2391: "मलकानागिरी",
        STATE_KL_CITY_2392: "मलप्पुरम",
        STATE_UP_CITY_2393: "मलासा",
        STATE_PB_CITY_2394: "मलौत",
        STATE_KA_CITY_2395: "मालवल्ली",
        STATE_MH_CITY_2396: "मालेगांव",
        STATE_PB_CITY_2397: "मलेरकोटला",
        STATE_MP_CITY_2398: "मल्हारगढ़",
        STATE_UP_CITY_2399: "मलीहाबाद",
        STATE_TG_CITY_2400: "मल्काजगिरि लोक सभा निर्वाचन क्षेत्र",
        STATE_OR_CITY_2401: "मल्कानगिरी",
        STATE_MH_CITY_2402: "मल्कापुर",
        STATE_JH_CITY_2403: "मालकेरा",
        STATE_TN_CITY_2404: "मल्लापुरम",
        STATE_TN_CITY_2405: "मल्लसमुद्रम",
        STATE_TN_CITY_2406: "मल्लूर",
        STATE_KA_CITY_2407: "मालपे",
        STATE_GJ_CITY_2408: "मालपुर",
        STATE_RJ_CITY_2409: "मालपुरा",
        STATE_KA_CITY_2410: "मालूर",
        STATE_MH_CITY_2411: "मालवन",
        STATE_MZ_CITY_2412: "मामित",
        STATE_TN_CITY_2413: "मनाली",
        STATE_HP_CITY_2414: "मनाली",
        STATE_TN_CITY_2415: "मनालूरपेट्टई",
        STATE_TN_CITY_2416: "मनमदुरै",
        STATE_TN_CITY_2417: "मनप्पक्कम",
        STATE_TN_CITY_2418: "मन्नापरई",
        STATE_MP_CITY_2419: "मनसा",
        STATE_GJ_CITY_2420: "मनावदर",
        STATE_TN_CITY_2421: "मनावलाकुरिची",
        STATE_MP_CITY_2422: "मनावर",
        STATE_MH_CITY_2423: "मंचर",
        STATE_TG_CITY_2424: "मनचेरल",
        STATE_RJ_CITY_2425: "मंडल",
        STATE_GJ_CITY_2426: "मंडल",
        STATE_RJ_CITY_2427: "मांडलगढ़",
        STATE_TG_CITY_2428: "मंदामरी",
        STATE_MH_CITY_2429: "मंडनगढ़",
        STATE_TN_CITY_2430: "मंडपम",
        STATE_AP_CITY_2431: "मंडपेटा",
        STATE_AP_CITY_2432: "मंदासा",
        STATE_UP_CITY_2433: "मंडावर",
        STATE_RJ_CITY_2434: "मंडावर",
        STATE_MH_CITY_2435: "मांढाल",
        STATE_HR_CITY_2436: "मंढोली कलां",
        STATE_HP_CITY_2437: "मंडी",
        STATE_MP_CITY_2438: "मंडीदीप",
        STATE_MP_CITY_2439: "मंडला",
        STATE_MP_CITY_2440: "मंडलेश्वर",
        STATE_MP_CITY_2441: "मन्दसौर",
        STATE_GJ_CITY_2442: "मांडवी",
        STATE_GJ_CITY_2443: "मांडवी (सूरत)",
        STATE_MH_CITY_2444: "मंडवा",
        STATE_KA_CITY_2445: "मंड्या",
        STATE_BR_CITY_2446: "मनेर",
        STATE_AP_CITY_2447: "मंगलगिरी",
        STATE_TN_CITY_2448: "मंगलम",
        STATE_AS_CITY_2449: "मंगलदै",
        STATE_KA_CITY_2450: "मंगलौर",
        STATE_SK_CITY_2451: "मंगन",
        STATE_MH_CITY_2452: "मनगांव",
        STATE_MP_CITY_2453: "मनगवां",
        STATE_UT_CITY_2454: "मंगलौर",
        STATE_GJ_CITY_2455: "मंगरोल",
        STATE_RJ_CITY_2456: "मंगरोल",
        STATE_GJ_CITY_2457: "मांगरोल (जूनागढ़)",
        STATE_MH_CITY_2458: "मंगरुल पीर",
        STATE_UP_CITY_2459: "मनियार",
        STATE_BR_CITY_2460: "मनिहारी",
        STATE_WB_CITY_2461: "मानिकपारा",
        STATE_UP_CITY_2462: "मानिकपुर",
        STATE_KA_CITY_2463: "मणिपाल",
        STATE_KL_CITY_2464: "मंजेरी",
        STATE_KL_CITY_2465: "मंजेश्वर",
        STATE_UP_CITY_2466: "मंझनपुर",
        STATE_MH_CITY_2467: "मंझलेगांव",
        STATE_ML_CITY_2468: "मनकाचर",
        STATE_UP_CITY_2469: "मनकापुर",
        STATE_MH_CITY_2470: "मनकेश्वर",
        STATE_MH_CITY_2471: "मानखुर्द",
        STATE_MH_CITY_2472: "मनमाड",
        STATE_KL_CITY_2473: "मन्नारक्कट",
        STATE_TN_CITY_2474: "मन्नारगुडी",
        STATE_RJ_CITY_2475: "मनोहरथाना",
        STATE_RJ_CITY_2476: "मनोहरपुर",
        STATE_JH_CITY_2477: "मनोहरपुर",
        STATE_MH_CITY_2478: "जागीर",
        STATE_MP_CITY_2479: "मानपुर",
        STATE_GJ_CITY_2480: "मानसा",
        STATE_PB_CITY_2481: "मानसा",
        STATE_MH_CITY_2482: "मानसर",
        STATE_TG_CITY_2483: "मंथनी",
        STATE_TG_CITY_2484: "मनुगुरु",
        STATE_KA_CITY_2485: "मानवी",
        STATE_MH_CITY_2486: "मनवत",
        STATE_MH_CITY_2487: "मानवथ",
        STATE_GA_CITY_2488: "मापुका",
        STATE_UP_CITY_2489: "मारहरा",
        STATE_TN_CITY_2490: "मरक्कनम",
        STATE_TN_CITY_2491: "मरांडाहल्ली",
        STATE_KL_CITY_2492: "मरयूर",
        STATE_MH_CITY_2493: "मारेगांव",
        STATE_AR_CITY_2494: "मार्गेरिटा",
        STATE_BR_CITY_2495: "मढ़ौरा",
        STATE_UP_CITY_2496: "मरियाहु",
        STATE_AS_CITY_2497: "मरिअनी",
        STATE_AP_CITY_2498: "मरकापुर",
        STATE_BR_CITY_2499: "मसौढ़ी बुजुर्ग",
        STATE_WB_CITY_2500: "मासिला",
        STATE_TN_CITY_2501: "Masinagudi",
        STATE_MH_CITY_2502: "मस्तीहोली",
        STATE_MH_CITY_2503: "मसूर, भारत",
        STATE_UP_CITY_2504: "मटौंध",
        STATE_WB_CITY_2505: "माथाभांगा",
        STATE_MH_CITY_2506: "माथेरान",
        STATE_UP_CITY_2507: "मथुरा",
        STATE_WB_CITY_2508: "मटियाली सामुदायिक विकास खंड",
        STATE_WB_CITY_2509: "माटीगाड़ा सामुदायिक विकास खंड",
        STATE_KL_CITY_2510: "मत्तानूर",
        STATE_TN_CITY_2511: "मत्तूर",
        STATE_MH_CITY_2512: "माटुंगा",
        STATE_MP_CITY_2513: "मऊ",
        STATE_UP_CITY_2514: "मऊ",
        STATE_UP_CITY_2515: "मऊ आइमा",
        STATE_UP_CITY_2516: "मऊ अइम्मा",
        STATE_UP_CITY_2517: "मौदहा",
        STATE_MP_CITY_2518: "मऊगंज",
        STATE_PB_CITY_2519: "मौर मंडी",
        STATE_UP_CITY_2520: "मौरांवां",
        STATE_UP_CITY_2521: "मौरावां",
        STATE_KL_CITY_2522: "मवेलीकारा",
        STATE_KL_CITY_2523: "मावूर",
        STATE_UP_CITY_2524: "मवाना",
        STATE_UP_CITY_2525: "मावर",
        STATE_KA_CITY_2526: "मायाकोंडा",
        STATE_MN_CITY_2527: "मायंग इंफाल",
        STATE_TN_CITY_2528: "माइलादुत्रयी",
        STATE_OR_CITY_2529: "मयूरभंज",
        STATE_MH_CITY_2530: "मझगांव",
        STATE_TG_CITY_2531: "मेडक",
        STATE_TG_CITY_2532: "मेडचाल",
        STATE_TG_CITY_2533: "मेडचल मल्काजगिरि",
        STATE_WB_CITY_2534: "मेदिनीपुर",
        STATE_UP_CITY_2535: "मेरठ",
        STATE_RJ_CITY_2536: "मीठड़ी मारवाड़",
        STATE_GJ_CITY_2537: "मेघराज",
        STATE_UP_CITY_2538: "मेंहदावल",
        STATE_MH_CITY_2539: "Mehkar",
        STATE_MH_CITY_2540: "मेहरगांव",
        STATE_MH_CITY_2541: "Mehkar",
        STATE_UP_CITY_2542: "मेंहनगर",
        STATE_UP_CITY_2543: "मेंहदावल",
        STATE_GJ_CITY_2544: "मेहसाणा",
        STATE_WB_CITY_2545: "मेजिया सामुदायिक विकास खंड",
        STATE_KA_CITY_2546: "मेलकोट",
        STATE_TN_CITY_2547: "मेलूर",
        STATE_WB_CITY_2548: "मेमारी",
        STATE_GJ_CITY_2549: "मेंदरदा",
        STATE_RJ_CITY_2550: "मेर्टा",
        STATE_TN_CITY_2551: "मेट्टुप्पलैयम",
        STATE_TN_CITY_2552: "मेट्टुर",
        STATE_MH_CITY_2553: "म्हासला",
        STATE_MH_CITY_2554: "म्हसवद",
        STATE_MP_CITY_2555: "मिहोना",
        STATE_UP_CITY_2556: "मिलक",
        STATE_UP_CITY_2557: "मिल्कीपुर",
        STATE_TN_CITY_2558: "मिंजुर",
        STATE_MH_CITY_2559: "मिराज",
        STATE_UP_CITY_2560: "मीरापुर",
        STATE_UP_CITY_2561: "मीरांपुर कटरा",
        STATE_UP_CITY_2562: "मीरगंज",
        STATE_TG_CITY_2563: "मिरियालगुडा",
        STATE_WB_CITY_2564: "मिरिक",
        STATE_UP_CITY_2565: "मिर्जापुर",
        STATE_UP_CITY_2566: "मिसरिख",
        STATE_GJ_CITY_2567: "मीठापुर",
        STATE_GJ_CITY_2568: "मोडासा",
        STATE_PB_CITY_2569: "मोगा",
        STATE_MH_CITY_2570: "मोहदी",
        STATE_PB_CITY_2571: "मोहाली",
        STATE_UP_CITY_2572: "मोहन",
        STATE_UP_CITY_2573: "मोहनपुर",
        STATE_WB_CITY_2574: "मोहनपुर सामुदायिक विकास खंड",
        STATE_TN_CITY_2575: "मोहनूर",
        STATE_MP_CITY_2576: "मोहगांव",
        STATE_BR_CITY_2577: "मोहिउद्दीननगर",
        STATE_MH_CITY_2578: "मोहोल",
        STATE_MH_CITY_2579: "मोहपा",
        STATE_MN_CITY_2580: "मोइरांग",
        STATE_BR_CITY_2581: "मोकामा",
        STATE_MH_CITY_2582: "मोखाडा तालुका",
        STATE_NL_CITY_2583: "मोकोकचुंग",
        STATE_NL_CITY_2584: "सोमवार",
        STATE_BR_CITY_2585: "मुंगेर",
        STATE_WB_CITY_2586: "मोनोहरपुर",
        STATE_MH_CITY_2587: "मोरा, महाराष्ट्र",
        STATE_UP_CITY_2588: "मुरादाबाद",
        STATE_MH_CITY_2589: "मोरम",
        STATE_AS_CITY_2590: "मोरान्हा",
        STATE_MP_CITY_2591: "मोरार",
        STATE_GJ_CITY_2592: "मोरबी",
        STATE_MP_CITY_2593: "मुरैना",
        STATE_AS_CITY_2594: "मोरीगांव",
        STATE_PB_CITY_2595: "मोरिंडा",
        STATE_GA_CITY_2596: "मोरजिम",
        STATE_GA_CITY_2597: "मोरमुगाओ",
        STATE_MH_CITY_2598: "मोरसी",
        STATE_GJ_CITY_2599: "मोरवा (हदफ़)",
        STATE_GJ_CITY_2600: "मोरवा",
        STATE_UP_CITY_2601: "कीट",
        STATE_BR_CITY_2602: "मोतिहारी",
        STATE_MH_CITY_2603: "मोवाड",
        STATE_UP_CITY_2604: "मुबारकपुर",
        STATE_KA_CITY_2605: "मुदबिद्री",
        STATE_KA_CITY_2606: "मुद्देबिहाल",
        STATE_KA_CITY_2607: "मुदगल",
        STATE_KA_CITY_2608: "मुडगेरे",
        STATE_KA_CITY_2609: "मुधोल",
        STATE_MH_CITY_2610: "मुदखेड़",
        STATE_TN_CITY_2611: "मुदुकुलत्तूर",
        STATE_UP_CITY_2612: "मुगलसराय",
        STATE_JH_CITY_2613: "मुग्मा",
        STATE_UP_CITY_2614: "मुहम्मदाबाद",
        STATE_PB_CITY_2615: "मुकेरियां",
        STATE_MH_CITY_2616: "मुखर",
        STATE_UP_CITY_2617: "मुक्तेश्वर",
        STATE_MH_CITY_2618: "एमयूएल",
        STATE_TN_CITY_2619: "मुलानुर",
        STATE_KA_CITY_2620: "मुल्बगल",
        STATE_KA_CITY_2621: "मुलगुंड",
        STATE_MH_CITY_2622: "मुलहेर",
        STATE_KA_CITY_2623: "मुल्की",
        STATE_MP_CITY_2624: "मुल्ताई",
        STATE_MH_CITY_2625: "मुलुंड",
        STATE_KL_CITY_2626: "मुलुप्पिलगाडु",
        STATE_MH_CITY_2627: "मुंबई",
        STATE_MH_CITY_2628: "मुंबई उपनगर",
        STATE_KA_CITY_2629: "मुंदारगी",
        STATE_KA_CITY_2630: "मुंडगोड",
        STATE_MP_CITY_2631: "मुंडी",
        STATE_GJ_CITY_2632: "मुंद्रा",
        STATE_RJ_CITY_2633: "मूंडवा",
        STATE_MP_CITY_2634: "मुंगावली",
        STATE_CT_CITY_2635: "मुंगेली",
        STATE_BR_CITY_2636: "मुंगेर",
        STATE_UP_CITY_2637: "मुंगरा बादशाहपुर",
        STATE_KA_CITY_2638: "मुनीराबाद",
        STATE_KL_CITY_2639: "मुन्नार",
        STATE_UP_CITY_2640: "मुनस्यारी",
        STATE_UP_CITY_2641: "मुरादाबाद",
        STATE_UP_CITY_2642: "मुरादनगर",
        STATE_WB_CITY_2643: "मुरागाचा",
        STATE_MH_CITY_2644: "मुरबाड",
        STATE_MH_CITY_2645: "मुर्गुड",
        STATE_WB_CITY_2646: "मूरी",
        STATE_BR_CITY_2647: "मुरलीगंज",
        STATE_UP_CITY_2648: "मुरसान",
        STATE_WB_CITY_2649: "मुर्शिदाबाद",
        STATE_MH_CITY_2650: "मुर्तजापुर",
        STATE_MH_CITY_2651: "मुरुड (रायगढ़)",
        STATE_MH_CITY_2652: "मुरुड (रत्नागिरी)",
        STATE_KA_CITY_2653: "मुरुदेश्वर",
        STATE_MH_CITY_2654: "मुरुम",
        STATE_MP_CITY_2655: "मुरवारा",
        STATE_UP_CITY_2656: "मुसाफिर-ख़ाना",
        STATE_UP_CITY_2657: "मुसाफिरखाना",
        STATE_JH_CITY_2658: "मुशाबनी",
        STATE_TN_CITY_2659: "मुसिरी",
        STATE_UT_CITY_2660: "मसूरी",
        STATE_HR_CITY_2661: "मुस्तफाबाद",
        STATE_TN_CITY_2662: "मुट्टुपेट",
        STATE_KL_CITY_2663: "मुवत्तुपुला",
        STATE_KL_CITY_2664: "मुवात्तुपूजा",
        STATE_UP_CITY_2665: "मुजफ्फरनगर",
        STATE_BR_CITY_2666: "मुजफ्फरपुर",
        STATE_KA_CITY_2667: "मैसूर",
        STATE_WB_CITY_2668: "नवद्वीप",
        STATE_WB_CITY_2669: "नबाग्राम",
        STATE_OR_CITY_2670: "नबरंगपुर",
        STATE_PB_CITY_2671: "नाभा",
        STATE_BR_CITY_2672: "नबीनगर",
        STATE_KL_CITY_2673: "नदापुरम",
        STATE_HP_CITY_2674: "नादौन",
        STATE_RJ_CITY_2675: "नदबई",
        STATE_MH_CITY_2676: "नदगाँव",
        STATE_WB_CITY_2677: "नादिया जिला",
        STATE_GJ_CITY_2678: "नाडियाड",
        STATE_GJ_CITY_2679: "नडियाद,",
        STATE_UP_CITY_2680: "नदीगांव",
        STATE_KL_CITY_2681: "नाडुवन्नूर",
        STATE_TN_CITY_2682: "Naduvattam",
        STATE_KA_CITY_2683: "नागमंगला",
        STATE_AS_CITY_2684: "नगांव",
        STATE_TN_CITY_2685: "नागपट्टिनम",
        STATE_MH_CITY_2686: "नागापुर",
        STATE_RJ_CITY_2687: "नगर",
        STATE_HP_CITY_2688: "नगर",
        STATE_TG_CITY_2689: "नगर कर्नुल",
        STATE_AP_CITY_2690: "नगरी",
        STATE_WB_CITY_2691: "नगरुखरा",
        STATE_RJ_CITY_2692: "नागौर",
        STATE_MP_CITY_2693: "नागदा",
        STATE_TN_CITY_2694: "नागरकोइल",
        STATE_UP_CITY_2695: "नगीना",
        STATE_AP_CITY_2696: "नागिरेड्डीपल्ली",
        STATE_UP_CITY_2697: "नगला",
        STATE_MP_CITY_2698: "नागोद",
        STATE_MH_CITY_2699: "नागोथाने",
        STATE_MH_CITY_2700: "नागपुर",
        STATE_MH_CITY_2701: "नागपुर डिवीजन",
        STATE_WB_CITY_2702: "नागराकाटा",
        STATE_UP_CITY_2703: "नगराम",
        STATE_HP_CITY_2704: "नगरोटा",
        STATE_GJ_CITY_2705: "नाग्वा",
        STATE_HP_CITY_2706: "नाहन",
        STATE_AR_CITY_2707: "नाहरलगुन",
        STATE_AS_CITY_2708: "नहोरकटिया",
        STATE_MP_CITY_2709: "नईगढ़ी",
        STATE_WB_CITY_2710: "नैहाटी",
        STATE_UT_CITY_2711: "नैनीताल",
        STATE_MP_CITY_2712: "नैनपुर",
        STATE_RJ_CITY_2713: "Nainwa",
        STATE_DL_CITY_2714: "नजफगढ़",
        STATE_UP_CITY_2715: "नजीबाबाद",
        STATE_PB_CITY_2716: "नकोदर",
        STATE_WB_CITY_2717: "नकलबाड़ी",
        STATE_UP_CITY_2718: "नकुड़",
        STATE_MH_CITY_2719: "नाला सोपारा",
        STATE_HP_CITY_2720: "नालागढ़",
        STATE_BR_CITY_2721: "नालन्दा",
        STATE_AS_CITY_2722: "नलबाड़ी",
        STATE_GJ_CITY_2723: "नलधारा",
        STATE_MH_CITY_2724: "नलदुर्ग",
        STATE_MH_CITY_2725: "नालेगांव",
        STATE_TG_CITY_2726: "नलगोंडा",
        STATE_WB_CITY_2727: "नलहाटी",
        STATE_GJ_CITY_2728: "नालिया",
        STATE_WB_CITY_2729: "नालपुर",
        STATE_TN_CITY_2730: "नामगिरिपेट्टई",
        STATE_TN_CITY_2731: "नमक्कल",
        STATE_TN_CITY_2732: "नांबियूर",
        STATE_TN_CITY_2733: "नंबुतलाई",
        STATE_SK_CITY_2734: "नामची",
        STATE_WB_CITY_2735: "नामखाना सामुदायिक विकास खंड",
        STATE_MP_CITY_2736: "नामली",
        STATE_MH_CITY_2737: "नामपुर",
        STATE_AS_CITY_2738: "नामरूप",
        STATE_UP_CITY_2739: "नानौता",
        STATE_TN_CITY_2740: "Nandambakkam",
        STATE_MH_CITY_2741: "नांदेड़",
        STATE_UP_CITY_2742: "नंदगांव",
        STATE_MH_CITY_2743: "नंदगांव",
        STATE_AP_CITY_2744: "नंदीगाम",
        STATE_WB_CITY_2745: "नंदीग्राम",
        STATE_AP_CITY_2746: "नंदीकोटकुर",
        STATE_MH_CITY_2747: "नंदनी",
        STATE_MH_CITY_2748: "नांदुरा",
        STATE_MH_CITY_2749: "नांदुरा बुजुर्ग",
        STATE_MH_CITY_2750: "नंदुरबार",
        STATE_AP_CITY_2751: "नांदयाल",
        STATE_PB_CITY_2752: "नांगल",
        STATE_TN_CITY_2753: "नंगावल्ली",
        STATE_WB_CITY_2754: "नंगी",
        STATE_TN_CITY_2755: "नंगिलिकोंडन",
        STATE_DL_CITY_2756: "नांगलोई जाट",
        STATE_TN_CITY_2757: "नांगुनेरी",
        STATE_KA_CITY_2758: "नंजनगुड",
        STATE_TN_CITY_2759: "नन्निलम",
        STATE_UP_CITY_2760: "नानपारा",
        STATE_RJ_CITY_2761: "नापासर",
        STATE_RJ_CITY_2762: "नारायणा",
        STATE_MP_CITY_2763: "नरैनी",
        STATE_AP_CITY_2764: "नरसन्नपेटा",
        STATE_AP_CITY_2765: "नरसापुर",
        STATE_AP_CITY_2766: "नरसरावपेट",
        STATE_KA_CITY_2767: "नरसिम्हराजपुरा",
        STATE_AP_CITY_2768: "नरसिंगपुरम",
        STATE_UP_CITY_2769: "नरौली",
        STATE_UP_CITY_2770: "नरौरा",
        STATE_TN_CITY_2771: "नरवरिकुप्पम",
        STATE_AP_CITY_2772: "नारायणवनम",
        STATE_MH_CITY_2773: "नारायणगांव",
        STATE_HR_CITY_2774: "नारायणगढ़",
        STATE_MP_CITY_2775: "नारायणगढ़",
        STATE_TG_CITY_2776: "नारायणपेट",
        STATE_CT_CITY_2777: "नारायणपुर",
        STATE_MH_CITY_2778: "नरदाना",
        STATE_KA_CITY_2779: "नारेगल",
        STATE_DL_CITY_2780: "नरेला",
        STATE_UT_CITY_2781: "नरेंद्रनगर",
        STATE_GJ_CITY_2782: "नारगोल",
        STATE_KA_CITY_2783: "नरगुंद",
        STATE_CT_CITY_2784: "नरहरपुर",
        STATE_MH_CITY_2785: "नरीमन पॉइंट",
        STATE_MH_CITY_2786: "नरखेड",
        STATE_GJ_CITY_2787: "नर्मदा",
        STATE_HR_CITY_2788: "नारनौल",
        STATE_HR_CITY_2789: "नारनौंद",
        STATE_GJ_CITY_2790: "नरोडा",
        STATE_UP_CITY_2791: "नरौरा",
        STATE_MP_CITY_2792: "नरसिंहपुर",
        STATE_MP_CITY_2793: "नरसिंहगढ़",
        STATE_TG_CITY_2794: "Narsingi",
        STATE_AP_CITY_2795: "Narsipatnam",
        STATE_HR_CITY_2796: "नरवाना",
        STATE_MP_CITY_2797: "नरवर",
        STATE_MH_CITY_2798: "नासिक",
        STATE_MH_CITY_2799: "नासिक प्रभाग",
        STATE_RJ_CITY_2800: "नसीराबाद",
        STATE_TG_CITY_2801: "नासपुर",
        STATE_BR_CITY_2802: "Nasriganj",
        STATE_MP_CITY_2803: "नसरुल्लागंज",
        STATE_RJ_CITY_2804: "नाथद्वारा",
        STATE_TN_CITY_2805: "नट्टम",
        STATE_TN_CITY_2806: "नट्टारासंकोट्टई",
        STATE_BR_CITY_2807: "नवगछिया",
        STATE_UP_CITY_2808: "नौगामा",
        STATE_UP_CITY_2809: "नौरंगपुर",
        STATE_UP_CITY_2810: "नौतनवा",
        STATE_KA_CITY_2811: "नवलगुंद",
        STATE_MH_CITY_2812: "नवापुर",
        STATE_GA_CITY_2813: "नवेलिम",
        STATE_MH_CITY_2814: "नवी मुंबई",
        STATE_GJ_CITY_2815: "नवसारी",
        STATE_RJ_CITY_2816: "नवा",
        STATE_UP_CITY_2817: "नवाबगंज",
        STATE_UP_CITY_2818: "नवाबगंज (बाराबंकी)।",
        STATE_UP_CITY_2819: "नवाबगंज (बरेली)",
        STATE_BR_CITY_2820: "नवादा",
        STATE_RJ_CITY_2821: "नवलगढ़",
        STATE_PB_CITY_2822: "नवांशहर",
        STATE_JK_CITY_2823: "नवांशहर",
        STATE_SK_CITY_2824: "नया बाजार",
        STATE_OR_CITY_2825: "नयागढ़",
        STATE_OR_CITY_2826: "नयागढ़ जिला",
        STATE_WB_CITY_2827: "नयाग्राम सामुदायिक विकास खंड",
        STATE_AP_CITY_2828: "नायडूपेट",
        STATE_AS_CITY_2829: "नाज़िरा",
        STATE_KL_CITY_2830: "नेदुमनगड",
        STATE_TN_CITY_2831: "नीदमंगलम",
        STATE_TN_CITY_2832: "नीलंकरई",
        STATE_RJ_CITY_2833: "नीम का थाना",
        STATE_MP_CITY_2834: "नीमच",
        STATE_TN_CITY_2835: "नेगापट्टम",
        STATE_KA_CITY_2836: "नेलमंगला",
        STATE_TN_CITY_2837: "नेल्लिक्कुप्पम",
        STATE_AP_CITY_2838: "नेल्लोर",
        STATE_MP_CITY_2839: "नेपानगर",
        STATE_MH_CITY_2840: "नेरल",
        STATE_MH_CITY_2841: "नेरूर",
        STATE_JH_CITY_2842: "नेतुरहाट",
        STATE_MH_CITY_2843: "नेवासा",
        STATE_DL_CITY_2844: "नई दिल्ली",
        STATE_UP_CITY_2845: "नेवारा",
        STATE_KL_CITY_2846: "Neyyattinkara",
        STATE_UP_CITY_2847: "निचलौल",
        STATE_AN_CITY_2848: "निकोबार",
        STATE_AP_CITY_2849: "निदादावोले",
        STATE_MH_CITY_2850: "निघोज",
        STATE_UP_CITY_2851: "निगोह",
        STATE_UP_CITY_2852: "निहटौर",
        STATE_GJ_CITY_2853: "निकोरा",
        STATE_TN_CITY_2854: "नीलाकोट्टई",
        STATE_MH_CITY_2855: "निलंगा",
        STATE_KL_CITY_2856: "नीलेश्वर",
        STATE_OR_CITY_2857: "नीलगिरि",
        STATE_TN_CITY_2858: "नीलगिरी",
        STATE_HR_CITY_2859: "नीलोखेड़ी",
        STATE_RJ_CITY_2860: "निमाज",
        STATE_OR_CITY_2861: "नीमापरहा",
        STATE_RJ_CITY_2862: "निंबाहेङा",
        STATE_MH_CITY_2863: "निपानी",
        STATE_MH_CITY_2864: "निफाड",
        STATE_MH_CITY_2865: "नीरा नरसिंगपुर",
        STATE_TG_CITY_2866: "निर्मल",
        STATE_BR_CITY_2867: "निर्मली",
        STATE_JH_CITY_2868: "निरसा",
        STATE_RJ_CITY_2869: "निवाई",
        STATE_UP_CITY_2870: "निवाड़ी",
        STATE_TG_CITY_2871: "निजामाबाद",
        STATE_UP_CITY_2872: "निजामाबाद",
        STATE_GJ_CITY_2873: "निज़ार",
        STATE_JH_CITY_2874: "नोवामुंडी",
        STATE_RJ_CITY_2875: "नोहर",
        STATE_UP_CITY_2876: "नोएडा",
        STATE_RJ_CITY_2877: "नोखा",
        STATE_ML_CITY_2878: "नोंगपोह",
        STATE_ML_CITY_2879: "नोंगस्टोइन",
        STATE_JK_CITY_2880: "नोरिया",
        STATE_WB_CITY_2881: "उत्तर 24 परगना जिला",
        STATE_DL_CITY_2882: "उत्तरी दिल्ली",
        STATE_SK_CITY_2883: "उत्तर जिला",
        STATE_DL_CITY_2884: "उत्तर पूर्वी दिल्ली",
        STATE_ML_CITY_2885: "उत्तरी गारो हिल्स",
        STATE_GA_CITY_2886: "उत्तरी गोवा",
        STATE_AS_CITY_2887: "उत्तर गुवाहाटी",
        STATE_AS_CITY_2888: "उत्तर-लखीमपुर",
        STATE_TR_CITY_2889: "उत्तरी त्रिपुरा",
        STATE_MZ_CITY_2890: "उत्तर वनलाईफाई",
        STATE_DL_CITY_2891: "उत्तर पश्चिम दिल्ली",
        STATE_OR_CITY_2892: "नौरंगपुर",
        STATE_OR_CITY_2893: "नुआपाड़ा",
        STATE_HR_CITY_2894: "नूह",
        STATE_AS_CITY_2895: "नुमालीगढ़",
        STATE_PB_CITY_2896: "नूरमहल",
        STATE_UP_CITY_2897: "नूरपुर",
        STATE_PB_CITY_2898: "नूरपुर कलां",
        STATE_AP_CITY_2899: "नुज्विद",
        STATE_KA_CITY_2900: "न्यामती",
        STATE_UP_CITY_2901: "obra",
        STATE_GJ_CITY_2902: "ओदादर",
        STATE_WB_CITY_2903: "ओडलाबारी",
        STATE_TN_CITY_2904: "ओडुगट्टूर",
        STATE_GJ_CITY_2905: "ओखा",
        STATE_GJ_CITY_2906: "ओलपाड",
        STATE_TN_CITY_2907: "ओमलुर",
        STATE_AP_CITY_2908: "ओंगोल",
        STATE_TN_CITY_2909: "ऊटी",
        STATE_UP_CITY_2910: "उरई",
        STATE_UP_CITY_2911: "ओरान",
        STATE_MP_CITY_2912: "ओरछा",
        STATE_MH_CITY_2913: "उस्मानाबाद",
        STATE_KL_CITY_2914: "ओट्टापलम",
        STATE_MH_CITY_2915: "ओज़ार",
        STATE_MH_CITY_2916: "पबल",
        STATE_MP_CITY_2917: "पचमढ़ी",
        STATE_MH_CITY_2918: "पचोरा",
        STATE_UP_CITY_2919: "पचपेरवा",
        STATE_JK_CITY_2920: "पदम",
        STATE_RJ_CITY_2921: "पदमपुर",
        STATE_OR_CITY_2922: "पदमपुर",
        STATE_GJ_CITY_2923: "पदधारी",
        STATE_TN_CITY_2924: "पद्मनाभपुरम",
        STATE_GJ_CITY_2925: "पड़रा",
        STATE_UP_CITY_2926: "पडरौना",
        STATE_UP_CITY_2927: "पहासू",
        STATE_JK_CITY_2928: "पहलगाम",
        STATE_MH_CITY_2929: "पहुर, महाराष्ट्र",
        STATE_UP_CITY_2930: "पैगांव",
        STATE_WB_CITY_2931: "पाइकपारा",
        STATE_MH_CITY_2932: "पैठण",
        STATE_AP_CITY_2933: "पकाला",
        STATE_JH_CITY_2934: "पाकुर",
        STATE_KL_CITY_2935: "पलक्कट्टुमाला",
        STATE_KL_CITY_2936: "पलक्कड़ जिला",
        STATE_TN_CITY_2937: "पलककोडु",
        STATE_AP_CITY_2938: "पलाकोल्लू",
        STATE_TN_CITY_2939: "पलामेडु",
        STATE_HP_CITY_2940: "पालमपुर",
        STATE_JH_CITY_2941: "पलामू",
        STATE_TN_CITY_2942: "पलानी",
        STATE_GJ_CITY_2943: "पालनपुर",
        STATE_GJ_CITY_2944: "पलानस्वा",
        STATE_AP_CITY_2945: "पलासा",
        STATE_AS_CITY_2946: "पलासबाड़ी",
        STATE_TN_CITY_2947: "पलवक्कम",
        STATE_MP_CITY_2948: "पलेरा",
        STATE_MH_CITY_2949: "Palghar",
        STATE_KL_CITY_2950: "के पालघाट",
        STATE_RJ_CITY_2951: "पाली",
        STATE_MP_CITY_2952: "पाली",
        STATE_UP_CITY_2953: "पाली",
        STATE_MH_CITY_2954: "पाली, रायगढ़",
        STATE_UP_CITY_2955: "पलिया कलां",
        STATE_GJ_CITY_2956: "पालिताना",
        STATE_GJ_CITY_2957: "पलियाड",
        STATE_GJ_CITY_2958: "पलियाड (भावनगर)",
        STATE_AP_CITY_2959: "पलकोंडा",
        STATE_TN_CITY_2960: "पल्लादम",
        STATE_TN_CITY_2961: "पल्लापट्टी",
        STATE_TN_CITY_2962: "पल्लात्तूर",
        STATE_TN_CITY_2963: "पल्लावरम",
        STATE_GA_CITY_2964: "पल्ले",
        STATE_AP_CITY_2965: "पल्लेवाड़ा",
        STATE_TN_CITY_2966: "पल्लीकोंडाई",
        STATE_TN_CITY_2967: "पल्लीपट्टू",
        STATE_TN_CITY_2968: "पल्लीपट्टी",
        STATE_AP_CITY_2969: "पामनेर",
        STATE_TG_CITY_2970: "पलोंचा",
        STATE_GJ_CITY_2971: "पलसाना",
        STATE_MH_CITY_2972: "पलसो",
        STATE_HR_CITY_2973: "पलवल",
        STATE_TG_CITY_2974: "पलवांचा",
        STATE_MP_CITY_2975: "पनागर",
        STATE_WB_CITY_2976: "पानागढ़",
        STATE_GA_CITY_2977: "पणजी",
        STATE_KL_CITY_2978: "पनामारम",
        STATE_MP_CITY_2979: "Panera",
        STATE_GJ_CITY_2980: "पंचमहल",
        STATE_MH_CITY_2981: "पंचगनी",
        STATE_HR_CITY_2982: "पंचकुला",
        STATE_WB_CITY_2983: "पांचला",
        STATE_GJ_CITY_2984: "पंचमहल जिला",
        STATE_WB_CITY_2985: "पंचमुरा",
        STATE_CT_CITY_2986: "पंडरिया",
        STATE_CT_CITY_2987: "पांडातराई",
        STATE_MP_CITY_2988: "पंधाना",
        STATE_MH_CITY_2989: "पंढरपुर",
        STATE_MH_CITY_2990: "पांढुर्ली",
        STATE_MP_CITY_2991: "पंधुरना",
        STATE_HP_CITY_2992: "पंडोह",
        STATE_WB_CITY_2993: "पांडुआ",
        STATE_KA_CITY_2994: "पंगाला",
        STATE_MH_CITY_2995: "पन्हाला",
        STATE_WB_CITY_2996: "पानीहाटी",
        STATE_HR_CITY_2997: "पानीपत",
        STATE_MP_CITY_2998: "पन्ना",
        STATE_TN_CITY_2999: "Panruti",
        STATE_MP_CITY_3000: "पानसेमल",
        STATE_WB_CITY_3001: "पंसकुरा",
        STATE_MH_CITY_3002: "पनवेल",
        STATE_HP_CITY_3003: "पांवटा साहिब",
        STATE_TN_CITY_3004: "पापनासम",
        STATE_TN_CITY_3005: "पपीरेड्डीपट्टी",
        STATE_TN_CITY_3006: "पप्पारापट्टी",
        STATE_KL_CITY_3007: "पप्पिनिशेरी",
        STATE_OR_CITY_3008: "पारादीप गढ़",
        STATE_TN_CITY_3009: "परमाकुदी",
        STATE_UP_CITY_3010: "परस रामपुर",
        STATE_MP_CITY_3011: "परासिया",
        STATE_KL_CITY_3012: "परावुर तेक्कुंभगम",
        STATE_WB_CITY_3013: "Parbatipur",
        STATE_MH_CITY_3014: "परभनी",
        STATE_GJ_CITY_3015: "पारदी",
        STATE_MH_CITY_3016: "परेल",
        STATE_UP_CITY_3017: "पारीछा",
        STATE_UP_CITY_3018: "पारीछतगढ़",
        STATE_KL_CITY_3019: "पारियापुरम",
        STATE_AP_CITY_3020: "पार्लाकिमिडी",
        STATE_MH_CITY_3021: "परली वैजनाथ",
        STATE_MH_CITY_3022: "पारनर",
        STATE_GJ_CITY_3023: "पारनेरा",
        STATE_JK_CITY_3024: "परोल",
        STATE_MH_CITY_3025: "परोला",
        STATE_MH_CITY_3026: "परसिवनी",
        STATE_UP_CITY_3027: "परशदेपुर",
        STATE_RJ_CITY_3028: "परतापुर",
        STATE_MH_CITY_3029: "पार्टूर",
        STATE_AP_CITY_3030: "पार्वतीपुरम",
        STATE_RJ_CITY_3031: "पर्वतसर",
        STATE_HP_CITY_3032: "परवाणू",
        STATE_CT_CITY_3033: "पसान",
        STATE_WB_CITY_3034: "पश्चिम मेदिनीपुर जिला",
        STATE_BR_CITY_3035: "पश्चिम चंपारण",
        STATE_JH_CITY_3036: "पश्चिम सिंहभूम",
        STATE_AR_CITY_3037: "पासीघाट",
        STATE_JH_CITY_3038: "पटमदा",
        STATE_OR_CITY_3039: "पटामुंडाई",
        STATE_GJ_CITY_3040: "पाटन",
        STATE_CT_CITY_3041: "पाटन",
        STATE_MH_CITY_3042: "पाटन",
        STATE_MP_CITY_3043: "पाटन",
        STATE_TG_CITY_3044: "Patancheru",
        STATE_HR_CITY_3045: "पटौदी",
        STATE_UP_CITY_3046: "पाठकपुरा",
        STATE_CT_CITY_3047: "पत्थलगांव",
        STATE_KL_CITY_3048: "पथानामथिट्टा",
        STATE_PB_CITY_3049: "पठानकोट",
        STATE_MH_CITY_3050: "पाथर्डी",
        STATE_JH_CITY_3051: "पाथरडीह",
        STATE_MP_CITY_3052: "पथरिया",
        STATE_MH_CITY_3053: "पथरी",
        STATE_PB_CITY_3054: "पटियाला",
        STATE_UP_CITY_3055: "पटियाली",
        STATE_WB_CITY_3056: "पतिराम",
        STATE_BR_CITY_3057: "पटना",
        STATE_OR_CITY_3058: "पटनागढ़",
        STATE_WB_CITY_3059: "पत्रासेर",
        STATE_JK_CITY_3060: "पट्टन",
        STATE_KL_CITY_3061: "पथानामथिट्टा",
        STATE_PB_CITY_3062: "पट्टी",
        STATE_UP_CITY_3063: "पट्टी",
        STATE_TN_CITY_3064: "पत्तुकोत्तई",
        STATE_WB_CITY_3065: "पाटुली",
        STATE_MH_CITY_3066: "पातुर",
        STATE_MH_CITY_3067: "पातुरदा",
        STATE_MH_CITY_3068: "पीए यूडी",
        STATE_MH_CITY_3069: "पौनी",
        STATE_UT_CITY_3070: "पौडी",
        STATE_GJ_CITY_3071: "प्रावि जेतपुर",
        STATE_KA_CITY_3072: "पावुगाडा",
        STATE_AP_CITY_3073: "पावुलुरू",
        STATE_MP_CITY_3074: "पवई",
        STATE_UP_CITY_3075: "पवायां",
        STATE_MH_CITY_3076: "पवनी",
        STATE_UP_CITY_3077: "पयागपुर",
        STATE_KL_CITY_3078: "पय्यान्नूर",
        STATE_AP_CITY_3079: "पेडाना",
        STATE_AP_CITY_3080: "पेद्दा नक्कलपलेम",
        STATE_TG_CITY_3081: "पेद्दापल्ली",
        STATE_AP_CITY_3082: "पेद्दापुरम",
        STATE_MH_CITY_3083: "पेड़गांव",
        STATE_HR_CITY_3084: "पेहोवा",
        STATE_MH_CITY_3085: "पेंट",
        STATE_MH_CITY_3086: "कलम",
        STATE_CT_CITY_3087: "पेंड्रा",
        STATE_TN_CITY_3088: "पेन्नादम",
        STATE_TN_CITY_3089: "पेन्नाग्राम",
        STATE_TN_CITY_3090: "पेन्नाथुर",
        STATE_AP_CITY_3091: "पेनुगोंडा",
        STATE_AP_CITY_3092: "पेनुकोंडा",
        STATE_TN_CITY_3093: "पेराइयुर",
        STATE_TN_CITY_3094: "पेरम्बलुर",
        STATE_TN_CITY_3095: "पेरानामल्लूर",
        STATE_TN_CITY_3096: "पेरानमपट्टू",
        STATE_TN_CITY_3097: "पेरावुरानी",
        STATE_NL_CITY_3098: "पेरेन",
        STATE_TN_CITY_3099: "पेरियाकुलम",
        STATE_TN_CITY_3100: "पेरियानायक्कनपालयम",
        STATE_TN_CITY_3101: "पेरियानेगाम",
        STATE_TN_CITY_3102: "पेरियापट्टी",
        STATE_TN_CITY_3103: "पेरियापट्टिनम",
        STATE_GA_CITY_3104: "पेरनेम",
        STATE_KL_CITY_3105: "Perumbavoor",
        STATE_KL_CITY_3106: "पेरुमपावुर",
        STATE_TN_CITY_3107: "पेरुंदुरई",
        STATE_TN_CITY_3108: "Perungudi",
        STATE_TN_CITY_3109: "पेरूर",
        STATE_KL_CITY_3110: "पेरिया",
        STATE_GJ_CITY_3111: "पेटलाड",
        STATE_MP_CITY_3112: "पेटलावद",
        STATE_PB_CITY_3113: "फगवाड़ा",
        STATE_UP_CITY_3114: "फलौदा",
        STATE_RJ_CITY_3115: "फलौदी",
        STATE_MH_CITY_3116: "फलटन",
        STATE_UP_CITY_3117: "फाफामऊ",
        STATE_UP_CITY_3118: "फफूंद",
        STATE_UP_CITY_3119: "फरिहा",
        STATE_MN_CITY_3120: "फ़ेक",
        STATE_NL_CITY_3121: "फ़ेक",
        STATE_UP_CITY_3122: "फियोना",
        STATE_PB_CITY_3123: "फिल्लौर",
        STATE_AP_CITY_3124: "फिरंगीपुरम",
        STATE_MH_CITY_3125: "फुलम्बरी",
        STATE_OR_CITY_3126: "फूलबनी",
        STATE_RJ_CITY_3127: "फुलेरा",
        STATE_UP_CITY_3128: "फूलपुर",
        STATE_UP_CITY_3129: "पिछौरा",
        STATE_UP_CITY_3130: "पिहानी",
        STATE_RJ_CITY_3131: "पिलानी",
        STATE_RJ_CITY_3132: "पीलीबंगा",
        STATE_UP_CITY_3133: "पीलीभीत",
        STATE_MH_CITY_3134: "पिलिव",
        STATE_UP_CITY_3135: "पिलखुआ",
        STATE_UP_CITY_3136: "Pilkhuwa",
        STATE_MH_CITY_3137: "पिंपलगांव बसवंत",
        STATE_MH_CITY_3138: "पिंपलगांव राजा",
        STATE_MH_CITY_3139: "पिंपरी",
        STATE_MH_CITY_3140: "पिंपरी-चिंचवड",
        STATE_UP_CITY_3141: "पिनाहट",
        STATE_RJ_CITY_3142: "पिंडवाड़ा",
        STATE_HR_CITY_3143: "पिंजौर",
        STATE_UT_CITY_3144: "पीपलकोटी",
        STATE_RJ_CITY_3145: "पीपाड़",
        STATE_GJ_CITY_3146: "पिपावाव",
        STATE_OR_CITY_3147: "पिपिली",
        STATE_GJ_CITY_3148: "पिपलोद",
        STATE_MP_CITY_3149: "पिपलौदा",
        STATE_AP_CITY_3150: "पिपरा",
        STATE_UP_CITY_3151: "पिपराइच",
        STATE_MH_CITY_3152: "पिपरी",
        STATE_UP_CITY_3153: "पिपरी",
        STATE_KL_CITY_3154: "पिरावम",
        STATE_RJ_CITY_3155: "पिरावा",
        STATE_KA_CITY_3156: "पिरियापटना",
        STATE_BR_CITY_3157: "पिरो",
        STATE_DL_CITY_3158: "पीतमपुरा",
        STATE_MP_CITY_3159: "पीथमपुर",
        STATE_AP_CITY_3160: "पीथापुरम",
        STATE_CT_CITY_3161: "पिथौरा",
        STATE_UT_CITY_3162: "पिथोरागढ़",
        STATE_RJ_CITY_3163: "पोखरण",
        STATE_OR_CITY_3164: "Polasara",
        STATE_AP_CITY_3165: "पोलावरम",
        STATE_TN_CITY_3166: "पोलाची",
        STATE_TN_CITY_3167: "पोलूर",
        STATE_GA_CITY_3168: "पोंडा",
        STATE_KL_CITY_3169: "पोनमना",
        STATE_TN_CITY_3170: "पोन्नामरावती",
        STATE_KA_CITY_3171: "पोन्नमपेट",
        STATE_KL_CITY_3172: "पोन्नानी",
        STATE_TN_CITY_3173: "पोन्नेरी",
        STATE_AP_CITY_3174: "पोन्नूर",
        STATE_AP_CITY_3175: "पोन्नुरु",
        STATE_TN_CITY_3176: "Poonamallee",
        STATE_GJ_CITY_3177: "पोरबंदर",
        STATE_MP_CITY_3178: "पोरसा",
        STATE_AN_CITY_3179: "पोर्ट ब्लेयर",
        STATE_TN_CITY_3180: "पोरूर",
        STATE_MH_CITY_3181: "पवई",
        STATE_MH_CITY_3182: "प्रभादेवी",
        STATE_GJ_CITY_3183: "प्रभास पाटण",
        STATE_AP_CITY_3184: "प्रकाशम",
        STATE_MH_CITY_3185: "प्रकाशा",
        STATE_GJ_CITY_3186: "Prantij",
        STATE_RJ_CITY_3187: "प्रतापगढ़",
        STATE_UP_CITY_3188: "प्रतापगढ़",
        STATE_UP_CITY_3189: "प्रयागराज (इलाहाबाद)",
        STATE_AP_CITY_3190: "प्रोद्दातुर",
        STATE_PY_CITY_3191: "पुदुचेरी",
        STATE_TN_CITY_3192: "पुदुक्कोट्टई",
        STATE_TN_CITY_3193: "पुडुपट्टी",
        STATE_TN_CITY_3194: "पुदुर",
        STATE_TN_CITY_3195: "पुडुवायल",
        STATE_WB_CITY_3196: "पुजाली",
        STATE_UP_CITY_3197: "पुखरायाँ",
        STATE_MH_CITY_3198: "पुलगांव",
        STATE_AP_CITY_3199: "पुलिवेन्दुला",
        STATE_TN_CITY_3200: "पुलियानगुडी",
        STATE_TN_CITY_3201: "पुलियूर",
        STATE_TN_CITY_3202: "पुल्लमबाड़ी",
        STATE_JK_CITY_3203: "पुलवामा",
        STATE_HR_CITY_3204: "पुनहाना",
        STATE_KL_CITY_3205: "पुनालुर",
        STATE_MP_CITY_3206: "पुनासा",
        STATE_JK_CITY_3207: "मुक्का",
        STATE_WB_CITY_3208: "पुंचा सामुदायिक विकास खंड",
        STATE_HR_CITY_3209: "पूंडरी",
        STATE_MH_CITY_3210: "पुणे",
        STATE_MH_CITY_3211: "पुणे डिवीजन",
        STATE_AP_CITY_3212: "पुंगनुरु",
        STATE_TN_CITY_3213: "पुंजई पुलियामपट्टी",
        STATE_MH_CITY_3214: "पुणतांबा",
        STATE_BR_CITY_3215: "पुपरी",
        STATE_MH_CITY_3216: "पुराल",
        STATE_UP_CITY_3217: "पूरनपुर",
        STATE_BR_CITY_3218: "पूर्वी चंपारण",
        STATE_WB_CITY_3219: "पूर्व मेदिनीपुर जिला",
        STATE_JH_CITY_3220: "पूर्वी सिंहभूम",
        STATE_OR_CITY_3221: "पुरी",
        STATE_UP_CITY_3222: "पुरमाफी",
        STATE_MH_CITY_3223: "पूर्णा",
        STATE_BR_CITY_3224: "पूर्णिया",
        STATE_WB_CITY_3225: "पुरुलिया",
        STATE_OR_CITY_3226: "पुरूषोत्तमपुर",
        STATE_UP_CITY_3227: "पूर्वा",
        STATE_MH_CITY_3228: "पुसाद",
        STATE_RJ_CITY_3229: "पुष्कर",
        STATE_AP_CITY_3230: "पुट्टपर्ती",
        STATE_KA_CITY_3231: "पुत्तूर",
        STATE_AP_CITY_3232: "पुत्तूर",
        STATE_PB_CITY_3233: "क़दियन",
        STATE_UP_CITY_3234: "कादिरगंज",
        STATE_JK_CITY_3235: "काजीगुंड",
        STATE_GA_CITY_3236: "क्यूपेम",
        STATE_GA_CITY_3237: "क्यूला",
        STATE_TG_CITY_3238: "कुथबुल्लापुर",
        STATE_KA_CITY_3239: "रबकवि",
        STATE_UP_CITY_3240: "राबूपुरा",
        STATE_HR_CITY_3241: "रादौर",
        STATE_UP_CITY_3242: "राधा कुंड",
        STATE_UP_CITY_3243: "राधाकुंड",
        STATE_MH_CITY_3244: "राधानगरी",
        STATE_GJ_CITY_3245: "राधनपुर",
        STATE_UP_CITY_3246: "रायबरेली",
        STATE_BR_CITY_3247: "रफीगंज",
        STATE_MP_CITY_3248: "राघोगढ़",
        STATE_WB_CITY_3249: "रघुदेबबती",
        STATE_BR_CITY_3250: "रघुनाथपुर",
        STATE_WB_CITY_3251: "रघुनाथपुर",
        STATE_AS_CITY_3252: "राहा",
        STATE_MH_CITY_3253: "राहाता",
        STATE_MP_CITY_3254: "राहतगढ़",
        STATE_MH_CITY_3255: "रहीमतपुर",
        STATE_PB_CITY_3256: "राहों",
        STATE_MH_CITY_3257: "राहुरी",
        STATE_GA_CITY_3258: "राया",
        STATE_KA_CITY_3259: "रायचुर",
        STATE_WB_CITY_3260: "रायगंज",
        STATE_CT_CITY_3261: "रायगढ़",
        STATE_MH_CITY_3262: "रायगढ़",
        STATE_PB_CITY_3263: "रायकोट",
        STATE_RJ_CITY_3264: "रायपुर",
        STATE_CT_CITY_3265: "रायपुर",
        STATE_UT_CITY_3266: "रायपुर",
        STATE_MH_CITY_3267: "रायरेश्वर",
        STATE_MP_CITY_3268: "रायसेन",
        STATE_RJ_CITY_3269: "रायसिंह नगर",
        STATE_UT_CITY_3270: "रायवाला बारा",
        STATE_CT_CITY_3271: "राज नंदगांव",
        STATE_CT_CITY_3272: "राज-नांदगांव",
        STATE_AP_CITY_3273: "राजमुंदरी",
        STATE_RJ_CITY_3274: "राजाखेड़ा",
        STATE_RJ_CITY_3275: "राजलदेसर",
        STATE_TG_CITY_3276: "राजन्ना सिरसिला",
        STATE_JK_CITY_3277: "राजोरी",
        STATE_TN_CITY_3278: "राजपलायम",
        STATE_MH_CITY_3279: "राजापुर",
        STATE_UP_CITY_3280: "राजापुर",
        STATE_PB_CITY_3281: "राजासांसी",
        STATE_JK_CITY_3282: "राजौरी",
        STATE_RJ_CITY_3283: "राजगढ़",
        STATE_MP_CITY_3284: "राजगढ़",
        STATE_HP_CITY_3285: "राजगढ़",
        STATE_BR_CITY_3286: "राजगीर",
        STATE_MH_CITY_3287: "राजगुरुनगर",
        STATE_GJ_CITY_3288: "राजकोट",
        STATE_WB_CITY_3289: "राजमहल",
        STATE_MP_CITY_3290: "राजनगर",
        STATE_WB_CITY_3291: "राजनगर सामुदायिक विकास खंड",
        STATE_GJ_CITY_3292: "राजपिपला",
        STATE_MP_CITY_3293: "राजपुर",
        STATE_PB_CITY_3294: "राजपुरा",
        STATE_RJ_CITY_3295: "राजसमंद",
        STATE_GJ_CITY_3296: "राजुला",
        STATE_MH_CITY_3297: "राजुर",
        STATE_MH_CITY_3298: "राजुरा",
        STATE_MH_CITY_3299: "रालेगांव",
        STATE_PB_CITY_3300: "राम दास",
        STATE_AP_CITY_3301: "रामचन्द्रपुरम",
        STATE_TG_CITY_3302: "रामगुंडम",
        STATE_KL_CITY_3303: "राममंगलम",
        STATE_KA_CITY_3304: "रामानगर",
        STATE_TN_CITY_3305: "रामनाथपुरम",
        STATE_AP_CITY_3306: "रामनय्यापेटा",
        STATE_CT_CITY_3307: "रामानुजगंज",
        STATE_AP_CITY_3308: "रामपुरम",
        STATE_JK_CITY_3309: "रामबन",
        STATE_OR_CITY_3310: "रंभा",
        STATE_WB_CITY_3311: "रामचन्द्रपुर",
        STATE_TN_CITY_3312: "रामेश्वरम",
        STATE_MH_CITY_3313: "रामेवाडी",
        STATE_RJ_CITY_3314: "रामगंजमंडी",
        STATE_JH_CITY_3315: "रामगढ़",
        STATE_RJ_CITY_3316: "रामगढ़",
        STATE_JK_CITY_3317: "रामगढ़",
        STATE_TG_CITY_3318: "रामगुंडम",
        STATE_WB_CITY_3319: "रामजीबनपुर",
        STATE_UP_CITY_3320: "रामकोला",
        STATE_BR_CITY_3321: "रामनगर",
        STATE_JK_CITY_3322: "रामनगर",
        STATE_UT_CITY_3323: "रामनगर",
        STATE_UP_CITY_3324: "रामनगर",
        STATE_WB_CITY_3325: "रामनगर",
        STATE_AP_CITY_3326: "रामपछोड़वरम",
        STATE_UP_CITY_3327: "रामपुर",
        STATE_HP_CITY_3328: "रामपुर",
        STATE_WB_CITY_3329: "रामपुर हाट",
        STATE_UP_CITY_3330: "रामपुरा",
        STATE_PB_CITY_3331: "रामपुरा",
        STATE_MP_CITY_3332: "रामपुरा",
        STATE_MH_CITY_3333: "रामटेक",
        STATE_WB_CITY_3334: "रानाघाट",
        STATE_MP_CITY_3335: "राणापुर",
        STATE_GJ_CITY_3336: "राणावाव",
        STATE_JH_CITY_3337: "रांची",
        STATE_AS_CITY_3338: "रंगापाड़ा",
        STATE_TG_CITY_3339: "रंगारेड्डी",
        STATE_AS_CITY_3340: "रंगिया",
        STATE_SK_CITY_3341: "रांगपो",
        STATE_RJ_CITY_3342: "रानी",
        STATE_HR_CITY_3343: "रनिया",
        STATE_KA_CITY_3344: "रानीबेन्नूर",
        STATE_WB_CITY_3345: "रानीगंज",
        STATE_UT_CITY_3346: "रानीखेत",
        STATE_UP_CITY_3347: "रानीपुर",
        STATE_UP_CITY_3348: "रानीपुर बरसी",
        STATE_TR_CITY_3349: "रानीर बाजार",
        STATE_GJ_CITY_3350: "रानपुर",
        STATE_GJ_CITY_3351: "रपार",
        STATE_TN_CITY_3352: "रासीपुरम",
        STATE_UP_CITY_3353: "रसड़ा",
        STATE_UP_CITY_3354: "रसूलाबाद",
        STATE_RJ_CITY_3355: "रतनगढ़",
        STATE_MP_CITY_3356: "रतनगढ़",
        STATE_CT_CITY_3357: "रतनपुर",
        STATE_UP_CITY_3358: "अधिक तत्पर",
        STATE_HR_CITY_3359: "रतिया",
        STATE_MP_CITY_3360: "रतलाम",
        STATE_MH_CITY_3361: "रत्नागिरि",
        STATE_OR_CITY_3362: "राउरकेला",
        STATE_MH_CITY_3363: "रावेर",
        STATE_RJ_CITY_3364: "रावतभाटा",
        STATE_RJ_CITY_3365: "रावतसर",
        STATE_BR_CITY_3366: "रक्सौल",
        STATE_JH_CITY_3367: "रे",
        STATE_UP_CITY_3368: "राया",
        STATE_AP_CITY_3369: "रायचोटी",
        STATE_AP_CITY_3370: "रायद्रग",
        STATE_OR_CITY_3371: "रायगढ़",
        STATE_KA_CITY_3372: "रेबैग",
        STATE_WB_CITY_3373: "रायपुर",
        STATE_AP_CITY_3374: "रज़म",
        STATE_AP_CITY_3375: "रज़ामपेटा",
        STATE_AP_CITY_3376: "राजोलु",
        STATE_GJ_CITY_3377: "रेहा",
        STATE_UP_CITY_3378: "रेहर",
        STATE_MP_CITY_3379: "रहली",
        STATE_MP_CITY_3380: "रहती",
        STATE_OR_CITY_3381: "रेमुना",
        STATE_MH_CITY_3382: "रेनापुर",
        STATE_MH_CITY_3383: "रेनावी",
        STATE_OR_CITY_3384: "रेंगाली",
        STATE_AP_CITY_3385: "रेनिगुंटा",
        STATE_UP_CITY_3386: "रेनुकूट",
        STATE_UP_CITY_3387: "रेनुकुट",
        STATE_UP_CITY_3388: "रेवती",
        STATE_UP_CITY_3389: "रेवतीपुर",
        STATE_AP_CITY_3390: "रेपल्ले",
        STATE_MH_CITY_3391: "रेवदंडा",
        STATE_MH_CITY_3392: "रेवदंडा",
        STATE_BR_CITY_3393: "रिवेलगंज",
        STATE_MP_CITY_3394: "रीवा",
        STATE_HR_CITY_3395: "रेवाड़ी",
        STATE_HR_CITY_3396: "रेवाडी जिला",
        STATE_ML_CITY_3397: "री-भोई",
        STATE_JK_CITY_3398: "रियासी",
        STATE_UP_CITY_3399: "रिछा",
        STATE_RJ_CITY_3400: "रींगस",
        STATE_UT_CITY_3401: "ऋषिकेश",
        STATE_WB_CITY_3402: "रिशरा",
        STATE_MH_CITY_3403: "रिसोड़",
        STATE_UP_CITY_3404: "रोबेर्त्स्गंज",
        STATE_KA_CITY_3405: "रॉबर्टसनपेट",
        STATE_GJ_CITY_3406: "रोहा",
        STATE_MH_CITY_3407: "रोहा",
        STATE_DL_CITY_3408: "रोहिणी",
        STATE_HP_CITY_3409: "रोहड़ू",
        STATE_HR_CITY_3410: "रोहतक",
        STATE_BR_CITY_3411: "रोहतास",
        STATE_KA_CITY_3412: "रॉन",
        STATE_UT_CITY_3413: "रुड़की",
        STATE_UP_CITY_3414: "रुदरपुर",
        STATE_UP_CITY_3415: "रुदौली",
        STATE_UT_CITY_3416: "रुद्रप्रयाग",
        STATE_PB_CITY_3417: "रूपनगर",
        STATE_UP_CITY_3418: "रूरा",
        STATE_BR_CITY_3419: "रुसेरा",
        STATE_MP_CITY_3420: "सबलगढ़",
        STATE_UP_CITY_3421: "सबलपुर",
        STATE_GJ_CITY_3422: "साबर कंथा",
        STATE_HP_CITY_3423: "सबाथू",
        STATE_TR_CITY_3424: "सब्रुम",
        STATE_UP_CITY_3425: "सचेंडी",
        STATE_GJ_CITY_3426: "सचिन",
        STATE_UP_CITY_3427: "सादाबाद",
        STATE_KA_CITY_3428: "सदल्गी",
        STATE_TG_CITY_3429: "सदासोपेट",
        STATE_UP_CITY_3430: "सादात",
        STATE_RJ_CITY_3431: "सादरी",
        STATE_HR_CITY_3432: "सफीदों",
        STATE_UP_CITY_3433: "सफीपुर",
        STATE_KA_CITY_3434: "सागर",
        STATE_MP_CITY_3435: "सागर",
        STATE_BR_CITY_3436: "सगौली",
        STATE_WB_CITY_3437: "साहपुर",
        STATE_UP_CITY_3438: "सहारनपुर",
        STATE_BR_CITY_3439: "सहरसा",
        STATE_UP_CITY_3440: "सहसपुर",
        STATE_UP_CITY_3441: "सहसवान",
        STATE_UP_CITY_3442: "सहावर",
        STATE_UP_CITY_3443: "साहिबाबाद",
        STATE_JH_CITY_3444: "साहिबगंज",
        STATE_UP_CITY_3445: "सहपऊ",
        STATE_UP_CITY_3446: "सईदपुर",
        STATE_MZ_CITY_3447: "सैहा",
        STATE_MP_CITY_3448: "सैलाना",
        STATE_MH_CITY_3449: "सैलु",
        STATE_TN_CITY_3450: "सेंट थॉमस माउंट",
        STATE_WB_CITY_3451: "सैंथिया",
        STATE_MZ_CITY_3452: "सैरंग",
        STATE_MZ_CITY_3453: "सैटलाव",
        STATE_UP_CITY_3454: "सखानू",
        STATE_UP_CITY_3455: "साकित",
        STATE_KA_CITY_3456: "सक्लेश्पुर",
        STATE_MH_CITY_3457: "साकोल",
        STATE_MH_CITY_3458: "साकोली",
        STATE_MH_CITY_3459: "सकरी",
        STATE_CT_CITY_3460: "सक्ती",
        STATE_WB_CITY_3461: "सालानपुर सामुदायिक विकास खंड",
        STATE_GJ_CITY_3462: "सलाया",
        STATE_TN_CITY_3463: "सलेम",
        STATE_UP_CITY_3464: "सलेमपुर",
        STATE_GA_CITY_3465: "Saligao",
        STATE_UP_CITY_3466: "सैलून",
        STATE_RJ_CITY_3467: "सलूंबर",
        STATE_AP_CITY_3468: "सलूर",
        STATE_GJ_CITY_3469: "Samakhiali",
        STATE_HR_CITY_3470: "समालखा",
        STATE_AP_CITY_3471: "सामलकोट",
        STATE_BR_CITY_3472: "समस्तीपुर",
        STATE_JK_CITY_3473: "सांबा",
        STATE_OR_CITY_3474: "संबलपुर",
        STATE_UP_CITY_3475: "संभल",
        STATE_RJ_CITY_3476: "सांभर",
        STATE_RJ_CITY_3477: "समदड़ी",
        STATE_PB_CITY_3478: "समराला",
        STATE_UP_CITY_3479: "समथर",
        STATE_MH_CITY_3480: "समुद्रपुर",
        STATE_GJ_CITY_3481: "साणंद",
        STATE_PB_CITY_3482: "सनौर",
        STATE_MP_CITY_3483: "सनावद",
        STATE_MP_CITY_3484: "सांची",
        STATE_RJ_CITY_3485: "सांचौर",
        STATE_GA_CITY_3486: "सांकोले",
        STATE_UP_CITY_3487: "सांडी",
        STATE_UP_CITY_3488: "संडीला",
        STATE_KA_CITY_3489: "संदूर",
        STATE_MH_CITY_3490: "संगमेश्वर",
        STATE_MH_CITY_3491: "संगमनेर",
        STATE_TG_CITY_3492: "संगारेड्डी",
        STATE_RJ_CITY_3493: "संगरिया",
        STATE_MH_CITY_3494: "सांगली",
        STATE_RJ_CITY_3495: "सांगोद",
        STATE_MH_CITY_3496: "सांगोला",
        STATE_MH_CITY_3497: "संगोले",
        STATE_MH_CITY_3498: "संग्रामपुर, महाराष्ट्र",
        STATE_PB_CITY_3499: "Sangrur",
        STATE_GA_CITY_3500: "संगुएम",
        STATE_KA_CITY_3501: "Sanivarsante",
        STATE_WB_CITY_3502: "शंकरपुर",
        STATE_KA_CITY_3503: "Sankeshwar",
        STATE_GJ_CITY_3504: "संखेडा",
        STATE_WB_CITY_3505: "सांकराइल",
        STATE_GA_CITY_3506: "संक्वेलिम",
        STATE_UP_CITY_3507: "संतकबीरनगर",
        STATE_UP_CITY_3508: "संत रविदास नगर",
        STATE_WB_CITY_3509: "शांतिपुर",
        STATE_HP_CITY_3510: "Santokhgarh",
        STATE_WB_CITY_3511: "संतोषपुर",
        STATE_WB_CITY_3512: "संतुरी सामुदायिक विकास खंड",
        STATE_GA_CITY_3513: "संवोर्डेम",
        STATE_MP_CITY_3514: "सांवेर",
        STATE_MH_CITY_3515: "साओली",
        STATE_MH_CITY_3516: "सावनेर",
        STATE_AS_CITY_3517: "सपतग्राम",
        STATE_HP_CITY_3518: "सराहन",
        STATE_UP_CITY_3519: "सराय अकिल",
        STATE_UP_CITY_3520: "सराय इकदिल",
        STATE_UP_CITY_3521: "सराय मीर",
        STATE_JH_CITY_3522: "Saraikela",
        STATE_CT_CITY_3523: "सरायपाली",
        STATE_BR_CITY_3524: "सारण",
        STATE_CT_CITY_3525: "सारंगढ़",
        STATE_MH_CITY_3526: "सारंगखेड़ा",
        STATE_MP_CITY_3527: "सारंगपुर",
        STATE_UP_CITY_3528: "सरौली",
        STATE_GJ_CITY_3529: "सरभोन",
        STATE_RJ_CITY_3530: "सरदारशहर",
        STATE_UP_CITY_3531: "सरधना",
        STATE_GJ_CITY_3532: "सरदोई",
        STATE_PB_CITY_3533: "सरदूलगढ़",
        STATE_WB_CITY_3534: "सारेंगा",
        STATE_KA_CITY_3535: "सरगुर",
        STATE_UP_CITY_3536: "सरीला",
        STATE_HP_CITY_3537: "सरका घाट",
        STATE_GJ_CITY_3538: "सरखेज",
        STATE_JH_CITY_3539: "सारूबेरा",
        STATE_AS_CITY_3540: "सरूपथार",
        STATE_UP_CITY_3541: "सरूरपुर",
        STATE_RJ_CITY_3542: "सरवर",
        STATE_UP_CITY_3543: "सासनी",
        STATE_MH_CITY_3544: "सासवड़",
        STATE_MH_CITY_3545: "सासवड़",
        STATE_MH_CITY_3546: "सताना",
        STATE_MH_CITY_3547: "सतारा",
        STATE_MH_CITY_3548: "सतारा डिवीजन",
        STATE_GJ_CITY_3549: "सथंबा",
        STATE_TN_CITY_3550: "Sathankulam",
        STATE_TG_CITY_3551: "सथुपल्ली",
        STATE_TN_CITY_3552: "सत्यमंगलम",
        STATE_MP_CITY_3553: "सतना",
        STATE_MH_CITY_3554: "सतपति",
        STATE_UP_CITY_3555: "सतरिख",
        STATE_AP_CITY_3556: "सत्तेनापल्ली",
        STATE_TN_CITY_3557: "सत्तूर",
        STATE_MP_CITY_3558: "सतवास",
        STATE_MP_CITY_3559: "सागर",
        STATE_KA_CITY_3560: "सौंदत्ती",
        STATE_UP_CITY_3561: "सौरिख",
        STATE_MP_CITY_3562: "सौसर",
        STATE_MH_CITY_3563: "सावंतवाडी",
        STATE_KA_CITY_3564: "सवनूर",
        STATE_GJ_CITY_3565: "सावरकुंडला",
        STATE_MH_CITY_3566: "सावदा",
        STATE_MH_CITY_3567: "सवलज",
        STATE_GJ_CITY_3568: "सावली",
        STATE_RJ_CITY_3569: "सवाई माधोपुर",
        STATE_MH_CITY_3570: "सावंतवाडी",
        STATE_TN_CITY_3571: "सयालकुडी",
        STATE_GJ_CITY_3572: "सायला",
        STATE_UP_CITY_3573: "क्षेत्र",
        STATE_TG_CITY_3574: "सिकंदराबाद",
        STATE_MP_CITY_3575: "सीहोर",
        STATE_MH_CITY_3576: "सेलु",
        STATE_MN_CITY_3577: "सेनापति",
        STATE_MP_CITY_3578: "सेंधवा",
        STATE_UP_CITY_3579: "स्योहारा",
        STATE_MP_CITY_3580: "स्योंधा",
        STATE_HP_CITY_3581: "सिवनी",
        STATE_MP_CITY_3582: "सिवनी",
        STATE_MP_CITY_3583: "सिवनी मालवा",
        STATE_CT_CITY_3584: "सिवरिनरायन",
        STATE_KA_CITY_3585: "सीरम",
        STATE_WB_CITY_3586: "श्रीरामपुर",
        STATE_MZ_CITY_3587: "सेरछिप",
        STATE_TG_CITY_3588: "Serilingampally",
        STATE_WB_CITY_3589: "सेरपुर",
        STATE_GA_CITY_3590: "सेरूला",
        STATE_MH_CITY_3591: "सेवाग्राम",
        STATE_TN_CITY_3592: "सात पगोडा",
        STATE_MH_CITY_3593: "सेवरी",
        STATE_HR_CITY_3594: "शादीपुर जुलाना",
        STATE_UP_CITY_3595: "शाहाबाद",
        STATE_HR_CITY_3596: "शाहाबाद",
        STATE_KA_CITY_3597: "शाहाबाद",
        STATE_MH_CITY_3598: "शहादा",
        STATE_MH_CITY_3599: "शाहपुर",
        STATE_BR_CITY_3600: "शहबाजपुर",
        STATE_MP_CITY_3601: "शाहडोल",
        STATE_UP_CITY_3602: "शाहगंज",
        STATE_MP_CITY_3603: "शाहगढ़",
        STATE_UP_CITY_3604: "शाही",
        STATE_PB_CITY_3605: "शहीद भगत सिंह नगर",
        STATE_UP_CITY_3606: "शाहजहांपुर",
        STATE_PB_CITY_3607: "शाहकोट",
        STATE_KA_CITY_3608: "शाहपुर",
        STATE_MP_CITY_3609: "शाहपुर",
        STATE_GJ_CITY_3610: "शाहपुर",
        STATE_UP_CITY_3611: "शाहपुर",
        STATE_BR_CITY_3612: "शाहपुर",
        STATE_RJ_CITY_3613: "शाहपुरा",
        STATE_MP_CITY_3614: "शाहपुरा",
        STATE_MP_CITY_3615: "शाजापुर",
        STATE_PB_CITY_3616: "शाम चुरसी",
        STATE_MP_CITY_3617: "शामगढ़",
        STATE_UP_CITY_3618: "शामली",
        STATE_UP_CITY_3619: "शमसाबाद",
        STATE_UP_CITY_3620: "शंकरगढ़",
        STATE_MH_CITY_3621: "शेडबल",
        STATE_MH_CITY_3622: "शेगाव",
        STATE_BR_CITY_3623: "शेखपुरा",
        STATE_RJ_CITY_3624: "श्योगंज",
        STATE_BR_CITY_3625: "शिवहर",
        STATE_MP_CITY_3626: "श्योपुर",
        STATE_UP_CITY_3627: "शेरगढ़",
        STATE_BR_CITY_3628: "Sherghati",
        STATE_UP_CITY_3629: "शेरकोट",
        STATE_KL_CITY_3630: "शेरतलाई",
        STATE_MH_CITY_3631: "शेवगांव",
        STATE_UP_CITY_3632: "शिबनगर",
        STATE_KA_CITY_3633: "शिगांव",
        STATE_KA_CITY_3634: "शिकारपुर",
        STATE_UP_CITY_3635: "शिकारपुर",
        STATE_UP_CITY_3636: "शिकारपुर (बुलंदशहर)",
        STATE_UP_CITY_3637: "शिकोहाबाद",
        STATE_MH_CITY_3638: "शिक्रापुर",
        STATE_ML_CITY_3639: "शिलांग",
        STATE_HP_CITY_3640: "शिमला",
        STATE_KA_CITY_3641: "शिमोगा",
        STATE_MH_CITY_3642: "शिरागुप्पी",
        STATE_MH_CITY_3643: "शिराला",
        STATE_MH_CITY_3644: "शिरडी",
        STATE_MH_CITY_3645: "शिरगांव",
        STATE_KA_CITY_3646: "शिरहट्टी",
        STATE_MH_CITY_3647: "शिरोल",
        STATE_MH_CITY_3648: "एगी",
        STATE_MH_CITY_3649: "शिरूड",
        STATE_MH_CITY_3650: "शिर्वल",
        STATE_UP_CITY_3651: "शीशगढ़",
        STATE_MH_CITY_3652: "शिवाजी नगर",
        STATE_MP_CITY_3653: "शिवपुरी",
        STATE_GJ_CITY_3654: "शिवराजपुर",
        STATE_UP_CITY_3655: "शिवराजपुर",
        STATE_TN_CITY_3656: "शोलिंघुर",
        STATE_KL_CITY_3657: "शोरानूर",
        STATE_KA_CITY_3658: "शोरापुर",
        STATE_UP_CITY_3659: "श्रावस्ती",
        STATE_MH_CITY_3660: "श्रीगोंदा",
        STATE_KA_CITY_3661: "श्रीरंगपट्टण",
        STATE_MP_CITY_3662: "शुजालपुर",
        STATE_JK_CITY_3663: "शुपियां",
        STATE_WB_CITY_3664: "श्यामनगर, पश्चिम बंगाल",
        STATE_AS_CITY_3665: "शिवसागर",
        STATE_KA_CITY_3666: "सिद्धपुर",
        STATE_UP_CITY_3667: "सिद्धार्थनगर",
        STATE_UP_CITY_3668: "सिद्धौर",
        STATE_GJ_CITY_3669: "सिद्धपुर",
        STATE_TG_CITY_3670: "सिद्दीपेट",
        STATE_UP_CITY_3671: "सिधौली",
        STATE_MP_CITY_3672: "सीधी",
        STATE_UP_CITY_3673: "सिढ़पुरा",
        STATE_KA_CITY_3674: "सिडलघट्टा",
        STATE_GJ_CITY_3675: "सीहोर",
        STATE_MP_CITY_3676: "सिहोरा",
        STATE_JH_CITY_3677: "सिजुवा",
        STATE_UP_CITY_3678: "सिकन्दराबाद",
        STATE_UP_CITY_3679: "सिकंदरपुर",
        STATE_UP_CITY_3680: "सिकंदरा",
        STATE_UP_CITY_3681: "सिकंदराराऊ",
        STATE_UP_CITY_3682: "सिकंदराबाद",
        STATE_RJ_CITY_3683: "सीकर",
        STATE_GJ_CITY_3684: "सिक्का",
        STATE_BR_CITY_3685: "सिलाव",
        STATE_AS_CITY_3686: "Silapathar",
        STATE_AS_CITY_3687: "सिलचर",
        STATE_WB_CITY_3688: "सिलीगुड़ी",
        STATE_MH_CITY_3689: "सिल्लोड",
        STATE_DN_CITY_3690: "सिल्वासा",
        STATE_MP_CITY_3691: "सिमरिया",
        STATE_JH_CITY_3692: "सिमडेगा",
        STATE_CT_CITY_3693: "सिमगा",
        STATE_MH_CITY_3694: "सिंदेवाही",
        STATE_KA_CITY_3695: "सिंदगी",
        STATE_KA_CITY_3696: "सिंधनूर",
        STATE_MH_CITY_3697: "सिंधुदुर्ग",
        STATE_MH_CITY_3698: "सिंडी",
        STATE_MH_CITY_3699: "सिंदखेडा",
        STATE_TN_CITY_3700: "सिंगानल्लुर",
        STATE_TN_CITY_3701: "सिंगपेरुमलकोविल",
        STATE_TG_CITY_3702: "सिंगापुर",
        STATE_AP_CITY_3703: "सिंगरायकोंडा",
        STATE_MP_CITY_3704: "सिंगोली",
        STATE_MP_CITY_3705: "सिंगरौली",
        STATE_SK_CITY_3706: "सिंगताम",
        STATE_WB_CITY_3707: "सिंगूर",
        STATE_JH_CITY_3708: "सिनी",
        STATE_MH_CITY_3709: "सिन्नर",
        STATE_GJ_CITY_3710: "सिनोर",
        STATE_MH_CITY_3711: "सायन, मुंबई",
        STATE_KA_CITY_3712: "सिरा",
        STATE_UP_CITY_3713: "सिराथू",
        STATE_PB_CITY_3714: "सरहिंद-फतेहगढ़",
        STATE_TN_CITY_3715: "सिरकाज़ी",
        STATE_MP_CITY_3716: "सिरमौर",
        STATE_HP_CITY_3717: "सिरमौर",
        STATE_RJ_CITY_3718: "सिरोही",
        STATE_MH_CITY_3719: "सिरोंचा",
        STATE_MP_CITY_3720: "सिरोंज",
        STATE_TG_CITY_3721: "सिरपुर",
        STATE_HR_CITY_3722: "सिरसा",
        STATE_UP_CITY_3723: "सिरसा",
        STATE_UP_CITY_3724: "सिरसागंज",
        STATE_KA_CITY_3725: "सिरसी",
        STATE_UP_CITY_3726: "सिरसी",
        STATE_TG_CITY_3727: "सिरसिल्ला",
        STATE_KA_CITY_3728: "Siruguppa",
        STATE_TN_CITY_3729: "सिरुमुगई",
        STATE_MH_CITY_3730: "सिरूर",
        STATE_UP_CITY_3731: "सिसौली",
        STATE_UP_CITY_3732: "सिसवा बाजार",
        STATE_BR_CITY_3733: "सीतामढ़ी",
        STATE_MP_CITY_3734: "सीतामऊ",
        STATE_UP_CITY_3735: "सीतापुर",
        STATE_UT_CITY_3736: "सितारगंज",
        STATE_TN_CITY_3737: "शिवगंगा",
        STATE_TN_CITY_3738: "शिवगिरी",
        STATE_TN_CITY_3739: "शिवकाशी",
        STATE_MH_CITY_3740: "सिवला, पूर्वी गोदावरी जिला",
        STATE_BR_CITY_3741: "सिवान",
        STATE_RJ_CITY_3742: "सिवाना",
        STATE_AS_CITY_3743: "सोलकुची",
        STATE_WB_CITY_3744: "सोदपुर",
        STATE_MP_CITY_3745: "सोहागी",
        STATE_MP_CITY_3746: "सोहागपुर",
        STATE_HR_CITY_3747: "सोहना",
        STATE_RJ_CITY_3748: "सोजत",
        STATE_GJ_CITY_3749: "सोजित्रा",
        STATE_HP_CITY_3750: "एक प्रकार का हंस",
        STATE_WB_CITY_3751: "सोलाप",
        STATE_MH_CITY_3752: "सोलापुर",
        STATE_GA_CITY_3753: "सोलिम",
        STATE_KA_CITY_3754: "सोमेश्वर",
        STATE_AP_CITY_3755: "सोम्पेता",
        STATE_KA_CITY_3756: "सोमवारपेट",
        STATE_WB_CITY_3757: "सोनादा",
        STATE_MH_CITY_3758: "सोनाला",
        STATE_WB_CITY_3759: "सोनामुखी",
        STATE_TR_CITY_3760: "सोनामुरा",
        STATE_AS_CITY_3761: "सोनारी",
        STATE_WB_CITY_3762: "सोनारपुर सामुदायिक विकास खंड",
        STATE_UP_CITY_3763: "सोनभद्र",
        STATE_MH_CITY_3764: "सोनेगांव",
        STATE_OR_CITY_3765: "सोनेपुर",
        STATE_GJ_CITY_3766: "सोनगढ़",
        STATE_MH_CITY_3767: "सोनगिर",
        STATE_HR_CITY_3768: "सोनीपत",
        STATE_AS_CITY_3769: "सोनितपुर",
        STATE_MH_CITY_3770: "सोनवाद",
        STATE_JK_CITY_3771: "सोपुर",
        STATE_KA_CITY_3772: "सोराब",
        STATE_OR_CITY_3773: "सोराडा",
        STATE_AS_CITY_3774: "सोरभोग",
        STATE_OR_CITY_3775: "सोरो",
        STATE_UP_CITY_3776: "सोरों",
        STATE_WB_CITY_3777: "दक्षिण 24 परगना जिला",
        STATE_AN_CITY_3778: "दक्षिण अंडमान",
        STATE_DL_CITY_3779: "दक्षिणी दिल्ली",
        STATE_SK_CITY_3780: "दक्षिण जिला",
        STATE_ML_CITY_3781: "दक्षिण गारो हिल्स",
        STATE_GA_CITY_3782: "दक्षिण गोवा",
        STATE_TR_CITY_3783: "दक्षिण त्रिपुरा",
        STATE_DL_CITY_3784: "दक्षिण पश्चिम दिल्ली",
        STATE_ML_CITY_3785: "दक्षिण पश्चिम गारो हिल्स",
        STATE_ML_CITY_3786: "दक्षिण पश्चिम खासी पहाड़ियाँ",
        STATE_MH_CITY_3787: "सोयगांव",
        STATE_JK_CITY_3788: "सोयाबग",
        STATE_KA_CITY_3789: "श्रवण बेलगोला",
        STATE_RJ_CITY_3790: "श्रीडूंगरगढ़",
        STATE_RJ_CITY_3791: "श्रीमाधोपुर",
        STATE_PB_CITY_3792: "श्री मुक्तसर साहिब",
        STATE_AP_CITY_3793: "श्रीकाकुलम",
        STATE_WB_CITY_3794: "श्रीखंड",
        STATE_TN_CITY_3795: "श्रीमुष्नाम",
        STATE_JK_CITY_3796: "श्रीनगर",
        STATE_UT_CITY_3797: "श्रीनगर",
        STATE_KA_CITY_3798: "श्रृंगेरी",
        STATE_KA_CITY_3799: "Srinivaspur",
        STATE_TN_CITY_3800: "श्रीपेरुमबुदुर",
        STATE_TG_CITY_3801: "श्रीरामनगर",
        STATE_WB_CITY_3802: "श्रीरामपुर",
        STATE_AP_CITY_3803: "श्रीशैलैन",
        STATE_TN_CITY_3804: "श्रीवैकुंठम",
        STATE_MH_CITY_3805: "Shrivardhan",
        STATE_TN_CITY_3806: "श्रीविल्लीपुतुर",
        STATE_UP_CITY_3807: "सुअर",
        STATE_OR_CITY_3808: "सुबरनपुर",
        STATE_TN_CITY_3809: "सुचिन्द्रम",
        STATE_RJ_CITY_3810: "सुजानगढ़",
        STATE_RJ_CITY_3811: "सुकेत",
        STATE_UT_CITY_3812: "सुल्तानपुर",
        STATE_MP_CITY_3813: "सुल्तानपुर",
        STATE_UP_CITY_3814: "सुल्तानपुर",
        STATE_PB_CITY_3815: "सुल्तानपुर लोधी",
        STATE_TN_CITY_3816: "सुलूर",
        STATE_AP_CITY_3817: "सुलुरू",
        STATE_KA_CITY_3818: "सुल्या",
        STATE_JK_CITY_3819: "सुम्बल",
        STATE_PB_CITY_3820: "सुनाम",
        STATE_OR_CITY_3821: "सुंदरगढ़",
        STATE_HP_CITY_3822: "सुंदरनगर",
        STATE_RJ_CITY_3823: "सुनेल",
        STATE_KA_CITY_3824: "सुन्तिकोप्पा",
        STATE_BR_CITY_3825: "सुपौल",
        STATE_GJ_CITY_3826: "सुपेड़ी",
        STATE_RJ_CITY_3827: "सूरजगढ़",
        STATE_TN_CITY_3828: "सुरनदाई",
        STATE_GJ_CITY_3829: "सूरत",
        STATE_RJ_CITY_3830: "सूरतगढ़",
        STATE_GJ_CITY_3831: "सुरेंद्रनगर",
        STATE_MH_CITY_3832: "सुरगना",
        STATE_CT_CITY_3833: "सरगुजा",
        STATE_WB_CITY_3834: "सूरी",
        STATE_UP_CITY_3835: "सुरियांवां",
        STATE_TG_CITY_3836: "सुरियापेट",
        STATE_MP_CITY_3837: "सुसनेर",
        STATE_GJ_CITY_3838: "सूत्रपाद",
        STATE_TN_CITY_3839: "स्वामीमलाई",
        STATE_WB_CITY_3840: "स्वरूपनगर सामुदायिक विकास खंड",
        STATE_AP_CITY_3841: "ताडेपल्ले",
        STATE_AP_CITY_3842: "ताडेपल्लेगुडेम",
        STATE_AP_CITY_3843: "ताड़पत्री",
        STATE_UP_CITY_3844: "ताजपुर",
        STATE_WB_CITY_3845: "तकदाह",
        STATE_RJ_CITY_3846: "तखतगढ़",
        STATE_CT_CITY_3847: "तखतपुर",
        STATE_WB_CITY_3848: "टाकी",
        STATE_MH_CITY_3849: "तकलीभन",
        STATE_MP_CITY_3850: "ताल",
        STATE_GJ_CITY_3851: "तलाजा",
        STATE_UP_CITY_3852: "तालबहाट",
        STATE_MH_CITY_3853: "तलबिद",
        STATE_OR_CITY_3854: "तालचेर",
        STATE_MH_CITY_3855: "तलेगांव दाभाड़े",
        STATE_MH_CITY_3856: "तलेगांव धमधेरे",
        STATE_GA_CITY_3857: "तलेइगाओ",
        STATE_MP_CITY_3858: "तलें",
        STATE_UP_CITY_3859: "तालग्राम",
        STATE_KA_CITY_3860: "Talikota",
        STATE_KL_CITY_3861: "तालिप्परम्बा",
        STATE_MH_CITY_3862: "तलोदा",
        STATE_MH_CITY_3863: "तालोद",
        STATE_PB_CITY_3864: "तलवंडी भाई",
        STATE_PB_CITY_3865: "तलवाड़ा",
        STATE_TN_CITY_3866: "ताम्बरम",
        STATE_MN_CITY_3867: "तामेंगलांग",
        STATE_WB_CITY_3868: "तामलुक",
        STATE_UT_CITY_3869: "टनकपुर",
        STATE_UP_CITY_3870: "टांडा",
        STATE_TG_CITY_3871: "तंदूर",
        STATE_TN_CITY_3872: "तंजौर",
        STATE_GJ_CITY_3873: "टंकारा",
        STATE_AP_CITY_3874: "टनुकु",
        STATE_HR_CITY_3875: "तावडू",
        STATE_GJ_CITY_3876: "तापी",
        STATE_OR_CITY_3877: "तारभा",
        STATE_WB_CITY_3878: "तारकेश्वर",
        STATE_TN_CITY_3879: "तारामंगलम",
        STATE_MP_CITY_3880: "तराना",
        STATE_RJ_CITY_3881: "तारानगर",
        STATE_MH_CITY_3882: "तारापुर",
        STATE_MH_CITY_3883: "ताड़देव",
        STATE_KA_CITY_3884: "तरिकेर",
        STATE_PB_CITY_3885: "तरनतारन साहिब",
        STATE_MH_CITY_3886: "tasgaon",
        STATE_TN_CITY_3887: "तत्तायंगारपेट्टई",
        STATE_AR_CITY_3888: "तवांग",
        STATE_BR_CITY_3889: "तेघरा",
        STATE_UT_CITY_3890: "टिहरी",
        STATE_UT_CITY_3891: "टिहरी गढ़वाल",
        STATE_MP_CITY_3892: "टेकनपुर",
        STATE_BR_CITY_3893: "टेकारी",
        STATE_KA_CITY_3894: "तेक्कलाकोटे",
        STATE_AP_CITY_3895: "तेक्कली",
        STATE_MH_CITY_3896: "तेल्हाड़ा",
        STATE_KL_CITY_3897: "तेल्लीचेरी",
        STATE_MP_CITY_3898: "Tendukheda",
        STATE_MP_CITY_3899: "त्योंथर",
        STATE_KA_CITY_3900: "टेरडाल",
        STATE_UP_CITY_3901: "तेरह",
        STATE_AS_CITY_3902: "तेजपुर",
        STATE_AR_CITY_3903: "तेजु",
        STATE_UP_CITY_3904: "ठाकुरद्वारा",
        STATE_BR_CITY_3905: "ठाकुरगंज",
        STATE_MH_CITY_3906: "थालनेर",
        STATE_GJ_CITY_3907: "बजाय",
        STATE_UP_CITY_3908: "थानाभवन",
        STATE_MP_CITY_3909: "थांदला",
        STATE_MH_CITY_3910: "थाइन",
        STATE_HR_CITY_3911: "थानेसर",
        STATE_JK_CITY_3912: "थांग",
        STATE_GJ_CITY_3913: "थानगढ़",
        STATE_TN_CITY_3914: "तंजावुर",
        STATE_JK_CITY_3915: "थन्ना मंडी",
        STATE_KL_CITY_3916: "थन्नियम",
        STATE_GJ_CITY_3917: "थराद",
        STATE_TN_CITY_3918: "Tharangambadi",
        STATE_GJ_CITY_3919: "ठसरा",
        STATE_GJ_CITY_3920: "डांग्स",
        STATE_TN_CITY_3921: "तब मैं",
        STATE_TN_CITY_3922: "थेंकासी",
        STATE_MZ_CITY_3923: "थेन्ज़ॉल",
        STATE_HP_CITY_3924: "ठियोग",
        STATE_TN_CITY_3925: "तिरुकट्टुपल्ली",
        STATE_TN_CITY_3926: "तिरुट्टनी",
        STATE_TN_CITY_3927: "थिरुवैयारु",
        STATE_TN_CITY_3928: "तिरुवल्लुर",
        STATE_KL_CITY_3929: "तिरुवनंतपुरम",
        STATE_TN_CITY_3930: "थिरुवरुर",
        STATE_TN_CITY_3931: "थिरुविदैमारुथुर",
        STATE_TN_CITY_3932: "Thoothukudi",
        STATE_MN_CITY_3933: "थौबल",
        STATE_KL_CITY_3934: "त्रिशूर",
        STATE_KL_CITY_3935: "त्रिशूर जिला",
        STATE_UP_CITY_3936: "तिगरी",
        STATE_RJ_CITY_3937: "तिजारा",
        STATE_UP_CITY_3938: "टिकैतनगर",
        STATE_MP_CITY_3939: "टीकमगढ़",
        STATE_UP_CITY_3940: "टिकारी",
        STATE_UP_CITY_3941: "तिलहर",
        STATE_UP_CITY_3942: "तिलसहरी",
        STATE_TN_CITY_3943: "टिंडीवनम",
        STATE_UP_CITY_3944: "तिंदवारी",
        STATE_TN_CITY_3945: "तिन्नानूर",
        STATE_AS_CITY_3946: "तिनसुकिया",
        STATE_KA_CITY_3947: "तिप्तूर",
        STATE_HP_CITY_3948: "टीरा सुजानपुर",
        STATE_AR_CITY_3949: "तिरप",
        STATE_MP_CITY_3950: "तिरोडी",
        STATE_KA_CITY_3951: "तीर्थहल्ली",
        STATE_TN_CITY_3952: "तिरुचेन्डुर",
        STATE_TN_CITY_3953: "तिरुचेंगोडे",
        STATE_TN_CITY_3954: "तिरुचिरापल्ली",
        STATE_TN_CITY_3955: "तिरुक्कोयिलुर",
        STATE_KA_CITY_3956: "तिरुमकुदल नरसीपुर",
        STATE_AP_CITY_3957: "तिरुमाला",
        STATE_TN_CITY_3958: "तिरुमुल्लैवासल",
        STATE_TN_CITY_3959: "तिरुनेलवेली",
        STATE_TN_CITY_3960: "तिरुनेलवेली कट्टाबो",
        STATE_AP_CITY_3961: "तिरुपति",
        STATE_TN_CITY_3962: "तिरुप्पलाईकुडी",
        STATE_TN_CITY_3963: "तिरुप्परंगुनराम",
        STATE_TN_CITY_3964: "तिरुपूर",
        STATE_TN_CITY_3965: "तिरुप्पुवनम",
        STATE_KL_CITY_3966: "तिरूर",
        STATE_TN_CITY_3967: "तिरुत्तंगल",
        STATE_KL_CITY_3968: "तिरुवल्ला",
        STATE_TN_CITY_3969: "तिरुवन्नामलाई",
        STATE_TN_CITY_3970: "Tirūvottiyūr",
        STATE_TN_CITY_3971: "तिसाइयांविलई",
        STATE_AS_CITY_3972: "तीताबर",
        STATE_WB_CITY_3973: "टीटागढ़",
        STATE_OR_CITY_3974: "टिटलागढ़",
        STATE_UP_CITY_3975: "तीतरों",
        STATE_RJ_CITY_3976: "टोडाभीम",
        STATE_RJ_CITY_3977: "टोडारायसिंह",
        STATE_HR_CITY_3978: "टोहाना",
        STATE_TN_CITY_3979: "टोंडी",
        STATE_RJ_CITY_3980: "टोंक",
        STATE_JH_CITY_3981: "तोपचांची",
        STATE_UP_CITY_3982: "टोरी फ़तेहपुर",
        STATE_UP_CITY_3983: "टोरी-फतेहपुर",
        STATE_HR_CITY_3984: "तोशाम",
        STATE_JK_CITY_3985: "त्राल",
        STATE_MH_CITY_3986: "त्रिम्बक",
        STATE_MH_CITY_3987: "ट्रॉम्बे",
        STATE_JK_CITY_3988: "ज़ार शरीफ",
        STATE_NL_CITY_3989: "तुएनसांग",
        STATE_NL_CITY_3990: "तुएनसांग जिला",
        STATE_WB_CITY_3991: "तूफानगंज",
        STATE_WB_CITY_3992: "ट्यूलिन",
        STATE_MH_CITY_3993: "तुलजापुर",
        STATE_UP_CITY_3994: "तुलसीपुर",
        STATE_KA_CITY_3995: "तुमकुर",
        STATE_MH_CITY_3996: "तुमसर",
        STATE_UP_CITY_3997: "टुंडला",
        STATE_AP_CITY_3998: "तुनि",
        STATE_ML_CITY_3999: "तुरा",
        STATE_TN_CITY_4000: "तुरईयुर",
        STATE_KA_CITY_4001: "तुरुवेकेरे",
        STATE_WB_CITY_4002: "उचलां",
        STATE_TR_CITY_4003: "उदयपुर",
        STATE_RJ_CITY_4004: "उदयपुर",
        STATE_MP_CITY_4005: "उदयपुरा",
        STATE_AS_CITY_4006: "उदलगुड़ी",
        STATE_TN_CITY_4007: "Udangudi",
        STATE_OR_CITY_4008: "उदयगिरि",
        STATE_MH_CITY_4009: "उदगीर",
        STATE_UT_CITY_4010: "उधम सिंह नगर",
        STATE_JK_CITY_4011: "उधमपुर",
        STATE_RJ_CITY_4012: "उदपुरा",
        STATE_TN_CITY_4013: "उदुमलैप्पेट्टई",
        STATE_KA_CITY_4014: "उडुपी",
        STATE_UP_CITY_4015: "उगु",
        STATE_UP_CITY_4016: "उझानी",
        STATE_MP_CITY_4017: "उज्जैन",
        STATE_MN_CITY_4018: "उखरूल",
        STATE_HR_CITY_4019: "उकलाना",
        STATE_MP_CITY_4020: "उकवा",
        STATE_WB_CITY_4021: "यूला",
        STATE_MH_CITY_4022: "उल्हासनगर",
        STATE_KA_CITY_4023: "उल्लाल",
        STATE_WB_CITY_4024: "उलूबेरिया",
        STATE_MH_CITY_4025: "उमरगा",
        STATE_MP_CITY_4026: "उमरिया",
        STATE_MP_CITY_4027: "उमरिया जिला",
        STATE_MH_CITY_4028: "उमरखेड़",
        STATE_CT_CITY_4029: "उमरकोट",
        STATE_GJ_CITY_4030: "उमरपाड़ा",
        STATE_GJ_CITY_4031: "उम्राला",
        STATE_MH_CITY_4032: "उमरेड",
        STATE_GJ_CITY_4033: "उमरेठ",
        STATE_MP_CITY_4034: "उमरी",
        STATE_UP_CITY_4035: "उमरी",
        STATE_GJ_CITY_4036: "संयुक्त राष्ट्र",
        STATE_UP_CITY_4037: "संयुक्त राष्ट्र",
        STATE_HP_CITY_4038: "ऊना",
        STATE_GJ_CITY_4039: "ऊना",
        STATE_TR_CITY_4040: "Unakoti",
        STATE_MP_CITY_4041: "उन्हेल",
        STATE_RJ_CITY_4042: "उनियारा",
        STATE_GJ_CITY_4043: "उंझा",
        STATE_UP_CITY_4044: "उन्नाव",
        STATE_GJ_CITY_4045: "उपलेटा",
        STATE_TG_CITY_4046: "उप्पल कलां",
        STATE_AR_CITY_4047: "ऊपरी सियांग",
        STATE_AR_CITY_4048: "ऊपरी सुबनसिरी",
        STATE_TN_CITY_4049: "उप्पिलियापुरम",
        STATE_MH_CITY_4050: "उरान",
        STATE_AP_CITY_4051: "उरावकोंडा",
        STATE_JK_CITY_4052: "उरी",
        STATE_MH_CITY_4053: "उरुली कंचन",
        STATE_UP_CITY_4054: "उसावां",
        STATE_UP_CITY_4055: "यूज़हैट",
        STATE_TN_CITY_4056: "Usilampatti",
        STATE_UP_CITY_4057: "उसका",
        STATE_GJ_CITY_4058: "उतरन",
        STATE_UP_CITY_4059: "उतरौला",
        STATE_TN_CITY_4060: "उत्तमपालयम",
        STATE_CT_CITY_4061: "उत्तर बस्तर कांकेर",
        STATE_WB_CITY_4062: "उत्तर दिनाजपुर जिला",
        STATE_KA_CITY_4063: "उत्तर कन्नड़",
        STATE_UT_CITY_4064: "उत्तरकाशी",
        STATE_WB_CITY_4065: "उत्तरपाड़ा कोट्रुंग",
        STATE_TN_CITY_4066: "उत्तरमेरुर",
        STATE_TN_CITY_4067: "उत्तुक्कुलि",
        STATE_TN_CITY_4068: "वीएसकेवलसाई (डिंडीगुल-जिला)",
        STATE_MH_CITY_4069: "वड़ा",
        STATE_TN_CITY_4070: "वडक्कू वल्लियूर",
        STATE_TN_CITY_4071: "वडक्कु विरावनल्लूर",
        STATE_TN_CITY_4072: "वडामदुरई",
        STATE_GJ_CITY_4073: "वडगाम",
        STATE_MH_CITY_4074: "वडगांव",
        STATE_KA_CITY_4075: "वाडिगेनहल्ली",
        STATE_TN_CITY_4076: "वडिप्पट्टी",
        STATE_AP_CITY_4077: "वडलामुरु",
        STATE_AP_CITY_4078: "वडलापुडी",
        STATE_GJ_CITY_4079: "वडनगर",
        STATE_MH_CITY_4080: "वडनेर",
        STATE_GJ_CITY_4081: "वडोदरा",
        STATE_GA_CITY_4082: "वागातोर",
        STATE_GJ_CITY_4083: "वाघोडिया",
        STATE_GJ_CITY_4084: "वाघोडिया आईएनए",
        STATE_MH_CITY_4085: "वैजापुर",
        STATE_KL_CITY_4086: "वैकम",
        STATE_MH_CITY_4087: "वैराग",
        STATE_BR_CITY_4088: "वैशाली",
        STATE_TN_CITY_4089: "वलंगइमन",
        STATE_TN_CITY_4090: "वलावनूर",
        STATE_GJ_CITY_4091: "वल्लभ विद्यानगर",
        STATE_GJ_CITY_4092: "वल्लभीपुर",
        STATE_TN_CITY_4093: "वल्लम",
        STATE_TN_CITY_4094: "वालपराई",
        STATE_GA_CITY_4095: "वालपोय",
        STATE_GJ_CITY_4096: "वलसाड",
        STATE_MH_CITY_4097: "वलसांग",
        STATE_GJ_CITY_4098: "वनाला",
        STATE_TN_CITY_4099: "वंडालूर",
        STATE_TN_CITY_4100: "वंदावासी",
        STATE_MH_CITY_4101: "वनगांव",
        STATE_TN_CITY_4102: "वानियमबाडी",
        STATE_GJ_CITY_4103: "वांसदा",
        STATE_GJ_CITY_4104: "वंथली",
        STATE_GJ_CITY_4105: "वापी",
        STATE_UP_CITY_4106: "वाराणसी",
        STATE_MH_CITY_4107: "वरनगांव",
        STATE_GA_CITY_4108: "वर्का",
        STATE_KL_CITY_4109: "वर्कला",
        STATE_GJ_CITY_4110: "वर्तेज",
        STATE_GJ_CITY_4111: "वासा",
        STATE_GJ_CITY_4112: "वासवद",
        STATE_GA_CITY_4113: "वास्को डिगामा",
        STATE_MH_CITY_4114: "वाशी",
        STATE_MH_CITY_4115: "Vasind",
        STATE_GJ_CITY_4116: "वासो",
        STATE_TN_CITY_4117: "वासुदेवानल्लुर",
        STATE_GJ_CITY_4118: "वतामन",
        STATE_TN_CITY_4119: "वट्टलकुंडु",
        STATE_MH_CITY_4120: "वातुल",
        STATE_KL_CITY_4121: "वयलार",
        STATE_TN_CITY_4122: "वेदारनीयम",
        STATE_TN_CITY_4123: "वेदसंदुर",
        STATE_GJ_CITY_4124: "वेजलपुर",
        STATE_TN_CITY_4125: "वेलनकन्नी",
        STATE_MH_CITY_4126: "वेलास, महाराष्ट्र",
        STATE_TN_CITY_4127: "वेल्लानूर",
        STATE_TN_CITY_4128: "वेल्लोर",
        STATE_MH_CITY_4129: "Velneshwar",
        STATE_TN_CITY_4130: "वेलूर",
        STATE_TG_CITY_4131: "वेमलवाड़ा",
        STATE_TN_CITY_4132: "वेंगावासल",
        STATE_MH_CITY_4133: "वेंगुर्ला",
        STATE_AP_CITY_4134: "वेंकटगिरी",
        STATE_AP_CITY_4135: "वेपागुंटा",
        STATE_GJ_CITY_4136: "वेरावल",
        STATE_AP_CITY_4137: "वेतापलेम",
        STATE_TN_CITY_4138: "वेट्टाइक्करनपुदुर",
        STATE_TN_CITY_4139: "वेट्टावलम",
        STATE_KL_CITY_4140: "वेट्टूर",
        STATE_MP_CITY_4141: "विदिशा",
        STATE_GJ_CITY_4142: "विजापुर",
        STATE_TN_CITY_4143: "विजयपुरी",
        STATE_AP_CITY_4144: "विजयवाड़ा",
        STATE_MH_CITY_4145: "विजयदुर्ग",
        STATE_TG_CITY_4146: "विकाराबाद",
        STATE_UT_CITY_4147: "विकासनगर",
        STATE_MH_CITY_4148: "विक्रोली",
        STATE_TN_CITY_4149: "विक्रवांडी",
        STATE_TN_CITY_4150: "विलाट्टिकुलम",
        STATE_MH_CITY_4151: "विले पार्ले",
        STATE_TN_CITY_4152: "विल्लुपुरम",
        STATE_GJ_CITY_4153: "विंछिया",
        STATE_GJ_CITY_4154: "विंचिया",
        STATE_MH_CITY_4155: "विन्चूर",
        STATE_UP_CITY_4156: "विंध्याचल",
        STATE_AP_CITY_4157: "विनुकोंडा",
        STATE_TN_CITY_4158: "विरागानुर",
        STATE_GJ_CITY_4159: "वीरमगाम",
        STATE_MH_CITY_4160: "विरार",
        STATE_KA_CITY_4161: "वीरराजेन्द्रपेट",
        STATE_GJ_CITY_4162: "वीरपुर",
        STATE_TN_CITY_4163: "विरुधुनगर",
        STATE_AP_CITY_4164: "विशाखापत्तनम",
        STATE_GJ_CITY_4165: "विसावदर",
        STATE_GJ_CITY_4166: "विसनगर",
        STATE_MH_CITY_4167: "वीटा, महाराष्ट्र",
        STATE_MH_CITY_4168: "विटे",
        STATE_AP_CITY_4169: "विजयनगरम",
        STATE_AP_CITY_4170: "विजयनगरम जिला",
        STATE_TN_CITY_4171: "वृद्धाचलम",
        STATE_UP_CITY_4172: "वृंदावन",
        STATE_AP_CITY_4173: "वुय्युरु",
        STATE_GJ_CITY_4174: "व्यारा",
        STATE_MH_CITY_4175: "वडाला",
        STATE_MH_CITY_4176: "वडगांव",
        STATE_GJ_CITY_4177: "वधाई",
        STATE_GJ_CITY_4178: "वधावन",
        STATE_KA_CITY_4179: "वाडी",
        STATE_MH_CITY_4180: "वाडनेर",
        STATE_MH_CITY_4181: "वडवानी",
        STATE_GJ_CITY_4182: "वाघई",
        STATE_MH_CITY_4183: "वाघोली",
        STATE_MH_CITY_4184: "वाई",
        STATE_MH_CITY_4185: "वाकड",
        STATE_TN_CITY_4186: "वालाजापेट",
        STATE_MH_CITY_4187: "वलगांव",
        STATE_MH_CITY_4188: "वाकी",
        STATE_TN_CITY_4189: "वलाजहबाद",
        STATE_UP_CITY_4190: "वाल्टरगंज",
        STATE_MN_CITY_4191: "वांगजिंग",
        STATE_MH_CITY_4192: "वानी",
        STATE_GJ_CITY_4193: "वांकानेर",
        STATE_TG_CITY_4194: "वानपार्टी",
        STATE_TG_CITY_4195: "वारंगल",
        STATE_MP_CITY_4196: "वारासिवनी",
        STATE_MH_CITY_4197: "वर्धा",
        STATE_BR_CITY_4198: "वारिस अलीगंज",
        STATE_MH_CITY_4199: "वरोरा",
        STATE_MH_CITY_4200: "वरूड",
        STATE_MH_CITY_4201: "वाशिम",
        STATE_KL_CITY_4202: "वायनाड",
        STATE_UP_CITY_4203: "Wazirganj",
        STATE_TN_CITY_4204: "वेलिंग्टन",
        STATE_RJ_CITY_4205: "वेर",
        STATE_DL_CITY_4206: "पश्चिमी दिल्ली",
        STATE_SK_CITY_4207: "पश्चिम जिला",
        STATE_ML_CITY_4208: "पश्चिम गारो हिल्स",
        STATE_AP_CITY_4209: "पश्चिम गोदावरी",
        STATE_ML_CITY_4210: "पश्चिम जैंतिया हिल्स",
        STATE_AR_CITY_4211: "पश्चिम कामेंग",
        STATE_ML_CITY_4212: "पश्चिम खासी हिल्स",
        STATE_AR_CITY_4213: "पश्चिम सियांग",
        STATE_TR_CITY_4214: "पश्चिम त्रिपुरा",
        STATE_NL_CITY_4215: "वोखा",
        STATE_MH_CITY_4216: "वर्ली",
        STATE_KA_CITY_4217: "यादगीर",
        STATE_MN_CITY_4218: "यारीपोक",
        STATE_HR_CITY_4219: "यमुनानगर",
        STATE_AP_CITY_4220: "यानम",
        STATE_PY_CITY_4221: "यानम",
        STATE_AP_CITY_4222: "Yanamalakuduru",
        STATE_AP_CITY_4223: "यारदा",
        STATE_MH_CITY_4224: "यावल",
        STATE_MH_CITY_4225: "यवतमाल",
        STATE_KA_CITY_4226: "येलाहंका",
        STATE_KA_CITY_4227: "येलंडूर",
        STATE_KA_CITY_4228: "येल्बर्गा",
        STATE_TG_CITY_4229: "येलांडु",
        STATE_KA_CITY_4230: "Yellapur",
        STATE_MH_CITY_4231: "येवला",
        STATE_HP_CITY_4232: "ब्रोकर",
        STATE_UP_CITY_4233: "यूसुफपुर",
        STATE_UP_CITY_4234: "जाफराबाद",
        STATE_TG_CITY_4235: "जहीराबाद",
        STATE_UP_CITY_4236: "जैदपुर",
        STATE_UP_CITY_4237: "जमानिया",
        STATE_PB_CITY_4238: "ज़ीरा",
        STATE_AR_CITY_4239: "जाइरो",
        STATE_NL_CITY_4240: "जुन्हेबोटो",
        STATE_AN: "अंदमान आणि निकोबार बेटे",
        STATE_AP: "आंध्र प्रदेश",
        STATE_AR: "अरुणाचल प्रदेश",
        STATE_AS: "आसाम",
        STATE_BR: "बिहार",
        STATE_CH: "चंदीगड",
        STATE_CT: "छत्तीसगड",
        STATE_DH: "दादरा आणि नगर हवेली आणि दमण आणि दीव",
        STATE_DL: "दिल्ली",
        STATE_GA: "गोवा",
        STATE_GJ: "गुजरात",
        STATE_HR: "हरियाणा",
        STATE_HP: "हिमाचल प्रदेश",
        STATE_JK: "जम्मू आणि काश्मीर",
        STATE_JH: "झारखंड",
        STATE_KA: "कर्नाटक",
        STATE_KL: "केरळ",
        STATE_LA: "लडाख",
        STATE_LD: "लक्षद्वीप",
        STATE_MP: "मध्य प्रदेश",
        STATE_MH: "महाराष्ट्र",
        STATE_MN: "मणिपूर",
        STATE_ML: "मेघालय",
        STATE_MZ: "मिझोरम",
        STATE_NL: "नागालैंड",
        STATE_OR: "ओडिशा",
        STATE_PY: "पुडुचेरी",
        STATE_PB: "पंजाब",
        STATE_RJ: "राजस्थान",
        STATE_SK: "सिक्कीम",
        STATE_TN: "तामिळनाडू",
        STATE_TG: "तेलंगणा",
        STATE_TR: "त्रिपुरा",
        STATE_UP: "उत्तर प्रदेश",
        STATE_UT: "उत्तराखंड",
        STATE_WB: "पश्चिम बंगाल",
        SERVICE_MODULAR_KITCHEN: "मॉड्यूलर किचन",
        SERVICE_STORAGE_WORDROBE: "भंडारण और अलमारी",
        SERVICE_CROCKERY_UNIT: "क्रॉकरी यूनिट",
        SERVICE_SPACE_SAVING: "स्थान बचाने वाला फर्नीचर",
        SERVICE_ELECRICAL_CHANGE: "विद्युत परिवर्तन",
        SERVICE_POP: "पीओपी (प्लास्टर ऑफ पेरिस)",
        SERVICE_TV_UNIT: "टीवी इकाइयाँ",
        SERVICE_STUDY_TABLE: "अध्ययन तालिका",
        SERVICE_FALSE_CEILING: "छत डिजाइन",
        SERVICE_LIGHTS: "बल्ब चयन",
        SERVICE_WALLPAPER: "वॉलपेपर",
        SERVICE_PAINTING: "पेंटिंग",
        SERVICE_BATHROOM_DESIGN: "बाथरूम डिजाइन",
        SERVICE_FURNITURE_DESIGN: "फर्नीचर डिजाइन",
        SERVICE_POOJA_UNIT: "पूजा इकाई",
        SERVICE_BEDROOM_DECORATION: "बेडरूम की सजावट",
        SERVICE_STORE_SHOP: "दुकानों और दुकानों की सजावट",
        SERVICE_KIDS_SPACE: "बच्चों का क्षेत्र",
        SERVICE_DINING_SPACE: "भोजन क्षेत्र",
        SERVICE_APPLIANCE_SELECTION: "उपकरण चयन",
        SERVICE_CABINATE_HARDWARE_DESIGN: "कैबिनेटरी और हार्डवेयर डिजाइन",
        SERVICE_CLOSET_DESIGN: "कोठरी डिजाइन",
        SERVICE_COMMERCIAL_INTERIOR: "वाणिज्यिक इंटीरियर डिजाइन और सजावट",
        SERVICE_CUSTOM_ART: "कस्टम कला चयन",
        SERVICE_DINING_ROOM: "भोजन कक्ष की सजावट",
        SERVICE_DOOR_DESIGN: "दरवाजा डिजाइन",
        SERVICE_FLOORING_SELECTION: "फ़्लोरिंग चयन",
        SERVICE_HOME_STAGING: "घर को बेचने के लिए सजाना",
        SERVICE_LIVING_ROOM_DESIGN: "लिविंग रूम डिजाइन और सजावट",
        SERVICE_INTERIOR_ARCHITECTURE_DESIGN: "आंतरिक वास्तु डिजाइन",
        SERVICE_REFURBISHMENT: "नवीकरण",
        SERVICE_RESTAURANT_DESIGN: "रेस्टोरेंट डिजाइन और सजावट",
        SERVICE_ROOM_PLANNING: "रूम प्लानिंग",
        SERVICE_OFFICE_DESIGN: "कार्यालय डिजाइन और सजावट",
        SERVICE_CUPBOARD_DESIGN: "अलमारी डिजाइन",
        SERVICE_CRAFT_INTERIORS: "अंदरूनी शिल्प",
        ABOUT_US_MAIN_TITLE: "हम कलात्मक इंटीरियर",
        ABOUT_US_DESCRIPTION: "एसबी.विश्वकर्मा इंटीरियर एंड डेकोरेटिंग आपके घर या कार्यालय में 10+ वर्षों का इंटीरियर डिजाइन अनुभव लाता है। हमारे डिज़ाइन पेशेवर आपको उन उत्पादों और डिज़ाइनों को निर्धारित करने में मदद करने के लिए सुसज्जित हैं जो आपके ग्राहकों के लिए आपकी अपेक्षा से अधिक रंगों और प्रकाश व्यवस्था के भीतर हमारे ग्राहकों के लिए सबसे अच्छा काम करते हैं।",
        SLEEK_ARCHITECTURE_TITLE: "चिकना वास्तुकला बनाते हैं ।",
        ABOUT_US_SECOND_PARA: "हम अपने ग्राहकों को घर और कार्यालय के फर्नीचर के साथ-साथ प्रयोगशालाओं, अस्पतालों और स्वास्थ्य देखभाल प्रतिष्ठानों, शिक्षा और प्रशिक्षण संस्थानों, शिपयार्ड और नौसेना, सभागारों और स्टेडियमों के लिए समाधान प्रदान करते हैं। चाहे आप किसी विशिष्ट शैली की तलाश कर रहे हों, जैसे कि पारंपरिक, आधुनिक, समकालीन, या उदार, या आपके मन में एक ब्रांड है, हम आपको सही विकल्प बनाने में मदद कर सकते हैं। हमारी आंतरिक डिज़ाइन सेवाओं में आपको सही रंग और फ़िनिश चुनने में मदद करने से लेकर फ़र्नीचर, फ़र्श, कैबिनेट और प्रकाश व्यवस्था तक सब कुछ शामिल है जो आपके घर के लिए सर्वोत्तम समग्र रूप और अनुभव प्रदान करेगा। हम आपके साथ एक ऐसा वातावरण बनाने के लिए काम करेंगे जो आपकी अपेक्षाओं से अधिक हो और आपकी अनूठी शैली के अनुकूल हो।",
        COMMON_CONTENT_AMPERSAND: "और",
        COMMON_CONTENT_ALONG_WITH: "और साथ में",
        COMMON_CONTENT_BEST_PRICE: "सबसे अच्छी कीमत",
        COMMON_CONTENT_SUPER_QUALITY: "उच्च गुणवत्ता",
        COMMON_CONTENT_SAFETY_ASSURANCE: "सुरक्षा का आश्वासन",
        COMMON_CONTENT_PHONE: "फ़ोन",
        COMMON_CONTENT_LOCATION: "स्थान",
        COMMON_CONTENT_EMAIL: "ईमेल",
        COMMON_CONTENT_STATE: "राज्य",
        COMMON_CONTENT_CITY: "शहर",
        COMMON_CONTENT_PIN_CODE: "पिन कोड",
        COMMON_CONTENT_SUBMIT: "जमा करे",
        COMMON_CONTENT_USEFUL_LINK: "उपयोगी लिंक",
        COMMON_BUTTON_SUBSCRIBE: "सदस्यता ले",
        COMMON_BUTTON_SUBSCRIBING: "सदस्यता ली जा रही",
        COMMON_BUTTON_CONTACT_US: "संपर्क करें",
        COMMON_BUTTON_SEND_MESSAGE: "मेसेज भेजें",
        COMMON_BUTTON_SUBMIT: "भेजे",
        COMMMON_BUTTON_VIEW_ALL: "सभी देखें",
        COMMON_CONTENT_COMPANY_NAME: "एस.बी.विश्वकर्मा",
        COMMON_CONTENT_ALL_RIGHTS_RESERVED: "सर्वाधिकार सुरक्षित।",
        COMMON_CONTENT_COPYRIGHT: "कॉपीराइट",
        COMMON_PLACEHOLDER_NAME: "अपना नाम दर्ज करें",
        COMMON_PLACEHOLDER_EMAIL: "अपना ईमेल दर्ज करें",
        COMMON_PLACEHOLDER_SUBJECT: "विषय दर्ज करें",
        COMMON_PLACEHOLDER_MESSAGE: "अपना संदेश दर्ज करें",
        COMMON_PLACEHOLDER_PHONE: "फोन नंबर दर्ज",
        COMMON_PLACEHOLDER_PINCODE: "अपना पिनकोड दर्ज करें",
        COMMON_PLACEHOLDER_FAQ: "खोजने के लिए शब्द दर्ज करें......",
        COMMON_PLACEHOLDER_SELECT: "चूने",
        COMMON_PLACEHOLDER_FAQ_NOTFOUND: "कोई मेल नहीं मिला.......",
        COMMON_LABEL_DESIGNED_BY: "अनुज विश्वकर्मा द्वारा डिजाइन किया गया।",
        CONTACT_ADDRESS: "साकीनाका अँधेरी ईस्ट, मुंबई",
        NEWLETTER_TITLE: "हमारे समाचार पत्र शामिल हों",
        NEWLETTER_DESC: "हमसे नवीनतम अपडेट और ऑफ़र प्राप्त करने के लिए आपको ईमेल प्रदान करें।",
        USER_WHATSAPP_CONFIRMATION: "आप व्हाट्सएप पर मुझसे संपर्क कर सकते हैं!",
        COMMON_CONTENT_OUR_TEAM: "हमारी टीम",
        TEAM_TITLE: "हमारी प्यारी टीम की एक छोटी सी झलक",
        BOOK_FREE_SESSION: "एक निःशुल्क सत्र बुक करें....",
        COMMON_CONTENT_SERVICES: "सेवाएं",
        COMMON_CONTENT_FEATURES: "विशेषताएँ",
        COMMON_CONTENT_FEATURED_PROJECTS: "फ़ीचर प्रोजेक्ट",
        FEATURED_PROJECTS_DESC: "यहां कुछ चुनिंदा परियोजनाएं दी गई हैं...",
        COMMON_CONTENT_GALLERY: "गैलरी",
        GALLERY_DESC: "हमारी नवीनतम गैलरी छवियां देखें",
        FEATURES_DESC: "अपने अनुभव और विशेषज्ञता के साथ हम अपने विश्वसनीय ग्राहकों को नीचे दी गई कुछ मूल्यवान सेवा प्रदान करते हैं।",
        COMMON_CONTENT_ABOUT_US: "हमारे बारे में",
        COMMON_CONTENT_FAQ: "सामान्य प्रश्न",
        COMMON_CONTENT_HOME: "घर",
        COMMON_CONTENT_PORTFOLIO: "संविभाग",
        COMMON_CONTENT_CONTACT: "संपर्क",
        COMMON_CONTENT_BLOG: "ब्लॉग",
        COMMON_CONTENT_WHY_US: "हमें क्यों चुनें",
        COMMON_CONTENT_DECORATOR: "डेकोरेटर",
        CONTENT_DECORATOR: "डेकोरेटर",
        COMMON_CONTENT_FULL_NAME: "पूरा नाम",
        WHY_US_TITLE: "हमें क्यों चुनें?",
        WHY_US_DESC: "अपने सपनों का घर चुनने को लेकर असमंजस में, तो देखें ये...",
        WHY_US_PARAGRAPH: "हमारी आंतरिक डिज़ाइन सेवाओं में आपको सही रंग और फ़िनिश चुनने में मदद करने से लेकर फ़र्नीचर, फ़र्श, कैबिनेट और प्रकाश व्यवस्था तक सब कुछ शामिल है जो आपके घर के लिए सर्वोत्तम समग्र रूप और अनुभव प्रदान करेगा। हम आपके साथ एक ऐसा वातावरण बनाने के लिए काम करेंगे जो आपकी अपेक्षाओं से अधिक हो और आपकी अनूठी शैली के अनुकूल हो।",
        WHY_US_ITEM_ONE: "अनुभव",
        WHY_US_ITEM_ONE_DESC: "{{key1}}+ वर्ष का अनुभव।",
        WHY_US_ITEM_TWO: "विश्वास",
        WHY_US_ITEM_TWO_DESC: "{{key1}}+ खुश ग्राहक",
        WHY_US_ITEM_THREE: "गुणवत्ता",
        WHY_US_ITEM_THREE_DESC: "आकर्षक डिजाइनों के साथ बेहतर गुणवत्ता वाली सामग्री",
        WHY_US_ITEM_FOUR: "वारंटी",
        WHY_US_ITEM_FOUR_DESC: "{{key1}} साल तक की सामग्री वारंटी",
        ABOUT_US_PARAGRAPH_ONE: "एसबी विश्वकर्मा इंटीरियर डिज़ाइन एंड डेकोरेटिंग में, हम आपको उन उत्पादों और शैलियों का चयन करने में मदद करने के लिए {{key1}}+ वर्षों के इंटीरियर डिजाइन ज्ञान की पेशकश करते हैं जो आपके आस-पास के वातावरण के रंगों और प्रकाश व्यवस्था के भीतर आपकी आवश्यकताओं के अनुरूप सर्वोत्तम हैं।",
        ABOUT_US_PARAGRAPH_TWO: "हम स्टाइलिश और व्यावहारिक उत्पादों की एक विस्तृत विविधता प्रदान करते हैं जो किसी भी बजट या डिजाइन की जरूरतों के अनुरूप हैं। चाहे आप एक नई रसोई या बाथरूम की तलाश कर रहे हों, या अपने रहने वाले कमरे या भोजन कक्ष में एक नए अपडेट पर विचार कर रहे हों, हम आपकी जरूरत की हर चीज के लिए वन-स्टॉप शॉप प्रदान करते हैं।",
        ABOUT_US_PARAGRAPH_THREE: "फर्नीचर से लेकर लाइटिंग, वॉल आर्ट से लेकर गलीचों तक, हम किसी भी सजाने की शैली के अनुरूप कई तरह के उत्पाद पेश करते हैं। उत्पादों के हमारे विशाल चयन के साथ, आप निश्चित रूप से कुछ ऐसा पाएंगे जो आपकी शैली के अनुकूल हो। साथ ही, हम आपके इंटीरियर डिज़ाइन की ज़रूरतों के लिए सर्वोत्तम निर्णय लेने में आपकी सहायता करने के लिए विभिन्न प्रकार की विशेषज्ञ सलाह प्रदान करते हैं।",
        ABOUT_US_PARAGRAPH_FOUR: "उच्च गुणवत्ता वाले उत्पादों को डिजाइन करना जो न केवल इंद्रियों के लिए आकर्षक हैं, बल्कि किफायती भी हैं। हमारे विशेषज्ञ डिजाइनिंग और निर्माण दल हमारे मिशन को प्राप्त करने में मदद करते हैं।",
        ABOUT_US_PARAGRAPH_FIVE: "हमारे इंटीरियर डिज़ाइन विशेषज्ञ आपके घर या कार्यालय के लिए सही उत्पाद और डिज़ाइन खोजने में आपकी मदद करने के लिए यहाँ हैं। हमारे व्यापक डिजाइन अनुभव के अलावा, हम आपके परिवेश को बढ़ाने के लिए रंग और प्रकाश व्यवस्था चुनने में आपकी सहायता कर सकते हैं।",
        ABOUT_US_PARAGRAPH_SIX: "हम डिजाइन के बारे में भावुक हैं और हमारे ग्राहकों की अपेक्षाओं को पार करते हैं! हमने महसूस किया कि ऐसा करने का सबसे अच्छा तरीका न केवल डिजाइन पर बल्कि फर्नीचर पर भी ध्यान केंद्रित करना है।",
        ABOUT_US_GOAL: "हमारा लक्ष्य हमेशा आपके डिजाइन के सपनों को साकार करना है और इसे इस तरह से करना है जो आपके लिए मजेदार और इंटरैक्टिव हो!",
        ABOUT_US_MISSION: "हमारा मिशन लोगों को सुंदर घरों की कल्पना करने, बनाने और बनाए रखने में मदद करना है। हम आपके लिए शानदार घरों, विशिष्ट स्थानों, वास्तुशिल्प चमत्कारों और नए डिजाइन रुझानों के प्रेरक दृश्य लेकर आए हैं।",
        ABOUT_US_PARAGRAPH_SEVEN: "हमारी आंतरिक डिज़ाइन सेवाओं में आपको सही रंग और फ़िनिश चुनने में मदद करने से लेकर फ़र्नीचर, फ़र्श, कैबिनेट और प्रकाश व्यवस्था तक सब कुछ शामिल है जो आपके घर के लिए सर्वोत्तम समग्र रूप और अनुभव प्रदान करेगा। हम आपके साथ एक ऐसा वातावरण बनाने के लिए काम करेंगे जो आपकी अपेक्षाओं से अधिक हो और आपकी अनूठी शैली के अनुकूल हो।",
        TEAM_ROLE_TWO: "डेकोरेटर",
        SANDEEP_VISHWAKARMA: "संदीप विश्वकर्मा",
        JITENDRA_VISHWAKARMA: "जितेंद्र विश्वकर्मा",
        SANDEEP_VISHWAKARMA_QUOTE: "हम अपने घरों को आकार देते हैं और फिर हमारे घर हमें आकार देते हैं।",
        JITENDRA_VISHWAKARMA_QUOTE: "विशिष्ट रूप से 'कुछ' होने से आपको भीड़ से अलग दिखने में मदद मिलेगी।",
        SECTION_CONTENT_TITLE: "एस.बी. विश्वकर्मा",
        SECTION_TITLE_HEADER: "एसबी विश्वकर्मा इंटीरियर डिज़ाइन एंड डेकोरेटिंग में, हम आपको उन उत्पादों और शैलियों का चयन करने में मदद करने के लिए {{key1}}+ वर्षों के इंटीरियर डिजाइन ज्ञान की पेशकश करते हैं जो आपके आस-पास के वातावरण के रंगों और प्रकाश व्यवस्था के भीतर आपकी आवश्यकताओं के अनुरूप सर्वोत्तम हैं।",
        SECTION_PARAGRAPH_ONE: "हम स्टाइलिश और व्यावहारिक उत्पादों की एक विस्तृत विविधता प्रदान करते हैं जो किसी भी बजट या डिजाइन की जरूरतों के अनुरूप हैं। चाहे आप एक नई रसोई या बाथरूम की तलाश कर रहे हों, या अपने रहने वाले कमरे या भोजन कक्ष में एक नए अपडेट पर विचार कर रहे हों, हम आपकी जरूरत की हर चीज के लिए वन-स्टॉप शॉप प्रदान करते हैं।",
        SECTION_PARAGRAPH_TWO: "फर्नीचर से लेकर लाइटिंग, वॉल आर्ट से लेकर गलीचों तक, हम किसी भी सजाने की शैली के अनुरूप कई तरह के उत्पाद पेश करते हैं। उत्पादों के हमारे विशाल चयन के साथ, आप निश्चित रूप से कुछ ऐसा पाएंगे जो आपकी शैली के अनुकूल हो। साथ ही, हम आपके इंटीरियर डिज़ाइन की ज़रूरतों के लिए सर्वोत्तम निर्णय लेने में आपकी सहायता करने के लिए विभिन्न प्रकार की विशेषज्ञ सलाह प्रदान करते हैं।",
        SECTION_PARAGRAPH_THREE: "उच्च गुणवत्ता वाले उत्पादों को डिजाइन करना जो न केवल इंद्रियों के लिए आकर्षक हैं, बल्कि किफायती भी हैं। हमारे विशेषज्ञ डिजाइनिंग और निर्माण दल हमारे मिशन को प्राप्त करने में मदद करते हैं।",
        SECTION_PARAGRAPH_FOUR: "हमारे इंटीरियर डिज़ाइन विशेषज्ञ आपके घर या कार्यालय के लिए सही उत्पाद और डिज़ाइन खोजने में आपकी मदद करने के लिए यहाँ हैं। हमारे व्यापक डिजाइन अनुभव के अलावा, हम आपके परिवेश को बढ़ाने के लिए रंग और प्रकाश व्यवस्था चुनने में आपकी सहायता कर सकते हैं।",
        SECTION_PARAGRAPH_FIVE: "हम डिजाइन के बारे में भावुक हैं और हमारे ग्राहकों की अपेक्षाओं को पार करते हैं! हमने महसूस किया कि ऐसा करने का सबसे अच्छा तरीका न केवल डिजाइन पर बल्कि फर्नीचर पर भी ध्यान केंद्रित करना है।",
        SECTION_PARAGRAPH_SIX: "हमारी आंतरिक डिज़ाइन सेवाओं में आपको सही रंग और फ़िनिश चुनने में मदद करने से लेकर फ़र्नीचर, फ़र्श, कैबिनेट और प्रकाश व्यवस्था तक सब कुछ शामिल है जो आपके घर के लिए सर्वोत्तम समग्र रूप और अनुभव प्रदान करेगा। हम आपके साथ एक ऐसा वातावरण बनाने के लिए काम करेंगे जो आपकी अपेक्षाओं से अधिक हो और आपकी अनूठी शैली के अनुकूल हो।",
        SECTION_PARAGRAPH_LIST_ITEM_ONE: "सबसे अच्छी कीमत",
        SECTION_PARAGRAPH_LIST_ITEM_TWO: "उच्च गुणवत्ता",
        SECTION_PARAGRAPH_LIST_ITEM_THREE: "सुरक्षा का आश्वासन",
        GOAL: "हमारा लक्ष्य हमेशा आपके डिजाइन के सपनों को साकार करना है और इसे इस तरह से करना है जो आपके लिए मजेदार और इंटरैक्टिव हो!",
        MISSION: "हमारा मिशन लोगों को सुंदर घरों की कल्पना करने, बनाने और बनाए रखने में मदद करना है। हम आपके लिए शानदार घरों, विशिष्ट स्थानों, वास्तुशिल्प चमत्कारों और नए डिजाइन रुझानों के प्रेरक दृश्य लेकर आए हैं।",
        FEATURE_ITEM_ONE: "इंटीरियर डिजाइन और सजावट",
        FEATURE_ITEM_TWO: "वास्तुकला डिजाइन",
        FEATURE_ITEM_THREE: "लैंडस्केप योजना",
        FEATURE_ITEM_FOUR: "तैयारशुदा परियोजना",
        FEATURE_ITEM_FIVE: "पैसे की बचत",
        FEATURE_ITEM_SIX: "परियोजना प्रबंधन",
        FEATURE_ITEM_ONE_DESC: "अपने स्थान की सुंदरता के पूरक के लिए पूरी तरह से व्यक्तिगत फर्नीचर प्राप्त करें।",
        FEATURE_ITEM_TWO_DESC: "एक चिकना-निर्मित डिज़ाइन की अपेक्षा करें जो लालित्य के साथ कार्य को मिश्रित करता है।",
        FEATURE_ITEM_THREE_DESC: "विविध रंगों में सही साज-सज्जा और कपड़ों से लेकर विभिन्न प्रकार के घर के इंटीरियर डेकोर आइटम तक।",
        FEATURE_ITEM_FOUR_DESC: "रोशनी की एक विस्तृत श्रृंखला से चुनें- विस्तृत झूमर, सुंदर फर्श लैंप।",
        FEATURE_ITEM_FIVE_DESC: "सिग्नेचर वॉर्डरोब के लिए सही आकार, सही आकार और एक ठाठ डिजाइन खोजें।",
        FEATURE_ITEM_SIX_DESC: "सिग्नेचर वॉल्स प्राप्त करें जो आपकी वास्तविक व्यक्तित्व शैली को व्यक्त करती हैं। दिलचस्प रंगों से।",
        PARAGRAPH: "हमारी आंतरिक डिज़ाइन सेवाओं में आपको सही रंग और फ़िनिश चुनने में मदद करने से लेकर फ़र्नीचर, फ़र्श, कैबिनेट और प्रकाश व्यवस्था तक सब कुछ शामिल है जो आपके घर के लिए सर्वोत्तम समग्र रूप और अनुभव प्रदान करेगा। हम आपके साथ एक ऐसा वातावरण बनाने के लिए काम करेंगे जो आपकी अपेक्षाओं से अधिक हो और आपकी अनूठी शैली के अनुकूल हो।",
        ITEM_ONE: "अनुभव",
        ITEM_TWO: "विश्वास",
        ITEM_THREE: "गुणवत्ता",
        ITEM_THREE_DESC: "आकर्षक डिजाइनों के साथ बेहतर गुणवत्ता वाली सामग्री",
        ITEM_FOUR: "वारंटी",
        ITEM_FOUR_DESC: "{{key1}} साल तक की सामग्री वारंटी",
        HWW_TITLE: "हम कैसे काम करते हैं",
        HWW_DESC: "पहली कॉल से लेकर अंतिम हैंडओवर तक—हम आपके घर की सभी डिज़ाइन आवश्यकताओं का ध्यान रखते हैं",
        HWW_STEP_ONE_TITLE: "डिजाइनर से मिलें",
        HWW_STEP_ONE_DESC: "हमारे डिज़ाइन विशेषज्ञ उन सामग्रियों और शैलियों को निर्धारित करने में सक्षम हैं जो आपकी अपेक्षाओं से अधिक आपकी सेटिंग के रंगों और प्रकाश व्यवस्था के संयोजन के साथ हमारे ग्राहकों के लिए सबसे अच्छा काम करती हैं। वे आपकी आवश्यकता को समझेंगे और आपके सपनों का घर जीवन में लाएंगे।",
        HWW_STEP_TWO_TITLE: "अपनी पसंदीदा सामग्री चुनें",
        HWW_STEP_TWO_DESC: "पेंट रंग चुनने से लेकर फर्नीचर का चयन करने तक, हम आपके साथ एक ऐसा स्थान बनाने के लिए काम करते हैं जो आपके व्यक्तित्व, आपकी जीवनशैली के लिए कार्य करता है, और बहुत अच्छा लगता है।",
        HWW_STEP_THREE_TITLE: "प्रोजेक्ट टाइमलाइन की पुष्टि करें",
        HWW_STEP_THREE_DESC: "परियोजना को बुक करने के लिए एक प्रारंभिक भुगतान करें और हमारी टीम विभिन्न गतिविधियों की योजना को ध्यान में रखते हुए आपके साथ परियोजना की अवधि तय करेगी।",
        HWW_STEP_FOUR_TITLE: "साइट हैंडओवर",
        HWW_STEP_FOUR_DESC: "हम कम या दिए गए समय के अंतराल में काम पूरा करते हैं और आपका सपनों का घर तैयार है और अब आप अपने पुन: डिज़ाइन किए गए घर में जा सकते हैं",
        HAPPY_CUSTOMERS_TEXT: "खुश ग्राहक",
        YOE_TEXT: "वर्षों का अनुभव",
        PROJECTS_TEXT: "प्रोजेक्ट",
        HARD_WORKING_EMPLOYEE_TEXT: "मेहनती कर्मचारी",
        HERO_ITEM_ONE: "इंटीरियर डिजाइन और सजावट",
        HERO_ITEM_TWO: "बेडरूम डिजाइन और सजावट",
        HERO_ITEM_THREE: "उत्तम गुणवत्ता सामग्री के साथ स्मार्ट और सुपीरियर फर्नीचर",
        CTA_TITLE: "काम के लिए हमें कॉल करें",
        CTA_DESC: "अभी भी उलझन में है कि क्या चुनना है? हमें कॉल करें और हम आपकी मदद करेंगे।",
        PORTFOLIO_TV_UNIT: "टीवी यूनिट",
        PORTFOLIO_BEDROOM: "शयन कक्ष",
        PORTFOLIO_BATHROOM: "बाथरूम",
        PORTFOLIO_FURNITURE: "फर्नीचर",
        PORTFOLIO_KITCHEN: "रसोईघर",
        PORTFOLIO_LIVING_SPACE: "रहने की जगह",
        COMMON_CONTENT_OTHERS: "अन्य",
        COMMON_CONTENT_ALL: "सभी",
        FAQ_QUE_1: "एसबी विश्वकर्मा क्या है?",
        FAQ_ANS_1: "एसबी विश्वकर्मा एक संपूर्ण, पूरी तरह से व्यक्तिगत सेवा है जो आपको अपने सपनों के घर के लिए इंटीरियर डिजाइन और निष्पादित करने में मदद करती है।",
        FAQ_QUE_2: "अगर मैं अपने घर के लिए कुछ बहुत ही सरल और न्यूनतम डिजाइन का काम करना चाहता हूं तो क्या मैं सेवा का लाभ उठा सकता हूं?",
        FAQ_ANS_2: "बिल्कुल। एसबी विश्वकर्मा आपके इंटीरियर डिजाइन की जरूरतों के लिए व्यक्तिगत समाधान प्रदान करता है। आपके विज़न को समझने के लिए हमारे डिज़ाइनर आपसे विस्तार से बात करते हैं और आपको एक ऐसा स्थान डिज़ाइन करने में मदद करते हैं जो आपके स्वाद और वरीयताओं के अनुरूप हो। यह सेवा निश्चित रूप से आपके लिए विचार करने का एक विकल्प है।",
        FAQ_QUE_3: "अगर मैं इस सेवा को बुक करता हूं तो क्या मुझे पूरे घर को डिजाइन करवाना होगा?",
        FAQ_ANS_3: "बिल्कुल भी नहीं। यह सेवा आपके लिए काम करती है, भले ही आपका नवीनीकरण किसी विशिष्ट कमरे या घर के क्षेत्र तक ही सीमित हो।",
        FAQ_QUE_4: "जब मैं काम पर घर से बाहर होऊंगा तो काम की निगरानी कौन करेगा?",
        FAQ_ANS_4: "हमारे ग्राहक अनुभव विशेषज्ञ (सीईएस) आपके सभी प्रश्नों और चिंताओं के लिए संपर्क का एकमात्र बिंदु होगा। वह पूरी परियोजना का नेतृत्व करेगा और आपको प्रगति के बारे में सूचित करेगा।",
        FAQ_QUE_5: "क्या मुझे नियमित रूप से साइट पर जाने की आवश्यकता होगी?",
        FAQ_ANS_5: "नहीं। हमारा ग्राहक अनुभव विशेषज्ञ (सीईएस) आपकी साइट का संरक्षक है और वह साइट पर जाएगा और यह भी सुनिश्चित करेगा कि काम कैसे आगे बढ़ रहा है, इस बारे में आपको नियमित अपडेट मिलते रहें। सीईएस किसी भी चिंता या प्रश्न के मामले में आपका व्यक्तिगत व्यक्ति है।",
        FAQ_QUE_6: "मेरी साइट को कैसे मापा जाएगा?",
        FAQ_ANS_6: "जिस स्थान का आप नवीनीकरण या निर्माण करना चाहते हैं उसे साइट कहा जाता है। पूरे क्षेत्र के आयाम और माप जानने के लिए, आप अपने स्थान की मंजिल योजना हमारे साथ साझा कर सकते हैं। यदि फ्लोर प्लान उपलब्ध नहीं है, तो हम डिजाइनिंग चरण से शुरू करने के लिए आवश्यक माप लेने के लिए अपने प्रतिनिधि को भेजेंगे।",
        FAQ_QUE_7: "मेरे प्रोजेक्ट के पूरा होने की समय-सीमा क्या होगी?",
        FAQ_ANS_7: "शीर्ष इंटीरियर डिजाइन फर्मों में से एक होने के नाते, एसबी विश्वकर्मा अपने ग्राहकों को एक मूव-इन गारंटी प्रदान करता है जो आपको आश्वासन देता है कि सभी मॉड्यूलर समाधान 60 दिनों की अवधि के भीतर स्थापित किए जाएंगे। आपके घर के पूरे इंटीरियर को पूरा करने के लिए, हमें आपके इंटीरियर डिज़ाइन प्रोजेक्ट को पूरा करने में लगभग 90 दिन लगते हैं। हालाँकि, पूर्णता समय-सीमा परियोजना-दर-परियोजना में भिन्न हो सकती है। सामग्री की उपलब्धता, वितरण, ग्राहक प्रतिक्रिया, डिजाइन अनुमोदन आदि जैसे कारक समयरेखा निर्धारित करने में महत्वपूर्ण भूमिका निभाते हैं। कृपया ध्यान दें कि गारंटी और निर्धारित डिज़ाइन समय सीमा पर शर्तें लागू हो सकती हैं।",
        FAQ_QUE_8: "क्या मुझे अपने स्वाद के अनुसार अपने घर के डिजाइन को अनुकूलित करने की अनुमति है?",
        FAQ_ANS_8: "बिल्कुल। हम आपको आपकी आवश्यकताओं के अनुरूप सर्वश्रेष्ठ-इन-क्लास व्यक्तिगत डिज़ाइन प्रदान करने पर गर्व करते हैं। आप हमारे ग्राहक अनुभव विशेषज्ञ (सीईएस) और इंटीरियर डिजाइनर के साथ परामर्श और सहयोग कर सकते हैं ताकि आपके लिए काम करने वाले डिजाइन को अंतिम रूप दिया जा सके।",
        FAQ_QUE_9: "क्या मैं अपने घर के अलग-अलग कमरों के लिए अलग-अलग थीम चुन सकता हूं?",
        FAQ_ANS_9: "निश्चित रूप से! आप हर डिजाइन निर्णय में शामिल होंगे जो कि लिया जाता है। ग्राहक अनुभव विशेषज्ञ (सीईएस) और इंटीरियर डिजाइनर आपकी राय पर विचार करेंगे और उसे शामिल करेंगे और डिजाइनिंग चरण के सभी चरणों में आपकी स्वीकृति मांगेंगे।  अंतिम डिज़ाइन आपके स्वाद और लोकप्रिय रुझानों पर आधारित होगा।",
        FAQ_QUE_10: "मैं अपनी आवश्यकताओं के बारे में बताने के लिए इंटीरियर डिजाइनर से कब मिल सकता हूं?",
        FAQ_ANS_10: "हमारी ग्राहक अनुभव विशेषज्ञ (सीईएस) आपकी आवश्यकताओं को समझने और घर की योजना प्राप्त करने के लिए पहले आपसे संपर्क करने वाला व्यक्ति होगा। वह आपको प्रक्रिया के बारे में विस्तार से बताएंगे और आपकी जरूरतों और आपकी शैली को समझेंगे। वह किसी भी संदेह और चिंताओं को भी स्पष्ट करेंगे।  दूसरी बैठक में, आपको सीईएस और हमारे इंटीरियर डिजाइनर दोनों से बात करने को मिलेगा, जो आपको प्रस्तावित डिजाइन दिखाएंगे।  आपको हमारे अत्याधुनिक 3D विज़ुअलाइज़र पर डिज़ाइन भी देखने को मिलेगा जहाँ आप परिवर्तन कर सकते हैं और उन्हें वास्तविक समय में देख सकते हैं।",
        FAQ_QUE_11: "क्या मैं इस सेवा के माध्यम से अपने फर्नीचर को कस्टम-मेड करवा सकता हूं?",
        FAQ_ANS_11: "हाँ आप कर सकते हैं। आप हमारे ग्राहक अनुभव विशेषज्ञ (सीईएस) और इंटीरियर डिजाइनर के साथ मिलकर काम कर सकते हैं ताकि आपकी आवश्यकताओं के अनुरूप फर्नीचर तैयार किया जा सके।",
        FAQ_QUE_12: "मैं अपने घर के लिए प्रस्तावित डिजाइन की कल्पना कैसे कर सकता हूं?",
        FAQ_ANS_12: "हमारे इंटीरियर डिज़ाइनर और CES के साथ विस्तृत डिज़ाइन चर्चा के बाद, वे हमारे अत्याधुनिक 3D विज़ुअलाइज़र के उपयोग के साथ आपके घर के प्रस्तावित डिज़ाइनों को साझा करते हैं। एक बार जब आप देख लें कि आपके घर का इंटीरियर डिज़ाइन क्या है? घर जैसा दिखेगा, आप किसी भी बदलाव के बारे में और चर्चा कर सकते हैं जो आप करना चाहते हैं—और उन्हें वास्तविक समय में होते हुए देख सकते हैं। 3D विज़ुअलाइज़र में डिज़ाइन आउटपुट के साथ, आप इसे 2D में भी देख सकते हैं। . बाद में कोई भी परिवर्तन जो आपको करने की आवश्यकता है, वह आपके स्वाद और पसंद के अनुसार किया जाएगा।",
        FAQ_QUE_13: "आप कौन सी सेवाएं प्रदान करते हैं और मुझे उन्हें क्यों चुनना चाहिए?",
        FAQ_ANS_13: "हमारी सेवाओं में आपके घर के इंटीरियर डिजाइन का एंड-टू-एंड डिजाइनिंग और निष्पादन शामिल है, जिसमें फर्नीचर, फर्निशिंग, सजावटी प्रकाश व्यवस्था, डेकोर एक्सेसरीज, मॉड्यूलर किचन डिजाइन, पेंटिंग और सिविल वर्क शामिल हैं।  अपने संबंधित क्षेत्रों के विशेषज्ञ आपकी दृष्टि को क्रियान्वित करने के लिए सटीकता और डिजाइन की एक अच्छी समझ का उपयोग करते हैं। यह सुनिश्चित करता है कि आपके घर का डिज़ाइन पूरी तरह से वैयक्तिकृत है। इसके अलावा, आप पूरी तरह से डिज़ाइन प्रक्रिया में शामिल हैं; आप अपने सपनों के घर की कल्पना करने और वास्तविक समय में बदलाव करने में सक्षम बनाने के लिए हमारे विशेष 3डी विज़ुअलाइज़र के साथ परिवर्तन और अपनी इच्छा के परिवर्तन भी देख सकते हैं। जब हम आपका सुंदर घर बनाते हैं तो आपको विशेषज्ञ परियोजना प्रबंधन और पूरी तरह से पेशेवर अनुभव का भी आश्वासन दिया जा सकता है।",
        FAQ_QUE_14: "यह सेवा किन शहरों में चालू है?",
        FAQ_ANS_14: "अभी तक, हम आठ शहरों में इंटीरियर डिजाइन सेवाएं प्रदान करते हैं- हमारे स्टोर दिल्ली, मुंबई, पुणे, बेंगलुरु और हैदराबाद में हैं। यह जानने के लिए कृपया संपर्क फ़ॉर्म भरें कि क्या हम आपके क्षेत्र में काम कर रहे हैं।",
        FAQ_QUE_15: "परियोजना की पूरी अवधि के लिए मेरा संपर्क व्यक्ति कौन होगा?",
        FAQ_ANS_15: "ग्राहक अनुभव विशेषज्ञ (सीईएस) इंटीरियर डिजाइन परियोजना के शुरू से अंत तक आपका संपर्क व्यक्ति होगा। वह इस दौरान आपके किसी भी प्रश्न या चिंताओं को संबोधित करेंगे और उनका समाधान करेंगे।",
        FAQ_QUE_16: "मुझे इंटीरियर डिजाइनर की आवश्यकता क्यों है?",
        FAQ_ANS_16: "जब घर और आंतरिक सजावट के लिए इंटीरियर डिजाइन की बात आती है, तो हम जो कल्पना करते हैं वह आम तौर पर हमें प्राप्त नहीं होता है। यह वह जगह है जहां एक इंटीरियर डिजाइनर के कौशल को नियोजित करने से एक कार्यात्मक इंटीरियर और एक शानदार दिखने वाले घर में अंतर आ सकता है जो व्यावहारिक भी है। जब आप व्यापक डिजाइन समाधान चाहते हैं तो एक इंटीरियर डिजाइनर सही समाधान है, चाहे वह सौंदर्य आंतरिक सजावट के लिए तकनीकी पहलू भी हो। वे आपके स्थान के लिए आपके पास मौजूद दृष्टि का सही अनुवाद कर सकते हैं और आपको एक ऐसा घर देने के लिए इसे बढ़ा सकते हैं जो अच्छी तरह से डिज़ाइन और आरामदायक हो। एक इंटीरियर डिजाइनर की विशेषज्ञता प्राप्त करने के कई फायदे हैं- सबसे प्रमुख वह कौशल और ज्ञान है जिससे वे सुसज्जित हैं। वे डिजाइन के सभी पहलुओं के बारे में ठोस जानकारी रखते हैं, नौकरी की जरूरतों से अच्छी तरह वाकिफ हैं और घर के लिए इंटीरियर डिजाइन की व्यवहार्यता पर आपको सलाह दे सकते हैं जो आपके मन में है। रंग, सामग्री और अंतरिक्ष विन्यास पर निर्णय घर के डिजाइन के मूलभूत पहलू हैं, और जब एक व्यापक और स्पष्ट योजना तैयार करने की बात आती है, तो एक इंटीरियर डिजाइनर आपके लिए सबसे अच्छा स्रोत है। उन्हें पता चल जाएगा कि आपके अंदरूनी हिस्से अद्वितीय और विशिष्ट दिखने के लिए कौन सी रंग योजनाओं और सामग्रियों का उपयोग करना है। आपके पास अपने स्थान के लिए सर्वोत्तम विकल्प बनाने में मदद करने के लिए ज्ञान, आंख और कौशल सेट है। एक और महत्वपूर्ण कारक जिस पर विचार किया जाना चाहिए, वह यह है कि जब आंतरिक सजावट की बात आती है तो इंटीरियर डिजाइनर नवीनतम और सबसे लोकप्रिय रुझानों पर अपडेट होते हैं। इसके अलावा, वे आपको यह भी बताएंगे कि क्या आपके घर में कोई विशेष चलन अच्छा काम करेगा, आपको क्या अपनाना चाहिए और आपको क्या त्यागना चाहिए। बाजार के बारे में उनका ज्ञान भी तब काम आता है जब आंतरिक सजावट के विभिन्न पहलुओं को देखने की बात आती है। जब आपके घर के लिए अच्छी गुणवत्ता वाले फर्नीचर, साज-सज्जा, सामान और अन्य सजावट से संबंधित तत्वों को चुनने की बात आती है तो वे आपको सही दिशा में ले जाएंगे। यदि आप अपने घर के इंटीरियर डिजाइन में कोई रुचि रखते हैं तो एक अच्छा इंटीरियर डिजाइनर भी आपको कलाकृतियों की सिफारिश और मदद कर सकता है। आज इंटीरियर डिजाइन सेवाओं को काम पर रखने का एक और फायदा यह सुनिश्चित करना है कि आपका घर ऊर्जा कुशल है। जबकि आपका दिल सही जगह पर हो सकता है, यह इंटीरियर डिजाइनर है जो अच्छे इरादों को सक्रिय कार्रवाई में बदल सकता है और ऊर्जा के उपयोग को अनुकूलित कर सकता है आपकी तरफ से एक इंटीरियर डिजाइनर के साथ, आपके पास अपने घर के डिजाइन पर काम करने के लिए विश्वसनीय और भरोसेमंद कोई है, एकल सभी अलग-अलग तत्वों और लोगों से निपटने के लिए स्रोत जो खेल में आते हैं और भार और तनाव को दूर करने में मदद करते हैं।",
        FAQ_QUE_17: "मैं पेशेवर के साथ कमरे के लिए अपने विचार कैसे साझा करूं?",
        FAQ_ANS_17: "एक गृहस्वामी के रूप में जो आपके घर के इंटीरियर डिजाइन को डिजाइन या पुनर्निर्मित करना चाहता है, आपका पहला कदम सभी उपलब्ध संसाधनों को ब्राउज़ करना है। एक व्यापक घर के डिजाइन के साथ, हालांकि, अलग-अलग कमरे भी अपने आप में एक चुनौती पेश करते हैं। यह संभावना है - और एक अच्छा विचार है - इससे पहले कि एक इंटीरियर डिजाइन पेशेवर भी तस्वीर में आए, केवल आप ही जान सकते हैं कि आपको क्या पसंद है और आप अपने कमरे के इंटीरियर डिजाइन में क्या देखना चाहते हैं। यह सुनिश्चित करने के लिए कि आपके कमरे के इंटीरियर डिजाइन की आकांक्षाएं आपके द्वारा किराए पर लिए गए पेशेवर को बताई गई हैं, आपको पहले अपने स्वाद का पता लगाना चाहिए। यह सुनिश्चित करने के लिए कमरे के इंटीरियर डिजाइन पर सावधानीपूर्वक विचार करने की आवश्यकता है कि कमरा अलग है, लेकिन समग्र घर डिजाइन योजना में भी अच्छी तरह से फिट बैठता है। ऐसा करने का सबसे अच्छा तरीका अनुसंधान का एक त्वरित दौर है; आपको इस बारे में एक विचार मिलता है कि आपको क्या पसंद है, क्या चलन में है, क्या नहीं है और सबसे उपयुक्त इंटीरियर डिज़ाइन क्या होगा जो आपकी व्यक्तिगत प्राथमिकताओं को पूरी तरह से प्रतिबिंबित करेगा। और आपको अपनी पसंद को कम करने के लिए बहुत दूर देखने की जरूरत नहीं है; एसबी विश्वकर्मा इंटीरियर डिज़ाइन सर्विसेज वेबसाइट में ही घरों और रिक्त स्थान की विभिन्न शैलियों की छवियों का ढेर है जो आपको कमरे के इंटीरियर डिज़ाइन को खोजने में मदद करेगा जो आपकी संवेदनशीलता को ध्यान में रखते हुए है। छवियों के माध्यम से ब्राउज़ करते समय, ध्यान रखें कि आप उन सभी तत्वों को ध्यान से देखें जो किसी स्थान को डिजाइन करने में जाते हैं: इसमें स्वयं स्थान शामिल है - प्रत्येक कमरे का आकार, लेआउट और समग्र सौंदर्य जिसे आप चुनना चाहते हैं . फिर अन्य महत्वपूर्ण तत्व आते हैं जैसे कि वे रंग जिनका आप उपयोग करना चाहते हैं और वे सामग्री जो आपको आकर्षित करती हैं। लेकिन यह सुनिश्चित करने के लिए याद रखें कि आपकी शैली की आवश्यकताएं व्यावहारिक विचारों से संतुलित हैं। यह महत्वपूर्ण है कि कमरे का इंटीरियर डिजाइन न केवल शानदार दिखने वाला हो बल्कि कार्यात्मक भी हो। इन सभी बिंदुओं को ध्यान में रखें जब आप हमारे पृष्ठों को ब्राउज़ करते हैं तो यह पता लगाने के लिए कि आपके लिए सबसे अच्छा क्या काम करता है। जब आपने दृश्यों का चयन किया है, तो सबसे अच्छी बात यह है कि उन्हें विचारों और सुझावों के एक कोलाज में ठीक से व्यवस्थित किया जाता है-एक प्रकार का मूड बोर्ड जो आपको यह समझ सकता है कि क्या काम कर रहा है और क्या नहीं। इसलिए एक बार जब आप हमारे ग्राहक अनुभव विशेषज्ञ (सीईएस) और इंटीरियर डिजाइनर से एक कमरे के इंटीरियर डिजाइन को अंतिम रूप देने के लिए मिलते हैं, तो उन्हें आपकी प्राथमिकताओं का एक दृश्य संदर्भ मिलता है। अंतिम डिज़ाइन आपके स्वाद और लोकप्रिय रुझानों पर आधारित होगा, जबकि हमारे पेशेवर यह सुनिश्चित करेंगे कि यह बड़े घरेलू डिज़ाइन में भी फिट हो। और निश्चिंत रहें कि आपके सभी प्रश्नों और शंकाओं का समाधान हमारे सीईएस द्वारा किया जाएगा, जो यह सुनिश्चित करेगा कि वह आपकी आवश्यकताओं को समझता है और घर के डिजाइन की योजना बनाता है।",
        FAQ_QUE_18: "एसबी विश्वकर्मा आपके घर के इंटीरियर डिजाइन के लिए एकदम सही क्यों है?",
        FAQ_ANS_18: "अपने घर के इंटीरियर डिजाइन को तैयार करना या उसका नवीनीकरण करना कोई ऐसा निर्णय नहीं है जिसे हल्के में लिया जाए। इसमें बहुत सावधानीपूर्वक विचार और शोध शामिल है। इन सबसे ऊपर, इसका मतलब एक भरोसेमंद पेशेवर की तलाश करना भी है जो आपके स्वाद, घर के अंदरूनी काम करने में शामिल काम और आपकी दृष्टि को निष्पादित करने के लिए आवश्यक कौशल को समझता है। एसबी विश्वकर्मा इंटीरियर डिजाइन सर्विस में, ग्राहक अनुभव विशेषज्ञों (सीईएस) और इंटीरियर डिजाइनरों का हमारा नेटवर्क आपके लिए सही होम इंटीरियर डिजाइन को महसूस करने के लिए अच्छी तरह से सुसज्जित है। हमने यह सुनिश्चित करने के लिए एक सुनियोजित प्रक्रिया को एक साथ रखा है कि आपके घर के इंटीरियर डिजाइन का अनुभव सहज हो। हम अवधारणा और विचार से लेकर योजना और निष्पादन तक, हैंडओवर तक आपके साथ रहेंगे। हमारे विशेषज्ञों का पैनल बनाने वाले 60 से अधिक इंटीरियर डिजाइनरों के साथ, आपको आश्वस्त किया जा सकता है कि आपके घर के इंटीरियर की डिजाइनिंग सुरक्षित और कुशल हाथों में है, और अंतिम परिणाम वह होगा जो आपके परिवार के आराम के लिए सबसे उपयुक्त होगा। हमारा सीईएस पहला व्यक्ति है जिसने आपसे संपर्क किया है और आपके घर के इंटीरियर डिजाइन की आवश्यकताओं के बारे में जानकारी हासिल की है। बदले में, वह एस.बी. विश्वकर्मा में हमारे द्वारा अपनाई जाने वाली प्रक्रिया का विस्तार से वर्णन करेंगे और आपकी किसी भी चिंता और संदेह को दूर करेंगे। एक अनुवर्ती बैठक वह जगह है जहाँ आप अपने घर के अंदरूनी हिस्सों के लिए डिज़ाइन के माध्यम से देखने के लिए सौंपे गए इंटीरियर डिज़ाइनर से मिलते हैं। वह आपको प्रस्तावित डिज़ाइन दिखाने वाला भी है, जिसे आप अत्याधुनिक 3D विज़ुअलाइज़र पर भी देख सकते हैं; यह आपको परिवर्तन करने और उन्हें वास्तविक समय में देखने में सक्षम बनाता है। हमारी सेवाएं घर के अंदरूनी हिस्सों की जरूरतों को पूरा करती हैं, जिसमें एंड-टू-एंड डिजाइनिंग और आपके घर के इंटीरियर डिजाइन का निष्पादन शामिल है। इसमें फर्नीचर और साज-सामान, सजावटी प्रकाश और सजावट के सामान से लेकर मॉड्यूलर किचन डिजाइन, पेंटिंग और सिविल वर्क शामिल हैं। एस.बी.विश्वकर्मा में, हम सुनिश्चित करते हैं कि आप पूरी डिजाइन प्रक्रिया में शामिल रहें और अपने घर के परिवर्तन को देखें। हमारा सीईएस घर के इंटीरियर डिजाइन के निष्पादन के दौरान ऑनसाइट है, यह सुनिश्चित करता है कि किसी भी गड़बड़ और मुद्दों को कुशलतापूर्वक, तुरंत और कुशलता से नियंत्रित किया जाता है। आपके एकल संपर्क बिंदु के रूप में, हमारा सीईएस आपको प्रगति पर नियमित रूप से अपडेट रखेगा। आपके घर के इंटीरियर का डिज़ाइन आपके लिए उतना ही महत्वपूर्ण है जितना कि यह आपके लिए है, लेकिन यह भी उतना ही महत्वपूर्ण है कि प्रक्रिया के माध्यम से आपके आराम को सुनिश्चित करना और आपको घर का इंटीरियर डिज़ाइन देना जो पूरी तरह से आप पर है। 9 शहरों में सैकड़ों संतुष्ट ग्राहक इस बात का प्रमाण हैं कि हम आपके सपनों के घर को डिजाइन करने की जिम्मेदारी बहुत गंभीरता से लेते हैं।",
        PORTFOLIO_TV_TAG: "टीवी यूनिट",
        PORTFOLIO_BEDROOM_TAG: "शयन कक्ष",
        PORTFOLIO_BATHROOM_TAG: "बाथरूम",
        PORTFOLIO_FURNITURE_TAG: "फर्नीचर",
        PORTFOLIO_KITCHEN_TAG: "रसोईघर",
        PORTFOLIO_LIVING_SPACE_TAG: "रहने की जगह",
        PORTFOLIO_OTHERS_TAG: "अन्य",
        PORTFOLIO_ALL_TAG: "सभी",
        PORTFOLIO_ITEM_TITLE_1: "टीवी यूनिट",
        PORTFOLIO_ITEM_DESC_1: "लकड़ी की फिनिशिंग के साथ टीवी यूनिट की सजावट।",
        PORTFOLIO_ITEM_TITLE_2: "रहने की जगह",
        PORTFOLIO_ITEM_DESC_2: "रहने की जगह के लिए पूर्ण आंतरिक सजावट",
        PORTFOLIO_ITEM_TITLE_3: "रहने की जगह",
        PORTFOLIO_ITEM_DESC_3: "रहने की जगह आंतरिक सजावट",
        PORTFOLIO_ITEM_TITLE_4: "रसोई सजावट",
        PORTFOLIO_ITEM_DESC_4: "चमकदार परिष्करण के साथ रसोई की सजावट",
        PORTFOLIO_ITEM_TITLE_5: "रहने की जगह",
        PORTFOLIO_ITEM_DESC_5: "रहने की जगह की सजावट",
        PORTFOLIO_ITEM_TITLE_6: "रहने की जगह",
        PORTFOLIO_ITEM_DESC_6: "रहने की जगह की सजावट",
        PORTFOLIO_ITEM_TITLE_7: "छत की सजावट",
        PORTFOLIO_ITEM_DESC_7: "छत की सजावट",
        PORTFOLIO_ITEM_TITLE_8: "शयन कक्ष",
        PORTFOLIO_ITEM_DESC_8: "विनियर मैट फिनिश के साथ स्लीक बेडरूम डेकोरेशन।",
        PORTFOLIO_ITEM_TITLE_9: "बाथरूम",
        PORTFOLIO_ITEM_DESC_9: "स्टाइलिश बाथरूम सजावट",
        PORTFOLIO_ITEM_TITLE_10: "मॉड्यूलर किचन",
        PORTFOLIO_ITEM_DESC_10: "स्थान बचाने की सुविधाओं के साथ मॉड्यूलर किचन डिजाइन और सजावट",
        PORTFOLIO_ITEM_TITLE_11: "मॉड्यूलर किचन",
        PORTFOLIO_ITEM_DESC_11: "स्थान बचाने की सुविधाओं के साथ मॉड्यूलर किचन डिजाइन और सजावट",
        PORTFOLIO_ITEM_TITLE_12: "मेज",
        PORTFOLIO_ITEM_DESC_12: "उच्च चमकदार ग्लास परिष्करण के साथ तालिका",
        PORTFOLIO_ITEM_TITLE_13: "बेडरूम की सजावट",
        PORTFOLIO_ITEM_DESC_13: "उच्च चमकदार परिष्करण के साथ क्लासिक बेडरूम सजावट",
        PORTFOLIO_ITEM_TITLE_14: "बेडरूम की सजावट",
        PORTFOLIO_ITEM_DESC_14: "लकड़ी के परिष्करण के साथ क्लासिक बेडरूम डिजाइन",
        PORTFOLIO_ITEM_TITLE_15: "शयन कक्ष और अलमारी",
        PORTFOLIO_ITEM_DESC_15: "दीवार रोशनी और चमकदार परिष्करण के साथ आकर्षक बेडरूम और अलमारी डिजाइन",
        PORTFOLIO_ITEM_TITLE_16: "शयन कक्ष और अलमारी",
        PORTFOLIO_ITEM_DESC_16: "क्लासिक बेडरूम डिजाइन",
        PORTFOLIO_ITEM_TITLE_17: "शयन कक्ष",
        PORTFOLIO_ITEM_DESC_17: "विनियर मैट फ़िनिशिंग के साथ स्लीक बेडरूम डिज़ाइन और सजावट",
        PORTFOLIO_ITEM_TITLE_18: "बाथरूम",
        PORTFOLIO_ITEM_DESC_18: "बाथरूम डिजाइन और सजावट",
        PORTFOLIO_ITEM_TITLE_19: "बाथरूम",
        PORTFOLIO_ITEM_DESC_19: "बाथरूम डिजाइन और सजावट",
        PORTFOLIO_ITEM_TITLE_20: "भंडारण इकाई",
        PORTFOLIO_ITEM_DESC_20: "भंडारण इकाई डिजाइन",
        PORTFOLIO_ITEM_TITLE_21: "टीवी यूनिट",
        PORTFOLIO_ITEM_DESC_21: "मैट फ़िनिशिंग के साथ लग्ज़री टीवी यूनिट",
        PORTFOLIO_ITEM_TITLE_22: "बाथरूम",
        PORTFOLIO_ITEM_DESC_22: "बाथरूम डिजाइन",
        PORTFOLIO_ITEM_TITLE_23: "छत",
        PORTFOLIO_ITEM_DESC_23: "छत डिजाइन",
        PORTFOLIO_ITEM_TITLE_24: "",
        PORTFOLIO_ITEM_DESC_24: "संपूर्ण केबिन डिजाइन और सजावट का दृश्य",
        PORTFOLIO_ITEM_TITLE_25: "शयन कक्ष सजावट",
        PORTFOLIO_ITEM_DESC_25: "उच्च चमकदार फिनिश के साथ बेडरूम की सजावट",
        PORTFOLIO_ITEM_TITLE_26: "बाथरूम",
        PORTFOLIO_ITEM_DESC_26: "बेडरूम की सजावट",
        PORTFOLIO_ITEM_TITLE_27: "शयन कक्ष",
        PORTFOLIO_ITEM_DESC_27: "बेडरूम की पूरी डिजाइन और सजावट का दृश्य",
        PORTFOLIO_ITEM_TITLE_28: "रहने की जगह",
        PORTFOLIO_ITEM_DESC_28: "रहने की जगह डिजाइन और सजावट",
        PORTFOLIO_ITEM_TITLE_29: "टीवी यूनिट",
        PORTFOLIO_ITEM_DESC_29: "मैट मैटेलिक फिनिश के साथ रॉयल टीवी यूनिट",
        PORTFOLIO_ITEM_TITLE_30: "भंडारण इकाई",
        PORTFOLIO_ITEM_DESC_30: "भंडारण कैबिनेट डिजाइन",
        PORTFOLIO_ITEM_TITLE_31: "कैबिनेट टेबल",
        PORTFOLIO_ITEM_DESC_31: "हाई ग्लॉसी ग्लास फिनिश के साथ ऑफिस केबिन टेबल",
        PORTFOLIO_ITEM_TITLE_32: "कैबिनेट टेबल",
        PORTFOLIO_ITEM_DESC_32: "हाई ग्लॉसी ग्लास फिनिश के साथ ऑफिस केबिन टेबल",
        PORTFOLIO_ITEM_TITLE_33: "मीटिंग टेबल",
        PORTFOLIO_ITEM_DESC_33: "रंगीन ग्लास फिनिश के साथ मीटिंग टेबल",
        PORTFOLIO_ITEM_TITLE_34: "कार्यालय सजावट",
        PORTFOLIO_ITEM_DESC_34: "कार्यालय डिजाइन और सजावट",
        PORTFOLIO_ITEM_TITLE_35: "वाणिज्यिक कार्य केंद्र",
        PORTFOLIO_ITEM_DESC_35: "वाणिज्यिक कार्य स्टेशन डिजाइन और सजावट",
        PORTFOLIO_ITEM_TITLE_36: "वाणिज्यिक कार्य केंद्र",
        PORTFOLIO_ITEM_DESC_36: "मैट मैटेलिक फिनिश के साथ रॉयल टीवी यूनिट",
        WHY_US_ITEM_1: "जगह में कार्यक्षमता जोड़ता है",
        WHY_US_ITEM_DATA_1: "इंटीरियर डिज़ाइन न केवल आपके भवन के इंटीरियर को सुशोभित करता है बल्कि यह भी सुनिश्चित करता है कि यह आपके घर में कार्यक्षमता जोड़ता है। कार्यक्षमता इंटीरियर डिजाइन के प्रमुख पहलुओं में से एक है। यह महत्वपूर्ण है क्योंकि खराब तरीके से डिजाइन किए गए बड़े घर में जगह की कमी हो सकती है या यहां तक ​​कि एक छोटा सा अपार्टमेंट भी कार्यक्षमता के आदर्श उदाहरणों में से एक हो सकता है। यह कुछ नवीनतम डिजाइन सिद्धांतों और विशेष सीढ़ी या मचान जैसे तत्वों की सहायता से प्राप्त किया जा सकता है। इस प्रकार, इंटीरियर डिजाइन प्रकाश से लेकर फर्नीचर से लेकर उपकरण तक सब कुछ एक साथ काम करता है, जिससे जगह अधिक आकर्षक और आमंत्रित महसूस होती है।",
        WHY_US_ITEM_2: "रहने वाले की जीवन शैली के अनुकूल है",
        WHY_US_ITEM_DATA_2: "जब भी कोई पेशेवर घर को डिजाइन करता है तो इसे इस तरह से किया जाता है कि यह रहने वालों की जीवनशैली के अनुकूल हो। यह एक बहुत ही महत्वपूर्ण घटक है क्योंकि वास्तु घटक आपकी जीवन शैली के अनुसार बनाया गया है। इसलिए, अपने डिजाइनर के साथ बैठना महत्वपूर्ण है और वे आपको सही डिजाइन बनाने और अनुकूलित करने में मदद करते हैं जो आपको सूट करता है। उदाहरण के लिए, इंटीरियर डिजाइन में जीवनशैली समायोजन में आपके शौचालय को बाकी बाथरूम से अलग करना या अपने रहने वाले कमरे के आकार को कम करना शामिल हो सकता है ताकि आपके पास एक घर कार्यालय हो जहां आप अपना अधिक खाली समय व्यतीत करेंगे।",
        WHY_US_ITEM_3: "उच्च सौंदर्य गुणवत्ता",
        WHY_US_ITEM_DATA_3: "इंटीरियर डिजाइनर जादूगरों की तरह होते हैं जो अपनी जादू की छड़ी लहराते हैं और एक साधारण दिखने वाली जगह को किसी ऐसी चीज में बदल देते हैं जो सौंदर्य की दृष्टि से बहुत सुंदर और स्वागत योग्य हो। वे एक आश्चर्यजनक उपस्थिति प्रदान करने के लिए उपयुक्त डिजाइन, योजना, रंग, पेंट, परिवेश, बनावट, संतुलन और समरूपता से शुरू करते हैं। यह अद्वितीय सौंदर्य गुण प्रत्येक कमरे या स्थान के उद्देश्य से मेल खाएगा। इस प्रकार, आपको कमरे की उपस्थिति को बढ़ाने में मदद करता है। उदाहरण के लिए: यह शयनकक्ष को अधिक आराम का अनुभव कराने में मदद करता है जिससे आराम और अच्छी नींद आती है, जबकि गृह कार्यालय क्षेत्र रचनात्मकता और उत्पादकता को बढ़ाएगा।",
        WHY_US_ITEM_4: "लागत बचत",
        WHY_US_ITEM_DATA_4: "अच्छे इंटीरियर डिजाइन में निवेश लंबे समय में मूल्य जोड़ता है। एक इंटीरियर डिजाइनर फिक्स्चर, लाइटिंग, ड्रेप्स, पेंट, सोफा डिजाइन और कारपेटिंग के प्रकारों से अच्छी तरह वाकिफ होता है, जिसे आपको घर के विभिन्न हिस्सों में लगाना चाहिए। कई बार घर के मालिक एक पेशेवर इंटीरियर डिजाइनर को काम पर रखने की लागत को बचाने की कोशिश करते हैं और सौदेबाजी में वे यह पता लगाने में अधिक समय व्यतीत करते हैं कि क्या स्थापित करना है और इसे सही तरीके से कैसे स्थापित करना है। इसके अलावा, एक अच्छा इंटीरियर डिजाइनर आपको सर्वोत्तम सामग्री, फिटिंग और फर्नीचर चुनने में मदद करके आपकी लागत बचाने में मदद करेगा, जिसे आप अपने वर्तमान बजट के साथ खर्च कर सकते हैं। यह आपके नए घर में जाने के तुरंत बाद महंगे नवीनीकरण और रीमॉडेलिंग से बचने में आपकी मदद करेगा।",
        WHY_US_ITEM_5: "सुरक्षा उद्देश्यों के लिए",
        WHY_US_ITEM_DATA_5: "घर को डिजाइन करते समय सुरक्षा सबसे महत्वपूर्ण बातों में से एक है। यह महत्वपूर्ण है क्योंकि आवश्यक सुरक्षा आवश्यकताओं की कमी से बच्चों को चोट लग सकती है, खासकर जब वे अकेले हों और घर में खतरनाक और नाजुक उपकरणों के आसपास खेल रहे हों। उचित सुरक्षा उपायों के साथ एक उचित रूप से डिज़ाइन किया गया घर यह सुनिश्चित करता है कि सभी आंतरिक उपकरण आवश्यक सुरक्षित स्थान पर रखे गए हैं और खतरनाक जगह बच्चों की पहुंच से बाहर हैं। इसके अलावा, एक उचित रूप से डिज़ाइन किए गए घर में बिजली के तारों को ठीक से रखा गया है और अच्छी तरह से इन्सुलेट किया गया है, इस प्रकार बच्चों और किसी भी आगंतुक के लिए सुरक्षित है।",
        WHY_US_ITEM_6: "अच्छा इंटीरियर डिज़ाइन बनाए रखना आसान है",
        WHY_US_ITEM_DATA_6: "सिर्फ एक सुंदर घर डिजाइन करना ही काफी नहीं है; सुंदरता को लंबे समय तक बनाए रखने के लिए आपको आवश्यक उपाय भी अपनाने होंगे। इसके अलावा, हर घर को नियमित रखरखाव की आवश्यकता होती है। एक उचित ढंग से डिज़ाइन किया गया इंटीरियर लंबे समय में घर के आसान रखरखाव को सुनिश्चित करने में मदद करता है। इसके अलावा, जब डिजाइन अच्छा होता है, तो नुकसान बहुत कम होता है क्योंकि दुर्घटनाएं होने की संभावना नहीं होती है जिससे नाजुक फर्नीचर और किसी भी अन्य उपकरण को नुकसान होता है।",
        WHY_US_ITEM_7: "एक अच्छा डिज़ाइन पर्याप्त स्थान की सुविधा प्रदान करेगा",
        WHY_US_ITEM_DATA_7: "जब आप एक अच्छी तरह से डिज़ाइन किए गए घर के बारे में बात करते हैं तो यह अंतरिक्ष के बेहतर अनुकूलन के साथ-साथ घर में कुछ मात्रा में खुली जगह की सुविधा की मांग करता है। एक उचित ढंग से डिजाइन किया गया घर बेहतर जगह के लिए प्रावधान करेगा, खासकर जब रहने वाले कमरे की बात आती है। कॉरिडोर अंतरिक्ष को उससे बड़ा महसूस कराने में भी मदद करेंगे। यह अनावश्यक भीड़भाड़ के पहलू को खत्म कर देगा जो खराब डिजाइन वाले घरों में आम है।",
        WHY_US_ITEM_8: "ठीक से डिज़ाइन किया गया घर पुनर्विक्रय मूल्य बढ़ाता है",
        WHY_US_ITEM_DATA_8: "यदि आप अपना घर बेचना चाहते हैं, तो उचित डिजाइन आपके घर के मूल्य को बढ़ाने में मदद करेगा। अधिकांश खरीदार एक अच्छी तरह से डिज़ाइन किया गया घर खरीदना चाहते हैं, जिस पर उन्हें अधिक समय और प्रयास खर्च न करना पड़े, खासकर किराये के मामले में। यदि डिजाइन खराब है, तो वे उस विशेष घर के लिए कम भुगतान करेंगे।",
        WHY_US_ITEM_9: "अच्छा इंटीरियर डिजाइन घर और लोगों के मूड को प्रभावित करता है",
        WHY_US_ITEM_DATA_9: "यह बहुत सही है क्योंकि आप वही हैं जो अपनी पसंद के अनुसार डिजाइन चुन रहे हैं। खासतौर पर आपके घर का रंग घर के मूड को प्रभावित करने में बहुत अहम भूमिका निभाता है। अगर घर के अंदरूनी हिस्सों को आपके पसंदीदा रंग से डिजाइन किया गया है तो आपको उस घर में रहना अच्छा लगेगा। इसके अलावा, आंतरिक भागों के एक उचित डिजाइन में एक प्राकृतिक प्रवाह और ताजी हवा का संचलन शामिल होगा। इससे आप घर में रहते हुए सहज महसूस करेंगे। दुर्गंध और यहां तक कि दम घुटने की भी संभावना रहेगी। इसलिए, आपके घर में उस सुंदर और सुखद एहसास के लिए, आंतरिक भागों को ठीक से डिजाइन किया जाना चाहिए।",
        WHY_US_ITEM_10: "अच्छा इंटीरियर डिज़ाइन आपके घर में उस सुंदर और सुखद एहसास के लिए एक बेहतरीन पहली छाप बनाता है, आंतरिक भागों को ठीक से डिज़ाइन किया जाना चाहिए।",
        WHY_US_ITEM_DATA_10: "अच्छा इंटीरियर डिज़ाइन न केवल आपको खुश और संतुष्ट महसूस कराता है बल्कि यह कुछ ऐसा भी है जो आपके आगंतुकों को प्रभावित कर सकता है। इंटीरियर डिजाइन आपके घर को उस रूप में विकसित करने में मदद करता है जो विशेष रूप से आपकी विशिष्ट सौंदर्य प्रशंसा को संतुष्ट करता है। आपका होना महत्वपूर्ण है, और अपने घर को डिजाइन करना मजेदार होना चाहिए। चाहे वह आपकी रसोई का डिज़ाइन हो, आपकी चिमनी का घेरा हो, या आपके बाथरूम के निर्माण की अंतरंगता हो, आपके घर को आपके व्यक्तिगत स्पर्श को प्रतिबिंबित करने के लिए आपका स्वाद जोड़ा जाता है।",
        WHY_US_ITEM_11: "रंग असंख्य उद्देश्यों की पूर्ति करते हैं",
        WHY_US_ITEM_DATA_11: "इंटीरियर डिजाइनिंग के महत्वपूर्ण घटकों में से एक विशिष्ट कमरों के लिए रंगों का सावधानीपूर्वक चयन करना है। अगर सही तरीके से किया जाए तो रंग घर के निवासियों के मूड को बढ़ाने में मदद करते हैं। इसके अलावा, यह किसी भी कमरे के लिए कला और नाटक के लिए एक उत्कृष्ट पृष्ठभूमि के रूप में भी कार्य करता है।",
        WHY_US_ITEM_12: "वृद्ध सदस्यों को आसानी से कमरों तक पहुंचने में सक्षम बनाता है",
        WHY_US_ITEM_DATA_12: "यदि आपके घर में बीमार, शारीरिक रूप से विकलांग या वृद्ध सदस्य हैं, तो यह इस बात पर निर्भर करता है कि आप घर को कैसे डिजाइन करते हैं, यह उनकी स्थिति को कम कर सकता है या बढ़ा सकता है। ध्यान रखने वाली सबसे बुनियादी चीजों में से एक जगह को इस तरह से डिजाइन करना है कि वे किसी भी प्रकार की अतिरिक्त सहायता या सहायता की आवश्यकता के बिना घर में आसानी से घूम सकें। इस संबंध में, वे अपनी गरिमा बनाए रखने में सक्षम होंगे क्योंकि वे अपनी और अपनी दैनिक जरूरतों की देखभाल करने में कम सक्षम हो जाएंगे। इसके अलावा, यह उन्हें यह भी महसूस कराएगा कि वे बोझ न बनकर चीजों को आसान बना रहे हैं।",
        WHY_US_ITEM_13: "अपने घर को स्वर्ग बना देता है",
        WHY_US_ITEM_DATA_13: "आज के दिन और उम्र में, हम सभी के पास व्यस्त कार्यक्रम हैं जिसके लिए हमें दिन के अंत में वापस बैठना, आराम करना और आराम करना पड़ता है। इस संबंध में, आपका घर विश्राम और आराम के स्वर्ग के रूप में काम करता है जहाँ आप बस हो सकते हैं। इस प्रकार, अच्छा इंटीरियर डिज़ाइन आपके घर को एक स्वर्गीय निवास में बदलने में मदद करता है।",
        WHY_US_ITEM_14: "घर वापसी के रूप में कार्य",
        WHY_US_ITEM_DATA_14: "आपके घर को न केवल कार्यक्षमता को अधिकतम करना चाहिए बल्कि वापस बैठने और आनंद लेने के लिए एक वापसी के रूप में भी कार्य करना चाहिए। अच्छा इंटीरियर डिज़ाइन आपको एक ऐसा घर बनाने में मदद करता है जिसके माध्यम से आप पॉश और लंबी छुट्टियों के लिए लंबे समय तक नहीं रहेंगे। इस संबंध में, आपका घर कुछ ऐसा होना चाहिए जो जीवन की हलचल से पीछे हटने जैसा महसूस हो। इसके अतिरिक्त, यह आपके और आपके परिवार के लिए एक दूसरे के साथ फिर से जुड़ने का एक अवसर भी होना चाहिए।",
        WHY_US_ITEM_15: "शैलियों को सही तरीके से संयोजित करना",
        WHY_US_ITEM_DATA_15: "एक अच्छा अनुभव इंटीरियर डिजाइनर समकालीन, आधुनिक, क्लासिक, इंडो-वेस्टर्न, वेस्टर्न और कई अन्य सजाने वाली शैलियों को एक सही तरीके से एक फ्यूजन बनाने में मदद करता है जो एक तरह का, सुंदर और पूरी तरह से मेल खाता है जरूरतें और अपेक्षाएं। तो अपने सबसे प्रशंसित पुराने इंटीरियर मास्टरपीस और फर्नीचर को क्लब करना अब कोई परेशानी नहीं होगी। वास्तव में, उन्हें ध्यान केंद्रित करने के लिए सबसे उपयुक्त स्थान मिलेगा।",
        WHY_US_ITEM_16: "व्यस्त व्यक्तियों के लिए सबसे अच्छा विकल्प",
        WHY_US_ITEM_DATA_16: "यदि आप काम कर रहे हैं और आपके पास समर्पित करने के लिए कम समय है तो एक पेशेवर इंटीरियर डिजाइनर को काम पर रखना सबसे अच्छे विकल्पों में से एक है। इस मामले में, एक इंटीरियर डिजाइनर एक बेहतर पैसा बचाने वाला, समय बचाने वाला और स्ट्रेस बस्टर विकल्प है।",
        WHY_US_ITEM_17: "निष्कर्ष",
        WHY_US_ITEM_DATA_17: "आपका घर आपका अपना स्थान है। यदि आप अपने काउंटरटॉप्स को बदलना चाहते हैं, तो आप वहां कुछ भी रख सकते हैं जो आपको सौंदर्यपूर्ण रूप से प्रसन्न करता है। आप रंग के बारे में अपने विचारों का मूल्यांकन करते हैं, स्थान क्या है, आप क्षेत्र को कैसे रोशन करना चाहते हैं, और उन सभी सामानों का मूल्यांकन करते हैं जिन्हें आप सीधे अपने स्टीरियो या टेलीविजन जैसी चीजों में जोड़ना चाहते हैं। अंत में, यह आपकी सुंदरता की सराहना और आप अपने क्षेत्र में क्या बनाना चाहते हैं, इसके बारे में है जो आपको खुश करता है।",

    },
    EN: {


        STATE_RJ_CITY_0: "Abhaneri",
        STATE_AS_CITY_1: "Abhayapuri",
        STATE_TN_CITY_2: "Abiramam",
        STATE_PB_CITY_3: "Abohar",
        STATE_GJ_CITY_4: "Abrama",
        STATE_RJ_CITY_5: "Abu",
        STATE_RJ_CITY_6: "Abu Road",
        STATE_MH_CITY_7: "Achalpur",
        STATE_UP_CITY_8: "Achhnera",
        STATE_GJ_CITY_9: "Adalaj",
        STATE_PB_CITY_10: "Adampur",
        STATE_MH_CITY_11: "Adawad",
        STATE_AP_CITY_12: "Addanki",
        STATE_TG_CITY_13: "Adilabad",
        STATE_TN_CITY_14: "Adirampattinam",
        STATE_AP_CITY_15: "Adoni",
        STATE_KL_CITY_16: "Adur",
        STATE_TN_CITY_17: "Aduthurai",
        STATE_UP_CITY_18: "Afzalgarh",
        STATE_KA_CITY_19: "Afzalpur",
        STATE_MP_CITY_20: "Agar",
        STATE_MH_CITY_21: "Agar Panchaitan",
        STATE_TR_CITY_22: "Agartala",
        STATE_GJ_CITY_23: "Agol",
        STATE_UP_CITY_24: "Agra",
        STATE_MH_CITY_25: "Aheri",
        STATE_MH_CITY_26: "Ahiri",
        STATE_MH_CITY_27: "Ahmadnagar",
        STATE_MH_CITY_28: "Ahmadpur",
        STATE_GJ_CITY_29: "Ahmedabad",
        STATE_MH_CITY_30: "Ahmednagar",
        STATE_WB_CITY_31: "Ahmedpur",
        STATE_UP_CITY_32: "Ahraura",
        STATE_GJ_CITY_33: "Ahwa",
        STATE_UP_CITY_34: "Aidalpur",
        STATE_MH_CITY_35: "Airoli",
        STATE_UP_CITY_36: "Airwa",
        STATE_WB_CITY_37: "Aistala",
        STATE_MZ_CITY_38: "Aizawl",
        STATE_MP_CITY_39: "Ajaigarh",
        STATE_PB_CITY_40: "Ajitgarh",
        STATE_KA_CITY_41: "Ajjampur",
        STATE_RJ_CITY_42: "Ajmer",
        STATE_PB_CITY_43: "Ajnala",
        STATE_MH_CITY_44: "Ajra",
        STATE_PB_CITY_45: "Akalgarh",
        STATE_MH_CITY_46: "Akalkot",
        STATE_CT_CITY_47: "Akaltara",
        STATE_AP_CITY_48: "Akasahebpet",
        STATE_UP_CITY_49: "Akbarpur",
        STATE_JK_CITY_50: "Akhnur",
        STATE_AP_CITY_51: "Akividu",
        STATE_MH_CITY_52: "Akkalkot",
        STATE_AP_CITY_53: "Akkarampalle",
        STATE_RJ_CITY_54: "Aklera",
        STATE_MH_CITY_55: "Akluj",
        STATE_WB_CITY_56: "Aknapur",
        STATE_MP_CITY_57: "Akodia",
        STATE_MH_CITY_58: "Akola",
        STATE_UP_CITY_59: "Akola",
        STATE_MH_CITY_60: "Akolner",
        STATE_MH_CITY_61: "Akot",
        STATE_MH_CITY_62: "Akrani",
        STATE_GJ_CITY_63: "Akrund",
        STATE_TN_CITY_64: "Alagapuram",
        STATE_MP_CITY_65: "Alampur",
        STATE_TG_CITY_66: "Alampur",
        STATE_KA_CITY_67: "Aland",
        STATE_MH_CITY_68: "Alandi",
        STATE_TN_CITY_69: "Alandur",
        STATE_TN_CITY_70: "Alanganallur",
        STATE_TN_CITY_71: "Alangayam",
        STATE_TN_CITY_72: "Alangudi",
        STATE_TN_CITY_73: "Alangulam",
        STATE_TN_CITY_74: "Alappakkam",
        STATE_KL_CITY_75: "Alappuzha",
        STATE_PB_CITY_76: "Alawalpur",
        STATE_GA_CITY_77: "Aldona",
        STATE_MH_CITY_78: "Ale",
        STATE_MH_CITY_79: "Alibag",
        STATE_UP_CITY_80: "Aliganj",
        STATE_UP_CITY_81: "Aligarh",
        STATE_DL_CITY_82: "Alipur",
        STATE_WB_CITY_83: "Alipurduar",
        STATE_MP_CITY_84: "Alirajpur",
        STATE_MH_CITY_85: "Alkuti",
        STATE_UP_CITY_86: "Allahabad",
        STATE_UP_CITY_87: "Allahganj",
        STATE_MH_CITY_88: "Allapalli",
        STATE_UT_CITY_89: "Almora",
        STATE_KA_CITY_90: "Alnavar",
        STATE_AR_CITY_91: "Along",
        STATE_MP_CITY_92: "Alot",
        STATE_KA_CITY_93: "Alur",
        STATE_KL_CITY_94: "Aluva",
        STATE_TN_CITY_95: "Alwa Tirunagari",
        STATE_RJ_CITY_96: "Alwar",
        STATE_KL_CITY_97: "Alwaye",
        STATE_AP_CITY_98: "Amalapuram",
        STATE_MH_CITY_99: "Amalner",
        STATE_MP_CITY_100: "Amanganj",
        STATE_UP_CITY_101: "Amanpur",
        STATE_MP_CITY_102: "Amarkantak",
        STATE_MH_CITY_103: "Amarnath",
        STATE_MP_CITY_104: "Amarpatan",
        STATE_BR_CITY_105: "Amarpur",
        STATE_TR_CITY_106: "Amarpur",
        STATE_MP_CITY_107: "Amarwara",
        STATE_UP_CITY_108: "Amauli",
        STATE_MH_CITY_109: "Ambad",
        STATE_CT_CITY_110: "Ambagarh Chauki",
        STATE_MP_CITY_111: "Ambah",
        STATE_UP_CITY_112: "Ambahta",
        STATE_MH_CITY_113: "Ambajogai",
        STATE_HR_CITY_114: "Ambala",
        STATE_MH_CITY_115: "Ambarnath",
        STATE_TR_CITY_116: "Ambasa",
        STATE_TN_CITY_117: "Ambasamudram",
        STATE_TN_CITY_118: "Ambattur",
        STATE_UP_CITY_119: "Ambedkar Nagar",
        STATE_MH_CITY_120: "Ambegaon",
        STATE_CT_CITY_121: "Ambikapur",
        STATE_TN_CITY_122: "Ambur",
        STATE_RJ_CITY_123: "Amet",
        STATE_UP_CITY_124: "Amethi",
        STATE_MH_CITY_125: "Amgaon",
        STATE_AS_CITY_126: "Amguri",
        STATE_MP_CITY_127: "Amla",
        STATE_WB_CITY_128: "Amlagora",
        STATE_DN_CITY_129: "Amli",
        STATE_PB_CITY_130: "Amloh",
        STATE_TN_CITY_131: "Ammapettai",
        STATE_GJ_CITY_132: "Amod",
        STATE_GJ_CITY_133: "Amod,",
        STATE_MH_CITY_134: "Amravati",
        STATE_MH_CITY_135: "Amravati Division",
        STATE_GJ_CITY_136: "Amreli",
        STATE_PB_CITY_137: "Amritsar",
        STATE_UP_CITY_138: "Amroha",
        STATE_GJ_CITY_139: "Amroli",
        STATE_WB_CITY_140: "Amta",
        STATE_WB_CITY_141: "Amtala",
        STATE_AP_CITY_142: "Amudalavalasa",
        STATE_AP_CITY_143: "Anakapalle",
        STATE_TN_CITY_144: "Anamalais",
        STATE_GJ_CITY_145: "Anand",
        STATE_UP_CITY_146: "Anandnagar",
        STATE_PB_CITY_147: "Anandpur Sahib",
        STATE_AP_CITY_148: "Anantapur",
        STATE_JK_CITY_149: "Anantnag",
        STATE_WB_CITY_150: "Andal",
        STATE_MH_CITY_151: "Andheri",
        STATE_TN_CITY_152: "Andippatti",
        STATE_TG_CITY_153: "Andol",
        STATE_MH_CITY_154: "Andura",
        STATE_KA_CITY_155: "Anekal",
        STATE_KL_CITY_156: "Angamali",
        STATE_OR_CITY_157: "Angul",
        STATE_OR_CITY_158: "Angul District",
        STATE_MP_CITY_159: "Anjad",
        STATE_MH_CITY_160: "Anjangaon",
        STATE_GJ_CITY_161: "Anjar",
        STATE_MH_CITY_162: "Anjarle",
        STATE_AR_CITY_163: "Anjaw",
        STATE_GJ_CITY_164: "Ankleshwar",
        STATE_KA_CITY_165: "Ankola",
        STATE_TN_CITY_166: "Annamalainagar",
        STATE_TN_CITY_167: "Annavasal",
        STATE_KA_CITY_168: "Annigeri",
        STATE_TN_CITY_169: "Annur",
        STATE_MH_CITY_170: "Anshing",
        STATE_RJ_CITY_171: "Anta",
        STATE_TN_CITY_172: "Anthiyur",
        STATE_MP_CITY_173: "Antri",
        STATE_UP_CITY_174: "Antu",
        STATE_RJ_CITY_175: "Anupgarh",
        STATE_MP_CITY_176: "Anuppur",
        STATE_UP_CITY_177: "Anupshahr",
        STATE_UP_CITY_178: "Aonla",
        STATE_MH_CITY_179: "Arag",
        STATE_TN_CITY_180: "Arakkonam",
        STATE_WB_CITY_181: "Arambagh community development block",
        STATE_GA_CITY_182: "Arambol",
        STATE_CT_CITY_183: "Arang",
        STATE_MH_CITY_184: "Arangaon",
        STATE_TN_CITY_185: "Arantangi",
        STATE_BR_CITY_186: "Araria",
        STATE_UP_CITY_187: "Araul",
        STATE_TN_CITY_188: "Arcot",
        STATE_MH_CITY_189: "Ardhapur",
        STATE_MH_CITY_190: "Argaon",
        STATE_TN_CITY_191: "Arimalam",
        STATE_TN_CITY_192: "Ariyalur",
        STATE_KA_CITY_193: "Arkalgud",
        STATE_HP_CITY_194: "Arki",
        STATE_TN_CITY_195: "Arni",
        STATE_MP_CITY_196: "Aron",
        STATE_KL_CITY_197: "Aroor",
        STATE_BR_CITY_198: "Arrah",
        STATE_KA_CITY_199: "Arsikere",
        STATE_MH_CITY_200: "Artist Village",
        STATE_KL_CITY_201: "Arukutti",
        STATE_TN_CITY_202: "Arumbavur",
        STATE_TN_CITY_203: "Arumuganeri",
        STATE_TN_CITY_204: "Aruppukkottai",
        STATE_TN_CITY_205: "Aruvankad",
        STATE_MH_CITY_206: "Arvi",
        STATE_BR_CITY_207: "Arwal",
        STATE_UP_CITY_208: "Asalatganj",
        STATE_HR_CITY_209: "Asandh",
        STATE_WB_CITY_210: "Asansol",
        STATE_BR_CITY_211: "Asarganj",
        STATE_MP_CITY_212: "Ashoknagar",
        STATE_WB_CITY_213: "Ashoknagar Kalyangarh",
        STATE_MH_CITY_214: "Ashta",
        STATE_MP_CITY_215: "Ashta",
        STATE_MH_CITY_216: "Ashti",
        STATE_TG_CITY_217: "Asifabad",
        STATE_OR_CITY_218: "Asika",
        STATE_RJ_CITY_219: "Asind",
        STATE_MH_CITY_220: "Asoda",
        STATE_MH_CITY_221: "Assaye",
        STATE_MH_CITY_222: "Astagaon",
        STATE_UP_CITY_223: "Atarra",
        STATE_HR_CITY_224: "Ateli Mandi",
        STATE_OR_CITY_225: "Athagarh",
        STATE_KA_CITY_226: "Athni",
        STATE_AP_CITY_227: "Atmakur",
        STATE_UP_CITY_228: "Atrauli",
        STATE_UP_CITY_229: "Atraulia",
        STATE_TN_CITY_230: "Attayyampatti",
        STATE_AP_CITY_231: "Attili",
        STATE_KL_CITY_232: "Attingal",
        STATE_TN_CITY_233: "Attur",
        STATE_MH_CITY_234: "Aundh, Satara",
        STATE_KA_CITY_235: "Aurad",
        STATE_UP_CITY_236: "Auraiya",
        STATE_MH_CITY_237: "Aurangabad",
        STATE_BR_CITY_238: "Aurangabad",
        STATE_UP_CITY_239: "Auras",
        STATE_TN_CITY_240: "Auroville",
        STATE_MH_CITY_241: "Ausa",
        STATE_TN_CITY_242: "Avadi",
        STATE_AP_CITY_243: "Avanigadda",
        STATE_KL_CITY_244: "Avanoor",
        STATE_TN_CITY_245: "Avinashi",
        STATE_JK_CITY_246: "Awantipur",
        STATE_TN_CITY_247: "Ayakudi",
        STATE_UP_CITY_248: "Ayodhya",
        STATE_TN_CITY_249: "Ayyampettai",
        STATE_UP_CITY_250: "Azamgarh",
        STATE_KL_CITY_251: "Azhikkal",
        STATE_UP_CITY_252: "Azizpur",
        STATE_MP_CITY_253: "Babai",
        STATE_UP_CITY_254: "Baberu",
        STATE_UP_CITY_255: "Babina",
        STATE_GJ_CITY_256: "Babra",
        STATE_UP_CITY_257: "Babrala",
        STATE_UP_CITY_258: "Babugarh",
        STATE_UP_CITY_259: "Bachhraon",
        STATE_UP_CITY_260: "Bachhrawan",
        STATE_OR_CITY_261: "Bada Barabil",
        STATE_KL_CITY_262: "Badagara",
        STATE_KA_CITY_263: "Badami",
        STATE_AS_CITY_264: "Badarpur",
        STATE_MP_CITY_265: "Badarwas",
        STATE_HP_CITY_266: "Baddi",
        STATE_JK_CITY_267: "Badgam",
        STATE_PB_CITY_268: "Badhni Kalan",
        STATE_WB_CITY_269: "Badkulla",
        STATE_MH_CITY_270: "Badlapur",
        STATE_MH_CITY_271: "Badnapur",
        STATE_MP_CITY_272: "Badnawar",
        STATE_MH_CITY_273: "Badnera",
        STATE_WB_CITY_274: "Baduria",
        STATE_AP_CITY_275: "Badvel",
        STATE_MP_CITY_276: "Bag",
        STATE_GA_CITY_277: "Baga",
        STATE_BR_CITY_278: "Bagaha",
        STATE_KA_CITY_279: "Bagalkot",
        STATE_RJ_CITY_280: "Bagar",
        STATE_GJ_CITY_281: "Bagasara",
        STATE_GJ_CITY_282: "Bagasra",
        STATE_WB_CITY_283: "Bagdogra",
        STATE_KA_CITY_284: "Bagepalli",
        STATE_UT_CITY_285: "Bageshwar",
        STATE_MH_CITY_286: "Bagewadi",
        STATE_PB_CITY_287: "Bagha Purana",
        STATE_UP_CITY_288: "Baghpat",
        STATE_UP_CITY_289: "Baghra",
        STATE_MP_CITY_290: "Bagli",
        STATE_WB_CITY_291: "Bagnan",
        STATE_JH_CITY_292: "Bagra",
        STATE_WB_CITY_293: "Bagula",
        STATE_UP_CITY_294: "Bah",
        STATE_BR_CITY_295: "Bahadurganj",
        STATE_HR_CITY_296: "Bahadurgarh",
        STATE_UP_CITY_297: "Baheri",
        STATE_UP_CITY_298: "Bahjoi",
        STATE_UP_CITY_299: "Bahraich",
        STATE_UP_CITY_300: "Bahraigh",
        STATE_UP_CITY_301: "Bahsuma",
        STATE_UP_CITY_302: "Bahua",
        STATE_WB_CITY_303: "Bahula",
        STATE_WB_CITY_304: "Baidyabati",
        STATE_MP_CITY_305: "Baihar",
        STATE_CT_CITY_306: "Baikunthpur",
        STATE_MP_CITY_307: "Baikunthpur",
        STATE_KA_CITY_308: "Bail-Hongal",
        STATE_BR_CITY_309: "Bairagnia",
        STATE_BR_CITY_310: "Baisi",
        STATE_UP_CITY_311: "Bajna",
        STATE_RJ_CITY_312: "Bakani",
        STATE_UP_CITY_313: "Bakewar",
        STATE_GJ_CITY_314: "Bakharla",
        STATE_BR_CITY_315: "Bakhtiyarpur",
        STATE_PB_CITY_316: "Bakloh",
        STATE_WB_CITY_317: "Bakreswar",
        STATE_AS_CITY_318: "Baksa",
        STATE_UP_CITY_319: "Baksar",
        STATE_MP_CITY_320: "Bakshwaho",
        STATE_PB_CITY_321: "Balachor",
        STATE_GJ_CITY_322: "Balagam",
        STATE_MP_CITY_323: "Balaghat",
        STATE_UP_CITY_324: "Balamau",
        STATE_OR_CITY_325: "Balangir",
        STATE_TG_CITY_326: "Balapur",
        STATE_MH_CITY_327: "Balapur",
        STATE_MH_CITY_328: "Balapur, Akola district",
        STATE_WB_CITY_329: "Balarampur",
        STATE_GJ_CITY_330: "Balasinor",
        STATE_OR_CITY_331: "Balasore",
        STATE_UP_CITY_332: "Baldeo",
        STATE_MP_CITY_333: "Baldeogarh",
        STATE_UP_CITY_334: "Baldev",
        STATE_OR_CITY_335: "Baleshwar",
        STATE_RJ_CITY_336: "Bali",
        STATE_WB_CITY_337: "Bali Chak",
        STATE_OR_CITY_338: "Balimila",
        STATE_GJ_CITY_339: "Balisana",
        STATE_MH_CITY_340: "Ballalpur",
        STATE_MH_CITY_341: "Ballard Estate",
        STATE_KA_CITY_342: "Ballari",
        STATE_MH_CITY_343: "Ballarpur",
        STATE_UP_CITY_344: "Ballia",
        STATE_WB_CITY_345: "Bally",
        STATE_CT_CITY_346: "Balod",
        STATE_CT_CITY_347: "Baloda",
        STATE_CT_CITY_348: "Baloda Bazar",
        STATE_RJ_CITY_349: "Balotra",
        STATE_UP_CITY_350: "Balrampur",
        STATE_OR_CITY_351: "Balugaon",
        STATE_WB_CITY_352: "Balurghat",
        STATE_GJ_CITY_353: "Bamanbore",
        STATE_WB_CITY_354: "Bamangola community development block",
        STATE_GA_CITY_355: "Bambolim",
        STATE_AN_CITY_356: "Bamboo Flat",
        STATE_MP_CITY_357: "Bamna",
        STATE_MP_CITY_358: "Bamor Kalan",
        STATE_MP_CITY_359: "Bamora",
        STATE_OR_CITY_360: "Banapur",
        STATE_GJ_CITY_361: "Banas Kantha",
        STATE_UP_CITY_362: "Banat",
        STATE_KA_CITY_363: "Banavar",
        STATE_UP_CITY_364: "Banbasa",
        STATE_MP_CITY_365: "Banda",
        STATE_UP_CITY_366: "Banda",
        STATE_MH_CITY_367: "Banda, Maharashtra",
        STATE_GJ_CITY_368: "Bandia",
        STATE_RJ_CITY_369: "Bandikui",
        STATE_JK_CITY_370: "Bandipore",
        STATE_JK_CITY_371: "Bandipura",
        STATE_GA_CITY_372: "Bandora",
        STATE_MH_CITY_373: "Bandra",
        STATE_MH_CITY_374: "Baner",
        STATE_WB_CITY_375: "Baneswar",
        STATE_PB_CITY_376: "Banga",
        STATE_KA_CITY_377: "Bangalore Rural",
        STATE_KA_CITY_378: "Bangalore Urban",
        STATE_AP_CITY_379: "Banganapalle",
        STATE_BR_CITY_380: "Bangaon",
        STATE_WB_CITY_381: "Bangaon",
        STATE_KA_CITY_382: "Bangarapet",
        STATE_UP_CITY_383: "Bangarmau",
        STATE_JK_CITY_384: "Banihal",
        STATE_HP_CITY_385: "Banjar",
        STATE_BR_CITY_386: "Banka",
        STATE_OR_CITY_387: "Banki",
        STATE_MH_CITY_388: "Bankot",
        STATE_WB_CITY_389: "Bankra",
        STATE_WB_CITY_390: "Bankura",
        STATE_BR_CITY_391: "Banmankhi",
        STATE_KA_CITY_392: "Bannur",
        STATE_OR_CITY_393: "Banposh",
        STATE_WB_CITY_394: "Bansberia",
        STATE_UP_CITY_395: "Bansdih",
        STATE_UP_CITY_396: "Bansgaon",
        STATE_UP_CITY_397: "Bansi",
        STATE_WB_CITY_398: "Bansihari community development block",
        STATE_TG_CITY_399: "Banswada",
        STATE_RJ_CITY_400: "Banswara",
        STATE_UP_CITY_401: "Banthra",
        STATE_GJ_CITY_402: "Bantva",
        STATE_KA_CITY_403: "Bantval",
        STATE_PB_CITY_404: "Banur",
        STATE_AP_CITY_405: "Bapatla",
        STATE_BR_CITY_406: "Bar Bigha",
        STATE_UP_CITY_407: "Bara Banki",
        STATE_HR_CITY_408: "Bara Uchana",
        STATE_WB_CITY_409: "Barabazar",
        STATE_UP_CITY_410: "Baragaon",
        STATE_OR_CITY_411: "Baragarh",
        STATE_MH_CITY_412: "Baramati",
        STATE_JK_CITY_413: "Baramula",
        STATE_RJ_CITY_414: "Baran",
        STATE_WB_CITY_415: "Baranagar",
        STATE_WB_CITY_416: "Barasat",
        STATE_BR_CITY_417: "Barauli",
        STATE_UP_CITY_418: "Baraut",
        STATE_OR_CITY_419: "Barbil",
        STATE_WB_CITY_420: "Bardhaman",
        STATE_GJ_CITY_421: "Bardoli",
        STATE_UP_CITY_422: "Bareilly",
        STATE_MP_CITY_423: "Barela",
        STATE_OR_CITY_424: "Bargarh",
        STATE_MP_CITY_425: "Barghat",
        STATE_MP_CITY_426: "Bargi",
        STATE_BR_CITY_427: "Barh",
        STATE_UP_CITY_428: "Barhalganj",
        STATE_MP_CITY_429: "Barhi",
        STATE_BR_CITY_430: "Barhiya",
        STATE_RJ_CITY_431: "Bari",
        STATE_RJ_CITY_432: "Bari Sadri",
        STATE_BR_CITY_433: "Bariarpur",
        STATE_TR_CITY_434: "Barjala",
        STATE_WB_CITY_435: "Barjora",
        STATE_JH_CITY_436: "Barka Kana",
        STATE_UP_CITY_437: "Barkhera",
        STATE_UP_CITY_438: "Barkhera Kalan",
        STATE_JH_CITY_439: "Barki Saria",
        STATE_UT_CITY_440: "Barkot",
        STATE_RJ_CITY_441: "Barmer",
        STATE_PB_CITY_442: "Barnala",
        STATE_UP_CITY_443: "Barokhar",
        STATE_OR_CITY_444: "Barpali",
        STATE_AS_CITY_445: "Barpathar",
        STATE_AS_CITY_446: "Barpeta",
        STATE_AS_CITY_447: "Barpeta Road",
        STATE_WB_CITY_448: "Barrackpore",
        STATE_UP_CITY_449: "Barsana",
        STATE_MH_CITY_450: "Barsi",
        STATE_WB_CITY_451: "Baruipur",
        STATE_BR_CITY_452: "Baruni",
        STATE_JH_CITY_453: "Barwadih",
        STATE_HR_CITY_454: "Barwala",
        STATE_MP_CITY_455: "Barwani",
        STATE_UP_CITY_456: "Barwar (Lakhimpur Kheri)",
        STATE_WB_CITY_457: "Basanti",
        STATE_AR_CITY_458: "Basar",
        STATE_KA_CITY_459: "Basavakalyan",
        STATE_KA_CITY_460: "Basavana Bagevadi",
        STATE_RJ_CITY_461: "Basi",
        STATE_WB_CITY_462: "Basirhat",
        STATE_MH_CITY_463: "Basmat",
        STATE_MH_CITY_464: "Basmath",
        STATE_CT_CITY_465: "Basna",
        STATE_RJ_CITY_466: "Basni",
        STATE_MP_CITY_467: "Basoda",
        STATE_CT_CITY_468: "Bastar",
        STATE_UP_CITY_469: "Basti",
        STATE_OR_CITY_470: "Basudebpur",
        STATE_AS_CITY_471: "Basugaon",
        STATE_RJ_CITY_472: "Baswa",
        STATE_PB_CITY_473: "Batala",
        STATE_JK_CITY_474: "Batoti",
        STATE_OR_CITY_475: "Baud",
        STATE_OR_CITY_476: "Baudh",
        STATE_MH_CITY_477: "Bavdhan",
        STATE_HR_CITY_478: "Bawal",
        STATE_WB_CITY_479: "Bawali",
        STATE_DL_CITY_480: "Bawana",
        STATE_MH_CITY_481: "Bawanbir",
        STATE_RJ_CITY_482: "Bayana",
        STATE_UT_CITY_483: "Bazpur",
        STATE_RJ_CITY_484: "Beawar",
        STATE_GJ_CITY_485: "Bedi",
        STATE_MH_CITY_486: "Beed",
        STATE_MP_CITY_487: "Begamganj",
        STATE_WB_CITY_488: "Begampur",
        STATE_PB_CITY_489: "Begowal",
        STATE_RJ_CITY_490: "Begun",
        STATE_BR_CITY_491: "Begusarai",
        STATE_UP_CITY_492: "Behat",
        STATE_RJ_CITY_493: "Behror",
        STATE_UP_CITY_494: "Bela",
        STATE_OR_CITY_495: "Belaguntha",
        STATE_WB_CITY_496: "Belda",
        STATE_WB_CITY_497: "Beldanga",
        STATE_KA_CITY_498: "Belgaum",
        STATE_WB_CITY_499: "Beliatore",
        STATE_TG_CITY_500: "Bellampalli",
        STATE_KA_CITY_501: "Bellary",
        STATE_KA_CITY_502: "Belluru",
        STATE_TR_CITY_503: "Belonia",
        STATE_BR_CITY_504: "Belsand",
        STATE_KA_CITY_505: "Beltangadi",
        STATE_UP_CITY_506: "Belthara",
        STATE_TN_CITY_507: "Belur",
        STATE_KA_CITY_508: "Belur",
        STATE_CT_CITY_509: "Bemetara",
        STATE_GA_CITY_510: "Benaulim",
        STATE_KA_CITY_511: "Bengaluru",
        STATE_UP_CITY_512: "Beniganj",
        STATE_MP_CITY_513: "Beohari",
        STATE_MP_CITY_514: "Berasia",
        STATE_WB_CITY_515: "Berhampore",
        STATE_HR_CITY_516: "Beri Khas",
        STATE_UP_CITY_517: "Beswan",
        STATE_AP_CITY_518: "Betamcherla",
        STATE_MP_CITY_519: "Betma",
        STATE_BR_CITY_520: "Bettiah",
        STATE_MP_CITY_521: "Betul",
        STATE_MP_CITY_522: "Betul Bazar",
        STATE_UP_CITY_523: "Bewar",
        STATE_KL_CITY_524: "Beypore",
        STATE_MP_CITY_525: "Bhabhra",
        STATE_BR_CITY_526: "Bhabhua",
        STATE_GJ_CITY_527: "Bhachau",
        STATE_UP_CITY_528: "Bhadarsa",
        STATE_JK_CITY_529: "Bhadarwah",
        STATE_RJ_CITY_530: "Bhadasar",
        STATE_PB_CITY_531: "Bhadaur",
        STATE_MH_CITY_532: "Bhadgaon, Maharashtra",
        STATE_UP_CITY_533: "Bhadohi",
        STATE_RJ_CITY_534: "Bhadra",
        STATE_TG_CITY_535: "Bhadrachalam",
        STATE_TG_CITY_536: "Bhadradri Kothagudem",
        STATE_OR_CITY_537: "Bhadrak",
        STATE_OR_CITY_538: "Bhadrakh",
        STATE_GJ_CITY_539: "Bhadran",
        STATE_KA_CITY_540: "Bhadravati",
        STATE_WB_CITY_541: "Bhadreswar",
        STATE_BR_CITY_542: "Bhagalpur",
        STATE_BR_CITY_543: "Bhagirathpur",
        STATE_UP_CITY_544: "Bhagwantnagar",
        STATE_MP_CITY_545: "Bhainsdehi",
        STATE_TG_CITY_546: "Bhaisa",
        STATE_KA_CITY_547: "Bhalki",
        STATE_MH_CITY_548: "Bhandara",
        STATE_WB_CITY_549: "Bhandardaha",
        STATE_MH_CITY_550: "Bhandardara",
        STATE_MP_CITY_551: "Bhander",
        STATE_GJ_CITY_552: "Bhandu",
        STATE_MH_CITY_553: "Bhandup",
        STATE_OR_CITY_554: "Bhanjanagar",
        STATE_MP_CITY_555: "Bhanpura",
        STATE_CT_CITY_556: "Bhanpuri",
        STATE_GJ_CITY_557: "Bhanvad",
        STATE_RJ_CITY_558: "Bharatpur",
        STATE_UP_CITY_559: "Bharatpura",
        STATE_UP_CITY_560: "Bhargain",
        STATE_UP_CITY_561: "Bharthana",
        STATE_GJ_CITY_562: "Bharuch",
        STATE_UP_CITY_563: "Bharwari",
        STATE_RJ_CITY_564: "Bhasawar",
        STATE_CT_CITY_565: "Bhatapara",
        STATE_CT_CITY_566: "Bhatgaon",
        STATE_GJ_CITY_567: "Bhatha",
        STATE_PB_CITY_568: "Bhatinda",
        STATE_KA_CITY_569: "Bhatkal",
        STATE_WB_CITY_570: "Bhatpara",
        STATE_AP_CITY_571: "Bhattiprolu",
        STATE_UP_CITY_572: "Bhaupur",
        STATE_TN_CITY_573: "Bhavani",
        STATE_GJ_CITY_574: "Bhavnagar",
        STATE_MP_CITY_575: "Bhawaniganj",
        STATE_PB_CITY_576: "Bhawanigarh",
        STATE_OR_CITY_577: "Bhawanipatna",
        STATE_BR_CITY_578: "Bhawanipur",
        STATE_MH_CITY_579: "Bhayandar",
        STATE_GJ_CITY_580: "Bhayavadar",
        STATE_MH_CITY_581: "Bhigvan",
        STATE_MP_CITY_582: "Bhikangaon",
        STATE_PB_CITY_583: "Bhikhi",
        STATE_CT_CITY_584: "Bhilai",
        STATE_GJ_CITY_585: "Bhildi",
        STATE_RJ_CITY_586: "Bhilwara",
        STATE_UT_CITY_587: "Bhim Tal",
        STATE_AP_CITY_588: "Bhimavaram",
        STATE_UP_CITY_589: "Bhimtal",
        STATE_AP_CITY_590: "Bhimunipatnam",
        STATE_MP_CITY_591: "Bhind",
        STATE_RJ_CITY_592: "Bhindar",
        STATE_UP_CITY_593: "Bhinga",
        STATE_RJ_CITY_594: "Bhinmal",
        STATE_MP_CITY_595: "Bhitarwar",
        STATE_RJ_CITY_596: "Bhiwadi",
        STATE_MH_CITY_597: "Bhiwandi",
        STATE_HR_CITY_598: "Bhiwani",
        STATE_MH_CITY_599: "Bhiwapur",
        STATE_UP_CITY_600: "Bhognipur",
        STATE_PB_CITY_601: "Bhogpur",
        STATE_BR_CITY_602: "Bhojpur",
        STATE_GJ_CITY_603: "Bhojpur Dharampur",
        STATE_JH_CITY_604: "Bhojudih",
        STATE_MH_CITY_605: "Bhokar",
        STATE_MH_CITY_606: "Bhokardan",
        STATE_PB_CITY_607: "Bholath",
        STATE_UP_CITY_608: "Bhongaon",
        STATE_TG_CITY_609: "Bhongir",
        STATE_MH_CITY_610: "Bhoom",
        STATE_MP_CITY_611: "Bhopal",
        STATE_MH_CITY_612: "Bhor",
        STATE_UT_CITY_613: "Bhowali",
        STATE_OR_CITY_614: "Bhuban",
        STATE_OR_CITY_615: "Bhubaneshwar",
        STATE_MH_CITY_616: "Bhudgaon",
        STATE_MH_CITY_617: "Bhugaon",
        STATE_GJ_CITY_618: "Bhuj",
        STATE_MH_CITY_619: "Bhum",
        STATE_RJ_CITY_620: "Bhuma",
        STATE_MH_CITY_621: "Bhusaval",
        STATE_MH_CITY_622: "Bhusawal",
        STATE_MP_CITY_623: "Biaora",
        STATE_MH_CITY_624: "Bid",
        STATE_KA_CITY_625: "Bidar",
        STATE_UP_CITY_626: "Bidhnu",
        STATE_UP_CITY_627: "Bidhuna",
        STATE_UP_CITY_628: "Bighapur",
        STATE_UP_CITY_629: "Bighapur Khurd",
        STATE_BR_CITY_630: "Bihar Sharif",
        STATE_BR_CITY_631: "Bihariganj",
        STATE_AS_CITY_632: "Bihpuriagaon",
        STATE_KA_CITY_633: "Bijapur",
        STATE_CT_CITY_634: "Bijapur",
        STATE_MP_CITY_635: "Bijawar",
        STATE_JK_CITY_636: "Bijbehara",
        STATE_AS_CITY_637: "Bijni",
        STATE_UP_CITY_638: "Bijnor",
        STATE_MP_CITY_639: "Bijrauni",
        STATE_MH_CITY_640: "Bijur",
        STATE_RJ_CITY_641: "Bikaner",
        STATE_UP_CITY_642: "Bikapur",
        STATE_BR_CITY_643: "Bikramganj",
        STATE_RJ_CITY_644: "Bilara",
        STATE_UP_CITY_645: "Bilari",
        STATE_UP_CITY_646: "Bilariaganj",
        STATE_MH_CITY_647: "Bilashi",
        STATE_AS_CITY_648: "Bilasipara",
        STATE_HP_CITY_649: "Bilaspur",
        STATE_HR_CITY_650: "Bilaspur",
        STATE_CT_CITY_651: "Bilaspur",
        STATE_UP_CITY_652: "Bilaspur",
        STATE_KA_CITY_653: "Bilgi",
        STATE_UP_CITY_654: "Bilgram",
        STATE_UP_CITY_655: "Bilhaur",
        STATE_GJ_CITY_656: "Bilimora",
        STATE_GJ_CITY_657: "Bilkha",
        STATE_MH_CITY_658: "Biloli",
        STATE_UP_CITY_659: "Bilsanda",
        STATE_UP_CITY_660: "Bilsi",
        STATE_UP_CITY_661: "Bilthra",
        STATE_UP_CITY_662: "Binauli",
        STATE_UP_CITY_663: "Binaur",
        STATE_UP_CITY_664: "Bindki",
        STATE_OR_CITY_665: "Binka",
        STATE_UT_CITY_666: "Birbhaddar",
        STATE_WB_CITY_667: "Birbhum district",
        STATE_UP_CITY_668: "Birdpur",
        STATE_OR_CITY_669: "Birmitrapur",
        STATE_WB_CITY_670: "Birpara",
        STATE_BR_CITY_671: "Birpur",
        STATE_UP_CITY_672: "Birpur",
        STATE_KA_CITY_673: "Birur",
        STATE_UP_CITY_674: "Bisalpur",
        STATE_UP_CITY_675: "Bisanda Buzurg",
        STATE_UP_CITY_676: "Bisauli",
        STATE_UP_CITY_677: "Bisenda Buzurg",
        STATE_JK_CITY_678: "Bishnah",
        STATE_MN_CITY_679: "Bishnupur",
        STATE_WB_CITY_680: "Bishnupur",
        STATE_UP_CITY_681: "Bishunpur Urf Maharajganj",
        STATE_RJ_CITY_682: "Bissau",
        STATE_UP_CITY_683: "Biswan",
        STATE_UP_CITY_684: "Bithur",
        STATE_AP_CITY_685: "Bobbili",
        STATE_TG_CITY_686: "Bodhan",
        STATE_TN_CITY_687: "Bodinayakkanur",
        STATE_MP_CITY_688: "Bodri",
        STATE_MH_CITY_689: "Boisar",
        STATE_AS_CITY_690: "Bokajan",
        STATE_AS_CITY_691: "Bokakhat",
        STATE_JH_CITY_692: "Bokaro",
        STATE_OR_CITY_693: "Bolanikhodan",
        STATE_WB_CITY_694: "Bolpur",
        STATE_AR_CITY_695: "Bomdila",
        STATE_AS_CITY_696: "Bongaigaon",
        STATE_MH_CITY_697: "Borgaon Manju",
        STATE_MH_CITY_698: "Borivali",
        STATE_MH_CITY_699: "Borivli",
        STATE_RJ_CITY_700: "Borkhera",
        STATE_GJ_CITY_701: "Borsad",
        STATE_GJ_CITY_702: "Botad",
        STATE_OR_CITY_703: "Brahmapur",
        STATE_MH_CITY_704: "Brahmapuri",
        STATE_OR_CITY_705: "Brajarajnagar",
        STATE_MH_CITY_706: "Breach Candy",
        STATE_UP_CITY_707: "Budaun",
        STATE_BR_CITY_708: "Buddh Gaya",
        STATE_WB_CITY_709: "Budge Budge",
        STATE_UP_CITY_710: "Budhana",
        STATE_PB_CITY_711: "Budhlada",
        STATE_OR_CITY_712: "Buguda",
        STATE_UP_CITY_713: "Bulandshahr",
        STATE_MH_CITY_714: "Buldana",
        STATE_MH_CITY_715: "Buldhana",
        STATE_RJ_CITY_716: "Bundi",
        STATE_JH_CITY_717: "Bundu",
        STATE_MP_CITY_718: "Burhanpur",
        STATE_MP_CITY_719: "Burhar",
        STATE_HR_CITY_720: "Buriya",
        STATE_OR_CITY_721: "Burla",
        STATE_BR_CITY_722: "Buxar",
        STATE_KA_CITY_723: "Byadgi",
        STATE_MH_CITY_724: "Byculla",
        STATE_KA_CITY_725: "Byndoor",
        STATE_AS_CITY_726: "Cachar",
        STATE_GA_CITY_727: "Calangute",
        STATE_KA_CITY_728: "Canacona",
        STATE_GA_CITY_729: "Candolim",
        STATE_WB_CITY_730: "Canning",
        STATE_UP_CITY_731: "Captainganj",
        STATE_GA_CITY_732: "Carapur",
        STATE_GA_CITY_733: "Cavelossim",
        STATE_DL_CITY_734: "Central Delhi",
        STATE_AS_CITY_735: "Chabua",
        STATE_JH_CITY_736: "Chaibasa",
        STATE_UP_CITY_737: "Chail",
        STATE_MH_CITY_738: "Chakan",
        STATE_WB_CITY_739: "Chakapara",
        STATE_WB_CITY_740: "Chakdaha",
        STATE_UP_CITY_741: "Chakia",
        STATE_BR_CITY_742: "Chakia",
        STATE_GJ_CITY_743: "Chaklasi",
        STATE_JH_CITY_744: "Chakradharpur",
        STATE_UT_CITY_745: "Chakrata",
        STATE_RJ_CITY_746: "Chaksu",
        STATE_JH_CITY_747: "Chakulia",
        STATE_MH_CITY_748: "Chakur",
        STATE_GJ_CITY_749: "Chalala",
        STATE_MH_CITY_750: "Chalisgaon",
        STATE_KA_CITY_751: "Challakere",
        STATE_AP_CITY_752: "Challapalle",
        STATE_GJ_CITY_753: "Chaloda",
        STATE_HP_CITY_754: "Chamba",
        STATE_UT_CITY_755: "Chamoli",
        STATE_CT_CITY_756: "Champa",
        STATE_WB_CITY_757: "Champadanga",
        STATE_WB_CITY_758: "Champahati",
        STATE_GJ_CITY_759: "Champaner",
        STATE_UT_CITY_760: "Champawat",
        STATE_WB_CITY_761: "Champdani",
        STATE_MZ_CITY_762: "Champhai",
        STATE_OR_CITY_763: "Champua",
        STATE_KA_CITY_764: "Chamrajnagar",
        STATE_GJ_CITY_765: "Chanasma",
        STATE_MH_CITY_766: "Chanda",
        STATE_WB_CITY_767: "Chandannagar",
        STATE_UP_CITY_768: "Chandauli",
        STATE_UP_CITY_769: "Chandauli District",
        STATE_UP_CITY_770: "Chandausi",
        STATE_OR_CITY_771: "Chandbali",
        STATE_MP_CITY_772: "Chanderi",
        STATE_MH_CITY_773: "Chandgad",
        STATE_MP_CITY_774: "Chandia",
        STATE_CH_CITY_775: "Chandigarh",
        STATE_JH_CITY_776: "Chandil",
        STATE_MP_CITY_777: "Chandla",
        STATE_MH_CITY_778: "Chandor",
        STATE_UP_CITY_779: "Chandpur",
        STATE_WB_CITY_780: "Chandrakona",
        STATE_MH_CITY_781: "Chandrapur",
        STATE_UP_CITY_782: "Chanduasi",
        STATE_TG_CITY_783: "Chandur",
        STATE_MH_CITY_784: "Chandur",
        STATE_MH_CITY_785: "Chandur Bazar",
        STATE_KL_CITY_786: "Changanacheri",
        STATE_AR_CITY_787: "Changlang",
        STATE_KA_CITY_788: "Channagiri",
        STATE_KA_CITY_789: "Channapatna",
        STATE_KA_CITY_790: "Channarayapatna",
        STATE_AS_CITY_791: "Chapar",
        STATE_BR_CITY_792: "Chapra",
        STATE_UP_CITY_793: "Charkhari",
        STATE_HR_CITY_794: "Charkhi Dadri",
        STATE_UP_CITY_795: "Charthawal",
        STATE_JH_CITY_796: "Chas",
        STATE_TG_CITY_797: "Chatakonda",
        STATE_JH_CITY_798: "Chatra",
        STATE_OR_CITY_799: "Chatrapur",
        STATE_HP_CITY_800: "Chaupal",
        STATE_MH_CITY_801: "Chausala",
        STATE_RJ_CITY_802: "Chechat",
        STATE_KL_CITY_803: "Chēlakara",
        STATE_MH_CITY_804: "Chembur",
        STATE_AP_CITY_805: "Chemmumiahpet",
        STATE_TN_CITY_806: "Chengam",
        STATE_KL_CITY_807: "Chengannur",
        STATE_TN_CITY_808: "Chennai",
        STATE_TN_CITY_809: "Chennimalai",
        STATE_KL_CITY_810: "Cherpulassery",
        STATE_ML_CITY_811: "Cherrapunji",
        STATE_KL_CITY_812: "Cherthala",
        STATE_TN_CITY_813: "Chetput",
        STATE_TN_CITY_814: "Chettipalaiyam",
        STATE_KL_CITY_815: "Chetwayi",
        STATE_TN_CITY_816: "Cheyyar",
        STATE_TN_CITY_817: "Cheyyur",
        STATE_RJ_CITY_818: "Chhabra",
        STATE_HR_CITY_819: "Chhachhrauli",
        STATE_GJ_CITY_820: "Chhala",
        STATE_RJ_CITY_821: "Chhapar",
        STATE_UP_CITY_822: "Chhaprauli",
        STATE_UP_CITY_823: "Chharra",
        STATE_UP_CITY_824: "Chhata",
        STATE_BR_CITY_825: "Chhatapur",
        STATE_MP_CITY_826: "Chhatarpur",
        STATE_UP_CITY_827: "Chhibramau",
        STATE_MP_CITY_828: "Chhindwara",
        STATE_UP_CITY_829: "Chhitauni",
        STATE_GJ_CITY_830: "Chhota Udepur",
        STATE_RJ_CITY_831: "Chhoti Sadri",
        STATE_CT_CITY_832: "Chhuikhadan",
        STATE_UP_CITY_833: "Chhutmalpur",
        STATE_GA_CITY_834: "Chicalim",
        STATE_MP_CITY_835: "Chichli",
        STATE_MH_CITY_836: "Chicholi",
        STATE_MH_CITY_837: "Chichondi Patil",
        STATE_TN_CITY_838: "Chidambaram",
        STATE_RJ_CITY_839: "Chidawa",
        STATE_KA_CITY_840: "Chik Ballapur",
        STATE_GJ_CITY_841: "Chikhli",
        STATE_MH_CITY_842: "Chikhli (Buldhana)",
        STATE_MH_CITY_843: "Chikhli (Jalna)",
        STATE_OR_CITY_844: "Chikitigarh",
        STATE_KA_CITY_845: "Chikkaballapur",
        STATE_KA_CITY_846: "Chikmagalur",
        STATE_KA_CITY_847: "Chiknayakanhalli",
        STATE_KA_CITY_848: "Chikodi",
        STATE_AP_CITY_849: "Chilakalurupet",
        STATE_UP_CITY_850: "Chillupar",
        STATE_PB_CITY_851: "Chima",
        STATE_MH_CITY_852: "Chimur",
        STATE_MH_CITY_853: "Chinchani",
        STATE_GA_CITY_854: "Chinchinim",
        STATE_KA_CITY_855: "Chincholi",
        STATE_MH_CITY_856: "Chinchpokli",
        STATE_TN_CITY_857: "Chingleput",
        STATE_TN_CITY_858: "Chinna Salem",
        STATE_AP_CITY_859: "Chinnachowk",
        STATE_TN_CITY_860: "Chinnamanur",
        STATE_TN_CITY_861: "Chinnasekkadu",
        STATE_KA_CITY_862: "Chintamani",
        STATE_MH_CITY_863: "Chiplun",
        STATE_AP_CITY_864: "Chipurupalle",
        STATE_AP_CITY_865: "Chirala",
        STATE_AS_CITY_866: "Chirang",
        STATE_UP_CITY_867: "Chirgaon",
        STATE_JH_CITY_868: "Chiria",
        STATE_KA_CITY_869: "Chitapur",
        STATE_KA_CITY_870: "Chitradurga",
        STATE_UP_CITY_871: "Chitrakoot",
        STATE_UP_CITY_872: "Chitrakoot Dham",
        STATE_WB_CITY_873: "Chittaranjan",
        STATE_OR_CITY_874: "Chittarkonda",
        STATE_RJ_CITY_875: "Chittaurgarh",
        STATE_AP_CITY_876: "Chittoor",
        STATE_KL_CITY_877: "Chittur",
        STATE_AP_CITY_878: "Chodavaram",
        STATE_TN_CITY_879: "Cholapuram",
        STATE_UP_CITY_880: "Chopan",
        STATE_MH_CITY_881: "Chopda",
        STATE_MP_CITY_882: "Chorhat",
        STATE_GJ_CITY_883: "Chotila",
        STATE_HP_CITY_884: "Chowari",
        STATE_HP_CITY_885: "Chuari Khas",
        STATE_GJ_CITY_886: "Chuda",
        STATE_UP_CITY_887: "Chunar",
        STATE_MN_CITY_888: "Churachandpur",
        STATE_UP_CITY_889: "Churk",
        STATE_RJ_CITY_890: "Churu",
        STATE_WB_CITY_891: "Churulia",
        STATE_UT_CITY_892: "Clement Town",
        STATE_KA_CITY_893: "Closepet",
        STATE_KL_CITY_894: "Cochin",
        STATE_TN_CITY_895: "Coimbatore",
        STATE_MH_CITY_896: "Colaba",
        STATE_TN_CITY_897: "Colachel",
        STATE_BR_CITY_898: "Colgong",
        STATE_UP_CITY_899: "Colonelganj",
        STATE_GA_CITY_900: "Colovale",
        STATE_GA_CITY_901: "Colva",
        STATE_WB_CITY_902: "Contai",
        STATE_WB_CITY_903: "Cooch Behar",
        STATE_KA_CITY_904: "Coondapoor",
        STATE_GA_CITY_905: "Cortalim",
        STATE_WB_CITY_906: "Cossimbazar",
        STATE_TN_CITY_907: "Cuddalore",
        STATE_AP_CITY_908: "Cuddapah",
        STATE_AP_CITY_909: "Cumbum",
        STATE_TN_CITY_910: "Cumbum",
        STATE_GA_CITY_911: "Cuncolim",
        STATE_GA_CITY_912: "Curchorem",
        STATE_GA_CITY_913: "Curti",
        STATE_OR_CITY_914: "Cuttack",
        STATE_GJ_CITY_915: "Dabhoda",
        STATE_GJ_CITY_916: "Dabhoi",
        STATE_MH_CITY_917: "Dabhol",
        STATE_MP_CITY_918: "Daboh",
        STATE_MP_CITY_919: "Dabra",
        STATE_HR_CITY_920: "Dabwali",
        STATE_MH_CITY_921: "Daddi",
        STATE_DN_CITY_922: "Dadra",
        STATE_DN_CITY_923: "Dadra & Nagar Haveli",
        STATE_UP_CITY_924: "Dadri",
        STATE_HP_CITY_925: "Dagshai",
        STATE_MH_CITY_926: "Dahanu",
        STATE_GJ_CITY_927: "Dahegam",
        STATE_MH_CITY_928: "Dahivel",
        STATE_GJ_CITY_929: "Dahod",
        STATE_OR_CITY_930: "Daitari",
        STATE_GJ_CITY_931: "Dakor",
        STATE_WB_CITY_932: "Dakshin Dinajpur district",
        STATE_KA_CITY_933: "Dakshina Kannada",
        STATE_HP_CITY_934: "Dalhousie",
        STATE_WB_CITY_935: "Dalkola",
        STATE_UP_CITY_936: "Dalmau",
        STATE_BR_CITY_937: "Dalsingh Sarai",
        STATE_JH_CITY_938: "Daltonganj",
        STATE_WB_CITY_939: "Dam Dam",
        STATE_DD_CITY_940: "Daman",
        STATE_DD_CITY_941: "Daman District",
        STATE_GJ_CITY_942: "Damnagar",
        STATE_MP_CITY_943: "Damoh",
        STATE_KA_CITY_944: "Dandeli",
        STATE_GJ_CITY_945: "Dandi",
        STATE_GJ_CITY_946: "Dangs (India)",
        STATE_UP_CITY_947: "Dankaur",
        STATE_GJ_CITY_948: "Danta",
        STATE_MH_CITY_949: "Dapoli",
        STATE_UP_CITY_950: "Daraganj",
        STATE_UP_CITY_951: "Daranagar",
        STATE_BR_CITY_952: "Darbhanga",
        STATE_RJ_CITY_953: "Dariba",
        STATE_WB_CITY_954: "Darjeeling",
        STATE_MZ_CITY_955: "Darlawn",
        STATE_AS_CITY_956: "Darrang",
        STATE_AP_CITY_957: "Darsi",
        STATE_MH_CITY_958: "Darwha",
        STATE_MH_CITY_959: "Daryapur",
        STATE_UP_CITY_960: "Dasna",
        STATE_TG_CITY_961: "Dasnapur",
        STATE_PB_CITY_962: "Dasuya",
        STATE_UP_CITY_963: "Dataganj",
        STATE_MP_CITY_964: "Datia",
        STATE_MH_CITY_965: "Dattapur",
        STATE_BR_CITY_966: "Daudnagar",
        STATE_MH_CITY_967: "Daulatabad",
        STATE_HP_CITY_968: "Daulatpur",
        STATE_WB_CITY_969: "Daulatpur",
        STATE_MH_CITY_970: "Daund",
        STATE_UP_CITY_971: "Daurala",
        STATE_RJ_CITY_972: "Dausa",
        STATE_KA_CITY_973: "Davanagere",
        STATE_GA_CITY_974: "Davorlim",
        STATE_UP_CITY_975: "Dayal Bagh",
        STATE_GJ_CITY_976: "Dayapar",
        STATE_WB_CITY_977: "Debagram",
        STATE_WB_CITY_978: "Debipur",
        STATE_MH_CITY_979: "Deccan Gymkhana",
        STATE_MH_CITY_980: "Deglur",
        STATE_UT_CITY_981: "Dehradun",
        STATE_BR_CITY_982: "Dehri",
        STATE_MH_CITY_983: "Dehu",
        STATE_DL_CITY_984: "Delhi",
        STATE_GJ_CITY_985: "Delvada",
        STATE_GJ_CITY_986: "Delwada",
        STATE_TN_CITY_987: "Denkanikota",
        STATE_UP_CITY_988: "Deoband",
        STATE_OR_CITY_989: "Deogarh",
        STATE_JH_CITY_990: "Deogarh",
        STATE_UP_CITY_991: "Deogarh",
        STATE_MH_CITY_992: "Deolali",
        STATE_MH_CITY_993: "Deolapar",
        STATE_RJ_CITY_994: "Deoli",
        STATE_MH_CITY_995: "Deoli",
        STATE_DL_CITY_996: "Deoli",
        STATE_MH_CITY_997: "Deoni",
        STATE_UP_CITY_998: "Deoranian",
        STATE_CT_CITY_999: "Deori",
        STATE_MP_CITY_1000: "Deori Khas",
        STATE_UP_CITY_1001: "Deoria",
        STATE_MP_CITY_1002: "Depalpur",
        STATE_PB_CITY_1003: "Dera Baba Nanak",
        STATE_PB_CITY_1004: "Dera Bassi",
        STATE_HP_CITY_1005: "Dera Gopipur",
        STATE_UP_CITY_1006: "Derapur",
        STATE_AS_CITY_1007: "Dergaon",
        STATE_RJ_CITY_1008: "Deshnoke",
        STATE_TN_CITY_1009: "Desur",
        STATE_GJ_CITY_1010: "Detroj",
        STATE_MH_CITY_1011: "Deulgaon Raja",
        STATE_TN_CITY_1012: "Devadanappatti",
        STATE_TN_CITY_1013: "Devakottai",
        STATE_KA_CITY_1014: "Devanhalli",
        STATE_UT_CITY_1015: "Devaprayag",
        STATE_TG_CITY_1016: "Devarkonda",
        STATE_GJ_CITY_1017: "Devbhumi Dwarka",
        STATE_GJ_CITY_1018: "Devgadh Bariya",
        STATE_RJ_CITY_1019: "Devgarh",
        STATE_MH_CITY_1020: "Devrukh",
        STATE_UP_CITY_1021: "Dewa",
        STATE_MP_CITY_1022: "Dewas",
        STATE_BR_CITY_1023: "Dhaka",
        STATE_TR_CITY_1024: "Dhalai",
        STATE_TN_CITY_1025: "Dhali",
        STATE_MP_CITY_1026: "Dhamnod",
        STATE_UP_CITY_1027: "Dhampur",
        STATE_CT_CITY_1028: "Dhamtari",
        STATE_MP_CITY_1029: "Dhana",
        STATE_PB_CITY_1030: "Dhanaula",
        STATE_UP_CITY_1031: "Dhanaura",
        STATE_JH_CITY_1032: "Dhanbad",
        STATE_GJ_CITY_1033: "Dhandhuka",
        STATE_GJ_CITY_1034: "Dhanera",
        STATE_UP_CITY_1035: "Dhanghata",
        STATE_WB_CITY_1036: "Dhaniakhali community development block",
        STATE_GJ_CITY_1037: "Dhansura",
        STATE_JH_CITY_1038: "Dhanwar",
        STATE_MP_CITY_1039: "Dhar",
        STATE_GJ_CITY_1040: "Dharampur",
        STATE_MP_CITY_1041: "Dharampuri",
        STATE_HP_CITY_1042: "Dharamsala",
        STATE_MH_CITY_1043: "Dharangaon",
        STATE_TN_CITY_1044: "Dharapuram",
        STATE_GJ_CITY_1045: "Dharasana",
        STATE_UP_CITY_1046: "Dharau",
        STATE_MH_CITY_1047: "Dharavi",
        STATE_UT_CITY_1048: "Dharchula",
        STATE_GJ_CITY_1049: "Dhari",
        STATE_PB_CITY_1050: "Dhariwal",
        STATE_MH_CITY_1051: "Dharmabad",
        STATE_KL_CITY_1052: "Dharmadam",
        STATE_TR_CITY_1053: "Dharmanagar",
        STATE_TN_CITY_1054: "Dharmapuri",
        STATE_AP_CITY_1055: "Dharmavaram",
        STATE_HR_CITY_1056: "Dharuhera",
        STATE_MH_CITY_1057: "Dharur",
        STATE_KA_CITY_1058: "Dharwad",
        STATE_GJ_CITY_1059: "Dhasa",
        STATE_RJ_CITY_1060: "Dhaulpur",
        STATE_UP_CITY_1061: "Dhaurahra",
        STATE_MH_CITY_1062: "Dhawalpuri",
        STATE_AS_CITY_1063: "Dhekiajuli",
        STATE_AS_CITY_1064: "Dhemaji",
        STATE_OR_CITY_1065: "Dhenkanal",
        STATE_PB_CITY_1066: "Dhilwan",
        STATE_AS_CITY_1067: "Dhing",
        STATE_GJ_CITY_1068: "Dhola",
        STATE_GJ_CITY_1069: "Dholera",
        STATE_GJ_CITY_1070: "Dholka",
        STATE_AP_CITY_1071: "Dhone",
        STATE_GJ_CITY_1072: "Dhoraji",
        STATE_GJ_CITY_1073: "Dhrangadhra",
        STATE_GJ_CITY_1074: "Dhrol",
        STATE_AS_CITY_1075: "Dhubri",
        STATE_PB_CITY_1076: "Dhudi",
        STATE_WB_CITY_1077: "Dhulagari",
        STATE_MH_CITY_1078: "Dhule",
        STATE_MH_CITY_1079: "Dhulia",
        STATE_WB_CITY_1080: "Dhulian",
        STATE_WB_CITY_1081: "Dhupguri",
        STATE_PB_CITY_1082: "Dhuri",
        STATE_GJ_CITY_1083: "Dhuwaran",
        STATE_WB_CITY_1084: "Diamond Harbour",
        STATE_UP_CITY_1085: "Dibai",
        STATE_AR_CITY_1086: "Dibang Valley",
        STATE_AS_CITY_1087: "Dibrugarh",
        STATE_GA_CITY_1088: "Dicholi",
        STATE_RJ_CITY_1089: "Didwana",
        STATE_RJ_CITY_1090: "Dig",
        STATE_OR_CITY_1091: "Digapahandi",
        STATE_AS_CITY_1092: "Digboi",
        STATE_WB_CITY_1093: "Digha",
        STATE_MH_CITY_1094: "Dighori",
        STATE_BR_CITY_1095: "Dighwara",
        STATE_MH_CITY_1096: "Diglur",
        STATE_MH_CITY_1097: "Digras",
        STATE_AP_CITY_1098: "Diguvametta",
        STATE_AS_CITY_1099: "Dima Hasao District",
        STATE_NL_CITY_1100: "Dimapur",
        STATE_PB_CITY_1101: "Dina Nagar",
        STATE_BR_CITY_1102: "Dinapore",
        STATE_TN_CITY_1103: "Dindigul",
        STATE_MP_CITY_1104: "Dindori",
        STATE_MH_CITY_1105: "Dindori, Maharashtra",
        STATE_WB_CITY_1106: "Dinhata",
        STATE_AS_CITY_1107: "Diphu",
        STATE_PB_CITY_1108: "Dirba",
        STATE_GJ_CITY_1109: "Disa",
        STATE_AS_CITY_1110: "Dispur",
        STATE_DD_CITY_1111: "Diu",
        STATE_MH_CITY_1112: "Diveagar",
        STATE_UP_CITY_1113: "Divrasai",
        STATE_KA_CITY_1114: "Dod Ballapur",
        STATE_JK_CITY_1115: "Doda",
        STATE_GJ_CITY_1116: "Dohad",
        STATE_UP_CITY_1117: "Dohrighat",
        STATE_UT_CITY_1118: "Doiwala",
        STATE_UP_CITY_1119: "Domariaganj",
        STATE_MH_CITY_1120: "Dombivli",
        STATE_WB_CITY_1121: "Domjur",
        STATE_MH_CITY_1122: "Dondaicha",
        STATE_CT_CITY_1123: "Dongargaon",
        STATE_CT_CITY_1124: "Dongargarh",
        STATE_MH_CITY_1125: "Dongri",
        STATE_PB_CITY_1126: "Doraha",
        STATE_TG_CITY_1127: "Dornakal",
        STATE_UP_CITY_1128: "Dostpur",
        STATE_WB_CITY_1129: "Dubrajpur",
        STATE_MH_CITY_1130: "Dudhani",
        STATE_UP_CITY_1131: "Dudhi",
        STATE_UT_CITY_1132: "Dugadda",
        STATE_JH_CITY_1133: "Dugda",
        STATE_AS_CITY_1134: "Duliagaon",
        STATE_AS_CITY_1135: "Dum Duma",
        STATE_JH_CITY_1136: "Dumka",
        STATE_GJ_CITY_1137: "Dumkhal",
        STATE_BR_CITY_1138: "Dumra",
        STATE_BR_CITY_1139: "Dumraon",
        STATE_GJ_CITY_1140: "Dungarpur",
        STATE_RJ_CITY_1141: "Dungarpur",
        STATE_CT_CITY_1142: "Durg",
        STATE_MH_CITY_1143: "Durgapur",
        STATE_WB_CITY_1144: "Durgapur",
        STATE_MH_CITY_1145: "Durgapur, Chandrapur",
        STATE_TN_CITY_1146: "Dusi",
        STATE_UT_CITY_1147: "Dwarahat",
        STATE_GJ_CITY_1148: "Dwarka",
        STATE_DL_CITY_1149: "East Delhi",
        STATE_SK_CITY_1150: "East District",
        STATE_ML_CITY_1151: "East Garo Hills",
        STATE_AP_CITY_1152: "East Godavari",
        STATE_ML_CITY_1153: "East Jaintia Hills",
        STATE_AR_CITY_1154: "East Kameng",
        STATE_ML_CITY_1155: "East Khasi Hills",
        STATE_AR_CITY_1156: "East Siang",
        STATE_KL_CITY_1157: "Edakkulam",
        STATE_WB_CITY_1158: "Egra",
        STATE_AP_CITY_1159: "Elamanchili",
        STATE_TN_CITY_1160: "Elayirampannai",
        STATE_HR_CITY_1161: "Ellenabad",
        STATE_AP_CITY_1162: "Ellore",
        STATE_TN_CITY_1163: "Elumalai",
        STATE_KL_CITY_1164: "Elur",
        STATE_AP_CITY_1165: "Emmiganur",
        STATE_TN_CITY_1166: "Eral",
        STATE_MH_CITY_1167: "Erandol",
        STATE_TN_CITY_1168: "Eraniel",
        STATE_KL_CITY_1169: "Erattupetta",
        STATE_KL_CITY_1170: "Ernakulam",
        STATE_TN_CITY_1171: "Erode",
        STATE_AP_CITY_1172: "Erraguntla",
        STATE_TN_CITY_1173: "Erumaippatti",
        STATE_UP_CITY_1174: "Etah",
        STATE_MP_CITY_1175: "Etawa",
        STATE_UP_CITY_1176: "Etawah",
        STATE_AP_CITY_1177: "Etikoppaka",
        STATE_UP_CITY_1178: "Etmadpur",
        STATE_TN_CITY_1179: "Ettaiyapuram",
        STATE_UP_CITY_1180: "Faizabad",
        STATE_MH_CITY_1181: "Faizpur",
        STATE_WB_CITY_1182: "Falakata",
        STATE_UP_CITY_1183: "Farah",
        STATE_WB_CITY_1184: "Farakka",
        STATE_HR_CITY_1185: "Faridabad",
        STATE_HR_CITY_1186: "Faridabad District",
        STATE_PB_CITY_1187: "Faridkot",
        STATE_UP_CITY_1188: "Faridnagar",
        STATE_UP_CITY_1189: "Faridpur",
        STATE_UP_CITY_1190: "Farrukhabad",
        STATE_HR_CITY_1191: "Farrukhnagar",
        STATE_TG_CITY_1192: "Farrukhnagar",
        STATE_UP_CITY_1193: "Fatehabad",
        STATE_HR_CITY_1194: "Fatehabad",
        STATE_HR_CITY_1195: "Fatehabad District",
        STATE_UP_CITY_1196: "Fatehganj West",
        STATE_UP_CITY_1197: "Fatehgarh",
        STATE_PB_CITY_1198: "Fatehgarh Churian",
        STATE_PB_CITY_1199: "Fatehgarh Sahib",
        STATE_RJ_CITY_1200: "Fatehpur",
        STATE_UP_CITY_1201: "Fatehpur",
        STATE_UP_CITY_1202: "Fatehpur (Barabanki)",
        STATE_UP_CITY_1203: "Fatehpur Chaurasi",
        STATE_UP_CITY_1204: "Fatehpur Sikri",
        STATE_BR_CITY_1205: "Fatwa",
        STATE_PB_CITY_1206: "Fazilka",
        STATE_KL_CITY_1207: "Ferokh",
        STATE_UP_CITY_1208: "Firozabad",
        STATE_PB_CITY_1209: "Firozpur",
        STATE_PB_CITY_1210: "Firozpur District",
        STATE_HR_CITY_1211: "Firozpur Jhirka",
        STATE_BR_CITY_1212: "Forbesganj",
        STATE_MH_CITY_1213: "Fort",
        STATE_WB_CITY_1214: "Fort Gloster",
        STATE_KA_CITY_1215: "French Rocks",
        STATE_UP_CITY_1216: "Fyzabad",
        STATE_KA_CITY_1217: "Gadag",
        STATE_KA_CITY_1218: "Gadag-Betageri",
        STATE_MP_CITY_1219: "Gadarwara",
        STATE_MH_CITY_1220: "Gadchiroli",
        STATE_TG_CITY_1221: "Gaddi Annaram",
        STATE_GJ_CITY_1222: "Gadhada",
        STATE_MH_CITY_1223: "Gadhinglaj",
        STATE_TG_CITY_1224: "Gadwal",
        STATE_HP_CITY_1225: "Gagret",
        STATE_UP_CITY_1226: "Gahlon",
        STATE_UP_CITY_1227: "Gahmar",
        STATE_WB_CITY_1228: "Gaighata community development block",
        STATE_UP_CITY_1229: "Gaini",
        STATE_WB_CITY_1230: "Gairkata",
        STATE_OR_CITY_1231: "Gajapati",
        STATE_KA_CITY_1232: "Gajendragarh",
        STATE_UP_CITY_1233: "Gajraula",
        STATE_AP_CITY_1234: "Gajuwaka",
        STATE_RJ_CITY_1235: "Galiakot",
        STATE_CT_CITY_1236: "Gandai",
        STATE_JK_CITY_1237: "Gandarbal",
        STATE_JK_CITY_1238: "Ganderbal",
        STATE_GJ_CITY_1239: "Gandevi",
        STATE_TN_CITY_1240: "Gandhi Nagar",
        STATE_GJ_CITY_1241: "Gandhidham",
        STATE_GJ_CITY_1242: "Gandhinagar",
        STATE_WB_CITY_1243: "Gangadharpur",
        STATE_TN_CITY_1244: "Gangaikondan",
        STATE_MH_CITY_1245: "Gangakher",
        STATE_RJ_CITY_1246: "Ganganagar",
        STATE_RJ_CITY_1247: "Gangapur",
        STATE_MH_CITY_1248: "Gangapur",
        STATE_WB_CITY_1249: "Gangarampur",
        STATE_TN_CITY_1250: "Gangavalli",
        STATE_KA_CITY_1251: "Gangawati",
        STATE_UP_CITY_1252: "Gangoh",
        STATE_KA_CITY_1253: "Gangolli",
        STATE_SK_CITY_1254: "Gangtok",
        STATE_AP_CITY_1255: "Ganguvada",
        STATE_UP_CITY_1256: "Ganj Dundawara",
        STATE_UP_CITY_1257: "Ganj Dundwara",
        STATE_UP_CITY_1258: "Ganj Muradabad",
        STATE_OR_CITY_1259: "Ganjam",
        STATE_AP_CITY_1260: "Gannavaram",
        STATE_MH_CITY_1261: "Ganpatipule",
        STATE_UP_CITY_1262: "Garautha",
        STATE_PB_CITY_1263: "Gardhiwala",
        STATE_MP_CITY_1264: "Garha Brahman",
        STATE_MP_CITY_1265: "Garhakota",
        STATE_UP_CITY_1266: "Garhi Pukhta",
        STATE_UP_CITY_1267: "Garhmuktesar",
        STATE_PB_CITY_1268: "Garhshankar",
        STATE_JH_CITY_1269: "Garhwa",
        STATE_UP_CITY_1270: "Garhwa",
        STATE_UT_CITY_1271: "Garhwal",
        STATE_CT_CITY_1272: "Gariaband",
        STATE_GJ_CITY_1273: "Gariadhar",
        STATE_WB_CITY_1274: "Garui",
        STATE_WB_CITY_1275: "Garulia",
        STATE_CT_CITY_1276: "Gaurela",
        STATE_UP_CITY_1277: "Gauriganj",
        STATE_AS_CITY_1278: "Gauripur",
        STATE_UP_CITY_1279: "Gautam Buddha Nagar",
        STATE_MP_CITY_1280: "Gautampura",
        STATE_UP_CITY_1281: "Gawan",
        STATE_BR_CITY_1282: "Gaya",
        STATE_MH_CITY_1283: "Gevrai",
        STATE_PB_CITY_1284: "Ghanaur",
        STATE_MP_CITY_1285: "Ghansor",
        STATE_HR_CITY_1286: "Gharaunda",
        STATE_MH_CITY_1287: "Ghargaon",
        STATE_CT_CITY_1288: "Gharghoda",
        STATE_WB_CITY_1289: "Ghatal",
        STATE_UP_CITY_1290: "Ghatampur",
        STATE_MH_CITY_1291: "Ghatanji",
        STATE_TG_CITY_1292: "Ghatkesar",
        STATE_MH_CITY_1293: "Ghatkopar",
        STATE_JH_CITY_1294: "Ghatsila",
        STATE_UP_CITY_1295: "Ghaziabad",
        STATE_UP_CITY_1296: "Ghazipur",
        STATE_UP_CITY_1297: "Ghiror",
        STATE_JK_CITY_1298: "Gho Brahmanan de",
        STATE_GJ_CITY_1299: "Ghodasar",
        STATE_BR_CITY_1300: "Ghoga",
        STATE_GJ_CITY_1301: "Ghogha",
        STATE_UP_CITY_1302: "Ghorawal",
        STATE_UP_CITY_1303: "Ghosi",
        STATE_MH_CITY_1304: "Ghoti Budrukh",
        STATE_MH_CITY_1305: "Ghugus",
        STATE_HP_CITY_1306: "Ghumarwin",
        STATE_CT_CITY_1307: "Gidam",
        STATE_AP_CITY_1308: "Giddalur",
        STATE_PB_CITY_1309: "Giddarbaha",
        STATE_TN_CITY_1310: "Gingee",
        STATE_GJ_CITY_1311: "Gir Somnath",
        STATE_MH_CITY_1312: "Girgaon",
        STATE_WB_CITY_1313: "Giria",
        STATE_JH_CITY_1314: "Giridih",
        STATE_GA_CITY_1315: "Goa Velha",
        STATE_AS_CITY_1316: "Goalpara",
        STATE_WB_CITY_1317: "Gobardanga",
        STATE_TN_CITY_1318: "Gobichettipalayam",
        STATE_WB_CITY_1319: "Gobindapur",
        STATE_JH_CITY_1320: "Gobindpur",
        STATE_JH_CITY_1321: "Godda",
        STATE_GJ_CITY_1322: "Godhra",
        STATE_MP_CITY_1323: "Gogapur",
        STATE_MP_CITY_1324: "Gohadi",
        STATE_HR_CITY_1325: "Gohana",
        STATE_UP_CITY_1326: "Gohand",
        STATE_AS_CITY_1327: "Gohpur",
        STATE_KA_CITY_1328: "Gokak",
        STATE_KA_CITY_1329: "Gokarna",
        STATE_AP_CITY_1330: "Gokavaram",
        STATE_UP_CITY_1331: "Gokul",
        STATE_UP_CITY_1332: "Gola Bazar",
        STATE_UP_CITY_1333: "Gola Gokarannath",
        STATE_AS_CITY_1334: "Golaghat",
        STATE_AS_CITY_1335: "Golakganj",
        STATE_TR_CITY_1336: "Gomati",
        STATE_JH_CITY_1337: "Gomoh",
        STATE_UP_CITY_1338: "Gonda",
        STATE_UP_CITY_1339: "Gonda (Aligarh)",
        STATE_UP_CITY_1340: "Gonda City",
        STATE_GJ_CITY_1341: "Gondal",
        STATE_MH_CITY_1342: "Gondia",
        STATE_MH_CITY_1343: "Gondiya",
        STATE_BR_CITY_1344: "Gopalganj",
        STATE_OR_CITY_1345: "Gopalpur",
        STATE_WB_CITY_1346: "Gopalpur",
        STATE_TG_CITY_1347: "Gopalur",
        STATE_UP_CITY_1348: "Gopamau",
        STATE_JH_CITY_1349: "Gopinathpur",
        STATE_WB_CITY_1350: "Gopinathpur",
        STATE_MH_CITY_1351: "Gorai",
        STATE_HR_CITY_1352: "Gorakhpur",
        STATE_UP_CITY_1353: "Gorakhpur",
        STATE_AP_CITY_1354: "Gorantla",
        STATE_MH_CITY_1355: "Goregaon",
        STATE_KA_CITY_1356: "Goribidnur",
        STATE_WB_CITY_1357: "Gorubathan",
        STATE_KA_CITY_1358: "Gorur",
        STATE_GJ_CITY_1359: "Gorwa",
        STATE_WB_CITY_1360: "Gosaba",
        STATE_UP_CITY_1361: "Gosainganj",
        STATE_WB_CITY_1362: "Gosanimari",
        STATE_UP_CITY_1363: "Goshainganj",
        STATE_AS_CITY_1364: "Goshaingaon",
        STATE_UP_CITY_1365: "Govardhan",
        STATE_AP_CITY_1366: "Govindapuram,Chilakaluripet,Guntur",
        STATE_MP_CITY_1367: "Govindgarh",
        STATE_RJ_CITY_1368: "Govindgarh",
        STATE_UP_CITY_1369: "Greater Noida",
        STATE_JH_CITY_1370: "Gua",
        STATE_KA_CITY_1371: "Gubbi",
        STATE_TN_CITY_1372: "Gudalur",
        STATE_OR_CITY_1373: "Gudari",
        STATE_KA_CITY_1374: "Gudibanda",
        STATE_AP_CITY_1375: "Gudivada",
        STATE_TN_CITY_1376: "Gudiyatham",
        STATE_AP_CITY_1377: "Gudlavalleru",
        STATE_AP_CITY_1378: "Gudur",
        STATE_TG_CITY_1379: "Gudur",
        STATE_TN_CITY_1380: "Guduvancheri",
        STATE_MH_CITY_1381: "Guhagar",
        STATE_GA_CITY_1382: "Guirim",
        STATE_RJ_CITY_1383: "Gulabpura",
        STATE_UP_CITY_1384: "Gulaothi",
        STATE_KA_CITY_1385: "Gulbarga",
        STATE_KA_CITY_1386: "Guledagudda",
        STATE_JH_CITY_1387: "Gumia",
        STATE_JH_CITY_1388: "Gumla",
        STATE_TN_CITY_1389: "Gummidipundi",
        STATE_MP_CITY_1390: "Guna",
        STATE_KA_CITY_1391: "Gundlupēt",
        STATE_UP_CITY_1392: "Gunnaur",
        STATE_AP_CITY_1393: "Guntakal Junction",
        STATE_AP_CITY_1394: "Guntur",
        STATE_OR_CITY_1395: "Gunupur",
        STATE_WB_CITY_1396: "Gurdaha",
        STATE_PB_CITY_1397: "Gurdaspur",
        STATE_HR_CITY_1398: "Gurgaon",
        STATE_MP_CITY_1399: "Gurh",
        STATE_KA_CITY_1400: "Gurmatkal",
        STATE_UP_CITY_1401: "Gursahaiganj",
        STATE_UP_CITY_1402: "Gursarai",
        STATE_PB_CITY_1403: "Guru Har Sahai",
        STATE_KL_CITY_1404: "Guruvayur",
        STATE_WB_CITY_1405: "Guskhara",
        STATE_AS_CITY_1406: "Guwahati",
        STATE_MP_CITY_1407: "Gwalior",
        STATE_SK_CITY_1408: "Gyalshing",
        STATE_UP_CITY_1409: "Gyanpur",
        STATE_WB_CITY_1410: "Habra",
        STATE_KA_CITY_1411: "Hadagalli",
        STATE_MH_CITY_1412: "Hadapsar, Pune",
        STATE_MH_CITY_1413: "Hadgaon",
        STATE_AS_CITY_1414: "Haflong",
        STATE_AS_CITY_1415: "Hailakandi",
        STATE_JK_CITY_1416: "Hajan",
        STATE_PB_CITY_1417: "Hajipur",
        STATE_BR_CITY_1418: "Hajipur",
        STATE_AS_CITY_1419: "Hajo",
        STATE_UP_CITY_1420: "Haldaur",
        STATE_WB_CITY_1421: "Haldia",
        STATE_WB_CITY_1422: "Haldibari",
        STATE_UT_CITY_1423: "Haldwani",
        STATE_GJ_CITY_1424: "Halenda",
        STATE_WB_CITY_1425: "Halisahar",
        STATE_KA_CITY_1426: "Haliyal",
        STATE_MH_CITY_1427: "Halkarni",
        STATE_GJ_CITY_1428: "Halol",
        STATE_GJ_CITY_1429: "Halvad",
        STATE_UP_CITY_1430: "Hamirpur",
        STATE_HP_CITY_1431: "Hamirpur",
        STATE_KA_CITY_1432: "Hampi",
        STATE_UP_CITY_1433: "Handia",
        STATE_KA_CITY_1434: "Hangal",
        STATE_HR_CITY_1435: "Hansi",
        STATE_GJ_CITY_1436: "Hansot",
        STATE_RJ_CITY_1437: "Hanumangarh",
        STATE_UP_CITY_1438: "Hapur",
        STATE_UP_CITY_1439: "Haraipur",
        STATE_UP_CITY_1440: "Haraiya",
        STATE_MH_CITY_1441: "Harangul",
        STATE_UT_CITY_1442: "Harbatpur",
        STATE_UP_CITY_1443: "Harchandpur",
        STATE_MP_CITY_1444: "Harda",
        STATE_MP_CITY_1445: "Harda Khas",
        STATE_UP_CITY_1446: "Hardoi",
        STATE_UP_CITY_1447: "Harduaganj",
        STATE_PB_CITY_1448: "Hariana",
        STATE_UT_CITY_1449: "Haridwar",
        STATE_KA_CITY_1450: "Harihar",
        STATE_GJ_CITY_1451: "Harij",
        STATE_WB_CITY_1452: "Harindanga",
        STATE_WB_CITY_1453: "Haringhata",
        STATE_WB_CITY_1454: "Haripur",
        STATE_MH_CITY_1455: "Harnai",
        STATE_MP_CITY_1456: "Harpalpur",
        STATE_KA_CITY_1457: "Harpanahalli",
        STATE_MP_CITY_1458: "Harrai",
        STATE_GJ_CITY_1459: "Harsol",
        STATE_MP_CITY_1460: "Harsud",
        STATE_TN_CITY_1461: "Harur",
        STATE_HR_CITY_1462: "Hasanpur",
        STATE_UP_CITY_1463: "Hasanpur",
        STATE_WB_CITY_1464: "Hasimara",
        STATE_KA_CITY_1465: "Hassan",
        STATE_UP_CITY_1466: "Hastinapur",
        STATE_UP_CITY_1467: "Hata",
        STATE_UP_CITY_1468: "Hata (India)",
        STATE_UP_CITY_1469: "Hathras",
        STATE_GJ_CITY_1470: "Hathuran",
        STATE_MP_CITY_1471: "Hatod",
        STATE_MP_CITY_1472: "Hatta",
        STATE_KA_CITY_1473: "Haveri",
        STATE_AR_CITY_1474: "Hayuliang",
        STATE_JH_CITY_1475: "Hazaribag",
        STATE_JH_CITY_1476: "Hazaribagh",
        STATE_KA_CITY_1477: "Heggadadevankote",
        STATE_MH_CITY_1478: "Helwak",
        STATE_JH_CITY_1479: "Hesla",
        STATE_BR_CITY_1480: "Hilsa",
        STATE_GJ_CITY_1481: "Himatnagar",
        STATE_RJ_CITY_1482: "Hindaun",
        STATE_MP_CITY_1483: "Hindoria",
        STATE_AP_CITY_1484: "Hindupur",
        STATE_WB_CITY_1485: "Hindusthan Cables Town",
        STATE_MH_CITY_1486: "Hinganghat",
        STATE_MH_CITY_1487: "Hingoli",
        STATE_OR_CITY_1488: "Hinjilikatu",
        STATE_OR_CITY_1489: "Hirakud",
        STATE_JK_CITY_1490: "Hiranagar",
        STATE_MH_CITY_1491: "Hirapur",
        STATE_MH_CITY_1492: "Hirapur Hamesha",
        STATE_KA_CITY_1493: "Hirekerur",
        STATE_KA_CITY_1494: "Hiriyur",
        STATE_HR_CITY_1495: "Hisar",
        STATE_BR_CITY_1496: "Hisua",
        STATE_HR_CITY_1497: "Hodal",
        STATE_AS_CITY_1498: "Hojai",
        STATE_KA_CITY_1499: "Holalkere",
        STATE_KA_CITY_1500: "Hole Narsipur",
        STATE_KA_CITY_1501: "Homnabad",
        STATE_KA_CITY_1502: "Honavar",
        STATE_KA_CITY_1503: "Honnali",
        STATE_WB_CITY_1504: "Hooghly district",
        STATE_KA_CITY_1505: "Hosanagara",
        STATE_KA_CITY_1506: "Hosangadi",
        STATE_KA_CITY_1507: "Hosdurga",
        STATE_MP_CITY_1508: "Hoshangabad",
        STATE_PB_CITY_1509: "Hoshiarpur",
        STATE_KA_CITY_1510: "Hoskote",
        STATE_KA_CITY_1511: "Hospet",
        STATE_TN_CITY_1512: "Hosur",
        STATE_MH_CITY_1513: "Hotgi",
        STATE_AS_CITY_1514: "Howli",
        STATE_WB_CITY_1515: "Howrah",
        STATE_KA_CITY_1516: "Hubli",
        STATE_KA_CITY_1517: "Hukeri",
        STATE_UP_CITY_1518: "Hulas",
        STATE_KA_CITY_1519: "Hungund",
        STATE_KA_CITY_1520: "Hunsur",
        STATE_JH_CITY_1521: "Husainabad",
        STATE_TG_CITY_1522: "Hyderabad",
        STATE_MP_CITY_1523: "Iawar",
        STATE_UP_CITY_1524: "Ibrahimpur",
        STATE_MH_CITY_1525: "Ichalkaranji",
        STATE_WB_CITY_1526: "Ichapur",
        STATE_AP_CITY_1527: "Ichchapuram",
        STATE_MP_CITY_1528: "Ichhawar",
        STATE_TN_CITY_1529: "Idappadi",
        STATE_GJ_CITY_1530: "Idar",
        STATE_KL_CITY_1531: "Idukki",
        STATE_MH_CITY_1532: "Igatpuri",
        STATE_UP_CITY_1533: "Iglas",
        STATE_UP_CITY_1534: "Ikauna",
        STATE_MP_CITY_1535: "Iklehra",
        STATE_TN_CITY_1536: "Ilampillai",
        STATE_KA_CITY_1537: "Ilkal",
        STATE_TN_CITY_1538: "Iluppur",
        STATE_MN_CITY_1539: "Imphal",
        STATE_HR_CITY_1540: "Inda Chhoi",
        STATE_MH_CITY_1541: "Indapur",
        STATE_UP_CITY_1542: "Indergarh",
        STATE_KA_CITY_1543: "Indi",
        STATE_MP_CITY_1544: "Indore",
        STATE_WB_CITY_1545: "Indpur community development block",
        STATE_UP_CITY_1546: "Indragarh",
        STATE_HR_CITY_1547: "Indri",
        STATE_WB_CITY_1548: "Ingraj Bazar",
        STATE_TN_CITY_1549: "Injambakkam",
        STATE_KL_CITY_1550: "Iringal",
        STATE_KL_CITY_1551: "Irinjalakuda",
        STATE_TN_CITY_1552: "Irugur",
        STATE_MP_CITY_1553: "Isagarh",
        STATE_PB_CITY_1554: "Ishanpur",
        STATE_UP_CITY_1555: "Islamnagar",
        STATE_UP_CITY_1556: "Islamnagar (Badaun)",
        STATE_BR_CITY_1557: "Islampur",
        STATE_WB_CITY_1558: "Islampur",
        STATE_AR_CITY_1559: "Itanagar",
        STATE_MP_CITY_1560: "Itarsi",
        STATE_UP_CITY_1561: "Itaunja",
        STATE_UP_CITY_1562: "Itimadpur",
        STATE_MP_CITY_1563: "Jabalpur",
        STATE_WB_CITY_1564: "Jafarpur",
        STATE_HR_CITY_1565: "Jagadhri",
        STATE_KA_CITY_1566: "Jagalur",
        STATE_JH_CITY_1567: "Jagannathpur",
        STATE_OR_CITY_1568: "Jagatsinghapur",
        STATE_OR_CITY_1569: "Jagatsinghpur",
        STATE_CT_CITY_1570: "Jagdalpur",
        STATE_UP_CITY_1571: "Jagdishpur",
        STATE_BR_CITY_1572: "Jagdispur",
        STATE_AP_CITY_1573: "Jaggayyapeta",
        STATE_UP_CITY_1574: "Jagnair",
        STATE_PB_CITY_1575: "Jagraon",
        STATE_TG_CITY_1576: "Jagtial",
        STATE_UP_CITY_1577: "Jahanabad",
        STATE_BR_CITY_1578: "Jahanabad",
        STATE_UP_CITY_1579: "Jahanabad (Pilibhit)",
        STATE_UP_CITY_1580: "Jahangirabad",
        STATE_UP_CITY_1581: "Jahangirpur",
        STATE_RJ_CITY_1582: "Jahazpur",
        STATE_WB_CITY_1583: "Jaigaon",
        STATE_UP_CITY_1584: "Jainpur",
        STATE_RJ_CITY_1585: "Jaipur",
        STATE_UP_CITY_1586: "Jais",
        STATE_RJ_CITY_1587: "Jaisalmer",
        STATE_MP_CITY_1588: "Jaisinghnagar",
        STATE_MH_CITY_1589: "Jaisingpur",
        STATE_MH_CITY_1590: "Jaitapur",
        STATE_RJ_CITY_1591: "Jaitaran",
        STATE_MP_CITY_1592: "Jaithari",
        STATE_PB_CITY_1593: "Jaito",
        STATE_OR_CITY_1594: "Jajpur",
        STATE_HR_CITY_1595: "Jakhal",
        STATE_MH_CITY_1596: "Jakhangaon",
        STATE_GJ_CITY_1597: "Jakhau",
        STATE_TN_CITY_1598: "Jalakandapuram",
        STATE_UP_CITY_1599: "Jalalabad",
        STATE_PB_CITY_1600: "Jalalabad",
        STATE_UP_CITY_1601: "Jalali",
        STATE_GJ_CITY_1602: "Jalalpore",
        STATE_GJ_CITY_1603: "Jalalpur",
        STATE_UP_CITY_1604: "Jalalpur",
        STATE_PB_CITY_1605: "Jalandhar",
        STATE_TN_CITY_1606: "Jalarpet",
        STATE_UP_CITY_1607: "Jalaun",
        STATE_UP_CITY_1608: "Jalesar",
        STATE_OR_CITY_1609: "Jaleshwar",
        STATE_MH_CITY_1610: "Jalgaon",
        STATE_MH_CITY_1611: "Jalgaon Jamod",
        STATE_GJ_CITY_1612: "Jalia",
        STATE_MH_CITY_1613: "Jalkot",
        STATE_MH_CITY_1614: "Jalna",
        STATE_RJ_CITY_1615: "Jalor",
        STATE_RJ_CITY_1616: "Jalore",
        STATE_WB_CITY_1617: "Jalpaiguri",
        STATE_JH_CITY_1618: "Jamadoba",
        STATE_MP_CITY_1619: "Jamai",
        STATE_BR_CITY_1620: "Jamalpur",
        STATE_GJ_CITY_1621: "Jambuda",
        STATE_GJ_CITY_1622: "Jambusar",
        STATE_KA_CITY_1623: "Jamkhandi",
        STATE_MH_CITY_1624: "Jamkhed",
        STATE_AP_CITY_1625: "Jammalamadugu",
        STATE_JK_CITY_1626: "Jammu",
        STATE_GJ_CITY_1627: "Jamnagar",
        STATE_MH_CITY_1628: "Jamod",
        STATE_JH_CITY_1629: "Jamshedpur",
        STATE_JH_CITY_1630: "Jamtara",
        STATE_BR_CITY_1631: "Jamui",
        STATE_WB_CITY_1632: "Jamuria",
        STATE_PB_CITY_1633: "Jandiala",
        STATE_PB_CITY_1634: "Jandiala Guru",
        STATE_MH_CITY_1635: "Janephal",
        STATE_TG_CITY_1636: "Jangaon",
        STATE_UP_CITY_1637: "Janghai",
        STATE_WB_CITY_1638: "Jangipur",
        STATE_TG_CITY_1639: "Jangoan",
        STATE_CT_CITY_1640: "Janjgir",
        STATE_CT_CITY_1641: "Janjgir-Champa",
        STATE_UP_CITY_1642: "Jansath",
        STATE_MH_CITY_1643: "Jaoli",
        STATE_MP_CITY_1644: "Jaora",
        STATE_GJ_CITY_1645: "Jarod,",
        STATE_UP_CITY_1646: "Jarwa",
        STATE_UP_CITY_1647: "Jarwal",
        STATE_GJ_CITY_1648: "Jasdan",
        STATE_CT_CITY_1649: "Jashpur",
        STATE_CT_CITY_1650: "Jashpurnagar",
        STATE_JH_CITY_1651: "Jasidih",
        STATE_UT_CITY_1652: "Jaspur",
        STATE_UP_CITY_1653: "Jasrana",
        STATE_UP_CITY_1654: "Jaswantnagar",
        STATE_MH_CITY_1655: "Jat, Sangli",
        STATE_OR_CITY_1656: "Jatani",
        STATE_MP_CITY_1657: "Jatara",
        STATE_MH_CITY_1658: "Jategaon",
        STATE_UP_CITY_1659: "Jaunpur",
        STATE_JK_CITY_1660: "Jaurian",
        STATE_MP_CITY_1661: "Jawad",
        STATE_HP_CITY_1662: "Jawala Mukhi",
        STATE_MH_CITY_1663: "Jawhar",
        STATE_TN_CITY_1664: "Jayamkondacholapuram",
        STATE_TG_CITY_1665: "Jayashankar Bhupalapally",
        STATE_BR_CITY_1666: "Jaynagar",
        STATE_WB_CITY_1667: "Jaynagar Majilpur",
        STATE_MH_CITY_1668: "Jaysingpur",
        STATE_BR_CITY_1669: "Jehanabad",
        STATE_WB_CITY_1670: "Jejur",
        STATE_MH_CITY_1671: "Jejuri",
        STATE_GJ_CITY_1672: "Jetalpur",
        STATE_GJ_CITY_1673: "Jetalsar",
        STATE_GJ_CITY_1674: "Jetpur",
        STATE_GJ_CITY_1675: "Jetpur (Navagadh)",
        STATE_KA_CITY_1676: "Jevargi",
        STATE_UP_CITY_1677: "Jewar",
        STATE_OR_CITY_1678: "Jeypore",
        STATE_BR_CITY_1679: "Jha-Jha",
        STATE_MP_CITY_1680: "Jhabua",
        STATE_UP_CITY_1681: "Jhajhar",
        STATE_HR_CITY_1682: "Jhajjar",
        STATE_RJ_CITY_1683: "Jhalawar",
        STATE_WB_CITY_1684: "Jhalida",
        STATE_GJ_CITY_1685: "Jhalod",
        STATE_RJ_CITY_1686: "Jhalrapatan",
        STATE_UP_CITY_1687: "Jhalu",
        STATE_BR_CITY_1688: "Jhanjharpur",
        STATE_UP_CITY_1689: "Jhansi",
        STATE_WB_CITY_1690: "Jhargram",
        STATE_JH_CITY_1691: "Jharia",
        STATE_OR_CITY_1692: "Jharsuguda",
        STATE_OR_CITY_1693: "Jharsuguda District",
        STATE_WB_CITY_1694: "Jhilimili",
        STATE_UP_CITY_1695: "Jhinjhak",
        STATE_UP_CITY_1696: "Jhinjhana",
        STATE_GJ_CITY_1697: "Jhulasan",
        STATE_RJ_CITY_1698: "Jhunjhunun",
        STATE_UP_CITY_1699: "Jhusi",
        STATE_HR_CITY_1700: "Jind",
        STATE_MH_CITY_1701: "Jintur",
        STATE_MP_CITY_1702: "Jiran",
        STATE_UP_CITY_1703: "Jiyanpur",
        STATE_MP_CITY_1704: "Jobat",
        STATE_RJ_CITY_1705: "Jobner",
        STATE_GJ_CITY_1706: "Jodhpur",
        STATE_RJ_CITY_1707: "Jodhpur",
        STATE_GJ_CITY_1708: "Jodhpur (Ahmedabad)",
        STATE_GJ_CITY_1709: "Jodia",
        STATE_GJ_CITY_1710: "Jodiya Bandar",
        STATE_BR_CITY_1711: "Jogbani",
        STATE_MH_CITY_1712: "Jogeshwari",
        STATE_AS_CITY_1713: "Jogighopa",
        STATE_HP_CITY_1714: "Jogindarnagar",
        STATE_TG_CITY_1715: "Jogulamba Gadwal",
        STATE_SK_CITY_1716: "Jorethang",
        STATE_AS_CITY_1717: "Jorhat",
        STATE_UT_CITY_1718: "Joshimath",
        STATE_GA_CITY_1719: "Jua",
        STATE_HP_CITY_1720: "Jubbal",
        STATE_JH_CITY_1721: "Jugsalai",
        STATE_MH_CITY_1722: "Juhu",
        STATE_JH_CITY_1723: "Jumri Tilaiya",
        STATE_GJ_CITY_1724: "Junagadh",
        STATE_CT_CITY_1725: "Junagarh",
        STATE_MH_CITY_1726: "Junnar",
        STATE_HP_CITY_1727: "Jutogh",
        STATE_UP_CITY_1728: "Jyotiba Phule Nagar",
        STATE_CT_CITY_1729: "Kabeerdham",
        STATE_UP_CITY_1730: "Kabrai",
        STATE_GJ_CITY_1731: "Kachchh",
        STATE_GJ_CITY_1732: "Kachholi",
        STATE_UP_CITY_1733: "Kachhwa",
        STATE_MH_CITY_1734: "Kachurwahi",
        STATE_KL_CITY_1735: "Kadakkavoor",
        STATE_TN_CITY_1736: "Kadambur",
        STATE_UP_CITY_1737: "Kadaura",
        STATE_TN_CITY_1738: "Kadayanallur",
        STATE_MH_CITY_1739: "Kadegaon",
        STATE_GJ_CITY_1740: "Kadi",
        STATE_UP_CITY_1741: "Kadipur",
        STATE_AP_CITY_1742: "Kadiri",
        STATE_GJ_CITY_1743: "Kadod",
        STATE_KA_CITY_1744: "Kadur",
        STATE_MH_CITY_1745: "Kadus",
        STATE_MH_CITY_1746: "Kagal",
        STATE_UP_CITY_1747: "Kagarol",
        STATE_TG_CITY_1748: "Kagaznagar",
        STATE_MH_CITY_1749: "Kaij",
        STATE_AP_CITY_1750: "Kaikalur",
        STATE_MP_CITY_1751: "Kailaras",
        STATE_TR_CITY_1752: "Kailashahar",
        STATE_UP_CITY_1753: "Kaimganj",
        STATE_MP_CITY_1754: "Kaimori",
        STATE_BR_CITY_1755: "Kaimur District",
        STATE_OR_CITY_1756: "Kaintragarh",
        STATE_UP_CITY_1757: "Kairana",
        STATE_HR_CITY_1758: "Kaithal",
        STATE_MN_CITY_1759: "Kakching",
        STATE_WB_CITY_1760: "Kakdwip",
        STATE_AP_CITY_1761: "Kakinada",
        STATE_UP_CITY_1762: "Kakori",
        STATE_UP_CITY_1763: "Kakrala",
        STATE_UT_CITY_1764: "Kaladhungi",
        STATE_UT_CITY_1765: "Kalagarh Project Colony",
        STATE_OR_CITY_1766: "Kalahandi",
        STATE_WB_CITY_1767: "Kalaikunda",
        STATE_TN_CITY_1768: "Kalakkadu",
        STATE_KL_CITY_1769: "Kalamassery",
        STATE_MH_CITY_1770: "Kalamb",
        STATE_MH_CITY_1771: "Kalamb, Osmanabad",
        STATE_MH_CITY_1772: "Kalamboli",
        STATE_MH_CITY_1773: "Kalamnuri",
        STATE_PB_CITY_1774: "Kalanaur",
        STATE_HR_CITY_1775: "Kalanaur",
        STATE_HR_CITY_1776: "Kalanwali",
        STATE_MH_CITY_1777: "Kalas",
        STATE_GJ_CITY_1778: "Kalavad",
        STATE_TN_CITY_1779: "Kalavai",
        STATE_KL_CITY_1780: "Kalavoor",
        STATE_KA_CITY_1781: "Kalghatgi",
        STATE_MH_CITY_1782: "Kali(DK)",
        STATE_WB_CITY_1783: "Kaliaganj",
        STATE_JH_CITY_1784: "Kalikapur",
        STATE_WB_CITY_1785: "Kalimpong",
        STATE_UP_CITY_1786: "Kalinagar",
        STATE_HP_CITY_1787: "Kalka",
        STATE_TN_CITY_1788: "Kallakkurichchi",
        STATE_TN_CITY_1789: "Kallidaikurichi",
        STATE_TN_CITY_1790: "Kallupatti",
        STATE_MH_CITY_1791: "Kalmeshwar",
        STATE_WB_CITY_1792: "Kalna",
        STATE_GJ_CITY_1793: "Kalol",
        STATE_KL_CITY_1794: "Kalpatta",
        STATE_UP_CITY_1795: "Kalpi",
        STATE_TN_CITY_1796: "Kalugumalai",
        STATE_MH_CITY_1797: "Kalundri",
        STATE_MH_CITY_1798: "Kalyan",
        STATE_AP_CITY_1799: "Kalyandurg",
        STATE_WB_CITY_1800: "Kalyani",
        STATE_MH_CITY_1801: "Kalyani Nagar",
        STATE_UP_CITY_1802: "Kalyanpur",
        STATE_OR_CITY_1803: "Kamakhyanagar",
        STATE_AP_CITY_1804: "Kamalapuram",
        STATE_UP_CITY_1805: "Kamalganj",
        STATE_TR_CITY_1806: "Kamalpur",
        STATE_RJ_CITY_1807: "Kaman",
        STATE_TG_CITY_1808: "Kamareddi",
        STATE_TG_CITY_1809: "Kamareddy",
        STATE_MH_CITY_1810: "Kamargaon",
        STATE_WB_CITY_1811: "Kamarhati",
        STATE_WB_CITY_1812: "Kamarpukur",
        STATE_MH_CITY_1813: "Kamatgi",
        STATE_UP_CITY_1814: "Kampil",
        STATE_KA_CITY_1815: "Kampli",
        STATE_MH_CITY_1816: "Kamptee",
        STATE_AS_CITY_1817: "Kamrup",
        STATE_AS_CITY_1818: "Kamrup Metropolitan",
        STATE_MH_CITY_1819: "Kamthi",
        STATE_TN_CITY_1820: "Kamuthi",
        STATE_TN_CITY_1821: "Kanadukattan",
        STATE_TN_CITY_1822: "Kancheepuram",
        STATE_TN_CITY_1823: "Kanchipuram",
        STATE_WB_CITY_1824: "Kanchrapara",
        STATE_OR_CITY_1825: "Kandhamal",
        STATE_UP_CITY_1826: "Kandhla",
        STATE_WB_CITY_1827: "Kandi",
        STATE_GJ_CITY_1828: "Kandla",
        STATE_GJ_CITY_1829: "Kandla port",
        STATE_JH_CITY_1830: "Kandra",
        STATE_MH_CITY_1831: "Kandri",
        STATE_AP_CITY_1832: "Kandukur",
        STATE_HP_CITY_1833: "Kangar",
        STATE_TN_CITY_1834: "Kangayam",
        STATE_HP_CITY_1835: "Kangra",
        STATE_AP_CITY_1836: "Kanigiri",
        STATE_HR_CITY_1837: "Kanina Khas",
        STATE_KA_CITY_1838: "Kankanhalli",
        STATE_MH_CITY_1839: "Kankauli",
        STATE_MH_CITY_1840: "Kankavli",
        STATE_JH_CITY_1841: "Kanke",
        STATE_CT_CITY_1842: "Kanker",
        STATE_AP_CITY_1843: "Kankipadu",
        STATE_GA_CITY_1844: "Kankon",
        STATE_MH_CITY_1845: "Kannad",
        STATE_KL_CITY_1846: "Kannangad",
        STATE_UP_CITY_1847: "Kannauj",
        STATE_KL_CITY_1848: "Kannavam",
        STATE_TN_CITY_1849: "Kanniyakumari",
        STATE_MP_CITY_1850: "Kannod",
        STATE_KL_CITY_1851: "Kannur",
        STATE_GJ_CITY_1852: "Kanodar",
        STATE_RJ_CITY_1853: "Kanor",
        STATE_UP_CITY_1854: "Kanpur",
        STATE_UP_CITY_1855: "Kanpur Dehat",
        STATE_UP_CITY_1856: "Kant",
        STATE_OR_CITY_1857: "Kantabanji",
        STATE_UP_CITY_1858: "Kanth",
        STATE_OR_CITY_1859: "Kantilo",
        STATE_AP_CITY_1860: "Kanuru",
        STATE_GJ_CITY_1861: "Kapadvanj",
        STATE_RJ_CITY_1862: "Kapren",
        STATE_UP_CITY_1863: "Kaptanganj",
        STATE_PB_CITY_1864: "Kapurthala",
        STATE_UP_CITY_1865: "Kara",
        STATE_MH_CITY_1866: "Karad",
        STATE_PY_CITY_1867: "Karaikal",
        STATE_TN_CITY_1868: "Karaikkudi",
        STATE_MH_CITY_1869: "Karajagi",
        STATE_TN_CITY_1870: "Karamadai",
        STATE_TN_CITY_1871: "Karambakkudi",
        STATE_GJ_CITY_1872: "Karamsad",
        STATE_MH_CITY_1873: "Karanja",
        STATE_MH_CITY_1874: "Karanja Lad",
        STATE_RJ_CITY_1875: "Karanpur",
        STATE_UP_CITY_1876: "Karari",
        STATE_RJ_CITY_1877: "Karauli",
        STATE_AS_CITY_1878: "Karbi Anglong",
        STATE_UP_CITY_1879: "Karbigwan",
        STATE_UP_CITY_1880: "Karchana",
        STATE_MP_CITY_1881: "Kareli",
        STATE_MP_CITY_1882: "Karera",
        STATE_LA_CITY_1883: "Kargil",
        STATE_UP_CITY_1884: "Karhal",
        STATE_GJ_CITY_1885: "Kariana",
        STATE_TN_CITY_1886: "Kariapatti",
        STATE_AS_CITY_1887: "Karimganj",
        STATE_TG_CITY_1888: "Karimnagar",
        STATE_WB_CITY_1889: "Karimpur",
        STATE_GJ_CITY_1890: "Karjan",
        STATE_MH_CITY_1891: "Karjat",
        STATE_KA_CITY_1892: "Karkala",
        STATE_MH_CITY_1893: "Karkamb",
        STATE_MH_CITY_1894: "Karmala",
        STATE_HR_CITY_1895: "Karnal",
        STATE_DL_CITY_1896: "Karol Bagh",
        STATE_MP_CITY_1897: "Karrapur",
        STATE_PB_CITY_1898: "Kartarpur",
        STATE_TN_CITY_1899: "Karumbakkam",
        STATE_TN_CITY_1900: "Karur",
        STATE_KA_CITY_1901: "Karwar",
        STATE_MH_CITY_1902: "Kasara",
        STATE_KL_CITY_1903: "Kasaragod",
        STATE_KL_CITY_1904: "Kasaragod District",
        STATE_HP_CITY_1905: "Kasauli",
        STATE_BR_CITY_1906: "Kasba",
        STATE_UP_CITY_1907: "Kasganj",
        STATE_UT_CITY_1908: "Kashipur",
        STATE_MH_CITY_1909: "Kasoda",
        STATE_MP_CITY_1910: "Kasrawad",
        STATE_MP_CITY_1911: "Katangi",
        STATE_CT_CITY_1912: "Katghora",
        STATE_GJ_CITY_1913: "Kathor",
        STATE_JK_CITY_1914: "Kathua",
        STATE_MH_CITY_1915: "Kati",
        STATE_BR_CITY_1916: "Katihar",
        STATE_MP_CITY_1917: "Katni",
        STATE_MH_CITY_1918: "Katol",
        STATE_TN_CITY_1919: "Katpadi",
        STATE_GJ_CITY_1920: "Katpur",
        STATE_UP_CITY_1921: "Katra",
        STATE_JK_CITY_1922: "Katra",
        STATE_MH_CITY_1923: "Katral",
        STATE_JH_CITY_1924: "Katras",
        STATE_KL_CITY_1925: "Kattanam",
        STATE_TN_CITY_1926: "Kattivakkam",
        STATE_TN_CITY_1927: "Kattupputtur",
        STATE_WB_CITY_1928: "Katwa",
        STATE_UP_CITY_1929: "Kausani",
        STATE_UP_CITY_1930: "Kaushambi District",
        STATE_AP_CITY_1931: "Kavali",
        STATE_KA_CITY_1932: "Kavalur",
        STATE_GJ_CITY_1933: "Kavant",
        STATE_LD_CITY_1934: "Kavaratti",
        STATE_TN_CITY_1935: "Kaveripatnam",
        STATE_GJ_CITY_1936: "Kawant",
        STATE_CT_CITY_1937: "Kawardha",
        STATE_TN_CITY_1938: "Kayalpattinam",
        STATE_KL_CITY_1939: "Kayankulam",
        STATE_TN_CITY_1940: "Kayattar",
        STATE_GJ_CITY_1941: "Kayavarohan",
        STATE_TN_CITY_1942: "Keelakarai",
        STATE_RJ_CITY_1943: "Kekri",
        STATE_TN_CITY_1944: "Kelamangalam",
        STATE_UP_CITY_1945: "Kemri",
        STATE_WB_CITY_1946: "Kenda",
        STATE_OR_CITY_1947: "Kendrapara",
        STATE_OR_CITY_1948: "Kendraparha",
        STATE_JH_CITY_1949: "Kenduadih",
        STATE_OR_CITY_1950: "Kendujhar",
        STATE_KA_CITY_1951: "Kerur",
        STATE_GJ_CITY_1952: "Kerwada",
        STATE_WB_CITY_1953: "Keshabpur",
        STATE_GJ_CITY_1954: "Keshod",
        STATE_RJ_CITY_1955: "Keshorai Patan",
        STATE_OR_CITY_1956: "Kesinga",
        STATE_MP_CITY_1957: "Khachrod",
        STATE_UP_CITY_1958: "Khada",
        STATE_MH_CITY_1959: "Khadki",
        STATE_UP_CITY_1960: "Khaga",
        STATE_BR_CITY_1961: "Khagaria",
        STATE_BR_CITY_1962: "Khagaul",
        STATE_MP_CITY_1963: "Khailar",
        STATE_UP_CITY_1964: "Khailar",
        STATE_UP_CITY_1965: "Khair",
        STATE_UP_CITY_1966: "Khairabad",
        STATE_CT_CITY_1967: "Khairagarh",
        STATE_MP_CITY_1968: "Khajuraho Group of Monuments",
        STATE_MH_CITY_1969: "Khalapur",
        STATE_UP_CITY_1970: "Khalilabad",
        STATE_MH_CITY_1971: "Khallar",
        STATE_OR_CITY_1972: "Khallikot",
        STATE_PB_CITY_1973: "Khamanon",
        STATE_MP_CITY_1974: "Khamaria",
        STATE_GJ_CITY_1975: "Khambhalia",
        STATE_GJ_CITY_1976: "Khambhat",
        STATE_MH_CITY_1977: "Khamgaon",
        STATE_CT_CITY_1978: "Khamharia",
        STATE_TG_CITY_1979: "Khammam",
        STATE_KA_CITY_1980: "Khanapur",
        STATE_MH_CITY_1981: "Khanapur",
        STATE_MH_CITY_1982: "Khandala",
        STATE_RJ_CITY_1983: "Khandela",
        STATE_MP_CITY_1984: "Khandwa",
        STATE_MP_CITY_1985: "Khandwa district",
        STATE_MH_CITY_1986: "Khangaon",
        STATE_PB_CITY_1987: "Khanna",
        STATE_UP_CITY_1988: "Khanpur",
        STATE_RJ_CITY_1989: "Khanpur",
        STATE_MH_CITY_1990: "Khapa",
        STATE_BR_CITY_1991: "Kharagpur",
        STATE_WB_CITY_1992: "Kharagpur",
        STATE_MH_CITY_1993: "Kharakvasla",
        STATE_PB_CITY_1994: "Kharar",
        STATE_WB_CITY_1995: "Kharar",
        STATE_WB_CITY_1996: "Kharba",
        STATE_MH_CITY_1997: "Kharda",
        STATE_WB_CITY_1998: "Khardaha",
        STATE_UP_CITY_1999: "Kharela",
        STATE_MP_CITY_2000: "Khargapur",
        STATE_MH_CITY_2001: "Kharghar",
        STATE_MP_CITY_2002: "Khargone",
        STATE_UP_CITY_2003: "Khargupur",
        STATE_OR_CITY_2004: "Kharhial",
        STATE_HR_CITY_2005: "Kharkhauda",
        STATE_UP_CITY_2006: "Kharkhauda",
        STATE_CT_CITY_2007: "Kharod",
        STATE_JH_CITY_2008: "Kharsawan",
        STATE_CT_CITY_2009: "Kharsia",
        STATE_MH_CITY_2010: "Kharsundi",
        STATE_AS_CITY_2011: "Kharupatia",
        STATE_UP_CITY_2012: "Khatauli",
        STATE_MP_CITY_2013: "Khategaon",
        STATE_UT_CITY_2014: "Khatima",
        STATE_WB_CITY_2015: "Khatra",
        STATE_JK_CITY_2016: "Khaur",
        STATE_GJ_CITY_2017: "Khavda",
        STATE_MZ_CITY_2018: "Khawhai",
        STATE_MH_CITY_2019: "Khed",
        STATE_GJ_CITY_2020: "Kheda",
        STATE_GJ_CITY_2021: "Khedbrahma",
        STATE_MH_CITY_2022: "Khede",
        STATE_GJ_CITY_2023: "Khedoi",
        STATE_UP_CITY_2024: "Khekra",
        STATE_PB_CITY_2025: "Khemkaran",
        STATE_GJ_CITY_2026: "Kherali",
        STATE_GJ_CITY_2027: "Kheralu",
        STATE_UP_CITY_2028: "Kheri",
        STATE_HR_CITY_2029: "Kheri Sampla",
        STATE_MH_CITY_2030: "Khetia",
        STATE_RJ_CITY_2031: "Khetri",
        STATE_MP_CITY_2032: "Khilchipur",
        STATE_MP_CITY_2033: "Khirkiyan",
        STATE_MH_CITY_2034: "Khoni",
        STATE_AR_CITY_2035: "Khonsa",
        STATE_MH_CITY_2036: "Khopoli",
        STATE_OR_CITY_2037: "Khordha",
        STATE_TR_CITY_2038: "Khowai",
        STATE_UP_CITY_2039: "Khudaganj",
        STATE_MP_CITY_2040: "Khujner",
        STATE_MH_CITY_2041: "Khuldabad",
        STATE_JH_CITY_2042: "Khunti",
        STATE_MP_CITY_2043: "Khurai",
        STATE_OR_CITY_2044: "Khurda",
        STATE_UP_CITY_2045: "Khurja",
        STATE_BR_CITY_2046: "Khusropur",
        STATE_UP_CITY_2047: "Khutar",
        STATE_UT_CITY_2048: "Kichha",
        STATE_TN_CITY_2049: "Kil Bhuvanagiri",
        STATE_TN_CITY_2050: "Kilvelur",
        STATE_HP_CITY_2051: "Kinnaur",
        STATE_MH_CITY_2052: "Kinwat",
        STATE_UP_CITY_2053: "Kirakat",
        STATE_CT_CITY_2054: "Kirandul",
        STATE_TN_CITY_2055: "Kiranur",
        STATE_UP_CITY_2056: "Kiraoli",
        STATE_UP_CITY_2057: "Kiratpur",
        STATE_OR_CITY_2058: "Kiri Buru",
        STATE_WB_CITY_2059: "Kirnahar",
        STATE_BR_CITY_2060: "Kishanganj",
        STATE_RJ_CITY_2061: "Kishangarh",
        STATE_UP_CITY_2062: "Kishanpur",
        STATE_UP_CITY_2063: "Kishanpur baral",
        STATE_UP_CITY_2064: "Kishni",
        STATE_JK_CITY_2065: "Kishtwar",
        STATE_UP_CITY_2066: "Kithor",
        STATE_KL_CITY_2067: "Kizhake Chalakudi",
        STATE_BR_CITY_2068: "Koath",
        STATE_KA_CITY_2069: "Kodagu",
        STATE_TN_CITY_2070: "Kodaikanal",
        STATE_OR_CITY_2071: "Kodala",
        STATE_TG_CITY_2072: "Kodar",
        STATE_JH_CITY_2073: "Kodarma",
        STATE_KA_CITY_2074: "Kodigenahalli",
        STATE_GJ_CITY_2075: "Kodinar",
        STATE_KA_CITY_2076: "Kodlipet",
        STATE_MH_CITY_2077: "Kodoli",
        STATE_TN_CITY_2078: "Kodumudi",
        STATE_KL_CITY_2079: "Kodungallur",
        STATE_BR_CITY_2080: "Koelwar",
        STATE_NL_CITY_2081: "Kohima",
        STATE_AS_CITY_2082: "Kokrajhar",
        STATE_AP_CITY_2083: "Kolanukonda",
        STATE_KA_CITY_2084: "Kolar",
        STATE_MP_CITY_2085: "Kolaras",
        STATE_MZ_CITY_2086: "Kolasib",
        STATE_MZ_CITY_2087: "Kolasib district",
        STATE_MH_CITY_2088: "Kolhapur",
        STATE_WB_CITY_2089: "Kolkata",
        STATE_KL_CITY_2090: "Kollam",
        STATE_KA_CITY_2091: "Kollegal",
        STATE_TN_CITY_2092: "Kombai",
        STATE_KA_CITY_2093: "Konanur",
        STATE_OR_CITY_2094: "Konarka",
        STATE_UP_CITY_2095: "Konch",
        STATE_CT_CITY_2096: "Kondagaon",
        STATE_MH_CITY_2097: "Kondalwadi",
        STATE_AP_CITY_2098: "Kondapalle",
        STATE_MH_CITY_2099: "Kondhali",
        STATE_TN_CITY_2100: "Konganapuram",
        STATE_WB_CITY_2101: "Konnagar",
        STATE_KA_CITY_2102: "Konnur",
        STATE_TN_CITY_2103: "Koothanallur",
        STATE_UP_CITY_2104: "Kopaganj",
        STATE_MH_CITY_2105: "Kopar Khairane",
        STATE_MH_CITY_2106: "Kopargaon",
        STATE_MH_CITY_2107: "Kopela",
        STATE_KA_CITY_2108: "Koppa",
        STATE_KA_CITY_2109: "Koppal",
        STATE_TN_CITY_2110: "Koradachcheri",
        STATE_MH_CITY_2111: "Koradi",
        STATE_TN_CITY_2112: "Korampallam",
        STATE_OR_CITY_2113: "Koraput",
        STATE_KA_CITY_2114: "Koratagere",
        STATE_TG_CITY_2115: "Koratla",
        STATE_CT_CITY_2116: "Korba",
        STATE_MH_CITY_2117: "Koregaon",
        STATE_CT_CITY_2118: "Koriya",
        STATE_AP_CITY_2119: "Korukollu",
        STATE_MP_CITY_2120: "Korwai",
        STATE_GJ_CITY_2121: "Kosamba",
        STATE_UP_CITY_2122: "Kosi",
        STATE_AP_CITY_2123: "Kosigi",
        STATE_PB_CITY_2124: "Kot Isa Khan",
        STATE_UP_CITY_2125: "Kota",
        STATE_RJ_CITY_2126: "Kota",
        STATE_CT_CITY_2127: "Kota",
        STATE_TN_CITY_2128: "Kotagiri",
        STATE_KL_CITY_2129: "Kotamangalam",
        STATE_CT_CITY_2130: "Kotaparh",
        STATE_MP_CITY_2131: "Kotar",
        STATE_UT_CITY_2132: "Kotdwara",
        STATE_TG_CITY_2133: "Kothapet",
        STATE_GJ_CITY_2134: "Kothara",
        STATE_GJ_CITY_2135: "Kotharia",
        STATE_MP_CITY_2136: "Kothi",
        STATE_PB_CITY_2137: "Kotkapura",
        STATE_HP_CITY_2138: "Kotkhai",
        STATE_HP_CITY_2139: "Kotla",
        STATE_MP_CITY_2140: "Kotma",
        STATE_RJ_CITY_2141: "Kotputli",
        STATE_UP_CITY_2142: "Kotra",
        STATE_TG_CITY_2143: "Kottagudem",
        STATE_TN_CITY_2144: "Kottaiyur",
        STATE_TG_CITY_2145: "Kottapalli",
        STATE_KL_CITY_2146: "Kottayam",
        STATE_KA_CITY_2147: "Kotturu",
        STATE_MP_CITY_2148: "Kotwa",
        STATE_KL_CITY_2149: "Kovalam",
        STATE_TN_CITY_2150: "Kovilpatti",
        STATE_AP_CITY_2151: "Kovvur",
        STATE_MH_CITY_2152: "Koynanagar",
        STATE_KL_CITY_2153: "Kozhikode",
        STATE_AP_CITY_2154: "Krishna",
        STATE_TN_CITY_2155: "Krishnagiri",
        STATE_WB_CITY_2156: "Krishnanagar",
        STATE_WB_CITY_2157: "Krishnapur",
        STATE_KA_CITY_2158: "Krishnarajpet",
        STATE_WB_CITY_2159: "Kshirpai",
        STATE_OR_CITY_2160: "Kuchaiburi",
        STATE_RJ_CITY_2161: "Kuchaman",
        STATE_RJ_CITY_2162: "Kuchera",
        STATE_UP_CITY_2163: "Kuchesar",
        STATE_OR_CITY_2164: "Kuchinda",
        STATE_JK_CITY_2165: "Kud",
        STATE_KA_CITY_2166: "Kudachi",
        STATE_MH_CITY_2167: "Kudal",
        STATE_UP_CITY_2168: "Kudarkot",
        STATE_KA_CITY_2169: "Kudligi",
        STATE_MH_CITY_2170: "Kuhi",
        STATE_JH_CITY_2171: "Kuju",
        STATE_GJ_CITY_2172: "Kukarmunda",
        STATE_TG_CITY_2173: "Kukatpalli",
        STATE_GJ_CITY_2174: "Kukma",
        STATE_MP_CITY_2175: "Kukshi",
        STATE_TN_CITY_2176: "Kulattur",
        STATE_JK_CITY_2177: "Kulgam",
        STATE_TN_CITY_2178: "Kulittalai",
        STATE_UP_CITY_2179: "Kulpahar",
        STATE_WB_CITY_2180: "Kulpi",
        STATE_WB_CITY_2181: "Kultali",
        STATE_WB_CITY_2182: "Kulti",
        STATE_HP_CITY_2183: "Kulu",
        STATE_TN_CITY_2184: "Kumaralingam",
        STATE_TN_CITY_2185: "Kumbakonam",
        STATE_KL_CITY_2186: "Kumbalam",
        STATE_MP_CITY_2187: "Kumbhraj",
        STATE_CT_CITY_2188: "Kumhari",
        STATE_RJ_CITY_2189: "Kumher",
        STATE_KA_CITY_2190: "Kumsi",
        STATE_KA_CITY_2191: "Kumta",
        STATE_UP_CITY_2192: "Kunda",
        STATE_UP_CITY_2193: "Kundarkhi",
        STATE_UP_CITY_2194: "Kundarki",
        STATE_KA_CITY_2195: "Kundgol",
        STATE_GJ_CITY_2196: "Kundla",
        STATE_KA_CITY_2197: "Kunigal",
        STATE_KL_CITY_2198: "Kunnamangalam",
        STATE_KL_CITY_2199: "Kunnamkulam",
        STATE_TN_CITY_2200: "Kunnattur",
        STATE_KL_CITY_2201: "Kunnumma",
        STATE_AP_CITY_2202: "Kuppam",
        STATE_JK_CITY_2203: "Kupwara",
        STATE_MH_CITY_2204: "Kurandvad",
        STATE_MH_CITY_2205: "Kurankhed",
        STATE_UP_CITY_2206: "Kurara",
        STATE_MH_CITY_2207: "Kurduvadi",
        STATE_UP_CITY_2208: "Kurebhar,saidkhanpur",
        STATE_KA_CITY_2209: "Kurgunta",
        STATE_TN_CITY_2210: "Kurinjippadi",
        STATE_AP_CITY_2211: "Kurnool",
        STATE_WB_CITY_2212: "Kurseong",
        STATE_CT_CITY_2213: "Kurud",
        STATE_HR_CITY_2214: "Kurukshetra",
        STATE_AR_CITY_2215: "Kurung Kumey",
        STATE_RJ_CITY_2216: "Kushalgarh",
        STATE_KA_CITY_2217: "Kushalnagar",
        STATE_UP_CITY_2218: "Kushinagar",
        STATE_KA_CITY_2219: "Kushtagi",
        STATE_UP_CITY_2220: "Kusmara",
        STATE_MH_CITY_2221: "Kusumba",
        STATE_GJ_CITY_2222: "Kutch district",
        STATE_UP_CITY_2223: "Kuthaund",
        STATE_KL_CITY_2224: "Kutiatodu",
        STATE_GJ_CITY_2225: "Kutiyana",
        STATE_TN_CITY_2226: "Kuttalam",
        STATE_KL_CITY_2227: "Kuttampuzha",
        STATE_TN_CITY_2228: "Kuzhithurai",
        STATE_TG_CITY_2229: "Kyathampalle",
        STATE_HP_CITY_2230: "Kyelang",
        STATE_RJ_CITY_2231: "Lachhmangarh Sikar",
        STATE_JK_CITY_2232: "Ladakh",
        STATE_RJ_CITY_2233: "Ladnun",
        STATE_GJ_CITY_2234: "Ladol",
        STATE_HR_CITY_2235: "Ladwa",
        STATE_MP_CITY_2236: "Lahar",
        STATE_UP_CITY_2237: "Laharpur",
        STATE_HP_CITY_2238: "Lahul and Spiti",
        STATE_MH_CITY_2239: "Lakhandur",
        STATE_RJ_CITY_2240: "Lakheri",
        STATE_AS_CITY_2241: "Lakhimpur",
        STATE_UP_CITY_2242: "Lakhimpur",
        STATE_AS_CITY_2243: "Lakhipur",
        STATE_BR_CITY_2244: "Lakhisarai",
        STATE_UP_CITY_2245: "Lakhna",
        STATE_MP_CITY_2246: "Lakhnadon",
        STATE_GJ_CITY_2247: "Lakhpat",
        STATE_GJ_CITY_2248: "Lakhtar",
        STATE_UT_CITY_2249: "Laksar",
        STATE_LD_CITY_2250: "Lakshadweep",
        STATE_TG_CITY_2251: "Lakshettipet",
        STATE_KA_CITY_2252: "Lakshmeshwar",
        STATE_TG_CITY_2253: "Lal Bahadur Nagar",
        STATE_AS_CITY_2254: "Lala",
        STATE_KL_CITY_2255: "Lalam",
        STATE_BR_CITY_2256: "Lalganj",
        STATE_UP_CITY_2257: "Lalganj",
        STATE_WB_CITY_2258: "Lalgarh",
        STATE_WB_CITY_2259: "Lalgola",
        STATE_TN_CITY_2260: "Lalgudi",
        STATE_UP_CITY_2261: "Lalitpur",
        STATE_GJ_CITY_2262: "Lalpur",
        STATE_RJ_CITY_2263: "Lalsot",
        STATE_UP_CITY_2264: "Lambhua",
        STATE_GJ_CITY_2265: "Langhnaj",
        STATE_MH_CITY_2266: "Lanja",
        STATE_UT_CITY_2267: "Lansdowne",
        STATE_UP_CITY_2268: "Lar",
        STATE_MH_CITY_2269: "Lasalgaon",
        STATE_JH_CITY_2270: "Latehar",
        STATE_GJ_CITY_2271: "Lathi",
        STATE_MH_CITY_2272: "Latur",
        STATE_PB_CITY_2273: "Laungowal",
        STATE_MH_CITY_2274: "Lavasa",
        STATE_UP_CITY_2275: "Lawar",
        STATE_UP_CITY_2276: "Lawar Khas",
        STATE_MZ_CITY_2277: "Lawngtlai",
        STATE_LA_CITY_2278: "Leh",
        STATE_MP_CITY_2279: "Leteri",
        STATE_GJ_CITY_2280: "Limbdi",
        STATE_GJ_CITY_2281: "Limkheda",
        STATE_KA_CITY_2282: "Lingsugur",
        STATE_MP_CITY_2283: "Lodhikheda",
        STATE_UT_CITY_2284: "Lohaghat",
        STATE_JH_CITY_2285: "Lohardaga",
        STATE_HR_CITY_2286: "Loharu",
        STATE_AR_CITY_2287: "Lohit District",
        STATE_MH_CITY_2288: "Lohogaon",
        STATE_MH_CITY_2289: "Lonar",
        STATE_MH_CITY_2290: "Lonavla",
        STATE_KA_CITY_2291: "Londa",
        STATE_UP_CITY_2292: "Loni",
        STATE_CT_CITY_2293: "Lormi",
        STATE_RJ_CITY_2294: "Losal",
        STATE_AR_CITY_2295: "Lower Dibang Valley",
        STATE_AR_CITY_2296: "Lower Subansiri",
        STATE_WB_CITY_2297: "Loyabad",
        STATE_BR_CITY_2298: "Luckeesarai",
        STATE_UP_CITY_2299: "Lucknow",
        STATE_UP_CITY_2300: "Lucknow District",
        STATE_PB_CITY_2301: "Ludhiana",
        STATE_AS_CITY_2302: "Lumding Railway Colony",
        STATE_GJ_CITY_2303: "Lunavada",
        STATE_MZ_CITY_2304: "Lunglei",
        STATE_MP_CITY_2305: "Machalpur",
        STATE_AP_CITY_2306: "Macherla",
        STATE_UP_CITY_2307: "Machhali Shahar",
        STATE_PB_CITY_2308: "Machhiwara",
        STATE_UP_CITY_2309: "Machhlishahr",
        STATE_AP_CITY_2310: "Machilipatnam",
        STATE_TN_CITY_2311: "Madambakkam",
        STATE_AP_CITY_2312: "Madanapalle",
        STATE_WB_CITY_2313: "Madanpur",
        STATE_KA_CITY_2314: "Maddagiri",
        STATE_KA_CITY_2315: "Maddur",
        STATE_GA_CITY_2316: "Madgaon",
        STATE_GJ_CITY_2317: "Madhavpur Ghed",
        STATE_BR_CITY_2318: "Madhepura",
        STATE_GJ_CITY_2319: "Madhi",
        STATE_BR_CITY_2320: "Madhipura",
        STATE_UP_CITY_2321: "Madhoganj",
        STATE_MP_CITY_2322: "Madhogarh",
        STATE_UP_CITY_2323: "Madhogarh",
        STATE_BR_CITY_2324: "Madhubani",
        STATE_JH_CITY_2325: "Madhupur",
        STATE_WB_CITY_2326: "Madhyamgram",
        STATE_KA_CITY_2327: "Madikeri",
        STATE_TN_CITY_2328: "Madipakkam",
        STATE_AP_CITY_2329: "Madugula",
        STATE_TN_CITY_2330: "Madukkarai",
        STATE_TN_CITY_2331: "Madukkur",
        STATE_TN_CITY_2332: "Madurai",
        STATE_TN_CITY_2333: "Madurantakam",
        STATE_KA_CITY_2334: "Magadi",
        STATE_JK_CITY_2335: "Magam",
        STATE_UP_CITY_2336: "Maghar",
        STATE_MH_CITY_2337: "Mahabaleshwar",
        STATE_UP_CITY_2338: "Mahaban",
        STATE_TG_CITY_2339: "Mahabubabad",
        STATE_MH_CITY_2340: "Mahad",
        STATE_KA_CITY_2341: "Mahalingpur",
        STATE_HR_CITY_2342: "Maham",
        STATE_MH_CITY_2343: "Mahape",
        STATE_BR_CITY_2344: "Maharajgani",
        STATE_UP_CITY_2345: "Maharajganj",
        STATE_CT_CITY_2346: "Mahasamund",
        STATE_TG_CITY_2347: "Mahbubnagar",
        STATE_PY_CITY_2348: "Mahe",
        STATE_KL_CITY_2349: "Mahē",
        STATE_GJ_CITY_2350: "Mahemdavad",
        STATE_HR_CITY_2351: "Mahendragarh",
        STATE_GJ_CITY_2352: "Mahesana",
        STATE_MP_CITY_2353: "Maheshwar",
        STATE_MP_CITY_2354: "Mahgawan",
        STATE_WB_CITY_2355: "Mahiari",
        STATE_MH_CITY_2356: "Mahim",
        STATE_GJ_CITY_2357: "Mahisa",
        STATE_WB_CITY_2358: "Mahishadal community development block",
        STATE_UP_CITY_2359: "Mahmudabad",
        STATE_UP_CITY_2360: "Mahoba",
        STATE_UP_CITY_2361: "Maholi",
        STATE_UP_CITY_2362: "Mahrajganj",
        STATE_UP_CITY_2363: "Mahrajganj (Raebareli)",
        STATE_UP_CITY_2364: "Mahroni",
        STATE_GJ_CITY_2365: "Mahudha",
        STATE_UP_CITY_2366: "Mahul",
        STATE_AS_CITY_2367: "Mahur",
        STATE_GJ_CITY_2368: "Mahuva",
        STATE_GJ_CITY_2369: "Mahuva (Surat)",
        STATE_RJ_CITY_2370: "Mahwah",
        STATE_AS_CITY_2371: "Maibong",
        STATE_MP_CITY_2372: "Maihar",
        STATE_UP_CITY_2373: "Mailani",
        STATE_WB_CITY_2374: "Mainaguri",
        STATE_MH_CITY_2375: "Maindargi",
        STATE_UP_CITY_2376: "Mainpuri",
        STATE_ML_CITY_2377: "Mairang",
        STATE_BR_CITY_2378: "Mairwa",
        STATE_MH_CITY_2379: "Majalgaon",
        STATE_MP_CITY_2380: "Majholi",
        STATE_UP_CITY_2381: "Majhupur",
        STATE_PB_CITY_2382: "Majitha",
        STATE_UP_CITY_2383: "Makanpur",
        STATE_MH_CITY_2384: "Makhjan",
        STATE_PB_CITY_2385: "Makhu",
        STATE_RJ_CITY_2386: "Makrana",
        STATE_MP_CITY_2387: "Maksi",
        STATE_AS_CITY_2388: "Makum",
        STATE_MH_CITY_2389: "Malabar Hill",
        STATE_MH_CITY_2390: "Malad",
        STATE_OR_CITY_2391: "Malakanagiri",
        STATE_KL_CITY_2392: "Malappuram",
        STATE_UP_CITY_2393: "Malasa",
        STATE_PB_CITY_2394: "Malaut",
        STATE_KA_CITY_2395: "Malavalli",
        STATE_MH_CITY_2396: "Malegaon",
        STATE_PB_CITY_2397: "Malerkotla",
        STATE_MP_CITY_2398: "Malhargarh",
        STATE_UP_CITY_2399: "Malihabad",
        STATE_TG_CITY_2400: "Malkajgiri",
        STATE_OR_CITY_2401: "Malkangiri",
        STATE_MH_CITY_2402: "Malkapur",
        STATE_JH_CITY_2403: "Malkera",
        STATE_TN_CITY_2404: "Mallapuram",
        STATE_TN_CITY_2405: "Mallasamudram",
        STATE_TN_CITY_2406: "Mallur",
        STATE_KA_CITY_2407: "Malpe",
        STATE_GJ_CITY_2408: "Malpur",
        STATE_RJ_CITY_2409: "Malpura",
        STATE_KA_CITY_2410: "Malur",
        STATE_MH_CITY_2411: "Malvan",
        STATE_MZ_CITY_2412: "Mamit",
        STATE_TN_CITY_2413: "Manali",
        STATE_HP_CITY_2414: "Manali",
        STATE_TN_CITY_2415: "Manalurpettai",
        STATE_TN_CITY_2416: "Manamadurai",
        STATE_TN_CITY_2417: "Manappakkam",
        STATE_TN_CITY_2418: "Manapparai",
        STATE_MP_CITY_2419: "Manasa",
        STATE_GJ_CITY_2420: "Manavadar",
        STATE_TN_CITY_2421: "Manavalakurichi",
        STATE_MP_CITY_2422: "Manawar",
        STATE_MH_CITY_2423: "Manchar",
        STATE_TG_CITY_2424: "Mancheral",
        STATE_RJ_CITY_2425: "Mandal",
        STATE_GJ_CITY_2426: "Mandal",
        STATE_RJ_CITY_2427: "Mandalgarh",
        STATE_TG_CITY_2428: "Mandamarri",
        STATE_MH_CITY_2429: "Mandangad",
        STATE_TN_CITY_2430: "Mandapam",
        STATE_AP_CITY_2431: "Mandapeta",
        STATE_AP_CITY_2432: "Mandasa",
        STATE_UP_CITY_2433: "Mandawar",
        STATE_RJ_CITY_2434: "Mandawar",
        STATE_MH_CITY_2435: "Mandhal",
        STATE_HR_CITY_2436: "Mandholi Kalan",
        STATE_HP_CITY_2437: "Mandi",
        STATE_MP_CITY_2438: "Mandideep",
        STATE_MP_CITY_2439: "Mandla",
        STATE_MP_CITY_2440: "Mandleshwar",
        STATE_MP_CITY_2441: "Mandsaur",
        STATE_GJ_CITY_2442: "Mandvi",
        STATE_GJ_CITY_2443: "Mandvi (Surat)",
        STATE_MH_CITY_2444: "Mandwa",
        STATE_KA_CITY_2445: "Mandya",
        STATE_BR_CITY_2446: "Maner",
        STATE_AP_CITY_2447: "Mangalagiri",
        STATE_TN_CITY_2448: "Mangalam",
        STATE_AS_CITY_2449: "Mangaldai",
        STATE_KA_CITY_2450: "Mangalore",
        STATE_SK_CITY_2451: "Mangan",
        STATE_MH_CITY_2452: "Mangaon",
        STATE_MP_CITY_2453: "Mangawan",
        STATE_UT_CITY_2454: "Manglaur",
        STATE_GJ_CITY_2455: "Mangrol",
        STATE_RJ_CITY_2456: "Mangrol",
        STATE_GJ_CITY_2457: "Mangrol (Junagadh)",
        STATE_MH_CITY_2458: "Mangrul Pir",
        STATE_UP_CITY_2459: "Maniar",
        STATE_BR_CITY_2460: "Manihari",
        STATE_WB_CITY_2461: "Manikpara",
        STATE_UP_CITY_2462: "Manikpur",
        STATE_KA_CITY_2463: "Manipal",
        STATE_KL_CITY_2464: "Manjeri",
        STATE_KL_CITY_2465: "Manjēshvar",
        STATE_UP_CITY_2466: "Manjhanpur",
        STATE_MH_CITY_2467: "Manjlegaon",
        STATE_ML_CITY_2468: "Mankachar",
        STATE_UP_CITY_2469: "Mankapur",
        STATE_MH_CITY_2470: "Mankeshwar",
        STATE_MH_CITY_2471: "Mankhurd",
        STATE_MH_CITY_2472: "Manmad",
        STATE_KL_CITY_2473: "Mannarakkat",
        STATE_TN_CITY_2474: "Mannargudi",
        STATE_RJ_CITY_2475: "Manohar Thana",
        STATE_RJ_CITY_2476: "Manoharpur",
        STATE_JH_CITY_2477: "Manoharpur",
        STATE_MH_CITY_2478: "Manor",
        STATE_MP_CITY_2479: "Manpur",
        STATE_GJ_CITY_2480: "Mansa",
        STATE_PB_CITY_2481: "Mansa",
        STATE_MH_CITY_2482: "Mansar",
        STATE_TG_CITY_2483: "Manthani",
        STATE_TG_CITY_2484: "Manuguru",
        STATE_KA_CITY_2485: "Manvi",
        STATE_MH_CITY_2486: "Manwat",
        STATE_MH_CITY_2487: "Manwath",
        STATE_GA_CITY_2488: "Mapuca",
        STATE_UP_CITY_2489: "Marahra",
        STATE_TN_CITY_2490: "Marakkanam",
        STATE_TN_CITY_2491: "Marandahalli",
        STATE_KL_CITY_2492: "Marayur",
        STATE_MH_CITY_2493: "Maregaon",
        STATE_AR_CITY_2494: "Margherita",
        STATE_BR_CITY_2495: "Marhaura",
        STATE_UP_CITY_2496: "Mariahu",
        STATE_AS_CITY_2497: "Mariani",
        STATE_AP_CITY_2498: "Markapur",
        STATE_BR_CITY_2499: "Masaurhi Buzurg",
        STATE_WB_CITY_2500: "Masila",
        STATE_TN_CITY_2501: "Masinigudi",
        STATE_MH_CITY_2502: "Mastiholi",
        STATE_MH_CITY_2503: "Masur, India",
        STATE_UP_CITY_2504: "Mataundh",
        STATE_WB_CITY_2505: "Mathabhanga",
        STATE_MH_CITY_2506: "Matheran",
        STATE_UP_CITY_2507: "Mathura",
        STATE_WB_CITY_2508: "Matiali community development block",
        STATE_WB_CITY_2509: "Matigara community development block",
        STATE_KL_CITY_2510: "Mattanur",
        STATE_TN_CITY_2511: "Mattur",
        STATE_MH_CITY_2512: "Matunga",
        STATE_MP_CITY_2513: "Mau",
        STATE_UP_CITY_2514: "Mau",
        STATE_UP_CITY_2515: "Mau Aima",
        STATE_UP_CITY_2516: "Mau Aimma",
        STATE_UP_CITY_2517: "Maudaha",
        STATE_MP_CITY_2518: "Mauganj",
        STATE_PB_CITY_2519: "Maur Mandi",
        STATE_UP_CITY_2520: "Mauranwan",
        STATE_UP_CITY_2521: "Maurawan",
        STATE_KL_CITY_2522: "Mavelikara",
        STATE_KL_CITY_2523: "Mavoor",
        STATE_UP_CITY_2524: "Mawana",
        STATE_UP_CITY_2525: "Mawar",
        STATE_KA_CITY_2526: "Mayakonda",
        STATE_MN_CITY_2527: "Mayang Imphal",
        STATE_TN_CITY_2528: "Mayiladuthurai",
        STATE_OR_CITY_2529: "Mayurbhanj",
        STATE_MH_CITY_2530: "Mazagaon",
        STATE_TG_CITY_2531: "Medak",
        STATE_TG_CITY_2532: "Medchal",
        STATE_TG_CITY_2533: "Medchal Malkajgiri",
        STATE_WB_CITY_2534: "Medinipur",
        STATE_UP_CITY_2535: "Meerut",
        STATE_RJ_CITY_2536: "Meethari Marwar",
        STATE_GJ_CITY_2537: "Meghraj",
        STATE_UP_CITY_2538: "Mehdawal",
        STATE_MH_CITY_2539: "Mehekar",
        STATE_MH_CITY_2540: "Mehergaon",
        STATE_MH_CITY_2541: "Mehkar",
        STATE_UP_CITY_2542: "Mehnagar",
        STATE_UP_CITY_2543: "Mehndawal",
        STATE_GJ_CITY_2544: "Mehsana",
        STATE_WB_CITY_2545: "Mejia community development block",
        STATE_KA_CITY_2546: "Melukote",
        STATE_TN_CITY_2547: "Melur",
        STATE_WB_CITY_2548: "Memari",
        STATE_GJ_CITY_2549: "Mendarda",
        STATE_RJ_CITY_2550: "Merta",
        STATE_TN_CITY_2551: "Mettuppalaiyam",
        STATE_TN_CITY_2552: "Mettur",
        STATE_MH_CITY_2553: "Mhasla",
        STATE_MH_CITY_2554: "Mhasvad",
        STATE_MP_CITY_2555: "Mihona",
        STATE_UP_CITY_2556: "Milak",
        STATE_UP_CITY_2557: "Milkipur",
        STATE_TN_CITY_2558: "Minjur",
        STATE_MH_CITY_2559: "Miraj",
        STATE_UP_CITY_2560: "Miranpur",
        STATE_UP_CITY_2561: "Miranpur Katra",
        STATE_UP_CITY_2562: "Mirganj",
        STATE_TG_CITY_2563: "Mirialguda",
        STATE_WB_CITY_2564: "Mirik",
        STATE_UP_CITY_2565: "Mirzapur",
        STATE_UP_CITY_2566: "Misrikh",
        STATE_GJ_CITY_2567: "Mithapur",
        STATE_GJ_CITY_2568: "Modasa",
        STATE_PB_CITY_2569: "Moga",
        STATE_MH_CITY_2570: "Mohadi",
        STATE_PB_CITY_2571: "Mohali",
        STATE_UP_CITY_2572: "Mohan",
        STATE_UP_CITY_2573: "Mohanpur",
        STATE_WB_CITY_2574: "Mohanpur community development block",
        STATE_TN_CITY_2575: "Mohanur",
        STATE_MP_CITY_2576: "Mohgaon",
        STATE_BR_CITY_2577: "Mohiuddinnagar",
        STATE_MH_CITY_2578: "Mohol",
        STATE_MH_CITY_2579: "Mohpa",
        STATE_MN_CITY_2580: "Moirang",
        STATE_BR_CITY_2581: "Mokameh",
        STATE_MH_CITY_2582: "Mokhada taluka",
        STATE_NL_CITY_2583: "Mokokchung",
        STATE_NL_CITY_2584: "Mon",
        STATE_BR_CITY_2585: "Monghyr",
        STATE_WB_CITY_2586: "Monoharpur",
        STATE_MH_CITY_2587: "Mora, Maharashtra",
        STATE_UP_CITY_2588: "Moradabad",
        STATE_MH_CITY_2589: "Moram",
        STATE_AS_CITY_2590: "Moranha",
        STATE_MP_CITY_2591: "Morar",
        STATE_GJ_CITY_2592: "Morbi",
        STATE_MP_CITY_2593: "Morena",
        STATE_AS_CITY_2594: "Morigaon",
        STATE_PB_CITY_2595: "Morinda",
        STATE_GA_CITY_2596: "Morjim",
        STATE_GA_CITY_2597: "Mormugao",
        STATE_MH_CITY_2598: "Morsi",
        STATE_GJ_CITY_2599: "Morva (Hadaf)",
        STATE_GJ_CITY_2600: "Morwa",
        STATE_UP_CITY_2601: "Moth",
        STATE_BR_CITY_2602: "Mothihari",
        STATE_MH_CITY_2603: "Mowad",
        STATE_UP_CITY_2604: "Mubarakpur",
        STATE_KA_CITY_2605: "Mudbidri",
        STATE_KA_CITY_2606: "Muddebihal",
        STATE_KA_CITY_2607: "Mudgal",
        STATE_KA_CITY_2608: "Mudgere",
        STATE_KA_CITY_2609: "Mudhol",
        STATE_MH_CITY_2610: "Mudkhed",
        STATE_TN_CITY_2611: "Mudukulattur",
        STATE_UP_CITY_2612: "Mughal Sarai",
        STATE_JH_CITY_2613: "Mugma",
        STATE_UP_CITY_2614: "Muhammadabad",
        STATE_PB_CITY_2615: "Mukerian",
        STATE_MH_CITY_2616: "Mukher",
        STATE_UP_CITY_2617: "Mukteshwar",
        STATE_MH_CITY_2618: "Mul",
        STATE_TN_CITY_2619: "Mulanur",
        STATE_KA_CITY_2620: "Mulbagal",
        STATE_KA_CITY_2621: "Mulgund",
        STATE_MH_CITY_2622: "Mulher",
        STATE_KA_CITY_2623: "Mulki",
        STATE_MP_CITY_2624: "Multai",
        STATE_MH_CITY_2625: "Mulund",
        STATE_KL_CITY_2626: "Muluppilagadu",
        STATE_MH_CITY_2627: "Mumbai",
        STATE_MH_CITY_2628: "Mumbai Suburban",
        STATE_KA_CITY_2629: "Mundargi",
        STATE_KA_CITY_2630: "Mundgod",
        STATE_MP_CITY_2631: "Mundi",
        STATE_GJ_CITY_2632: "Mundra",
        STATE_RJ_CITY_2633: "Mundwa",
        STATE_MP_CITY_2634: "Mungaoli",
        STATE_CT_CITY_2635: "Mungeli",
        STATE_BR_CITY_2636: "Munger",
        STATE_UP_CITY_2637: "Mungra Badshahpur",
        STATE_KA_CITY_2638: "Munirabad",
        STATE_KL_CITY_2639: "Munnar",
        STATE_UP_CITY_2640: "Munsyari",
        STATE_UP_CITY_2641: "Muradabad",
        STATE_UP_CITY_2642: "Muradnagar",
        STATE_WB_CITY_2643: "Muragacha",
        STATE_MH_CITY_2644: "Murbad",
        STATE_MH_CITY_2645: "Murgud",
        STATE_WB_CITY_2646: "Muri",
        STATE_BR_CITY_2647: "Murliganj",
        STATE_UP_CITY_2648: "Mursan",
        STATE_WB_CITY_2649: "Murshidabad",
        STATE_MH_CITY_2650: "Murtajapur",
        STATE_MH_CITY_2651: "Murud (Raigad)",
        STATE_MH_CITY_2652: "Murud (Ratnagiri)",
        STATE_KA_CITY_2653: "Murudeshwara",
        STATE_MH_CITY_2654: "Murum",
        STATE_MP_CITY_2655: "Murwara",
        STATE_UP_CITY_2656: "Musafir-Khana",
        STATE_UP_CITY_2657: "Musafirkhana",
        STATE_JH_CITY_2658: "Mushabani",
        STATE_TN_CITY_2659: "Musiri",
        STATE_UT_CITY_2660: "Mussoorie",
        STATE_HR_CITY_2661: "Mustafabad",
        STATE_TN_CITY_2662: "Muttupet",
        STATE_KL_CITY_2663: "Muvattupula",
        STATE_KL_CITY_2664: "Muvattupuzha",
        STATE_UP_CITY_2665: "Muzaffarnagar",
        STATE_BR_CITY_2666: "Muzaffarpur",
        STATE_KA_CITY_2667: "Mysore",
        STATE_WB_CITY_2668: "Nabadwip",
        STATE_WB_CITY_2669: "Nabagram",
        STATE_OR_CITY_2670: "Nabarangpur",
        STATE_PB_CITY_2671: "Nabha",
        STATE_BR_CITY_2672: "Nabinagar",
        STATE_KL_CITY_2673: "Nadapuram",
        STATE_HP_CITY_2674: "Nadaun",
        STATE_RJ_CITY_2675: "Nadbai",
        STATE_MH_CITY_2676: "Nadgaon",
        STATE_WB_CITY_2677: "Nadia district",
        STATE_GJ_CITY_2678: "Nadiad",
        STATE_GJ_CITY_2679: "Nadiad,",
        STATE_UP_CITY_2680: "Nadigaon",
        STATE_KL_CITY_2681: "Naduvannur",
        STATE_TN_CITY_2682: "Naduvattam",
        STATE_KA_CITY_2683: "Nagamangala",
        STATE_AS_CITY_2684: "Nagaon",
        STATE_TN_CITY_2685: "Nagapattinam",
        STATE_MH_CITY_2686: "Nagapur",
        STATE_RJ_CITY_2687: "Nagar",
        STATE_HP_CITY_2688: "Nagar",
        STATE_TG_CITY_2689: "Nagar Karnul",
        STATE_AP_CITY_2690: "Nagari",
        STATE_WB_CITY_2691: "Nagarukhra",
        STATE_RJ_CITY_2692: "Nagaur",
        STATE_MP_CITY_2693: "Nagda",
        STATE_TN_CITY_2694: "Nagercoil",
        STATE_UP_CITY_2695: "Nagina",
        STATE_AP_CITY_2696: "Nagireddipalli",
        STATE_UP_CITY_2697: "Nagla",
        STATE_MP_CITY_2698: "Nagod",
        STATE_MH_CITY_2699: "Nagothana",
        STATE_MH_CITY_2700: "Nagpur",
        STATE_MH_CITY_2701: "Nagpur Division",
        STATE_WB_CITY_2702: "Nagrakata",
        STATE_UP_CITY_2703: "Nagram",
        STATE_HP_CITY_2704: "Nagrota",
        STATE_GJ_CITY_2705: "Nagwa",
        STATE_HP_CITY_2706: "Nahan",
        STATE_AR_CITY_2707: "Naharlagun",
        STATE_AS_CITY_2708: "Nahorkatiya",
        STATE_MP_CITY_2709: "Naigarhi",
        STATE_WB_CITY_2710: "Naihati",
        STATE_UT_CITY_2711: "Naini Tal",
        STATE_MP_CITY_2712: "Nainpur",
        STATE_RJ_CITY_2713: "Nainwa",
        STATE_DL_CITY_2714: "Najafgarh",
        STATE_UP_CITY_2715: "Najibabad",
        STATE_PB_CITY_2716: "Nakodar",
        STATE_WB_CITY_2717: "Naksalbari",
        STATE_UP_CITY_2718: "Nakur",
        STATE_MH_CITY_2719: "Nala Sopara",
        STATE_HP_CITY_2720: "Nalagarh",
        STATE_BR_CITY_2721: "Nalanda",
        STATE_AS_CITY_2722: "Nalbari",
        STATE_GJ_CITY_2723: "Naldhara",
        STATE_MH_CITY_2724: "Naldurg",
        STATE_MH_CITY_2725: "Nalegaon",
        STATE_TG_CITY_2726: "Nalgonda",
        STATE_WB_CITY_2727: "Nalhati",
        STATE_GJ_CITY_2728: "Naliya",
        STATE_WB_CITY_2729: "Nalpur",
        STATE_TN_CITY_2730: "Namagiripettai",
        STATE_TN_CITY_2731: "Namakkal",
        STATE_TN_CITY_2732: "Nambiyur",
        STATE_TN_CITY_2733: "Nambutalai",
        STATE_SK_CITY_2734: "Namchi",
        STATE_WB_CITY_2735: "Namkhana community development block",
        STATE_MP_CITY_2736: "Namli",
        STATE_MH_CITY_2737: "Nampur",
        STATE_AS_CITY_2738: "Namrup",
        STATE_UP_CITY_2739: "Nanauta",
        STATE_TN_CITY_2740: "Nandambakkam",
        STATE_MH_CITY_2741: "Nanded",
        STATE_UP_CITY_2742: "Nandgaon",
        STATE_MH_CITY_2743: "Nandgaon",
        STATE_AP_CITY_2744: "Nandigama",
        STATE_WB_CITY_2745: "Nandigram",
        STATE_AP_CITY_2746: "Nandikotkur",
        STATE_MH_CITY_2747: "Nandnee",
        STATE_MH_CITY_2748: "Nandura",
        STATE_MH_CITY_2749: "Nandura Buzurg",
        STATE_MH_CITY_2750: "Nandurbar",
        STATE_AP_CITY_2751: "Nandyal",
        STATE_PB_CITY_2752: "Nangal",
        STATE_TN_CITY_2753: "Nangavalli",
        STATE_WB_CITY_2754: "Nangi",
        STATE_TN_CITY_2755: "Nangilickondan",
        STATE_DL_CITY_2756: "Nangloi Jat",
        STATE_TN_CITY_2757: "Nanguneri",
        STATE_KA_CITY_2758: "Nanjangud",
        STATE_TN_CITY_2759: "Nannilam",
        STATE_UP_CITY_2760: "Nanpara",
        STATE_RJ_CITY_2761: "Napasar",
        STATE_RJ_CITY_2762: "Naraina",
        STATE_MP_CITY_2763: "Naraini",
        STATE_AP_CITY_2764: "Narasannapeta",
        STATE_AP_CITY_2765: "Narasapur",
        STATE_AP_CITY_2766: "Narasaraopet",
        STATE_KA_CITY_2767: "Narasimharajapura",
        STATE_AP_CITY_2768: "Narasingapuram",
        STATE_UP_CITY_2769: "Narauli",
        STATE_UP_CITY_2770: "Naraura",
        STATE_TN_CITY_2771: "Naravarikuppam",
        STATE_AP_CITY_2772: "Narayanavanam",
        STATE_MH_CITY_2773: "Narayangaon",
        STATE_HR_CITY_2774: "Narayangarh",
        STATE_MP_CITY_2775: "Narayangarh",
        STATE_TG_CITY_2776: "Narayanpet",
        STATE_CT_CITY_2777: "Narayanpur",
        STATE_MH_CITY_2778: "Nardana",
        STATE_KA_CITY_2779: "Naregal",
        STATE_DL_CITY_2780: "Narela",
        STATE_UT_CITY_2781: "Narendranagar",
        STATE_GJ_CITY_2782: "Nargol",
        STATE_KA_CITY_2783: "Nargund",
        STATE_CT_CITY_2784: "Narharpur",
        STATE_MH_CITY_2785: "Nariman Point",
        STATE_MH_CITY_2786: "Narkhed",
        STATE_GJ_CITY_2787: "Narmada",
        STATE_HR_CITY_2788: "Narnaul",
        STATE_HR_CITY_2789: "Narnaund",
        STATE_GJ_CITY_2790: "Naroda",
        STATE_UP_CITY_2791: "Narora",
        STATE_MP_CITY_2792: "Narsimhapur",
        STATE_MP_CITY_2793: "Narsinghgarh",
        STATE_TG_CITY_2794: "Narsingi",
        STATE_AP_CITY_2795: "Narsipatnam",
        STATE_HR_CITY_2796: "Narwana",
        STATE_MP_CITY_2797: "Narwar",
        STATE_MH_CITY_2798: "Nashik",
        STATE_MH_CITY_2799: "Nashik Division",
        STATE_RJ_CITY_2800: "Nasirabad",
        STATE_TG_CITY_2801: "Naspur",
        STATE_BR_CITY_2802: "Nasriganj",
        STATE_MP_CITY_2803: "Nasrullahganj",
        STATE_RJ_CITY_2804: "Nathdwara",
        STATE_TN_CITY_2805: "Nattam",
        STATE_TN_CITY_2806: "Nattarasankottai",
        STATE_BR_CITY_2807: "Naugachhia",
        STATE_UP_CITY_2808: "Naugama",
        STATE_UP_CITY_2809: "Naurangpur",
        STATE_UP_CITY_2810: "Nautanwa",
        STATE_KA_CITY_2811: "Navalgund",
        STATE_MH_CITY_2812: "Navapur",
        STATE_GA_CITY_2813: "Navelim",
        STATE_MH_CITY_2814: "Navi Mumbai",
        STATE_GJ_CITY_2815: "Navsari",
        STATE_RJ_CITY_2816: "Nawa",
        STATE_UP_CITY_2817: "Nawabganj",
        STATE_UP_CITY_2818: "Nawabganj (Barabanki)",
        STATE_UP_CITY_2819: "Nawabganj (Bareilly)",
        STATE_BR_CITY_2820: "Nawada",
        STATE_RJ_CITY_2821: "Nawalgarh",
        STATE_PB_CITY_2822: "Nawanshahr",
        STATE_JK_CITY_2823: "Nawanshahr",
        STATE_SK_CITY_2824: "Naya Bazar",
        STATE_OR_CITY_2825: "Nayagarh",
        STATE_OR_CITY_2826: "Nayagarh District",
        STATE_WB_CITY_2827: "Nayagram community development block",
        STATE_AP_CITY_2828: "Nayudupet",
        STATE_AS_CITY_2829: "Nazira",
        STATE_KL_CITY_2830: "Nedumangad",
        STATE_TN_CITY_2831: "Needamangalam",
        STATE_TN_CITY_2832: "Neelankarai",
        STATE_RJ_CITY_2833: "Neem ka Thana",
        STATE_MP_CITY_2834: "Neemuch",
        STATE_TN_CITY_2835: "Negapatam",
        STATE_KA_CITY_2836: "Nelamangala",
        STATE_TN_CITY_2837: "Nellikkuppam",
        STATE_AP_CITY_2838: "Nellore",
        STATE_MP_CITY_2839: "Nepanagar",
        STATE_MH_CITY_2840: "Neral",
        STATE_MH_CITY_2841: "Nerur",
        STATE_JH_CITY_2842: "Neturhat",
        STATE_MH_CITY_2843: "Nevasa",
        STATE_DL_CITY_2844: "New Delhi",
        STATE_UP_CITY_2845: "Newara",
        STATE_KL_CITY_2846: "Neyyattinkara",
        STATE_UP_CITY_2847: "Nichlaul",
        STATE_AN_CITY_2848: "Nicobar",
        STATE_AP_CITY_2849: "Nidadavole",
        STATE_MH_CITY_2850: "Nighoj",
        STATE_UP_CITY_2851: "Nigoh",
        STATE_UP_CITY_2852: "Nihtaur",
        STATE_GJ_CITY_2853: "Nikora",
        STATE_TN_CITY_2854: "Nilakottai",
        STATE_MH_CITY_2855: "Nilanga",
        STATE_KL_CITY_2856: "Nilēshwar",
        STATE_OR_CITY_2857: "Nilgiri",
        STATE_TN_CITY_2858: "Nilgiris",
        STATE_HR_CITY_2859: "Nilokheri",
        STATE_RJ_CITY_2860: "Nimaj",
        STATE_OR_CITY_2861: "Nimaparha",
        STATE_RJ_CITY_2862: "Nimbahera",
        STATE_MH_CITY_2863: "Nipani",
        STATE_MH_CITY_2864: "Niphad",
        STATE_MH_CITY_2865: "Nira Narsingpur",
        STATE_TG_CITY_2866: "Nirmal",
        STATE_BR_CITY_2867: "Nirmali",
        STATE_JH_CITY_2868: "Nirsa",
        STATE_RJ_CITY_2869: "Niwai",
        STATE_UP_CITY_2870: "Niwari",
        STATE_TG_CITY_2871: "Nizamabad",
        STATE_UP_CITY_2872: "Nizamabad",
        STATE_GJ_CITY_2873: "Nizar",
        STATE_JH_CITY_2874: "Noamundi",
        STATE_RJ_CITY_2875: "Nohar",
        STATE_UP_CITY_2876: "Noida",
        STATE_RJ_CITY_2877: "Nokha",
        STATE_ML_CITY_2878: "Nongpoh",
        STATE_ML_CITY_2879: "Nongstoin",
        STATE_JK_CITY_2880: "Noria",
        STATE_WB_CITY_2881: "North 24 Parganas district",
        STATE_DL_CITY_2882: "North Delhi",
        STATE_SK_CITY_2883: "North District",
        STATE_DL_CITY_2884: "North East Delhi",
        STATE_ML_CITY_2885: "North Garo Hills",
        STATE_GA_CITY_2886: "North Goa",
        STATE_AS_CITY_2887: "North Guwahati",
        STATE_AS_CITY_2888: "North Lakhimpur",
        STATE_TR_CITY_2889: "North Tripura",
        STATE_MZ_CITY_2890: "North Vanlaiphai",
        STATE_DL_CITY_2891: "North West Delhi",
        STATE_OR_CITY_2892: "Nowrangapur",
        STATE_OR_CITY_2893: "Nuapada",
        STATE_HR_CITY_2894: "Nuh",
        STATE_AS_CITY_2895: "Numaligarh",
        STATE_PB_CITY_2896: "Nurmahal",
        STATE_UP_CITY_2897: "Nurpur",
        STATE_PB_CITY_2898: "Nurpur Kalan",
        STATE_AP_CITY_2899: "Nuzvid",
        STATE_KA_CITY_2900: "Nyamti",
        STATE_UP_CITY_2901: "Obra",
        STATE_GJ_CITY_2902: "Odadar",
        STATE_WB_CITY_2903: "Odlabari",
        STATE_TN_CITY_2904: "Odugattur",
        STATE_GJ_CITY_2905: "Okha",
        STATE_GJ_CITY_2906: "Olpad",
        STATE_TN_CITY_2907: "Omalur",
        STATE_AP_CITY_2908: "Ongole",
        STATE_TN_CITY_2909: "Ooty",
        STATE_UP_CITY_2910: "Orai",
        STATE_UP_CITY_2911: "Oran",
        STATE_MP_CITY_2912: "Orchha",
        STATE_MH_CITY_2913: "Osmanabad",
        STATE_KL_CITY_2914: "Ottappalam",
        STATE_MH_CITY_2915: "Ozar",
        STATE_MH_CITY_2916: "Pabal",
        STATE_MP_CITY_2917: "Pachmarhi",
        STATE_MH_CITY_2918: "Pachora",
        STATE_UP_CITY_2919: "Pachperwa",
        STATE_JK_CITY_2920: "Padam",
        STATE_RJ_CITY_2921: "Padampur",
        STATE_OR_CITY_2922: "Padampur",
        STATE_GJ_CITY_2923: "Paddhari",
        STATE_TN_CITY_2924: "Padmanabhapuram",
        STATE_GJ_CITY_2925: "Padra",
        STATE_UP_CITY_2926: "Padrauna",
        STATE_UP_CITY_2927: "Pahasu",
        STATE_JK_CITY_2928: "Pahlgam",
        STATE_MH_CITY_2929: "Pahur, Maharashtra",
        STATE_UP_CITY_2930: "Paigaon",
        STATE_WB_CITY_2931: "Paikpara",
        STATE_MH_CITY_2932: "Paithan",
        STATE_AP_CITY_2933: "Pakala",
        STATE_JH_CITY_2934: "Pakur",
        STATE_KL_CITY_2935: "Palackattumala",
        STATE_KL_CITY_2936: "Palakkad district",
        STATE_TN_CITY_2937: "Palakkodu",
        STATE_AP_CITY_2938: "Palakollu",
        STATE_TN_CITY_2939: "Palamedu",
        STATE_HP_CITY_2940: "Palampur",
        STATE_JH_CITY_2941: "Palamu",
        STATE_TN_CITY_2942: "Palani",
        STATE_GJ_CITY_2943: "Palanpur",
        STATE_GJ_CITY_2944: "Palanswa",
        STATE_AP_CITY_2945: "Palasa",
        STATE_AS_CITY_2946: "Palasbari",
        STATE_TN_CITY_2947: "Palavakkam",
        STATE_MP_CITY_2948: "Palera",
        STATE_MH_CITY_2949: "Palghar",
        STATE_KL_CITY_2950: "Palghat",
        STATE_RJ_CITY_2951: "Pali",
        STATE_MP_CITY_2952: "Pali",
        STATE_UP_CITY_2953: "Pali",
        STATE_MH_CITY_2954: "Pali, Raigad",
        STATE_UP_CITY_2955: "Palia Kalan",
        STATE_GJ_CITY_2956: "Palitana",
        STATE_GJ_CITY_2957: "Paliyad",
        STATE_GJ_CITY_2958: "Paliyad (Bhavnagar)",
        STATE_AP_CITY_2959: "Palkonda",
        STATE_TN_CITY_2960: "Palladam",
        STATE_TN_CITY_2961: "Pallappatti",
        STATE_TN_CITY_2962: "Pallattur",
        STATE_TN_CITY_2963: "Pallavaram",
        STATE_GA_CITY_2964: "Palle",
        STATE_AP_CITY_2965: "Pallevada",
        STATE_TN_CITY_2966: "Pallikondai",
        STATE_TN_CITY_2967: "Pallipattu",
        STATE_TN_CITY_2968: "Pallippatti",
        STATE_AP_CITY_2969: "Palmaner",
        STATE_TG_CITY_2970: "Paloncha",
        STATE_GJ_CITY_2971: "Palsana",
        STATE_MH_CITY_2972: "Palso",
        STATE_HR_CITY_2973: "Palwal",
        STATE_TG_CITY_2974: "Palwancha",
        STATE_MP_CITY_2975: "Panagar",
        STATE_WB_CITY_2976: "Panagarh",
        STATE_GA_CITY_2977: "Panaji",
        STATE_KL_CITY_2978: "Panamaram",
        STATE_MP_CITY_2979: "Panara",
        STATE_GJ_CITY_2980: "Panch Mahals",
        STATE_MH_CITY_2981: "Panchgani",
        STATE_HR_CITY_2982: "Panchkula",
        STATE_WB_CITY_2983: "Panchla",
        STATE_GJ_CITY_2984: "Panchmahal district",
        STATE_WB_CITY_2985: "Panchmura",
        STATE_CT_CITY_2986: "Pandaria",
        STATE_CT_CITY_2987: "Pandatarai",
        STATE_MP_CITY_2988: "Pandhana",
        STATE_MH_CITY_2989: "Pandharpur",
        STATE_MH_CITY_2990: "Pandhurli",
        STATE_MP_CITY_2991: "Pandhurna",
        STATE_HP_CITY_2992: "Pandoh",
        STATE_WB_CITY_2993: "Pandua",
        STATE_KA_CITY_2994: "Pangala",
        STATE_MH_CITY_2995: "Panhala",
        STATE_WB_CITY_2996: "Panihati",
        STATE_HR_CITY_2997: "Panipat",
        STATE_MP_CITY_2998: "Panna",
        STATE_TN_CITY_2999: "Panruti",
        STATE_MP_CITY_3000: "Pansemal",
        STATE_WB_CITY_3001: "Panskura",
        STATE_MH_CITY_3002: "Panvel",
        STATE_HP_CITY_3003: "Paonta Sahib",
        STATE_TN_CITY_3004: "Papanasam",
        STATE_TN_CITY_3005: "Papireddippatti",
        STATE_TN_CITY_3006: "Papparappatti",
        STATE_KL_CITY_3007: "Pappinisshēri",
        STATE_OR_CITY_3008: "Paradip Garh",
        STATE_TN_CITY_3009: "Paramagudi",
        STATE_UP_CITY_3010: "Paras Rampur",
        STATE_MP_CITY_3011: "Parasia",
        STATE_KL_CITY_3012: "Paravur Tekkumbhagam",
        STATE_WB_CITY_3013: "Parbatipur",
        STATE_MH_CITY_3014: "Parbhani",
        STATE_GJ_CITY_3015: "Pardi",
        STATE_MH_CITY_3016: "Parel",
        STATE_UP_CITY_3017: "Parichha",
        STATE_UP_CITY_3018: "Parichhatgarh",
        STATE_KL_CITY_3019: "Pariyapuram",
        STATE_AP_CITY_3020: "Parlakimidi",
        STATE_MH_CITY_3021: "Parli Vaijnath",
        STATE_MH_CITY_3022: "Parner",
        STATE_GJ_CITY_3023: "Parnera",
        STATE_JK_CITY_3024: "Parol",
        STATE_MH_CITY_3025: "Parola",
        STATE_MH_CITY_3026: "Parseoni",
        STATE_UP_CITY_3027: "Parshadepur",
        STATE_RJ_CITY_3028: "Partapur",
        STATE_MH_CITY_3029: "Partur",
        STATE_AP_CITY_3030: "Parvatipuram",
        STATE_RJ_CITY_3031: "Parvatsar",
        STATE_HP_CITY_3032: "Parwanoo",
        STATE_CT_CITY_3033: "Pasan",
        STATE_WB_CITY_3034: "Paschim Medinipur district",
        STATE_BR_CITY_3035: "Pashchim Champaran",
        STATE_JH_CITY_3036: "Pashchim Singhbhum",
        STATE_AR_CITY_3037: "Pasighat",
        STATE_JH_CITY_3038: "patamda",
        STATE_OR_CITY_3039: "Patamundai",
        STATE_GJ_CITY_3040: "Patan",
        STATE_CT_CITY_3041: "Patan",
        STATE_MH_CITY_3042: "Patan",
        STATE_MP_CITY_3043: "Patan",
        STATE_TG_CITY_3044: "Patancheru",
        STATE_HR_CITY_3045: "Pataudi",
        STATE_UP_CITY_3046: "Pathakpura",
        STATE_CT_CITY_3047: "Pathalgaon",
        STATE_KL_CITY_3048: "Pathanamthitta",
        STATE_PB_CITY_3049: "Pathankot",
        STATE_MH_CITY_3050: "Pathardi",
        STATE_JH_CITY_3051: "Pathardih",
        STATE_MP_CITY_3052: "Patharia",
        STATE_MH_CITY_3053: "Pathri",
        STATE_PB_CITY_3054: "Patiala",
        STATE_UP_CITY_3055: "Patiali",
        STATE_WB_CITY_3056: "Patiram",
        STATE_BR_CITY_3057: "Patna",
        STATE_OR_CITY_3058: "Patnagarh",
        STATE_WB_CITY_3059: "Patrasaer",
        STATE_JK_CITY_3060: "Pattan",
        STATE_KL_CITY_3061: "Pattanamtitta",
        STATE_PB_CITY_3062: "Patti",
        STATE_UP_CITY_3063: "Patti",
        STATE_TN_CITY_3064: "Pattukkottai",
        STATE_WB_CITY_3065: "Patuli",
        STATE_MH_CITY_3066: "Patur",
        STATE_MH_CITY_3067: "Paturda",
        STATE_MH_CITY_3068: "Paud",
        STATE_MH_CITY_3069: "Pauni",
        STATE_UT_CITY_3070: "Pauri",
        STATE_GJ_CITY_3071: "Pavi Jetpur",
        STATE_KA_CITY_3072: "Pavugada",
        STATE_AP_CITY_3073: "Pavuluru",
        STATE_MP_CITY_3074: "Pawai",
        STATE_UP_CITY_3075: "Pawayan",
        STATE_MH_CITY_3076: "Pawni",
        STATE_UP_CITY_3077: "Payagpur",
        STATE_KL_CITY_3078: "Payyannur",
        STATE_AP_CITY_3079: "Pedana",
        STATE_AP_CITY_3080: "pedda nakkalapalem",
        STATE_TG_CITY_3081: "Peddapalli",
        STATE_AP_CITY_3082: "Peddapuram",
        STATE_MH_CITY_3083: "Pedgaon",
        STATE_HR_CITY_3084: "Pehowa",
        STATE_MH_CITY_3085: "Peint",
        STATE_MH_CITY_3086: "Pen",
        STATE_CT_CITY_3087: "Pendra",
        STATE_TN_CITY_3088: "Pennadam",
        STATE_TN_CITY_3089: "Pennagaram",
        STATE_TN_CITY_3090: "Pennathur",
        STATE_AP_CITY_3091: "Penugonda",
        STATE_AP_CITY_3092: "Penukonda",
        STATE_TN_CITY_3093: "Peraiyur",
        STATE_TN_CITY_3094: "Perambalur",
        STATE_TN_CITY_3095: "Peranamallur",
        STATE_TN_CITY_3096: "Peranampattu",
        STATE_TN_CITY_3097: "Peravurani",
        STATE_NL_CITY_3098: "Peren",
        STATE_TN_CITY_3099: "Periyakulam",
        STATE_TN_CITY_3100: "Periyanayakkanpalaiyam",
        STATE_TN_CITY_3101: "Periyanegamam",
        STATE_TN_CITY_3102: "Periyapatti",
        STATE_TN_CITY_3103: "Periyapattinam",
        STATE_GA_CITY_3104: "Pernem",
        STATE_KL_CITY_3105: "Perumbavoor",
        STATE_KL_CITY_3106: "Perumpavur",
        STATE_TN_CITY_3107: "Perundurai",
        STATE_TN_CITY_3108: "Perungudi",
        STATE_TN_CITY_3109: "Perur",
        STATE_KL_CITY_3110: "Perya",
        STATE_GJ_CITY_3111: "Petlad",
        STATE_MP_CITY_3112: "Petlawad",
        STATE_PB_CITY_3113: "Phagwara",
        STATE_UP_CITY_3114: "Phalauda",
        STATE_RJ_CITY_3115: "Phalodi",
        STATE_MH_CITY_3116: "Phaltan",
        STATE_UP_CITY_3117: "Phaphamau",
        STATE_UP_CITY_3118: "Phaphund",
        STATE_UP_CITY_3119: "Phariha",
        STATE_MN_CITY_3120: "Phek",
        STATE_NL_CITY_3121: "Phek",
        STATE_UP_CITY_3122: "Pheona",
        STATE_PB_CITY_3123: "Phillaur",
        STATE_AP_CITY_3124: "Phirangipuram",
        STATE_MH_CITY_3125: "Phulambri",
        STATE_OR_CITY_3126: "Phulbani",
        STATE_RJ_CITY_3127: "Phulera",
        STATE_UP_CITY_3128: "Phulpur",
        STATE_UP_CITY_3129: "Pichhaura",
        STATE_UP_CITY_3130: "Pihani",
        STATE_RJ_CITY_3131: "Pilani",
        STATE_RJ_CITY_3132: "Pilibangan",
        STATE_UP_CITY_3133: "Pilibhit",
        STATE_MH_CITY_3134: "Piliv",
        STATE_UP_CITY_3135: "Pilkhua",
        STATE_UP_CITY_3136: "Pilkhuwa",
        STATE_MH_CITY_3137: "Pimpalgaon Baswant",
        STATE_MH_CITY_3138: "Pimpalgaon Raja",
        STATE_MH_CITY_3139: "Pimpri",
        STATE_MH_CITY_3140: "Pimpri-Chinchwad",
        STATE_UP_CITY_3141: "Pinahat",
        STATE_RJ_CITY_3142: "Pindwara",
        STATE_HR_CITY_3143: "Pinjaur",
        STATE_UT_CITY_3144: "Pipalkoti",
        STATE_RJ_CITY_3145: "Pipar",
        STATE_GJ_CITY_3146: "Pipavav",
        STATE_OR_CITY_3147: "Pipili",
        STATE_GJ_CITY_3148: "Piplod",
        STATE_MP_CITY_3149: "Piploda",
        STATE_AP_CITY_3150: "Pippara",
        STATE_UP_CITY_3151: "Pipraich",
        STATE_MH_CITY_3152: "Pipri",
        STATE_UP_CITY_3153: "Pipri",
        STATE_KL_CITY_3154: "Piravam",
        STATE_RJ_CITY_3155: "Pirawa",
        STATE_KA_CITY_3156: "Piriyapatna",
        STATE_BR_CITY_3157: "Piro",
        STATE_DL_CITY_3158: "Pitampura",
        STATE_MP_CITY_3159: "Pithampur",
        STATE_AP_CITY_3160: "Pithapuram",
        STATE_CT_CITY_3161: "Pithora",
        STATE_UT_CITY_3162: "Pithoragarh",
        STATE_RJ_CITY_3163: "Pokaran",
        STATE_OR_CITY_3164: "Polasara",
        STATE_AP_CITY_3165: "Polavaram",
        STATE_TN_CITY_3166: "Pollachi",
        STATE_TN_CITY_3167: "Polur",
        STATE_GA_CITY_3168: "Ponda",
        STATE_KL_CITY_3169: "Ponmana",
        STATE_TN_CITY_3170: "Ponnamaravati",
        STATE_KA_CITY_3171: "Ponnampet",
        STATE_KL_CITY_3172: "Ponnani",
        STATE_TN_CITY_3173: "Ponneri",
        STATE_AP_CITY_3174: "Ponnur",
        STATE_AP_CITY_3175: "Ponnuru",
        STATE_TN_CITY_3176: "Poonamalle",
        STATE_GJ_CITY_3177: "Porbandar",
        STATE_MP_CITY_3178: "Porsa",
        STATE_AN_CITY_3179: "Port Blair",
        STATE_TN_CITY_3180: "Porur",
        STATE_MH_CITY_3181: "Powai",
        STATE_MH_CITY_3182: "Prabhadevi",
        STATE_GJ_CITY_3183: "Prabhas Patan",
        STATE_AP_CITY_3184: "Prakasam",
        STATE_MH_CITY_3185: "Prakasha",
        STATE_GJ_CITY_3186: "Prantij",
        STATE_RJ_CITY_3187: "Pratapgarh",
        STATE_UP_CITY_3188: "Pratapgarh",
        STATE_UP_CITY_3189: "Prayagraj (Allahabad)",
        STATE_AP_CITY_3190: "Proddatur",
        STATE_PY_CITY_3191: "Puducherry",
        STATE_TN_CITY_3192: "Pudukkottai",
        STATE_TN_CITY_3193: "Puduppatti",
        STATE_TN_CITY_3194: "Pudur",
        STATE_TN_CITY_3195: "Puduvayal",
        STATE_WB_CITY_3196: "Pujali",
        STATE_UP_CITY_3197: "Pukhrayan",
        STATE_MH_CITY_3198: "Pulgaon",
        STATE_AP_CITY_3199: "Pulivendla",
        STATE_TN_CITY_3200: "Puliyangudi",
        STATE_TN_CITY_3201: "Puliyur",
        STATE_TN_CITY_3202: "Pullambadi",
        STATE_JK_CITY_3203: "Pulwama",
        STATE_HR_CITY_3204: "Punahana",
        STATE_KL_CITY_3205: "Punalur",
        STATE_MP_CITY_3206: "Punasa",
        STATE_JK_CITY_3207: "Punch",
        STATE_WB_CITY_3208: "Puncha community development block",
        STATE_HR_CITY_3209: "Pundri",
        STATE_MH_CITY_3210: "Pune",
        STATE_MH_CITY_3211: "Pune Division",
        STATE_AP_CITY_3212: "Punganuru",
        STATE_TN_CITY_3213: "Punjai Puliyampatti",
        STATE_MH_CITY_3214: "Puntamba",
        STATE_BR_CITY_3215: "Pupri",
        STATE_MH_CITY_3216: "Pural",
        STATE_UP_CITY_3217: "Puranpur",
        STATE_BR_CITY_3218: "Purba Champaran",
        STATE_WB_CITY_3219: "Purba Medinipur district",
        STATE_JH_CITY_3220: "Purba Singhbhum",
        STATE_OR_CITY_3221: "Puri",
        STATE_UP_CITY_3222: "Purmafi",
        STATE_MH_CITY_3223: "Purna",
        STATE_BR_CITY_3224: "Purnia",
        STATE_WB_CITY_3225: "Purulia",
        STATE_OR_CITY_3226: "Purushottampur",
        STATE_UP_CITY_3227: "Purwa",
        STATE_MH_CITY_3228: "Pusad",
        STATE_RJ_CITY_3229: "Pushkar",
        STATE_AP_CITY_3230: "Puttaparthi",
        STATE_KA_CITY_3231: "Puttur",
        STATE_AP_CITY_3232: "Puttur",
        STATE_PB_CITY_3233: "Qadian",
        STATE_UP_CITY_3234: "Qadirganj",
        STATE_JK_CITY_3235: "Qazigund",
        STATE_GA_CITY_3236: "Quepem",
        STATE_GA_CITY_3237: "Queula",
        STATE_TG_CITY_3238: "Quthbullapur",
        STATE_KA_CITY_3239: "Rabkavi",
        STATE_UP_CITY_3240: "Rabupura",
        STATE_HR_CITY_3241: "Radaur",
        STATE_UP_CITY_3242: "Radha Kund",
        STATE_UP_CITY_3243: "Radhakund",
        STATE_MH_CITY_3244: "Radhanagari",
        STATE_GJ_CITY_3245: "Radhanpur",
        STATE_UP_CITY_3246: "Raebareli",
        STATE_BR_CITY_3247: "Rafiganj",
        STATE_MP_CITY_3248: "Raghogarh",
        STATE_WB_CITY_3249: "Raghudebbati",
        STATE_BR_CITY_3250: "Raghunathpur",
        STATE_WB_CITY_3251: "Raghunathpur",
        STATE_AS_CITY_3252: "Raha",
        STATE_MH_CITY_3253: "Rahata",
        STATE_MP_CITY_3254: "Rahatgarh",
        STATE_MH_CITY_3255: "Rahimatpur",
        STATE_PB_CITY_3256: "Rahon",
        STATE_MH_CITY_3257: "Rahuri",
        STATE_GA_CITY_3258: "Raia",
        STATE_KA_CITY_3259: "Raichur",
        STATE_WB_CITY_3260: "Raiganj",
        STATE_CT_CITY_3261: "Raigarh",
        STATE_MH_CITY_3262: "Raigarh",
        STATE_PB_CITY_3263: "Raikot",
        STATE_RJ_CITY_3264: "Raipur",
        STATE_CT_CITY_3265: "Raipur",
        STATE_UT_CITY_3266: "Raipur",
        STATE_MH_CITY_3267: "Raireshwar",
        STATE_MP_CITY_3268: "Raisen",
        STATE_RJ_CITY_3269: "Raisinghnagar",
        STATE_UT_CITY_3270: "Raiwala Bara",
        STATE_CT_CITY_3271: "Raj Nandgaon",
        STATE_CT_CITY_3272: "Raj-Nandgaon",
        STATE_AP_CITY_3273: "Rajahmundry",
        STATE_RJ_CITY_3274: "Rajakhera",
        STATE_RJ_CITY_3275: "Rajaldesar",
        STATE_TG_CITY_3276: "Rajanna Sircilla",
        STATE_JK_CITY_3277: "Rajaori",
        STATE_TN_CITY_3278: "Rajapalaiyam",
        STATE_MH_CITY_3279: "Rajapur",
        STATE_UP_CITY_3280: "Rajapur",
        STATE_PB_CITY_3281: "Rajasansi",
        STATE_JK_CITY_3282: "Rajauri",
        STATE_RJ_CITY_3283: "Rajgarh",
        STATE_MP_CITY_3284: "Rajgarh",
        STATE_HP_CITY_3285: "Rajgarh",
        STATE_BR_CITY_3286: "Rajgir",
        STATE_MH_CITY_3287: "Rajgurunagar",
        STATE_GJ_CITY_3288: "Rajkot",
        STATE_WB_CITY_3289: "Rajmahal",
        STATE_MP_CITY_3290: "Rajnagar",
        STATE_WB_CITY_3291: "Rajnagar community development block",
        STATE_GJ_CITY_3292: "Rajpipla",
        STATE_MP_CITY_3293: "Rajpur",
        STATE_PB_CITY_3294: "Rajpura",
        STATE_RJ_CITY_3295: "Rajsamand",
        STATE_GJ_CITY_3296: "Rajula",
        STATE_MH_CITY_3297: "Rajur",
        STATE_MH_CITY_3298: "Rajura",
        STATE_MH_CITY_3299: "Ralegaon",
        STATE_PB_CITY_3300: "Ram Das",
        STATE_AP_CITY_3301: "Ramachandrapuram",
        STATE_TG_CITY_3302: "Ramagundam",
        STATE_KL_CITY_3303: "Ramamangalam",
        STATE_KA_CITY_3304: "Ramanagara",
        STATE_TN_CITY_3305: "Ramanathapuram",
        STATE_AP_CITY_3306: "Ramanayyapeta",
        STATE_CT_CITY_3307: "Ramanuj Ganj",
        STATE_AP_CITY_3308: "Ramapuram",
        STATE_JK_CITY_3309: "Ramban",
        STATE_OR_CITY_3310: "Rambha",
        STATE_WB_CITY_3311: "Ramchandrapur",
        STATE_TN_CITY_3312: "Rameswaram",
        STATE_MH_CITY_3313: "Ramewadi",
        STATE_RJ_CITY_3314: "Ramganj Mandi",
        STATE_JH_CITY_3315: "Ramgarh",
        STATE_RJ_CITY_3316: "Ramgarh",
        STATE_JK_CITY_3317: "Ramgarh",
        STATE_TG_CITY_3318: "Ramgundam",
        STATE_WB_CITY_3319: "Ramjibanpur",
        STATE_UP_CITY_3320: "Ramkola",
        STATE_BR_CITY_3321: "Ramnagar",
        STATE_JK_CITY_3322: "Ramnagar",
        STATE_UT_CITY_3323: "Ramnagar",
        STATE_UP_CITY_3324: "Ramnagar",
        STATE_WB_CITY_3325: "Ramnagar",
        STATE_AP_CITY_3326: "Rampachodavaram",
        STATE_UP_CITY_3327: "Rampur",
        STATE_HP_CITY_3328: "Rampur",
        STATE_WB_CITY_3329: "Rampur Hat",
        STATE_UP_CITY_3330: "Rampura",
        STATE_PB_CITY_3331: "Rampura",
        STATE_MP_CITY_3332: "Rampura",
        STATE_MH_CITY_3333: "Ramtek",
        STATE_WB_CITY_3334: "Ranaghat",
        STATE_MP_CITY_3335: "Ranapur",
        STATE_GJ_CITY_3336: "Ranavav",
        STATE_JH_CITY_3337: "Ranchi",
        STATE_AS_CITY_3338: "Rangapara",
        STATE_TG_CITY_3339: "Rangareddi",
        STATE_AS_CITY_3340: "Rangia",
        STATE_SK_CITY_3341: "Rangpo",
        STATE_RJ_CITY_3342: "Rani",
        STATE_HR_CITY_3343: "Rania",
        STATE_KA_CITY_3344: "Ranibennur",
        STATE_WB_CITY_3345: "Raniganj",
        STATE_UT_CITY_3346: "Ranikhet",
        STATE_UP_CITY_3347: "Ranipur",
        STATE_UP_CITY_3348: "Ranipur Barsi",
        STATE_TR_CITY_3349: "Ranir Bazar",
        STATE_GJ_CITY_3350: "Ranpur",
        STATE_GJ_CITY_3351: "Rapar",
        STATE_TN_CITY_3352: "Rasipuram",
        STATE_UP_CITY_3353: "Rasra",
        STATE_UP_CITY_3354: "Rasulabad",
        STATE_RJ_CITY_3355: "Ratangarh",
        STATE_MP_CITY_3356: "Ratangarh",
        STATE_CT_CITY_3357: "Ratanpur",
        STATE_UP_CITY_3358: "Rath",
        STATE_HR_CITY_3359: "Ratia",
        STATE_MP_CITY_3360: "Ratlam",
        STATE_MH_CITY_3361: "Ratnagiri",
        STATE_OR_CITY_3362: "Raurkela",
        STATE_MH_CITY_3363: "Raver",
        STATE_RJ_CITY_3364: "Rawatbhata",
        STATE_RJ_CITY_3365: "Rawatsar",
        STATE_BR_CITY_3366: "Raxaul",
        STATE_JH_CITY_3367: "Ray",
        STATE_UP_CITY_3368: "Raya",
        STATE_AP_CITY_3369: "Rayachoti",
        STATE_AP_CITY_3370: "Rayadrug",
        STATE_OR_CITY_3371: "Rayagada",
        STATE_KA_CITY_3372: "Raybag",
        STATE_WB_CITY_3373: "Raypur",
        STATE_AP_CITY_3374: "Razam",
        STATE_AP_CITY_3375: "Razampeta",
        STATE_AP_CITY_3376: "Razole",
        STATE_GJ_CITY_3377: "Reha",
        STATE_UP_CITY_3378: "Rehar",
        STATE_MP_CITY_3379: "Rehli",
        STATE_MP_CITY_3380: "Rehti",
        STATE_OR_CITY_3381: "Remuna",
        STATE_MH_CITY_3382: "Renapur",
        STATE_MH_CITY_3383: "Renavi",
        STATE_OR_CITY_3384: "Rengali",
        STATE_AP_CITY_3385: "Renigunta",
        STATE_UP_CITY_3386: "Renukoot",
        STATE_UP_CITY_3387: "Renukut",
        STATE_UP_CITY_3388: "Reoti",
        STATE_UP_CITY_3389: "Reotipur",
        STATE_AP_CITY_3390: "Repalle",
        STATE_MH_CITY_3391: "Revadanda",
        STATE_MH_CITY_3392: "Revdanda",
        STATE_BR_CITY_3393: "Revelganj",
        STATE_MP_CITY_3394: "Rewa",
        STATE_HR_CITY_3395: "Rewari",
        STATE_HR_CITY_3396: "Rewari District",
        STATE_ML_CITY_3397: "Ri-Bhoi",
        STATE_JK_CITY_3398: "Riasi",
        STATE_UP_CITY_3399: "Richha",
        STATE_RJ_CITY_3400: "Ringas",
        STATE_UT_CITY_3401: "Rishikesh",
        STATE_WB_CITY_3402: "Rishra",
        STATE_MH_CITY_3403: "Risod",
        STATE_UP_CITY_3404: "Robertsganj",
        STATE_KA_CITY_3405: "Robertsonpet",
        STATE_GJ_CITY_3406: "Roha",
        STATE_MH_CITY_3407: "Roha",
        STATE_DL_CITY_3408: "Rohini",
        STATE_HP_CITY_3409: "Rohru",
        STATE_HR_CITY_3410: "Rohtak",
        STATE_BR_CITY_3411: "Rohtas",
        STATE_KA_CITY_3412: "Ron",
        STATE_UT_CITY_3413: "Roorkee",
        STATE_UP_CITY_3414: "Rudarpur",
        STATE_UP_CITY_3415: "Rudauli",
        STATE_UT_CITY_3416: "Rudraprayag",
        STATE_PB_CITY_3417: "Rupnagar",
        STATE_UP_CITY_3418: "Rura",
        STATE_BR_CITY_3419: "Rusera",
        STATE_MP_CITY_3420: "Sabalgarh",
        STATE_UP_CITY_3421: "Sabalpur",
        STATE_GJ_CITY_3422: "Sabar Kantha",
        STATE_HP_CITY_3423: "Sabathu",
        STATE_TR_CITY_3424: "Sabrum",
        STATE_UP_CITY_3425: "Sachendi",
        STATE_GJ_CITY_3426: "Sachin",
        STATE_UP_CITY_3427: "Sadabad",
        STATE_KA_CITY_3428: "Sadalgi",
        STATE_TG_CITY_3429: "Sadaseopet",
        STATE_UP_CITY_3430: "Sadat",
        STATE_RJ_CITY_3431: "Sadri",
        STATE_HR_CITY_3432: "Safidon",
        STATE_UP_CITY_3433: "Safipur",
        STATE_KA_CITY_3434: "Sagar",
        STATE_MP_CITY_3435: "Sagar",
        STATE_BR_CITY_3436: "Sagauli",
        STATE_WB_CITY_3437: "Sahapur",
        STATE_UP_CITY_3438: "Saharanpur",
        STATE_BR_CITY_3439: "Saharsa",
        STATE_UP_CITY_3440: "Sahaspur",
        STATE_UP_CITY_3441: "Sahaswan",
        STATE_UP_CITY_3442: "Sahawar",
        STATE_UP_CITY_3443: "Sahibabad",
        STATE_JH_CITY_3444: "Sahibganj",
        STATE_UP_CITY_3445: "Sahpau",
        STATE_UP_CITY_3446: "Saidpur",
        STATE_MZ_CITY_3447: "Saiha",
        STATE_MP_CITY_3448: "Sailana",
        STATE_MH_CITY_3449: "Sailu",
        STATE_TN_CITY_3450: "Saint Thomas Mount",
        STATE_WB_CITY_3451: "Sainthia",
        STATE_MZ_CITY_3452: "Sairang",
        STATE_MZ_CITY_3453: "Saitlaw",
        STATE_UP_CITY_3454: "Sakhanu",
        STATE_UP_CITY_3455: "Sakit",
        STATE_KA_CITY_3456: "Sakleshpur",
        STATE_MH_CITY_3457: "Sakol",
        STATE_MH_CITY_3458: "Sakoli",
        STATE_MH_CITY_3459: "Sakri",
        STATE_CT_CITY_3460: "Sakti",
        STATE_WB_CITY_3461: "Salanpur community development block",
        STATE_GJ_CITY_3462: "Salaya",
        STATE_TN_CITY_3463: "Salem",
        STATE_UP_CITY_3464: "Salempur",
        STATE_GA_CITY_3465: "Saligao",
        STATE_UP_CITY_3466: "Salon",
        STATE_RJ_CITY_3467: "Salumbar",
        STATE_AP_CITY_3468: "Salur",
        STATE_GJ_CITY_3469: "Samakhiali",
        STATE_HR_CITY_3470: "Samalkha",
        STATE_AP_CITY_3471: "Samalkot",
        STATE_BR_CITY_3472: "Samastipur",
        STATE_JK_CITY_3473: "Samba",
        STATE_OR_CITY_3474: "Sambalpur",
        STATE_UP_CITY_3475: "Sambhal",
        STATE_RJ_CITY_3476: "Sambhar",
        STATE_RJ_CITY_3477: "Samdari",
        STATE_PB_CITY_3478: "Samrala",
        STATE_UP_CITY_3479: "Samthar",
        STATE_MH_CITY_3480: "Samudrapur",
        STATE_GJ_CITY_3481: "Sanand",
        STATE_PB_CITY_3482: "Sanaur",
        STATE_MP_CITY_3483: "Sanawad",
        STATE_MP_CITY_3484: "Sanchi",
        STATE_RJ_CITY_3485: "Sanchor",
        STATE_GA_CITY_3486: "Sancoale",
        STATE_UP_CITY_3487: "Sandi",
        STATE_UP_CITY_3488: "Sandila",
        STATE_KA_CITY_3489: "Sandur",
        STATE_MH_CITY_3490: "Sangameshwar",
        STATE_MH_CITY_3491: "Sangamner",
        STATE_TG_CITY_3492: "Sangareddi",
        STATE_RJ_CITY_3493: "Sangaria",
        STATE_MH_CITY_3494: "Sangli",
        STATE_RJ_CITY_3495: "Sangod",
        STATE_MH_CITY_3496: "Sangola",
        STATE_MH_CITY_3497: "Sangole",
        STATE_MH_CITY_3498: "Sangrampur, Maharashtra",
        STATE_PB_CITY_3499: "Sangrur",
        STATE_GA_CITY_3500: "Sanguem",
        STATE_KA_CITY_3501: "Sanivarsante",
        STATE_WB_CITY_3502: "Sankarpur",
        STATE_KA_CITY_3503: "Sankeshwar",
        STATE_GJ_CITY_3504: "Sankheda",
        STATE_WB_CITY_3505: "Sankrail",
        STATE_GA_CITY_3506: "Sanquelim",
        STATE_UP_CITY_3507: "Sant Kabir Nagar",
        STATE_UP_CITY_3508: "Sant Ravi Das Nagar",
        STATE_WB_CITY_3509: "Santipur",
        STATE_HP_CITY_3510: "Santokhgarh",
        STATE_WB_CITY_3511: "Santoshpur",
        STATE_WB_CITY_3512: "Santuri community development block",
        STATE_GA_CITY_3513: "Sanvordem",
        STATE_MP_CITY_3514: "Sanwer",
        STATE_MH_CITY_3515: "Saoli",
        STATE_MH_CITY_3516: "Saoner",
        STATE_AS_CITY_3517: "Sapatgram",
        STATE_HP_CITY_3518: "Sarahan",
        STATE_UP_CITY_3519: "Sarai Akil",
        STATE_UP_CITY_3520: "Sarai Ekdil",
        STATE_UP_CITY_3521: "Sarai Mir",
        STATE_JH_CITY_3522: "Saraikela",
        STATE_CT_CITY_3523: "Saraipali",
        STATE_BR_CITY_3524: "Saran",
        STATE_CT_CITY_3525: "Sarangarh",
        STATE_MH_CITY_3526: "Sarangkheda",
        STATE_MP_CITY_3527: "Sarangpur",
        STATE_UP_CITY_3528: "Sarauli",
        STATE_GJ_CITY_3529: "Sarbhon",
        STATE_RJ_CITY_3530: "Sardarshahr",
        STATE_UP_CITY_3531: "Sardhana",
        STATE_GJ_CITY_3532: "Sardoi",
        STATE_PB_CITY_3533: "Sardulgarh",
        STATE_WB_CITY_3534: "Sarenga",
        STATE_KA_CITY_3535: "Sargur",
        STATE_UP_CITY_3536: "Sarila",
        STATE_HP_CITY_3537: "Sarka Ghat",
        STATE_GJ_CITY_3538: "Sarkhej",
        STATE_JH_CITY_3539: "Sarubera",
        STATE_AS_CITY_3540: "Sarupathar",
        STATE_UP_CITY_3541: "Sarurpur",
        STATE_RJ_CITY_3542: "Sarwar",
        STATE_UP_CITY_3543: "Sasni",
        STATE_MH_CITY_3544: "Sasvad",
        STATE_MH_CITY_3545: "Saswad",
        STATE_MH_CITY_3546: "Satana",
        STATE_MH_CITY_3547: "Satara",
        STATE_MH_CITY_3548: "Satara Division",
        STATE_GJ_CITY_3549: "Sathamba",
        STATE_TN_CITY_3550: "Sathankulam",
        STATE_TG_CITY_3551: "Sathupalli",
        STATE_TN_CITY_3552: "Sathyamangalam",
        STATE_MP_CITY_3553: "Satna",
        STATE_MH_CITY_3554: "Satpati",
        STATE_UP_CITY_3555: "Satrikh",
        STATE_AP_CITY_3556: "Sattenapalle",
        STATE_TN_CITY_3557: "Sattur",
        STATE_MP_CITY_3558: "Satwas",
        STATE_MP_CITY_3559: "Saugor",
        STATE_KA_CITY_3560: "Saundatti",
        STATE_UP_CITY_3561: "Saurikh",
        STATE_MP_CITY_3562: "Sausar",
        STATE_MH_CITY_3563: "Savantvadi",
        STATE_KA_CITY_3564: "Savanur",
        STATE_GJ_CITY_3565: "Savarkundla",
        STATE_MH_CITY_3566: "Savda",
        STATE_MH_CITY_3567: "Savlaj",
        STATE_GJ_CITY_3568: "Savli",
        STATE_RJ_CITY_3569: "Sawai Madhopur",
        STATE_MH_CITY_3570: "Sawantvadi",
        STATE_TN_CITY_3571: "Sayalkudi",
        STATE_GJ_CITY_3572: "Sayla",
        STATE_UP_CITY_3573: "Sector",
        STATE_TG_CITY_3574: "Secunderabad",
        STATE_MP_CITY_3575: "Sehore",
        STATE_MH_CITY_3576: "Selu",
        STATE_MN_CITY_3577: "Senapati",
        STATE_MP_CITY_3578: "Sendhwa",
        STATE_UP_CITY_3579: "Seohara",
        STATE_MP_CITY_3580: "Seondha",
        STATE_HP_CITY_3581: "Seoni",
        STATE_MP_CITY_3582: "Seoni",
        STATE_MP_CITY_3583: "Seoni Malwa",
        STATE_CT_CITY_3584: "Seorinarayan",
        STATE_KA_CITY_3585: "Seram",
        STATE_WB_CITY_3586: "Serampore",
        STATE_MZ_CITY_3587: "Serchhip",
        STATE_TG_CITY_3588: "Serilingampalle",
        STATE_WB_CITY_3589: "Serpur",
        STATE_GA_CITY_3590: "Serula",
        STATE_MH_CITY_3591: "Sevagram",
        STATE_TN_CITY_3592: "Seven Pagodas",
        STATE_MH_CITY_3593: "Sewri",
        STATE_HR_CITY_3594: "Shadipur Julana",
        STATE_UP_CITY_3595: "Shahabad",
        STATE_HR_CITY_3596: "Shahabad",
        STATE_KA_CITY_3597: "Shahabad",
        STATE_MH_CITY_3598: "Shahada",
        STATE_MH_CITY_3599: "Shahapur",
        STATE_BR_CITY_3600: "Shahbazpur",
        STATE_MP_CITY_3601: "Shahdol",
        STATE_UP_CITY_3602: "Shahganj",
        STATE_MP_CITY_3603: "Shahgarh",
        STATE_UP_CITY_3604: "Shahi",
        STATE_PB_CITY_3605: "Shahid Bhagat Singh Nagar",
        STATE_UP_CITY_3606: "Shahjahanpur",
        STATE_PB_CITY_3607: "Shahkot",
        STATE_KA_CITY_3608: "Shahpur",
        STATE_MP_CITY_3609: "Shahpur",
        STATE_GJ_CITY_3610: "Shahpur",
        STATE_UP_CITY_3611: "Shahpur",
        STATE_BR_CITY_3612: "Shahpur",
        STATE_RJ_CITY_3613: "Shahpura",
        STATE_MP_CITY_3614: "Shahpura",
        STATE_MP_CITY_3615: "Shajapur",
        STATE_PB_CITY_3616: "Sham Churasi",
        STATE_MP_CITY_3617: "Shamgarh",
        STATE_UP_CITY_3618: "Shamli",
        STATE_UP_CITY_3619: "Shamsabad",
        STATE_UP_CITY_3620: "Shankargarh",
        STATE_MH_CITY_3621: "Shedbal",
        STATE_MH_CITY_3622: "Shegaon",
        STATE_BR_CITY_3623: "Sheikhpura",
        STATE_RJ_CITY_3624: "Sheoganj",
        STATE_BR_CITY_3625: "Sheohar",
        STATE_MP_CITY_3626: "Sheopur",
        STATE_UP_CITY_3627: "Shergarh",
        STATE_BR_CITY_3628: "Sherghati",
        STATE_UP_CITY_3629: "Sherkot",
        STATE_KL_CITY_3630: "Shertallai",
        STATE_MH_CITY_3631: "Shevgaon",
        STATE_UP_CITY_3632: "Shibnagar",
        STATE_KA_CITY_3633: "Shiggaon",
        STATE_KA_CITY_3634: "Shikarpur",
        STATE_UP_CITY_3635: "Shikarpur",
        STATE_UP_CITY_3636: "Shikarpur (Bulandshahr)",
        STATE_UP_CITY_3637: "Shikohabad",
        STATE_MH_CITY_3638: "Shikrapur",
        STATE_ML_CITY_3639: "Shillong",
        STATE_HP_CITY_3640: "Shimla",
        STATE_KA_CITY_3641: "Shimoga",
        STATE_MH_CITY_3642: "Shiraguppi",
        STATE_MH_CITY_3643: "Shirala",
        STATE_MH_CITY_3644: "Shirdi",
        STATE_MH_CITY_3645: "Shirgaon",
        STATE_KA_CITY_3646: "Shirhatti",
        STATE_MH_CITY_3647: "Shirol",
        STATE_MH_CITY_3648: "Shirpur",
        STATE_MH_CITY_3649: "Shirud",
        STATE_MH_CITY_3650: "Shirwal",
        STATE_UP_CITY_3651: "Shishgarh",
        STATE_MH_CITY_3652: "Shivaji Nagar",
        STATE_MP_CITY_3653: "Shivpuri",
        STATE_GJ_CITY_3654: "Shivrajpur",
        STATE_UP_CITY_3655: "Shivrajpur",
        STATE_TN_CITY_3656: "Sholinghur",
        STATE_KL_CITY_3657: "Shōranur",
        STATE_KA_CITY_3658: "Shorapur",
        STATE_UP_CITY_3659: "Shrawasti",
        STATE_MH_CITY_3660: "Shrigonda",
        STATE_KA_CITY_3661: "Shrirangapattana",
        STATE_MP_CITY_3662: "Shujalpur",
        STATE_JK_CITY_3663: "Shupiyan",
        STATE_WB_CITY_3664: "Shyamnagar, West Bengal",
        STATE_AS_CITY_3665: "Sibsagar",
        STATE_KA_CITY_3666: "Siddapur",
        STATE_UP_CITY_3667: "Siddharthnagar",
        STATE_UP_CITY_3668: "Siddhaur",
        STATE_GJ_CITY_3669: "Siddhpur",
        STATE_TG_CITY_3670: "Siddipet",
        STATE_UP_CITY_3671: "Sidhauli",
        STATE_MP_CITY_3672: "Sidhi",
        STATE_UP_CITY_3673: "Sidhpura",
        STATE_KA_CITY_3674: "Sidlaghatta",
        STATE_GJ_CITY_3675: "Sihor",
        STATE_MP_CITY_3676: "Sihora",
        STATE_JH_CITY_3677: "Sijua",
        STATE_UP_CITY_3678: "Sikandarabad",
        STATE_UP_CITY_3679: "Sikandarpur",
        STATE_UP_CITY_3680: "Sikandra",
        STATE_UP_CITY_3681: "Sikandra Rao",
        STATE_UP_CITY_3682: "Sikandrabad",
        STATE_RJ_CITY_3683: "Sikar",
        STATE_GJ_CITY_3684: "Sikka",
        STATE_BR_CITY_3685: "Silao",
        STATE_AS_CITY_3686: "Silapathar",
        STATE_AS_CITY_3687: "Silchar",
        STATE_WB_CITY_3688: "Siliguri",
        STATE_MH_CITY_3689: "Sillod",
        STATE_DN_CITY_3690: "Silvassa",
        STATE_MP_CITY_3691: "Simaria",
        STATE_JH_CITY_3692: "Simdega",
        STATE_CT_CITY_3693: "Simga",
        STATE_MH_CITY_3694: "Sindewahi",
        STATE_KA_CITY_3695: "Sindgi",
        STATE_KA_CITY_3696: "Sindhnur",
        STATE_MH_CITY_3697: "Sindhudurg",
        STATE_MH_CITY_3698: "Sindi",
        STATE_MH_CITY_3699: "Sindkheda",
        STATE_TN_CITY_3700: "Singanallur",
        STATE_TN_CITY_3701: "Singapperumalkovil",
        STATE_TG_CITY_3702: "Singapur",
        STATE_AP_CITY_3703: "Singarayakonda",
        STATE_MP_CITY_3704: "Singoli",
        STATE_MP_CITY_3705: "Singrauli",
        STATE_SK_CITY_3706: "Singtam",
        STATE_WB_CITY_3707: "Singur",
        STATE_JH_CITY_3708: "Sini",
        STATE_MH_CITY_3709: "Sinnar",
        STATE_GJ_CITY_3710: "Sinor",
        STATE_MH_CITY_3711: "Sion, Mumbai",
        STATE_KA_CITY_3712: "Sira",
        STATE_UP_CITY_3713: "Sirathu",
        STATE_PB_CITY_3714: "Sirhind-Fategarh",
        STATE_TN_CITY_3715: "Sirkazhi",
        STATE_MP_CITY_3716: "Sirmaur",
        STATE_HP_CITY_3717: "Sirmaur",
        STATE_RJ_CITY_3718: "Sirohi",
        STATE_MH_CITY_3719: "Sironcha",
        STATE_MP_CITY_3720: "Sironj",
        STATE_TG_CITY_3721: "Sirpur",
        STATE_HR_CITY_3722: "Sirsa",
        STATE_UP_CITY_3723: "Sirsa",
        STATE_UP_CITY_3724: "Sirsaganj",
        STATE_KA_CITY_3725: "Sirsi",
        STATE_UP_CITY_3726: "Sirsi",
        STATE_TG_CITY_3727: "Sirsilla",
        STATE_KA_CITY_3728: "Siruguppa",
        STATE_TN_CITY_3729: "Sirumugai",
        STATE_MH_CITY_3730: "Sirur",
        STATE_UP_CITY_3731: "Sisauli",
        STATE_UP_CITY_3732: "Siswa Bazar",
        STATE_BR_CITY_3733: "Sitamarhi",
        STATE_MP_CITY_3734: "Sitamau",
        STATE_UP_CITY_3735: "Sitapur",
        STATE_UT_CITY_3736: "Sitarganj",
        STATE_TN_CITY_3737: "Sivaganga",
        STATE_TN_CITY_3738: "Sivagiri",
        STATE_TN_CITY_3739: "Sivakasi",
        STATE_MH_CITY_3740: "Sivala, East Godavari district",
        STATE_BR_CITY_3741: "Siwan",
        STATE_RJ_CITY_3742: "Siwana",
        STATE_AS_CITY_3743: "Soalkuchi",
        STATE_WB_CITY_3744: "Sodpur",
        STATE_MP_CITY_3745: "Sohagi",
        STATE_MP_CITY_3746: "Sohagpur",
        STATE_HR_CITY_3747: "Sohna",
        STATE_RJ_CITY_3748: "Sojat",
        STATE_GJ_CITY_3749: "Sojitra",
        STATE_HP_CITY_3750: "Solan",
        STATE_WB_CITY_3751: "Solap",
        STATE_MH_CITY_3752: "Solapur",
        STATE_GA_CITY_3753: "Solim",
        STATE_KA_CITY_3754: "Someshwar",
        STATE_AP_CITY_3755: "Sompeta",
        STATE_KA_CITY_3756: "Somvarpet",
        STATE_WB_CITY_3757: "Sonada",
        STATE_MH_CITY_3758: "Sonala",
        STATE_WB_CITY_3759: "Sonamukhi",
        STATE_TR_CITY_3760: "Sonamura",
        STATE_AS_CITY_3761: "Sonari",
        STATE_WB_CITY_3762: "Sonarpur community development block",
        STATE_UP_CITY_3763: "Sonbhadra",
        STATE_MH_CITY_3764: "Sonegaon",
        STATE_OR_CITY_3765: "Sonepur",
        STATE_GJ_CITY_3766: "Songadh",
        STATE_MH_CITY_3767: "Songir",
        STATE_HR_CITY_3768: "Sonipat",
        STATE_AS_CITY_3769: "Sonitpur",
        STATE_MH_CITY_3770: "Sonvad",
        STATE_JK_CITY_3771: "Sopur",
        STATE_KA_CITY_3772: "Sorab",
        STATE_OR_CITY_3773: "Sorada",
        STATE_AS_CITY_3774: "Sorbhog",
        STATE_OR_CITY_3775: "Soro",
        STATE_UP_CITY_3776: "Soron",
        STATE_WB_CITY_3777: "South 24 Parganas district",
        STATE_AN_CITY_3778: "South Andaman",
        STATE_DL_CITY_3779: "South Delhi",
        STATE_SK_CITY_3780: "South District",
        STATE_ML_CITY_3781: "South Garo Hills",
        STATE_GA_CITY_3782: "South Goa",
        STATE_TR_CITY_3783: "South Tripura",
        STATE_DL_CITY_3784: "South West Delhi",
        STATE_ML_CITY_3785: "South West Garo Hills",
        STATE_ML_CITY_3786: "South West Khasi Hills",
        STATE_MH_CITY_3787: "Soygaon",
        STATE_JK_CITY_3788: "Soyibug",
        STATE_KA_CITY_3789: "Sravana Belgola",
        STATE_RJ_CITY_3790: "Sri Dungargarh",
        STATE_RJ_CITY_3791: "Sri Madhopur",
        STATE_PB_CITY_3792: "Sri Muktsar Sahib",
        STATE_AP_CITY_3793: "Srikakulam",
        STATE_WB_CITY_3794: "Srikhanda",
        STATE_TN_CITY_3795: "Srimushnam",
        STATE_JK_CITY_3796: "Srinagar",
        STATE_UT_CITY_3797: "Srinagar",
        STATE_KA_CITY_3798: "Sringeri",
        STATE_KA_CITY_3799: "Srinivaspur",
        STATE_TN_CITY_3800: "Sriperumbudur",
        STATE_TG_CITY_3801: "Sriramnagar",
        STATE_WB_CITY_3802: "Srirampur",
        STATE_AP_CITY_3803: "Srisailain",
        STATE_TN_CITY_3804: "Srivaikuntam",
        STATE_MH_CITY_3805: "Srivardhan",
        STATE_TN_CITY_3806: "Srivilliputhur",
        STATE_UP_CITY_3807: "Suar",
        STATE_OR_CITY_3808: "Subarnapur",
        STATE_TN_CITY_3809: "Suchindram",
        STATE_RJ_CITY_3810: "Sujangarh",
        STATE_RJ_CITY_3811: "Suket",
        STATE_UT_CITY_3812: "Sultanpur",
        STATE_MP_CITY_3813: "Sultanpur",
        STATE_UP_CITY_3814: "Sultanpur",
        STATE_PB_CITY_3815: "Sultanpur Lodhi",
        STATE_TN_CITY_3816: "Sulur",
        STATE_AP_CITY_3817: "Suluru",
        STATE_KA_CITY_3818: "Sulya",
        STATE_JK_CITY_3819: "Sumbal",
        STATE_PB_CITY_3820: "Sunam",
        STATE_OR_CITY_3821: "Sundargarh",
        STATE_HP_CITY_3822: "Sundarnagar",
        STATE_RJ_CITY_3823: "Sunel",
        STATE_KA_CITY_3824: "Suntikoppa",
        STATE_BR_CITY_3825: "Supaul",
        STATE_GJ_CITY_3826: "Supedi",
        STATE_RJ_CITY_3827: "Surajgarh",
        STATE_TN_CITY_3828: "Surandai",
        STATE_GJ_CITY_3829: "Surat",
        STATE_RJ_CITY_3830: "Suratgarh",
        STATE_GJ_CITY_3831: "Surendranagar",
        STATE_MH_CITY_3832: "Surgana",
        STATE_CT_CITY_3833: "Surguja",
        STATE_WB_CITY_3834: "Suri",
        STATE_UP_CITY_3835: "Surianwan",
        STATE_TG_CITY_3836: "Suriapet",
        STATE_MP_CITY_3837: "Susner",
        STATE_GJ_CITY_3838: "Sutrapada",
        STATE_TN_CITY_3839: "Swamimalai",
        STATE_WB_CITY_3840: "Swarupnagar community development block",
        STATE_AP_CITY_3841: "Tadepalle",
        STATE_AP_CITY_3842: "Tadepallegudem",
        STATE_AP_CITY_3843: "Tadpatri",
        STATE_UP_CITY_3844: "Tajpur",
        STATE_WB_CITY_3845: "Takdah",
        STATE_RJ_CITY_3846: "Takhatgarh",
        STATE_CT_CITY_3847: "Takhatpur",
        STATE_WB_CITY_3848: "Taki",
        STATE_MH_CITY_3849: "Taklibhan",
        STATE_MP_CITY_3850: "Tal",
        STATE_GJ_CITY_3851: "Talaja",
        STATE_UP_CITY_3852: "Talbahat",
        STATE_MH_CITY_3853: "Talbid",
        STATE_OR_CITY_3854: "Talcher",
        STATE_MH_CITY_3855: "Talegaon Dabhade",
        STATE_MH_CITY_3856: "Talegaon Dhamdhere",
        STATE_GA_CITY_3857: "Taleigao",
        STATE_MP_CITY_3858: "Talen",
        STATE_UP_CITY_3859: "Talgram",
        STATE_KA_CITY_3860: "Talikota",
        STATE_KL_CITY_3861: "Talipparamba",
        STATE_MH_CITY_3862: "Taloda",
        STATE_MH_CITY_3863: "Talode",
        STATE_PB_CITY_3864: "Talwandi Bhai",
        STATE_PB_CITY_3865: "Talwara",
        STATE_TN_CITY_3866: "Tambaram",
        STATE_MN_CITY_3867: "Tamenglong",
        STATE_WB_CITY_3868: "Tamluk",
        STATE_UT_CITY_3869: "Tanakpur",
        STATE_UP_CITY_3870: "Tanda",
        STATE_TG_CITY_3871: "Tandur",
        STATE_TN_CITY_3872: "Tanjore",
        STATE_GJ_CITY_3873: "Tankara",
        STATE_AP_CITY_3874: "Tanuku",
        STATE_HR_CITY_3875: "Taoru",
        STATE_GJ_CITY_3876: "Tapi",
        STATE_OR_CITY_3877: "Tarabha",
        STATE_WB_CITY_3878: "Tarakeswar",
        STATE_TN_CITY_3879: "Taramangalam",
        STATE_MP_CITY_3880: "Tarana",
        STATE_RJ_CITY_3881: "Taranagar",
        STATE_MH_CITY_3882: "Tarapur",
        STATE_MH_CITY_3883: "Tardeo",
        STATE_KA_CITY_3884: "Tarikere",
        STATE_PB_CITY_3885: "Tarn Taran Sahib",
        STATE_MH_CITY_3886: "Tasgaon",
        STATE_TN_CITY_3887: "Tattayyangarpettai",
        STATE_AR_CITY_3888: "Tawang",
        STATE_BR_CITY_3889: "Teghra",
        STATE_UT_CITY_3890: "Tehri",
        STATE_UT_CITY_3891: "Tehri-Garhwal",
        STATE_MP_CITY_3892: "Tekanpur",
        STATE_BR_CITY_3893: "Tekari",
        STATE_KA_CITY_3894: "Tekkalakote",
        STATE_AP_CITY_3895: "Tekkali",
        STATE_MH_CITY_3896: "Telhara",
        STATE_KL_CITY_3897: "Tellicherry",
        STATE_MP_CITY_3898: "Tendukheda",
        STATE_MP_CITY_3899: "Teonthar",
        STATE_KA_CITY_3900: "Terdal",
        STATE_UP_CITY_3901: "Terha",
        STATE_AS_CITY_3902: "Tezpur",
        STATE_AR_CITY_3903: "Tezu",
        STATE_UP_CITY_3904: "Thakurdwara",
        STATE_BR_CITY_3905: "Thakurganj",
        STATE_MH_CITY_3906: "Thalner",
        STATE_GJ_CITY_3907: "Than",
        STATE_UP_CITY_3908: "Thana Bhawan",
        STATE_MP_CITY_3909: "Thandla",
        STATE_MH_CITY_3910: "Thane",
        STATE_HR_CITY_3911: "Thanesar",
        STATE_JK_CITY_3912: "Thang",
        STATE_GJ_CITY_3913: "Thangadh",
        STATE_TN_CITY_3914: "Thanjavur",
        STATE_JK_CITY_3915: "Thanna Mandi",
        STATE_KL_CITY_3916: "Thanniyam",
        STATE_GJ_CITY_3917: "Tharad",
        STATE_TN_CITY_3918: "Tharangambadi",
        STATE_GJ_CITY_3919: "Thasra",
        STATE_GJ_CITY_3920: "The Dangs",
        STATE_TN_CITY_3921: "Theni",
        STATE_TN_CITY_3922: "Thenkasi",
        STATE_MZ_CITY_3923: "Thenzawl",
        STATE_HP_CITY_3924: "Theog",
        STATE_TN_CITY_3925: "Thirukattupalli",
        STATE_TN_CITY_3926: "Thiruthani",
        STATE_TN_CITY_3927: "Thiruvaiyaru",
        STATE_TN_CITY_3928: "Thiruvallur",
        STATE_KL_CITY_3929: "Thiruvananthapuram",
        STATE_TN_CITY_3930: "Thiruvarur",
        STATE_TN_CITY_3931: "Thiruvidaimaruthur",
        STATE_TN_CITY_3932: "Thoothukudi",
        STATE_MN_CITY_3933: "Thoubal",
        STATE_KL_CITY_3934: "Thrissur",
        STATE_KL_CITY_3935: "Thrissur District",
        STATE_UP_CITY_3936: "Tigri",
        STATE_RJ_CITY_3937: "Tijara",
        STATE_UP_CITY_3938: "Tikaitnagar",
        STATE_MP_CITY_3939: "Tikamgarh",
        STATE_UP_CITY_3940: "Tikri",
        STATE_UP_CITY_3941: "Tilhar",
        STATE_UP_CITY_3942: "Tilsahri",
        STATE_TN_CITY_3943: "Tindivanam",
        STATE_UP_CITY_3944: "Tindwari",
        STATE_TN_CITY_3945: "Tinnanur",
        STATE_AS_CITY_3946: "Tinsukia",
        STATE_KA_CITY_3947: "Tiptur",
        STATE_HP_CITY_3948: "Tira Sujanpur",
        STATE_AR_CITY_3949: "Tirap",
        STATE_MP_CITY_3950: "Tirodi",
        STATE_KA_CITY_3951: "Tirthahalli",
        STATE_TN_CITY_3952: "Tiruchchendur",
        STATE_TN_CITY_3953: "Tiruchengode",
        STATE_TN_CITY_3954: "Tiruchirappalli",
        STATE_TN_CITY_3955: "Tirukkoyilur",
        STATE_KA_CITY_3956: "Tirumakudal Narsipur",
        STATE_AP_CITY_3957: "Tirumala",
        STATE_TN_CITY_3958: "Tirumullaivasal",
        STATE_TN_CITY_3959: "Tirunelveli",
        STATE_TN_CITY_3960: "Tirunelveli Kattabo",
        STATE_AP_CITY_3961: "Tirupati",
        STATE_TN_CITY_3962: "Tiruppalaikudi",
        STATE_TN_CITY_3963: "Tirupparangunram",
        STATE_TN_CITY_3964: "Tiruppur",
        STATE_TN_CITY_3965: "Tiruppuvanam",
        STATE_KL_CITY_3966: "Tirur",
        STATE_TN_CITY_3967: "Tiruttangal",
        STATE_KL_CITY_3968: "Tiruvalla",
        STATE_TN_CITY_3969: "Tiruvannamalai",
        STATE_TN_CITY_3970: "Tiruvottiyur",
        STATE_TN_CITY_3971: "Tisaiyanvilai",
        STATE_AS_CITY_3972: "Titabar",
        STATE_WB_CITY_3973: "Titagarh",
        STATE_OR_CITY_3974: "Titlagarh",
        STATE_UP_CITY_3975: "Titron",
        STATE_RJ_CITY_3976: "Todabhim",
        STATE_RJ_CITY_3977: "Todaraisingh",
        STATE_HR_CITY_3978: "Tohana",
        STATE_TN_CITY_3979: "Tondi",
        STATE_RJ_CITY_3980: "Tonk",
        STATE_JH_CITY_3981: "Topchanchi",
        STATE_UP_CITY_3982: "Tori Fatehpur",
        STATE_UP_CITY_3983: "Tori-Fatehpur",
        STATE_HR_CITY_3984: "Tosham",
        STATE_JK_CITY_3985: "Tral",
        STATE_MH_CITY_3986: "Trimbak",
        STATE_MH_CITY_3987: "Trombay",
        STATE_JK_CITY_3988: "Tsrar Sharif",
        STATE_NL_CITY_3989: "Tuensang",
        STATE_NL_CITY_3990: "Tuensang District",
        STATE_WB_CITY_3991: "Tufanganj",
        STATE_WB_CITY_3992: "Tulin",
        STATE_MH_CITY_3993: "Tuljapur",
        STATE_UP_CITY_3994: "Tulsipur",
        STATE_KA_CITY_3995: "Tumkur",
        STATE_MH_CITY_3996: "Tumsar",
        STATE_UP_CITY_3997: "Tundla",
        STATE_AP_CITY_3998: "Tuni",
        STATE_ML_CITY_3999: "Tura",
        STATE_TN_CITY_4000: "Turaiyur",
        STATE_KA_CITY_4001: "Turuvekere",
        STATE_WB_CITY_4002: "Uchalan",
        STATE_TR_CITY_4003: "Udaipur",
        STATE_RJ_CITY_4004: "Udaipur",
        STATE_MP_CITY_4005: "Udaipura",
        STATE_AS_CITY_4006: "Udalguri",
        STATE_TN_CITY_4007: "Udangudi",
        STATE_OR_CITY_4008: "Udayagiri",
        STATE_MH_CITY_4009: "Udgir",
        STATE_UT_CITY_4010: "Udham Singh Nagar",
        STATE_JK_CITY_4011: "Udhampur",
        STATE_RJ_CITY_4012: "Udpura",
        STATE_TN_CITY_4013: "Udumalaippettai",
        STATE_KA_CITY_4014: "Udupi",
        STATE_UP_CITY_4015: "Ugu",
        STATE_UP_CITY_4016: "Ujhani",
        STATE_MP_CITY_4017: "Ujjain",
        STATE_MN_CITY_4018: "Ukhrul",
        STATE_HR_CITY_4019: "Uklana",
        STATE_MP_CITY_4020: "Ukwa",
        STATE_WB_CITY_4021: "Ula",
        STATE_MH_CITY_4022: "Ulhasnagar",
        STATE_KA_CITY_4023: "Ullal",
        STATE_WB_CITY_4024: "Uluberia",
        STATE_MH_CITY_4025: "Umarga",
        STATE_MP_CITY_4026: "Umaria",
        STATE_MP_CITY_4027: "Umaria District",
        STATE_MH_CITY_4028: "Umarkhed",
        STATE_CT_CITY_4029: "Umarkot",
        STATE_GJ_CITY_4030: "Umarpada",
        STATE_GJ_CITY_4031: "Umrala",
        STATE_MH_CITY_4032: "Umred",
        STATE_GJ_CITY_4033: "Umreth",
        STATE_MP_CITY_4034: "Umri",
        STATE_UP_CITY_4035: "Umri",
        STATE_GJ_CITY_4036: "Un",
        STATE_UP_CITY_4037: "Un",
        STATE_HP_CITY_4038: "Una",
        STATE_GJ_CITY_4039: "Una",
        STATE_TR_CITY_4040: "Unakoti",
        STATE_MP_CITY_4041: "Unhel",
        STATE_RJ_CITY_4042: "Uniara",
        STATE_GJ_CITY_4043: "Unjha",
        STATE_UP_CITY_4044: "Unnao",
        STATE_GJ_CITY_4045: "Upleta",
        STATE_TG_CITY_4046: "Uppal Kalan",
        STATE_AR_CITY_4047: "Upper Siang",
        STATE_AR_CITY_4048: "Upper Subansiri",
        STATE_TN_CITY_4049: "Uppiliyapuram",
        STATE_MH_CITY_4050: "Uran",
        STATE_AP_CITY_4051: "Uravakonda",
        STATE_JK_CITY_4052: "Uri",
        STATE_MH_CITY_4053: "Uruli Kanchan",
        STATE_UP_CITY_4054: "Usawan",
        STATE_UP_CITY_4055: "Usehat",
        STATE_TN_CITY_4056: "Usilampatti",
        STATE_UP_CITY_4057: "Uska",
        STATE_GJ_CITY_4058: "Utran",
        STATE_UP_CITY_4059: "Utraula",
        STATE_TN_CITY_4060: "Uttamapalaiyam",
        STATE_CT_CITY_4061: "Uttar Bastar Kanker",
        STATE_WB_CITY_4062: "Uttar Dinajpur district",
        STATE_KA_CITY_4063: "Uttar Kannada",
        STATE_UT_CITY_4064: "Uttarkashi",
        STATE_WB_CITY_4065: "Uttarpara Kotrung",
        STATE_TN_CITY_4066: "Uttiramerur",
        STATE_TN_CITY_4067: "Uttukkuli",
        STATE_TN_CITY_4068: "V.S.K.Valasai (Dindigul-Dist.)",
        STATE_MH_CITY_4069: "Vada",
        STATE_TN_CITY_4070: "Vadakku Valliyur",
        STATE_TN_CITY_4071: "Vadakku Viravanallur",
        STATE_TN_CITY_4072: "Vadamadurai",
        STATE_GJ_CITY_4073: "Vadgam",
        STATE_MH_CITY_4074: "Vadgaon",
        STATE_KA_CITY_4075: "Vadigenhalli",
        STATE_TN_CITY_4076: "Vadippatti",
        STATE_AP_CITY_4077: "vadlamuru",
        STATE_AP_CITY_4078: "Vadlapudi",
        STATE_GJ_CITY_4079: "Vadnagar",
        STATE_MH_CITY_4080: "Vadner",
        STATE_GJ_CITY_4081: "Vadodara",
        STATE_GA_CITY_4082: "Vagator",
        STATE_GJ_CITY_4083: "Vaghodia",
        STATE_GJ_CITY_4084: "Vaghodia INA",
        STATE_MH_CITY_4085: "Vaijapur",
        STATE_KL_CITY_4086: "Vaikam",
        STATE_MH_CITY_4087: "Vairag",
        STATE_BR_CITY_4088: "Vaishali",
        STATE_TN_CITY_4089: "Valangaiman",
        STATE_TN_CITY_4090: "Valavanur",
        STATE_GJ_CITY_4091: "Vallabh Vidyanagar",
        STATE_GJ_CITY_4092: "Vallabhipur",
        STATE_TN_CITY_4093: "Vallam",
        STATE_TN_CITY_4094: "Valparai",
        STATE_GA_CITY_4095: "Valpoy",
        STATE_GJ_CITY_4096: "Valsad",
        STATE_MH_CITY_4097: "Valsang",
        STATE_GJ_CITY_4098: "Vanala",
        STATE_TN_CITY_4099: "Vandalur",
        STATE_TN_CITY_4100: "Vandavasi",
        STATE_MH_CITY_4101: "Vangaon",
        STATE_TN_CITY_4102: "Vaniyambadi",
        STATE_GJ_CITY_4103: "Vansda",
        STATE_GJ_CITY_4104: "Vanthli",
        STATE_GJ_CITY_4105: "Vapi",
        STATE_UP_CITY_4106: "Varanasi",
        STATE_MH_CITY_4107: "Varangaon",
        STATE_GA_CITY_4108: "Varca",
        STATE_KL_CITY_4109: "Varkala",
        STATE_GJ_CITY_4110: "Vartej",
        STATE_GJ_CITY_4111: "Vasa",
        STATE_GJ_CITY_4112: "Vasavad",
        STATE_GA_CITY_4113: "Vasco da Gama",
        STATE_MH_CITY_4114: "Vashi",
        STATE_MH_CITY_4115: "Vasind",
        STATE_GJ_CITY_4116: "Vaso",
        STATE_TN_CITY_4117: "Vasudevanallur",
        STATE_GJ_CITY_4118: "Vataman",
        STATE_TN_CITY_4119: "Vattalkundu",
        STATE_MH_CITY_4120: "Vatul",
        STATE_KL_CITY_4121: "Vayalar",
        STATE_TN_CITY_4122: "Vedaraniyam",
        STATE_TN_CITY_4123: "Vedasandur",
        STATE_GJ_CITY_4124: "Vejalpur",
        STATE_TN_CITY_4125: "Velankanni",
        STATE_MH_CITY_4126: "Velas, Maharashtra",
        STATE_TN_CITY_4127: "Vellanur",
        STATE_TN_CITY_4128: "Vellore",
        STATE_MH_CITY_4129: "Velneshwar",
        STATE_TN_CITY_4130: "Velur",
        STATE_TG_CITY_4131: "Vemalwada",
        STATE_TN_CITY_4132: "Vengavasal",
        STATE_MH_CITY_4133: "Vengurla",
        STATE_AP_CITY_4134: "Venkatagiri",
        STATE_AP_CITY_4135: "Vepagunta",
        STATE_GJ_CITY_4136: "Veraval",
        STATE_AP_CITY_4137: "Vetapalem",
        STATE_TN_CITY_4138: "Vettaikkaranpudur",
        STATE_TN_CITY_4139: "Vettavalam",
        STATE_KL_CITY_4140: "Vettur",
        STATE_MP_CITY_4141: "Vidisha",
        STATE_GJ_CITY_4142: "Vijapur",
        STATE_TN_CITY_4143: "Vijayapuri",
        STATE_AP_CITY_4144: "Vijayawada",
        STATE_MH_CITY_4145: "Vijaydurg",
        STATE_TG_CITY_4146: "Vikarabad",
        STATE_UT_CITY_4147: "Vikasnagar",
        STATE_MH_CITY_4148: "Vikhroli",
        STATE_TN_CITY_4149: "Vikravandi",
        STATE_TN_CITY_4150: "Vilattikulam",
        STATE_MH_CITY_4151: "Vile Parle",
        STATE_TN_CITY_4152: "Villupuram",
        STATE_GJ_CITY_4153: "Vinchhiya",
        STATE_GJ_CITY_4154: "Vinchia",
        STATE_MH_CITY_4155: "Vinchur",
        STATE_UP_CITY_4156: "Vindhyachal",
        STATE_AP_CITY_4157: "Vinukonda",
        STATE_TN_CITY_4158: "Viraganur",
        STATE_GJ_CITY_4159: "Viramgam",
        STATE_MH_CITY_4160: "Virar",
        STATE_KA_CITY_4161: "Virarajendrapet",
        STATE_GJ_CITY_4162: "Virpur",
        STATE_TN_CITY_4163: "Virudhunagar",
        STATE_AP_CITY_4164: "Visakhapatnam",
        STATE_GJ_CITY_4165: "Visavadar",
        STATE_GJ_CITY_4166: "Visnagar",
        STATE_MH_CITY_4167: "Vita, Maharashtra",
        STATE_MH_CITY_4168: "Vite",
        STATE_AP_CITY_4169: "Vizianagaram",
        STATE_AP_CITY_4170: "Vizianagaram District",
        STATE_TN_CITY_4171: "Vriddhachalam",
        STATE_UP_CITY_4172: "Vrindavan",
        STATE_AP_CITY_4173: "Vuyyuru",
        STATE_GJ_CITY_4174: "Vyara",
        STATE_MH_CITY_4175: "Wadala",
        STATE_MH_CITY_4176: "Wadgaon",
        STATE_GJ_CITY_4177: "Wadhai",
        STATE_GJ_CITY_4178: "Wadhwan",
        STATE_KA_CITY_4179: "Wadi",
        STATE_MH_CITY_4180: "Wadner",
        STATE_MH_CITY_4181: "Wadwani",
        STATE_GJ_CITY_4182: "Waghai",
        STATE_MH_CITY_4183: "Wagholi",
        STATE_MH_CITY_4184: "Wai",
        STATE_MH_CITY_4185: "Wakad",
        STATE_TN_CITY_4186: "Walajapet",
        STATE_MH_CITY_4187: "Walgaon",
        STATE_MH_CITY_4188: "Walki",
        STATE_TN_CITY_4189: "Wallajahbad",
        STATE_UP_CITY_4190: "Walterganj",
        STATE_MN_CITY_4191: "Wangjing",
        STATE_MH_CITY_4192: "Wani",
        STATE_GJ_CITY_4193: "Wankaner",
        STATE_TG_CITY_4194: "Wanparti",
        STATE_TG_CITY_4195: "Warangal",
        STATE_MP_CITY_4196: "Waraseoni",
        STATE_MH_CITY_4197: "Wardha",
        STATE_BR_CITY_4198: "Waris Aliganj",
        STATE_MH_CITY_4199: "Warora",
        STATE_MH_CITY_4200: "Warud",
        STATE_MH_CITY_4201: "Washim",
        STATE_KL_CITY_4202: "Wayanad",
        STATE_UP_CITY_4203: "Wazirganj",
        STATE_TN_CITY_4204: "Wellington",
        STATE_RJ_CITY_4205: "Wer",
        STATE_DL_CITY_4206: "West Delhi",
        STATE_SK_CITY_4207: "West District",
        STATE_ML_CITY_4208: "West Garo Hills",
        STATE_AP_CITY_4209: "West Godavari",
        STATE_ML_CITY_4210: "West Jaintia Hills",
        STATE_AR_CITY_4211: "West Kameng",
        STATE_ML_CITY_4212: "West Khasi Hills",
        STATE_AR_CITY_4213: "West Siang",
        STATE_TR_CITY_4214: "West Tripura",
        STATE_NL_CITY_4215: "Wokha",
        STATE_MH_CITY_4216: "Worli",
        STATE_KA_CITY_4217: "Yadgir",
        STATE_MN_CITY_4218: "Yairipok",
        STATE_HR_CITY_4219: "Yamunanagar",
        STATE_AP_CITY_4220: "Yanam",
        STATE_PY_CITY_4221: "Yanam",
        STATE_AP_CITY_4222: "Yanamalakuduru",
        STATE_AP_CITY_4223: "Yarada",
        STATE_MH_CITY_4224: "Yaval",
        STATE_MH_CITY_4225: "Yavatmal",
        STATE_KA_CITY_4226: "Yelahanka",
        STATE_KA_CITY_4227: "Yelandur",
        STATE_KA_CITY_4228: "Yelbarga",
        STATE_TG_CITY_4229: "Yellandu",
        STATE_KA_CITY_4230: "Yellapur",
        STATE_MH_CITY_4231: "Yeola",
        STATE_HP_CITY_4232: "Yol",
        STATE_UP_CITY_4233: "Yusufpur",
        STATE_UP_CITY_4234: "Zafarabad",
        STATE_TG_CITY_4235: "Zahirabad",
        STATE_UP_CITY_4236: "Zaidpur",
        STATE_UP_CITY_4237: "Zamania",
        STATE_PB_CITY_4238: "Zira",
        STATE_AR_CITY_4239: "Ziro",
        STATE_NL_CITY_4240: "Zunheboto",





        STATE_AN: "Andaman and Nicobar Islands",
        STATE_AP: "Andhra Pradesh",
        STATE_AR: "Arunachal Pradesh",
        STATE_AS: "Assam",
        STATE_BR: "Bihar",
        STATE_CH: "Chandigarh",
        STATE_CT: "Chhattisgarh",
        STATE_DH: "Dadra and Nagar Haveli and Daman and Diu",
        STATE_DL: "Delhi",
        STATE_GA: "Goa",
        STATE_GJ: "Gujarat",
        STATE_HR: "Haryana",
        STATE_HP: "Himachal Pradesh",
        STATE_JK: "Jammu and Kashmir",
        STATE_JH: "Jharkhand",
        STATE_KA: "Karnataka",
        STATE_KL: "Kerala",
        STATE_LA: "Ladakh",
        STATE_LD: "Lakshadweep",
        STATE_MP: "Madhya Pradesh",
        STATE_MH: "Maharashtra",
        STATE_MN: "Manipur",
        STATE_ML: "Meghalaya",
        STATE_MZ: "Mizoram",
        STATE_NL: "Nagaland",
        STATE_OR: "Odisha",
        STATE_PY: "Puducherry",
        STATE_PB: "Punjab",
        STATE_RJ: "Rajasthan",
        STATE_SK: "Sikkim",
        STATE_TN: "Tamil Nadu",
        STATE_TG: "Telangana",
        STATE_TR: "Tripura",
        STATE_UP: "Uttar Pradesh",
        STATE_UT: "Uttarakhand",
        STATE_WB: "West Bengal",
        SERVICE_MODULAR_KITCHEN: "Modular Kitchen",
        SERVICE_STORAGE_WORDROBE: "Storage and Wardrobe",
        SERVICE_CROCKERY_UNIT: "Crockery unit",
        SERVICE_SPACE_SAVING: "Space saving furniture",
        SERVICE_ELECRICAL_CHANGE: "Electrical change",
        SERVICE_POP: "POP (Plaster of Paris)",
        SERVICE_TV_UNIT: "TV Units",
        SERVICE_STUDY_TABLE: "Study Table",
        SERVICE_FALSE_CEILING: "False Ceiling",
        SERVICE_LIGHTS: "Lights",
        SERVICE_WALLPAPER: "Wallpaper",
        SERVICE_PAINTING: "Painting",
        SERVICE_BATHROOM_DESIGN: "Bathroom Design",
        SERVICE_FURNITURE_DESIGN: "Furniture Design",
        SERVICE_POOJA_UNIT: "Pooja Unit",
        SERVICE_BEDROOM_DECORATION: "Bedroom Decoration",
        SERVICE_STORE_SHOP: "Stores and Shops",
        SERVICE_KIDS_SPACE: "Kids Space",
        SERVICE_DINING_SPACE: "Dining Space",
        SERVICE_APPLIANCE_SELECTION: "Appliance Selection",
        SERVICE_CABINATE_HARDWARE_DESIGN: "Cabinetry & Hardware design",
        SERVICE_CLOSET_DESIGN: "Closet design",
        SERVICE_COMMERCIAL_INTERIOR: "Commercial interior design and decoration",
        SERVICE_CUSTOM_ART: "Custom art selection",
        SERVICE_DINING_ROOM: "Dining room design",
        SERVICE_DOOR_DESIGN: "Door Design",
        SERVICE_FLOORING_SELECTION: "Flooring Selection",
        SERVICE_HOME_STAGING: "Home staging",
        SERVICE_LIVING_ROOM_DESIGN: "Living room design & decoration",
        SERVICE_INTERIOR_ARCHITECTURE_DESIGN: "Interior architectural design",
        SERVICE_REFURBISHMENT: "Refurbishment",
        SERVICE_RESTAURANT_DESIGN: "Restaurant design & decoration",
        SERVICE_ROOM_PLANNING: "Room planning",
        SERVICE_OFFICE_DESIGN: "Office design & decoration",
        SERVICE_CUPBOARD_DESIGN: "Cupboard design",
        SERVICE_CRAFT_INTERIORS: "Craft Interiors",
        ABOUT_US_MAIN_TITLE: "WE MAKE ARTISTIC INTERIOR",
        ABOUT_US_DESCRIPTION: "SBVishwakarma - Interior Solutions brings {{key1}}+ years of interior design experience right to your home or office. Our design professionals are equipped to help you determine the products and designs that work best for our customers within the colors and lighting of your surroundings more than your expectation.",
        SLEEK_ARCHITECTURE_TITLE: "SLEEK ARCHITECTURE",
        ABOUT_US_SECOND_PARA: "We offer our customers house and office furniture, along with solutions for laboratories, hospitals and healthcare establishments, education and training institutes, shipyards and navy, auditoriums and stadiums. Whether you are looking for a specific style, such as traditional, modern, contemporary, or eclectic, or you have a brand in mind, we can help you make the right choices. Our interior design services include everything from helping you choose the right colours and finishes to selecting furniture, flooring, cabinets, and lighting that will create the best overall look and feel for your home. We will work with you to create an environment that exceeds your expectations and fits your unique style.",
        COMMON_CONTENT_AMPERSAND: "&",
        COMMON_CONTENT_ALONG_WITH: "Along with",
        COMMON_CONTENT_BEST_PRICE: "Best Price",
        COMMON_CONTENT_SUPER_QUALITY: "Superior Quality",
        COMMON_CONTENT_SAFETY_ASSURANCE: "Safety Assured",
        COMMON_CONTENT_PHONE: "Phone",
        COMMON_CONTENT_LOCATION: "Location",
        COMMON_CONTENT_EMAIL: "Email",
        COMMON_CONTENT_STATE: "State",
        COMMON_CONTENT_CITY: "City",
        COMMON_CONTENT_PIN_CODE: "Pincode",
        COMMON_CONTENT_SUBMIT: "Submit",
        COMMON_CONTENT_USEFUL_LINK: "Useful Links",
        COMMON_BUTTON_SUBSCRIBE: "Subscribe",
        COMMON_BUTTON_SUBSCRIBING: "Subscribing",
        COMMON_BUTTON_CONTACT_US: "Contact US",
        COMMON_BUTTON_SEND_MESSAGE: "Send Message",
        COMMON_BUTTON_SUBMIT: "Submit",
        COMMMON_BUTTON_VIEW_ALL: "View All",
        COMMON_CONTENT_COMPANY_NAME: "SBVishwakarma",
        COMMON_CONTENT_ALL_RIGHTS_RESERVED: "All rights reserved.",
        COMMON_CONTENT_COPYRIGHT: "Copyright",
        COMMON_PLACEHOLDER_NAME: "Enter your name",
        COMMON_PLACEHOLDER_EMAIL: "Enter your email",
        COMMON_PLACEHOLDER_SUBJECT: "Enter subject",
        COMMON_PLACEHOLDER_MESSAGE: "Enter your message",
        COMMON_PLACEHOLDER_PHONE: "Enter phone number",
        COMMON_PLACEHOLDER_PINCODE: "Enter your pincode",
        COMMON_PLACEHOLDER_FAQ: "Enter keyword to search........",
        COMMON_PLACEHOLDER_SELECT: "Select.",
        COMMON_PLACEHOLDER_FAQ_NOTFOUND: "No match found.......",
        COMMON_LABEL_DESIGNED_BY: "Designed by Anuj Vishwakarma.",
        CONTACT_ADDRESS: "Sakinaka Andheri East, Mumbai",
        NEWLETTER_TITLE: "Join Our Newsletter",
        NEWLETTER_DESC: "Provide you email to receive latest updates and offers from us.",
        USER_WHATSAPP_CONFIRMATION: "You can reach me on whatsapp !",
        COMMON_CONTENT_OUR_TEAM: "Our Team",
        TEAM_TITLE: "A small glymps of our beloving team",
        BOOK_FREE_SESSION: "Book a free session....",
        COMMON_CONTENT_SERVICES: "Services",
        COMMON_CONTENT_FEATURES: "Features",
        COMMON_CONTENT_FEATURED_PROJECTS: "Featured Projects",
        FEATURED_PROJECTS_DESC: "Here are some of the featured projects.......",
        COMMON_CONTENT_GALLERY: "Gallery",
        GALLERY_DESC: "Check out our latest gallery images",
        FEATURES_DESC: "With our experience and expertise we provide some of the below valuable service to our trusted customers.",
        COMMON_CONTENT_ABOUT_US: "About us",
        COMMON_CONTENT_FAQ: "Faq",
        COMMON_CONTENT_HOME: "Home",
        COMMON_CONTENT_PORTFOLIO: "Portfolio",
        COMMON_CONTENT_CONTACT: "Contact",
        COMMON_CONTENT_BLOG: "Blog",
        COMMON_CONTENT_WHY_US: "Why us",
        COMMON_CONTENT_DECORATOR: "DECORATOR",
        CONTENT_DECORATOR: "DECORATOR",
        COMMON_CONTENT_FULL_NAME: "Full name",
        WHY_US_TITLE: "Why Us ?",
        WHY_US_DESC: "Confused about choosing us for your dream home, then check out these.....",
        WHY_US_PARAGRAPH: "Our interior design services include everything from helping you choose the right colours and finishes to selecting furniture, flooring, cabinets, and lighting that will create the best overall look and feel for your home. We will work with you to create an environment that exceeds your expectations and fits your unique style.",
        WHY_US_ITEM_ONE: "Experience",
        WHY_US_ITEM_ONE_DESC: "{{key1}}+ years of experience.",
        WHY_US_ITEM_TWO: "Trust",
        WHY_US_ITEM_TWO_DESC: "{{key1}}+ Happy customers",
        WHY_US_ITEM_THREE: "Quality",
        WHY_US_ITEM_THREE_DESC: "superior quality materials with sleek designs",
        WHY_US_ITEM_FOUR: "Warranty",
        WHY_US_ITEM_FOUR_DESC: "upto {{key1}} year of material warranty",
        ABOUT_US_PARAGRAPH_ONE: "At SBVishwakarma Interior Design & Decorating, we offer {{key1}}+ years of interior design knowledge to help you select the products and styles that best suit your needs within the colours and lighting of your surrounding environment.",
        ABOUT_US_PARAGRAPH_TWO: "We offer a wide variety of stylish and practical products that are tailored to suit any budget or design needs. Whether you are looking for a new kitchen or bathroom, or considering a fresh update to your living room or dining room, we provide a one-stop shop for everything you need.",
        ABOUT_US_PARAGRAPH_THREE: "From furniture to lighting, wall art to rugs, we offer a variety of products to suit any decorating style. With our vast selection of products, you are sure to find something that fits your style. At the same time, we offer a variety of expert advice to help you make the best decision for your interior design needs.",
        ABOUT_US_PARAGRAPH_FOUR: "Designing high quality products that are not only attractive to the senses, but also economical. Our expert designing and manufacturing teams help to achieve our mission.",
        ABOUT_US_PARAGRAPH_FIVE: "Our interior design specialists are here to help you find the right products and designs for your home or office. In addition to our extensive design experience, we can assist you in choosing the colours and lighting to enhance your surroundings.",
        ABOUT_US_PARAGRAPH_SIX: "we are passionate about design and exceeding our customers expectations! We felt the best way to do that was to not only focus on the design but also the furniture.",
        ABOUT_US_GOAL: "Our goal is to always make your design dreams achievable and to do it in a way that is fun and interactive for you!",
        ABOUT_US_MISSION: "Our mission is to help people visualize, create & maintain beautiful homes. We bring to you inspiring visuals of cool homes, specific spaces, architectural marvels and new design trends.",
        ABOUT_US_PARAGRAPH_SEVEN: "Our interior design services include everything from helping you choose the right colours and finishes to selecting furniture, flooring, cabinets, and lighting that will create the best overall look and feel for your home. We will work with you to create an environment that exceeds your expectations and fits your unique style.",
        TEAM_ROLE_TWO: "DECORATOR",
        SANDEEP_VISHWAKARMA: "Sandeep Vishwakarma",
        JITENDRA_VISHWAKARMA: "Jitendra Vishwakarma",
        SANDEEP_VISHWAKARMA_QUOTE: "We shape our homes and then our homes shape us.",
        JITENDRA_VISHWAKARMA_QUOTE: "Being identifiably ‘something’ will help you stand out from the crowd.",
        SECTION_CONTENT_TITLE: "SBVishwakarma",
        SECTION_TITLE_HEADER: "At SBVishwakarma Interior Design & Decorating, we offer {{key1}}+ years of interior design knowledge to help you select the products and styles that best suit your needs within the colours and lighting of your surrounding environment.",
        SECTION_PARAGRAPH_ONE: "We offer a wide variety of stylish and practical products that are tailored to suit any budget or design needs. Whether you are looking for a new kitchen or bathroom, or considering a fresh update to your living room or dining room, we provide a one-stop shop for everything you need.",
        SECTION_PARAGRAPH_TWO: "From furniture to lighting, wall art to rugs, we offer a variety of products to suit any decorating style. With our vast selection of products, you are sure to find something that fits your style. At the same time, we offer a variety of expert advice to help you make the best decision for your interior design needs.",
        SECTION_PARAGRAPH_THREE: "Designing high quality products that are not only attractive to the senses, but also economical. Our expert designing and manufacturing teams help to achieve our mission.",
        SECTION_PARAGRAPH_FOUR: "Our interior design specialists are here to help you find the right products and designs for your home or office. In addition to our extensive design experience, we can assist you in choosing the colours and lighting to enhance your surroundings.",
        SECTION_PARAGRAPH_FIVE: "we are passionate about design and exceeding our customers expectations! We felt the best way to do that was to not only focus on the design but also the furniture.",
        SECTION_PARAGRAPH_SIX: "Our interior design services include everything from helping you choose the right colours and finishes to selecting furniture, flooring, cabinets, and lighting that will create the best overall look and feel for your home. We will work with you to create an environment that exceeds your expectations and fits your unique style.",
        SECTION_PARAGRAPH_LIST_ITEM_ONE: "Best Price",
        SECTION_PARAGRAPH_LIST_ITEM_TWO: "Superior Quality",
        SECTION_PARAGRAPH_LIST_ITEM_THREE: "Safety Assured",
        GOAL: "Our goal is to always make your design dreams achievable and to do it in a way that is fun and interactive for you!",
        MISSION: "Our mission is to help people visualize, create & maintain beautiful homes. We bring to you inspiring visuals of cool homes, specific spaces, architectural marvels and new design trends.",
        FEATURE_ITEM_ONE: "Interior Design & Decorating",
        FEATURE_ITEM_TWO: "Architecture Design",
        FEATURE_ITEM_THREE: "Landscape Planning",
        FEATURE_ITEM_FOUR: "Trunkey Project",
        FEATURE_ITEM_FIVE: "Money Saving",
        FEATURE_ITEM_SIX: "Project Management",
        FEATURE_ITEM_ONE_DESC: "Get completely personalised furniture to complement the aesthetic of your space.",
        FEATURE_ITEM_TWO_DESC: "Expect a Sleek-made design that blends function with elegance.",
        FEATURE_ITEM_THREE_DESC: "From the right furnishings and fabrics in diverse colours to a variety of house interior décor items.",
        FEATURE_ITEM_FOUR_DESC: "Choose from a wide-range of light— elaborate chandeliers, beautiful floor lamps.",
        FEATURE_ITEM_FIVE_DESC: "Find the right size, the perfect shape and a chic design for a signature wardrobe.",
        FEATURE_ITEM_SIX_DESC: "Get Signature Walls that express your true personality style. From interesting shades.",
        PARAGRAPH: "Our interior design services include everything from helping you choose the right colours and finishes to selecting furniture, flooring, cabinets, and lighting that will create the best overall look and feel for your home. We will work with you to create an environment that exceeds your expectations and fits your unique style.",
        ITEM_ONE: "Experience",
        ITEM_TWO: "Trust",
        ITEM_THREE: "Quality",
        ITEM_THREE_DESC: "superior quality materials with sleek designs",
        ITEM_FOUR: "Warranty",
        ITEM_FOUR_DESC: "upto {{key1}} year of material warranty",
        HWW_TITLE: "HOW WE WORK",
        HWW_DESC: "From the first call to the final handover—we take care of all your home design requirements",
        HWW_STEP_ONE_TITLE: "Meet Designer",
        HWW_STEP_ONE_DESC: "Our design specialists are able to determine the materials and styles that work best for our clients in conjunction with the colours and lighting of your setting in excess of your expectations. They will understand your requirement and bring your dream home to life.",
        HWW_STEP_TWO_TITLE: "Choose your favorite materials",
        HWW_STEP_TWO_DESC: "From choosing paint colour to selecting furniture, we work with you to create a space that reflects your personality, functions for your lifestyle, and looks great.",
        HWW_STEP_THREE_TITLE: "Confirm the project timeline",
        HWW_STEP_THREE_DESC: "Make an Initial payment to book the project and our team will work out the project duration with you keeping in mind various activities planned.",
        HWW_STEP_FOUR_TITLE: "Site Handover",
        HWW_STEP_FOUR_DESC: "We complete the work in less than or the given time interval and Your dream home is ready and you can now move into your redesigned home",
        HAPPY_CUSTOMERS_TEXT: "Happy Customers",
        YOE_TEXT: "years of experience",
        PROJECTS_TEXT: "Projects",
        HARD_WORKING_EMPLOYEE_TEXT: "Hard Working Employees",
        HERO_ITEM_ONE: "Interior Design & Decorating",
        HERO_ITEM_TWO: "Bedroom Design & Decorating",
        HERO_ITEM_THREE: "Smart & Superior furniture with best quality materials",
        CTA_TITLE: "Call to Action",
        CTA_DESC: "Still confused what to choose? Give us a call and we will help you out.",
        PORTFOLIO_TV_UNIT: "TV Unit",
        PORTFOLIO_BEDROOM: "Bedroom",
        PORTFOLIO_BATHROOM: "Bathroom",
        PORTFOLIO_FURNITURE: "Furniture",
        PORTFOLIO_KITCHEN: "Kitchen",
        PORTFOLIO_LIVING_SPACE: "Living Space",
        COMMON_CONTENT_OTHERS: "Others",
        COMMON_CONTENT_ALL: "ALL",
        FAQ_QUE_1: "What is SBVishwakarma?",
        FAQ_ANS_1: "SBVishwakarma is an end-to-end, completely personalized service that helps you design and execute the interiors for your dream home.",
        FAQ_QUE_2: "Can I avail of the service if I want some very simple and minimal design work done for my house?",
        FAQ_ANS_2: "Absolutely. SBVishwakarma offers personalized solutions for your interior design needs. Our designers talk to you in detail to understand your vision and help you design a space that is in sync with your tastes and preferences. This service is definitely an option for you to consider.",
        FAQ_QUE_3: "Do I have to get the entire house designed if I book this service?",
        FAQ_ANS_3: "Not at all. This service works for you even if your renovation is limited to a specific room or area of the house. ",
        FAQ_QUE_4: "Who will supervise the work when I'm out of the house at work?",
        FAQ_ANS_4: "Our customer experience specialist (CES) would be your single point of contact for all queries and concerns that you may have. He will be the one to lead the entire project and keep you informed about the progress.",
        FAQ_QUE_5: "Will I need to visit the site regularly?",
        FAQ_ANS_5: "No. Our customer experience specialist (CES) is the custodian of your site and he will visit the site and also ensure that you get regular updates about how the work is progressing. The CES is your go-to person in case of any concerns or queries. ",
        FAQ_QUE_6: "How will my site be measured?",
        FAQ_ANS_6: "The space that you want to renovate or build is called the site. To know the dimensions and measurements of the entire area, you can share the floor plan of your place with us. In case the floor plan is not available, we will send our representative to take the measurements that are necessary to start with the designing phase.",
        FAQ_QUE_7: "What will be the timeline for my project completion?",
        FAQ_ANS_7: "Being one of the top interior design firms, SBVishwakarma offer its clients a move-in guarantee that assures you that all the modular solutions will be installed within a period of 45 days. To complete your full home interiors, we take around 90 days to complete your interior design project. However, the completion timeline may vary from project-to-project. Factors such as material availability, delivery, customer feedback, design approvals, etc., play an important role in determining the timeline. Please note that conditions may apply to the guarantee and the stipulated design timeframe.",
        FAQ_QUE_8: "Am I allowed to customize the design for my house according to my taste?",
        FAQ_ANS_8: "Absolutely. We pride ourselves on providing you best-in-class personalized designs to fit your needs. You can consult and collaborate with our customer experience specialist (CES) and interior designer to finalise the design that works for you. ",
        FAQ_QUE_9: "Can I opt for different themes for different rooms in my house?",
        FAQ_ANS_9: "Definitely! You will be involved in every design decision that is taken. The customer experience specialist (CES) and interior designer will consider and incorporate your opinion and solicit your approval at all stages in the designing phase.  The final design will be based on your tastes and on popular trends. ",
        FAQ_QUE_10: "When can I meet the interior designer to communicate my requirements?",
        FAQ_ANS_10: "Our customer experience specialist (CES) will be the person to contact you first, to understand your needs and get the house plan. He will explain the process to you in detail and understand your needs and your style. He will also clarify any doubts and concerns.  In the second meeting, you will get to speak to both the CES and our interior designer, who will show you the proposed design.  You will also get to see the design over our state-of-the-art 3D visualiser where you can make changes and see them in real time.",
        FAQ_QUE_11: "Can I get my furniture custom-made via this service?",
        FAQ_ANS_11: "Yes, you can. You can work together with our customer experience specialist (CES) and interior designer to create the furniture that fit your needs.",
        FAQ_QUE_12: "How can I visualize the proposed design for my house?",
        FAQ_ANS_12: "After a detailed design discussion with our interior designer and CES, they share the proposed designs of your house with the use of our state-of-the-art 3D visualizer. Once you've seen what the interior design of your house would look like, you can get into further discussion of any changes that you want made—and see them happening in real time. Along with the design output in the 3D visualiser, you also get to look at it in 2D. Any subsequent changes that you need to make will be made to fit into your taste and liking. ",
        FAQ_QUE_13: "What services do you offer and why should I choose them?",
        FAQ_ANS_13: "Our services include end-to-end designing and execution of the interior design of your house, which includes furniture, furnishings, decorative lighting, décor accessories, modular kitchen designs, painting and civil work.  Experts from their respective fields employ precision and a fine sense of design to execute your vision. This ensures that your house design is entirely personalised. Apart from that, you are completely involved in the design process; you also get to witness the transformation and changes you desire with our exclusive 3D visualiser, to enable you to envision your dream home and make changes in real time. You can also be assured of expert project management and a completely professional experience while we create your beautiful home.",
        FAQ_QUE_14: "In which cities is this service operational?",
        FAQ_ANS_14: "As of now, we provide interior design services in eight cities—our stores are in Delhi, Mumbai, Pune, Bengaluru and Hyderabad. Please fill out contact form to know if we are operational in your area.",
        FAQ_QUE_15: "Who will be my contact person for the entire duration of the project?",
        FAQ_ANS_15: "The customer experience specialist (CES) will be your contact person from the beginning till the end of the interior design project. He will address and assuage any queries or concerns that you have during this time.",
        FAQ_QUE_16: "Why do I need an interior designer?",
        FAQ_ANS_16: "When it comes to interior design for home and interior decoration, what we visualize is generally not what we end up getting. This is where employing the skills of an interior designer can make the difference in a functional interior and a great-looking home that is practical as well. An interior designer is the perfect solution when you want comprehensive design solutions, whether it is the technical aspects to the aesthetic interior decoration as well. They can correctly translate the vision you have for your space and enhance it to give you a house that's well-designed and comfortable. There are several advantages to seeking out the expertise of an interior designer—the most prominent one being the skills and knowledge that they come equipped with. They have solid know-how regarding all aspects of design, are well-versed with the requirements of what the job entails and can advise you on the feasibility of the interior design for home that you have in mind. Deciding on colour, material and space configuration are the fundamental facets of home design, and when it comes to drawing out a comprehensive and clear plan, an interior designer is your go-to source. They will know exactly what colour schemes and materials to use to ensure your interiors look unique and distinct. They have the knowledge, the eye and the skill set to help you make the best choices for your space. Another important factor that must be considered is that interior designers are updated on the latest and most popular trends when it comes to interior decoration. What's more, they will also tell you whether a particular trend would work well within your home, what you should adopt and what you should discard. Their knowledge about the market also come into play when it comes to looking into the different aspects of interior decoration. They will steer you in the right direction when it comes to choosing good-quality furniture, furnishings, accessories and other décor-related elements for your home. A good interior designer can also recommend and help you source artworks if you are inclined to have any in your home interior design. Another advantage of hiring interior design services today is in ensuring your home is energy efficient. While you may have your heart in the right place, it's the interior designer who can translate good intentions into proactive action and optimize energy usage With an interior designer by your side, you have someone reliable and trustworthy to work on your home design, a single source to tackle all the different elements and people that come into play and help take the load—and the stress—off.",
        FAQ_QUE_17: "How do I share my ideas for a room with the professional?",
        FAQ_ANS_17: "As a homeowner keen on designing or renovating your house interior design, your first step is to browse through all available resources. Along with an overarching home design, though, the individual rooms, too, pose a challenge in themselves. It is likely—and a good idea—that before an interior design professional even comes into the picture, only you can know what you like and what you would like to see in your room interior design. In order to ensure that your room interior design aspirations are conveyed to the professional you hire, you should first figure out your tastes. Room interior designs need to be carefully considered to ensure that the room is distinct but also fits well into the overall home design scheme. The best way to do so is a quick round of research; you get an idea about what you like, what's trending, what's not and what would be most the suitable interior design that would perfectly reflect your personal preferences. And you don't have to look too far to narrow down your choices; the SBVishwakarma Interior Design Services website itself has a plethora of images of homes and spaces in a diversity of styles that will help you discover the room interior design that is in keeping with your sensibilities. When browsing through images, keep in mind that you look carefully at all the elements that go into designing a space: this includes the space itself—the size of each of the rooms, the layout and the overall aesthetic that you would like to opt for. Then come the other important elements such as the colours that you would like to use and the materials that appeal to you. But remember to ensure that your style requirements are balanced by practical considerations. It is important that the room interior design isn't just great-looking but functional as well. Keep all these points in mind when you browse through our pages to find what works best for you. When you have made a selection of visuals, the best thing to do is arrange them properly in a collage of ideas and suggestions—a mood board of sorts that can give you a sense of what's working and what isn't. So once you meet with our customer experience specialist (CES) and interior designer to finalize a room interior design, they get a visual reference of your preferences. The final design will be based on your tastes and popular trends while our professionals will ensure it fits into the larger home design as well. And rest assured that all your queries and doubts will be addressed by our CES, who will ensure he understands your needs and plan for the home design.",
        FAQ_QUE_18: "Why SBVishwakarma is perfect for your home interior design?",
        FAQ_ANS_18: "Doing up or renovating your home interior design is not a decision that is taken lightly. It involves a lot of careful thought and research. Above all, it also means finding a trustworthy professional who innately understands your tastes, the work involved in doing up house interiors and has the required skills to execute your vision. At SBVishwakarma Interior Design Service, our network of customer experience specialists (CES) and interior designers are well-equipped to realize that perfect home interior design for you. We have put together a well-planned process to ensure that your home interior design experience is a smooth one. We will be with you from the conceptualisation and ideating to the planning and execution, right up to the handover. With over 60 interior designers making up our panel of experts, you can be assured that the designing of your house interiors is in secure and skilled hands, and the final result would be one that's best suited for your family's comfort.  Our CES is the first person to contact you and gain an insight into your home interior design requirements. He, in turn, will detail out the process that we follow at SBVishwakarma and allay any concerns and doubts that you may have. A follow-up meeting is where you meet the interior designer assigned to seeing through the design for your house interiors. He is also the one to show you the proposed design, which you also get to visualize on a state-of-the-art 3D visualizer; this enables you to make changes and see them in real time. Our services run the gamut of house interiors requirements, including end-to-end designing and execution of your home interior design. This includes furniture and furnishings, decorative lighting and décor accessories to modular kitchen designs, painting and civil work. At SBVishwakarma, we make sure that you stay closely involved throughout the design process and witness the transformation of your house. Our CES is onsite during the execution of the home interior design, ensuring that any glitches and issues are ably, immediately and efficiently handled. As your single point of contact, our CES will keep you regularly updated on the progress. The design of your house interiors is as important to us as it is to you, but what is also equally significant is ensuring your comfort through the process and giving you the home interior design that's completely you. The hundreds of satisfied customers across 9 cities are testament to the fact that we take the responsibility of designing your dream home very seriously.",
        PORTFOLIO_TV_TAG: "TV Unit",
        PORTFOLIO_BEDROOM_TAG: "Bedroom",
        PORTFOLIO_BATHROOM_TAG: "Bathroom",
        PORTFOLIO_FURNITURE_TAG: "Furniture",
        PORTFOLIO_KITCHEN_TAG: "Kitchen",
        PORTFOLIO_LIVING_SPACE_TAG: "Living Space",
        PORTFOLIO_OTHERS_TAG: "Others",
        PORTFOLIO_ALL_TAG: "ALL",
        PORTFOLIO_ITEM_TITLE_1: "TV Unit",
        PORTFOLIO_ITEM_DESC_1: "TV Unit decoration with wooden finishing.",
        PORTFOLIO_ITEM_TITLE_2: "Living Space",
        PORTFOLIO_ITEM_DESC_2: "Complete interior decoration for living space",
        PORTFOLIO_ITEM_TITLE_3: "Living space",
        PORTFOLIO_ITEM_DESC_3: "Living space interior decoration",
        PORTFOLIO_ITEM_TITLE_4: "Kitchen Decoration",
        PORTFOLIO_ITEM_DESC_4: "Kitchen decoration with glossy finish",
        PORTFOLIO_ITEM_TITLE_5: "Living Space",
        PORTFOLIO_ITEM_DESC_5: "Living space decoration",
        PORTFOLIO_ITEM_TITLE_6: "Living Space",
        PORTFOLIO_ITEM_DESC_6: "Living space decoration",
        PORTFOLIO_ITEM_TITLE_7: "Ceiling Decoration",
        PORTFOLIO_ITEM_DESC_7: "False Ceiling decoration",
        PORTFOLIO_ITEM_TITLE_8: "Bedroom",
        PORTFOLIO_ITEM_DESC_8: "Sleek bedroom decoration with veneer matt finish.",
        PORTFOLIO_ITEM_TITLE_9: "Bathroom",
        PORTFOLIO_ITEM_DESC_9: "Stylish bathroom decoration",
        PORTFOLIO_ITEM_TITLE_10: "Modular Kitchen",
        PORTFOLIO_ITEM_DESC_10: "Modular kitchen design and Decoration with space saving features",
        PORTFOLIO_ITEM_TITLE_11: "Modular Kitchen",
        PORTFOLIO_ITEM_DESC_11: "Modular kitchen design and Decoration with space saving features",
        PORTFOLIO_ITEM_TITLE_12: "Table",
        PORTFOLIO_ITEM_DESC_12: "Table with high glossy glass finishing",
        PORTFOLIO_ITEM_TITLE_13: "Bedroom Decoration",
        PORTFOLIO_ITEM_DESC_13: "Classic bedroom decoration with high glossy finishing",
        PORTFOLIO_ITEM_TITLE_14: "Bedroom Decoration",
        PORTFOLIO_ITEM_DESC_14: "Classic bedroom design with wooden finishing",
        PORTFOLIO_ITEM_TITLE_15: "Bedroom and Wardrobe",
        PORTFOLIO_ITEM_DESC_15: "Sleek bedroom and wardrobe design with with wall lights and glossy finishing",
        PORTFOLIO_ITEM_TITLE_16: "Bedroom & Wardrobe",
        PORTFOLIO_ITEM_DESC_16: "Classic bedroom design",
        PORTFOLIO_ITEM_TITLE_17: "Bedroom",
        PORTFOLIO_ITEM_DESC_17: "Sleek bedroom design and decoration with veneer matt finishing",
        PORTFOLIO_ITEM_TITLE_18: "Bathroom",
        PORTFOLIO_ITEM_DESC_18: "Bathroom design and decoration",
        PORTFOLIO_ITEM_TITLE_19: "Bathroom",
        PORTFOLIO_ITEM_DESC_19: "Bathroom design and decoration",
        PORTFOLIO_ITEM_TITLE_20: "Storage unit",
        PORTFOLIO_ITEM_DESC_20: "Storage unit design",
        PORTFOLIO_ITEM_TITLE_21: "TV Unit",
        PORTFOLIO_ITEM_DESC_21: "Luxury TV Unit with matt finishing",
        PORTFOLIO_ITEM_TITLE_22: "Bathroom",
        PORTFOLIO_ITEM_DESC_22: "Bathroom design",
        PORTFOLIO_ITEM_TITLE_23: "Ceiling",
        PORTFOLIO_ITEM_DESC_23: "False ceiling design",
        PORTFOLIO_ITEM_TITLE_24: "Cabin Design",
        PORTFOLIO_ITEM_DESC_24: "View of complete Cabin design and decoration",
        PORTFOLIO_ITEM_TITLE_25: "Bedroom Decoration",
        PORTFOLIO_ITEM_DESC_25: "Bedroom decoration with high glossy finish",
        PORTFOLIO_ITEM_TITLE_26: "Bedroom",
        PORTFOLIO_ITEM_DESC_26: "Bedroom decoration",
        PORTFOLIO_ITEM_TITLE_27: "Bedroom",
        PORTFOLIO_ITEM_DESC_27: "View of complete design and decoration of bedroom",
        PORTFOLIO_ITEM_TITLE_28: "Living Space",
        PORTFOLIO_ITEM_DESC_28: "Living space design and decoration",
        PORTFOLIO_ITEM_TITLE_29: "TV Unit",
        PORTFOLIO_ITEM_DESC_29: "Royal TV Unit with matt metallic finish",
        PORTFOLIO_ITEM_TITLE_30: "Storage Unit",
        PORTFOLIO_ITEM_DESC_30: "Storage cabinet design",
        PORTFOLIO_ITEM_TITLE_31: "Cabinet Table",
        PORTFOLIO_ITEM_DESC_31: "Office Cabin table with high glossy glass finish",
        PORTFOLIO_ITEM_TITLE_32: "Cabinet Table",
        PORTFOLIO_ITEM_DESC_32: "Office Cabin table with high glossy glass finish",
        PORTFOLIO_ITEM_TITLE_33: "Meeting Table",
        PORTFOLIO_ITEM_DESC_33: "Meeting table with colorful glass finish",
        PORTFOLIO_ITEM_TITLE_34: "Office Decoration",
        PORTFOLIO_ITEM_DESC_34: "Office design and decoration",
        PORTFOLIO_ITEM_TITLE_35: "Commercial Workstation",
        PORTFOLIO_ITEM_DESC_35: "Commercial work station design and decoration",
        PORTFOLIO_ITEM_TITLE_36: "Commercial Workstation",
        PORTFOLIO_ITEM_DESC_36: "Royal TV Unit with matt metallic finish",
        WHY_US_ITEM_1: "Adds functionality to the place",
        WHY_US_ITEM_DATA_1: "Interior design not only beautifies the interior of your building but also makes sure that it adds functionality to your home. Functionality is one of the key aspects of interior design. This is important because a poorly designed large house can be lacking in space or even a tiny apartment can be one of the perfect examples of functionality. This can be achieved with the help of some latest design principles and elements such as a special staircase or a loft. Thus, interior design makes everything work in unison from lighting to furniture to the equipment, making the place feel more appealing and inviting.",
        WHY_US_ITEM_2: "Fits the occupant's lifestyle",
        WHY_US_ITEM_DATA_2: "Whenever a professional designs a home it is done in such a manner that it suits the lifestyle of the occupants. This is a very important component since the architectural component is built according to your lifestyle.  So, it is important to sit with your designer and they help you to optimize and create the perfect design which suits you. For instance, lifestyle adjustments in interior design could include separating your toilet from the rest of the bathroom or reducing the size of your living room so that you can have a home office where you will spend more of your spare time.",
        WHY_US_ITEM_3: "High aesthetic quality",
        WHY_US_ITEM_DATA_3: "Interior designers are like the wizards who wave their magic wand and transform an ordinary-looking place into something which is aesthetically very beautiful and welcoming. They start by suitable design, scheme, colour, paint, ambience, textures, balance and symmetry to provide a stunning appearance.  This unique aesthetic quality will match the purpose of each room or space. Thus, helping you to enhance the appearance of the room. For instance: it helps to make the bedroom feel more relaxed enhancing rest and a night of good sleep, while the home office area will enhance creativity and productivity.",
        WHY_US_ITEM_4: "Cost savings",
        WHY_US_ITEM_DATA_4: "Investing in good interior design adds value in the long run. An interior designer is well aware of the types of fixtures, lighting, drapes, paint, sofa designs, and carpeting that you should put in various parts of a house. Many times homeowners try to save on the cost of hiring a professional interior designer and in the bargain they end up spending more time figuring out what to install and how to install it correctly. Furthermore, a good interior designer will help you to save your costs by helping you choose the best materials, fittings, and furniture that you can afford with your current budget. This will help you to avoid costly renovations and remodelling shortly after you move into your new home.",
        WHY_US_ITEM_5: "For safety purposes",
        WHY_US_ITEM_DATA_5: "Safety is one of the most important things to consider while designing the home. This is important because a lack of necessary safety requirements can cause injuries to children, especially when they are alone and playing around dangerous and fragile equipments in the house. A properly designed house with proper safety measures ensures that all the interior equipment are placed in the required safe place and the dangerous ones placed in those places out of reach of children. Besides, the electric wires in a properly designed house are properly placed and well-insulated thus safe for children and any visitor.",
        WHY_US_ITEM_6: "Good interior design is easy to maintain",
        WHY_US_ITEM_DATA_6: "Just designing a beautiful home is not enough; you also need to adopt the necessary measures to ensure that beauty lasts for a long period. Further, every house requires regular maintenance.  A properly designed interior helps to ensure easy maintenance of the home in the long run. Besides, when the design is good, the damages are very rare as the accidents are not likely to occur which causes damages to the fragile furniture and any other equipment.",
        WHY_US_ITEM_7: "A good design will facilitate ample space",
        WHY_US_ITEM_DATA_7: "When you talk about a well-designed home it calls for better optimization of the space as well facilitating some amount of open space in the house. A properly designed home will make provision for better space especially when it comes to the living room. The corridors will also help to make space feel bigger than it is. This will eliminate the aspect of unnecessary congestion which is common in the poorly designed houses.",
        WHY_US_ITEM_8: "A properly designed home increases resale value",
        WHY_US_ITEM_DATA_8: "In case you want to sell your house, the proper design will help to raise the value of your home. Most of the buyers are looking to buy a well-designed house on which they do not have to spend more time and effort, especially in the case of rentals. If the design is poor, they will pay less for that particular house.",
        WHY_US_ITEM_9: "Good interior design affects the mood of the home and the people",
        WHY_US_ITEM_DATA_9: "This stands very true since you are the one who is choosing the designs according to your preferences. Especially the colour of your home plays a very important part in affecting the mood of the house. If the inner parts of the home are designed with your favourite colour you will enjoy staying in that house. Besides, a proper design of the interior parts will include a natural flow and circulation of fresh air. This will make you feel comfortable while in the house.  There will be a possibility of a bad smell and even suffocation. Therefore, for you to have that beautiful and pleasant feeling in your house, the interior parts should be properly designed.",
        WHY_US_ITEM_10: "Good interior design creates a great first impression",
        WHY_US_ITEM_DATA_10: "Good interior design not only makes you feel happy and content but it is also something which can impress your visitors. Interior design helps to develop your home into what exclusively satisfies your distinctive aesthetic appreciations. Being you is important, and designing your home should be fun. Whether it is your kitchen design, your fireplace surround, or the intimacy of your bathroom creation, your flavour is added to make your home reflect your personal touch.",
        WHY_US_ITEM_11: "Colours serve a myriad of purposes",
        WHY_US_ITEM_DATA_11: "One of the crucial components of interior designing is carefully selecting the colours for the specific rooms. If done right, colours help to enhance the mood of the inhabitants of the home. Furthermore, it also serves as an excellent backdrop for art and drama for any room.",
        WHY_US_ITEM_12: "Enables ageing members to access rooms easily",
        WHY_US_ITEM_DATA_12: "If you have sick, physically challenged or ageing members at home it can either alleviate or aggravate their condition depending upon how you design the home. One of the most basic things to keep in mind is designing the space in such a manner that they can move about easily in the house without requiring any kind of additional help or assistance. In this regard, they would be able to maintain their dignity as they will become less able to care for themselves and their daily needs. Moreover, it would also make them feel like they are making things easier by not being a burden.",
        WHY_US_ITEM_13: "Turns your home into heaven",
        WHY_US_ITEM_DATA_13: "In today's day and age, we all have busy schedules which require us to sit back, unwind and relax at the end of the day.  In this regard, your home works as a heaven of relaxation and comfort where you can just be. Thus, good interior design helps to transform your home into a heavenly abode.",
        WHY_US_ITEM_14: "Functions as a home retreat",
        WHY_US_ITEM_DATA_14: "Your home should not only maximize functionality but should also act as a retreat to sit back and enjoy. Good interior design helps you to have a home through which you will not long for posh and long vacations. In this regard, your home should be something that feels like a retreat from the hustle and bustle of life. Additionally, it should also be an avenue for you and your family to re-engage with each other.",
        WHY_US_ITEM_15: "Combining styles in the right manner",
        WHY_US_ITEM_DATA_15: "A good experiences interior designer helps to combine the various decorating styles like contemporary, modern, classic, indo-western, western and many more in a perfect way to create a fusion that is one-of-a-kind, beautiful and perfectly matches your needs and expectations. So clubbing your most appreciated old interior masterpieces and furniture would no more be a hassle. In fact, they will get the most appropriate space to get focus on.",
        WHY_US_ITEM_16: "The best option for busy persons",
        WHY_US_ITEM_DATA_16: "Hiring a professional interior designer is one of the best options if you are working and have less time to devote to. In this case, an interior designer is a better money-saving, time-saving, and stress buster option.",
        WHY_US_ITEM_17: "Conclusion",
        WHY_US_ITEM_DATA_17: "Your home is your own space. If you want to change your countertops, you can put anything there that is aesthetically pleasing to you. You evaluate your thoughts about color, what space is, how you want to light the area, and all the accessories you want to add right down to things like your stereo or your television. In the end, it's all about your appreciation of beauty and what you want to create in your area that makes you happy."

    },
    MR: {

        STATE_RJ_CITY_0: "अभानेरी",
        STATE_AS_CITY_1: "अभयपुरी",
        STATE_TN_CITY_2: "अभिरामम",
        STATE_PB_CITY_3: "अबोहर",
        STATE_GJ_CITY_4: "अब्रामा",
        STATE_RJ_CITY_5: "अबू",
        STATE_RJ_CITY_6: "अबू रोड",
        STATE_MH_CITY_7: "अचलपूर",
        STATE_UP_CITY_8: "अछनेरा",
        STATE_GJ_CITY_9: "अडालज",
        STATE_PB_CITY_10: "आदमपूर",
        STATE_MH_CITY_11: "अडवद",
        STATE_AP_CITY_12: "अडंकी",
        STATE_TG_CITY_13: "आदिलाबाद",
        STATE_TN_CITY_14: "आदिरामपट्टिनम",
        STATE_AP_CITY_15: "अडोनी",
        STATE_KL_CITY_16: "अदूर",
        STATE_TN_CITY_17: "अदुथुराई",
        STATE_UP_CITY_18: "अफजलगड",
        STATE_KA_CITY_19: "अफजलपूर",
        STATE_MP_CITY_20: "आगर",
        STATE_MH_CITY_21: "आगर पंचाईतन",
        STATE_TR_CITY_22: "आगरतळा",
        STATE_GJ_CITY_23: "आगोल",
        STATE_UP_CITY_24: "आग्रा",
        STATE_MH_CITY_25: "अहेरी",
        STATE_MH_CITY_26: "अहिरी",
        STATE_MH_CITY_27: "अहमदनगर",
        STATE_MH_CITY_28: "अहमदपूर",
        STATE_GJ_CITY_29: "अहमदाबाद",
        STATE_MH_CITY_30: "अहमदनगर",
        STATE_WB_CITY_31: "अहमदपूर",
        STATE_UP_CITY_32: "अहराउरा",
        STATE_GJ_CITY_33: "आहवा",
        STATE_UP_CITY_34: "ऐदलपूर",
        STATE_MH_CITY_35: "ऐरोली",
        STATE_UP_CITY_36: "एअरवा",
        STATE_WB_CITY_37: "ऐस्ताला",
        STATE_MZ_CITY_38: "आयझॉल",
        STATE_MP_CITY_39: "अजयगड",
        STATE_PB_CITY_40: "अजितगड",
        STATE_KA_CITY_41: "अज्जमपूर",
        STATE_RJ_CITY_42: "अजमेर",
        STATE_PB_CITY_43: "अजनाळा",
        STATE_MH_CITY_44: "आजरा",
        STATE_PB_CITY_45: "अकलगड",
        STATE_MH_CITY_46: "अकलकोट",
        STATE_CT_CITY_47: "अकलतारा",
        STATE_AP_CITY_48: "आकासाहेबपेठ",
        STATE_UP_CITY_49: "अकबरपूर",
        STATE_JK_CITY_50: "अखनूर",
        STATE_AP_CITY_51: "अकिविडू",
        STATE_MH_CITY_52: "अक्कलकोट",
        STATE_AP_CITY_53: "अक्करमपल्ले",
        STATE_RJ_CITY_54: "अकलेरा",
        STATE_MH_CITY_55: "अकलूज",
        STATE_WB_CITY_56: "अकनापूर",
        STATE_MP_CITY_57: "अकोडिया",
        STATE_MH_CITY_58: "अकोला",
        STATE_UP_CITY_59: "अकोला",
        STATE_MH_CITY_60: "अकोळनेर",
        STATE_MH_CITY_61: "अकोट",
        STATE_MH_CITY_62: "अक्राणी",
        STATE_GJ_CITY_63: "अक्रंद",
        STATE_TN_CITY_64: "अलगपुरम",
        STATE_MP_CITY_65: "आलमपूर",
        STATE_TG_CITY_66: "आलमपूर",
        STATE_KA_CITY_67: "आलंड",
        STATE_MH_CITY_68: "आळंदी",
        STATE_TN_CITY_69: "अलंदूर",
        STATE_TN_CITY_70: "अलंगनलूर",
        STATE_TN_CITY_71: "अलंगयम",
        STATE_TN_CITY_72: "अलंगुडी",
        STATE_TN_CITY_73: "अलंगुलम",
        STATE_TN_CITY_74: "आलापक्कम",
        STATE_KL_CITY_75: "अलप्पुझा",
        STATE_PB_CITY_76: "अलावलपूर",
        STATE_GA_CITY_77: "अल्डोना",
        STATE_MH_CITY_78: "आले",
        STATE_MH_CITY_79: "अलिबाग",
        STATE_UP_CITY_80: "अलीगंज",
        STATE_UP_CITY_81: "अलीगढ",
        STATE_DL_CITY_82: "अलीपूर",
        STATE_WB_CITY_83: "अलीपुरद्वार",
        STATE_MP_CITY_84: "अलीराजपूर",
        STATE_MH_CITY_85: "अलकुटी",
        STATE_UP_CITY_86: "अलाहाबाद",
        STATE_UP_CITY_87: "अल्लागंज",
        STATE_MH_CITY_88: "अल्लापल्ली",
        STATE_UT_CITY_89: "अल्मोडा",
        STATE_KA_CITY_90: "अलनावर",
        STATE_AR_CITY_91: "सोबत",
        STATE_MP_CITY_92: "खूप",
        STATE_KA_CITY_93: "अलूर",
        STATE_KL_CITY_94: "अलुवा",
        STATE_TN_CITY_95: "अल्वा तिरुनगरी",
        STATE_RJ_CITY_96: "अलवर",
        STATE_KL_CITY_97: "नेहमी",
        STATE_AP_CITY_98: "अमलापुरम",
        STATE_MH_CITY_99: "अमळनेर",
        STATE_MP_CITY_100: "अमनगंज",
        STATE_UP_CITY_101: "अमनपूर",
        STATE_MP_CITY_102: "अमरकंटक",
        STATE_MH_CITY_103: "अमरनाथ",
        STATE_MP_CITY_104: "अमरपाटण",
        STATE_BR_CITY_105: "अमरपूर",
        STATE_TR_CITY_106: "अमरपूर",
        STATE_MP_CITY_107: "अमरवारा",
        STATE_UP_CITY_108: "अमौली",
        STATE_MH_CITY_109: "अंबड",
        STATE_CT_CITY_110: "अंबागड चौकी",
        STATE_MP_CITY_111: "आंबा",
        STATE_UP_CITY_112: "आंबाहटा",
        STATE_MH_CITY_113: "अंबाजोगाई",
        STATE_HR_CITY_114: "अंबाला",
        STATE_MH_CITY_115: "अंबरनाथ",
        STATE_TR_CITY_116: "अंबासा",
        STATE_TN_CITY_117: "अंबासमुद्रम",
        STATE_TN_CITY_118: "अंबत्तूर",
        STATE_UP_CITY_119: "आंबेडकर नगर",
        STATE_MH_CITY_120: "आंबेगाव",
        STATE_CT_CITY_121: "अंबिकापूर",
        STATE_TN_CITY_122: "अंबुर",
        STATE_RJ_CITY_123: "अमेट",
        STATE_UP_CITY_124: "अमेठी",
        STATE_MH_CITY_125: "आमगाव",
        STATE_AS_CITY_126: "आमगुरी",
        STATE_MP_CITY_127: "आवळा",
        STATE_WB_CITY_128: "आमलागोरा",
        STATE_DN_CITY_129: "आमली",
        STATE_PB_CITY_130: "अमलोह",
        STATE_TN_CITY_131: "अम्मापेट्टाई",
        STATE_GJ_CITY_132: "आमोद",
        STATE_GJ_CITY_133: "आमोद,",
        STATE_MH_CITY_134: "अमरावती",
        STATE_MH_CITY_135: "अमरावती विभाग",
        STATE_GJ_CITY_136: "अमरेली",
        STATE_PB_CITY_137: "अमृतसर",
        STATE_UP_CITY_138: "अमरोहा",
        STATE_GJ_CITY_139: "अमरोली",
        STATE_WB_CITY_140: "आमटा",
        STATE_WB_CITY_141: "आमटाळा",
        STATE_AP_CITY_142: "अमुदलवलसा",
        STATE_AP_CITY_143: "अनकपल्ले",
        STATE_TN_CITY_144: "अनमलाईस",
        STATE_GJ_CITY_145: "आनंद",
        STATE_UP_CITY_146: "आनंदनगर",
        STATE_PB_CITY_147: "आनंदपूर साहिब",
        STATE_AP_CITY_148: "अनंतपूर",
        STATE_JK_CITY_149: "अनंतनाग",
        STATE_WB_CITY_150: "आंदल",
        STATE_MH_CITY_151: "अंधेरी",
        STATE_TN_CITY_152: "आंदिपट्टी",
        STATE_TG_CITY_153: "आंदोल",
        STATE_MH_CITY_154: "अंदुरा",
        STATE_KA_CITY_155: "अनकल",
        STATE_KL_CITY_156: "अंगमाली",
        STATE_OR_CITY_157: "अंगुल",
        STATE_OR_CITY_158: "अंगुल जिल्हा",
        STATE_MP_CITY_159: "अंजद",
        STATE_MH_CITY_160: "अंजनगाव",
        STATE_GJ_CITY_161: "अंजार",
        STATE_MH_CITY_162: "आंजर्ले",
        STATE_AR_CITY_163: "आंजव",
        STATE_GJ_CITY_164: "अंकलेश्वर",
        STATE_KA_CITY_165: "अंकोला",
        STATE_TN_CITY_166: "अन्नामलाईनगर",
        STATE_TN_CITY_167: "अण्णावासल",
        STATE_KA_CITY_168: "अँनिगेरी",
        STATE_TN_CITY_169: "अन्नूर",
        STATE_MH_CITY_170: "अनशिंग",
        STATE_RJ_CITY_171: "अंता",
        STATE_TN_CITY_172: "अंत्यूर",
        STATE_MP_CITY_173: "अंतरी",
        STATE_UP_CITY_174: "अंतु",
        STATE_RJ_CITY_175: "अनुपगढ",
        STATE_MP_CITY_176: "अनुपपूर",
        STATE_UP_CITY_177: "अनुपशहर",
        STATE_UP_CITY_178: "झोनला",
        STATE_MH_CITY_179: "आरग",
        STATE_TN_CITY_180: "अरक्कोनम",
        STATE_WB_CITY_181: "आरामबाग समुदाय विकास गट",
        STATE_GA_CITY_182: "आरंबोल",
        STATE_CT_CITY_183: "आरंग",
        STATE_MH_CITY_184: "अरणगाव",
        STATE_TN_CITY_185: "अरांतंगी",
        STATE_BR_CITY_186: "अररिया",
        STATE_UP_CITY_187: "अरौल",
        STATE_TN_CITY_188: "अर्कोट",
        STATE_MH_CITY_189: "अर्धापूर",
        STATE_MH_CITY_190: "अरगाव",
        STATE_TN_CITY_191: "अरिमलम",
        STATE_TN_CITY_192: "अरियालूर",
        STATE_KA_CITY_193: "अर्कलगुड",
        STATE_HP_CITY_194: "अर्की",
        STATE_TN_CITY_195: "आर्णी",
        STATE_MP_CITY_196: "आरोन",
        STATE_KL_CITY_197: "आरूर",
        STATE_BR_CITY_198: "आराह",
        STATE_KA_CITY_199: "अरसिकरे",
        STATE_MH_CITY_200: "कलाकारांचे गाव",
        STATE_KL_CITY_201: "अरुकुट्टी",
        STATE_TN_CITY_202: "अरुंबवूर",
        STATE_TN_CITY_203: "अरुमुगनेरी",
        STATE_TN_CITY_204: "अरुप्पुकोट्टाई",
        STATE_TN_CITY_205: "अरुवंकड",
        STATE_MH_CITY_206: "आर्वी",
        STATE_BR_CITY_207: "अरवाल",
        STATE_UP_CITY_208: "असलतगंज",
        STATE_HR_CITY_209: "असांध",
        STATE_WB_CITY_210: "आसनसोल",
        STATE_BR_CITY_211: "असरगंज",
        STATE_MP_CITY_212: "अशोकनगर",
        STATE_WB_CITY_213: "अशोकनगर कल्याणगड",
        STATE_MH_CITY_214: "आष्टा",
        STATE_MP_CITY_215: "आष्टा",
        STATE_MH_CITY_216: "आष्टी",
        STATE_TG_CITY_217: "आसिफाबाद",
        STATE_OR_CITY_218: "आशिका",
        STATE_RJ_CITY_219: "असिंद",
        STATE_MH_CITY_220: "असोदा",
        STATE_MH_CITY_221: "असाय",
        STATE_MH_CITY_222: "अस्तगाव",
        STATE_UP_CITY_223: "अतर्रा",
        STATE_HR_CITY_224: "अटेली मंडी",
        STATE_OR_CITY_225: "अथगढ",
        STATE_KA_CITY_226: "अथनी",
        STATE_AP_CITY_227: "आत्मकूर",
        STATE_UP_CITY_228: "अत्रौली",
        STATE_UP_CITY_229: "अट्रोलिया",
        STATE_TN_CITY_230: "अट्टयंपट्टी",
        STATE_AP_CITY_231: "अटिली",
        STATE_KL_CITY_232: "अटिंगल",
        STATE_TN_CITY_233: "अत्तूर",
        STATE_MH_CITY_234: "औंध, सातारा",
        STATE_KA_CITY_235: "औराद",
        STATE_UP_CITY_236: "औरैया",
        STATE_MH_CITY_237: "औरंगाबाद",
        STATE_BR_CITY_238: "औरंगाबाद",
        STATE_UP_CITY_239: "औरास",
        STATE_TN_CITY_240: "ऑरोविल",
        STATE_MH_CITY_241: "औसा",
        STATE_TN_CITY_242: "आवडी",
        STATE_AP_CITY_243: "अवनीगड्डा",
        STATE_KL_CITY_244: "अवनूर",
        STATE_TN_CITY_245: "अविनाशी",
        STATE_JK_CITY_246: "अवंतीपूर",
        STATE_TN_CITY_247: "अयाकुडी",
        STATE_UP_CITY_248: "अयोध्या",
        STATE_TN_CITY_249: "अय्यामपेट्टाई",
        STATE_UP_CITY_250: "आझमगड",
        STATE_KL_CITY_251: "अळीकल",
        STATE_UP_CITY_252: "अजीजपूर",
        STATE_MP_CITY_253: "बाबाई",
        STATE_UP_CITY_254: "बाबेरू",
        STATE_UP_CITY_255: "बाबिना",
        STATE_GJ_CITY_256: "बाबरा",
        STATE_UP_CITY_257: "बाबराळा",
        STATE_UP_CITY_258: "बाबुगढ",
        STATE_UP_CITY_259: "बछरावन",
        STATE_UP_CITY_260: "बछरावन",
        STATE_OR_CITY_261: "बडा बाराबिल",
        STATE_KL_CITY_262: "बडगारा",
        STATE_KA_CITY_263: "बदामी",
        STATE_AS_CITY_264: "बदरपूर",
        STATE_MP_CITY_265: "बदरवास",
        STATE_HP_CITY_266: "बद्दी",
        STATE_JK_CITY_267: "बडगाम",
        STATE_PB_CITY_268: "बधनी कलान",
        STATE_WB_CITY_269: "बडकुल्ला",
        STATE_MH_CITY_270: "बदलापूर",
        STATE_MH_CITY_271: "बदनापूर",
        STATE_MP_CITY_272: "बदनावार",
        STATE_MH_CITY_273: "बडनेरा",
        STATE_WB_CITY_274: "बदुरिया",
        STATE_AP_CITY_275: "बडवेल",
        STATE_MP_CITY_276: "बॅग",
        STATE_GA_CITY_277: "बगा",
        STATE_BR_CITY_278: "बगहा",
        STATE_KA_CITY_279: "बागलकोट",
        STATE_RJ_CITY_280: "बागर",
        STATE_GJ_CITY_281: "बगसरा",
        STATE_GJ_CITY_282: "बगसरा",
        STATE_WB_CITY_283: "बागडोगरा",
        STATE_KA_CITY_284: "बागेपल्ली",
        STATE_UT_CITY_285: "बागेश्वर",
        STATE_MH_CITY_286: "बागेवाडी",
        STATE_PB_CITY_287: "बाघा पुराण",
        STATE_UP_CITY_288: "बागपत",
        STATE_UP_CITY_289: "बघरा",
        STATE_MP_CITY_290: "बागली",
        STATE_WB_CITY_291: "बागनन",
        STATE_JH_CITY_292: "बागरा",
        STATE_WB_CITY_293: "बागुळा",
        STATE_UP_CITY_294: "बह",
        STATE_BR_CITY_295: "बहादूरगंज",
        STATE_HR_CITY_296: "बहादूरगड",
        STATE_UP_CITY_297: "बाहेरी",
        STATE_UP_CITY_298: "बहजोई",
        STATE_UP_CITY_299: "बहराइच",
        STATE_UP_CITY_300: "बहराघ",
        STATE_UP_CITY_301: "बहुसुमा",
        STATE_UP_CITY_302: "बहुआ",
        STATE_WB_CITY_303: "बाहुला",
        STATE_WB_CITY_304: "बैद्यबाती",
        STATE_MP_CITY_305: "बैहार",
        STATE_CT_CITY_306: "बैकुंठपूर",
        STATE_MP_CITY_307: "बैकुंठपूर",
        STATE_KA_CITY_308: "जामीन-होंगल",
        STATE_BR_CITY_309: "बैरागनिया",
        STATE_BR_CITY_310: "बैसी",
        STATE_UP_CITY_311: "बजना",
        STATE_RJ_CITY_312: "बकानी",
        STATE_UP_CITY_313: "बकेवार",
        STATE_GJ_CITY_314: "बखरला",
        STATE_BR_CITY_315: "बख्तियारपूर",
        STATE_PB_CITY_316: "बकलोह",
        STATE_WB_CITY_317: "बकरेश्वर",
        STATE_AS_CITY_318: "बक्सा",
        STATE_UP_CITY_319: "बकसर",
        STATE_MP_CITY_320: "बक्षवाहो",
        STATE_PB_CITY_321: "बालचोर",
        STATE_GJ_CITY_322: "बलगम",
        STATE_MP_CITY_323: "बालाघाट",
        STATE_UP_CITY_324: "बाळामाळ",
        STATE_OR_CITY_325: "बालंगीर",
        STATE_TG_CITY_326: "बाळापूर",
        STATE_MH_CITY_327: "बाळापूर",
        STATE_MH_CITY_328: "बाळापूर, अकोला जि",
        STATE_WB_CITY_329: "बलरामपूर",
        STATE_GJ_CITY_330: "बालसिनोर",
        STATE_OR_CITY_331: "बालासोर",
        STATE_UP_CITY_332: "बालदेव",
        STATE_MP_CITY_333: "बलदेवगड",
        STATE_UP_CITY_334: "बलदेव",
        STATE_OR_CITY_335: "बालेश्वर",
        STATE_RJ_CITY_336: "बाली",
        STATE_WB_CITY_337: "बळी चक",
        STATE_OR_CITY_338: "बलिमिला",
        STATE_GJ_CITY_339: "बालीसणा",
        STATE_MH_CITY_340: "बल्लाळपूर",
        STATE_MH_CITY_341: "बॅलार्ड इस्टेट",
        STATE_KA_CITY_342: "बल्लारी",
        STATE_MH_CITY_343: "बल्लारपूर",
        STATE_UP_CITY_344: "बलिया",
        STATE_WB_CITY_345: "बल्ली",
        STATE_CT_CITY_346: "बालोद",
        STATE_CT_CITY_347: "बालोदा",
        STATE_CT_CITY_348: "बालोदा बाजार",
        STATE_RJ_CITY_349: "बालोत्रा",
        STATE_UP_CITY_350: "बलरामपूर",
        STATE_OR_CITY_351: "बाळुगाव",
        STATE_WB_CITY_352: "बालूरघाट",
        STATE_GJ_CITY_353: "बामणबोरे",
        STATE_WB_CITY_354: "बामनगोला समुदाय विकास गट",
        STATE_GA_CITY_355: "बांबोलीम",
        STATE_AN_CITY_356: "बांबू फ्लॅट",
        STATE_MP_CITY_357: "बामना",
        STATE_MP_CITY_358: "बामोर कलान",
        STATE_MP_CITY_359: "बामोरा",
        STATE_OR_CITY_360: "बाणापूर",
        STATE_GJ_CITY_361: "बनास कंठा",
        STATE_UP_CITY_362: "बनात",
        STATE_KA_CITY_363: "बनवर",
        STATE_UP_CITY_364: "बनबासा",
        STATE_MP_CITY_365: "बांदा",
        STATE_UP_CITY_366: "बांदा",
        STATE_MH_CITY_367: "बांदा, महाराष्ट्र",
        STATE_GJ_CITY_368: "बंड्या",
        STATE_RJ_CITY_369: "बंदिकुई",
        STATE_JK_CITY_370: "बांदीपोर",
        STATE_JK_CITY_371: "बंदिपुरा",
        STATE_GA_CITY_372: "बांदोरा",
        STATE_MH_CITY_373: "वांद्रे",
        STATE_MH_CITY_374: "बाणेर",
        STATE_WB_CITY_375: "बनेश्वर",
        STATE_PB_CITY_376: "बंगा",
        STATE_KA_CITY_377: "बंगलोर ग्रामीण",
        STATE_KA_CITY_378: "बंगलोर शहरी",
        STATE_AP_CITY_379: "बंगनपल्ले",
        STATE_BR_CITY_380: "बनगाव",
        STATE_WB_CITY_381: "बनगाव",
        STATE_KA_CITY_382: "बांगरापेठ",
        STATE_UP_CITY_383: "बांगरमाऊ",
        STATE_JK_CITY_384: "बनिहाल",
        STATE_HP_CITY_385: "बंजार",
        STATE_BR_CITY_386: "बंका",
        STATE_OR_CITY_387: "बांकी",
        STATE_MH_CITY_388: "बाणकोट",
        STATE_WB_CITY_389: "बांकरा",
        STATE_WB_CITY_390: "बांकुरा",
        STATE_BR_CITY_391: "बनमंखी",
        STATE_KA_CITY_392: "बन्नूर",
        STATE_OR_CITY_393: "बनपोश",
        STATE_WB_CITY_394: "बन्सबेरिया",
        STATE_UP_CITY_395: "बन्सडीह",
        STATE_UP_CITY_396: "बनसगाव",
        STATE_UP_CITY_397: "बन्सी",
        STATE_WB_CITY_398: "बनसिहारी कम्युनिटी डेव्हलपमेंट ब्लॉक",
        STATE_TG_CITY_399: "बनसवाडा",
        STATE_RJ_CITY_400: "बांसवाडा",
        STATE_UP_CITY_401: "बंत्रा",
        STATE_GJ_CITY_402: "बांटवा",
        STATE_KA_CITY_403: "बंटवल",
        STATE_PB_CITY_404: "बाणूर",
        STATE_AP_CITY_405: "बापटला",
        STATE_BR_CITY_406: "बार बिघा",
        STATE_UP_CITY_407: "बारा बांकी",
        STATE_HR_CITY_408: "बारा उचना",
        STATE_WB_CITY_409: "बाराबाजार",
        STATE_UP_CITY_410: "बारागाव",
        STATE_OR_CITY_411: "बारागड",
        STATE_MH_CITY_412: "बारामती",
        STATE_JK_CITY_413: "बारामुला",
        STATE_RJ_CITY_414: "बरण",
        STATE_WB_CITY_415: "बारानगर",
        STATE_WB_CITY_416: "बारासात",
        STATE_BR_CITY_417: "बारौली",
        STATE_UP_CITY_418: "बरौत",
        STATE_OR_CITY_419: "बारबिल",
        STATE_WB_CITY_420: "वर्धमान",
        STATE_GJ_CITY_421: "बारडोली",
        STATE_UP_CITY_422: "बरेली",
        STATE_MP_CITY_423: "बारेला",
        STATE_OR_CITY_424: "बारगळ",
        STATE_MP_CITY_425: "बारघाट",
        STATE_MP_CITY_426: "बर्गी",
        STATE_BR_CITY_427: "बारह",
        STATE_UP_CITY_428: "बरहालगंज",
        STATE_MP_CITY_429: "बार्ही",
        STATE_BR_CITY_430: "बारह्या",
        STATE_RJ_CITY_431: "बारी",
        STATE_RJ_CITY_432: "बारी सदरी",
        STATE_BR_CITY_433: "बरियारपूर",
        STATE_TR_CITY_434: "बरजाळा",
        STATE_WB_CITY_435: "बारजोरा",
        STATE_JH_CITY_436: "बरका काना",
        STATE_UP_CITY_437: "बरखेरा",
        STATE_UP_CITY_438: "बरखेरा कलान",
        STATE_JH_CITY_439: "बर्की सारिया",
        STATE_UT_CITY_440: "बरकोट",
        STATE_RJ_CITY_441: "बारमेर",
        STATE_PB_CITY_442: "बर्नाळा",
        STATE_UP_CITY_443: "बारोखर",
        STATE_OR_CITY_444: "बारपाली",
        STATE_AS_CITY_445: "बारपठार",
        STATE_AS_CITY_446: "बारपेटा",
        STATE_AS_CITY_447: "बारपेटा रोड",
        STATE_WB_CITY_448: "बॅरकपूर",
        STATE_UP_CITY_449: "बरसाना",
        STATE_MH_CITY_450: "बारसी",
        STATE_WB_CITY_451: "बरुईपूर",
        STATE_BR_CITY_452: "बारुणी",
        STATE_JH_CITY_453: "बारवडीह",
        STATE_HR_CITY_454: "बारवाला",
        STATE_MP_CITY_455: "बरवणी",
        STATE_UP_CITY_456: "बारवार (लखीमपूर खेरी)",
        STATE_WB_CITY_457: "बसंती",
        STATE_AR_CITY_458: "बसर",
        STATE_KA_CITY_459: "बसवकल्याण",
        STATE_KA_CITY_460: "बसवना बागेवाडी",
        STATE_RJ_CITY_461: "बसी",
        STATE_WB_CITY_462: "बसीरहाट",
        STATE_MH_CITY_463: "बसमत",
        STATE_MH_CITY_464: "बासमथ",
        STATE_CT_CITY_465: "बसना",
        STATE_RJ_CITY_466: "बसनी",
        STATE_MP_CITY_467: "बसोडा",
        STATE_CT_CITY_468: "बस्तर",
        STATE_UP_CITY_469: "बस्ती",
        STATE_OR_CITY_470: "बासुदेबपूर",
        STATE_AS_CITY_471: "बसुगाव",
        STATE_RJ_CITY_472: "बसवा",
        STATE_PB_CITY_473: "बटाळा",
        STATE_JK_CITY_474: "बतोटी",
        STATE_OR_CITY_475: "बॉड",
        STATE_OR_CITY_476: "बौध",
        STATE_MH_CITY_477: "बावधन",
        STATE_HR_CITY_478: "बावल",
        STATE_WB_CITY_479: "बावळी",
        STATE_DL_CITY_480: "बावना",
        STATE_MH_CITY_481: "बावनबीर",
        STATE_RJ_CITY_482: "बायणा",
        STATE_UT_CITY_483: "बाजपूर",
        STATE_RJ_CITY_484: "बेवारस",
        STATE_GJ_CITY_485: "बेदी",
        STATE_MH_CITY_486: "बीड",
        STATE_MP_CITY_487: "बेगमगंज",
        STATE_WB_CITY_488: "बेगमपूर",
        STATE_PB_CITY_489: "बेगोवाल",
        STATE_RJ_CITY_490: "सुरुवात केली",
        STATE_BR_CITY_491: "बेगुसराय",
        STATE_UP_CITY_492: "बेहत",
        STATE_RJ_CITY_493: "बेहरोर",
        STATE_UP_CITY_494: "बेला",
        STATE_OR_CITY_495: "बेलागुंठा",
        STATE_WB_CITY_496: "बेलडा",
        STATE_WB_CITY_497: "बेलडांगा",
        STATE_KA_CITY_498: "बेळगाव",
        STATE_WB_CITY_499: "बेलियाटोर",
        STATE_TG_CITY_500: "बेल्लमपल्ली",
        STATE_KA_CITY_501: "बेल्लारी",
        STATE_KA_CITY_502: "बेल्लुरू",
        STATE_TR_CITY_503: "बेलोनिया",
        STATE_BR_CITY_504: "बेलसँड",
        STATE_KA_CITY_505: "बेलतंगडी",
        STATE_UP_CITY_506: "बेलथरा",
        STATE_TN_CITY_507: "बेलूर",
        STATE_KA_CITY_508: "बेलूर",
        STATE_CT_CITY_509: "बेमेटारा",
        STATE_GA_CITY_510: "बेनौलिम",
        STATE_KA_CITY_511: "बेंगळुरू",
        STATE_UP_CITY_512: "बेनीगंज",
        STATE_MP_CITY_513: "बेओहारी",
        STATE_MP_CITY_514: "बेरासिया",
        STATE_WB_CITY_515: "बेरहामपूर",
        STATE_HR_CITY_516: "बेरी खास",
        STATE_UP_CITY_517: "बेसवान",
        STATE_AP_CITY_518: "बेतामचेर्ला",
        STATE_MP_CITY_519: "बेतमा",
        STATE_BR_CITY_520: "बेतिया",
        STATE_MP_CITY_521: "बैतुल",
        STATE_MP_CITY_522: "बैतूल बाजार",
        STATE_UP_CITY_523: "बेवार",
        STATE_KL_CITY_524: "बेपोर",
        STATE_MP_CITY_525: "भाभ्र",
        STATE_BR_CITY_526: "भाभुआ",
        STATE_GJ_CITY_527: "भाचाळ",
        STATE_UP_CITY_528: "भदरसा",
        STATE_JK_CITY_529: "भदरवाह",
        STATE_RJ_CITY_530: "भडसर",
        STATE_PB_CITY_531: "भदौर",
        STATE_MH_CITY_532: "भडगाव, महाराष्ट्र",
        STATE_UP_CITY_533: "भदोही",
        STATE_RJ_CITY_534: "भद्रा",
        STATE_TG_CITY_535: "भद्राचलम",
        STATE_TG_CITY_536: "भद्राद्री कोठागुडेम",
        STATE_OR_CITY_537: "भद्रक",
        STATE_OR_CITY_538: "भद्रख",
        STATE_GJ_CITY_539: "भद्रन",
        STATE_KA_CITY_540: "भद्रावती",
        STATE_WB_CITY_541: "भद्रेश्वर",
        STATE_BR_CITY_542: "भागलपूर",
        STATE_BR_CITY_543: "भगीरथपूर",
        STATE_UP_CITY_544: "भगवंतनगर",
        STATE_MP_CITY_545: "भैंसदेही",
        STATE_TG_CITY_546: "भैसा",
        STATE_KA_CITY_547: "भालकी",
        STATE_MH_CITY_548: "भंडारा",
        STATE_WB_CITY_549: "भंडारदहा",
        STATE_MH_CITY_550: "भंडारदरा",
        STATE_MP_CITY_551: "भांडेर",
        STATE_GJ_CITY_552: "भोंदू",
        STATE_MH_CITY_553: "भांडुप",
        STATE_OR_CITY_554: "भंजननगर",
        STATE_MP_CITY_555: "भानपुरा",
        STATE_CT_CITY_556: "भानपुरी",
        STATE_GJ_CITY_557: "भानवड",
        STATE_RJ_CITY_558: "भरतपूर",
        STATE_UP_CITY_559: "भरतपुरा",
        STATE_UP_CITY_560: "भार्गेन",
        STATE_UP_CITY_561: "भरठाणा",
        STATE_GJ_CITY_562: "भरुच",
        STATE_UP_CITY_563: "भारवारी",
        STATE_RJ_CITY_564: "भासावार",
        STATE_CT_CITY_565: "भाटपारा",
        STATE_CT_CITY_566: "भाटगाव",
        STATE_GJ_CITY_567: "भाठा",
        STATE_PB_CITY_568: "भटिंडा",
        STATE_KA_CITY_569: "भटकळ",
        STATE_WB_CITY_570: "भटपारा",
        STATE_AP_CITY_571: "भट्टीप्रोलु",
        STATE_UP_CITY_572: "भाऊपूर",
        STATE_TN_CITY_573: "भवानी",
        STATE_GJ_CITY_574: "भावनगर",
        STATE_MP_CITY_575: "भवानीगंज",
        STATE_PB_CITY_576: "भवानीगड",
        STATE_OR_CITY_577: "भवानीपत्ना",
        STATE_BR_CITY_578: "भवानीपूर",
        STATE_MH_CITY_579: "भाईंदर",
        STATE_GJ_CITY_580: "भायावदार",
        STATE_MH_CITY_581: "भिगवण",
        STATE_MP_CITY_582: "भिकणगाव",
        STATE_PB_CITY_583: "भिखी",
        STATE_CT_CITY_584: "भिलाई",
        STATE_GJ_CITY_585: "भिलडी",
        STATE_RJ_CITY_586: "भिलवाडा",
        STATE_UT_CITY_587: "भीम ता",
        STATE_AP_CITY_588: "भीमवरम",
        STATE_UP_CITY_589: "भीमताल",
        STATE_AP_CITY_590: "भीमुनिपट्टणम",
        STATE_MP_CITY_591: "भिंड",
        STATE_RJ_CITY_592: "भिंदर",
        STATE_UP_CITY_593: "भिंगा",
        STATE_RJ_CITY_594: "भीनमाळ",
        STATE_MP_CITY_595: "भितरवार",
        STATE_RJ_CITY_596: "भिवडी",
        STATE_MH_CITY_597: "भिवंडी",
        STATE_HR_CITY_598: "भिवानी",
        STATE_MH_CITY_599: "भिवापूर",
        STATE_UP_CITY_600: "भोगनीपूर",
        STATE_PB_CITY_601: "भोगपूर",
        STATE_BR_CITY_602: "भोजपूर",
        STATE_GJ_CITY_603: "भोजपूर धरमपूर",
        STATE_JH_CITY_604: "भोजुडीह",
        STATE_MH_CITY_605: "भोकर",
        STATE_MH_CITY_606: "भोकरदन",
        STATE_PB_CITY_607: "भोलाथ",
        STATE_UP_CITY_608: "भोणगाव",
        STATE_TG_CITY_609: "भोंगीर",
        STATE_MH_CITY_610: "भूम",
        STATE_MP_CITY_611: "भोपाळ",
        STATE_MH_CITY_612: "भोर",
        STATE_UT_CITY_613: "भोवली",
        STATE_OR_CITY_614: "भुवन",
        STATE_OR_CITY_615: "भुवनेश्वर",
        STATE_MH_CITY_616: "भुडगाव",
        STATE_MH_CITY_617: "भूगाव",
        STATE_GJ_CITY_618: "भुज",
        STATE_MH_CITY_619: "भूम",
        STATE_RJ_CITY_620: "भूमा",
        STATE_MH_CITY_621: "भुसावळ",
        STATE_MH_CITY_622: "भुसावळ",
        STATE_MP_CITY_623: "बिओरा",
        STATE_MH_CITY_624: "बोली",
        STATE_KA_CITY_625: "बिदर",
        STATE_UP_CITY_626: "बिधनू",
        STATE_UP_CITY_627: "बिधुना",
        STATE_UP_CITY_628: "बिघापूर",
        STATE_UP_CITY_629: "बिघापूर खुर्द",
        STATE_BR_CITY_630: "बिहार शरीफ",
        STATE_BR_CITY_631: "बिहारीगंज",
        STATE_AS_CITY_632: "बिहपुरियागाव",
        STATE_KA_CITY_633: "विजापूर",
        STATE_CT_CITY_634: "विजापूर",
        STATE_MP_CITY_635: "बिजावर",
        STATE_JK_CITY_636: "बिजबेहरा",
        STATE_AS_CITY_637: "बिजनी",
        STATE_UP_CITY_638: "बिजनौर",
        STATE_MP_CITY_639: "बिजरौनी",
        STATE_MH_CITY_640: "बिजूर",
        STATE_RJ_CITY_641: "बिकानेर",
        STATE_UP_CITY_642: "बिकापूर",
        STATE_BR_CITY_643: "बिक्रमगंज",
        STATE_RJ_CITY_644: "बिलारा",
        STATE_UP_CITY_645: "बिलारी",
        STATE_UP_CITY_646: "बिलरियागंज",
        STATE_MH_CITY_647: "बिलाशी",
        STATE_AS_CITY_648: "बिलासीपारा",
        STATE_HP_CITY_649: "बिलासपूर",
        STATE_HR_CITY_650: "बिलासपूर",
        STATE_CT_CITY_651: "बिलासपूर",
        STATE_UP_CITY_652: "बिलासपूर",
        STATE_KA_CITY_653: "बिलगी",
        STATE_UP_CITY_654: "बिलग्राम",
        STATE_UP_CITY_655: "बिल्हौर",
        STATE_GJ_CITY_656: "बिलीमोरा",
        STATE_GJ_CITY_657: "बिलखा",
        STATE_MH_CITY_658: "बिलोली",
        STATE_UP_CITY_659: "बिलसांडा",
        STATE_UP_CITY_660: "बिलसी",
        STATE_UP_CITY_661: "बिल्थरा",
        STATE_UP_CITY_662: "बिनौली",
        STATE_UP_CITY_663: "बिनाौर",
        STATE_UP_CITY_664: "बिंदकी",
        STATE_OR_CITY_665: "बिंका",
        STATE_UT_CITY_666: "बिरभद्दर",
        STATE_WB_CITY_667: "बीरभूम जिल्हा",
        STATE_UP_CITY_668: "बर्डपूर",
        STATE_OR_CITY_669: "बिरमित्रापूर",
        STATE_WB_CITY_670: "बिरपारा",
        STATE_BR_CITY_671: "बिरपूर",
        STATE_UP_CITY_672: "बिरपूर",
        STATE_KA_CITY_673: "बिरूर",
        STATE_UP_CITY_674: "बिसलपूर",
        STATE_UP_CITY_675: "बिसंडा बुजुर्ग",
        STATE_UP_CITY_676: "बिसौली",
        STATE_UP_CITY_677: "बिसेंडा बुजुर्ग",
        STATE_JK_CITY_678: "बिश्नाह",
        STATE_MN_CITY_679: "बिष्णुपूर",
        STATE_WB_CITY_680: "बिष्णुपूर",
        STATE_UP_CITY_681: "बिशुनपूर उर्फ ​​महाराजगंज",
        STATE_RJ_CITY_682: "बिसाऊ",
        STATE_UP_CITY_683: "बिस्वान",
        STATE_UP_CITY_684: "बिथूर",
        STATE_AP_CITY_685: "बोबली",
        STATE_TG_CITY_686: "बोधन",
        STATE_TN_CITY_687: "बोडीनायककानूर",
        STATE_MP_CITY_688: "बोदरी",
        STATE_MH_CITY_689: "बोईसर",
        STATE_AS_CITY_690: "बोकाजन",
        STATE_AS_CITY_691: "बोकाखत",
        STATE_JH_CITY_692: "बोकारो",
        STATE_OR_CITY_693: "बोलनीखोदन",
        STATE_WB_CITY_694: "बोलपूर",
        STATE_AR_CITY_695: "बोमडिला",
        STATE_AS_CITY_696: "बोंगईगाव",
        STATE_MH_CITY_697: "बोरगाव मंजू",
        STATE_MH_CITY_698: "बोरिवली",
        STATE_MH_CITY_699: "बोरिवली",
        STATE_RJ_CITY_700: "बोरखेरा",
        STATE_GJ_CITY_701: "बोरसद",
        STATE_GJ_CITY_702: "बोताड",
        STATE_OR_CITY_703: "ब्रह्मपूर",
        STATE_MH_CITY_704: "ब्रह्मपुरी",
        STATE_OR_CITY_705: "ब्रजराजनगर",
        STATE_MH_CITY_706: "ब्रीच कँडी",
        STATE_UP_CITY_707: "बुडाऊन",
        STATE_BR_CITY_708: "बुद्धगया",
        STATE_WB_CITY_709: "Budge Budge",
        STATE_UP_CITY_710: "बुढाणा",
        STATE_PB_CITY_711: "बुधलाडा",
        STATE_OR_CITY_712: "बुगुडा",
        STATE_UP_CITY_713: "बुलंदशहर",
        STATE_MH_CITY_714: "बुलडाणा",
        STATE_MH_CITY_715: "बुलढाणा",
        STATE_RJ_CITY_716: "बुंदी",
        STATE_JH_CITY_717: "बंडू",
        STATE_MP_CITY_718: "बुरहानपूर",
        STATE_MP_CITY_719: "बुरहर",
        STATE_HR_CITY_720: "बुरिया",
        STATE_OR_CITY_721: "बुर्ला",
        STATE_BR_CITY_722: "बक्सर",
        STATE_KA_CITY_723: "ब्याडगी",
        STATE_MH_CITY_724: "भायखळा",
        STATE_KA_CITY_725: "बायंडूर",
        STATE_AS_CITY_726: "कचर",
        STATE_GA_CITY_727: "कळंगुट",
        STATE_KA_CITY_728: "कानाकोना",
        STATE_GA_CITY_729: "कँडोलिम",
        STATE_WB_CITY_730: "कॅनिंग",
        STATE_UP_CITY_731: "कॅप्टनगंज",
        STATE_GA_CITY_732: "कारापूर",
        STATE_GA_CITY_733: "कॅव्हेलोसिम",
        STATE_DL_CITY_734: "मध्य दिल्ली",
        STATE_AS_CITY_735: "चाबुआ",
        STATE_JH_CITY_736: "चायबासा",
        STATE_UP_CITY_737: "चैल",
        STATE_MH_CITY_738: "चाकण",
        STATE_WB_CITY_739: "चकापरा",
        STATE_WB_CITY_740: "चकदहा",
        STATE_UP_CITY_741: "चकिया",
        STATE_BR_CITY_742: "चकिया",
        STATE_GJ_CITY_743: "चकलासी",
        STATE_JH_CITY_744: "चक्रधरपूर",
        STATE_UT_CITY_745: "चक्रता",
        STATE_RJ_CITY_746: "चकसू",
        STATE_JH_CITY_747: "चाकुल्या",
        STATE_MH_CITY_748: "चाकूर",
        STATE_GJ_CITY_749: "चालला",
        STATE_MH_CITY_750: "चाळीसगाव",
        STATE_KA_CITY_751: "चल्लाकेरे",
        STATE_AP_CITY_752: "चल्लापल्ले",
        STATE_GJ_CITY_753: "चलोडा",
        STATE_HP_CITY_754: "चंबा",
        STATE_UT_CITY_755: "चमोली",
        STATE_CT_CITY_756: "चंपा",
        STATE_WB_CITY_757: "चंपाडंगा",
        STATE_WB_CITY_758: "चंपाहाटी",
        STATE_GJ_CITY_759: "चंपानेर",
        STATE_UT_CITY_760: "चंपावत",
        STATE_WB_CITY_761: "चंपादानी",
        STATE_MZ_CITY_762: "चंफई",
        STATE_OR_CITY_763: "चंपुआ",
        STATE_KA_CITY_764: "चामराजनगर",
        STATE_GJ_CITY_765: "चाणस्मा",
        STATE_MH_CITY_766: "चंदा",
        STATE_WB_CITY_767: "चंदननगर",
        STATE_UP_CITY_768: "चांदौली",
        STATE_UP_CITY_769: "चांदौली जिल्हा",
        STATE_UP_CITY_770: "चांदौसी",
        STATE_OR_CITY_771: "चांदबळी",
        STATE_MP_CITY_772: "चंदेरी",
        STATE_MH_CITY_773: "चंदगड",
        STATE_MP_CITY_774: "चांदिया",
        STATE_CH_CITY_775: "चंदीगड",
        STATE_JH_CITY_776: "चांडिल",
        STATE_MP_CITY_777: "चांदला",
        STATE_MH_CITY_778: "चांदोर",
        STATE_UP_CITY_779: "चांदपूर",
        STATE_WB_CITY_780: "चंद्रकोना",
        STATE_MH_CITY_781: "चंद्रपूर",
        STATE_UP_CITY_782: "चंदूसी",
        STATE_TG_CITY_783: "चांदूर",
        STATE_MH_CITY_784: "चांदूर",
        STATE_MH_CITY_785: "चांदूरबाजार",
        STATE_KL_CITY_786: "चांगनाचेरी",
        STATE_AR_CITY_787: "चांगलांग",
        STATE_KA_CITY_788: "चन्नगिरी",
        STATE_KA_CITY_789: "चन्नपटना",
        STATE_KA_CITY_790: "चन्नरायपटना",
        STATE_AS_CITY_791: "चापर",
        STATE_BR_CITY_792: "छपरा",
        STATE_UP_CITY_793: "चरखारी",
        STATE_HR_CITY_794: "चरखी दादरी",
        STATE_UP_CITY_795: "चारथावल",
        STATE_JH_CITY_796: "चास",
        STATE_TG_CITY_797: "चातकोंडा",
        STATE_JH_CITY_798: "चत्र",
        STATE_OR_CITY_799: "चतरपूर",
        STATE_HP_CITY_800: "चौपाल",
        STATE_MH_CITY_801: "चौसाळा",
        STATE_RJ_CITY_802: "चेचट",
        STATE_KL_CITY_803: "चेलकारा",
        STATE_MH_CITY_804: "चेंबूर",
        STATE_AP_CITY_805: "चेमुमियाहपेट",
        STATE_TN_CITY_806: "चेंगम",
        STATE_KL_CITY_807: "चेंगन्नूर",
        STATE_TN_CITY_808: "चेन्नई",
        STATE_TN_CITY_809: "चेन्नीमलाई",
        STATE_KL_CITY_810: "चेरपुलासेरी",
        STATE_ML_CITY_811: "चेरापुंजी",
        STATE_KL_CITY_812: "चेर्थला",
        STATE_TN_CITY_813: "चेतपुट",
        STATE_TN_CITY_814: "चेट्टीपलैयम",
        STATE_KL_CITY_815: "चेतवई",
        STATE_TN_CITY_816: "च्याय्यार",
        STATE_TN_CITY_817: "चेयूर",
        STATE_RJ_CITY_818: "छाबरा",
        STATE_HR_CITY_819: "छछरौली",
        STATE_GJ_CITY_820: "छळा",
        STATE_RJ_CITY_821: "छपर",
        STATE_UP_CITY_822: "छपरौली",
        STATE_UP_CITY_823: "छर्रा",
        STATE_UP_CITY_824: "छटा",
        STATE_BR_CITY_825: "छटापूर",
        STATE_MP_CITY_826: "छतरपूर",
        STATE_UP_CITY_827: "छिब्रामाळ",
        STATE_MP_CITY_828: "छिंदवाडा",
        STATE_UP_CITY_829: "चिताउनी",
        STATE_GJ_CITY_830: "छोटा उदेपूर",
        STATE_RJ_CITY_831: "छोटी सदरी",
        STATE_CT_CITY_832: "चुईखडन",
        STATE_UP_CITY_833: "छुटमलपूर",
        STATE_GA_CITY_834: "चिकलीम",
        STATE_MP_CITY_835: "चिचली",
        STATE_MH_CITY_836: "चिचोली",
        STATE_MH_CITY_837: "चिचोंडी पाटील",
        STATE_TN_CITY_838: "चिदंबरम",
        STATE_RJ_CITY_839: "चिदावा",
        STATE_KA_CITY_840: "चिक बल्लापूर",
        STATE_GJ_CITY_841: "चिखली",
        STATE_MH_CITY_842: "चिखली (बुलढाणा)",
        STATE_MH_CITY_843: "चिखली (जालना)",
        STATE_OR_CITY_844: "चिकीतीगड",
        STATE_KA_CITY_845: "चिक्कबल्लापूर",
        STATE_KA_CITY_846: "चिकमंगळूर",
        STATE_KA_CITY_847: "चिकनायकनहल्ली",
        STATE_KA_CITY_848: "चिकोडी",
        STATE_AP_CITY_849: "चिलकलुरुपेत",
        STATE_UP_CITY_850: "चिल्लुपार",
        STATE_PB_CITY_851: "चिमा",
        STATE_MH_CITY_852: "चिमूर",
        STATE_MH_CITY_853: "चिंचणी",
        STATE_GA_CITY_854: "चिंचणीम",
        STATE_KA_CITY_855: "चिंचोली",
        STATE_MH_CITY_856: "चिंचपोकळी",
        STATE_TN_CITY_857: "चिंगलपुट",
        STATE_TN_CITY_858: "चिन्ना सालेम",
        STATE_AP_CITY_859: "चिन्नाचौक",
        STATE_TN_CITY_860: "चिन्नमनूर",
        STATE_TN_CITY_861: "चिन्नसेक्कडू",
        STATE_KA_CITY_862: "चिंतामणी",
        STATE_MH_CITY_863: "चिपळूण",
        STATE_AP_CITY_864: "चिपुरुपल्ले",
        STATE_AP_CITY_865: "चिराळा",
        STATE_AS_CITY_866: "चिरांग",
        STATE_UP_CITY_867: "चिरगाव",
        STATE_JH_CITY_868: "चिरिया",
        STATE_KA_CITY_869: "चितापूर",
        STATE_KA_CITY_870: "चित्रदुर्ग",
        STATE_UP_CITY_871: "चित्रकूट",
        STATE_UP_CITY_872: "चित्रकूट धाम",
        STATE_WB_CITY_873: "चित्तरंजन",
        STATE_OR_CITY_874: "चित्तरकोंडा",
        STATE_RJ_CITY_875: "चित्तौडगड",
        STATE_AP_CITY_876: "चित्तूर",
        STATE_KL_CITY_877: "चित्तूर",
        STATE_AP_CITY_878: "चोदावरम",
        STATE_TN_CITY_879: "चोलापुरम",
        STATE_UP_CITY_880: "चोपण",
        STATE_MH_CITY_881: "चोपडा",
        STATE_MP_CITY_882: "चोरहाट",
        STATE_GJ_CITY_883: "चोटीला",
        STATE_HP_CITY_884: "चौवारी",
        STATE_HP_CITY_885: "चुवारी खास",
        STATE_GJ_CITY_886: "चुडा",
        STATE_UP_CITY_887: "चुनार",
        STATE_MN_CITY_888: "चुरचंदपूर",
        STATE_UP_CITY_889: "चुर्क",
        STATE_RJ_CITY_890: "चुरू",
        STATE_WB_CITY_891: "चुरुलिया",
        STATE_UT_CITY_892: "क्लेमेंट टाउन",
        STATE_KA_CITY_893: "क्लोजपेट",
        STATE_KL_CITY_894: "कोचीन",
        STATE_TN_CITY_895: "कोईम्बतूर",
        STATE_MH_CITY_896: "कुलाबा",
        STATE_TN_CITY_897: "कोलाशेल",
        STATE_BR_CITY_898: "कोलगॉन्ग",
        STATE_UP_CITY_899: "कर्नलगंज",
        STATE_GA_CITY_900: "कोलोवळे",
        STATE_GA_CITY_901: "कोल्वा",
        STATE_WB_CITY_902: "कंटाय",
        STATE_WB_CITY_903: "कूचबिहार",
        STATE_KA_CITY_904: "कुंडापूर",
        STATE_GA_CITY_905: "कोर्टालिम",
        STATE_WB_CITY_906: "कोसिमबाजार",
        STATE_TN_CITY_907: "कुड्डालोर",
        STATE_AP_CITY_908: "कडपळ",
        STATE_AP_CITY_909: "कंबम",
        STATE_TN_CITY_910: "कंबम",
        STATE_GA_CITY_911: "कनकोलिम",
        STATE_GA_CITY_912: "कर्चोरेम",
        STATE_GA_CITY_913: "कर्टी",
        STATE_OR_CITY_914: "कटक",
        STATE_GJ_CITY_915: "दाभोडा",
        STATE_GJ_CITY_916: "डभोई",
        STATE_MH_CITY_917: "दाभोळ",
        STATE_MP_CITY_918: "दाबोह",
        STATE_MP_CITY_919: "डबरा",
        STATE_HR_CITY_920: "डबवली",
        STATE_MH_CITY_921: "दादी",
        STATE_DN_CITY_922: "दादरा",
        STATE_DN_CITY_923: "दादरा आणि नगर हवेली",
        STATE_UP_CITY_924: "दादरी",
        STATE_HP_CITY_925: "दग्शाई",
        STATE_MH_CITY_926: "डहाणू",
        STATE_GJ_CITY_927: "दहेगम",
        STATE_MH_CITY_928: "दहिवेल",
        STATE_GJ_CITY_929: "दाहोद",
        STATE_OR_CITY_930: "दैतरी",
        STATE_GJ_CITY_931: "डाकोर",
        STATE_WB_CITY_932: "दक्षिण दिनाजपूर जिल्हा",
        STATE_KA_CITY_933: "दक्षिण कन्नड",
        STATE_HP_CITY_934: "डलहौसी",
        STATE_WB_CITY_935: "डालकोला",
        STATE_UP_CITY_936: "दलमळ",
        STATE_BR_CITY_937: "दलसिंग सराई",
        STATE_JH_CITY_938: "डाल्टनगंज",
        STATE_WB_CITY_939: "धरण धरण",
        STATE_DD_CITY_940: "दमण",
        STATE_DD_CITY_941: "दमण जिल्हा",
        STATE_GJ_CITY_942: "दामनगर",
        STATE_MP_CITY_943: "दमोह",
        STATE_KA_CITY_944: "दांडेली",
        STATE_GJ_CITY_945: "दांडी",
        STATE_GJ_CITY_946: "डांग (भारत)",
        STATE_UP_CITY_947: "दनकौर",
        STATE_GJ_CITY_948: "दंता",
        STATE_MH_CITY_949: "दापोली",
        STATE_UP_CITY_950: "दारागंज",
        STATE_UP_CITY_951: "दारानगर",
        STATE_BR_CITY_952: "दरभंगा",
        STATE_RJ_CITY_953: "दरिबा",
        STATE_WB_CITY_954: "दार्जिलिंग",
        STATE_MZ_CITY_955: "डार्लॉन",
        STATE_AS_CITY_956: "दररंग",
        STATE_AP_CITY_957: "दरसी",
        STATE_MH_CITY_958: "दारव्हा",
        STATE_MH_CITY_959: "दर्यापूर",
        STATE_UP_CITY_960: "दसना",
        STATE_TG_CITY_961: "दसनापूर",
        STATE_PB_CITY_962: "दसूया",
        STATE_UP_CITY_963: "दातागंज",
        STATE_MP_CITY_964: "दतिया",
        STATE_MH_CITY_965: "दत्तापूर",
        STATE_BR_CITY_966: "दौडनगर",
        STATE_MH_CITY_967: "दौलताबाद",
        STATE_HP_CITY_968: "दौलतपूर",
        STATE_WB_CITY_969: "दौलतपूर",
        STATE_MH_CITY_970: "दौंड",
        STATE_UP_CITY_971: "दौराला",
        STATE_RJ_CITY_972: "दौसा",
        STATE_KA_CITY_973: "दावणगेरे",
        STATE_GA_CITY_974: "दावरलिम",
        STATE_UP_CITY_975: "दयाल बाग",
        STATE_GJ_CITY_976: "दयापार",
        STATE_WB_CITY_977: "देबग्राम",
        STATE_WB_CITY_978: "देबीपूर",
        STATE_MH_CITY_979: "डेक्कन जिमखाना",
        STATE_MH_CITY_980: "देगलूर",
        STATE_UT_CITY_981: "डेहराडून",
        STATE_BR_CITY_982: "देहरी",
        STATE_MH_CITY_983: "देहू",
        STATE_DL_CITY_984: "दिल्ली",
        STATE_GJ_CITY_985: "देऊळवडा",
        STATE_GJ_CITY_986: "देऊळवाडा",
        STATE_TN_CITY_987: "डेंकनीकोटा",
        STATE_UP_CITY_988: "देवबंद",
        STATE_OR_CITY_989: "देवगड",
        STATE_JH_CITY_990: "देवगड",
        STATE_UP_CITY_991: "देवगड",
        STATE_MH_CITY_992: "देवळाली",
        STATE_MH_CITY_993: "देवळापार",
        STATE_RJ_CITY_994: "देवळी",
        STATE_MH_CITY_995: "देवळी",
        STATE_DL_CITY_996: "देवळी",
        STATE_MH_CITY_997: "देवनी",
        STATE_UP_CITY_998: "देवरानियन",
        STATE_CT_CITY_999: "देवरी",
        STATE_MP_CITY_1000: "देवरी खास",
        STATE_UP_CITY_1001: "देवरिया",
        STATE_MP_CITY_1002: "देपालपूर",
        STATE_PB_CITY_1003: "डेरा बाबा नानक",
        STATE_PB_CITY_1004: "डेरा बस्सी",
        STATE_HP_CITY_1005: "डेरा गोपीपूर",
        STATE_UP_CITY_1006: "डेरापूर",
        STATE_AS_CITY_1007: "डेरगाव",
        STATE_RJ_CITY_1008: "देशनोके",
        STATE_TN_CITY_1009: "देसुर",
        STATE_GJ_CITY_1010: "देत्रोज",
        STATE_MH_CITY_1011: "देऊळगाव राजा",
        STATE_TN_CITY_1012: "देवदानप्पत्ती",
        STATE_TN_CITY_1013: "देवकोट्टाई",
        STATE_KA_CITY_1014: "देवनहल्ली",
        STATE_UT_CITY_1015: "देवप्रयाग",
        STATE_TG_CITY_1016: "देवरकोंडा",
        STATE_GJ_CITY_1017: "देवभूमी द्वारका",
        STATE_GJ_CITY_1018: "देवगड बारिया",
        STATE_RJ_CITY_1019: "देवगड",
        STATE_MH_CITY_1020: "देवरूख",
        STATE_UP_CITY_1021: "देवा",
        STATE_MP_CITY_1022: "देवास",
        STATE_BR_CITY_1023: "ढाका",
        STATE_TR_CITY_1024: "धलाई",
        STATE_TN_CITY_1025: "झाली",
        STATE_MP_CITY_1026: "धामनोद",
        STATE_UP_CITY_1027: "धामपूर",
        STATE_CT_CITY_1028: "धमतरी",
        STATE_MP_CITY_1029: "धना",
        STATE_PB_CITY_1030: "धनौला",
        STATE_UP_CITY_1031: "धनौरा",
        STATE_JH_CITY_1032: "धनबाद",
        STATE_GJ_CITY_1033: "धंधुका",
        STATE_GJ_CITY_1034: "धनेरा",
        STATE_UP_CITY_1035: "धनघाटा",
        STATE_WB_CITY_1036: "धनियाखली समाज विकास गट",
        STATE_GJ_CITY_1037: "धनसुरा",
        STATE_JH_CITY_1038: "धनवर",
        STATE_MP_CITY_1039: "धार",
        STATE_GJ_CITY_1040: "धरमपूर",
        STATE_MP_CITY_1041: "धरमपुरी",
        STATE_HP_CITY_1042: "धर्मशाळा",
        STATE_MH_CITY_1043: "धरणगाव",
        STATE_TN_CITY_1044: "धारापुरम",
        STATE_GJ_CITY_1045: "धरासना",
        STATE_UP_CITY_1046: "धरौ",
        STATE_MH_CITY_1047: "धारावी",
        STATE_UT_CITY_1048: "धारचुला",
        STATE_GJ_CITY_1049: "धरी",
        STATE_PB_CITY_1050: "धारिवाल",
        STATE_MH_CITY_1051: "धर्माबाद",
        STATE_KL_CITY_1052: "धर्मदम",
        STATE_TR_CITY_1053: "धर्मनगर",
        STATE_TN_CITY_1054: "धर्मपुरी",
        STATE_AP_CITY_1055: "धर्मावरम",
        STATE_HR_CITY_1056: "धरुहेरा",
        STATE_MH_CITY_1057: "धारूर",
        STATE_KA_CITY_1058: "धारवाड",
        STATE_GJ_CITY_1059: "धसा",
        STATE_RJ_CITY_1060: "धौलपूर",
        STATE_UP_CITY_1061: "धौरहरा",
        STATE_MH_CITY_1062: "धवलपुरी",
        STATE_AS_CITY_1063: "ढेकियाजुळी",
        STATE_AS_CITY_1064: "धेमाजी",
        STATE_OR_CITY_1065: "ढेंकनाल",
        STATE_PB_CITY_1066: "धिलवान",
        STATE_AS_CITY_1067: "धिंग",
        STATE_GJ_CITY_1068: "ढोला",
        STATE_GJ_CITY_1069: "ढोलेरा",
        STATE_GJ_CITY_1070: "ढोलका",
        STATE_AP_CITY_1071: "ढोणे",
        STATE_GJ_CITY_1072: "धोराजी",
        STATE_GJ_CITY_1073: "ध्रंगध्रा",
        STATE_GJ_CITY_1074: "ध्रोळ",
        STATE_AS_CITY_1075: "धुबरी",
        STATE_PB_CITY_1076: "धुडी",
        STATE_WB_CITY_1077: "धुलागरी",
        STATE_MH_CITY_1078: "धुळे",
        STATE_MH_CITY_1079: "धुलिया",
        STATE_WB_CITY_1080: "धुलियन",
        STATE_WB_CITY_1081: "धुपगुरी",
        STATE_PB_CITY_1082: "धुरी",
        STATE_GJ_CITY_1083: "धुवरन",
        STATE_WB_CITY_1084: "डायमंड हार्बर",
        STATE_UP_CITY_1085: "दिबाई",
        STATE_AR_CITY_1086: "दिबांग व्हॅली",
        STATE_AS_CITY_1087: "दिब्रुगड",
        STATE_GA_CITY_1088: "डिचोली",
        STATE_RJ_CITY_1089: "दिडवाना",
        STATE_RJ_CITY_1090: "खणणे",
        STATE_OR_CITY_1091: "दिगपहांडी",
        STATE_AS_CITY_1092: "डिगबोई",
        STATE_WB_CITY_1093: "दिघा",
        STATE_MH_CITY_1094: "दिघोरी",
        STATE_BR_CITY_1095: "दिघवारा",
        STATE_MH_CITY_1096: "डिगलूर",
        STATE_MH_CITY_1097: "दिग्रस",
        STATE_AP_CITY_1098: "दिगुवमेत्ता",
        STATE_AS_CITY_1099: "दिमा हासाओ जिल्हा",
        STATE_NL_CITY_1100: "दिमापूर",
        STATE_PB_CITY_1101: "दिना नगर",
        STATE_BR_CITY_1102: "दिनापूर",
        STATE_TN_CITY_1103: "दिंडी",
        STATE_MP_CITY_1104: "दिंडोरी",
        STATE_MH_CITY_1105: "दिंडोरी, महाराष्ट्र",
        STATE_WB_CITY_1106: "दिनहाटा",
        STATE_AS_CITY_1107: "दिफू",
        STATE_PB_CITY_1108: "दिर्बा",
        STATE_GJ_CITY_1109: "दिसा",
        STATE_AS_CITY_1110: "दिसपूर",
        STATE_DD_CITY_1111: "दीव",
        STATE_MH_CITY_1112: "दिवेआगर",
        STATE_UP_CITY_1113: "दिवरसाई",
        STATE_KA_CITY_1114: "दोड बल्लापूर",
        STATE_JK_CITY_1115: "दोडा",
        STATE_GJ_CITY_1116: "दोहाड",
        STATE_UP_CITY_1117: "दोहरीघाट",
        STATE_UT_CITY_1118: "डोईवाला",
        STATE_UP_CITY_1119: "डोमरियागंज",
        STATE_MH_CITY_1120: "डोंबिवली",
        STATE_WB_CITY_1121: "डोमजूर",
        STATE_MH_CITY_1122: "दोंडाईचा",
        STATE_CT_CITY_1123: "डोंगरगाव",
        STATE_CT_CITY_1124: "डोंगरगड",
        STATE_MH_CITY_1125: "डोंगरी",
        STATE_PB_CITY_1126: "दोराहा",
        STATE_TG_CITY_1127: "दोर्नकाल",
        STATE_UP_CITY_1128: "दोस्तपूर",
        STATE_WB_CITY_1129: "दुबराजपूर",
        STATE_MH_CITY_1130: "दुधनी",
        STATE_UP_CITY_1131: "दुधी",
        STATE_UT_CITY_1132: "दुगड्डा",
        STATE_JH_CITY_1133: "दुगडा",
        STATE_AS_CITY_1134: "दुलियागाव",
        STATE_AS_CITY_1135: "डम ड्यूमा",
        STATE_JH_CITY_1136: "दुमका",
        STATE_GJ_CITY_1137: "दुमखल",
        STATE_BR_CITY_1138: "डुमरा",
        STATE_BR_CITY_1139: "डुमराव",
        STATE_GJ_CITY_1140: "डुंगरपूर",
        STATE_RJ_CITY_1141: "डुंगरपूर",
        STATE_CT_CITY_1142: "दुर्ग",
        STATE_MH_CITY_1143: "दुर्गापूर",
        STATE_WB_CITY_1144: "दुर्गापूर",
        STATE_MH_CITY_1145: "दुर्गापूर, चंद्रपूर",
        STATE_TN_CITY_1146: "दुसी",
        STATE_UT_CITY_1147: "द्वारहाट",
        STATE_GJ_CITY_1148: "द्वारका",
        STATE_DL_CITY_1149: "पूर्व दिल्ली",
        STATE_SK_CITY_1150: "पूर्व जिल्हा",
        STATE_ML_CITY_1151: "पूर्व गारो हिल्स",
        STATE_AP_CITY_1152: "पूर्व गोदावरी",
        STATE_ML_CITY_1153: "पूर्व जैंतिया टेकड्या",
        STATE_AR_CITY_1154: "पूर्व Kameng",
        STATE_ML_CITY_1155: "पूर्व खासी टेकड्या",
        STATE_AR_CITY_1156: "पूर्व सियांग",
        STATE_KL_CITY_1157: "एडक्कुलम",
        STATE_WB_CITY_1158: "इग्रा",
        STATE_AP_CITY_1159: "एलामंचिली",
        STATE_TN_CITY_1160: "इलायिरंपण्णई",
        STATE_HR_CITY_1161: "एलेनाबाद",
        STATE_AP_CITY_1162: "एलोर",
        STATE_TN_CITY_1163: "एलुमलाई",
        STATE_KL_CITY_1164: "एलुर",
        STATE_AP_CITY_1165: "एमिगनूर",
        STATE_TN_CITY_1166: "इरल",
        STATE_MH_CITY_1167: "एरंडोल",
        STATE_TN_CITY_1168: "एरनिएल",
        STATE_KL_CITY_1169: "एरट्टुपेट्टा",
        STATE_KL_CITY_1170: "एर्नाकुलम",
        STATE_TN_CITY_1171: "इरोड",
        STATE_AP_CITY_1172: "इरागुंटला",
        STATE_TN_CITY_1173: "इरुमाइप्पट्टी",
        STATE_UP_CITY_1174: "एटा",
        STATE_MP_CITY_1175: "इटावा",
        STATE_UP_CITY_1176: "इटावा",
        STATE_AP_CITY_1177: "एटिकोपका",
        STATE_UP_CITY_1178: "एतमादपूर",
        STATE_TN_CITY_1179: "इत्तैयापुरम",
        STATE_UP_CITY_1180: "फैजाबाद",
        STATE_MH_CITY_1181: "फैजपूर",
        STATE_WB_CITY_1182: "फलकता",
        STATE_UP_CITY_1183: "फराह",
        STATE_WB_CITY_1184: "फरक्का",
        STATE_HR_CITY_1185: "फरीदाबाद",
        STATE_HR_CITY_1186: "फरिदाबाद जिल्हा",
        STATE_PB_CITY_1187: "फरीदकोट",
        STATE_UP_CITY_1188: "फरीदनगर",
        STATE_UP_CITY_1189: "फरीदपूर",
        STATE_UP_CITY_1190: "फारुखाबाद",
        STATE_HR_CITY_1191: "फारुखनगर",
        STATE_TG_CITY_1192: "फारुखनगर",
        STATE_UP_CITY_1193: "फतेहाबाद",
        STATE_HR_CITY_1194: "फतेहाबाद",
        STATE_HR_CITY_1195: "फतेहाबाद जिल्हा",
        STATE_UP_CITY_1196: "फतेहगंज पश्चिम",
        STATE_UP_CITY_1197: "फतेहगड",
        STATE_PB_CITY_1198: "फतेहगड चुरियन",
        STATE_PB_CITY_1199: "फतेहगढ साहिब",
        STATE_RJ_CITY_1200: "फतेहपूर",
        STATE_UP_CITY_1201: "फतेहपूर",
        STATE_UP_CITY_1202: "फतेहपूर (बाराबंकी)",
        STATE_UP_CITY_1203: "फतेहपूर चौरासी",
        STATE_UP_CITY_1204: "फतेहपूर सिक्री",
        STATE_BR_CITY_1205: "फतवा",
        STATE_PB_CITY_1206: "फाजिल्का",
        STATE_KL_CITY_1207: "फेरोख",
        STATE_UP_CITY_1208: "फिरोजाबाद",
        STATE_PB_CITY_1209: "फिरोजपूर",
        STATE_PB_CITY_1210: "फिरोजपूर जिल्हा",
        STATE_HR_CITY_1211: "फिरोजपूर झिरका",
        STATE_BR_CITY_1212: "फोर्ब्सगंज",
        STATE_MH_CITY_1213: "किल्ला",
        STATE_WB_CITY_1214: "फोर्ट ग्लोस्टर",
        STATE_KA_CITY_1215: "फ्रेंच रॉक्स",
        STATE_UP_CITY_1216: "फैजाबाद",
        STATE_KA_CITY_1217: "गदग",
        STATE_KA_CITY_1218: "गदग-बेतागेरी",
        STATE_MP_CITY_1219: "गदरवारा",
        STATE_MH_CITY_1220: "गडचिरोली",
        STATE_TG_CITY_1221: "गड्डी अण्णाराम",
        STATE_GJ_CITY_1222: "गधडा",
        STATE_MH_CITY_1223: "गडहिंग्लज",
        STATE_TG_CITY_1224: "गडवाल",
        STATE_HP_CITY_1225: "गॅग्रेट",
        STATE_UP_CITY_1226: "गहलों",
        STATE_UP_CITY_1227: "गहमर",
        STATE_WB_CITY_1228: "गायघाटा समाज विकास गट",
        STATE_UP_CITY_1229: "गयनी",
        STATE_WB_CITY_1230: "गैरकाटा",
        STATE_OR_CITY_1231: "गजपती",
        STATE_KA_CITY_1232: "गजेंद्रगड",
        STATE_UP_CITY_1233: "गजरौला",
        STATE_AP_CITY_1234: "गजुवाका",
        STATE_RJ_CITY_1235: "गालियाकोट",
        STATE_CT_CITY_1236: "गंडई",
        STATE_JK_CITY_1237: "गंदरबल",
        STATE_JK_CITY_1238: "गांदरबल",
        STATE_GJ_CITY_1239: "गाणदेवी",
        STATE_TN_CITY_1240: "गांधी नगर",
        STATE_GJ_CITY_1241: "गांधीधाम",
        STATE_GJ_CITY_1242: "गांधीनगर",
        STATE_WB_CITY_1243: "गंगाधरपूर",
        STATE_TN_CITY_1244: "गंगाईकोंडन",
        STATE_MH_CITY_1245: "गंगाखेर",
        STATE_RJ_CITY_1246: "गंगानगर",
        STATE_RJ_CITY_1247: "गाणगापूर",
        STATE_MH_CITY_1248: "गाणगापूर",
        STATE_WB_CITY_1249: "गंगारामपूर",
        STATE_TN_CITY_1250: "गंगावल्ली",
        STATE_KA_CITY_1251: "गंगावती",
        STATE_UP_CITY_1252: "गंगोह",
        STATE_KA_CITY_1253: "गंगोळी",
        STATE_SK_CITY_1254: "गंगटोक",
        STATE_AP_CITY_1255: "गंगुवडा",
        STATE_UP_CITY_1256: "गंज दुंदावरा",
        STATE_UP_CITY_1257: "गंज दुंडवारा",
        STATE_UP_CITY_1258: "गंज मुरादाबाद",
        STATE_OR_CITY_1259: "गंजम",
        STATE_AP_CITY_1260: "गन्नावरम",
        STATE_MH_CITY_1261: "गणपतीपुळे",
        STATE_UP_CITY_1262: "गरौठा",
        STATE_PB_CITY_1263: "गार्डीवाला",
        STATE_MP_CITY_1264: "गर्हा ब्राह्मण",
        STATE_MP_CITY_1265: "गरकोटा",
        STATE_UP_CITY_1266: "गढी पुख्ता",
        STATE_UP_CITY_1267: "गढमुक्तसर",
        STATE_PB_CITY_1268: "गडशंकर",
        STATE_JH_CITY_1269: "गढवा",
        STATE_UP_CITY_1270: "गढवा",
        STATE_UT_CITY_1271: "गढवाल",
        STATE_CT_CITY_1272: "गारीबंद",
        STATE_GJ_CITY_1273: "गारीधर",
        STATE_WB_CITY_1274: "गरूई",
        STATE_WB_CITY_1275: "गारुलिया",
        STATE_CT_CITY_1276: "गौरेला",
        STATE_UP_CITY_1277: "गौरीगंज",
        STATE_AS_CITY_1278: "गौरीपूर",
        STATE_UP_CITY_1279: "गौतम बुद्ध नगर",
        STATE_MP_CITY_1280: "गौतमपुरा",
        STATE_UP_CITY_1281: "गव्हाण",
        STATE_BR_CITY_1282: "गया",
        STATE_MH_CITY_1283: "गेवराई",
        STATE_PB_CITY_1284: "घनौर",
        STATE_MP_CITY_1285: "घनसोर",
        STATE_HR_CITY_1286: "घारौंडा",
        STATE_MH_CITY_1287: "घारगाव",
        STATE_CT_CITY_1288: "घरघोडा",
        STATE_WB_CITY_1289: "घाटाळ",
        STATE_UP_CITY_1290: "घाटमपूर",
        STATE_MH_CITY_1291: "घाटंजी",
        STATE_TG_CITY_1292: "घाटकेसर",
        STATE_MH_CITY_1293: "घाटकोपर",
        STATE_JH_CITY_1294: "घाटशिला",
        STATE_UP_CITY_1295: "गाझियाबाद",
        STATE_UP_CITY_1296: "गाझीपूर",
        STATE_UP_CITY_1297: "घिरोर",
        STATE_JK_CITY_1298: "घो ब्राह्मणन दे",
        STATE_GJ_CITY_1299: "घोडासर",
        STATE_BR_CITY_1300: "घोगा",
        STATE_GJ_CITY_1301: "घोघा",
        STATE_UP_CITY_1302: "घोरवळ",
        STATE_UP_CITY_1303: "घोसी",
        STATE_MH_CITY_1304: "घोटी बुद्रुक",
        STATE_MH_CITY_1305: "घुग्गुस",
        STATE_HP_CITY_1306: "घुमारविन",
        STATE_CT_CITY_1307: "गिदम",
        STATE_AP_CITY_1308: "गिद्दलूर",
        STATE_PB_CITY_1309: "गिद्दरबाहा",
        STATE_TN_CITY_1310: "जिन्जी",
        STATE_GJ_CITY_1311: "गीर सोमनाथ",
        STATE_MH_CITY_1312: "गिरगाव",
        STATE_WB_CITY_1313: "गिर्या",
        STATE_JH_CITY_1314: "गिरिडीह",
        STATE_GA_CITY_1315: "गोवा वेल्हा",
        STATE_AS_CITY_1316: "गोलपारा",
        STATE_WB_CITY_1317: "गोबरडंगा",
        STATE_TN_CITY_1318: "गोबिचेट्टीपलयम",
        STATE_WB_CITY_1319: "गोविंदापूर",
        STATE_JH_CITY_1320: "गोबिंदपूर",
        STATE_JH_CITY_1321: "गोड्डा",
        STATE_GJ_CITY_1322: "गोध्रा",
        STATE_MP_CITY_1323: "गोगापूर",
        STATE_MP_CITY_1324: "गोहाडी",
        STATE_HR_CITY_1325: "गोहाना",
        STATE_UP_CITY_1326: "गोहंड",
        STATE_AS_CITY_1327: "गोहपूर",
        STATE_KA_CITY_1328: "गोकाक",
        STATE_KA_CITY_1329: "गोकर्ण",
        STATE_AP_CITY_1330: "गोकावरम",
        STATE_UP_CITY_1331: "गोकुळ",
        STATE_UP_CITY_1332: "गोळा बाजार",
        STATE_UP_CITY_1333: "गोळा गोकरनाथ",
        STATE_AS_CITY_1334: "गोलाघाट",
        STATE_AS_CITY_1335: "गोलकगंज",
        STATE_TR_CITY_1336: "गोमती",
        STATE_JH_CITY_1337: "गोमोह",
        STATE_UP_CITY_1338: "गोंडा",
        STATE_UP_CITY_1339: "गोंडा (अलिगड)",
        STATE_UP_CITY_1340: "गोंडा शहर",
        STATE_GJ_CITY_1341: "गोंडल",
        STATE_MH_CITY_1342: "गोंदिया",
        STATE_MH_CITY_1343: "गोंदिया",
        STATE_BR_CITY_1344: "गोपालगंज",
        STATE_OR_CITY_1345: "गोपाळपूर",
        STATE_WB_CITY_1346: "गोपाळपूर",
        STATE_TG_CITY_1347: "गोपालूर",
        STATE_UP_CITY_1348: "गोपमाळ",
        STATE_JH_CITY_1349: "गोपीनाथपूर",
        STATE_WB_CITY_1350: "गोपीनाथपूर",
        STATE_MH_CITY_1351: "गोराई",
        STATE_HR_CITY_1352: "गोरखपूर",
        STATE_UP_CITY_1353: "गोरखपूर",
        STATE_AP_CITY_1354: "गोरंटला",
        STATE_MH_CITY_1355: "गोरेगाव",
        STATE_KA_CITY_1356: "गोरीबिदनूर",
        STATE_WB_CITY_1357: "गोरुबथन",
        STATE_KA_CITY_1358: "गोरूर",
        STATE_GJ_CITY_1359: "गोरवा",
        STATE_WB_CITY_1360: "गोसाबा",
        STATE_UP_CITY_1361: "गोसाईगंज",
        STATE_WB_CITY_1362: "गोसाणिमारी",
        STATE_UP_CITY_1363: "गोशाईगंज",
        STATE_AS_CITY_1364: "गोशाईगाव",
        STATE_UP_CITY_1365: "गोवर्धन",
        STATE_AP_CITY_1366: "गोविंदापुरम, चिलाकालुरीपेट, गुंटूर",
        STATE_MP_CITY_1367: "गोविंदगड",
        STATE_RJ_CITY_1368: "गोविंदगड",
        STATE_UP_CITY_1369: "ग्रेटर नोएडा",
        STATE_JH_CITY_1370: "गुआ",
        STATE_KA_CITY_1371: "गुब्बी",
        STATE_TN_CITY_1372: "गुडलूर",
        STATE_OR_CITY_1373: "गुडारी",
        STATE_KA_CITY_1374: "गुढीबंद",
        STATE_AP_CITY_1375: "गुढीवडा",
        STATE_TN_CITY_1376: "गुडियाथम",
        STATE_AP_CITY_1377: "गुडलावल्लेरू",
        STATE_AP_CITY_1378: "गुडूर",
        STATE_TG_CITY_1379: "गुडूर",
        STATE_TN_CITY_1380: "गुडुवनचेरी",
        STATE_MH_CITY_1381: "गुहागर",
        STATE_GA_CITY_1382: "गुरीम",
        STATE_RJ_CITY_1383: "गुलाबपुरा",
        STATE_UP_CITY_1384: "गुलाओठी",
        STATE_KA_CITY_1385: "गुलबर्गा",
        STATE_KA_CITY_1386: "गुलेदगुड्डा",
        STATE_JH_CITY_1387: "गुमिया",
        STATE_JH_CITY_1388: "गुमला",
        STATE_TN_CITY_1389: "गुम्मीदिपुंडी",
        STATE_MP_CITY_1390: "गुण",
        STATE_KA_CITY_1391: "गुंडलुपेत",
        STATE_UP_CITY_1392: "गुन्नौर",
        STATE_AP_CITY_1393: "गुंटकल जंक्शन",
        STATE_AP_CITY_1394: "गुंटूर",
        STATE_OR_CITY_1395: "गुणुपूर",
        STATE_WB_CITY_1396: "गुरदहा",
        STATE_PB_CITY_1397: "गुरुदासपूर",
        STATE_HR_CITY_1398: "गुडगाव",
        STATE_MP_CITY_1399: "गुऱ्हा",
        STATE_KA_CITY_1400: "गुरुमतकल",
        STATE_UP_CITY_1401: "गुरसहायगंज",
        STATE_UP_CITY_1402: "गुरसराय",
        STATE_PB_CITY_1403: "गुरु हर सहाय",
        STATE_KL_CITY_1404: "गुरुवायूर",
        STATE_WB_CITY_1405: "गुसखारा",
        STATE_AS_CITY_1406: "गुवाहाटी",
        STATE_MP_CITY_1407: "ग्वाल्हेर",
        STATE_SK_CITY_1408: "ग्यालशिंग",
        STATE_UP_CITY_1409: "ज्ञानपूर",
        STATE_WB_CITY_1410: "हबरा",
        STATE_KA_CITY_1411: "हडगल्ली",
        STATE_MH_CITY_1412: "हडपसर, पुणे",
        STATE_MH_CITY_1413: "हदगाव",
        STATE_AS_CITY_1414: "हाफलाँग",
        STATE_AS_CITY_1415: "हायलाकांडी",
        STATE_JK_CITY_1416: "हजन",
        STATE_PB_CITY_1417: "हाजीपूर",
        STATE_BR_CITY_1418: "हाजीपूर",
        STATE_AS_CITY_1419: "हाजो",
        STATE_UP_CITY_1420: "हलदौर",
        STATE_WB_CITY_1421: "हल्दिया",
        STATE_WB_CITY_1422: "हळदीबारी",
        STATE_UT_CITY_1423: "हल्दवानी",
        STATE_GJ_CITY_1424: "हलेंडा",
        STATE_WB_CITY_1425: "हलीसहर",
        STATE_KA_CITY_1426: "हलियाल",
        STATE_MH_CITY_1427: "हलकर्णी",
        STATE_GJ_CITY_1428: "हालोल",
        STATE_GJ_CITY_1429: "हलवड",
        STATE_UP_CITY_1430: "हमीरपूर",
        STATE_HP_CITY_1431: "हमीरपूर",
        STATE_KA_CITY_1432: "हंपी",
        STATE_UP_CITY_1433: "हंडिया",
        STATE_KA_CITY_1434: "हंगल",
        STATE_HR_CITY_1435: "हांसी",
        STATE_GJ_CITY_1436: "हंसोट",
        STATE_RJ_CITY_1437: "हनुमानगड",
        STATE_UP_CITY_1438: "हापूर",
        STATE_UP_CITY_1439: "हरायपूर",
        STATE_UP_CITY_1440: "हरैया",
        STATE_MH_CITY_1441: "हरंगुल",
        STATE_UT_CITY_1442: "हरबतपूर",
        STATE_UP_CITY_1443: "हरचंदपूर",
        STATE_MP_CITY_1444: "हरडा",
        STATE_MP_CITY_1445: "हरदा खस",
        STATE_UP_CITY_1446: "हरदोई",
        STATE_UP_CITY_1447: "हरदुआगंज",
        STATE_PB_CITY_1448: "हरियाणा",
        STATE_UT_CITY_1449: "हरिद्वार",
        STATE_KA_CITY_1450: "हरिहर",
        STATE_GJ_CITY_1451: "हरिज",
        STATE_WB_CITY_1452: "हरिंदंगा",
        STATE_WB_CITY_1453: "हरिंघटा",
        STATE_WB_CITY_1454: "हरिपूर",
        STATE_MH_CITY_1455: "हर्णै",
        STATE_MP_CITY_1456: "हरपालपूर",
        STATE_KA_CITY_1457: "हरपनहल्ली",
        STATE_MP_CITY_1458: "हरराई",
        STATE_GJ_CITY_1459: "हरसोल",
        STATE_MP_CITY_1460: "हरसूद",
        STATE_TN_CITY_1461: "हरुर",
        STATE_HR_CITY_1462: "हसनपूर",
        STATE_UP_CITY_1463: "हसनपूर",
        STATE_WB_CITY_1464: "हसिमारा",
        STATE_KA_CITY_1465: "हसन",
        STATE_UP_CITY_1466: "हस्तिनापूर",
        STATE_UP_CITY_1467: "हाता",
        STATE_UP_CITY_1468: "हाता (भारत)",
        STATE_UP_CITY_1469: "हातरस",
        STATE_GJ_CITY_1470: "हथुरन",
        STATE_MP_CITY_1471: "हातोड",
        STATE_MP_CITY_1472: "हट्टा",
        STATE_KA_CITY_1473: "हावेरी",
        STATE_AR_CITY_1474: "हायुलियांग",
        STATE_JH_CITY_1475: "हजारीबाग",
        STATE_JH_CITY_1476: "हजारीबाग",
        STATE_KA_CITY_1477: "हेग्गडदेवंकोटे",
        STATE_MH_CITY_1478: "हेलवाक",
        STATE_JH_CITY_1479: "हेसला",
        STATE_BR_CITY_1480: "हिल्सा",
        STATE_GJ_CITY_1481: "हिमतनगर",
        STATE_RJ_CITY_1482: "हिंडौन",
        STATE_MP_CITY_1483: "हिंदोरिया",
        STATE_AP_CITY_1484: "हिंदुपूर",
        STATE_WB_CITY_1485: "हिंदुस्थान केबल्स टाऊन",
        STATE_MH_CITY_1486: "हिंगणघाट",
        STATE_MH_CITY_1487: "हिंगोली",
        STATE_OR_CITY_1488: "हिंजिलकाटू",
        STATE_OR_CITY_1489: "हिराकुड",
        STATE_JK_CITY_1490: "हिरानगर",
        STATE_MH_CITY_1491: "हिरापूर",
        STATE_MH_CITY_1492: "हिरापूर हमेशा",
        STATE_KA_CITY_1493: "हिरेकरूर",
        STATE_KA_CITY_1494: "हिरीयुर",
        STATE_HR_CITY_1495: "हिसार",
        STATE_BR_CITY_1496: "हिसुआ",
        STATE_HR_CITY_1497: "होडल",
        STATE_AS_CITY_1498: "होजाई",
        STATE_KA_CITY_1499: "होलालकेरे",
        STATE_KA_CITY_1500: "होल नरसीपूर",
        STATE_KA_CITY_1501: "होमनाबाद",
        STATE_KA_CITY_1502: "होनावर",
        STATE_KA_CITY_1503: "होन्नाली",
        STATE_WB_CITY_1504: "हुगळी जिल्हा",
        STATE_KA_CITY_1505: "होसनगारा",
        STATE_KA_CITY_1506: "होसांगडी",
        STATE_KA_CITY_1507: "होसदुर्गा",
        STATE_MP_CITY_1508: "होशंगाबाद",
        STATE_PB_CITY_1509: "होशियारपूर",
        STATE_KA_CITY_1510: "होस्कोटे",
        STATE_KA_CITY_1511: "हॉस्पेट",
        STATE_TN_CITY_1512: "होसूर",
        STATE_MH_CITY_1513: "होटगी",
        STATE_AS_CITY_1514: "होळी",
        STATE_WB_CITY_1515: "हावडा",
        STATE_KA_CITY_1516: "हुबळी",
        STATE_KA_CITY_1517: "हुकेरी",
        STATE_UP_CITY_1518: "हुलास",
        STATE_KA_CITY_1519: "हुंगुंड",
        STATE_KA_CITY_1520: "हुन्सूर",
        STATE_JH_CITY_1521: "हुसेनाबाद",
        STATE_TG_CITY_1522: "हैदराबाद",
        STATE_MP_CITY_1523: "आयवर",
        STATE_UP_CITY_1524: "इब्राहिमपूर",
        STATE_MH_CITY_1525: "इचलकरंजी",
        STATE_WB_CITY_1526: "इच्छापूर",
        STATE_AP_CITY_1527: "इच्छापुरम",
        STATE_MP_CITY_1528: "इच्छावार",
        STATE_TN_CITY_1529: "इडप्पाडी",
        STATE_GJ_CITY_1530: "इडर",
        STATE_KL_CITY_1531: "इडुक्की",
        STATE_MH_CITY_1532: "इगतपुरी",
        STATE_UP_CITY_1533: "इग्लास",
        STATE_UP_CITY_1534: "इकाउना",
        STATE_MP_CITY_1535: "इकलेहरा",
        STATE_TN_CITY_1536: "इलाम्पिल्लई",
        STATE_KA_CITY_1537: "इल्कल",
        STATE_TN_CITY_1538: "इलुपूर",
        STATE_MN_CITY_1539: "इंफाळ",
        STATE_HR_CITY_1540: "इंदा छोई",
        STATE_MH_CITY_1541: "इंदापूर",
        STATE_UP_CITY_1542: "इंदरगड",
        STATE_KA_CITY_1543: "इंडी",
        STATE_MP_CITY_1544: "इंदूर",
        STATE_WB_CITY_1545: "इंदपूर कम्युनिटी डेव्हलपमेंट ब्लॉक",
        STATE_UP_CITY_1546: "इंद्रगड",
        STATE_HR_CITY_1547: "इंद्री",
        STATE_WB_CITY_1548: "इंग्रज बाजार",
        STATE_TN_CITY_1549: "इंजंबक्कम",
        STATE_KL_CITY_1550: "इरिंगल",
        STATE_KL_CITY_1551: "इरिंजलकुडा",
        STATE_TN_CITY_1552: "इरुगुर",
        STATE_MP_CITY_1553: "इसागढ",
        STATE_PB_CITY_1554: "इशनपूर",
        STATE_UP_CITY_1555: "इस्लामनगर",
        STATE_UP_CITY_1556: "इस्लामनगर (बदाऊन)",
        STATE_BR_CITY_1557: "इस्लामपूर",
        STATE_WB_CITY_1558: "इस्लामपूर",
        STATE_AR_CITY_1559: "इटानगर",
        STATE_MP_CITY_1560: "इटारसी",
        STATE_UP_CITY_1561: "इटौंजा",
        STATE_UP_CITY_1562: "इतिमादपूर",
        STATE_MP_CITY_1563: "जबलपूर",
        STATE_WB_CITY_1564: "जाफरपूर",
        STATE_HR_CITY_1565: "जगाधरी",
        STATE_KA_CITY_1566: "जगलूर",
        STATE_JH_CITY_1567: "जगन्नाथपूर",
        STATE_OR_CITY_1568: "जगतसिंगपूर",
        STATE_OR_CITY_1569: "जगतसिंगपूर",
        STATE_CT_CITY_1570: "जगदलपूर",
        STATE_UP_CITY_1571: "जगदीशपूर",
        STATE_BR_CITY_1572: "जगदीसपूर",
        STATE_AP_CITY_1573: "जगगय्यपेटा",
        STATE_UP_CITY_1574: "जगनाईर",
        STATE_PB_CITY_1575: "जगरांव",
        STATE_TG_CITY_1576: "जगत्याल",
        STATE_UP_CITY_1577: "जहानाबाद",
        STATE_BR_CITY_1578: "जहानाबाद",
        STATE_UP_CITY_1579: "जहानाबाद (पीलीभीत)",
        STATE_UP_CITY_1580: "जहांगीराबाद",
        STATE_UP_CITY_1581: "जहांगीरपूर",
        STATE_RJ_CITY_1582: "जहाजपूर",
        STATE_WB_CITY_1583: "जायगाव",
        STATE_UP_CITY_1584: "जैनपूर",
        STATE_RJ_CITY_1585: "जयपूर",
        STATE_UP_CITY_1586: "जैस",
        STATE_RJ_CITY_1587: "जैसलमेर",
        STATE_MP_CITY_1588: "जयसिंगनगर",
        STATE_MH_CITY_1589: "जयसिंगपूर",
        STATE_MH_CITY_1590: "जैतापूर",
        STATE_RJ_CITY_1591: "जैतरण",
        STATE_MP_CITY_1592: "जैथरी",
        STATE_PB_CITY_1593: "जैतो",
        STATE_OR_CITY_1594: "जाजपूर",
        STATE_HR_CITY_1595: "जाखल",
        STATE_MH_CITY_1596: "जखणगाव",
        STATE_GJ_CITY_1597: "जाखळ",
        STATE_TN_CITY_1598: "जलकंदापुरम",
        STATE_UP_CITY_1599: "जलालाबाद",
        STATE_PB_CITY_1600: "जलालाबाद",
        STATE_UP_CITY_1601: "जलाली",
        STATE_GJ_CITY_1602: "जलालपूर",
        STATE_GJ_CITY_1603: "जलालपूर",
        STATE_UP_CITY_1604: "जलालपूर",
        STATE_PB_CITY_1605: "जालंधर",
        STATE_TN_CITY_1606: "जलरपेठ",
        STATE_UP_CITY_1607: "जालौन",
        STATE_UP_CITY_1608: "जळेसर",
        STATE_OR_CITY_1609: "जलेश्वर",
        STATE_MH_CITY_1610: "जळगाव",
        STATE_MH_CITY_1611: "जळगाव जामोद",
        STATE_GJ_CITY_1612: "जालिया",
        STATE_MH_CITY_1613: "जळकोट",
        STATE_MH_CITY_1614: "जालना",
        STATE_RJ_CITY_1615: "जालोर",
        STATE_RJ_CITY_1616: "जालोरे",
        STATE_WB_CITY_1617: "जलपाईगुडी",
        STATE_JH_CITY_1618: "जमडोबा",
        STATE_MP_CITY_1619: "जमई",
        STATE_BR_CITY_1620: "जमालपूर",
        STATE_GJ_CITY_1621: "जंबुडा",
        STATE_GJ_CITY_1622: "जंबुसर",
        STATE_KA_CITY_1623: "जमखंडी",
        STATE_MH_CITY_1624: "जामखेड",
        STATE_AP_CITY_1625: "जमलमदुगु",
        STATE_JK_CITY_1626: "जम्मू",
        STATE_GJ_CITY_1627: "जामनगर",
        STATE_MH_CITY_1628: "जामोद",
        STATE_JH_CITY_1629: "जमशेदपूर",
        STATE_JH_CITY_1630: "जामतारा",
        STATE_BR_CITY_1631: "जमुई",
        STATE_WB_CITY_1632: "जमुरिया",
        STATE_PB_CITY_1633: "जंदियाळा",
        STATE_PB_CITY_1634: "जंदियाला गुरु",
        STATE_MH_CITY_1635: "जानेफळ",
        STATE_TG_CITY_1636: "जानगाव",
        STATE_UP_CITY_1637: "जंघाई",
        STATE_WB_CITY_1638: "जंगीपूर",
        STATE_TG_CITY_1639: "जंगोआन",
        STATE_CT_CITY_1640: "जंजगीर",
        STATE_CT_CITY_1641: "जंजगीर-चांपा",
        STATE_UP_CITY_1642: "जनसाठ",
        STATE_MH_CITY_1643: "जाओली",
        STATE_MP_CITY_1644: "जाओरा",
        STATE_GJ_CITY_1645: "जरोड,",
        STATE_UP_CITY_1646: "जारवा",
        STATE_UP_CITY_1647: "जारवाल",
        STATE_GJ_CITY_1648: "जसदण",
        STATE_CT_CITY_1649: "जशपूर",
        STATE_CT_CITY_1650: "जशपूरनगर",
        STATE_JH_CITY_1651: "जसिदिह",
        STATE_UT_CITY_1652: "जसपूर",
        STATE_UP_CITY_1653: "जसराणा",
        STATE_UP_CITY_1654: "जसवंतनगर",
        STATE_MH_CITY_1655: "जत, सांगली",
        STATE_OR_CITY_1656: "जटाणी",
        STATE_MP_CITY_1657: "जटारा",
        STATE_MH_CITY_1658: "जातेगाव",
        STATE_UP_CITY_1659: "जौनपूर",
        STATE_JK_CITY_1660: "जौरियन",
        STATE_MP_CITY_1661: "जवाद",
        STATE_HP_CITY_1662: "जावळ मुखी",
        STATE_MH_CITY_1663: "जव्हार",
        STATE_TN_CITY_1664: "जयमकोंडाचोलापुरम",
        STATE_TG_CITY_1665: "जयशंकर भूपालपल्ली",
        STATE_BR_CITY_1666: "जयनगर",
        STATE_WB_CITY_1667: "जयनगर मजिलपूर",
        STATE_MH_CITY_1668: "जयसिंगपूर",
        STATE_BR_CITY_1669: "जेहानाबाद",
        STATE_WB_CITY_1670: "जेजुर",
        STATE_MH_CITY_1671: "जेजुरी",
        STATE_GJ_CITY_1672: "जेतलपूर",
        STATE_GJ_CITY_1673: "जेतलसर",
        STATE_GJ_CITY_1674: "जेतपूर",
        STATE_GJ_CITY_1675: "जेतपूर (नवगढ)",
        STATE_KA_CITY_1676: "जेवर्गी",
        STATE_UP_CITY_1677: "जेवर",
        STATE_OR_CITY_1678: "जेपोर",
        STATE_BR_CITY_1679: "झा-झा",
        STATE_MP_CITY_1680: "झाबुआ",
        STATE_UP_CITY_1681: "झाझर",
        STATE_HR_CITY_1682: "झज्जर",
        STATE_RJ_CITY_1683: "झालावार",
        STATE_WB_CITY_1684: "झालिदा",
        STATE_GJ_CITY_1685: "झालोद",
        STATE_RJ_CITY_1686: "झालरापाटन",
        STATE_UP_CITY_1687: "झालू",
        STATE_BR_CITY_1688: "झांझारपूर",
        STATE_UP_CITY_1689: "झाशी",
        STATE_WB_CITY_1690: "झारग्राम",
        STATE_JH_CITY_1691: "झरिया",
        STATE_OR_CITY_1692: "झारसुगुडा",
        STATE_OR_CITY_1693: "झारसुगुडा जिल्हा",
        STATE_WB_CITY_1694: "झिलीमिली",
        STATE_UP_CITY_1695: "झिंझाक",
        STATE_UP_CITY_1696: "झिंझाना",
        STATE_GJ_CITY_1697: "झुलासन",
        STATE_RJ_CITY_1698: "झुंझुनुन",
        STATE_UP_CITY_1699: "झुशी",
        STATE_HR_CITY_1700: "जिंद",
        STATE_MH_CITY_1701: "जिंतूर",
        STATE_MP_CITY_1702: "जिरान",
        STATE_UP_CITY_1703: "जियानपूर",
        STATE_MP_CITY_1704: "जॉबट",
        STATE_RJ_CITY_1705: "जॉबनर",
        STATE_GJ_CITY_1706: "जोधपूर",
        STATE_RJ_CITY_1707: "जोधपूर",
        STATE_GJ_CITY_1708: "जोधपूर (अहमदाबाद)",
        STATE_GJ_CITY_1709: "जोडीया",
        STATE_GJ_CITY_1710: "जोडिया बंदर",
        STATE_BR_CITY_1711: "जोगबाणी",
        STATE_MH_CITY_1712: "जोगेश्वरी",
        STATE_AS_CITY_1713: "जोगीघोपा",
        STATE_HP_CITY_1714: "जोगिंदरनगर",
        STATE_TG_CITY_1715: "जोगुलंबा गडवाल",
        STATE_SK_CITY_1716: "जोरथांग",
        STATE_AS_CITY_1717: "जोरहाट",
        STATE_UT_CITY_1718: "जोशीमठ",
        STATE_GA_CITY_1719: "जुआ",
        STATE_HP_CITY_1720: "जुब्बल",
        STATE_JH_CITY_1721: "जुगसलाय",
        STATE_MH_CITY_1722: "जुहू",
        STATE_JH_CITY_1723: "जुमरी तिलाय्या",
        STATE_GJ_CITY_1724: "जुनागड",
        STATE_CT_CITY_1725: "जुनागढ",
        STATE_MH_CITY_1726: "जुन्नर",
        STATE_HP_CITY_1727: "जुतोघ",
        STATE_UP_CITY_1728: "ज्योतिबा फुले नगर",
        STATE_CT_CITY_1729: "कबीरधाम",
        STATE_UP_CITY_1730: "कबराई",
        STATE_GJ_CITY_1731: "कच्छ",
        STATE_GJ_CITY_1732: "कचोळी",
        STATE_UP_CITY_1733: "कच्छवा",
        STATE_MH_CITY_1734: "कचूरवाही",
        STATE_KL_CITY_1735: "कडाक्कावूर",
        STATE_TN_CITY_1736: "कदंबूर",
        STATE_UP_CITY_1737: "कदौरा",
        STATE_TN_CITY_1738: "कदयनाल्लूर",
        STATE_MH_CITY_1739: "कडेगाव",
        STATE_GJ_CITY_1740: "काडी",
        STATE_UP_CITY_1741: "कादीपूर",
        STATE_AP_CITY_1742: "कादिरी",
        STATE_GJ_CITY_1743: "कदोद",
        STATE_KA_CITY_1744: "कदूर",
        STATE_MH_CITY_1745: "कडूस",
        STATE_MH_CITY_1746: "कागल",
        STATE_UP_CITY_1747: "कागरोल",
        STATE_TG_CITY_1748: "कागदनगर",
        STATE_MH_CITY_1749: "कैज",
        STATE_AP_CITY_1750: "कैकलूर",
        STATE_MP_CITY_1751: "कैलारस",
        STATE_TR_CITY_1752: "कैलाशहर",
        STATE_UP_CITY_1753: "कैमगंज",
        STATE_MP_CITY_1754: "कैमोरी",
        STATE_BR_CITY_1755: "कैमूर जिल्हा",
        STATE_OR_CITY_1756: "कैंत्रागढ",
        STATE_UP_CITY_1757: "कैराना",
        STATE_HR_CITY_1758: "कैथल",
        STATE_MN_CITY_1759: "ककचिंग",
        STATE_WB_CITY_1760: "काकद्वीप",
        STATE_AP_CITY_1761: "काकीनाडा",
        STATE_UP_CITY_1762: "काकोरी",
        STATE_UP_CITY_1763: "काकराळा",
        STATE_UT_CITY_1764: "काळधुंगी",
        STATE_UT_CITY_1765: "कलागड प्रकल्प कॉलनी",
        STATE_OR_CITY_1766: "कालाहंडी",
        STATE_WB_CITY_1767: "कलाईकुंडा",
        STATE_TN_CITY_1768: "कलक्कडू",
        STATE_KL_CITY_1769: "कलामसेरी",
        STATE_MH_CITY_1770: "कळंब",
        STATE_MH_CITY_1771: "कळंब, उस्मानाबाद",
        STATE_MH_CITY_1772: "कळंबोली",
        STATE_MH_CITY_1773: "कळमनुरी",
        STATE_PB_CITY_1774: "कलानौर",
        STATE_HR_CITY_1775: "कलानौर",
        STATE_HR_CITY_1776: "कालनवली",
        STATE_MH_CITY_1777: "कलस",
        STATE_GJ_CITY_1778: "कलावद",
        STATE_TN_CITY_1779: "कालवई",
        STATE_KL_CITY_1780: "कलावूर",
        STATE_KA_CITY_1781: "कलघटगी",
        STATE_MH_CITY_1782: "काली (डीके)",
        STATE_WB_CITY_1783: "कालियागंज",
        STATE_JH_CITY_1784: "कालिकापूर",
        STATE_WB_CITY_1785: "कालिम्पॉन्ग",
        STATE_UP_CITY_1786: "कालीनगर",
        STATE_HP_CITY_1787: "कालका",
        STATE_TN_CITY_1788: "कल्लक्कुरिची",
        STATE_TN_CITY_1789: "कल्लीडायकुरीची",
        STATE_TN_CITY_1790: "कल्लुपट्टी",
        STATE_MH_CITY_1791: "कळमेश्वर",
        STATE_WB_CITY_1792: "कालना",
        STATE_GJ_CITY_1793: "कलोल",
        STATE_KL_CITY_1794: "कलपत्ता",
        STATE_UP_CITY_1795: "काल्पी",
        STATE_TN_CITY_1796: "कलुगुमलाई",
        STATE_MH_CITY_1797: "काळुंद्री",
        STATE_MH_CITY_1798: "कल्याण",
        STATE_AP_CITY_1799: "कल्याणदुर्ग",
        STATE_WB_CITY_1800: "कल्याणी",
        STATE_MH_CITY_1801: "कल्याणी नगर",
        STATE_UP_CITY_1802: "कल्याणपूर",
        STATE_OR_CITY_1803: "कामाख्यानगर",
        STATE_AP_CITY_1804: "कमलापुरम",
        STATE_UP_CITY_1805: "कमलगंज",
        STATE_TR_CITY_1806: "कमालपूर",
        STATE_RJ_CITY_1807: "कमन",
        STATE_TG_CITY_1808: "कामरेड्डी",
        STATE_TG_CITY_1809: "कामरेड्डी",
        STATE_MH_CITY_1810: "कामरगाव",
        STATE_WB_CITY_1811: "कामरहटी",
        STATE_WB_CITY_1812: "कामरपुकुर",
        STATE_MH_CITY_1813: "कामतगी",
        STATE_UP_CITY_1814: "कंपिल",
        STATE_KA_CITY_1815: "कांपली",
        STATE_MH_CITY_1816: "कॅम्पटी",
        STATE_AS_CITY_1817: "कामरूप",
        STATE_AS_CITY_1818: "कामरूप महानगर",
        STATE_MH_CITY_1819: "कामठी",
        STATE_TN_CITY_1820: "कामुठी",
        STATE_TN_CITY_1821: "कनदुकट्टन",
        STATE_TN_CITY_1822: "कांचीपुरम",
        STATE_TN_CITY_1823: "कांचीपुरम",
        STATE_WB_CITY_1824: "कांचरापारा",
        STATE_OR_CITY_1825: "कंधमाळ",
        STATE_UP_CITY_1826: "कंधला",
        STATE_WB_CITY_1827: "कंदी",
        STATE_GJ_CITY_1828: "कांडला",
        STATE_GJ_CITY_1829: "कांडला बंदर",
        STATE_JH_CITY_1830: "कांद्रा",
        STATE_MH_CITY_1831: "कांद्री",
        STATE_AP_CITY_1832: "कंदुकूर",
        STATE_HP_CITY_1833: "कांगार",
        STATE_TN_CITY_1834: "कांगायम",
        STATE_HP_CITY_1835: "कांगडा",
        STATE_AP_CITY_1836: "कनिगिरी",
        STATE_HR_CITY_1837: "कनिना खस",
        STATE_KA_CITY_1838: "कंकणहल्ली",
        STATE_MH_CITY_1839: "कणकौली",
        STATE_MH_CITY_1840: "कणकवली",
        STATE_JH_CITY_1841: "कणके",
        STATE_CT_CITY_1842: "कांकेर",
        STATE_AP_CITY_1843: "कानकिपाडू",
        STATE_GA_CITY_1844: "काणकोण",
        STATE_MH_CITY_1845: "कन्नड",
        STATE_KL_CITY_1846: "कन्ननगड",
        STATE_UP_CITY_1847: "कन्नौज",
        STATE_KL_CITY_1848: "कन्नवम",
        STATE_TN_CITY_1849: "कन्याकुमारी",
        STATE_MP_CITY_1850: "कन्नोड",
        STATE_KL_CITY_1851: "कन्नूर",
        STATE_GJ_CITY_1852: "कानोदर",
        STATE_RJ_CITY_1853: "कानोर",
        STATE_UP_CITY_1854: "कानपूर",
        STATE_UP_CITY_1855: "कानपूर देहाट",
        STATE_UP_CITY_1856: "कांत",
        STATE_OR_CITY_1857: "कांताबंजी",
        STATE_UP_CITY_1858: "कंठ",
        STATE_OR_CITY_1859: "कंटिलो",
        STATE_AP_CITY_1860: "कानुरू",
        STATE_GJ_CITY_1861: "कपडवंज",
        STATE_RJ_CITY_1862: "कापरेन",
        STATE_UP_CITY_1863: "कप्तानगंज",
        STATE_PB_CITY_1864: "कपूरथळा",
        STATE_UP_CITY_1865: "कारा",
        STATE_MH_CITY_1866: "कराड",
        STATE_PY_CITY_1867: "कराईकल",
        STATE_TN_CITY_1868: "कराइक्कुडी",
        STATE_MH_CITY_1869: "करजगी",
        STATE_TN_CITY_1870: "करमदाई",
        STATE_TN_CITY_1871: "करंबक्कुडी",
        STATE_GJ_CITY_1872: "करमसद",
        STATE_MH_CITY_1873: "कारंजा",
        STATE_MH_CITY_1874: "कारंजा लाड",
        STATE_RJ_CITY_1875: "करणपूर",
        STATE_UP_CITY_1876: "करारी",
        STATE_RJ_CITY_1877: "करौली",
        STATE_AS_CITY_1878: "कार्बी आंगलाँग",
        STATE_UP_CITY_1879: "कर्बिगवान",
        STATE_UP_CITY_1880: "करचना",
        STATE_MP_CITY_1881: "कारली",
        STATE_MP_CITY_1882: "करेरा",
        STATE_LA_CITY_1883: "कारगिल",
        STATE_UP_CITY_1884: "करहाल",
        STATE_GJ_CITY_1885: "करियाना",
        STATE_TN_CITY_1886: "करियापट्टी",
        STATE_AS_CITY_1887: "करीमगंज",
        STATE_TG_CITY_1888: "करीमनगर",
        STATE_WB_CITY_1889: "करीमपूर",
        STATE_GJ_CITY_1890: "कर्जन",
        STATE_MH_CITY_1891: "कर्जत",
        STATE_KA_CITY_1892: "करकला",
        STATE_MH_CITY_1893: "करकंब",
        STATE_MH_CITY_1894: "करमाळा",
        STATE_HR_CITY_1895: "कर्नाल",
        STATE_DL_CITY_1896: "करोल बाग",
        STATE_MP_CITY_1897: "कर्रापूर",
        STATE_PB_CITY_1898: "करतारपूर",
        STATE_TN_CITY_1899: "करुम्बक्कम",
        STATE_TN_CITY_1900: "करूर",
        STATE_KA_CITY_1901: "कारवार",
        STATE_MH_CITY_1902: "कसारा",
        STATE_KL_CITY_1903: "कासारगोड",
        STATE_KL_CITY_1904: "कासारगोड जिल्हा",
        STATE_HP_CITY_1905: "कसौली",
        STATE_BR_CITY_1906: "कसबा",
        STATE_UP_CITY_1907: "कासगंज",
        STATE_UT_CITY_1908: "काशीपूर",
        STATE_MH_CITY_1909: "कासोदा",
        STATE_MP_CITY_1910: "कासरवाड",
        STATE_MP_CITY_1911: "कटंगी",
        STATE_CT_CITY_1912: "कटघोरा",
        STATE_GJ_CITY_1913: "कथोर",
        STATE_JK_CITY_1914: "कठुआ",
        STATE_MH_CITY_1915: "कटी",
        STATE_BR_CITY_1916: "कटिहार",
        STATE_MP_CITY_1917: "कटनी",
        STATE_MH_CITY_1918: "काटोल",
        STATE_TN_CITY_1919: "कातपडी",
        STATE_GJ_CITY_1920: "कातपूर",
        STATE_UP_CITY_1921: "कटरा",
        STATE_JK_CITY_1922: "कटरा",
        STATE_MH_CITY_1923: "कात्रळ",
        STATE_JH_CITY_1924: "कात्रस",
        STATE_KL_CITY_1925: "कट्टणम",
        STATE_TN_CITY_1926: "कत्तिवक्कम",
        STATE_TN_CITY_1927: "कट्टुपुत्तूर",
        STATE_WB_CITY_1928: "कटवा",
        STATE_UP_CITY_1929: "कौसानी",
        STATE_UP_CITY_1930: "कौशांबी जिल्हा",
        STATE_AP_CITY_1931: "कवळी",
        STATE_KA_CITY_1932: "कवलूर",
        STATE_GJ_CITY_1933: "कवंत",
        STATE_LD_CITY_1934: "कावरत्ती",
        STATE_TN_CITY_1935: "कावेरीपट्टणम",
        STATE_GJ_CITY_1936: "कवंत",
        STATE_CT_CITY_1937: "कावर्धा",
        STATE_TN_CITY_1938: "कायलपट्टीनम",
        STATE_KL_CITY_1939: "कायनकुलम",
        STATE_TN_CITY_1940: "कायत्तर",
        STATE_GJ_CITY_1941: "कायवरोहण",
        STATE_TN_CITY_1942: "केलकराय",
        STATE_RJ_CITY_1943: "केकरी",
        STATE_TN_CITY_1944: "केलामंगलम",
        STATE_UP_CITY_1945: "केमरी",
        STATE_WB_CITY_1946: "केंदा",
        STATE_OR_CITY_1947: "केंद्रपारा",
        STATE_OR_CITY_1948: "केंद्रपहा",
        STATE_JH_CITY_1949: "केंदुआडीह",
        STATE_OR_CITY_1950: "केंदुझार",
        STATE_KA_CITY_1951: "केरूर",
        STATE_GJ_CITY_1952: "केरवडा",
        STATE_WB_CITY_1953: "केशबपूर",
        STATE_GJ_CITY_1954: "केशोद",
        STATE_RJ_CITY_1955: "केशोराई पाटण",
        STATE_OR_CITY_1956: "केसिंगा",
        STATE_MP_CITY_1957: "खाचरोड",
        STATE_UP_CITY_1958: "खडा",
        STATE_MH_CITY_1959: "खडकी",
        STATE_UP_CITY_1960: "खगा",
        STATE_BR_CITY_1961: "खगरिया",
        STATE_BR_CITY_1962: "खगौल",
        STATE_MP_CITY_1963: "खैलार",
        STATE_UP_CITY_1964: "खैलार",
        STATE_UP_CITY_1965: "खैर",
        STATE_UP_CITY_1966: "खैराबाद",
        STATE_CT_CITY_1967: "खैरागड",
        STATE_MP_CITY_1968: "खजुराहो स्मारक समूह",
        STATE_MH_CITY_1969: "खालापूर",
        STATE_UP_CITY_1970: "खलीलाबाद",
        STATE_MH_CITY_1971: "खल्लार",
        STATE_OR_CITY_1972: "खल्लीकोट",
        STATE_PB_CITY_1973: "खमणोन",
        STATE_MP_CITY_1974: "खमरिया",
        STATE_GJ_CITY_1975: "खंभालिया",
        STATE_GJ_CITY_1976: "खंभात",
        STATE_MH_CITY_1977: "खामगाव",
        STATE_CT_CITY_1978: "खमहरिया",
        STATE_TG_CITY_1979: "खम्मम",
        STATE_KA_CITY_1980: "खानापूर",
        STATE_MH_CITY_1981: "खानापूर",
        STATE_MH_CITY_1982: "खंडाळा",
        STATE_RJ_CITY_1983: "खंडेला",
        STATE_MP_CITY_1984: "खांडवा",
        STATE_MP_CITY_1985: "खांडवा जिल्हा",
        STATE_MH_CITY_1986: "खानगाव",
        STATE_PB_CITY_1987: "खन्ना",
        STATE_UP_CITY_1988: "खानापूर",
        STATE_RJ_CITY_1989: "खानापूर",
        STATE_MH_CITY_1990: "खापा",
        STATE_BR_CITY_1991: "खरगपूर",
        STATE_WB_CITY_1992: "खरगपूर",
        STATE_MH_CITY_1993: "खारकवासला",
        STATE_PB_CITY_1994: "खरर",
        STATE_WB_CITY_1995: "खरर",
        STATE_WB_CITY_1996: "खरबा",
        STATE_MH_CITY_1997: "खर्डा",
        STATE_WB_CITY_1998: "खर्डा",
        STATE_UP_CITY_1999: "खरेला",
        STATE_MP_CITY_2000: "खरगापूर",
        STATE_MH_CITY_2001: "खारघर",
        STATE_MP_CITY_2002: "खरगोन",
        STATE_UP_CITY_2003: "खरगुपूर",
        STATE_OR_CITY_2004: "खर्‍याल",
        STATE_HR_CITY_2005: "खारखौडा",
        STATE_UP_CITY_2006: "खारखौडा",
        STATE_CT_CITY_2007: "खारोद",
        STATE_JH_CITY_2008: "खरसावन",
        STATE_CT_CITY_2009: "खरसिया",
        STATE_MH_CITY_2010: "खरसुंडी",
        STATE_AS_CITY_2011: "खारुपाट्या",
        STATE_UP_CITY_2012: "खतौली",
        STATE_MP_CITY_2013: "खाटेगाव",
        STATE_UT_CITY_2014: "खातीमा",
        STATE_WB_CITY_2015: "खत्रा",
        STATE_JK_CITY_2016: "खौर",
        STATE_GJ_CITY_2017: "खवडा",
        STATE_MZ_CITY_2018: "खवई",
        STATE_MH_CITY_2019: "खेड",
        STATE_GJ_CITY_2020: "खेडा",
        STATE_GJ_CITY_2021: "खेडब्रह्मा",
        STATE_MH_CITY_2022: "खेडे",
        STATE_GJ_CITY_2023: "खेडोई",
        STATE_UP_CITY_2024: "खेकरा",
        STATE_PB_CITY_2025: "खेमकरन",
        STATE_GJ_CITY_2026: "खेराळी",
        STATE_GJ_CITY_2027: "खेरालू",
        STATE_UP_CITY_2028: "खेरी",
        STATE_HR_CITY_2029: "खेरी सांपला",
        STATE_MH_CITY_2030: "खेतिया",
        STATE_RJ_CITY_2031: "खेत्री",
        STATE_MP_CITY_2032: "खिलचीपूर",
        STATE_MP_CITY_2033: "खिरकियां",
        STATE_MH_CITY_2034: "खोणी",
        STATE_AR_CITY_2035: "खोन्सा",
        STATE_MH_CITY_2036: "खोपोली",
        STATE_OR_CITY_2037: "खोरधा",
        STATE_TR_CITY_2038: "खोवाई",
        STATE_UP_CITY_2039: "खुदागंज",
        STATE_MP_CITY_2040: "खुजनेर",
        STATE_MH_CITY_2041: "खुलदाबाद",
        STATE_JH_CITY_2042: "खुंटी",
        STATE_MP_CITY_2043: "खुराई",
        STATE_OR_CITY_2044: "खुर्दा",
        STATE_UP_CITY_2045: "खुर्जा",
        STATE_BR_CITY_2046: "खुसरोपूर",
        STATE_UP_CITY_2047: "खुटार",
        STATE_UT_CITY_2048: "किच्छा",
        STATE_TN_CITY_2049: "किल भुवनगिरी",
        STATE_TN_CITY_2050: "किलवेलूर",
        STATE_HP_CITY_2051: "किन्नर",
        STATE_MH_CITY_2052: "किनवट",
        STATE_UP_CITY_2053: "किरकट",
        STATE_CT_CITY_2054: "किरंदुल",
        STATE_TN_CITY_2055: "किरणूर",
        STATE_UP_CITY_2056: "किरौली",
        STATE_UP_CITY_2057: "किरतपूर",
        STATE_OR_CITY_2058: "किरी बुरु",
        STATE_WB_CITY_2059: "किरणहार",
        STATE_BR_CITY_2060: "किशनगंज",
        STATE_RJ_CITY_2061: "किशनगड",
        STATE_UP_CITY_2062: "किशनपूर",
        STATE_UP_CITY_2063: "किशनपूर बराळ",
        STATE_UP_CITY_2064: "किष्णी",
        STATE_JK_CITY_2065: "किश्तवार",
        STATE_UP_CITY_2066: "किथोर",
        STATE_KL_CITY_2067: "किऱ्हाके चालकुडी",
        STATE_BR_CITY_2068: "कोथ",
        STATE_KA_CITY_2069: "कोडगू",
        STATE_TN_CITY_2070: "कोडाईकनाल",
        STATE_OR_CITY_2071: "कोडाला",
        STATE_TG_CITY_2072: "कोदर",
        STATE_JH_CITY_2073: "कोडरमा",
        STATE_KA_CITY_2074: "कोडीगेनहल्ली",
        STATE_GJ_CITY_2075: "कोडीनार",
        STATE_KA_CITY_2076: "कोडलीपेट",
        STATE_MH_CITY_2077: "कोडोली",
        STATE_TN_CITY_2078: "कोडुमुडी",
        STATE_KL_CITY_2079: "कोडुंगल्लूर",
        STATE_BR_CITY_2080: "कोयलवार",
        STATE_NL_CITY_2081: "कोहिमा",
        STATE_AS_CITY_2082: "कोक्राझार",
        STATE_AP_CITY_2083: "कोलानुकोंडा",
        STATE_KA_CITY_2084: "कोलार",
        STATE_MP_CITY_2085: "कोलारस",
        STATE_MZ_CITY_2086: "कोलासिब",
        STATE_MZ_CITY_2087: "कोलासिब जिल्हा",
        STATE_MH_CITY_2088: "कोल्हापूर",
        STATE_WB_CITY_2089: "कोलकाता",
        STATE_KL_CITY_2090: "कोल्लम",
        STATE_KA_CITY_2091: "कोलेगल",
        STATE_TN_CITY_2092: "कोंबई",
        STATE_KA_CITY_2093: "कोनानूर",
        STATE_OR_CITY_2094: "कोणार्का",
        STATE_UP_CITY_2095: "कोंच",
        STATE_CT_CITY_2096: "कोंडागाव",
        STATE_MH_CITY_2097: "कोंदळवाडी",
        STATE_AP_CITY_2098: "कोंडापल्ले",
        STATE_MH_CITY_2099: "कोंढाळी",
        STATE_TN_CITY_2100: "कोंगणापुरम",
        STATE_WB_CITY_2101: "कोननगर",
        STATE_KA_CITY_2102: "कोन्नूर",
        STATE_TN_CITY_2103: "कूथनाल्लूर",
        STATE_UP_CITY_2104: "कोपगंज",
        STATE_MH_CITY_2105: "कोपर खैरणे",
        STATE_MH_CITY_2106: "कोपरगाव",
        STATE_MH_CITY_2107: "कोपेला",
        STATE_KA_CITY_2108: "कोप्पा",
        STATE_KA_CITY_2109: "कोप्पल",
        STATE_TN_CITY_2110: "कोराडचेरी",
        STATE_MH_CITY_2111: "कोराडी",
        STATE_TN_CITY_2112: "कोरमपल्लम",
        STATE_OR_CITY_2113: "कोरापुट",
        STATE_KA_CITY_2114: "कोरटागेरे",
        STATE_TG_CITY_2115: "कोरटला",
        STATE_CT_CITY_2116: "कोरबा",
        STATE_MH_CITY_2117: "कोरेगाव",
        STATE_CT_CITY_2118: "कोरीया",
        STATE_AP_CITY_2119: "कोरुकोल्लू",
        STATE_MP_CITY_2120: "कोरवाई",
        STATE_GJ_CITY_2121: "कोसंबा",
        STATE_UP_CITY_2122: "कोसी",
        STATE_AP_CITY_2123: "कोसिगी",
        STATE_PB_CITY_2124: "कोट ईसा खान",
        STATE_UP_CITY_2125: "कोटा",
        STATE_RJ_CITY_2126: "कोटा",
        STATE_CT_CITY_2127: "कोटा",
        STATE_TN_CITY_2128: "कोटगिरी",
        STATE_KL_CITY_2129: "कोटामंगलम",
        STATE_CT_CITY_2130: "कोटापरळ",
        STATE_MP_CITY_2131: "कोतार",
        STATE_UT_CITY_2132: "कोटद्वार",
        STATE_TG_CITY_2133: "कोठापेठ",
        STATE_GJ_CITY_2134: "कोठारा",
        STATE_GJ_CITY_2135: "कोठारिया",
        STATE_MP_CITY_2136: "कोठी",
        STATE_PB_CITY_2137: "कोटकपुरा",
        STATE_HP_CITY_2138: "कोटखाई",
        STATE_HP_CITY_2139: "कोटला",
        STATE_MP_CITY_2140: "कोटमा",
        STATE_RJ_CITY_2141: "कोटपुतली",
        STATE_UP_CITY_2142: "कोटरा",
        STATE_TG_CITY_2143: "कोट्टागुडेम",
        STATE_TN_CITY_2144: "कोट्टयूर",
        STATE_TG_CITY_2145: "कोत्तापल्ली",
        STATE_KL_CITY_2146: "कोट्टायम",
        STATE_KA_CITY_2147: "कोट्टुरू",
        STATE_MP_CITY_2148: "कोटवा",
        STATE_KL_CITY_2149: "कोवलम",
        STATE_TN_CITY_2150: "कोविलपट्टी",
        STATE_AP_CITY_2151: "कोव्वुर",
        STATE_MH_CITY_2152: "कोयनानगर",
        STATE_KL_CITY_2153: "कोझिकोडे",
        STATE_AP_CITY_2154: "कृष्णा",
        STATE_TN_CITY_2155: "कृष्णगिरी",
        STATE_WB_CITY_2156: "कृष्णनगर",
        STATE_WB_CITY_2157: "कृष्णापूर",
        STATE_KA_CITY_2158: "कृष्णराजपेठ",
        STATE_WB_CITY_2159: "क्षीरपाई",
        STATE_OR_CITY_2160: "कुचाईबुरी",
        STATE_RJ_CITY_2161: "कुचामन",
        STATE_RJ_CITY_2162: "कुचेरा",
        STATE_UP_CITY_2163: "कुचेसर",
        STATE_OR_CITY_2164: "कुचिंदा",
        STATE_JK_CITY_2165: "कुड",
        STATE_KA_CITY_2166: "कुडाची",
        STATE_MH_CITY_2167: "कुडाळ",
        STATE_UP_CITY_2168: "कुदरकोट",
        STATE_KA_CITY_2169: "कुडलिगी",
        STATE_MH_CITY_2170: "कुही",
        STATE_JH_CITY_2171: "कुजू",
        STATE_GJ_CITY_2172: "कुकरमुंडा",
        STATE_TG_CITY_2173: "कुकटपल्ली",
        STATE_GJ_CITY_2174: "कुकमा",
        STATE_MP_CITY_2175: "कुक्षी",
        STATE_TN_CITY_2176: "कुलत्तूर",
        STATE_JK_CITY_2177: "कुलगाम",
        STATE_TN_CITY_2178: "कुलितलाय",
        STATE_UP_CITY_2179: "कुलपहार",
        STATE_WB_CITY_2180: "कुल्पी",
        STATE_WB_CITY_2181: "कुलटाळी",
        STATE_WB_CITY_2182: "कुल्टी",
        STATE_HP_CITY_2183: "कुलू",
        STATE_TN_CITY_2184: "कुमारलिंगम",
        STATE_TN_CITY_2185: "कुंभकोणम",
        STATE_KL_CITY_2186: "कुंबलम",
        STATE_MP_CITY_2187: "कुंभराज",
        STATE_CT_CITY_2188: "कुम्हारी",
        STATE_RJ_CITY_2189: "कुम्हेर",
        STATE_KA_CITY_2190: "कुमसी",
        STATE_KA_CITY_2191: "कुमटा",
        STATE_UP_CITY_2192: "कुंदा",
        STATE_UP_CITY_2193: "कुंदरखी",
        STATE_UP_CITY_2194: "कुंदरकी",
        STATE_KA_CITY_2195: "कुंदगोळ",
        STATE_GJ_CITY_2196: "कुंडला",
        STATE_KA_CITY_2197: "कुनिगल",
        STATE_KL_CITY_2198: "कुनमंगलम",
        STATE_KL_CITY_2199: "कुन्नमकुलम",
        STATE_TN_CITY_2200: "कुन्नत्तूर",
        STATE_KL_CITY_2201: "कुन्नुम्मा",
        STATE_AP_CITY_2202: "कुप्पम",
        STATE_JK_CITY_2203: "कुपवाडा",
        STATE_MH_CITY_2204: "कुरंदवड",
        STATE_MH_CITY_2205: "कुरणखेड",
        STATE_UP_CITY_2206: "कुरारा",
        STATE_MH_CITY_2207: "कुर्डुवाडी",
        STATE_UP_CITY_2208: "कुरेभर, सैदखानपूर",
        STATE_KA_CITY_2209: "कुरगुंटा",
        STATE_TN_CITY_2210: "कुरींजीपाडी",
        STATE_AP_CITY_2211: "कर्नूल",
        STATE_WB_CITY_2212: "कुर्सिओंग",
        STATE_CT_CITY_2213: "कुरुड",
        STATE_HR_CITY_2214: "कुरुक्षेत्र",
        STATE_AR_CITY_2215: "कुरुंग कुमे",
        STATE_RJ_CITY_2216: "कुशलगड",
        STATE_KA_CITY_2217: "कुशलनगर",
        STATE_UP_CITY_2218: "कुशीनगर",
        STATE_KA_CITY_2219: "कुष्टगी",
        STATE_UP_CITY_2220: "कुसमरा",
        STATE_MH_CITY_2221: "कुसुंबा",
        STATE_GJ_CITY_2222: "कच्छ जिल्हा",
        STATE_UP_CITY_2223: "कुठौंड",
        STATE_KL_CITY_2224: "कुतियातोडू",
        STATE_GJ_CITY_2225: "कुतियाना",
        STATE_TN_CITY_2226: "कुट्टलम",
        STATE_KL_CITY_2227: "कुट्टमपुझा",
        STATE_TN_CITY_2228: "कुळीथुराई",
        STATE_TG_CITY_2229: "कायथमपल्ले",
        STATE_HP_CITY_2230: "कायलंग",
        STATE_RJ_CITY_2231: "लच्छमनगड सीकर",
        STATE_JK_CITY_2232: "लडाख",
        STATE_RJ_CITY_2233: "लाडुन",
        STATE_GJ_CITY_2234: "लाडोल",
        STATE_HR_CITY_2235: "लाडवा",
        STATE_MP_CITY_2236: "लहर",
        STATE_UP_CITY_2237: "लाहारपूर",
        STATE_HP_CITY_2238: "लाहुल आणि स्पिती",
        STATE_MH_CITY_2239: "लाखांदूर",
        STATE_RJ_CITY_2240: "लाखेरी",
        STATE_AS_CITY_2241: "लखीमपूर",
        STATE_UP_CITY_2242: "लखीमपूर",
        STATE_AS_CITY_2243: "लखीपूर",
        STATE_BR_CITY_2244: "लखीसराय",
        STATE_UP_CITY_2245: "लखना",
        STATE_MP_CITY_2246: "लखनाडोन",
        STATE_GJ_CITY_2247: "लखपत",
        STATE_GJ_CITY_2248: "लख्तर",
        STATE_UT_CITY_2249: "लकसार",
        STATE_LD_CITY_2250: "लक्षद्वीप",
        STATE_TG_CITY_2251: "लक्षेट्टीपेठ",
        STATE_KA_CITY_2252: "लक्ष्मेश्वर",
        STATE_TG_CITY_2253: "लाल बहादूर नगर",
        STATE_AS_CITY_2254: "लाला",
        STATE_KL_CITY_2255: "लालम",
        STATE_BR_CITY_2256: "लालगंज",
        STATE_UP_CITY_2257: "लालगंज",
        STATE_WB_CITY_2258: "लालगड",
        STATE_WB_CITY_2259: "लालगोला",
        STATE_TN_CITY_2260: "लालगुडी",
        STATE_UP_CITY_2261: "ललितपूर",
        STATE_GJ_CITY_2262: "लालपूर",
        STATE_RJ_CITY_2263: "लालसोट",
        STATE_UP_CITY_2264: "लंबुआ",
        STATE_GJ_CITY_2265: "लंघनाज",
        STATE_MH_CITY_2266: "लांजा",
        STATE_UT_CITY_2267: "लॅन्सडाउन",
        STATE_UP_CITY_2268: "लार",
        STATE_MH_CITY_2269: "लासलगाव",
        STATE_JH_CITY_2270: "लातेहार",
        STATE_GJ_CITY_2271: "लाठी",
        STATE_MH_CITY_2272: "लातूर",
        STATE_PB_CITY_2273: "लॉन्गोवाल",
        STATE_MH_CITY_2274: "लवासा",
        STATE_UP_CITY_2275: "लावर",
        STATE_UP_CITY_2276: "लावर खास",
        STATE_MZ_CITY_2277: "लॉंगटलाय",
        STATE_LA_CITY_2278: "लेह",
        STATE_MP_CITY_2279: "लेटेरी",
        STATE_GJ_CITY_2280: "लिंबडी",
        STATE_GJ_CITY_2281: "लिमखेडा",
        STATE_KA_CITY_2282: "लिंगसुगर",
        STATE_MP_CITY_2283: "लोधीखेडा",
        STATE_UT_CITY_2284: "लोहघाट",
        STATE_JH_CITY_2285: "लोहरदगा",
        STATE_HR_CITY_2286: "लोहारू",
        STATE_AR_CITY_2287: "लोहित जिल्हा",
        STATE_MH_CITY_2288: "लोहोगाव",
        STATE_MH_CITY_2289: "लोणार",
        STATE_MH_CITY_2290: "लोणावळा",
        STATE_KA_CITY_2291: "लोंडा",
        STATE_UP_CITY_2292: "लोणी",
        STATE_CT_CITY_2293: "लोर्मी",
        STATE_RJ_CITY_2294: "लॉसल",
        STATE_AR_CITY_2295: "खालची दिबांग व्हॅली",
        STATE_AR_CITY_2296: "लोअर सुबनसिरी",
        STATE_WB_CITY_2297: "लॉयाबाद",
        STATE_BR_CITY_2298: "लकीसराय",
        STATE_UP_CITY_2299: "लखनौ",
        STATE_UP_CITY_2300: "लखनौ जिल्हा",
        STATE_PB_CITY_2301: "लुधियाना",
        STATE_AS_CITY_2302: "लुमडिंग रेल्वे कॉलनी",
        STATE_GJ_CITY_2303: "लुणावडा",
        STATE_MZ_CITY_2304: "लुंगले",
        STATE_MP_CITY_2305: "माचलपूर",
        STATE_AP_CITY_2306: "माचेर्ला",
        STATE_UP_CITY_2307: "मच्छली शहर",
        STATE_PB_CITY_2308: "मच्छीवाडा",
        STATE_UP_CITY_2309: "मच्छलीशहर",
        STATE_AP_CITY_2310: "मछलीपट्टणम",
        STATE_TN_CITY_2311: "मदमबक्कम",
        STATE_AP_CITY_2312: "मदनपल्ले",
        STATE_WB_CITY_2313: "मदनपूर",
        STATE_KA_CITY_2314: "मडदगिरी",
        STATE_KA_CITY_2315: "मद्दूर",
        STATE_GA_CITY_2316: "मडगाव",
        STATE_GJ_CITY_2317: "माधवपूर घेड",
        STATE_BR_CITY_2318: "मधेपुरा",
        STATE_GJ_CITY_2319: "मधी",
        STATE_BR_CITY_2320: "मधीपुरा",
        STATE_UP_CITY_2321: "माधोगंज",
        STATE_MP_CITY_2322: "माधोगड",
        STATE_UP_CITY_2323: "माधोगड",
        STATE_BR_CITY_2324: "मधुबनी",
        STATE_JH_CITY_2325: "मधुपूर",
        STATE_WB_CITY_2326: "मध्यमग्राम",
        STATE_KA_CITY_2327: "मडिकेरी",
        STATE_TN_CITY_2328: "मदिपक्कम",
        STATE_AP_CITY_2329: "मदुगुला",
        STATE_TN_CITY_2330: "मधुकराय",
        STATE_TN_CITY_2331: "मदुक्कुर",
        STATE_TN_CITY_2332: "मदुराई",
        STATE_TN_CITY_2333: "मदुरांतकम",
        STATE_KA_CITY_2334: "मागडी",
        STATE_JK_CITY_2335: "मगम",
        STATE_UP_CITY_2336: "मगर",
        STATE_MH_CITY_2337: "महाबळेश्वर",
        STATE_UP_CITY_2338: "महाबन",
        STATE_TG_CITY_2339: "महबूबाबाद",
        STATE_MH_CITY_2340: "महाड",
        STATE_KA_CITY_2341: "महालिंगपूर",
        STATE_HR_CITY_2342: "महाम",
        STATE_MH_CITY_2343: "महापे",
        STATE_BR_CITY_2344: "महाराजगणी",
        STATE_UP_CITY_2345: "महाराजगंज",
        STATE_CT_CITY_2346: "महासमुंद",
        STATE_TG_CITY_2347: "महबूबनगर",
        STATE_PY_CITY_2348: "माहे",
        STATE_KL_CITY_2349: "माहे",
        STATE_GJ_CITY_2350: "महेमदावाद",
        STATE_HR_CITY_2351: "महेंद्रगड",
        STATE_GJ_CITY_2352: "महेसाणा",
        STATE_MP_CITY_2353: "महेश्वर",
        STATE_MP_CITY_2354: "महागव्हाण",
        STATE_WB_CITY_2355: "माहियारी",
        STATE_MH_CITY_2356: "माहीम",
        STATE_GJ_CITY_2357: "महिसा",
        STATE_WB_CITY_2358: "महिषदल सामुदायिक विकास गट",
        STATE_UP_CITY_2359: "महमुदाबाद",
        STATE_UP_CITY_2360: "महोबा",
        STATE_UP_CITY_2361: "माहोली",
        STATE_UP_CITY_2362: "महाराजगंज",
        STATE_UP_CITY_2363: "महराजगंज (रायबरेली)",
        STATE_UP_CITY_2364: "महारोनी",
        STATE_GJ_CITY_2365: "महुधा",
        STATE_UP_CITY_2366: "माहुल",
        STATE_AS_CITY_2367: "माहूर",
        STATE_GJ_CITY_2368: "महुवा",
        STATE_GJ_CITY_2369: "महुवा (सुरत)",
        STATE_RJ_CITY_2370: "महवाह",
        STATE_AS_CITY_2371: "मायबोंग",
        STATE_MP_CITY_2372: "मैहर",
        STATE_UP_CITY_2373: "मैलानी",
        STATE_WB_CITY_2374: "मैनागुरी",
        STATE_MH_CITY_2375: "मैंदर्गी",
        STATE_UP_CITY_2376: "मैनपुरी",
        STATE_ML_CITY_2377: "मैरांग",
        STATE_BR_CITY_2378: "मैरवा",
        STATE_MH_CITY_2379: "माजलगाव",
        STATE_MP_CITY_2380: "माळोळी",
        STATE_UP_CITY_2381: "माझुपूर",
        STATE_PB_CITY_2382: "मजिठा",
        STATE_UP_CITY_2383: "मकनपूर",
        STATE_MH_CITY_2384: "माखजन",
        STATE_PB_CITY_2385: "मखू",
        STATE_RJ_CITY_2386: "मकराना",
        STATE_MP_CITY_2387: "मकसी",
        STATE_AS_CITY_2388: "माकुम",
        STATE_MH_CITY_2389: "मलबार हिल",
        STATE_MH_CITY_2390: "मालाड",
        STATE_OR_CITY_2391: "मलकानगिरी",
        STATE_KL_CITY_2392: "मलप्पुरम",
        STATE_UP_CITY_2393: "मलासा",
        STATE_PB_CITY_2394: "मलौत",
        STATE_KA_CITY_2395: "मलावल्ली",
        STATE_MH_CITY_2396: "मालेगाव",
        STATE_PB_CITY_2397: "मालेरकोटला",
        STATE_MP_CITY_2398: "मल्हारगड",
        STATE_UP_CITY_2399: "मलिहाबाद",
        STATE_TG_CITY_2400: "मलकाजगिरी",
        STATE_OR_CITY_2401: "मलकानगिरी",
        STATE_MH_CITY_2402: "मलकापूर",
        STATE_JH_CITY_2403: "मलकेरा",
        STATE_TN_CITY_2404: "मल्लपुरम",
        STATE_TN_CITY_2405: "मल्लसमुद्रम",
        STATE_TN_CITY_2406: "मल्लूर",
        STATE_KA_CITY_2407: "मालपे",
        STATE_GJ_CITY_2408: "मालपूर",
        STATE_RJ_CITY_2409: "मालपुरा",
        STATE_KA_CITY_2410: "मलूर",
        STATE_MH_CITY_2411: "मालवण",
        STATE_MZ_CITY_2412: "ममित",
        STATE_TN_CITY_2413: "मनाली",
        STATE_HP_CITY_2414: "मनाली",
        STATE_TN_CITY_2415: "मनलुरपेट्टाई",
        STATE_TN_CITY_2416: "मनामदुराई",
        STATE_TN_CITY_2417: "मानप्पाक्कम",
        STATE_TN_CITY_2418: "मानापराय",
        STATE_MP_CITY_2419: "मानसा",
        STATE_GJ_CITY_2420: "मानवदर",
        STATE_TN_CITY_2421: "मानवलाकुरीची",
        STATE_MP_CITY_2422: "मनवर",
        STATE_MH_CITY_2423: "मंचर",
        STATE_TG_CITY_2424: "मंचेरल",
        STATE_RJ_CITY_2425: "मंडळ",
        STATE_GJ_CITY_2426: "मंडळ",
        STATE_RJ_CITY_2427: "मांडलगड",
        STATE_TG_CITY_2428: "मंदामरी",
        STATE_MH_CITY_2429: "मंडणगड",
        STATE_TN_CITY_2430: "मंडपम",
        STATE_AP_CITY_2431: "मंडपेटा",
        STATE_AP_CITY_2432: "मंदासा",
        STATE_UP_CITY_2433: "मंडावर",
        STATE_RJ_CITY_2434: "मंडावर",
        STATE_MH_CITY_2435: "मांडळ",
        STATE_HR_CITY_2436: "मांडोळी कलान",
        STATE_HP_CITY_2437: "मंडी",
        STATE_MP_CITY_2438: "मंडीदीप",
        STATE_MP_CITY_2439: "मांडला",
        STATE_MP_CITY_2440: "मंडलेश्वर",
        STATE_MP_CITY_2441: "मंदसौर",
        STATE_GJ_CITY_2442: "मांडवी",
        STATE_GJ_CITY_2443: "मांडवी (सुरत)",
        STATE_MH_CITY_2444: "मांडवा",
        STATE_KA_CITY_2445: "मांड्या",
        STATE_BR_CITY_2446: "मणेर",
        STATE_AP_CITY_2447: "मंगलगिरी",
        STATE_TN_CITY_2448: "मंगलम्",
        STATE_AS_CITY_2449: "मंगलदाई",
        STATE_KA_CITY_2450: "मंगलोर",
        STATE_SK_CITY_2451: "मंगण",
        STATE_MH_CITY_2452: "माणगाव",
        STATE_MP_CITY_2453: "मांगवन",
        STATE_UT_CITY_2454: "मंगळौर",
        STATE_GJ_CITY_2455: "मंगरूळ",
        STATE_RJ_CITY_2456: "मंगरूळ",
        STATE_GJ_CITY_2457: "मंगरोळ (जुनागड)",
        STATE_MH_CITY_2458: "मंगरूळ पीर",
        STATE_UP_CITY_2459: "मनियार",
        STATE_BR_CITY_2460: "मनिहारी",
        STATE_WB_CITY_2461: "माणिकपारा",
        STATE_UP_CITY_2462: "माणिकपूर",
        STATE_KA_CITY_2463: "मणिपाल",
        STATE_KL_CITY_2464: "मंजेरी",
        STATE_KL_CITY_2465: "मंजेश्वर",
        STATE_UP_CITY_2466: "मंझणपूर",
        STATE_MH_CITY_2467: "मांजलेगाव",
        STATE_ML_CITY_2468: "मानकचार",
        STATE_UP_CITY_2469: "मानकापूर",
        STATE_MH_CITY_2470: "माणकेश्वर",
        STATE_MH_CITY_2471: "मानखुर्द",
        STATE_MH_CITY_2472: "मनमाड",
        STATE_KL_CITY_2473: "मन्नारक्कट",
        STATE_TN_CITY_2474: "मन्नारगुडी",
        STATE_RJ_CITY_2475: "मनोहर ठा",
        STATE_RJ_CITY_2476: "मनोहरपूर",
        STATE_JH_CITY_2477: "मनोहरपूर",
        STATE_MH_CITY_2478: "मनोर",
        STATE_MP_CITY_2479: "मानपूर",
        STATE_GJ_CITY_2480: "मानसा",
        STATE_PB_CITY_2481: "मानसा",
        STATE_MH_CITY_2482: "मानसर",
        STATE_TG_CITY_2483: "मंथनी",
        STATE_TG_CITY_2484: "मनुगुरु",
        STATE_KA_CITY_2485: "मानवी",
        STATE_MH_CITY_2486: "मनवत",
        STATE_MH_CITY_2487: "मनवथ",
        STATE_GA_CITY_2488: "मॅपुका",
        STATE_UP_CITY_2489: "मराहरा",
        STATE_TN_CITY_2490: "मारक्कनम",
        STATE_TN_CITY_2491: "मरंदहल्ली",
        STATE_KL_CITY_2492: "मरयूर",
        STATE_MH_CITY_2493: "मारेगाव",
        STATE_AR_CITY_2494: "मार्गेरिटा",
        STATE_BR_CITY_2495: "मारहौरा",
        STATE_UP_CITY_2496: "मारियाहू",
        STATE_AS_CITY_2497: "मारियानी",
        STATE_AP_CITY_2498: "मरकापूर",
        STATE_BR_CITY_2499: "मसौरी बुजुर्ग",
        STATE_WB_CITY_2500: "मसिला",
        STATE_TN_CITY_2501: "मासीनीगुडी",
        STATE_MH_CITY_2502: "मस्तीहोळी",
        STATE_MH_CITY_2503: "मसूर, भारत",
        STATE_UP_CITY_2504: "माटौंध",
        STATE_WB_CITY_2505: "माथाभंगा",
        STATE_MH_CITY_2506: "माथेरान",
        STATE_UP_CITY_2507: "मथुरा",
        STATE_WB_CITY_2508: "मटियाली समुदाय विकास गट",
        STATE_WB_CITY_2509: "मातीगारा समाज विकास गट",
        STATE_KL_CITY_2510: "मत्तनूर",
        STATE_TN_CITY_2511: "मत्तूर",
        STATE_MH_CITY_2512: "माटुंगा",
        STATE_MP_CITY_2513: "मौ",
        STATE_UP_CITY_2514: "मौ",
        STATE_UP_CITY_2515: "माऊ आईमा",
        STATE_UP_CITY_2516: "माऊ आईम्मा",
        STATE_UP_CITY_2517: "मौदाहा",
        STATE_MP_CITY_2518: "मौगंज",
        STATE_PB_CITY_2519: "मौर मंडी",
        STATE_UP_CITY_2520: "मौरानवान",
        STATE_UP_CITY_2521: "मौरवान",
        STATE_KL_CITY_2522: "मावेलीकर",
        STATE_KL_CITY_2523: "मावूर",
        STATE_UP_CITY_2524: "मावणा",
        STATE_UP_CITY_2525: "मवार",
        STATE_KA_CITY_2526: "मायाकोंडा",
        STATE_MN_CITY_2527: "मायांग इंफाळ",
        STATE_TN_CITY_2528: "मायलादुथुराई",
        STATE_OR_CITY_2529: "मयूरभंज",
        STATE_MH_CITY_2530: "माझगाव",
        STATE_TG_CITY_2531: "मेडक",
        STATE_TG_CITY_2532: "मेडचल",
        STATE_TG_CITY_2533: "मेडचल मलकाजगिरी",
        STATE_WB_CITY_2534: "मेदिनीपूर",
        STATE_UP_CITY_2535: "मेरठ",
        STATE_RJ_CITY_2536: "मिठारी मारवाड",
        STATE_GJ_CITY_2537: "मेघराज",
        STATE_UP_CITY_2538: "मेहडवळ",
        STATE_MH_CITY_2539: "मेहेकर",
        STATE_MH_CITY_2540: "मेहेरगाव",
        STATE_MH_CITY_2541: "मेहकर",
        STATE_UP_CITY_2542: "मेहनगर",
        STATE_UP_CITY_2543: "मेहंदवळ",
        STATE_GJ_CITY_2544: "मेहसाणा",
        STATE_WB_CITY_2545: "मेजिया समुदाय विकास ब्लॉक",
        STATE_KA_CITY_2546: "मेलुकोटे",
        STATE_TN_CITY_2547: "मेलुर",
        STATE_WB_CITY_2548: "मेमरी",
        STATE_GJ_CITY_2549: "मेंदर्डा",
        STATE_RJ_CITY_2550: "मेर्टा",
        STATE_TN_CITY_2551: "मेट्टुप्पलयम",
        STATE_TN_CITY_2552: "मेत्तूर",
        STATE_MH_CITY_2553: "म्हसळा",
        STATE_MH_CITY_2554: "म्हसवड",
        STATE_MP_CITY_2555: "मिहोना",
        STATE_UP_CITY_2556: "मिलक",
        STATE_UP_CITY_2557: "मिल्कीपूर",
        STATE_TN_CITY_2558: "मिंजूर",
        STATE_MH_CITY_2559: "मिरज",
        STATE_UP_CITY_2560: "मिराणपूर",
        STATE_UP_CITY_2561: "मिराणपूर कटरा",
        STATE_UP_CITY_2562: "मिरगंज",
        STATE_TG_CITY_2563: "मिरियालगुडा",
        STATE_WB_CITY_2564: "मिरिक",
        STATE_UP_CITY_2565: "मिर्झापूर",
        STATE_UP_CITY_2566: "मिसरिख",
        STATE_GJ_CITY_2567: "मिठापूर",
        STATE_GJ_CITY_2568: "मोडासा",
        STATE_PB_CITY_2569: "मोगा",
        STATE_MH_CITY_2570: "मोहाडी",
        STATE_PB_CITY_2571: "मोहाली",
        STATE_UP_CITY_2572: "मोहन",
        STATE_UP_CITY_2573: "मोहनपूर",
        STATE_WB_CITY_2574: "मोहनपूर समुदाय विकास गट",
        STATE_TN_CITY_2575: "मोहनूर",
        STATE_MP_CITY_2576: "मोहगाव",
        STATE_BR_CITY_2577: "मोहिउद्दीननगर",
        STATE_MH_CITY_2578: "मोहोळ",
        STATE_MH_CITY_2579: "मोहपा",
        STATE_MN_CITY_2580: "मोइरंग",
        STATE_BR_CITY_2581: "मोकामेह",
        STATE_MH_CITY_2582: "मोखाडा तालुका",
        STATE_NL_CITY_2583: "मोकोकचुंग",
        STATE_NL_CITY_2584: "सोम",
        STATE_BR_CITY_2585: "मोंघायर",
        STATE_WB_CITY_2586: "मोनोहरपूर",
        STATE_MH_CITY_2587: "मोरा, महाराष्ट्र",
        STATE_UP_CITY_2588: "मुरादाबाद",
        STATE_MH_CITY_2589: "मोरम",
        STATE_AS_CITY_2590: "मोरान्हा",
        STATE_MP_CITY_2591: "मोरार",
        STATE_GJ_CITY_2592: "मोरबी",
        STATE_MP_CITY_2593: "मोरेना",
        STATE_AS_CITY_2594: "मोरीगाव",
        STATE_PB_CITY_2595: "मोरिंडा",
        STATE_GA_CITY_2596: "मोरजीम",
        STATE_GA_CITY_2597: "मुरगाव",
        STATE_MH_CITY_2598: "मोर्सी",
        STATE_GJ_CITY_2599: "मोरवा (हडफ)",
        STATE_GJ_CITY_2600: "मोरवा",
        STATE_UP_CITY_2601: "पतंग",
        STATE_BR_CITY_2602: "मोतिहारी",
        STATE_MH_CITY_2603: "मोवाड",
        STATE_UP_CITY_2604: "मुबारकपूर",
        STATE_KA_CITY_2605: "मुडबिद्री",
        STATE_KA_CITY_2606: "मुद्देबिहाळ",
        STATE_KA_CITY_2607: "मुद्गल",
        STATE_KA_CITY_2608: "मुडगेरे",
        STATE_KA_CITY_2609: "मुधोळ",
        STATE_MH_CITY_2610: "मुदखेड",
        STATE_TN_CITY_2611: "मुदुकुलत्तूर",
        STATE_UP_CITY_2612: "मुघल सराई",
        STATE_JH_CITY_2613: "मुग्मा",
        STATE_UP_CITY_2614: "मुहम्मदाबाद",
        STATE_PB_CITY_2615: "मुकेरियन",
        STATE_MH_CITY_2616: "मुखेर",
        STATE_UP_CITY_2617: "मुक्तेश्वर",
        STATE_MH_CITY_2618: "मुल",
        STATE_TN_CITY_2619: "मुलानूर",
        STATE_KA_CITY_2620: "मुलबागल",
        STATE_KA_CITY_2621: "मुळगुंद",
        STATE_MH_CITY_2622: "मुल्हेर",
        STATE_KA_CITY_2623: "मुल्की",
        STATE_MP_CITY_2624: "मुलताई",
        STATE_MH_CITY_2625: "मुलुंड",
        STATE_KL_CITY_2626: "मुलुपिलागडू",
        STATE_MH_CITY_2627: "मुंबई",
        STATE_MH_CITY_2628: "मुंबई उपनगर",
        STATE_KA_CITY_2629: "मुंदरगी",
        STATE_KA_CITY_2630: "मुंडगोड",
        STATE_MP_CITY_2631: "मुंडी",
        STATE_GJ_CITY_2632: "मुंद्रा",
        STATE_RJ_CITY_2633: "मुंडवा",
        STATE_MP_CITY_2634: "मुंगोली",
        STATE_CT_CITY_2635: "मुंगेली",
        STATE_BR_CITY_2636: "मुंगेर",
        STATE_UP_CITY_2637: "मुंगरा बादशाहपूर",
        STATE_KA_CITY_2638: "मुनिराबाद",
        STATE_KL_CITY_2639: "मुन्नार",
        STATE_UP_CITY_2640: "मुन्स्यारी",
        STATE_UP_CITY_2641: "मुरादाबाद",
        STATE_UP_CITY_2642: "मुरादनगर",
        STATE_WB_CITY_2643: "मुरगाचा",
        STATE_MH_CITY_2644: "मुरबाड",
        STATE_MH_CITY_2645: "मुरगूड",
        STATE_WB_CITY_2646: "मुरी",
        STATE_BR_CITY_2647: "मुरलीगंज",
        STATE_UP_CITY_2648: "मुर्सन",
        STATE_WB_CITY_2649: "मुर्शिदाबाद",
        STATE_MH_CITY_2650: "मुर्तजापूर",
        STATE_MH_CITY_2651: "मुरुड (रायगड)",
        STATE_MH_CITY_2652: "मुरुड (रत्नागिरी)",
        STATE_KA_CITY_2653: "मुरुडेश्वरा",
        STATE_MH_CITY_2654: "मुरुम",
        STATE_MP_CITY_2655: "मुरवारा",
        STATE_UP_CITY_2656: "मुसाफिर-खाना",
        STATE_UP_CITY_2657: "मुसाफिरखाना",
        STATE_JH_CITY_2658: "मुशाबानी",
        STATE_TN_CITY_2659: "मुसिरी",
        STATE_UT_CITY_2660: "मसुरी",
        STATE_HR_CITY_2661: "मुस्तफाबाद",
        STATE_TN_CITY_2662: "मुटुपेट",
        STATE_KL_CITY_2663: "मुवट्टुपुला",
        STATE_KL_CITY_2664: "मुवट्टुपुढा",
        STATE_UP_CITY_2665: "मुझफ्फरनगर",
        STATE_BR_CITY_2666: "मुझफ्फरपूर",
        STATE_KA_CITY_2667: "म्हैसूर",
        STATE_WB_CITY_2668: "नवद्वीप",
        STATE_WB_CITY_2669: "नबाग्राम",
        STATE_OR_CITY_2670: "नबरंगपूर",
        STATE_PB_CITY_2671: "नभा",
        STATE_BR_CITY_2672: "नबीनगर",
        STATE_KL_CITY_2673: "नादापुरम",
        STATE_HP_CITY_2674: "नादौन",
        STATE_RJ_CITY_2675: "नादबाई",
        STATE_MH_CITY_2676: "नडगाव",
        STATE_WB_CITY_2677: "नादिया जिल्हा",
        STATE_GJ_CITY_2678: "नडियाद",
        STATE_GJ_CITY_2679: "नडियाद,",
        STATE_UP_CITY_2680: "नदीगाव",
        STATE_KL_CITY_2681: "नादुवन्नूर",
        STATE_TN_CITY_2682: "नादुवत्तम",
        STATE_KA_CITY_2683: "नागमंगला",
        STATE_AS_CITY_2684: "नागाव",
        STATE_TN_CITY_2685: "नागपट्टणम",
        STATE_MH_CITY_2686: "नागापूर",
        STATE_RJ_CITY_2687: "नगर",
        STATE_HP_CITY_2688: "नगर",
        STATE_TG_CITY_2689: "नगर कर्नूल",
        STATE_AP_CITY_2690: "नागरी",
        STATE_WB_CITY_2691: "नागरुखरा",
        STATE_RJ_CITY_2692: "नागौर",
        STATE_MP_CITY_2693: "नागडा",
        STATE_TN_CITY_2694: "नागरकोइल",
        STATE_UP_CITY_2695: "नगीना",
        STATE_AP_CITY_2696: "नागिरेड्डीपल्ली",
        STATE_UP_CITY_2697: "नागला",
        STATE_MP_CITY_2698: "नागोड",
        STATE_MH_CITY_2699: "नागोठाणा",
        STATE_MH_CITY_2700: "नागपूर",
        STATE_MH_CITY_2701: "नागपूर विभाग",
        STATE_WB_CITY_2702: "नागरकटा",
        STATE_UP_CITY_2703: "नागग्राम",
        STATE_HP_CITY_2704: "नगरोटा",
        STATE_GJ_CITY_2705: "नागवा",
        STATE_HP_CITY_2706: "न्हाऊन",
        STATE_AR_CITY_2707: "नाहरलागुन",
        STATE_AS_CITY_2708: "नाहोरकटिया",
        STATE_MP_CITY_2709: "नायगढ़ी",
        STATE_WB_CITY_2710: "नैहाटी",
        STATE_UT_CITY_2711: "नैनी ता",
        STATE_MP_CITY_2712: "नैनपूर",
        STATE_RJ_CITY_2713: "नैनवा",
        STATE_DL_CITY_2714: "नजफगढ",
        STATE_UP_CITY_2715: "नजीबाबाद",
        STATE_PB_CITY_2716: "नकोदर",
        STATE_WB_CITY_2717: "नक्सलबारी",
        STATE_UP_CITY_2718: "नकूर",
        STATE_MH_CITY_2719: "नाला सोपारा",
        STATE_HP_CITY_2720: "नालागड",
        STATE_BR_CITY_2721: "नालंदा",
        STATE_AS_CITY_2722: "नलबारी",
        STATE_GJ_CITY_2723: "नळधरा",
        STATE_MH_CITY_2724: "नळदुर्ग",
        STATE_MH_CITY_2725: "नालेगाव",
        STATE_TG_CITY_2726: "नलगोंडा",
        STATE_WB_CITY_2727: "नल्हाटी",
        STATE_GJ_CITY_2728: "नाल्या",
        STATE_WB_CITY_2729: "नालपूर",
        STATE_TN_CITY_2730: "नामगिरिपेट्टाय",
        STATE_TN_CITY_2731: "नमक्कल",
        STATE_TN_CITY_2732: "नंबियुर",
        STATE_TN_CITY_2733: "नंबुतलाय",
        STATE_SK_CITY_2734: "नामची",
        STATE_WB_CITY_2735: "नामखाना समुदाय विकास गट",
        STATE_MP_CITY_2736: "नामली",
        STATE_MH_CITY_2737: "नामपूर",
        STATE_AS_CITY_2738: "नामरूप",
        STATE_UP_CITY_2739: "नानौता",
        STATE_TN_CITY_2740: "नंदंबक्कम",
        STATE_MH_CITY_2741: "नांदेड",
        STATE_UP_CITY_2742: "नांदगाव",
        STATE_MH_CITY_2743: "नांदगाव",
        STATE_AP_CITY_2744: "नंदीगामा",
        STATE_WB_CITY_2745: "नंदीग्राम",
        STATE_AP_CITY_2746: "नंदीकोटकुर",
        STATE_MH_CITY_2747: "नंदनी",
        STATE_MH_CITY_2748: "नांदुरा",
        STATE_MH_CITY_2749: "नांदुरा बुजुर्ग",
        STATE_MH_CITY_2750: "नंदुरबार",
        STATE_AP_CITY_2751: "नांद्याल",
        STATE_PB_CITY_2752: "नांगल",
        STATE_TN_CITY_2753: "नांगवल्ली",
        STATE_WB_CITY_2754: "नंगी",
        STATE_TN_CITY_2755: "नांगीलीकोंडन",
        STATE_DL_CITY_2756: "नांगलोई जाट",
        STATE_TN_CITY_2757: "नांगुनेरी",
        STATE_KA_CITY_2758: "नंजनगुड",
        STATE_TN_CITY_2759: "नन्निलम",
        STATE_UP_CITY_2760: "नानपरा",
        STATE_RJ_CITY_2761: "नापसर",
        STATE_RJ_CITY_2762: "नरैना",
        STATE_MP_CITY_2763: "नारायणी",
        STATE_AP_CITY_2764: "नरसन्नपेटा",
        STATE_AP_CITY_2765: "नरसापूर",
        STATE_AP_CITY_2766: "नरसरावपेठ",
        STATE_KA_CITY_2767: "नरसिंहराजपुरा",
        STATE_AP_CITY_2768: "नरसिंगपुरम",
        STATE_UP_CITY_2769: "नरौली",
        STATE_UP_CITY_2770: "नरौरा",
        STATE_TN_CITY_2771: "नरवरीकुप्पम",
        STATE_AP_CITY_2772: "नारायणवनम",
        STATE_MH_CITY_2773: "नारायणगाव",
        STATE_HR_CITY_2774: "नारायणगड",
        STATE_MP_CITY_2775: "नारायणगड",
        STATE_TG_CITY_2776: "नारायणपेठ",
        STATE_CT_CITY_2777: "नारायणपूर",
        STATE_MH_CITY_2778: "नरडाणा",
        STATE_KA_CITY_2779: "नरेगल",
        STATE_DL_CITY_2780: "नरेला",
        STATE_UT_CITY_2781: "नरेंद्रनगर",
        STATE_GJ_CITY_2782: "नारगोल",
        STATE_KA_CITY_2783: "नरगुंड",
        STATE_CT_CITY_2784: "नरहरपूर",
        STATE_MH_CITY_2785: "नरिमन पॉइंट",
        STATE_MH_CITY_2786: "नरखेड",
        STATE_GJ_CITY_2787: "नर्मदा",
        STATE_HR_CITY_2788: "नारनौल",
        STATE_HR_CITY_2789: "नारनौंड",
        STATE_GJ_CITY_2790: "नरोडा",
        STATE_UP_CITY_2791: "नरोरा",
        STATE_MP_CITY_2792: "नरसिंहपूर",
        STATE_MP_CITY_2793: "नरसिंगगड",
        STATE_TG_CITY_2794: "नरसिंगी",
        STATE_AP_CITY_2795: "नरसिपट्टणम",
        STATE_HR_CITY_2796: "नरवाना",
        STATE_MP_CITY_2797: "नरवर",
        STATE_MH_CITY_2798: "नाशिक",
        STATE_MH_CITY_2799: "नाशिक विभाग",
        STATE_RJ_CITY_2800: "नशिराबाद",
        STATE_TG_CITY_2801: "नासपूर",
        STATE_BR_CITY_2802: "नसरीगंज",
        STATE_MP_CITY_2803: "नसरुल्लागंज",
        STATE_RJ_CITY_2804: "नाथद्वारा",
        STATE_TN_CITY_2805: "नट्टम",
        STATE_TN_CITY_2806: "नटरसंकोट्टय",
        STATE_BR_CITY_2807: "नौगाचिया",
        STATE_UP_CITY_2808: "नौगामा",
        STATE_UP_CITY_2809: "नौरंगपूर",
        STATE_UP_CITY_2810: "नौतनवा",
        STATE_KA_CITY_2811: "नवलगुंड",
        STATE_MH_CITY_2812: "नवापूर",
        STATE_GA_CITY_2813: "नवलीम",
        STATE_MH_CITY_2814: "नवी मुंबई",
        STATE_GJ_CITY_2815: "नवसारी",
        STATE_RJ_CITY_2816: "नवा",
        STATE_UP_CITY_2817: "नवाबगंज",
        STATE_UP_CITY_2818: "नवाबगंज (बाराबंकी)",
        STATE_UP_CITY_2819: "नवाबगंज (बरेली)",
        STATE_BR_CITY_2820: "नवाडा",
        STATE_RJ_CITY_2821: "नवलगढ",
        STATE_PB_CITY_2822: "नवनशहर",
        STATE_JK_CITY_2823: "नवनशहर",
        STATE_SK_CITY_2824: "नया बाजार",
        STATE_OR_CITY_2825: "नयागड",
        STATE_OR_CITY_2826: "नयागड जिल्हा",
        STATE_WB_CITY_2827: "नयाग्राम समुदाय विकास गट",
        STATE_AP_CITY_2828: "नायडूपेत",
        STATE_AS_CITY_2829: "नाझिरा",
        STATE_KL_CITY_2830: "नेदुमनगड",
        STATE_TN_CITY_2831: "नीडमंगलम",
        STATE_TN_CITY_2832: "नीलंकराय",
        STATE_RJ_CITY_2833: "कडुनिंब का थाना",
        STATE_MP_CITY_2834: "नीमच",
        STATE_TN_CITY_2835: "नेगापटम",
        STATE_KA_CITY_2836: "नेलमंगला",
        STATE_TN_CITY_2837: "नेल्लिककुप्पम",
        STATE_AP_CITY_2838: "नेल्लोर",
        STATE_MP_CITY_2839: "नेपानगर",
        STATE_MH_CITY_2840: "नेरल",
        STATE_MH_CITY_2841: "नेरूर",
        STATE_JH_CITY_2842: "नेतुरहाट",
        STATE_MH_CITY_2843: "नेवासा",
        STATE_DL_CITY_2844: "नवी दिल्ली",
        STATE_UP_CITY_2845: "नेवारा",
        STATE_KL_CITY_2846: "नेय्याटिंकरा",
        STATE_UP_CITY_2847: "निचलौल",
        STATE_AN_CITY_2848: "निकोबार",
        STATE_AP_CITY_2849: "निदादवोळे",
        STATE_MH_CITY_2850: "निघोज",
        STATE_UP_CITY_2851: "निघोह",
        STATE_UP_CITY_2852: "निहतौर",
        STATE_GJ_CITY_2853: "निकोरा",
        STATE_TN_CITY_2854: "निलकोट्टाई",
        STATE_MH_CITY_2855: "निलंगा",
        STATE_KL_CITY_2856: "निलेश्‍वर",
        STATE_OR_CITY_2857: "निलगिरी",
        STATE_TN_CITY_2858: "निलगिरी",
        STATE_HR_CITY_2859: "निलोखेरी",
        STATE_RJ_CITY_2860: "निमज",
        STATE_OR_CITY_2861: "निमपरहा",
        STATE_RJ_CITY_2862: "निंबाहेरा",
        STATE_MH_CITY_2863: "निपाणी",
        STATE_MH_CITY_2864: "निफाड",
        STATE_MH_CITY_2865: "नीरा नरसिंगपूर",
        STATE_TG_CITY_2866: "निर्मल",
        STATE_BR_CITY_2867: "निर्मली",
        STATE_JH_CITY_2868: "निरसा",
        STATE_RJ_CITY_2869: "निवाई",
        STATE_UP_CITY_2870: "निवारी",
        STATE_TG_CITY_2871: "निजामाबाद",
        STATE_UP_CITY_2872: "निजामाबाद",
        STATE_GJ_CITY_2873: "निझर",
        STATE_JH_CITY_2874: "नोआमुंडी",
        STATE_RJ_CITY_2875: "नोहर",
        STATE_UP_CITY_2876: "नोएडा",
        STATE_RJ_CITY_2877: "नोखा",
        STATE_ML_CITY_2878: "नॉन्गपोह",
        STATE_ML_CITY_2879: "नॉन्गस्टॉइन",
        STATE_JK_CITY_2880: "नोरिया",
        STATE_WB_CITY_2881: "उत्तर 24 परगणा जिल्हा",
        STATE_DL_CITY_2882: "उत्तर दिल्ली",
        STATE_SK_CITY_2883: "उत्तर जिल्हा",
        STATE_DL_CITY_2884: "ईशान्य दिल्ली",
        STATE_ML_CITY_2885: "उत्तर गारो हिल्स",
        STATE_GA_CITY_2886: "उत्तर गोवा",
        STATE_AS_CITY_2887: "उत्तर गुवाहाटी",
        STATE_AS_CITY_2888: "उत्तर लखीमपूर",
        STATE_TR_CITY_2889: "उत्तर त्रिपुरा",
        STATE_MZ_CITY_2890: "उत्तर वनलाइफई",
        STATE_DL_CITY_2891: "उत्तर पश्चिम दिल्ली",
        STATE_OR_CITY_2892: "नवरंगापूर",
        STATE_OR_CITY_2893: "नुआपाडा",
        STATE_HR_CITY_2894: "नुह",
        STATE_AS_CITY_2895: "नुमालीगढ",
        STATE_PB_CITY_2896: "नूरमहाल",
        STATE_UP_CITY_2897: "नूरपूर",
        STATE_PB_CITY_2898: "नूरपूर कलान",
        STATE_AP_CITY_2899: "Nuzvid",
        STATE_KA_CITY_2900: "न्यामती",
        STATE_UP_CITY_2901: "ओब्रा",
        STATE_GJ_CITY_2902: "ओडादर",
        STATE_WB_CITY_2903: "ओडलाबारी",
        STATE_TN_CITY_2904: "ओडुगत्तूर",
        STATE_GJ_CITY_2905: "ओखा",
        STATE_GJ_CITY_2906: "ओलपाड",
        STATE_TN_CITY_2907: "ओमालुर",
        STATE_AP_CITY_2908: "ओंगोल",
        STATE_TN_CITY_2909: "उटी",
        STATE_UP_CITY_2910: "ओराई",
        STATE_UP_CITY_2911: "ओरन",
        STATE_MP_CITY_2912: "ओरछा",
        STATE_MH_CITY_2913: "उस्मानाबाद",
        STATE_KL_CITY_2914: "ओट्टापलम",
        STATE_MH_CITY_2915: "ओझर",
        STATE_MH_CITY_2916: "पाबळ",
        STATE_MP_CITY_2917: "पचमढी",
        STATE_MH_CITY_2918: "पाचोरा",
        STATE_UP_CITY_2919: "पाचपेरवा",
        STATE_JK_CITY_2920: "पदम",
        STATE_RJ_CITY_2921: "पदमपूर",
        STATE_OR_CITY_2922: "पदमपूर",
        STATE_GJ_CITY_2923: "पडझरी",
        STATE_TN_CITY_2924: "पद्मनाभपुरम",
        STATE_GJ_CITY_2925: "पदरा",
        STATE_UP_CITY_2926: "पदरौना",
        STATE_UP_CITY_2927: "पहासू",
        STATE_JK_CITY_2928: "पहलगाम",
        STATE_MH_CITY_2929: "पहूर, महाराष्ट्र",
        STATE_UP_CITY_2930: "पायगाव",
        STATE_WB_CITY_2931: "पाईकपारा",
        STATE_MH_CITY_2932: "पैठण",
        STATE_AP_CITY_2933: "पाकला",
        STATE_JH_CITY_2934: "पाकूर",
        STATE_KL_CITY_2935: "पलकट्टुमाला",
        STATE_KL_CITY_2936: "पलक्कड जिल्हा",
        STATE_TN_CITY_2937: "पलक्कोडू",
        STATE_AP_CITY_2938: "पलाकोल्लू",
        STATE_TN_CITY_2939: "पालामेडू",
        STATE_HP_CITY_2940: "पालमपूर",
        STATE_JH_CITY_2941: "पलामू",
        STATE_TN_CITY_2942: "पलानी",
        STATE_GJ_CITY_2943: "पालनपूर",
        STATE_GJ_CITY_2944: "पलांसवा",
        STATE_AP_CITY_2945: "पलासा",
        STATE_AS_CITY_2946: "पलासबारी",
        STATE_TN_CITY_2947: "पलवक्कम",
        STATE_MP_CITY_2948: "पालेरा",
        STATE_MH_CITY_2949: "पालघर",
        STATE_KL_CITY_2950: "पालघाट",
        STATE_RJ_CITY_2951: "पाली",
        STATE_MP_CITY_2952: "पाली",
        STATE_UP_CITY_2953: "पाली",
        STATE_MH_CITY_2954: "पाली, रायगड",
        STATE_UP_CITY_2955: "पालिया कलान",
        STATE_GJ_CITY_2956: "पालीताना",
        STATE_GJ_CITY_2957: "पाल्याड",
        STATE_GJ_CITY_2958: "पल्याड (भावनगर)",
        STATE_AP_CITY_2959: "पालकोंडा",
        STATE_TN_CITY_2960: "पल्लडम",
        STATE_TN_CITY_2961: "पल्लप्पट्टी",
        STATE_TN_CITY_2962: "पल्लत्तूर",
        STATE_TN_CITY_2963: "पल्लवरम",
        STATE_GA_CITY_2964: "पल्ले",
        STATE_AP_CITY_2965: "पल्लेवाडा",
        STATE_TN_CITY_2966: "पल्लीकोंडाई",
        STATE_TN_CITY_2967: "पल्लीपट्टू",
        STATE_TN_CITY_2968: "पल्लीपट्टी",
        STATE_AP_CITY_2969: "पालमनेर",
        STATE_TG_CITY_2970: "पालोंचा",
        STATE_GJ_CITY_2971: "पलसाणा",
        STATE_MH_CITY_2972: "पल्सो",
        STATE_HR_CITY_2973: "पलवल",
        STATE_TG_CITY_2974: "पालवांचा",
        STATE_MP_CITY_2975: "पानगर",
        STATE_WB_CITY_2976: "पानागढ",
        STATE_GA_CITY_2977: "पणजी",
        STATE_KL_CITY_2978: "पणमराम",
        STATE_MP_CITY_2979: "पणारा",
        STATE_GJ_CITY_2980: "पंचमहाल",
        STATE_MH_CITY_2981: "पाचगणी",
        STATE_HR_CITY_2982: "पंचकुला",
        STATE_WB_CITY_2983: "पांचला",
        STATE_GJ_CITY_2984: "पंचमहाल जिल्हा",
        STATE_WB_CITY_2985: "पंचमुरा",
        STATE_CT_CITY_2986: "पंढरीया",
        STATE_CT_CITY_2987: "पंडताराय",
        STATE_MP_CITY_2988: "पांधना",
        STATE_MH_CITY_2989: "पंढरपूर",
        STATE_MH_CITY_2990: "पांढुर्ली",
        STATE_MP_CITY_2991: "पांढुर्णा",
        STATE_HP_CITY_2992: "पंडोह",
        STATE_WB_CITY_2993: "पांडुआ",
        STATE_KA_CITY_2994: "पांगळा",
        STATE_MH_CITY_2995: "पन्हाळा",
        STATE_WB_CITY_2996: "पाणिहाटी",
        STATE_HR_CITY_2997: "पानिपत",
        STATE_MP_CITY_2998: "पन्ना",
        STATE_TN_CITY_2999: "पाणरुती",
        STATE_MP_CITY_3000: "पानसेमल",
        STATE_WB_CITY_3001: "पांसकुरा",
        STATE_MH_CITY_3002: "पनवेल",
        STATE_HP_CITY_3003: "पांवटा साहिब",
        STATE_TN_CITY_3004: "पापनासम",
        STATE_TN_CITY_3005: "पापिरेडिप्पत्ती",
        STATE_TN_CITY_3006: "पप्परपट्टी",
        STATE_KL_CITY_3007: "पप्पिनीशेरी",
        STATE_OR_CITY_3008: "पारादीप गड",
        STATE_TN_CITY_3009: "परमागुडी",
        STATE_UP_CITY_3010: "पारस रामपूर",
        STATE_MP_CITY_3011: "परासिया",
        STATE_KL_CITY_3012: "परावुर टेक्कुंभगम",
        STATE_WB_CITY_3013: "पारबतीपूर",
        STATE_MH_CITY_3014: "परभणी",
        STATE_GJ_CITY_3015: "पारडी",
        STATE_MH_CITY_3016: "परळ",
        STATE_UP_CITY_3017: "परिचा",
        STATE_UP_CITY_3018: "परिचतगड",
        STATE_KL_CITY_3019: "परियापुरम",
        STATE_AP_CITY_3020: "पर्लकिमिडी",
        STATE_MH_CITY_3021: "परळी वैजनाथ",
        STATE_MH_CITY_3022: "पारनेर",
        STATE_GJ_CITY_3023: "पारनेरा",
        STATE_JK_CITY_3024: "पारोल",
        STATE_MH_CITY_3025: "पारोळा",
        STATE_MH_CITY_3026: "परसोनी",
        STATE_UP_CITY_3027: "परशदेपूर",
        STATE_RJ_CITY_3028: "परतापूर",
        STATE_MH_CITY_3029: "परतूर",
        STATE_AP_CITY_3030: "पार्वतीपुरम",
        STATE_RJ_CITY_3031: "पर्वतसर",
        STATE_HP_CITY_3032: "परवानू",
        STATE_CT_CITY_3033: "पासन",
        STATE_WB_CITY_3034: "पश्चिम मेदिनीपूर जिल्हा",
        STATE_BR_CITY_3035: "पश्‍चिम चंपारण",
        STATE_JH_CITY_3036: "पश्चिम सिंगभूम",
        STATE_AR_CITY_3037: "पासीघाट",
        STATE_JH_CITY_3038: "पटमडा",
        STATE_OR_CITY_3039: "पाटामुंडई",
        STATE_GJ_CITY_3040: "पाटण",
        STATE_CT_CITY_3041: "पाटण",
        STATE_MH_CITY_3042: "पाटण",
        STATE_MP_CITY_3043: "पाटण",
        STATE_TG_CITY_3044: "पटांचेरू",
        STATE_HR_CITY_3045: "पतौडी",
        STATE_UP_CITY_3046: "पाठकपुरा",
        STATE_CT_CITY_3047: "पाथळगाव",
        STATE_KL_CITY_3048: "पठाणमथिट्टा",
        STATE_PB_CITY_3049: "पठाणकोट",
        STATE_MH_CITY_3050: "पाथर्डी",
        STATE_JH_CITY_3051: "पाथर्डीह",
        STATE_MP_CITY_3052: "पाथरिया",
        STATE_MH_CITY_3053: "पाथरी",
        STATE_PB_CITY_3054: "पटियाला",
        STATE_UP_CITY_3055: "पटियाली",
        STATE_WB_CITY_3056: "पतिराम",
        STATE_BR_CITY_3057: "पाटणा",
        STATE_OR_CITY_3058: "पटनागढ",
        STATE_WB_CITY_3059: "पत्रासेर",
        STATE_JK_CITY_3060: "पट्टण",
        STATE_KL_CITY_3061: "पट्टणमतिट्टा",
        STATE_PB_CITY_3062: "पट्टी",
        STATE_UP_CITY_3063: "पट्टी",
        STATE_TN_CITY_3064: "पट्टुकोट्टाई",
        STATE_WB_CITY_3065: "पाटुली",
        STATE_MH_CITY_3066: "पातूर",
        STATE_MH_CITY_3067: "पातुर्डा",
        STATE_MH_CITY_3068: "पौड",
        STATE_MH_CITY_3069: "पौनी",
        STATE_UT_CITY_3070: "पौडी",
        STATE_GJ_CITY_3071: "पवी जेतपूर",
        STATE_KA_CITY_3072: "पावुगडा",
        STATE_AP_CITY_3073: "पावलुरु",
        STATE_MP_CITY_3074: "पवई",
        STATE_UP_CITY_3075: "पावयन",
        STATE_MH_CITY_3076: "पवनी",
        STATE_UP_CITY_3077: "पायगपूर",
        STATE_KL_CITY_3078: "पयन्नूर",
        STATE_AP_CITY_3079: "पेडाणा",
        STATE_AP_CITY_3080: "pedda nakkalapalem",
        STATE_TG_CITY_3081: "पेद्दपल्ली",
        STATE_AP_CITY_3082: "पेद्दापुरम",
        STATE_MH_CITY_3083: "पेडगाव",
        STATE_HR_CITY_3084: "पेहोवा",
        STATE_MH_CITY_3085: "पेंट",
        STATE_MH_CITY_3086: "पेन",
        STATE_CT_CITY_3087: "पेंद्र",
        STATE_TN_CITY_3088: "पेन्नाडम",
        STATE_TN_CITY_3089: "पेननगरम",
        STATE_TN_CITY_3090: "पेन्नतूर",
        STATE_AP_CITY_3091: "पेनुगोंडा",
        STATE_AP_CITY_3092: "पेनुकोंडा",
        STATE_TN_CITY_3093: "पेरायुर",
        STATE_TN_CITY_3094: "पेरांबलूर",
        STATE_TN_CITY_3095: "पेरणमल्लूर",
        STATE_TN_CITY_3096: "पेरणमपट्टू",
        STATE_TN_CITY_3097: "पेरावुराणी",
        STATE_NL_CITY_3098: "पेरेन",
        STATE_TN_CITY_3099: "पेरियाकुलम",
        STATE_TN_CITY_3100: "पेरीयानायककनपलायम",
        STATE_TN_CITY_3101: "पेरियानेगमम",
        STATE_TN_CITY_3102: "पेरियापट्टी",
        STATE_TN_CITY_3103: "पेरियापट्टिनम",
        STATE_GA_CITY_3104: "पेर्नेम",
        STATE_KL_CITY_3105: "पेरुम्बवूर",
        STATE_KL_CITY_3106: "पेरुमपावूर",
        STATE_TN_CITY_3107: "पेरुंडुराई",
        STATE_TN_CITY_3108: "पेरुंगुडी",
        STATE_TN_CITY_3109: "पेरूर",
        STATE_KL_CITY_3110: "पेर्या",
        STATE_GJ_CITY_3111: "पेटलाड",
        STATE_MP_CITY_3112: "पेटलावद",
        STATE_PB_CITY_3113: "फगवाडा",
        STATE_UP_CITY_3114: "फलौदा",
        STATE_RJ_CITY_3115: "फलोदी",
        STATE_MH_CITY_3116: "फलटण",
        STATE_UP_CITY_3117: "फाफमाळ",
        STATE_UP_CITY_3118: "फाफुंड",
        STATE_UP_CITY_3119: "फरीहा",
        STATE_MN_CITY_3120: "फेक",
        STATE_NL_CITY_3121: "फेक",
        STATE_UP_CITY_3122: "फेओना",
        STATE_PB_CITY_3123: "फिल्लौर",
        STATE_AP_CITY_3124: "फिरंगीपुरम",
        STATE_MH_CITY_3125: "फुलंब्री",
        STATE_OR_CITY_3126: "फुलबनी",
        STATE_RJ_CITY_3127: "फुलेरा",
        STATE_UP_CITY_3128: "फुलपूर",
        STATE_UP_CITY_3129: "पिचौरा",
        STATE_UP_CITY_3130: "पिहाणी",
        STATE_RJ_CITY_3131: "पिलानी",
        STATE_RJ_CITY_3132: "पिलीबंगान",
        STATE_UP_CITY_3133: "पिलीभीत",
        STATE_MH_CITY_3134: "पिलिव्ह",
        STATE_UP_CITY_3135: "पिलखुआ",
        STATE_UP_CITY_3136: "पिलखुवा",
        STATE_MH_CITY_3137: "पिंपळगाव बसवंत",
        STATE_MH_CITY_3138: "पिंपळगाव राजा",
        STATE_MH_CITY_3139: "पिंपरी",
        STATE_MH_CITY_3140: "पिंपरी-चिंचवड",
        STATE_UP_CITY_3141: "पिनाहत",
        STATE_RJ_CITY_3142: "पिंडवाडा",
        STATE_HR_CITY_3143: "पिंजौर",
        STATE_UT_CITY_3144: "पिपळकोटी",
        STATE_RJ_CITY_3145: "पिपर",
        STATE_GJ_CITY_3146: "पिपावाव",
        STATE_OR_CITY_3147: "पिपिली",
        STATE_GJ_CITY_3148: "पिपलोद",
        STATE_MP_CITY_3149: "पिपलोडा",
        STATE_AP_CITY_3150: "पिप्पारा",
        STATE_UP_CITY_3151: "पिपराइच",
        STATE_MH_CITY_3152: "पिपरी",
        STATE_UP_CITY_3153: "पिपरी",
        STATE_KL_CITY_3154: "पिरावम",
        STATE_RJ_CITY_3155: "पिरवा",
        STATE_KA_CITY_3156: "पिरियापटना",
        STATE_BR_CITY_3157: "पिरो",
        STATE_DL_CITY_3158: "पीतमपुरा",
        STATE_MP_CITY_3159: "पिथमपूर",
        STATE_AP_CITY_3160: "पिठापुरम",
        STATE_CT_CITY_3161: "पिथोरा",
        STATE_UT_CITY_3162: "पिथौरागढ",
        STATE_RJ_CITY_3163: "पोकरन",
        STATE_OR_CITY_3164: "पोलासरा",
        STATE_AP_CITY_3165: "पोलावरम",
        STATE_TN_CITY_3166: "पोल्लाची",
        STATE_TN_CITY_3167: "पोलूर",
        STATE_GA_CITY_3168: "फोंडा",
        STATE_KL_CITY_3169: "पोनमणा",
        STATE_TN_CITY_3170: "पोन्नमारावती",
        STATE_KA_CITY_3171: "पोन्नमपेट",
        STATE_KL_CITY_3172: "पोन्नानी",
        STATE_TN_CITY_3173: "पोनेरी",
        STATE_AP_CITY_3174: "पोन्नूर",
        STATE_AP_CITY_3175: "पोन्नुरू",
        STATE_TN_CITY_3176: "पूनमल्ले",
        STATE_GJ_CITY_3177: "पोरबंदर",
        STATE_MP_CITY_3178: "पोरसा",
        STATE_AN_CITY_3179: "पोर्ट ब्लेअर",
        STATE_TN_CITY_3180: "पोरूर",
        STATE_MH_CITY_3181: "पवई",
        STATE_MH_CITY_3182: "प्रभादेवी",
        STATE_GJ_CITY_3183: "प्रभास पाटण",
        STATE_AP_CITY_3184: "प्रकाशम",
        STATE_MH_CITY_3185: "प्रकाशा",
        STATE_GJ_CITY_3186: "प्रांतिज",
        STATE_RJ_CITY_3187: "प्रतापगड",
        STATE_UP_CITY_3188: "प्रतापगड",
        STATE_UP_CITY_3189: "प्रयागराज (अलाहाबाद)",
        STATE_AP_CITY_3190: "प्रदातुर",
        STATE_PY_CITY_3191: "पुद्दुचेरी",
        STATE_TN_CITY_3192: "पुदुकोट्टाई",
        STATE_TN_CITY_3193: "पुडुप्पत्ती",
        STATE_TN_CITY_3194: "पुदुर",
        STATE_TN_CITY_3195: "पुदुवायल",
        STATE_WB_CITY_3196: "पुजाली",
        STATE_UP_CITY_3197: "पुखरायण",
        STATE_MH_CITY_3198: "पुलगाव",
        STATE_AP_CITY_3199: "पुलिवेंडला",
        STATE_TN_CITY_3200: "पुलियांगुडी",
        STATE_TN_CITY_3201: "पुलियुर",
        STATE_TN_CITY_3202: "पुल्लंबडी",
        STATE_JK_CITY_3203: "पुलवामा",
        STATE_HR_CITY_3204: "पुनाहणा",
        STATE_KL_CITY_3205: "पुनालूर",
        STATE_MP_CITY_3206: "पुनासा",
        STATE_JK_CITY_3207: "पंच",
        STATE_WB_CITY_3208: "पंच समुदाय विकास गट",
        STATE_HR_CITY_3209: "पुंद्री",
        STATE_MH_CITY_3210: "पुणे",
        STATE_MH_CITY_3211: "पुणे विभाग",
        STATE_AP_CITY_3212: "पुंगानुरु",
        STATE_TN_CITY_3213: "पुंजाई पुलीयमपट्टी",
        STATE_MH_CITY_3214: "पुणतांबा",
        STATE_BR_CITY_3215: "पुपरी",
        STATE_MH_CITY_3216: "पुरल",
        STATE_UP_CITY_3217: "पुरणपूर",
        STATE_BR_CITY_3218: "पूर्वा चंपारण",
        STATE_WB_CITY_3219: "पूर्वा मेदिनीपूर जिल्हा",
        STATE_JH_CITY_3220: "पूर्वा सिंगभूम",
        STATE_OR_CITY_3221: "पुरी",
        STATE_UP_CITY_3222: "पुरमाफी",
        STATE_MH_CITY_3223: "पूर्णा",
        STATE_BR_CITY_3224: "पूर्णिया",
        STATE_WB_CITY_3225: "पुरुलिया",
        STATE_OR_CITY_3226: "पुरुषोत्तमपूर",
        STATE_UP_CITY_3227: "पूर्वा",
        STATE_MH_CITY_3228: "पुसद",
        STATE_RJ_CITY_3229: "पुष्कर",
        STATE_AP_CITY_3230: "पुट्टपर्थी",
        STATE_KA_CITY_3231: "पुत्तूर",
        STATE_AP_CITY_3232: "पुत्तूर",
        STATE_PB_CITY_3233: "कादियान",
        STATE_UP_CITY_3234: "कादिरगंज",
        STATE_JK_CITY_3235: "काझीगुंड",
        STATE_GA_CITY_3236: "क्वेपेम",
        STATE_GA_CITY_3237: "क्युला",
        STATE_TG_CITY_3238: "कुथबुल्लापूर",
        STATE_KA_CITY_3239: "रबकवी",
        STATE_UP_CITY_3240: "राबुपुरा",
        STATE_HR_CITY_3241: "राडौर",
        STATE_UP_CITY_3242: "राधाकुंड",
        STATE_UP_CITY_3243: "राधाकुंड",
        STATE_MH_CITY_3244: "राधानगरी",
        STATE_GJ_CITY_3245: "राधनपूर",
        STATE_UP_CITY_3246: "रायबरेली",
        STATE_BR_CITY_3247: "रफीगंज",
        STATE_MP_CITY_3248: "राघोगड",
        STATE_WB_CITY_3249: "रघुदेब्बती",
        STATE_BR_CITY_3250: "रघुनाथपूर",
        STATE_WB_CITY_3251: "रघुनाथपूर",
        STATE_AS_CITY_3252: "राहा",
        STATE_MH_CITY_3253: "राहाता",
        STATE_MP_CITY_3254: "रहाटगड",
        STATE_MH_CITY_3255: "रहिमतपूर",
        STATE_PB_CITY_3256: "राहोन",
        STATE_MH_CITY_3257: "राहुरी",
        STATE_GA_CITY_3258: "राया",
        STATE_KA_CITY_3259: "रायचूर",
        STATE_WB_CITY_3260: "रायगंज",
        STATE_CT_CITY_3261: "रायगड",
        STATE_MH_CITY_3262: "रायगड",
        STATE_PB_CITY_3263: "रायकोट",
        STATE_RJ_CITY_3264: "रायपूर",
        STATE_CT_CITY_3265: "रायपूर",
        STATE_UT_CITY_3266: "रायपूर",
        STATE_MH_CITY_3267: "रायरेश्वर",
        STATE_MP_CITY_3268: "रायसेन",
        STATE_RJ_CITY_3269: "रायसिंगनगर",
        STATE_UT_CITY_3270: "रायवाला बारा",
        STATE_CT_CITY_3271: "राज नांदगाव",
        STATE_CT_CITY_3272: "राज-नांदगाव",
        STATE_AP_CITY_3273: "राजमुंद्री",
        STATE_RJ_CITY_3274: "राजखेरा",
        STATE_RJ_CITY_3275: "राजलदेसर",
        STATE_TG_CITY_3276: "राजन्ना सरसिल्ला",
        STATE_JK_CITY_3277: "राजोरी",
        STATE_TN_CITY_3278: "राजापलायम",
        STATE_MH_CITY_3279: "राजापूर",
        STATE_UP_CITY_3280: "राजापूर",
        STATE_PB_CITY_3281: "राजसांसी",
        STATE_JK_CITY_3282: "राजौरी",
        STATE_RJ_CITY_3283: "राजगड",
        STATE_MP_CITY_3284: "राजगड",
        STATE_HP_CITY_3285: "राजगड",
        STATE_BR_CITY_3286: "राजगीर",
        STATE_MH_CITY_3287: "राजगुरुनगर",
        STATE_GJ_CITY_3288: "राजकोट",
        STATE_WB_CITY_3289: "राजमहाल",
        STATE_MP_CITY_3290: "राजनगर",
        STATE_WB_CITY_3291: "राजनगर कम्युनिटी डेव्हलपमेंट ब्लॉक",
        STATE_GJ_CITY_3292: "राजपिपला",
        STATE_MP_CITY_3293: "राजपूर",
        STATE_PB_CITY_3294: "राजपुरा",
        STATE_RJ_CITY_3295: "राजसमंद",
        STATE_GJ_CITY_3296: "राजुला",
        STATE_MH_CITY_3297: "राजूर",
        STATE_MH_CITY_3298: "राजुरा",
        STATE_MH_CITY_3299: "राळेगाव",
        STATE_PB_CITY_3300: "राम दास",
        STATE_AP_CITY_3301: "रामचंद्रपुरम",
        STATE_TG_CITY_3302: "रामागुंडम",
        STATE_KL_CITY_3303: "राममंगलम",
        STATE_KA_CITY_3304: "रामनगरा",
        STATE_TN_CITY_3305: "रामनाथपुरम",
        STATE_AP_CITY_3306: "रामनयापेता",
        STATE_CT_CITY_3307: "रामानुज गंज",
        STATE_AP_CITY_3308: "रामापुरम",
        STATE_JK_CITY_3309: "रामबन",
        STATE_OR_CITY_3310: "रंभा",
        STATE_WB_CITY_3311: "रामचंद्रपूर",
        STATE_TN_CITY_3312: "रामेश्वरम",
        STATE_MH_CITY_3313: "रामेवाडी",
        STATE_RJ_CITY_3314: "रामगंज मंडी",
        STATE_JH_CITY_3315: "रामगड",
        STATE_RJ_CITY_3316: "रामगड",
        STATE_JK_CITY_3317: "रामगड",
        STATE_TG_CITY_3318: "रामगुंडम",
        STATE_WB_CITY_3319: "रामजीबानपूर",
        STATE_UP_CITY_3320: "रामकोला",
        STATE_BR_CITY_3321: "रामनगर",
        STATE_JK_CITY_3322: "रामनगर",
        STATE_UT_CITY_3323: "रामनगर",
        STATE_UP_CITY_3324: "रामनगर",
        STATE_WB_CITY_3325: "रामनगर",
        STATE_AP_CITY_3326: "रामपचोदवरम",
        STATE_UP_CITY_3327: "रामपूर",
        STATE_HP_CITY_3328: "रामपूर",
        STATE_WB_CITY_3329: "रामपूर हाट",
        STATE_UP_CITY_3330: "रामपुरा",
        STATE_PB_CITY_3331: "रामपुरा",
        STATE_MP_CITY_3332: "रामपुरा",
        STATE_MH_CITY_3333: "रामटेक",
        STATE_WB_CITY_3334: "राणाघाट",
        STATE_MP_CITY_3335: "राणापूर",
        STATE_GJ_CITY_3336: "राणावाव",
        STATE_JH_CITY_3337: "रांची",
        STATE_AS_CITY_3338: "रंगपरा",
        STATE_TG_CITY_3339: "रंगारेड्डी",
        STATE_AS_CITY_3340: "रंगिया",
        STATE_SK_CITY_3341: "रंगपो",
        STATE_RJ_CITY_3342: "राणी",
        STATE_HR_CITY_3343: "रानिया",
        STATE_KA_CITY_3344: "राणीबेन्नूर",
        STATE_WB_CITY_3345: "राणीगंज",
        STATE_UT_CITY_3346: "राणीखेत",
        STATE_UP_CITY_3347: "राणीपूर",
        STATE_UP_CITY_3348: "राणीपूर बारसी",
        STATE_TR_CITY_3349: "राणीर बाजार",
        STATE_GJ_CITY_3350: "राणपूर",
        STATE_GJ_CITY_3351: "रापर",
        STATE_TN_CITY_3352: "रासिपुरम",
        STATE_UP_CITY_3353: "रसरा",
        STATE_UP_CITY_3354: "रसुलाबाद",
        STATE_RJ_CITY_3355: "रतनगड",
        STATE_MP_CITY_3356: "रतनगड",
        STATE_CT_CITY_3357: "रतनपूर",
        STATE_UP_CITY_3358: "रथ",
        STATE_HR_CITY_3359: "रतीया",
        STATE_MP_CITY_3360: "रतलाम",
        STATE_MH_CITY_3361: "रत्नागिरी",
        STATE_OR_CITY_3362: "राउरकेला",
        STATE_MH_CITY_3363: "रावेर",
        STATE_RJ_CITY_3364: "रावतभाटा",
        STATE_RJ_CITY_3365: "रावतसर",
        STATE_BR_CITY_3366: "रक्सौल",
        STATE_JH_CITY_3367: "रे",
        STATE_UP_CITY_3368: "राया",
        STATE_AP_CITY_3369: "रायचोटी",
        STATE_AP_CITY_3370: "रायड्रग",
        STATE_OR_CITY_3371: "रायगडा",
        STATE_KA_CITY_3372: "रायबाग",
        STATE_WB_CITY_3373: "रायपूर",
        STATE_AP_CITY_3374: "रझम",
        STATE_AP_CITY_3375: "रझामपेटा",
        STATE_AP_CITY_3376: "रझोले",
        STATE_GJ_CITY_3377: "रेहा",
        STATE_UP_CITY_3378: "रेहर",
        STATE_MP_CITY_3379: "रेहली",
        STATE_MP_CITY_3380: "रेहती",
        STATE_OR_CITY_3381: "रेमुना",
        STATE_MH_CITY_3382: "रेणापूर",
        STATE_MH_CITY_3383: "रेणावी",
        STATE_OR_CITY_3384: "रेंगाळी",
        STATE_AP_CITY_3385: "रेनिगुंता",
        STATE_UP_CITY_3386: "रेणुकूट",
        STATE_UP_CITY_3387: "रेणुकुत",
        STATE_UP_CITY_3388: "रेओती",
        STATE_UP_CITY_3389: "रेतीपूर",
        STATE_AP_CITY_3390: "रेपल्ले",
        STATE_MH_CITY_3391: "रेवदंडा",
        STATE_MH_CITY_3392: "रेवदंडा",
        STATE_BR_CITY_3393: "रेवेलगंज",
        STATE_MP_CITY_3394: "रेवा",
        STATE_HR_CITY_3395: "रेवाडी",
        STATE_HR_CITY_3396: "रेवाडी जिल्हा",
        STATE_ML_CITY_3397: "रि-भोई",
        STATE_JK_CITY_3398: "रियासी",
        STATE_UP_CITY_3399: "रिचा",
        STATE_RJ_CITY_3400: "रिंगा",
        STATE_UT_CITY_3401: "ऋषिकेश",
        STATE_WB_CITY_3402: "रिश्रा",
        STATE_MH_CITY_3403: "रिसोड",
        STATE_UP_CITY_3404: "रॉबर्टसगंज",
        STATE_KA_CITY_3405: "रॉबर्टसनपेट",
        STATE_GJ_CITY_3406: "रोहा",
        STATE_MH_CITY_3407: "रोहा",
        STATE_DL_CITY_3408: "रोहिणी",
        STATE_HP_CITY_3409: "रोहरू",
        STATE_HR_CITY_3410: "रोहतक",
        STATE_BR_CITY_3411: "रोहतास",
        STATE_KA_CITY_3412: "रॉन",
        STATE_UT_CITY_3413: "रुरकी",
        STATE_UP_CITY_3414: "रुदरपूर",
        STATE_UP_CITY_3415: "रुदौली",
        STATE_UT_CITY_3416: "रुद्रप्रयाग",
        STATE_PB_CITY_3417: "रुपनगर",
        STATE_UP_CITY_3418: "रुरा",
        STATE_BR_CITY_3419: "रुसेरा",
        STATE_MP_CITY_3420: "सबलगड",
        STATE_UP_CITY_3421: "सबलपूर",
        STATE_GJ_CITY_3422: "साबर कंठा",
        STATE_HP_CITY_3423: "सबथु",
        STATE_TR_CITY_3424: "साब्रम",
        STATE_UP_CITY_3425: "सचेंडी",
        STATE_GJ_CITY_3426: "सचिन",
        STATE_UP_CITY_3427: "सादाबाद",
        STATE_KA_CITY_3428: "सदलगी",
        STATE_TG_CITY_3429: "सदासोपेत",
        STATE_UP_CITY_3430: "सादात",
        STATE_RJ_CITY_3431: "सदरी",
        STATE_HR_CITY_3432: "सफिडॉन",
        STATE_UP_CITY_3433: "सफीपूर",
        STATE_KA_CITY_3434: "सागर",
        STATE_MP_CITY_3435: "सागर",
        STATE_BR_CITY_3436: "सागौळी",
        STATE_WB_CITY_3437: "सहापूर",
        STATE_UP_CITY_3438: "सहारनपूर",
        STATE_BR_CITY_3439: "सहरसा",
        STATE_UP_CITY_3440: "सहसपूर",
        STATE_UP_CITY_3441: "सहस्वान",
        STATE_UP_CITY_3442: "सहावर",
        STATE_UP_CITY_3443: "साहिबाबाद",
        STATE_JH_CITY_3444: "साहिबगंज",
        STATE_UP_CITY_3445: "साहपळ",
        STATE_UP_CITY_3446: "सैदपूर",
        STATE_MZ_CITY_3447: "सायहा",
        STATE_MP_CITY_3448: "सैलाना",
        STATE_MH_CITY_3449: "सायलू",
        STATE_TN_CITY_3450: "सेंट थॉमस माउंट",
        STATE_WB_CITY_3451: "सायंथिया",
        STATE_MZ_CITY_3452: "सायरंग",
        STATE_MZ_CITY_3453: "सैतलाव",
        STATE_UP_CITY_3454: "सखानु",
        STATE_UP_CITY_3455: "सकित",
        STATE_KA_CITY_3456: "सकलेशपूर",
        STATE_MH_CITY_3457: "साकोळ",
        STATE_MH_CITY_3458: "साकोली",
        STATE_MH_CITY_3459: "साक्री",
        STATE_CT_CITY_3460: "शक्ती",
        STATE_WB_CITY_3461: "सलनपूर समाज विकास गट",
        STATE_GJ_CITY_3462: "सल्या",
        STATE_TN_CITY_3463: "सालेम",
        STATE_UP_CITY_3464: "सालेमपूर",
        STATE_GA_CITY_3465: "साळीगाव",
        STATE_UP_CITY_3466: "सलून",
        STATE_RJ_CITY_3467: "साळुंबर",
        STATE_AP_CITY_3468: "सालूर",
        STATE_GJ_CITY_3469: "समखियाली",
        STATE_HR_CITY_3470: "समलखा",
        STATE_AP_CITY_3471: "समलकोट",
        STATE_BR_CITY_3472: "समस्तीपूर",
        STATE_JK_CITY_3473: "सांबा",
        STATE_OR_CITY_3474: "संबळपूर",
        STATE_UP_CITY_3475: "संभळ",
        STATE_RJ_CITY_3476: "सांभार",
        STATE_RJ_CITY_3477: "समदरी",
        STATE_PB_CITY_3478: "समराळा",
        STATE_UP_CITY_3479: "समथर",
        STATE_MH_CITY_3480: "समुद्रपूर",
        STATE_GJ_CITY_3481: "सानंद",
        STATE_PB_CITY_3482: "सनौर",
        STATE_MP_CITY_3483: "सनावद",
        STATE_MP_CITY_3484: "सांची",
        STATE_RJ_CITY_3485: "सांचोर",
        STATE_GA_CITY_3486: "सांकोले",
        STATE_UP_CITY_3487: "सांडी",
        STATE_UP_CITY_3488: "सांडिला",
        STATE_KA_CITY_3489: "सांडूर",
        STATE_MH_CITY_3490: "संगमेश्वर",
        STATE_MH_CITY_3491: "संगमनेर",
        STATE_TG_CITY_3492: "संगारेड्डी",
        STATE_RJ_CITY_3493: "संगरिया",
        STATE_MH_CITY_3494: "सांगली",
        STATE_RJ_CITY_3495: "सांगोड",
        STATE_MH_CITY_3496: "सांगोला",
        STATE_MH_CITY_3497: "सांगोळे",
        STATE_MH_CITY_3498: "संग्रामपूर, महाराष्ट्र",
        STATE_PB_CITY_3499: "संगरूर",
        STATE_GA_CITY_3500: "संगुम",
        STATE_KA_CITY_3501: "सनिवारसंते",
        STATE_WB_CITY_3502: "शंकरपूर",
        STATE_KA_CITY_3503: "संकेश्वर",
        STATE_GJ_CITY_3504: "संखेडा",
        STATE_WB_CITY_3505: "संकरेल",
        STATE_GA_CITY_3506: "सॅन्क्वेलिम",
        STATE_UP_CITY_3507: "संत कबीर नगर",
        STATE_UP_CITY_3508: "संत रविदास नगर",
        STATE_WB_CITY_3509: "संतीपूर",
        STATE_HP_CITY_3510: "संतोखगड",
        STATE_WB_CITY_3511: "संतोषपूर",
        STATE_WB_CITY_3512: "संतुरी समुदाय विकास गट",
        STATE_GA_CITY_3513: "सॅन्वॉर्डेम",
        STATE_MP_CITY_3514: "सनवर",
        STATE_MH_CITY_3515: "साओली",
        STATE_MH_CITY_3516: "सावनेर",
        STATE_AS_CITY_3517: "सप्तग्राम",
        STATE_HP_CITY_3518: "साराहन",
        STATE_UP_CITY_3519: "सराई अकील",
        STATE_UP_CITY_3520: "सराई एकदिल",
        STATE_UP_CITY_3521: "सराय मीर",
        STATE_JH_CITY_3522: "सरायकेला",
        STATE_CT_CITY_3523: "सराईपली",
        STATE_BR_CITY_3524: "सारण",
        STATE_CT_CITY_3525: "सारंगढ",
        STATE_MH_CITY_3526: "सारंगखेडा",
        STATE_MP_CITY_3527: "सारंगपूर",
        STATE_UP_CITY_3528: "सरौली",
        STATE_GJ_CITY_3529: "सरभोन",
        STATE_RJ_CITY_3530: "सरदारशहर",
        STATE_UP_CITY_3531: "सरधना",
        STATE_GJ_CITY_3532: "सरदोई",
        STATE_PB_CITY_3533: "सरदुलगड",
        STATE_WB_CITY_3534: "सारेंगा",
        STATE_KA_CITY_3535: "सरगुर",
        STATE_UP_CITY_3536: "सरिला",
        STATE_HP_CITY_3537: "सरका घाट",
        STATE_GJ_CITY_3538: "सरखेज",
        STATE_JH_CITY_3539: "सरुबेरा",
        STATE_AS_CITY_3540: "सरूपथर",
        STATE_UP_CITY_3541: "सरूरपूर",
        STATE_RJ_CITY_3542: "सरवर",
        STATE_UP_CITY_3543: "सासनी",
        STATE_MH_CITY_3544: "सासवड",
        STATE_MH_CITY_3545: "सासवड",
        STATE_MH_CITY_3546: "सटाणा",
        STATE_MH_CITY_3547: "सातारा",
        STATE_MH_CITY_3548: "सातारा विभाग",
        STATE_GJ_CITY_3549: "सातंबा",
        STATE_TN_CITY_3550: "सथनकुलम",
        STATE_TG_CITY_3551: "सथुपल्ली",
        STATE_TN_CITY_3552: "सत्यमंगलम",
        STATE_MP_CITY_3553: "सतना",
        STATE_MH_CITY_3554: "सत्पती",
        STATE_UP_CITY_3555: "सात्रीख",
        STATE_AP_CITY_3556: "सत्तानापल्ले",
        STATE_TN_CITY_3557: "सत्तूर",
        STATE_MP_CITY_3558: "सत्वस",
        STATE_MP_CITY_3559: "सौगोर",
        STATE_KA_CITY_3560: "सौंदत्ती",
        STATE_UP_CITY_3561: "सौरीख",
        STATE_MP_CITY_3562: "सौसर",
        STATE_MH_CITY_3563: "सावंतवाडी",
        STATE_KA_CITY_3564: "सावनूर",
        STATE_GJ_CITY_3565: "सावरकुंडला",
        STATE_MH_CITY_3566: "सावदा",
        STATE_MH_CITY_3567: "सावळाज",
        STATE_GJ_CITY_3568: "सावली",
        STATE_RJ_CITY_3569: "सवाई माधोपूर",
        STATE_MH_CITY_3570: "सावंतवाडी",
        STATE_TN_CITY_3571: "सायलकुडी",
        STATE_GJ_CITY_3572: "सायला",
        STATE_UP_CITY_3573: "क्षेत्र",
        STATE_TG_CITY_3574: "सिकंदराबाद",
        STATE_MP_CITY_3575: "सिहोर",
        STATE_MH_CITY_3576: "सेलू",
        STATE_MN_CITY_3577: "सेनापती",
        STATE_MP_CITY_3578: "सेंधवा",
        STATE_UP_CITY_3579: "सेओहरा",
        STATE_MP_CITY_3580: "शेवंडा",
        STATE_HP_CITY_3581: "सिवनी",
        STATE_MP_CITY_3582: "सिवनी",
        STATE_MP_CITY_3583: "सिवनी माळवा",
        STATE_CT_CITY_3584: "सेओरीनारायण",
        STATE_KA_CITY_3585: "सेरम",
        STATE_WB_CITY_3586: "सेरामपूर",
        STATE_MZ_CITY_3587: "सरचिप",
        STATE_TG_CITY_3588: "सेरिलिंगमपल्ले",
        STATE_WB_CITY_3589: "सेरपूर",
        STATE_GA_CITY_3590: "सेरुला",
        STATE_MH_CITY_3591: "सेवाग्राम",
        STATE_TN_CITY_3592: "सात पॅगोडा",
        STATE_MH_CITY_3593: "शिवडी",
        STATE_HR_CITY_3594: "शादीपूर जुलाना",
        STATE_UP_CITY_3595: "शहााबाद",
        STATE_HR_CITY_3596: "शहााबाद",
        STATE_KA_CITY_3597: "शहााबाद",
        STATE_MH_CITY_3598: "शहादा",
        STATE_MH_CITY_3599: "शहापूर",
        STATE_BR_CITY_3600: "शाहबाजपूर",
        STATE_MP_CITY_3601: "शहाडोल",
        STATE_UP_CITY_3602: "शहागंज",
        STATE_MP_CITY_3603: "शहागढ",
        STATE_UP_CITY_3604: "शाही",
        STATE_PB_CITY_3605: "शहीद भगतसिंग नगर",
        STATE_UP_CITY_3606: "शहाजहानपूर",
        STATE_PB_CITY_3607: "शाहकोट",
        STATE_KA_CITY_3608: "शहापूर",
        STATE_MP_CITY_3609: "शहापूर",
        STATE_GJ_CITY_3610: "शहापूर",
        STATE_UP_CITY_3611: "शहापूर",
        STATE_BR_CITY_3612: "शहापूर",
        STATE_RJ_CITY_3613: "शाहपुरा",
        STATE_MP_CITY_3614: "शाहपुरा",
        STATE_MP_CITY_3615: "शाजापूर",
        STATE_PB_CITY_3616: "शाम चुरासी",
        STATE_MP_CITY_3617: "शामगढ",
        STATE_UP_CITY_3618: "शामली",
        STATE_UP_CITY_3619: "शम्साबाद",
        STATE_UP_CITY_3620: "शंकरगड",
        STATE_MH_CITY_3621: "शेडबाळ",
        STATE_MH_CITY_3622: "शेगाव",
        STATE_BR_CITY_3623: "शेखपुरा",
        STATE_RJ_CITY_3624: "शेओगंज",
        STATE_BR_CITY_3625: "शेओहर",
        STATE_MP_CITY_3626: "श्योपूर",
        STATE_UP_CITY_3627: "शेरगड",
        STATE_BR_CITY_3628: "शेरघाटी",
        STATE_UP_CITY_3629: "शेरकोट",
        STATE_KL_CITY_3630: "शेरताल्लई",
        STATE_MH_CITY_3631: "शेवगाव",
        STATE_UP_CITY_3632: "शिबनगर",
        STATE_KA_CITY_3633: "शिगाव",
        STATE_KA_CITY_3634: "शिकारपूर",
        STATE_UP_CITY_3635: "शिकारपूर",
        STATE_UP_CITY_3636: "शिकारपूर (बुलंदशहर)",
        STATE_UP_CITY_3637: "शिकोहाबाद",
        STATE_MH_CITY_3638: "शिक्रापूर",
        STATE_ML_CITY_3639: "शिलाँग",
        STATE_HP_CITY_3640: "शिमला",
        STATE_KA_CITY_3641: "शिमोगा",
        STATE_MH_CITY_3642: "शिरगुप्पी",
        STATE_MH_CITY_3643: "शिराळा",
        STATE_MH_CITY_3644: "शिर्डी",
        STATE_MH_CITY_3645: "शिरगाव",
        STATE_KA_CITY_3646: "शिरहट्टी",
        STATE_MH_CITY_3647: "शिरोळ",
        STATE_MH_CITY_3648: "शिरपूर",
        STATE_MH_CITY_3649: "शिरूड",
        STATE_MH_CITY_3650: "शिरवळ",
        STATE_UP_CITY_3651: "शिशगड",
        STATE_MH_CITY_3652: "शिवाजी नगर",
        STATE_MP_CITY_3653: "शिवपुरी",
        STATE_GJ_CITY_3654: "शिवराजपूर",
        STATE_UP_CITY_3655: "शिवराजपूर",
        STATE_TN_CITY_3656: "शोलिंगूर",
        STATE_KL_CITY_3657: "शोरानूर",
        STATE_KA_CITY_3658: "शोरापूर",
        STATE_UP_CITY_3659: "श्रावस्ती",
        STATE_MH_CITY_3660: "श्रीगोंदा",
        STATE_KA_CITY_3661: "श्रीरंगपट्टण",
        STATE_MP_CITY_3662: "शुजालपूर",
        STATE_JK_CITY_3663: "शुपियन",
        STATE_WB_CITY_3664: "श्यामनगर, पश्चिम बंगाल",
        STATE_AS_CITY_3665: "शिबसागर",
        STATE_KA_CITY_3666: "सिद्धापूर",
        STATE_UP_CITY_3667: "सिद्धार्थनगर",
        STATE_UP_CITY_3668: "सिद्धौर",
        STATE_GJ_CITY_3669: "सिद्धपूर",
        STATE_TG_CITY_3670: "सिद्धीपेठ",
        STATE_UP_CITY_3671: "सिधौली",
        STATE_MP_CITY_3672: "सिधी",
        STATE_UP_CITY_3673: "सिद्धपुरा",
        STATE_KA_CITY_3674: "सिडलघट्टा",
        STATE_GJ_CITY_3675: "सिहोर",
        STATE_MP_CITY_3676: "सिहोरा",
        STATE_JH_CITY_3677: "सिजुआ",
        STATE_UP_CITY_3678: "सिकंदराबाद",
        STATE_UP_CITY_3679: "सिकंदरपूर",
        STATE_UP_CITY_3680: "सिकंदरा",
        STATE_UP_CITY_3681: "सिकंदर राव",
        STATE_UP_CITY_3682: "सिकंदराबाद",
        STATE_RJ_CITY_3683: "सिकर",
        STATE_GJ_CITY_3684: "सिक्का",
        STATE_BR_CITY_3685: "सिलाओ",
        STATE_AS_CITY_3686: "सिलापठार",
        STATE_AS_CITY_3687: "सिलचर",
        STATE_WB_CITY_3688: "सिलीगुडी",
        STATE_MH_CITY_3689: "सिल्लोड",
        STATE_DN_CITY_3690: "सिल्वासा",
        STATE_MP_CITY_3691: "सिमरिया",
        STATE_JH_CITY_3692: "सिमडेगा",
        STATE_CT_CITY_3693: "सिमगा",
        STATE_MH_CITY_3694: "सिंदेवाही",
        STATE_KA_CITY_3695: "सिंदगी",
        STATE_KA_CITY_3696: "सिंधनूर",
        STATE_MH_CITY_3697: "सिंधुदुर्ग",
        STATE_MH_CITY_3698: "सिंदी",
        STATE_MH_CITY_3699: "सिंदखेडा",
        STATE_TN_CITY_3700: "सिंगनल्लूर",
        STATE_TN_CITY_3701: "सिंगापेरुमलकोविल",
        STATE_TG_CITY_3702: "सिंगापूर",
        STATE_AP_CITY_3703: "सिंगरायकोंडा",
        STATE_MP_CITY_3704: "सिंगोली",
        STATE_MP_CITY_3705: "सिंगरौली",
        STATE_SK_CITY_3706: "सिंगतम",
        STATE_WB_CITY_3707: "सिंगूर",
        STATE_JH_CITY_3708: "सिनी",
        STATE_MH_CITY_3709: "सिन्नर",
        STATE_GJ_CITY_3710: "सिनोर",
        STATE_MH_CITY_3711: "सायन, मुंबई",
        STATE_KA_CITY_3712: "सिरा",
        STATE_UP_CITY_3713: "सिरथु",
        STATE_PB_CITY_3714: "सरहिंद-फतेगड",
        STATE_TN_CITY_3715: "सिरकाळी",
        STATE_MP_CITY_3716: "सिरमौर",
        STATE_HP_CITY_3717: "सिरमौर",
        STATE_RJ_CITY_3718: "सिरोही",
        STATE_MH_CITY_3719: "सिरोंचा",
        STATE_MP_CITY_3720: "सिरोंज",
        STATE_TG_CITY_3721: "सिरपूर",
        STATE_HR_CITY_3722: "सिरसा",
        STATE_UP_CITY_3723: "सिरसा",
        STATE_UP_CITY_3724: "सिरसागंज",
        STATE_KA_CITY_3725: "सिरसी",
        STATE_UP_CITY_3726: "सिरसी",
        STATE_TG_CITY_3727: "सिरसिल्ला",
        STATE_KA_CITY_3728: "सिरगुप्पा",
        STATE_TN_CITY_3729: "सिरमुगाई",
        STATE_MH_CITY_3730: "सिरूर",
        STATE_UP_CITY_3731: "शिसौली",
        STATE_UP_CITY_3732: "शिस्वा बाजार",
        STATE_BR_CITY_3733: "सीतामढी",
        STATE_MP_CITY_3734: "सीतामाळ",
        STATE_UP_CITY_3735: "सीतापूर",
        STATE_UT_CITY_3736: "सितारगंज",
        STATE_TN_CITY_3737: "शिवगंगा",
        STATE_TN_CITY_3738: "शिवगिरी",
        STATE_TN_CITY_3739: "शिवकाशी",
        STATE_MH_CITY_3740: "शिवाला, पूर्व गोदावरी जिल्हा",
        STATE_BR_CITY_3741: "सिवान",
        STATE_RJ_CITY_3742: "शिवाना",
        STATE_AS_CITY_3743: "सोळकुची",
        STATE_WB_CITY_3744: "सोडपूर",
        STATE_MP_CITY_3745: "सोहागी",
        STATE_MP_CITY_3746: "सोहागपूर",
        STATE_HR_CITY_3747: "सोहना",
        STATE_RJ_CITY_3748: "सोजत",
        STATE_GJ_CITY_3749: "सोजित्रा",
        STATE_HP_CITY_3750: "सोलन",
        STATE_WB_CITY_3751: "सोलाप",
        STATE_MH_CITY_3752: "सोलापूर",
        STATE_GA_CITY_3753: "सॉलिम",
        STATE_KA_CITY_3754: "सोमेश्वर",
        STATE_AP_CITY_3755: "सोमपेटा",
        STATE_KA_CITY_3756: "सोमवारपेठ",
        STATE_WB_CITY_3757: "सोनाडा",
        STATE_MH_CITY_3758: "सोनाळा",
        STATE_WB_CITY_3759: "सोनमुखी",
        STATE_TR_CITY_3760: "सोनमुरा",
        STATE_AS_CITY_3761: "सोनारी",
        STATE_WB_CITY_3762: "सोनारपूर कम्युनिटी डेव्हलपमेंट ब्लॉक",
        STATE_UP_CITY_3763: "सोनभद्र",
        STATE_MH_CITY_3764: "सोनेगाव",
        STATE_OR_CITY_3765: "सोनपूर",
        STATE_GJ_CITY_3766: "सोनगढ",
        STATE_MH_CITY_3767: "सोनगीर",
        STATE_HR_CITY_3768: "सोनीपत",
        STATE_AS_CITY_3769: "सोनितपूर",
        STATE_MH_CITY_3770: "सोनवद",
        STATE_JK_CITY_3771: "सोपूर",
        STATE_KA_CITY_3772: "सोराब",
        STATE_OR_CITY_3773: "सोराडा",
        STATE_AS_CITY_3774: "सोरभोग",
        STATE_OR_CITY_3775: "सोरो",
        STATE_UP_CITY_3776: "सोरोन",
        STATE_WB_CITY_3777: "दक्षिण २४ परगणा जिल्हा",
        STATE_AN_CITY_3778: "दक्षिण अंदमान",
        STATE_DL_CITY_3779: "दक्षिण दिल्ली",
        STATE_SK_CITY_3780: "दक्षिण जिल्हा",
        STATE_ML_CITY_3781: "दक्षिण गारो हिल्स",
        STATE_GA_CITY_3782: "दक्षिण गोवा",
        STATE_TR_CITY_3783: "दक्षिण त्रिपुरा",
        STATE_DL_CITY_3784: "दक्षिण पश्चिम दिल्ली",
        STATE_ML_CITY_3785: "दक्षिण पश्चिम गारो हिल्स",
        STATE_ML_CITY_3786: "दक्षिण पश्चिम खासी टेकड्या",
        STATE_MH_CITY_3787: "सोयगाव",
        STATE_JK_CITY_3788: "सोयाबग",
        STATE_KA_CITY_3789: "श्रावण बेळगोळा",
        STATE_RJ_CITY_3790: "श्री डुंगरगड",
        STATE_RJ_CITY_3791: "श्री माधोपूर",
        STATE_PB_CITY_3792: "श्री मुक्तसर साहिब",
        STATE_AP_CITY_3793: "श्रीकाकुलम",
        STATE_WB_CITY_3794: "श्रीखंडा",
        STATE_TN_CITY_3795: "श्रीमुष्णम",
        STATE_JK_CITY_3796: "श्रीनगर",
        STATE_UT_CITY_3797: "श्रीनगर",
        STATE_KA_CITY_3798: "शृंगेरी",
        STATE_KA_CITY_3799: "श्रीनिवासपूर",
        STATE_TN_CITY_3800: "श्रीपेरंबुदुर",
        STATE_TG_CITY_3801: "श्रीरामनगर",
        STATE_WB_CITY_3802: "श्रीरामपूर",
        STATE_AP_CITY_3803: "श्रीशैलैन",
        STATE_TN_CITY_3804: "श्रीवैकुंटम",
        STATE_MH_CITY_3805: "श्रीवर्धन",
        STATE_TN_CITY_3806: "श्रीविल्लीपुथूर",
        STATE_UP_CITY_3807: "सूर",
        STATE_OR_CITY_3808: "सुबर्णपूर",
        STATE_TN_CITY_3809: "सुचिंद्रम",
        STATE_RJ_CITY_3810: "सुजानगड",
        STATE_RJ_CITY_3811: "सुकेत",
        STATE_UT_CITY_3812: "सुलतानपूर",
        STATE_MP_CITY_3813: "सुलतानपूर",
        STATE_UP_CITY_3814: "सुलतानपूर",
        STATE_PB_CITY_3815: "सुलतानपूर लोधी",
        STATE_TN_CITY_3816: "सुलुर",
        STATE_AP_CITY_3817: "सुलुरु",
        STATE_KA_CITY_3818: "सुल्या",
        STATE_JK_CITY_3819: "सुंबल",
        STATE_PB_CITY_3820: "सुनम",
        STATE_OR_CITY_3821: "सुंदरगड",
        STATE_HP_CITY_3822: "सुंदरनगर",
        STATE_RJ_CITY_3823: "सुनेल",
        STATE_KA_CITY_3824: "सुंतीकोप्पा",
        STATE_BR_CITY_3825: "सुपौल",
        STATE_GJ_CITY_3826: "सुपेडी",
        STATE_RJ_CITY_3827: "सूरजगड",
        STATE_TN_CITY_3828: "सुरंदाई",
        STATE_GJ_CITY_3829: "सुरत",
        STATE_RJ_CITY_3830: "सुरतगड",
        STATE_GJ_CITY_3831: "सुरेंद्रनगर",
        STATE_MH_CITY_3832: "सुरगाणा",
        STATE_CT_CITY_3833: "सुरगुजा",
        STATE_WB_CITY_3834: "सुरी",
        STATE_UP_CITY_3835: "सुरियनवान",
        STATE_TG_CITY_3836: "सुरियापेट",
        STATE_MP_CITY_3837: "सुसनर",
        STATE_GJ_CITY_3838: "सूत्रपाडा",
        STATE_TN_CITY_3839: "स्वामीमालाई",
        STATE_WB_CITY_3840: "स्वरूपनगर समुदाय विकास गट",
        STATE_AP_CITY_3841: "ताडेपल्ले",
        STATE_AP_CITY_3842: "ताडेपल्लेगुडेम",
        STATE_AP_CITY_3843: "ताडपत्री",
        STATE_UP_CITY_3844: "ताजपूर",
        STATE_WB_CITY_3845: "तकदाह",
        STATE_RJ_CITY_3846: "तखतगड",
        STATE_CT_CITY_3847: "तखतपूर",
        STATE_WB_CITY_3848: "टाकी",
        STATE_MH_CITY_3849: "टाकळीभान",
        STATE_MP_CITY_3850: "ता",
        STATE_GJ_CITY_3851: "तळाजा",
        STATE_UP_CITY_3852: "तालबात",
        STATE_MH_CITY_3853: "तालबीड",
        STATE_OR_CITY_3854: "तालचेर",
        STATE_MH_CITY_3855: "तळेगाव दाभाडे",
        STATE_MH_CITY_3856: "तळेगाव धामढेरे",
        STATE_GA_CITY_3857: "तळेगाव",
        STATE_MP_CITY_3858: "तालेन",
        STATE_UP_CITY_3859: "तालग्राम",
        STATE_KA_CITY_3860: "तालिकोटा",
        STATE_KL_CITY_3861: "तळीपरंबा",
        STATE_MH_CITY_3862: "तळोदा",
        STATE_MH_CITY_3863: "तळोदे",
        STATE_PB_CITY_3864: "तलवंडी भाई",
        STATE_PB_CITY_3865: "तलवाडा",
        STATE_TN_CITY_3866: "तांबरम",
        STATE_MN_CITY_3867: "तामेंगलाँग",
        STATE_WB_CITY_3868: "तामलुक",
        STATE_UT_CITY_3869: "टनकपूर",
        STATE_UP_CITY_3870: "तांडा",
        STATE_TG_CITY_3871: "तंदूर",
        STATE_TN_CITY_3872: "तंजोर",
        STATE_GJ_CITY_3873: "टंकारा",
        STATE_AP_CITY_3874: "तनुकू",
        STATE_HR_CITY_3875: "तोरू",
        STATE_GJ_CITY_3876: "तापी",
        STATE_OR_CITY_3877: "तारभा",
        STATE_WB_CITY_3878: "तारकेश्वर",
        STATE_TN_CITY_3879: "तारमंगलम",
        STATE_MP_CITY_3880: "तराना",
        STATE_RJ_CITY_3881: "तारानगर",
        STATE_MH_CITY_3882: "तारापूर",
        STATE_MH_CITY_3883: "तारदेव",
        STATE_KA_CITY_3884: "तारिकेरे",
        STATE_PB_CITY_3885: "तरन तारण साहिब",
        STATE_MH_CITY_3886: "तासगाव",
        STATE_TN_CITY_3887: "तट्टयंगरपेट्टय",
        STATE_AR_CITY_3888: "तवांग",
        STATE_BR_CITY_3889: "तेघरा",
        STATE_UT_CITY_3890: "टिहरी",
        STATE_UT_CITY_3891: "टिहरी-गढवाल",
        STATE_MP_CITY_3892: "टेकनपूर",
        STATE_BR_CITY_3893: "टेकरी",
        STATE_KA_CITY_3894: "टेक्कलकोट",
        STATE_AP_CITY_3895: "टेक्कली",
        STATE_MH_CITY_3896: "तेल्हारा",
        STATE_KL_CITY_3897: "तेल्लीचेरी",
        STATE_MP_CITY_3898: "तेंदुखेडा",
        STATE_MP_CITY_3899: "तेंथर",
        STATE_KA_CITY_3900: "तेरडल",
        STATE_UP_CITY_3901: "तेर्हा",
        STATE_AS_CITY_3902: "तेजपूर",
        STATE_AR_CITY_3903: "तेजू",
        STATE_UP_CITY_3904: "ठाकुरद्वारा",
        STATE_BR_CITY_3905: "ठाकूरगंज",
        STATE_MH_CITY_3906: "थाळनेर",
        STATE_GJ_CITY_3907: "पेक्षा",
        STATE_UP_CITY_3908: "ठाणे भवन",
        STATE_MP_CITY_3909: "थंडला",
        STATE_MH_CITY_3910: "ठाणे",
        STATE_HR_CITY_3911: "ठाणेसर",
        STATE_JK_CITY_3912: "थांग",
        STATE_GJ_CITY_3913: "ठाणगड",
        STATE_TN_CITY_3914: "तंजावर",
        STATE_JK_CITY_3915: "थन्ना मंडी",
        STATE_KL_CITY_3916: "थन्निअम",
        STATE_GJ_CITY_3917: "थरद",
        STATE_TN_CITY_3918: "तरंगंबडी",
        STATE_GJ_CITY_3919: "थसरा",
        STATE_GJ_CITY_3920: "डांग",
        STATE_TN_CITY_3921: "थेनी",
        STATE_TN_CITY_3922: "थेंकसी",
        STATE_MZ_CITY_3923: "थेनझॉल",
        STATE_HP_CITY_3924: "थिओग",
        STATE_TN_CITY_3925: "तिरुकट्टुपल्ली",
        STATE_TN_CITY_3926: "तिरुथनी",
        STATE_TN_CITY_3927: "तिरुवैयारू",
        STATE_TN_CITY_3928: "तिरुवल्लूर",
        STATE_KL_CITY_3929: "तिरुवनंतपुरम",
        STATE_TN_CITY_3930: "तिरुवरूर",
        STATE_TN_CITY_3931: "तिरुविदैमारुथुर",
        STATE_TN_CITY_3932: "थुथुकुडी",
        STATE_MN_CITY_3933: "थौबल",
        STATE_KL_CITY_3934: "त्रिशूर",
        STATE_KL_CITY_3935: "त्रिशूर जिल्हा",
        STATE_UP_CITY_3936: "टिग्री",
        STATE_RJ_CITY_3937: "तिजारा",
        STATE_UP_CITY_3938: "टिकैतनगर",
        STATE_MP_CITY_3939: "टिकमगड",
        STATE_UP_CITY_3940: "टिकरी",
        STATE_UP_CITY_3941: "तिल्हार",
        STATE_UP_CITY_3942: "तिळसाहरी",
        STATE_TN_CITY_3943: "टिंडीवनम",
        STATE_UP_CITY_3944: "तिंदवारी",
        STATE_TN_CITY_3945: "तिन्नूर",
        STATE_AS_CITY_3946: "तिनसुकिया",
        STATE_KA_CITY_3947: "तिप्तूर",
        STATE_HP_CITY_3948: "तिरा सुजानपूर",
        STATE_AR_CITY_3949: "तिरप",
        STATE_MP_CITY_3950: "तिरोडी",
        STATE_KA_CITY_3951: "तीर्थहळ्ळी",
        STATE_TN_CITY_3952: "तिरुच्छेंदूर",
        STATE_TN_CITY_3953: "तिरुचेनगोडे",
        STATE_TN_CITY_3954: "तिरुचिरापल्ली",
        STATE_TN_CITY_3955: "तिरुक्कोयलूर",
        STATE_KA_CITY_3956: "तिरुमाकुडल नरसीपूर",
        STATE_AP_CITY_3957: "तिरुमला",
        STATE_TN_CITY_3958: "तिरुमुल्लैवसल",
        STATE_TN_CITY_3959: "तिरुनेलवेली",
        STATE_TN_CITY_3960: "तिरुनेलवेली कट्टाबो",
        STATE_AP_CITY_3961: "तिरुपती",
        STATE_TN_CITY_3962: "तिरुप्पलाईकुडी",
        STATE_TN_CITY_3963: "तिरुप्परंगुनराम",
        STATE_TN_CITY_3964: "तिरुपूर",
        STATE_TN_CITY_3965: "तिरुप्पुवनम",
        STATE_KL_CITY_3966: "तिरूर",
        STATE_TN_CITY_3967: "तिरुत्तंगल",
        STATE_KL_CITY_3968: "तिरुवल्ला",
        STATE_TN_CITY_3969: "तिरुवन्नमलाई",
        STATE_TN_CITY_3970: "तिरुवोट्टीयुर",
        STATE_TN_CITY_3971: "तिसाईंविलाय",
        STATE_AS_CITY_3972: "तिताबर",
        STATE_WB_CITY_3973: "टिटागड",
        STATE_OR_CITY_3974: "तितलागड",
        STATE_UP_CITY_3975: "टायट्रॉन",
        STATE_RJ_CITY_3976: "तोडभीम",
        STATE_RJ_CITY_3977: "तोडरायसिंग",
        STATE_HR_CITY_3978: "तोहाणा",
        STATE_TN_CITY_3979: "तोंडी",
        STATE_RJ_CITY_3980: "टोंक",
        STATE_JH_CITY_3981: "टोपांची",
        STATE_UP_CITY_3982: "तोरी फतेहपूर",
        STATE_UP_CITY_3983: "तोरी-फतेहपूर",
        STATE_HR_CITY_3984: "तोशाम",
        STATE_JK_CITY_3985: "त्राल",
        STATE_MH_CITY_3986: "त्र्यंबक",
        STATE_MH_CITY_3987: "ट्रॉम्बे",
        STATE_JK_CITY_3988: "त्सर शरीफ",
        STATE_NL_CITY_3989: "तुएनसांग",
        STATE_NL_CITY_3990: "तुएनसांग जिल्हा",
        STATE_WB_CITY_3991: "तुफानगंज",
        STATE_WB_CITY_3992: "तुलिन",
        STATE_MH_CITY_3993: "तुळजापूर",
        STATE_UP_CITY_3994: "तुळशीपूर",
        STATE_KA_CITY_3995: "तुमकूर",
        STATE_MH_CITY_3996: "तुमसर",
        STATE_UP_CITY_3997: "तुंडला",
        STATE_AP_CITY_3998: "तुनी",
        STATE_ML_CITY_3999: "तुरा",
        STATE_TN_CITY_4000: "तुरायूर",
        STATE_KA_CITY_4001: "तुरुवेकेरे",
        STATE_WB_CITY_4002: "उचलन",
        STATE_TR_CITY_4003: "उदयपूर",
        STATE_RJ_CITY_4004: "उदयपूर",
        STATE_MP_CITY_4005: "उदयपुरा",
        STATE_AS_CITY_4006: "उदलगुरी",
        STATE_TN_CITY_4007: "उदंगुडी",
        STATE_OR_CITY_4008: "उदयगिरी",
        STATE_MH_CITY_4009: "उदगीर",
        STATE_UT_CITY_4010: "उधम सिंग नगर",
        STATE_JK_CITY_4011: "उधमपूर",
        STATE_RJ_CITY_4012: "उदपुरा",
        STATE_TN_CITY_4013: "उदुमलाईप्पट्टाई",
        STATE_KA_CITY_4014: "उडुपी",
        STATE_UP_CITY_4015: "उगु",
        STATE_UP_CITY_4016: "उजनी",
        STATE_MP_CITY_4017: "उज्जैन",
        STATE_MN_CITY_4018: "उखरुल",
        STATE_HR_CITY_4019: "उकलाना",
        STATE_MP_CITY_4020: "उकवा",
        STATE_WB_CITY_4021: "उला",
        STATE_MH_CITY_4022: "उल्हासनगर",
        STATE_KA_CITY_4023: "उल्लाल",
        STATE_WB_CITY_4024: "उलुबेरिया",
        STATE_MH_CITY_4025: "उमरगा",
        STATE_MP_CITY_4026: "उमरिया",
        STATE_MP_CITY_4027: "उमरिया जिल्हा",
        STATE_MH_CITY_4028: "उमरखेड",
        STATE_CT_CITY_4029: "उमरकोट",
        STATE_GJ_CITY_4030: "उमरपाडा",
        STATE_GJ_CITY_4031: "उमराळा",
        STATE_MH_CITY_4032: "उमरेड",
        STATE_GJ_CITY_4033: "उमरेठ",
        STATE_MP_CITY_4034: "उमरी",
        STATE_UP_CITY_4035: "उमरी",
        STATE_GJ_CITY_4036: "अन",
        STATE_UP_CITY_4037: "अन",
        STATE_HP_CITY_4038: "उना",
        STATE_GJ_CITY_4039: "उना",
        STATE_TR_CITY_4040: "उनाकोटी",
        STATE_MP_CITY_4041: "अनहेल",
        STATE_RJ_CITY_4042: "Uniara",
        STATE_GJ_CITY_4043: "उंझा",
        STATE_UP_CITY_4044: "उन्नाव",
        STATE_GJ_CITY_4045: "उपलेटा",
        STATE_TG_CITY_4046: "उप्पल कलान",
        STATE_AR_CITY_4047: "अप्पर सियांग",
        STATE_AR_CITY_4048: "अप्पर सुबनसिरी",
        STATE_TN_CITY_4049: "उप्पिलियापुरम",
        STATE_MH_CITY_4050: "उरण",
        STATE_AP_CITY_4051: "उरावकोंडा",
        STATE_JK_CITY_4052: "उरी",
        STATE_MH_CITY_4053: "उरुळी कांचन",
        STATE_UP_CITY_4054: "उसावन",
        STATE_UP_CITY_4055: "वापरत",
        STATE_TN_CITY_4056: "उसिलमपट्टी",
        STATE_UP_CITY_4057: "उसका",
        STATE_GJ_CITY_4058: "उत्रान",
        STATE_UP_CITY_4059: "उट्रौला",
        STATE_TN_CITY_4060: "उत्तमपालयम",
        STATE_CT_CITY_4061: "उत्तर बस्तर कांकेर",
        STATE_WB_CITY_4062: "उत्तर दिनाजपूर जिल्हा",
        STATE_KA_CITY_4063: "उत्तर कन्नड",
        STATE_UT_CITY_4064: "उत्तरकाशी",
        STATE_WB_CITY_4065: "उत्तरपारा कोटरंग",
        STATE_TN_CITY_4066: "उत्तरामेरूर",
        STATE_TN_CITY_4067: "उत्तुक्कुली",
        STATE_TN_CITY_4068: "व्हीएसकेवालसई (दिंडीगुल-जि.)",
        STATE_MH_CITY_4069: "वडा",
        STATE_TN_CITY_4070: "वडक्कू वल्लीयुर",
        STATE_TN_CITY_4071: "वडक्कू विरावनाल्लूर",
        STATE_TN_CITY_4072: "वडामदुराई",
        STATE_GJ_CITY_4073: "वडगाम",
        STATE_MH_CITY_4074: "वडगाव",
        STATE_KA_CITY_4075: "वडिगेनहल्ली",
        STATE_TN_CITY_4076: "वडिप्पत्ती",
        STATE_AP_CITY_4077: "वडलामुरू",
        STATE_AP_CITY_4078: "वडलापुडी",
        STATE_GJ_CITY_4079: "वडनगर",
        STATE_MH_CITY_4080: "वडनेर",
        STATE_GJ_CITY_4081: "वडोदरा",
        STATE_GA_CITY_4082: "वॅगेटर",
        STATE_GJ_CITY_4083: "वाघोडिया",
        STATE_GJ_CITY_4084: "वाघोडिया आयएनए",
        STATE_MH_CITY_4085: "वैजापूर",
        STATE_KL_CITY_4086: "वैकम",
        STATE_MH_CITY_4087: "वैराग",
        STATE_BR_CITY_4088: "वैशाली",
        STATE_TN_CITY_4089: "वलंगाईमन",
        STATE_TN_CITY_4090: "वलवानूर",
        STATE_GJ_CITY_4091: "वल्लभ विद्यानगर",
        STATE_GJ_CITY_4092: "वल्लभीपूर",
        STATE_TN_CITY_4093: "वल्लम",
        STATE_TN_CITY_4094: "वालपराई",
        STATE_GA_CITY_4095: "वाल्पोय",
        STATE_GJ_CITY_4096: "वलसाड",
        STATE_MH_CITY_4097: "वलसंग",
        STATE_GJ_CITY_4098: "वनाळा",
        STATE_TN_CITY_4099: "वंडलूर",
        STATE_TN_CITY_4100: "वंदवासी",
        STATE_MH_CITY_4101: "वाणगाव",
        STATE_TN_CITY_4102: "वानियांबडी",
        STATE_GJ_CITY_4103: "वांसदा",
        STATE_GJ_CITY_4104: "वंथली",
        STATE_GJ_CITY_4105: "वापी",
        STATE_UP_CITY_4106: "वाराणसी",
        STATE_MH_CITY_4107: "वरणगाव",
        STATE_GA_CITY_4108: "वर्का",
        STATE_KL_CITY_4109: "वर्कला",
        STATE_GJ_CITY_4110: "वरतेज",
        STATE_GJ_CITY_4111: "वासा",
        STATE_GJ_CITY_4112: "वासावद",
        STATE_GA_CITY_4113: "वास्को द गामा",
        STATE_MH_CITY_4114: "वाशी",
        STATE_MH_CITY_4115: "वासिंद",
        STATE_GJ_CITY_4116: "वासो",
        STATE_TN_CITY_4117: "वासुदेवनल्लूर",
        STATE_GJ_CITY_4118: "वाटमान",
        STATE_TN_CITY_4119: "वट्टलकुंडू",
        STATE_MH_CITY_4120: "वाटुल",
        STATE_KL_CITY_4121: "वयलर",
        STATE_TN_CITY_4122: "वेदरानियम",
        STATE_TN_CITY_4123: "वेदसंदूर",
        STATE_GJ_CITY_4124: "वेजलपूर",
        STATE_TN_CITY_4125: "वेलंकन्नी",
        STATE_MH_CITY_4126: "वेळास, महाराष्ट्र",
        STATE_TN_CITY_4127: "वेलणूर",
        STATE_TN_CITY_4128: "वेल्लोर",
        STATE_MH_CITY_4129: "वेळणेश्वर",
        STATE_TN_CITY_4130: "वेलूर",
        STATE_TG_CITY_4131: "वेमलवाडा",
        STATE_TN_CITY_4132: "वेंगावसल",
        STATE_MH_CITY_4133: "वेंगुर्ला",
        STATE_AP_CITY_4134: "व्यंकटगिरी",
        STATE_AP_CITY_4135: "वेपागुंटा",
        STATE_GJ_CITY_4136: "वेरावळ",
        STATE_AP_CITY_4137: "वेतापलेम",
        STATE_TN_CITY_4138: "वेट्टीक्करणपुदूर",
        STATE_TN_CITY_4139: "वेट्टावलम",
        STATE_KL_CITY_4140: "वेत्तूर",
        STATE_MP_CITY_4141: "विदिशा",
        STATE_GJ_CITY_4142: "विजापूर",
        STATE_TN_CITY_4143: "विजयापुरी",
        STATE_AP_CITY_4144: "विजयवाडा",
        STATE_MH_CITY_4145: "विजयदुर्ग",
        STATE_TG_CITY_4146: "विकाराबाद",
        STATE_UT_CITY_4147: "विकासनगर",
        STATE_MH_CITY_4148: "विक्रोळी",
        STATE_TN_CITY_4149: "विक्रवंडी",
        STATE_TN_CITY_4150: "विलाट्टीकुलम",
        STATE_MH_CITY_4151: "विलेपार्ले",
        STATE_TN_CITY_4152: "विल्लुपुरम",
        STATE_GJ_CITY_4153: "विंचिया",
        STATE_GJ_CITY_4154: "विंचिया",
        STATE_MH_CITY_4155: "विंचूर",
        STATE_UP_CITY_4156: "विंध्याचल",
        STATE_AP_CITY_4157: "विनुकोंडा",
        STATE_TN_CITY_4158: "विरागणूर",
        STATE_GJ_CITY_4159: "विरमगाम",
        STATE_MH_CITY_4160: "विरार",
        STATE_KA_CITY_4161: "विरराजेंद्रपेठ",
        STATE_GJ_CITY_4162: "वीरपूर",
        STATE_TN_CITY_4163: "विरुधुनगर",
        STATE_AP_CITY_4164: "विशाखापट्टणम",
        STATE_GJ_CITY_4165: "विसावदर",
        STATE_GJ_CITY_4166: "विसनगर",
        STATE_MH_CITY_4167: "विटा, महाराष्ट्र",
        STATE_MH_CITY_4168: "विटे",
        STATE_AP_CITY_4169: "विजयनगरम",
        STATE_AP_CITY_4170: "विजयनगरम जिल्हा",
        STATE_TN_CITY_4171: "वृद्धचलम्",
        STATE_UP_CITY_4172: "वृंदावन",
        STATE_AP_CITY_4173: "वुयुरु",
        STATE_GJ_CITY_4174: "व्यारा",
        STATE_MH_CITY_4175: "वडाळा",
        STATE_MH_CITY_4176: "वडगाव",
        STATE_GJ_CITY_4177: "वाढाई",
        STATE_GJ_CITY_4178: "वाधवण",
        STATE_KA_CITY_4179: "वाडी",
        STATE_MH_CITY_4180: "वडनेर",
        STATE_MH_CITY_4181: "वडवणी",
        STATE_GJ_CITY_4182: "वाघाई",
        STATE_MH_CITY_4183: "वाघोली",
        STATE_MH_CITY_4184: "वाई",
        STATE_MH_CITY_4185: "वाकड",
        STATE_TN_CITY_4186: "वलाजापेठ",
        STATE_MH_CITY_4187: "वळगाव",
        STATE_MH_CITY_4188: "वाकी",
        STATE_TN_CITY_4189: "वालाजहाबाद",
        STATE_UP_CITY_4190: "वॉल्टरगंज",
        STATE_MN_CITY_4191: "वांगजिंग",
        STATE_MH_CITY_4192: "वणी",
        STATE_GJ_CITY_4193: "वांकानेर",
        STATE_TG_CITY_4194: "वानपार्टी",
        STATE_TG_CITY_4195: "वरंगल",
        STATE_MP_CITY_4196: "वारासोनी",
        STATE_MH_CITY_4197: "वर्धा",
        STATE_BR_CITY_4198: "वारिस अलीगंज",
        STATE_MH_CITY_4199: "वरोरा",
        STATE_MH_CITY_4200: "वरुड",
        STATE_MH_CITY_4201: "वाशिम",
        STATE_KL_CITY_4202: "वायनाड",
        STATE_UP_CITY_4203: "वजीरगंज",
        STATE_TN_CITY_4204: "वेलिंग्टन",
        STATE_RJ_CITY_4205: "वेर",
        STATE_DL_CITY_4206: "पश्चिम दिल्ली",
        STATE_SK_CITY_4207: "पश्चिम जिल्हा",
        STATE_ML_CITY_4208: "पश्चिम गारो हिल्स",
        STATE_AP_CITY_4209: "पश्चिम गोदावरी",
        STATE_ML_CITY_4210: "पश्चिम जैंतिया टेकड्या",
        STATE_AR_CITY_4211: "पश्चिम कामेंग",
        STATE_ML_CITY_4212: "पश्चिम खासी टेकड्या",
        STATE_AR_CITY_4213: "पश्चिम सियांग",
        STATE_TR_CITY_4214: "पश्चिम त्रिपुरा",
        STATE_NL_CITY_4215: "वोखा",
        STATE_MH_CITY_4216: "वरळी",
        STATE_KA_CITY_4217: "यादगीर",
        STATE_MN_CITY_4218: "येरीपोक",
        STATE_HR_CITY_4219: "यमुनानगर",
        STATE_AP_CITY_4220: "यनाम",
        STATE_PY_CITY_4221: "यनाम",
        STATE_AP_CITY_4222: "यनामलाकुदुरु",
        STATE_AP_CITY_4223: "येराडा",
        STATE_MH_CITY_4224: "यावल",
        STATE_MH_CITY_4225: "यवतमाळ",
        STATE_KA_CITY_4226: "येलहंका",
        STATE_KA_CITY_4227: "येलंदूर",
        STATE_KA_CITY_4228: "येलबर्गा",
        STATE_TG_CITY_4229: "येलांडू",
        STATE_KA_CITY_4230: "येल्लापूर",
        STATE_MH_CITY_4231: "येवला",
        STATE_HP_CITY_4232: "योल",
        STATE_UP_CITY_4233: "युसूफपूर",
        STATE_UP_CITY_4234: "जाफराबाद",
        STATE_TG_CITY_4235: "जहिराबाद",
        STATE_UP_CITY_4236: "जैदपूर",
        STATE_UP_CITY_4237: "झमानिया",
        STATE_PB_CITY_4238: "झिरा",
        STATE_AR_CITY_4239: "झिरो",
        STATE_NL_CITY_4240: "झुन्हेबोटो",
        STATE_AN: "अंदमान आणि निकोबार बेटे",
        STATE_AP: "आंध्र प्रदेश",
        STATE_AR: "अरुणाचल प्रदेश",
        STATE_AS: "आसाम",
        STATE_BR: "बिहार",
        STATE_CH: "चंदीगड",
        STATE_CT: "छत्तीसगड",
        STATE_DH: "दादरा आणि नगर हवेली आणि दमण आणि दीव",
        STATE_DL: "दिल्ली",
        STATE_GA: "गोवा",
        STATE_GJ: "गुजरात",
        STATE_HR: "हरियाणा",
        STATE_HP: "हिमाचल प्रदेश",
        STATE_JK: "जम्मू आणि काश्मीर",
        STATE_JH: "झारखंड",
        STATE_KA: "कर्नाटक",
        STATE_KL: "केरळ",
        STATE_LA: "लडाख",
        STATE_LD: "लक्षद्वीप",
        STATE_MP: "मध्य प्रदेश",
        STATE_MH: "महाराष्ट्र",
        STATE_MN: "मणिपूर",
        STATE_ML: "मेघालय",
        STATE_MZ: "मिझोरम",
        STATE_NL: "नागालैंड",
        STATE_OR: "ओडिशा",
        STATE_PY: "पुडुचेरी",
        STATE_PB: "पंजाब",
        STATE_RJ: "राजस्थान",
        STATE_SK: "सिक्कीम",
        STATE_TN: "तामिळनाडू",
        STATE_TG: "तेलंगणा",
        STATE_TR: "त्रिपुरा",
        STATE_UP: "उत्तर प्रदेश",
        STATE_UT: "उत्तराखंड",
        STATE_WB: "पश्चिम बंगाल",
        SERVICE_MODULAR_KITCHEN: "मॉड्युलर किचन",
        SERVICE_STORAGE_WORDROBE: "स्टोरेज आणि वॉर्डरोब",
        SERVICE_CROCKERY_UNIT: "क्रोकरी युनिट",
        SERVICE_SPACE_SAVING: "स्पेस सेव्हिंग फर्निचर",
        SERVICE_ELECRICAL_CHANGE: "विद्युत बदल",
        SERVICE_POP: "POP (प्लास्टर ऑफ पॅरिस)",
        SERVICE_TV_UNIT: "टीव्ही युनिट",
        SERVICE_STUDY_TABLE: "अभ्यासाचे टेबल",
        SERVICE_FALSE_CEILING: "फॉल्स सीलिंग",
        SERVICE_LIGHTS: "दिवे",
        SERVICE_WALLPAPER: "वॉलपेपर",
        WHY_US_DESC: "तुमच्या स्वप्नातील घरासाठी आम्हाला निवडण्याबाबत संभ्रम आहे, मग हे पहा.....",
        SERVICE_PAINTING: "पेंटिंग",
        SERVICE_BATHROOM_DESIGN: "स्नानगृह डिझाइन",
        SERVICE_FURNITURE_DESIGN: "फर्निचर डिझाइन",
        SERVICE_POOJA_UNIT: "पूजा युनिट",
        SERVICE_BEDROOM_DECORATION: "बेडरूम सजावट",
        SERVICE_STORE_SHOP: "दुकाने आणि दुकाने",
        SERVICE_KIDS_SPACE: "किड्स स्पेस",
        SERVICE_DINING_SPACE: "जेवणाची जागा",
        SERVICE_APPLIANCE_SELECTION: "उपकरण निवड",
        SERVICE_CABINATE_HARDWARE_DESIGN: "कॅबिनेटरी आणि हार्डवेअर डिझाइन",
        SERVICE_CLOSET_DESIGN: "लहान डिझाईन",
        SERVICE_COMMERCIAL_INTERIOR: "व्यावसायिक आतील रचना आणि सजावट",
        SERVICE_CUSTOM_ART: "सानुकूल कला निवड",
        SERVICE_DINING_ROOM: "डायनिंग रूम डिझाइन",
        SERVICE_DOOR_DESIGN: "दरवाजा डिझाइन",
        SERVICE_FLOORING_SELECTION: "फ्लोरिंग निवड",
        SERVICE_HOME_STAGING: "होम स्टेजिंग",
        SERVICE_LIVING_ROOM_DESIGN: "लिव्हिंग रूम डिझाइन आणि सजावट",
        SERVICE_INTERIOR_ARCHITECTURE_DESIGN: "इंटिरिअर आर्किटेक्चरल डिझाइन",
        SERVICE_REFURBISHMENT: "नूतनीकरण",
        SERVICE_RESTAURANT_DESIGN: "रेस्टॉरंट डिझाइन आणि सजावट",
        SERVICE_ROOM_PLANNING: "खोली नियोजन",
        SERVICE_OFFICE_DESIGN: "ऑफिस डिझाइन आणि सजावट",
        SERVICE_CUPBOARD_DESIGN: "कपाट डिझाइन",
        SERVICE_CRAFT_INTERIORS: "क्राफ्ट इंटिरियर्स",
        ABOUT_US_MAIN_TITLE: "आम्ही कलात्मक इंटीरियर बनवतो",
        ABOUT_US_DESCRIPTION: "SB विश्वकर्मा इंटिरियर अँड डेकोरेटिंग तुमच्या घरामध्ये किंवा ऑफिसमध्ये {{key1}}+ वर्षांचा इंटिरियर डिझाइनचा अनुभव घेऊन येते. आमचे डिझाइन व्यावसायिक तुमच्या सभोवतालच्या रंग आणि प्रकाशात आमच्या ग्राहकांसाठी सर्वोत्तम कार्य करणारी उत्पादने आणि डिझाइन निर्धारित करण्यात मदत करण्यासाठी सज्ज आहेत. तुमच्या अपेक्षेपेक्षा जास्त.",
        SLEEK_ARCHITECTURE_TITLE: "स्लीक आर्किटेक्चर",
        ABOUT_US_SECOND_PARA: "आम्ही आमच्या ग्राहकांना प्रयोगशाळा, रुग्णालये आणि आरोग्य सेवा आस्थापने, शिक्षण आणि प्रशिक्षण संस्था, शिपयार्ड आणि नौदल, सभागृह आणि स्टेडियमसाठी उपायांसह घर आणि ऑफिस फर्निचर ऑफर करतो. तुम्ही विशिष्ट शैली शोधत आहात, जसे की पारंपारिक, आधुनिक , समकालीन किंवा इक्लेक्टिक किंवा तुमच्या मनात एखादा ब्रँड असेल तर आम्ही तुम्हाला योग्य निवड करण्यात मदत करू शकतो. आमच्या इंटीरियर डिझाइन सेवांमध्ये तुम्हाला योग्य रंग आणि फिनिशेस निवडण्यात मदत करण्यापासून ते फर्निचर, फ्लोअरिंग, कॅबिनेट आणि लाइटिंग निवडण्यापर्यंत सर्व गोष्टींचा समावेश आहे. तुमच्या घरासाठी सर्वोत्कृष्ट देखावा आणि अनुभव तयार करा. तुमच्या अपेक्षांपेक्षा जास्त आणि तुमच्या खास शैलीला बसणारे वातावरण तयार करण्यासाठी आम्ही तुमच्यासोबत काम करू.",
        COMMON_CONTENT_AMPERSAND: "&",
        COMMON_CONTENT_ALONG_WITH: "सोबत",
        COMMON_CONTENT_BEST_PRICE: "सर्वोत्तम किंमत",
        COMMON_CONTENT_SUPER_QUALITY: "उच्च गुणवत्ता",
        COMMON_CONTENT_SAFETY_ASSURANCE: "सुरक्षितता सुनिश्चित",
        COMMON_CONTENT_PHONE: "फोन",
        COMMON_CONTENT_LOCATION: "स्थान",
        COMMON_CONTENT_EMAIL: "ईमेल",
        COMMON_CONTENT_STATE: "राज्य",
        COMMON_CONTENT_CITY: "शहर",
        COMMON_CONTENT_PIN_CODE: "पिनकोड",
        COMMON_CONTENT_SUBMIT: "सबमिट करा",
        COMMON_CONTENT_USEFUL_LINK: "उपयुक्त दुवे",
        COMMON_BUTTON_SUBSCRIBE: "सदस्यता घ्या",
        COMMON_BUTTON_SUBSCRIBING: "सदस्यत्व घेत आहे",
        COMMON_BUTTON_CONTACT_US: "आमच्याशी संपर्क साधा",
        COMMON_BUTTON_SEND_MESSAGE: "संदेश पाठवा",
        COMMON_BUTTON_SUBMIT: "सबमिट करा",
        COMMMON_BUTTON_VIEW_ALL: "सर्व पहा",
        COMMON_CONTENT_COMPANY_NAME: "SB विश्वकर्मा",
        COMMON_CONTENT_ALL_RIGHTS_RESERVED: "सर्व हक्क राखीव.",
        COMMON_CONTENT_COPYRIGHT: "कॉपीराइट",
        COMMON_PLACEHOLDER_NAME: "तुमचे नाव प्रविष्ट करा",
        COMMON_PLACEHOLDER_EMAIL: "तुमचा ईमेल प्रविष्ट करा",
        COMMON_PLACEHOLDER_SUBJECT: "विषय प्रविष्ट करा",
        COMMON_PLACEHOLDER_MESSAGE: "तुमचा संदेश प्रविष्ट करा",
        COMMON_PLACEHOLDER_PHONE: "फोन नंबर प्रविष्ट करा",
        COMMON_PLACEHOLDER_PINCODE: "तुमचा पिनकोड प्रविष्ट करा",
        COMMON_PLACEHOLDER_FAQ: "शोधण्यासाठी कीवर्ड प्रविष्ट करा........",
        COMMON_PLACEHOLDER_SELECT: "निवडा.",
        COMMON_PLACEHOLDER_FAQ_NOTFOUND: "कोणतीही जुळणी आढळली नाही.......",
        COMMON_LABEL_DESIGNED_BY: "अनुज विश्वकर्मा यांनी डिझाइन केलेले.",
        CONTACT_ADDRESS: "साकीनाका अंधेरी पूर्व, मुंबई",
        NEWLETTER_TITLE: "आमच्या वृत्तपत्रात सामील व्हा",
        NEWLETTER_DESC: "आमच्याकडून नवीनतम अद्यतने आणि ऑफर प्राप्त करण्यासाठी तुम्हाला ईमेल प्रदान करा.",
        USER_WHATSAPP_CONFIRMATION: "तुम्ही माझ्याशी whatsapp वर संपर्क साधू शकता!",
        COMMON_CONTENT_OUR_TEAM: "आमची टीम",
        TEAM_TITLE: "आमच्या प्रिय संघाची एक छोटीशी झलक",
        BOOK_FREE_SESSION: "एक विनामूल्य सत्र बुक करा...",
        COMMON_CONTENT_SERVICES: "सेवा",
        COMMON_CONTENT_FEATURES: "वैशिष्ट्ये",
        COMMON_CONTENT_FEATURED_PROJECTS: "वैशिष्ट्यीकृत प्रकल्प",
        FEATURED_PROJECTS_DESC: "येथे काही वैशिष्ट्यीकृत प्रकल्प आहेत.......",
        COMMON_CONTENT_GALLERY: "गॅलरी",
        GALLERY_DESC: "आमच्या नवीनतम गॅलरी प्रतिमा पहा",
        FEATURES_DESC: "आमच्या अनुभव आणि कौशल्याने आम्ही आमच्या विश्वसनीय ग्राहकांना खालीलपैकी काही मौल्यवान सेवा प्रदान करतो.",
        COMMON_CONTENT_ABOUT_US: "आमच्याबद्दल",
        COMMON_CONTENT_FAQ: "FAQ",
        COMMON_CONTENT_HOME: "घर",
        COMMON_CONTENT_PORTFOLIO: "पोर्टफोलिओ",
        COMMON_CONTENT_CONTACT: "संपर्क",
        COMMON_CONTENT_BLOG: "ब्लॉग",
        COMMON_CONTENT_WHY_US: "आम्ही का",
        COMMON_CONTENT_DECORATOR: "DECORATOR",
        CONTENT_DECORATOR: "DECORATOR",
        COMMON_CONTENT_FULL_NAME: "पूर्ण नाव",
        WHY_US_TITLE: "आम्ही का?",
        WHY_US_PARAGRAPH: "आमच्या इंटीरियर डिझाइन सेवांमध्ये तुम्हाला योग्य रंग आणि फिनिशेस निवडण्यात मदत करण्यापासून ते फर्निचर, फ्लोअरिंग, कॅबिनेट आणि प्रकाशयोजना निवडण्यापर्यंत सर्व गोष्टींचा समावेश आहे ज्यामुळे तुमच्या घरासाठी सर्वोत्कृष्ट देखावा आणि अनुभव येईल. वातावरण तयार करण्यासाठी आम्ही तुमच्यासोबत काम करू. जे तुमच्या अपेक्षेपेक्षा जास्त आणि तुमच्या अनोख्या शैलीला बसते.",
        WHY_US_ITEM_ONE: "अनुभव",
        WHY_US_ITEM_ONE_DESC: "{{key1}}+ वर्षांचा अनुभव.",
        WHY_US_ITEM_TWO: "विश्वास",
        WHY_US_ITEM_TWO_DESC: "{{key1}}+ आनंदी ग्राहक",
        WHY_US_ITEM_THREE: "गुणवत्ता",
        WHY_US_ITEM_THREE_DESC: "स्लीक डिझाइनसह उत्कृष्ट दर्जाचे साहित्य",
        WHY_US_ITEM_FOUR: "वारंटी",
        WHY_US_ITEM_FOUR_DESC: "मटेरियल वॉरंटी {{key1}} वर्षांपर्यंत",
        ABOUT_US_PARAGRAPH_ONE: "SB विश्वकर्मा इंटिरियर डिझाईन आणि डेकोरेटिंगमध्ये, आम्ही तुम्हाला तुमच्या सभोवतालच्या वातावरणातील रंग आणि प्रकाशात तुमच्या गरजेनुसार सर्वोत्तम उत्पादने आणि शैली निवडण्यात मदत करण्यासाठी {{key1}}+ वर्षांचे इंटिरियर डिझाइन ज्ञान ऑफर करतो.",
        ABOUT_US_PARAGRAPH_TWO: "आम्ही विविध प्रकारच्या स्टाईलिश आणि व्यावहारिक उत्पादनांची ऑफर करतो जी कोणत्याही बजेट किंवा डिझाइनच्या गरजेनुसार तयार केली जातात. तुम्ही नवीन स्वयंपाकघर किंवा स्नानगृह शोधत असाल किंवा तुमच्या लिव्हिंग रूम किंवा डायनिंग रूममध्ये नवीन अद्यतनाचा विचार करत असाल तरीही, आम्ही प्रदान करतो तुम्हाला आवश्यक असलेल्या प्रत्येक गोष्टीसाठी एक-स्टॉप शॉप.",
        ABOUT_US_PARAGRAPH_THREE: "फर्निचरपासून लाइटिंगपर्यंत, वॉल आर्टपासून रग्जपर्यंत, आम्ही कोणत्याही सजावटीच्या शैलीला अनुरूप अशी विविध उत्पादने ऑफर करतो. आमच्या उत्पादनांच्या विस्तृत निवडीसह, तुम्हाला तुमच्या शैलीशी जुळणारे काहीतरी नक्कीच मिळेल. त्याच वेळी, आम्ही ऑफर करतो. तुमच्या इंटिरिअर डिझाइनच्या गरजा पूर्ण करण्यासाठी तुम्हाला सर्वोत्तम निर्णय घेण्यास मदत करण्यासाठी विविध तज्ञ सल्ला.",
        ABOUT_US_PARAGRAPH_FOUR: "उच्च दर्जाची उत्पादने डिझाईन करणे जी केवळ इंद्रियांनाच आकर्षक नाही तर किफायतशीर देखील आहे. आमचे तज्ज्ञ डिझाईनिंग आणि मॅन्युफॅक्चरिंग टीम आमचे ध्येय साध्य करण्यात मदत करतात.",
        ABOUT_US_PARAGRAPH_FIVE: "तुमच्या घरासाठी किंवा कार्यालयासाठी योग्य उत्पादने आणि डिझाइन्स शोधण्यात मदत करण्यासाठी आमचे इंटीरियर डिझाइन विशेषज्ञ येथे आहेत. आमच्या विस्तृत डिझाइन अनुभवाव्यतिरिक्त, आम्ही तुमचा परिसर सुधारण्यासाठी रंग आणि प्रकाश निवडण्यात तुम्हाला मदत करू शकतो.",
        ABOUT_US_PARAGRAPH_SIX: "आम्ही डिझाइनबद्दल उत्कट आहोत आणि आमच्या ग्राहकांच्या अपेक्षा ओलांडत आहोत! आम्हाला असे वाटले की ते करण्याचा सर्वोत्तम मार्ग म्हणजे केवळ डिझाइनवरच नव्हे तर फर्निचरवर देखील लक्ष केंद्रित करणे.",
        ABOUT_US_GOAL: "तुमची डिझाइनची स्वप्ने नेहमी साध्य करण्यायोग्य बनवणे आणि ते तुमच्यासाठी मनोरंजक आणि परस्परसंवादी पद्धतीने करणे हे आमचे ध्येय आहे!",
        ABOUT_US_MISSION: "आमचे ध्येय लोकांना सुंदर घरे व्हिज्युअलाइझ करण्यात, तयार करण्यात आणि देखरेख करण्यात मदत करणे हे आहे. आम्ही तुमच्यासाठी मस्त घरे, विशिष्ट जागा, वास्तुशास्त्रीय चमत्कार आणि नवीन डिझाइन ट्रेंडचे प्रेरणादायी व्हिज्युअल घेऊन आलो आहोत.",
        ABOUT_US_PARAGRAPH_SEVEN: "आमच्या इंटीरियर डिझाइन सेवांमध्ये तुम्हाला योग्य रंग आणि फिनिश निवडण्यात मदत करण्यापासून ते फर्निचर, फ्लोअरिंग, कॅबिनेट आणि प्रकाशयोजना निवडण्यापर्यंत सर्व काही समाविष्ट आहे जे तुमच्या घरासाठी सर्वोत्कृष्ट देखावा आणि अनुभव देईल. वातावरण तयार करण्यासाठी आम्ही तुमच्यासोबत काम करू. जे तुमच्या अपेक्षेपेक्षा जास्त आणि तुमच्या अनोख्या शैलीला बसते.",
        TEAM_ROLE_TWO: "DECORATOR",
        SANDEEP_VISHWAKARMA: "संदीप विश्वकर्मा",
        JITENDRA_VISHWAKARMA: "जितेंद्र विश्वकर्मा",
        SANDEEP_VISHWAKARMA_QUOTE: "आपण आपल्या घरांना आकार देतो आणि मग आपली घरे आपल्याला आकार देतात.",
        JITENDRA_VISHWAKARMA_QUOTE: "ओळखण्यायोग्य 'काहीतरी' असण्याने तुम्हाला गर्दीतून वेगळे उभे राहण्यास मदत होईल.",
        SECTION_CONTENT_TITLE: "SB विश्वकर्मा",
        SECTION_TITLE_HEADER: "SB विश्वकर्मा इंटिरियर डिझाईन आणि डेकोरेटिंग येथे, आम्ही तुम्हाला तुमच्या सभोवतालच्या वातावरणातील रंग आणि प्रकाशात तुमच्या गरजेनुसार सर्वोत्तम उत्पादने आणि शैली निवडण्यात मदत करण्यासाठी {{key1}}+ वर्षांचे इंटिरियर डिझाइन ज्ञान ऑफर करतो.",
        SECTION_PARAGRAPH_ONE: "आम्ही विविध प्रकारच्या स्टायलिश आणि व्यावहारिक उत्पादनांची ऑफर करतो जी कोणत्याही बजेट किंवा डिझाइनच्या गरजेनुसार तयार केली जातात. तुम्ही नवीन स्वयंपाकघर किंवा स्नानगृह शोधत असाल, किंवा तुमच्या लिव्हिंग रूम किंवा डायनिंग रूममध्ये नवीन अद्यतनाचा विचार करत असाल, आम्ही प्रदान करतो तुम्हाला आवश्यक असलेल्या प्रत्येक गोष्टीसाठी एक-स्टॉप शॉप.",
        SECTION_PARAGRAPH_TWO: "फर्निचरपासून लाइटिंगपर्यंत, वॉल आर्टपासून रग्जपर्यंत, आम्ही कोणत्याही सजावटीच्या शैलीला अनुरूप अशी विविध उत्पादने ऑफर करतो. आमच्या उत्पादनांच्या विस्तृत निवडीसह, तुम्हाला तुमच्या शैलीशी जुळणारे काहीतरी नक्कीच मिळेल. त्याच वेळी, आम्ही ऑफर करतो. तुमच्या इंटिरिअर डिझाइनच्या गरजा पूर्ण करण्यासाठी तुम्हाला सर्वोत्तम निर्णय घेण्यास मदत करण्यासाठी विविध तज्ञ सल्ला.",
        SECTION_PARAGRAPH_THREE: "उच्च दर्जाची उत्पादने डिझाईन करणे जे केवळ इंद्रियांनाच आकर्षक नाही तर किफायतशीर देखील आहेत. आमचे तज्ज्ञ डिझाईनिंग आणि मॅन्युफॅक्चरिंग टीम आमचे ध्येय साध्य करण्यात मदत करतात.",
        SECTION_PARAGRAPH_FOUR: "तुमच्या घरासाठी किंवा कार्यालयासाठी योग्य उत्पादने आणि डिझाइन्स शोधण्यात तुमची मदत करण्यासाठी आमचे इंटीरियर डिझाइन विशेषज्ञ येथे आहेत. आमच्या विस्तृत डिझाइन अनुभवाव्यतिरिक्त, आम्ही तुम्हाला तुमच्या सभोवतालचे रंग आणि प्रकाश निवडण्यात मदत करू शकतो.",
        SECTION_PARAGRAPH_FIVE: "आम्ही डिझाइनबद्दल उत्कट आहोत आणि आमच्या ग्राहकांच्या अपेक्षा ओलांडत आहोत! आम्हाला असे वाटले की ते करण्याचा सर्वोत्तम मार्ग म्हणजे केवळ डिझाइनवरच नव्हे तर फर्निचरवर देखील लक्ष केंद्रित करणे.",
        SECTION_PARAGRAPH_SIX: "आमच्या इंटीरियर डिझाइन सेवांमध्ये तुम्हाला योग्य रंग आणि फिनिशेस निवडण्यात मदत करण्यापासून ते फर्निचर, फ्लोअरिंग, कॅबिनेट आणि प्रकाशयोजना निवडण्यापर्यंत सर्व काही समाविष्ट आहे जे तुमच्या घराला सर्वोत्कृष्ट स्वरूप आणि अनुभव देईल. वातावरण तयार करण्यासाठी आम्ही तुमच्यासोबत काम करू. जे तुमच्या अपेक्षेपेक्षा जास्त आणि तुमच्या अनोख्या शैलीला बसते.",
        SECTION_PARAGRAPH_LIST_ITEM_ONE: "सर्वोत्तम किंमत",
        SECTION_PARAGRAPH_LIST_ITEM_TWO: "उच्च गुणवत्ता",
        SECTION_PARAGRAPH_LIST_ITEM_THREE: "सुरक्षितता सुनिश्चित",
        GOAL: "तुमची डिझाइनची स्वप्ने नेहमी साध्य करण्यायोग्य बनवणे आणि ते तुमच्यासाठी मनोरंजक आणि परस्परसंवादी पद्धतीने करणे हे आमचे ध्येय आहे!",
        MISSION: "लोकांना सुंदर घरे व्हिज्युअलाइज करण्यात, तयार करण्यात आणि त्यांची देखरेख करण्यात मदत करणे हे आमचे ध्येय आहे. आम्ही तुमच्यासाठी मस्त घरे, विशिष्ट जागा, वास्तुशास्त्रीय चमत्कार आणि नवीन डिझाइन ट्रेंडचे प्रेरणादायी व्हिज्युअल घेऊन आलो आहोत.",
        FEATURE_ITEM_ONE: "इंटिरिअर डिझाइन आणि सजावट",
        FEATURE_ITEM_TWO: "आर्किटेक्चर डिझाइन",
        FEATURE_ITEM_THREE: "लैंडस्केप नियोजन",
        FEATURE_ITEM_FOUR: "ट्रंकी प्रोजेक्ट",
        FEATURE_ITEM_FIVE: "पैशाची बचत",
        FEATURE_ITEM_SIX: "प्रकल्प व्यवस्थापन",
        FEATURE_ITEM_ONE_DESC: "तुमच्या जागेचे सौंदर्य पूरक करण्यासाठी पूर्णपणे वैयक्तिकृत फर्निचर मिळवा.",
        FEATURE_ITEM_TWO_DESC: "एखाद्या आकर्षक डिझाइनची अपेक्षा करा जी सुरेखतेसह कार्य करते.",
        FEATURE_ITEM_THREE_DESC: "विविध रंगांमधील योग्य फर्निचर आणि फॅब्रिक्सपासून घराच्या अंतर्गत सजावटीच्या विविध वस्तूंपर्यंत.",
        FEATURE_ITEM_FOUR_DESC: "विस्तृत-विस्तृत-विस्तृत झुंबर, सुंदर मजल्यावरील दिव्यांच्या विस्तृत श्रेणीमधून निवडा.",
        FEATURE_ITEM_FIVE_DESC: "हस्ताक्षरित वॉर्डरोबसाठी योग्य आकार, परिपूर्ण आकार आणि आकर्षक डिझाइन शोधा.",
        FEATURE_ITEM_SIX_DESC: "तुमची खरी व्यक्तिमत्त्व शैली व्यक्त करणार्‍या स्वाक्षरी भिंती मिळवा. मनोरंजक शेड्समधून.",
        PARAGRAPH: "आमच्या इंटीरियर डिझाइन सेवांमध्ये तुम्हाला योग्य रंग आणि फिनिशेस निवडण्यात मदत करण्यापासून ते फर्निचर, फ्लोअरिंग, कॅबिनेट आणि प्रकाशयोजना निवडण्यापर्यंत सर्वकाही समाविष्ट आहे जे तुमच्या घरासाठी सर्वोत्कृष्ट देखावा आणि अनुभव देईल. वातावरण तयार करण्यासाठी आम्ही तुमच्यासोबत काम करू. जे तुमच्या अपेक्षेपेक्षा जास्त आणि तुमच्या अनोख्या शैलीला बसते.",
        ITEM_ONE: "अनुभव",
        ITEM_TWO: "विश्वास",
        ITEM_THREE: "गुणवत्ता",
        ITEM_THREE_DESC: "स्लीक डिझाइनसह उत्कृष्ट दर्जाचे साहित्य",
        ITEM_FOUR: "वारंटी",
        ITEM_FOUR_DESC: "मटेरियल वॉरंटी {{key1}} वर्षांपर्यंत",
        HWW_TITLE: "आम्ही कसे काम करतो",
        HWW_DESC: "पहिल्या कॉलपासून ते अंतिम हस्तांतरापर्यंत—आम्ही तुमच्या घराच्या डिझाइनच्या सर्व गरजांची काळजी घेतो",
        HWW_STEP_ONE_TITLE: "डिझायनरला भेटा",
        HWW_STEP_ONE_DESC: "आमचे डिझाइन विशेषज्ञ तुमच्या अपेक्षेपेक्षा जास्त तुमच्या सेटिंगचे रंग आणि प्रकाशयोजना यांच्या संयोगाने आमच्या क्लायंटसाठी सर्वोत्कृष्ट काम करणारी सामग्री आणि शैली निर्धारित करण्यात सक्षम आहेत. ते तुमच्या गरजा समजून घेतील आणि तुमचे स्वप्न साकार करतील.",
        HWW_STEP_TWO_TITLE: "तुमची आवडती सामग्री निवडा",
        HWW_STEP_TWO_DESC: "पेंट कलर निवडण्यापासून ते फर्निचर निवडण्यापर्यंत, तुमचे व्यक्तिमत्व प्रतिबिंबित करणारी, तुमच्या जीवनशैलीसाठी कार्य करणारी आणि छान दिसणारी जागा तयार करण्यासाठी आम्ही तुमच्यासोबत काम करतो.",
        HWW_STEP_THREE_TITLE: "प्रोजेक्ट टाइमलाइनची पुष्टी करा",
        HWW_STEP_THREE_DESC: "प्रोजेक्ट बुक करण्यासाठी प्रारंभिक पेमेंट करा आणि आमचा कार्यसंघ नियोजित विविध क्रियाकलाप लक्षात घेऊन तुमच्यासोबत प्रकल्प कालावधी निश्चित करेल.",
        HWW_STEP_FOUR_TITLE: "साइट हँडओव्हर",
        HWW_STEP_FOUR_DESC: "आम्ही दिलेल्या वेळेपेक्षा कमी किंवा कमी वेळेत काम पूर्ण करतो आणि तुमचे स्वप्नातील घर तयार आहे आणि तुम्ही आता पुन्हा डिझाइन केलेल्या घरात जाऊ शकता",
        HAPPY_CUSTOMERS_TEXT: "हॅपी ग्राहक",
        YOE_TEXT: "वर्षांचा अनुभव",
        PROJECTS_TEXT: "प्रकल्प",
        HARD_WORKING_EMPLOYEE_TEXT: "कष्टकरी कर्मचारी",
        HERO_ITEM_ONE: "इंटिरिअर डिझाइन आणि सजावट",
        HERO_ITEM_TWO: "बेडरूम डिझाइन आणि सजावट",
        HERO_ITEM_THREE: "उत्कृष्ट दर्जाच्या सामग्रीसह स्मार्ट आणि उत्कृष्ट फर्निचर",
        CTA_TITLE: "कॉल टू अॅक्शन",
        CTA_DESC: "काय निवडायचे ते अजूनही संभ्रमात आहे? आम्हाला कॉल करा आणि आम्ही तुम्हाला मदत करू.",
        PORTFOLIO_TV_UNIT: "टीव्ही युनिट",
        PORTFOLIO_BEDROOM: "बेडरूम",
        PORTFOLIO_BATHROOM: "स्नानगृह",
        PORTFOLIO_FURNITURE: "फर्निचर",
        PORTFOLIO_KITCHEN: "स्वयंपाकघर",
        PORTFOLIO_LIVING_SPACE: "लिव्हिंग स्पेस",
        COMMON_CONTENT_OTHERS: "इतर",
        COMMON_CONTENT_ALL: "सर्व",
        FAQ_QUE_1: "SB विश्वकर्मा म्हणजे काय?",
        FAQ_ANS_1: "SB विश्वकर्मा ही एंड-टू-एंड, पूर्णपणे वैयक्तिकृत सेवा आहे जी तुम्हाला तुमच्या स्वप्नातील घराचे अंतर्गत डिझाइन आणि कार्यान्वित करण्यात मदत करते.",
        FAQ_QUE_2: "माझ्या घरासाठी काही अगदी साधे आणि किमान डिझाइनचे काम करायचे असल्यास मी सेवेचा लाभ घेऊ शकतो?",
        FAQ_ANS_2: "नक्कीच. एसबी विश्वकर्मा तुमच्या इंटीरियर डिझाइनच्या गरजांसाठी वैयक्तिकृत उपाय ऑफर करतात. तुमची दृष्टी समजून घेण्यासाठी आमचे डिझायनर तुमच्याशी सविस्तरपणे बोलतात आणि तुमच्या आवडी आणि प्राधान्यांशी सुसंगत जागा डिझाइन करण्यात मदत करतात. ही सेवा निश्चितपणे एक पर्याय आहे तुम्ही विचार करा.",
        FAQ_QUE_3: "मी जर ही सेवा बुक केली तर मला संपूर्ण घराची रचना करावी लागेल का?",
        FAQ_ANS_3: "अजिबात नाही. तुमचे नूतनीकरण घराच्या विशिष्ट खोली किंवा क्षेत्रापुरते मर्यादित असले तरीही ही सेवा तुमच्यासाठी कार्य करते.",
        FAQ_QUE_4: "मी कामावर घराबाहेर असताना कामाचे पर्यवेक्षण कोण करेल?",
        FAQ_ANS_4: "तुमच्या सर्व शंका आणि समस्यांसाठी आमचा ग्राहक अनुभव तज्ञ (CES) हा तुमचा एकल संपर्क असेल. तो संपूर्ण प्रकल्पाचे नेतृत्व करेल आणि तुम्हाला प्रगतीबद्दल माहिती देईल.",
        FAQ_QUE_5: "मला नियमितपणे साइटला भेट द्यावी लागेल?",
        FAQ_ANS_5: "नाही. आमचे ग्राहक अनुभव तज्ञ (CES) तुमच्या साइटचे संरक्षक आहेत आणि ते साइटला भेट देतील आणि काम कसे प्रगतीपथावर आहे याबद्दल तुम्हाला नियमित अद्यतने मिळतील याची देखील खात्री करेल. CES ही तुमची भेट देणारी व्यक्ती आहे. कोणतीही चिंता किंवा शंका.",
        FAQ_QUE_6: "माझी साइट कशी मोजली जाईल?",
        FAQ_ANS_6: "तुम्ही जी जागा नूतनीकरण करू इच्छिता किंवा बांधू इच्छिता त्याला साइट म्हणतात. संपूर्ण क्षेत्राची परिमाणे आणि मोजमाप जाणून घेण्यासाठी, तुम्ही तुमच्या जागेचा मजला आराखडा आमच्यासोबत शेअर करू शकता. जर मजला योजना उपलब्ध नसेल, तर आम्ही डिझायनिंगच्या टप्प्यापासून सुरुवात करण्यासाठी आवश्यक असलेली मोजमाप घेण्यासाठी आमचा प्रतिनिधी पाठवेल.",
        FAQ_QUE_7: "माझा प्रकल्प पूर्ण होण्याची टाइमलाइन काय असेल?",
        FAQ_ANS_7: "सर्वोच्च इंटिरियर डिझाईन फर्म्सपैकी एक असल्याने, SB विश्वकर्मा आपल्या क्लायंटला मूव्ह-इन गॅरंटी ऑफर करते जी तुम्हाला खात्री देते की सर्व मॉड्यूलर सोल्यूशन्स 45 दिवसांच्या कालावधीत स्थापित केले जातील. तुमचे संपूर्ण घर इंटीरियर पूर्ण करण्यासाठी, आम्ही सुमारे तुमचा इंटिरियर डिझाईन प्रकल्प पूर्ण करण्यासाठी ९० दिवस. तथापि, प्रकल्प-ते-प्रोजेक्ट पूर्ण होण्याची टाइमलाइन बदलू शकते. सामग्रीची उपलब्धता, वितरण, ग्राहक अभिप्राय, डिझाइन मंजूरी इत्यादी घटक वेळरेखा निश्चित करण्यात महत्त्वाची भूमिका बजावतात. कृपया लक्षात ठेवा की हमी आणि निर्धारित डिझाइन कालावधीसाठी अटी लागू होऊ शकतात.",
        FAQ_QUE_8: "मला माझ्या आवडीनुसार माझ्या घरासाठी डिझाइन सानुकूलित करण्याची परवानगी आहे का?",
        FAQ_ANS_8: "नक्कीच. तुमच्या गरजा पूर्ण करण्यासाठी तुम्हाला सर्वोत्कृष्ट वैयक्तिकृत डिझाईन्स प्रदान केल्याबद्दल आम्हाला अभिमान वाटतो. तुम्ही आमच्या ग्राहक अनुभव तज्ञ (CES) आणि इंटिरियर डिझायनरशी सल्लामसलत करू शकता आणि तुमच्यासाठी उपयुक्त असलेल्या डिझाइनला अंतिम रूप देण्यासाठी सहयोग करू शकता.",
        FAQ_QUE_9: "मी माझ्या घरातील वेगवेगळ्या खोल्यांसाठी वेगवेगळ्या थीम निवडू शकतो का?",
        FAQ_ANS_9: "नक्कीच! तुम्ही घेतलेल्या प्रत्येक डिझाईन निर्णयात सहभागी व्हाल. ग्राहक अनुभव तज्ञ (CES) आणि इंटिरियर डिझायनर विचारात घेतील आणि तुमचे मत समाविष्ट करतील आणि डिझाइनिंग टप्प्यातील सर्व टप्प्यांवर तुमची मंजुरी मागतील. अंतिम डिझाइन असेल. तुमच्या अभिरुचीनुसार आणि लोकप्रिय ट्रेंडवर आधारित.",
        FAQ_QUE_10: "माझ्या गरजा सांगण्यासाठी मी इंटीरियर डिझायनरला कधी भेटू शकतो?",
        FAQ_ANS_10: "तुमच्या गरजा समजून घेण्यासाठी आणि घराची योजना मिळवण्यासाठी आमचा ग्राहक अनुभव विशेषज्ञ (CES) तुमच्याशी प्रथम संपर्क साधेल. तो तुम्हाला प्रक्रिया तपशीलवार समजावून सांगेल आणि तुमच्या गरजा आणि तुमची शैली समजून घेईल. तो स्पष्ट करेल. कोणत्याही शंका आणि चिंता. दुसऱ्या मीटिंगमध्ये, तुम्हाला CES आणि आमचे इंटिरियर डिझायनर या दोघांशी बोलता येईल, जे तुम्हाला प्रस्तावित डिझाइन दाखवतील. तुम्हाला आमच्या अत्याधुनिक 3D वरील डिझाइन देखील पाहायला मिळेल व्हिज्युअलायझर जेथे तुम्ही बदल करू शकता आणि ते रिअल टाइममध्ये पाहू शकता.",
        FAQ_QUE_11: "मला या सेवेद्वारे माझे फर्निचर कस्टम-मेड मिळू शकते?",
        FAQ_ANS_11: "होय, तुम्ही हे करू शकता. तुमच्या गरजेनुसार फर्निचर तयार करण्यासाठी तुम्ही आमच्या ग्राहक अनुभव तज्ञ (CES) आणि इंटिरिअर डिझायनरसोबत काम करू शकता.",
        FAQ_QUE_12: "माझ्या घरासाठी प्रस्तावित डिझाईनची कल्पना मी कशी करू शकतो?",
        FAQ_ANS_12: "आमच्या इंटिरिअर डिझायनर आणि CES सोबत तपशीलवार डिझाईन चर्चेनंतर, ते आमच्या अत्याधुनिक 3D व्हिज्युअलायझरच्या वापरासह तुमच्या घराच्या प्रस्तावित डिझाईन्स शेअर करतात. एकदा तुम्ही पाहिलं की तुमच्या घराची आतील रचना कशी आहे. असे दिसेल, तुम्हाला हवे असलेल्या कोणत्याही बदलांची तुम्ही पुढील चर्चा करू शकता—आणि ते रिअल टाइममध्ये होताना पाहू शकता. 3D व्हिज्युअलायझरमधील डिझाइन आउटपुटसह, तुम्हाला ते 2D मध्ये देखील पाहता येईल. त्यानंतरचे कोणतेही बदल तुम्हाला तुमच्या आवडीनुसार आणि आवडीनुसार बनवायला हवे.",
        FAQ_QUE_13: "तुम्ही कोणत्या सेवा ऑफर करता आणि मी त्या का निवडू?",
        FAQ_ANS_13: "आमच्या सेवांमध्ये तुमच्या घराच्या आतील डिझाइनचे शेवटपर्यंत डिझाइनिंग आणि अंमलबजावणी समाविष्ट आहे, ज्यामध्ये फर्निचर, असबाब, सजावटीची प्रकाशयोजना, सजावट उपकरणे, मॉड्यूलर किचन डिझाइन, पेंटिंग आणि सिव्हिल वर्क यांचा समावेश आहे. त्यांच्या संबंधित क्षेत्रातील तज्ञ अचूकतेचा वापर करतात. आणि तुमची दृष्टी पूर्ण करण्यासाठी डिझाइनची उत्तम जाणीव. हे सुनिश्चित करते की तुमच्या घराची रचना पूर्णपणे वैयक्तिकृत आहे. त्याशिवाय, तुम्ही डिझाइन प्रक्रियेत पूर्णपणे गुंतलेले आहात; तुम्ही आमच्या विशेष 3D व्हिज्युअलायझरद्वारे तुम्हाला हवे असलेले परिवर्तन आणि बदल पाहण्यास देखील मिळतात. , तुम्हाला तुमच्या स्वप्नातील घराची कल्पना करता यावी आणि रिअल टाइममध्ये बदल करता यावेत. आम्ही तुमचे सुंदर घर तयार करत असताना तुम्हाला तज्ञ प्रकल्प व्यवस्थापन आणि पूर्णपणे व्यावसायिक अनुभवाची खात्री देता येईल.",
        FAQ_QUE_14: "कोणत्या शहरांमध्ये ही सेवा चालू आहे?",
        FAQ_ANS_14: "आतापर्यंत, आम्ही आठ शहरांमध्ये इंटिरियर डिझाइन सेवा प्रदान करतो—आमची दुकाने दिल्ली, मुंबई, पुणे, बेंगळुरू आणि हैदराबाद येथे आहेत. आम्ही तुमच्या परिसरात कार्यरत आहोत की नाही हे जाणून घेण्यासाठी कृपया संपर्क फॉर्म भरा.",
        FAQ_QUE_15: "प्रकल्पाच्या संपूर्ण कालावधीसाठी माझा संपर्क व्यक्ती कोण असेल?",
        FAQ_ANS_15: "ग्राहक अनुभव तज्ञ (CES) हे इंटीरियर डिझाईन प्रकल्पाच्या सुरुवातीपासून शेवटपर्यंत तुमचा संपर्क व्यक्ती असेल. तो या काळात तुमच्या कोणत्याही शंका किंवा समस्यांचे निराकरण करेल.",
        FAQ_QUE_16: "मला इंटिरियर डिझायनरची गरज का आहे?",
        FAQ_ANS_16: "जेव्हा घरासाठी आणि अंतर्गत सजावटीसाठी इंटिरियर डिझाइनचा विचार केला जातो, तेव्हा आपण जे काही पाहतो ते सामान्यत: आपल्याला मिळत नाही. येथेच इंटिरियर डिझायनरच्या कौशल्यांचा वापर केल्यास कार्यशील इंटीरियरमध्ये फरक पडू शकतो आणि सुंदर दिसणे. घर जे व्यावहारिक देखील आहे. जेव्हा तुम्हाला सर्वसमावेशक डिझाइन सोल्यूशन्स हवे असतील तेव्हा इंटिरिअर डिझायनर हा एक परिपूर्ण उपाय आहे, मग ते सौंदर्यविषयक आतील सजावटीच्या तांत्रिक बाबी असोत. ते तुमच्या जागेसाठी तुमच्याकडे असलेल्या दृष्टीचे अचूक भाषांतर करू शकतात आणि ते वाढवू शकतात. तुम्हाला चांगले डिझाइन केलेले आणि आरामदायी घर द्या. इंटिरिअर डिझायनरचे कौशल्य शोधण्याचे अनेक फायदे आहेत—सर्वात प्रमुख म्हणजे ते सुसज्ज असलेले कौशल्य आणि ज्ञान. त्यांना सर्व पैलूंबद्दल ठोस माहिती आहे. डिझाईन, जॉबमध्ये काय आवश्यक आहे याच्या गरजा चांगल्या प्रकारे पारंगत आहेत आणि तुमच्या मनात असलेल्या घराच्या आतील डिझाइनच्या व्यवहार्यतेबद्दल तुम्हाला सल्ला देऊ शकतात. रंग, साहित्य आणि जागेचे कॉन्फिगरेशन हे घराच्या डिझाइनचे मूलभूत पैलू आहेत आणि जेव्हा सर्वसमावेशक आणि स्पष्ट योजना तयार करण्याची वेळ येते तेव्हा एक इंटीरियर डिझायनर हा तुमचा जाण्याचा स्रोत असतो. तुमचे आतील भाग अद्वितीय आणि वेगळे दिसावेत यासाठी कोणती रंगसंगती आणि साहित्य वापरायचे हे त्यांना नक्की कळेल. तुमच्या जागेसाठी सर्वोत्तम निवड करण्यात मदत करण्यासाठी त्यांच्याकडे ज्ञान, डोळा आणि कौशल्य आहे. आणखी एक महत्त्वाचा घटक ज्याचा विचार केला पाहिजे तो म्हणजे इंटीरियर डिझायनर आतील सजावटीच्या बाबतीत नवीनतम आणि सर्वात लोकप्रिय ट्रेंडवर अद्यतनित केले जातात. इतकेच काय, ते तुम्हाला हे देखील सांगतील की तुमच्या घरात एखादा विशिष्ट ट्रेंड चांगला चालेल की नाही, तुम्ही काय अवलंबावे आणि काय टाकून द्यावे. इंटिरिअर डेकोरेशनच्या विविध पैलूंचा शोध घेताना बाजाराबद्दलचे त्यांचे ज्ञान देखील कार्यात येते. तुमच्या घरासाठी चांगल्या दर्जाचे फर्निचर, फर्निशिंग, अॅक्सेसरीज आणि इतर सजावटीशी संबंधित घटक निवडताना ते तुम्हाला योग्य दिशेने नेतील. तुमच्या घराच्या इंटिरिअर डिझाईनमध्ये काही असण्याची तुमची इच्छा असेल तर एक चांगला इंटीरियर डिझायनर तुम्हाला आर्टवर्कची शिफारस करू शकतो आणि मदत करू शकतो. आज इंटिरियर डिझाइन सेवा भाड्याने घेण्याचा आणखी एक फायदा म्हणजे तुमचे घर ऊर्जा कार्यक्षम आहे याची खात्री करणे. तुमचे हृदय योग्य ठिकाणी असले तरी, तो इंटिरिअर डिझायनर आहे जो चांगल्या हेतूंना सक्रिय कृतीत अनुवादित करू शकतो आणि उर्जेचा वापर ऑप्टिमाइझ करू शकतो तुमच्या बाजूला असलेल्या इंटीरियर डिझायनरसह, तुमच्याकडे तुमच्या घराच्या डिझाइनवर काम करण्यासाठी विश्वासार्ह आणि विश्वासार्ह कोणीतरी आहे, एकल सर्व भिन्न घटक आणि लोकांशी सामना करण्यासाठी आणि भार-आणि ताण-बंद करण्यास मदत करण्यासाठी स्त्रोत.",
        FAQ_QUE_17: "मी व्यावसायिकांसोबत रूमसाठीच्या माझ्या कल्पना कशा शेअर करू?",
        FAQ_ANS_17: "तुमच्या घराच्या अंतर्गत डिझाइनची रचना किंवा नूतनीकरण करण्यास उत्सुक असलेले घरमालक म्हणून, तुमची पहिली पायरी सर्व उपलब्ध संसाधने ब्राउझ करणे आहे. घराच्या विस्तृत डिझाइनसह, वैयक्तिक खोल्या देखील स्वतःमध्ये एक आव्हान आहे. संभाव्यत: आणि एक चांगली कल्पना—कि एक इंटीरियर डिझाइन व्यावसायिक चित्रात येण्याआधी, फक्त तुम्हालाच कळू शकते की तुम्हाला तुमच्या खोलीच्या आतील डिझाइनमध्ये काय आवडते आणि तुम्हाला काय पहायचे आहे. तुमच्या खोलीच्या आतील डिझाइनच्या आकांक्षा आहेत याची खात्री करण्यासाठी तुम्ही भाड्याने घेतलेल्या व्यावसायिकांना कळवले की, तुम्ही प्रथम तुमची अभिरुची शोधून काढली पाहिजे. खोली वेगळी असली तरी घराच्या एकूण डिझाइन योजनेत ती योग्य प्रकारे बसते याची खात्री करण्यासाठी खोलीच्या आतील रचनांचा काळजीपूर्वक विचार करणे आवश्यक आहे. तसे करण्याचा सर्वोत्तम मार्ग म्हणजे जलद. संशोधनाचा फेरा; तुम्हाला काय आवडते, काय ट्रेंडिंग आहे, काय नाही आणि तुमच्या वैयक्तिक आवडीनिवडी उत्तम प्रकारे प्रतिबिंबित करणारे सर्वात योग्य आतील डिझाइन कोणते असेल याची कल्पना मिळते. आणि तुमच्या निवडी कमी करण्यासाठी तुम्हाला फार दूर पाहण्याची गरज नाही. ; एसबी विश्वकर्मा इंटिरियर डिझाइन सर्व्हिसेसच्या वेबसाइटमध्ये घरे आणि मोकळ्या जागेच्या विविध शैलीतील अनेक प्रतिमा आहेत जे तुम्हाला तुमच्या संवेदनशीलतेनुसार खोलीचे आतील डिझाइन शोधण्यात मदत करतील. प्रतिमांद्वारे ब्राउझ करताना, लक्षात ठेवा की तुम्ही जागेच्या डिझाइनमध्ये जाणारे सर्व घटक काळजीपूर्वक पाहतात: यामध्ये स्वतःच जागा समाविष्ट आहे—प्रत्येक खोलीचा आकार, लेआउट आणि एकूण सौंदर्याचा समावेश आहे ज्यासाठी तुम्ही निवड करू इच्छिता. . मग इतर महत्त्वाचे घटक जसे की तुम्ही वापरू इच्छित असलेले रंग आणि तुम्हाला आकर्षित करणारे साहित्य. परंतु आपल्या शैलीच्या आवश्यकता व्यावहारिक विचारांद्वारे संतुलित असल्याची खात्री करा. हे महत्वाचे आहे की खोलीच्या आतील रचना केवळ सुंदर दिसत नाही तर कार्यक्षम देखील आहे. तुमच्यासाठी सर्वोत्तम काय आहे हे शोधण्यासाठी तुम्ही आमची पेज ब्राउझ करता तेव्हा हे सर्व मुद्दे लक्षात ठेवा. जेव्हा तुम्ही व्हिज्युअल्सची निवड केली असेल, तेव्हा सर्वोत्तम गोष्ट म्हणजे कल्पना आणि सूचनांच्या कोलाजमध्ये त्यांची योग्यरित्या मांडणी करणे - एक मूड बोर्ड जे तुम्हाला काय काम करत आहे आणि काय नाही हे समजू शकते. त्यामुळे एकदा तुम्ही आमच्या ग्राहक अनुभव तज्ञ (CES) आणि इंटिरिअर डिझायनरला भेटून खोलीच्या आतील डिझाइनला अंतिम रूप देण्यासाठी भेटलात की त्यांना तुमच्या प्राधान्यांचा दृश्य संदर्भ मिळेल. अंतिम डिझाइन तुमच्या अभिरुचीनुसार आणि लोकप्रिय ट्रेंडवर आधारित असेल तर आमचे व्यावसायिक हे सुनिश्चित करतील की ते मोठ्या घराच्या डिझाइनमध्ये बसेल. आणि खात्री बाळगा की तुमच्या सर्व शंका आणि शंका आमच्या CES द्वारे संबोधित केल्या जातील, जो तुमच्या गरजा समजून घेईल आणि घराच्या डिझाइनची योजना करेल याची खात्री करेल.",
        FAQ_QUE_18: "एसबी विश्वकर्मा तुमच्या घराच्या आतील डिझाइनसाठी योग्य का आहे?",
        FAQ_ANS_18: "तुमच्या घराच्या आतील रचना तयार करणे किंवा त्याचे नूतनीकरण करणे हा हलकासा निर्णय नाही. यात खूप काळजीपूर्वक विचार आणि संशोधन करावे लागते. सर्वात महत्त्वाचे म्हणजे, तुमची अभिरुची, त्यात गुंतलेले काम हे जन्मजात समजून घेणारा विश्वासू व्यावसायिक शोधणे देखील आहे. घराचे इंटिरियर तयार करणे आणि तुमची दृष्टी पूर्ण करण्यासाठी आवश्यक कौशल्ये आहेत. एसबी विश्वकर्मा इंटिरियर डिझाइन सर्व्हिसमध्ये, आमचे ग्राहक अनुभव विशेषज्ञ (सीईएस) आणि इंटीरियर डिझायनर्सचे नेटवर्क तुमच्यासाठी योग्य घराचे इंटिरियर डिझाइन समजून घेण्यासाठी सुसज्ज आहेत. तुमच्या घराच्या इंटिरियर डिझाइनचा अनुभव गुळगुळीत आहे याची खात्री करण्यासाठी एकत्रितपणे एक सुनियोजित प्रक्रिया. संकल्पना आणि कल्पना तयार करण्यापासून ते हँडओव्हर होईपर्यंत आम्ही तुमच्यासोबत असू. ६० हून अधिक इंटिरियर डिझायनर्ससह आमचे पॅनेल बनवले आहे. तज्ञांच्या मते, तुम्ही खात्री बाळगू शकता की तुमच्या घराच्या इंटिरिअरची रचना सुरक्षित आणि कुशल हातात आहे आणि अंतिम परिणाम तुमच्या कुटुंबाच्या सोयीसाठी सर्वात योग्य असेल. आमची CES ही तुमच्याशी संपर्क साधणारी पहिली व्यक्ती आहे आणि तुमच्या घराच्या आतील डिझाइनच्या आवश्यकतांबद्दल माहिती मिळवते. तो, त्या बदल्यात, आम्ही एसबीविश्वकर्मा येथे ज्या प्रक्रियेचे अनुसरण करतो त्याबद्दल तपशीलवार माहिती देईल आणि तुमच्या शंका आणि शंका दूर करेल. फॉलो-अप मीटिंग आहे जिथे तुम्ही तुमच्या घराच्या इंटिरियरची रचना पाहण्यासाठी नियुक्त केलेल्या इंटीरियर डिझायनरला भेटता. तो तुम्हाला प्रस्तावित डिझाइन दाखवणारा देखील आहे, जो तुम्हाला अत्याधुनिक 3D व्हिज्युअलायझरवर देखील व्हिज्युअलायझ करण्यासाठी मिळेल; हे तुम्हाला बदल करण्यास आणि ते रिअल टाइममध्ये पाहण्यास सक्षम करते. आमच्‍या सेवा घराच्या अंतर्भागातील आवश्‍यकता पूर्ण करतात, ज्यात तुमच्‍या घराचे इंटिरियर डिझाईन पूर्ण करणे आणि अंमलात आणणे समाविष्ट आहे. यामध्ये फर्निचर आणि असबाब, सजावटीच्या प्रकाशयोजना आणि मॉड्युलर किचन डिझाइन्स, पेंटिंग आणि सिव्हिल वर्कसाठी डेकोर अॅक्सेसरीज समाविष्ट आहेत. एसबीविश्वकर्मा येथे, आम्ही खात्री करतो की तुम्ही संपूर्ण डिझाइन प्रक्रियेत जवळून सहभागी व्हाल आणि तुमच्या घराच्या परिवर्तनाचे साक्षीदार आहात. आमची CES घराच्या इंटिरियर डिझाइनच्या अंमलबजावणीदरम्यान ऑनसाइट आहे, कोणत्याही त्रुटी आणि समस्या सक्षमपणे, त्वरित आणि कार्यक्षमतेने हाताळल्या गेल्या आहेत याची खात्री करून. तुमचा संपर्काचा एकमेव बिंदू म्हणून, आमची CES तुम्हाला प्रगतीबद्दल नियमितपणे अपडेट ठेवेल. तुमच्या घराच्या इंटिरिअरची रचना तुमच्यासाठी आमच्यासाठी तितकीच महत्त्वाची आहे, पण तितकीच महत्त्वाची गोष्ट म्हणजे या प्रक्रियेद्वारे तुमच्या आरामाची खात्री करणे आणि तुम्हाला पूर्णतः तुम्हीच घराची आतील रचना देणे. 9 शहरांमधील शेकडो समाधानी ग्राहक या वस्तुस्थितीचा पुरावा आहेत की आम्ही तुमच्या स्वप्नातील घराची रचना करण्याची जबाबदारी अतिशय गांभीर्याने घेतो.",
        PORTFOLIO_TV_TAG: "टीव्ही युनिट",
        PORTFOLIO_BEDROOM_TAG: "बेडरूम",
        PORTFOLIO_BATHROOM_TAG: "स्नानगृह",
        PORTFOLIO_FURNITURE_TAG: "फर्निचर",
        PORTFOLIO_KITCHEN_TAG: "स्वयंपाकघर",
        PORTFOLIO_LIVING_SPACE_TAG: "लिव्हिंग स्पेस",
        PORTFOLIO_OTHERS_TAG: "इतर",
        PORTFOLIO_ALL_TAG: "सर्व",
        PORTFOLIO_ITEM_TITLE_1: "टीव्ही युनिट",
        PORTFOLIO_ITEM_DESC_1: "लाकडी फिनिशिंगसह टीव्ही युनिट सजावट.",
        PORTFOLIO_ITEM_TITLE_2: "लिव्हिंग स्पेस",
        PORTFOLIO_ITEM_DESC_2: "राहण्याच्या जागेसाठी संपूर्ण अंतर्गत सजावट",
        PORTFOLIO_ITEM_TITLE_3: "राहण्याची जागा",
        PORTFOLIO_ITEM_DESC_3: "लिव्हिंग स्पेस अंतर्गत सजावट",
        PORTFOLIO_ITEM_TITLE_4: "स्वयंपाकघर सजावट",
        PORTFOLIO_ITEM_DESC_4: "ग्लॉसी फिनिशसह स्वयंपाकघर सजावट",
        PORTFOLIO_ITEM_TITLE_5: "लिव्हिंग स्पेस",
        PORTFOLIO_ITEM_DESC_5: "लिव्हिंग स्पेस डेकोरेशन",
        PORTFOLIO_ITEM_TITLE_6: "लिव्हिंग स्पेस",
        PORTFOLIO_ITEM_DESC_6: "लिव्हिंग स्पेस डेकोरेशन",
        PORTFOLIO_ITEM_TITLE_7: "सीलिंग डेकोरेशन",
        PORTFOLIO_ITEM_DESC_7: "फॉल्स सीलिंग डेकोरेशन",
        PORTFOLIO_ITEM_TITLE_8: "बेडरूम",
        PORTFOLIO_ITEM_DESC_8: "विनीअर मॅट फिनिशसह आकर्षक बेडरूमची सजावट.",
        PORTFOLIO_ITEM_TITLE_9: "स्नानगृह",
        PORTFOLIO_ITEM_DESC_9: "स्टाईलिश बाथरूम सजावट",
        PORTFOLIO_ITEM_TITLE_10: "मॉड्युलर किचन",
        PORTFOLIO_ITEM_DESC_10: "मॉड्युलर स्वयंपाकघर डिझाइन आणि जागा बचत वैशिष्ट्यांसह सजावट",
        PORTFOLIO_ITEM_TITLE_11: "मॉड्युलर किचन",
        PORTFOLIO_ITEM_DESC_11: "मॉड्युलर स्वयंपाकघर डिझाइन आणि जागा बचत वैशिष्ट्यांसह सजावट",
        PORTFOLIO_ITEM_TITLE_12: "टेबल",
        PORTFOLIO_ITEM_DESC_12: "उच्च ग्लॉसी ग्लास फिनिशिंगसह टेबल",
        PORTFOLIO_ITEM_TITLE_13: "बेडरूमची सजावट",
        PORTFOLIO_ITEM_DESC_13: "उच्च ग्लॉसी फिनिशिंगसह क्लासिक बेडरूमची सजावट",
        PORTFOLIO_ITEM_TITLE_14: "बेडरूमची सजावट",
        PORTFOLIO_ITEM_DESC_14: "लाकडी फिनिशिंगसह क्लासिक बेडरूम डिझाइन",
        PORTFOLIO_ITEM_TITLE_15: "बेडरूम आणि वॉर्डरोब",
        PORTFOLIO_ITEM_DESC_15: "वॉल लाइट्स आणि ग्लॉसी फिनिशिंगसह आकर्षक बेडरूम आणि वॉर्डरोब डिझाइन",
        PORTFOLIO_ITEM_TITLE_16: "बेडरूम आणि वॉर्डरोब",
        PORTFOLIO_ITEM_DESC_16: "क्लासिक बेडरूम डिझाइन",
        PORTFOLIO_ITEM_TITLE_17: "बेडरूम",
        PORTFOLIO_ITEM_DESC_17: "विनीअर मॅट फिनिशिंगसह आकर्षक बेडरूम डिझाइन आणि सजावट",
        PORTFOLIO_ITEM_TITLE_18: "स्नानगृह",
        PORTFOLIO_ITEM_DESC_18: "स्नानगृह डिझाइन आणि सजावट",
        PORTFOLIO_ITEM_TITLE_19: "स्नानगृह",
        PORTFOLIO_ITEM_DESC_19: "स्नानगृह डिझाइन आणि सजावट",
        PORTFOLIO_ITEM_TITLE_20: "स्टोरेज युनिट",
        PORTFOLIO_ITEM_DESC_20: "स्टोरेज युनिट डिझाइन",
        PORTFOLIO_ITEM_TITLE_21: "टीव्ही युनिट",
        PORTFOLIO_ITEM_DESC_21: "मॅट फिनिशिंगसह लक्झरी टीव्ही युनिट",
        PORTFOLIO_ITEM_TITLE_22: "स्नानगृह",
        PORTFOLIO_ITEM_DESC_22: "स्नानगृह डिझाइन",
        PORTFOLIO_ITEM_TITLE_23: "सीलिंग",
        PORTFOLIO_ITEM_DESC_23: "फॉल्स सीलिंग डिझाइन",
        PORTFOLIO_ITEM_TITLE_24: "केबिन डिझाइन",
        PORTFOLIO_ITEM_DESC_24: "संपूर्ण केबिन डिझाइन आणि सजावटीचे दृश्य",
        PORTFOLIO_ITEM_TITLE_25: "बेडरूमची सजावट",
        PORTFOLIO_ITEM_DESC_25: "उच्च ग्लॉसी फिनिशसह बेडरूमची सजावट",
        PORTFOLIO_ITEM_TITLE_26: "बेडरूम",
        PORTFOLIO_ITEM_DESC_26: "बेडरूमची सजावट",
        PORTFOLIO_ITEM_TITLE_27: "बेडरूम",
        PORTFOLIO_ITEM_DESC_27: "बेडरूमचे संपूर्ण डिझाइन आणि सजावटीचे दृश्य",
        PORTFOLIO_ITEM_TITLE_28: "लिव्हिंग स्पेस",
        PORTFOLIO_ITEM_DESC_28: "लिव्हिंग स्पेस डिझाइन आणि सजावट",
        PORTFOLIO_ITEM_TITLE_29: "टीव्ही युनिट",
        PORTFOLIO_ITEM_DESC_29: "मॅट मेटॅलिक फिनिशसह रॉयल टीव्ही युनिट",
        PORTFOLIO_ITEM_TITLE_30: "स्टोरेज युनिट",
        PORTFOLIO_ITEM_DESC_30: "स्टोरेज कॅबिनेट डिझाइन",
        PORTFOLIO_ITEM_TITLE_31: "कॅबिनेट टेबल",
        PORTFOLIO_ITEM_DESC_31: "उच्च ग्लॉसी ग्लास फिनिशसह ऑफिस केबिन टेबल",
        PORTFOLIO_ITEM_TITLE_32: "कॅबिनेट टेबल",
        PORTFOLIO_ITEM_DESC_32: "उच्च ग्लॉसी ग्लास फिनिशसह ऑफिस केबिन टेबल",
        PORTFOLIO_ITEM_TITLE_33: "मीटिंग टेबल",
        PORTFOLIO_ITEM_DESC_33: "रंगीत ग्लास फिनिशसह मीटिंग टेबल",
        PORTFOLIO_ITEM_TITLE_34: "कार्यालय सजावट",
        PORTFOLIO_ITEM_DESC_34: "ऑफिस डिझाइन आणि सजावट",
        PORTFOLIO_ITEM_TITLE_35: "कमर्शियल वर्कस्टेशन",
        PORTFOLIO_ITEM_DESC_35: "व्यावसायिक कार्य स्टेशन डिझाइन आणि सजावट",
        PORTFOLIO_ITEM_TITLE_36: "कमर्शियल वर्कस्टेशन",
        PORTFOLIO_ITEM_DESC_36: "मॅट मेटॅलिक फिनिशसह रॉयल टीव्ही युनिट",
        WHY_US_ITEM_1: "ठिकाणी कार्यक्षमता जोडते",
        WHY_US_ITEM_DATA_1: "इंटिरिअर डिझाईन केवळ तुमच्या इमारतीच्या आतील भागात सुशोभित करत नाही तर ते तुमच्या घरामध्ये कार्यक्षमता वाढवते याची देखील खात्री करते. कार्यक्षमता ही इंटीरियर डिझाइनच्या प्रमुख पैलूंपैकी एक आहे. हे महत्त्वाचे आहे कारण खराब डिझाइन केलेल्या मोठ्या घरामध्ये जागेची कमतरता असू शकते. किंवा एक लहान अपार्टमेंट देखील कार्यक्षमतेच्या परिपूर्ण उदाहरणांपैकी एक असू शकते. हे काही नवीनतम डिझाइन तत्त्वे आणि घटकांच्या मदतीने साध्य केले जाऊ शकते जसे की विशेष पायर्या किंवा माचा. अशा प्रकारे, आतील रचना प्रकाशापासून ते सर्व काही एकसंधपणे कार्य करते. उपकरणांना फर्निचर, ते ठिकाण अधिक आकर्षक आणि आकर्षक वाटेल.",
        WHY_US_ITEM_2: "रहिवाशाच्या जीवनशैलीशी जुळते",
        WHY_US_ITEM_DATA_2: "जेव्हा जेव्हा एखादा व्यावसायिक घर डिझाइन करतो तेव्हा ते रहिवाशांच्या जीवनशैलीला साजेसे अशा पद्धतीने केले जाते. हा एक अतिशय महत्त्वाचा घटक आहे कारण वास्तुशास्त्रीय घटक आपल्या जीवनशैलीनुसार तयार केला जातो. त्यामुळे, त्याच्यासोबत बसणे महत्त्वाचे आहे. तुमचा डिझायनर आणि ते तुम्हाला अनुकूल आणि परिपूर्ण डिझाइन तयार करण्यात मदत करतात. उदाहरणार्थ, इंटीरियर डिझाइनमध्ये जीवनशैलीच्या समायोजनामध्ये तुमचे टॉयलेट उर्वरित बाथरूमपासून वेगळे करणे किंवा तुमच्या लिव्हिंग रूमचा आकार कमी करणे समाविष्ट असू शकते जेणेकरून तुम्हाला होम ऑफिस जिथे तुम्ही तुमचा मोकळा वेळ जास्त घालवाल.",
        WHY_US_ITEM_3: "उच्च सौंदर्याचा दर्जा",
        WHY_US_ITEM_DATA_3: "इंटिरिअर डिझायनर हे जादूगारांसारखे असतात जे आपली जादूची कांडी फिरवतात आणि एखाद्या सामान्य दिसणार्‍या जागेचे सौंदर्यदृष्ट्या अतिशय सुंदर आणि स्वागतार्ह अशा गोष्टीत रूपांतर करतात. ते योग्य डिझाईन, योजना, रंग, रंग, वातावरण, पोत, समतोल आणि सममितीने सुरुवात करतात. एक आकर्षक देखावा प्रदान करण्यासाठी. हा अद्वितीय सौंदर्याचा दर्जा प्रत्येक खोलीच्या किंवा जागेच्या उद्देशाशी जुळेल. अशा प्रकारे, खोलीचे स्वरूप वाढवण्यास मदत करते. उदाहरणार्थ: हे शयनकक्ष अधिक आरामशीर वाटण्यास मदत करते आणि विश्रांती वाढवते. चांगली झोप, तर होम ऑफिस क्षेत्र सर्जनशीलता आणि उत्पादकता वाढवेल.",
        WHY_US_ITEM_4: "खर्च बचत",
        WHY_US_ITEM_DATA_4: "चांगल्या इंटीरियर डिझाइनमध्ये गुंतवणूक केल्याने दीर्घकाळात मूल्य वाढते. एखाद्या इंटिरियर डिझायनरला फिक्स्चर, लाइटिंग, ड्रेप्स, पेंट, सोफा डिझाइन आणि कार्पेटिंगचे प्रकार माहित असतात जे तुम्ही घराच्या विविध भागांमध्ये लावले पाहिजेत. अनेक घरमालक व्यावसायिक इंटिरिअर डिझायनरची नेमणूक करण्याच्या खर्चात बचत करण्याचा प्रयत्न करतात आणि सौदेबाजीमध्ये ते काय स्थापित करायचे आणि ते कसे योग्यरित्या स्थापित करायचे हे शोधण्यात अधिक वेळ घालवतात. शिवाय, एक चांगला इंटीरियर डिझायनर तुम्हाला तुमचे खर्च वाचविण्यात मदत करेल. तुमच्या सध्याच्या बजेटमध्ये तुम्हाला परवडेल असे सर्वोत्तम साहित्य, फिटिंग्ज आणि फर्निचर निवडण्यात मदत करणे. हे तुम्हाला तुमच्या नवीन घरात गेल्यानंतर लवकरच महागडे नूतनीकरण आणि रीमॉडेलिंग टाळण्यास मदत करेल.",
        WHY_US_ITEM_5: "सुरक्षेच्या उद्देशाने",
        WHY_US_ITEM_DATA_5: "घराची रचना करताना विचारात घेणे ही सर्वात महत्त्वाची बाब आहे. हे महत्त्वाचे आहे कारण आवश्यक सुरक्षा आवश्यकतांच्या अभावामुळे मुलांना दुखापत होऊ शकते, विशेषत: जेव्हा ते एकटे असतात आणि घरातील धोकादायक आणि नाजूक उपकरणांभोवती खेळत असतात. योग्य सुरक्षा उपायांसह योग्यरित्या डिझाइन केलेले घर हे सुनिश्चित करते की सर्व आतील उपकरणे आवश्यक सुरक्षित ठिकाणी ठेवली जातात आणि त्या ठिकाणी धोकादायक उपकरणे मुलांच्या आवाक्याबाहेर ठेवली जातात. याशिवाय, योग्यरित्या डिझाइन केलेल्या घरातील विद्युत तारा योग्यरित्या आणि व्यवस्थित ठेवल्या जातात. - इन्सुलेटेड अशा प्रकारे मुलांसाठी आणि कोणत्याही अभ्यागतासाठी सुरक्षित आहे.",
        WHY_US_ITEM_6: "चांगली आतील रचना राखणे सोपे आहे",
        WHY_US_ITEM_DATA_6: "फक्त सुंदर घराची रचना करणे पुरेसे नाही; सौंदर्य दीर्घकाळ टिकेल याची खात्री करण्यासाठी तुम्हाला आवश्यक उपाययोजना करणे देखील आवश्यक आहे. पुढे, प्रत्येक घराची नियमित देखभाल आवश्यक आहे. योग्यरित्या डिझाइन केलेले इंटीरियर घराची सहज देखभाल सुनिश्चित करण्यास मदत करते. दीर्घकाळात. याशिवाय, जेव्हा रचना चांगली असते, तेव्हा नुकसान फारच कमी असते कारण अपघात होण्याची शक्यता नसते ज्यामुळे नाजूक फर्निचर आणि इतर कोणत्याही उपकरणाचे नुकसान होते.",
        WHY_US_ITEM_7: "चांगली रचना पुरेशी जागा सुलभ करेल",
        WHY_US_ITEM_DATA_7: "जेव्हा तुम्ही चांगल्या प्रकारे डिझाइन केलेल्या घराबद्दल बोलता तेव्हा ते जागेचे उत्तम ऑप्टिमायझेशन तसेच घरात काही प्रमाणात मोकळी जागा उपलब्ध करून देण्याची आवश्यकता असते. योग्यरित्या डिझाइन केलेले घर अधिक चांगल्या जागेची तरतूद करते, विशेषत: जेव्हा ते लिव्हिंग रूममध्ये येते तेव्हा कॉरिडॉर देखील जागा आहे त्यापेक्षा मोठी वाटण्यास मदत करतील. यामुळे खराब डिझाइन केलेल्या घरांमध्ये सामान्यतः अनावश्यक गर्दीचा पैलू दूर होईल.",
        WHY_US_ITEM_8: "योग्यरित्या डिझाइन केलेले घर पुनर्विक्री मूल्य वाढवते",
        WHY_US_ITEM_DATA_8: "तुम्हाला तुमचे घर विकायचे असल्यास, योग्य डिझाईन तुमच्या घराचे मूल्य वाढवण्यास मदत करेल. बहुतेक खरेदीदार चांगले डिझाइन केलेले घर विकत घेण्याचा विचार करत आहेत ज्यासाठी त्यांना जास्त वेळ आणि मेहनत खर्च करावी लागणार नाही. , विशेषतः भाड्याच्या बाबतीत. जर डिझाईन खराब असेल तर ते त्या विशिष्ट घरासाठी कमी पैसे देतील.",
        WHY_US_ITEM_9: "चांगल्या इंटीरियर डिझाइनचा घराच्या आणि लोकांच्या मूडवर परिणाम होतो",
        WHY_US_ITEM_DATA_9: "हे अगदी खरे आहे कारण तुम्हीच तुमच्या आवडीनुसार डिझाईन्स निवडत आहात. विशेषत: तुमच्या घराचा रंग घराच्या मूडवर परिणाम करण्यात खूप महत्त्वाची भूमिका बजावतो. जर घराच्या आतील भागांची रचना केली असेल तर तुमच्या आवडत्या रंगाने तुम्हाला त्या घरात राहण्याचा आनंद मिळेल. याशिवाय, आतील भागांच्या योग्य रचनेत नैसर्गिक प्रवाह आणि ताजी हवेचे अभिसरण समाविष्ट असेल. यामुळे घरात असताना तुम्हाला आरामदायी वाटेल. दुर्गंधी आणि गुदमरल्यासारखे देखील. त्यामुळे, तुमच्या घरात ती सुंदर आणि आनंददायी अनुभूती येण्यासाठी, आतील भाग योग्यरित्या डिझाइन केले पाहिजेत.",
        WHY_US_ITEM_10: "चांगले इंटीरियर डिझाइन एक उत्तम प्रथम छाप निर्माण करते",
        WHY_US_ITEM_DATA_10: "चांगले इंटीरियर डिझाइन केवळ तुम्हाला आनंदी आणि समाधानी वाटत नाही तर ते तुमच्या अभ्यागतांना प्रभावित करू शकते. इंटिरियर डिझाइनमुळे तुमचे घर विकसित करण्यात मदत होते ज्यामध्ये तुमची विशिष्ट सौंदर्याची प्रशंसा पूर्ण होते. तुम्ही असणे महत्वाचे आहे आणि तुमचे घर डिझाइन करणे महत्वाचे आहे. मजेशीर असायला हवे. तुमची स्वयंपाकघराची रचना असो, तुमच्या शेकोटीचा परिसर असो किंवा तुमच्या बाथरूमच्या निर्मितीची जवळीक असो, तुमची चव तुमच्या घरात तुमचा वैयक्तिक स्पर्श प्रतिबिंबित करण्यासाठी जोडली जाते.",
        WHY_US_ITEM_11: "रंग असंख्य हेतू पूर्ण करतात",
        WHY_US_ITEM_DATA_11: "इंटिरिअर डिझायनिंगमधील एक महत्त्वाचा घटक म्हणजे विशिष्ट खोल्यांसाठी रंगांची काळजीपूर्वक निवड करणे. योग्य प्रकारे केले असल्यास, रंग घरातील रहिवाशांचा मूड वाढवण्यास मदत करतात. शिवाय, ते कला आणि कोणत्याही खोलीसाठी नाटक.",
        WHY_US_ITEM_12: "वृद्ध सदस्यांना खोल्यांमध्ये सहज प्रवेश करण्यास सक्षम करते",
        WHY_US_ITEM_DATA_12: "तुमच्या घरी आजारी, शारीरिकदृष्ट्या विकलांग किंवा वृद्ध सदस्य असल्यास, तुम्ही घराची रचना कशी करता यावर अवलंबून ते त्यांची स्थिती कमी करू शकतात किंवा वाढवू शकतात. लक्षात ठेवण्यासारख्या सर्वात मूलभूत गोष्टींपैकी एक म्हणजे जागा अशा प्रकारे डिझाइन करणे. कोणत्याही प्रकारची अतिरिक्त मदत किंवा मदत न घेता ते सहजपणे घरात फिरू शकतात. या संदर्भात, ते त्यांची प्रतिष्ठा राखण्यास सक्षम असतील कारण ते स्वतःची आणि त्यांच्या दैनंदिन गरजांची काळजी घेण्यास कमी सक्षम होतील. शिवाय, हे देखील होईल. त्यांना असे वाटू द्या की ते ओझे बनून गोष्टी सुलभ करत आहेत.",
        WHY_US_ITEM_13: "तुमचे घर स्वर्गात बदलते",
        WHY_US_ITEM_DATA_13: "आजच्या दिवसात आणि युगात, आपल्या सर्वांचे वेळापत्रक व्यस्त आहे ज्यात आपल्याला दिवसाच्या शेवटी बसणे, आराम करणे आणि आराम करणे आवश्यक आहे. या संदर्भात, आपले घर विश्रांती आणि आरामाचे स्वर्ग म्हणून कार्य करते जेथे आपण फक्त असू शकता. अशाप्रकारे, चांगल्या इंटीरियर डिझाइनमुळे तुमचे घर स्वर्गीय निवासस्थानात बदलण्यास मदत होते.",
        WHY_US_ITEM_14: "होम रिट्रीट म्हणून कार्य",
        WHY_US_ITEM_DATA_14: "तुमच्या घराने केवळ कार्यक्षमता वाढवली पाहिजे असे नाही तर आरामात बसून आनंद लुटण्यासाठी एक रिट्रीट म्हणून देखील कार्य केले पाहिजे. चांगले इंटीरियर डिझाइन तुम्हाला असे घर बनवण्यास मदत करते ज्याद्वारे तुम्हाला पॉश आणि लांब सुट्ट्यांची इच्छा होणार नाही. या संदर्भात तुमचे घर, जीवनाच्या घाई-घाईतून माघार घेतल्यासारखे वाटेल असे काहीतरी असावे. शिवाय, ते तुमच्यासाठी आणि तुमच्या कुटुंबासाठी एकमेकांशी पुन्हा गुंतून राहण्याचा मार्गही असावा.",
        WHY_US_ITEM_15: "शैली योग्य पद्धतीने एकत्र करणे",
        WHY_US_ITEM_DATA_15: "एक चांगला अनुभव देणारा इंटिरियर डिझायनर समकालीन, आधुनिक, क्लासिक, इंडो-वेस्टर्न, वेस्टर्न आणि अशा अनेक सजावटीच्या शैली एकत्र करून एक फ्यूजन तयार करण्यास मदत करतो जे एक-एक प्रकारचे, सुंदर आणि तुमच्या गरजा आणि अपेक्षांशी पूर्णपणे जुळते. त्यामुळे तुमच्या सर्वात प्रशंसनीय जुन्या इंटिरिअर मास्टरपीस आणि फर्निचरला एकत्र करणे यापुढे त्रासदायक ठरणार नाही. खरं तर, त्यांना लक्ष केंद्रित करण्यासाठी सर्वात योग्य जागा मिळेल.",
        WHY_US_ITEM_16: "व्यस्त व्यक्तींसाठी सर्वोत्तम पर्याय",
        WHY_US_ITEM_DATA_16: "तुम्ही काम करत असाल आणि त्यासाठी कमी वेळ असेल तर व्यावसायिक इंटिरियर डिझायनरची नियुक्ती हा एक उत्तम पर्याय आहे. या प्रकरणात, एक इंटीरियर डिझायनर हा एक चांगला पैसा वाचवणारा, वेळेची बचत करणारा आणि तणाव कमी करणारा पर्याय आहे.",
        WHY_US_ITEM_17: "निष्कर्ष",
        WHY_US_ITEM_DATA_17: "तुमचे घर ही तुमची स्वतःची जागा आहे. जर तुम्हाला तुमचे काउंटरटॉप बदलायचे असतील, तर तुम्हाला सौंदर्यदृष्ट्या आनंद देणारी कोणतीही गोष्ट तुम्ही तेथे ठेवू शकता. तुम्ही रंग, जागा कोणती आहे, तुम्हाला क्षेत्र कसे उजळवायचे आहे याविषयी तुमच्या विचारांचे मूल्यांकन करा आणि तुमच्या स्टिरीओ किंवा तुमच्या टेलिव्हिजन सारख्या गोष्टींमध्ये तुम्हाला जोडायचे असलेले सर्व अॅक्सेसरीज. सरतेशेवटी, हे सर्व तुमच्या सौंदर्याबद्दलचे कौतुक आणि तुमच्या क्षेत्रात तुम्हाला आनंद देणारे काय तयार करायचे आहे."
    }
}

export function fetchContents(locale) {
    return async (dispatch) => {
        dispatch({ type: ActionTypes.application.FETCH_CONTENTS })
        dispatch({ type: ActionTypes.application.FETCH_CONTENTS_SUCCESS, payload: data[locale] })
    }
}

export function updateLocale(locale) {
    return async (dispatch) => {
        dispatch({ type: ActionTypes.application.UPDATE_LOCALE, payload: locale })
    }
}

export function addEvent(eventDetails) {
    return async (dispatch) => {
        dispatch({ type: ActionTypes.tracking.TRACK_EVENT, payload: eventDetails })
    }
}

export function clearEvents() {
    return async (dispatch) => {
        dispatch({ type: ActionTypes.tracking.CLEAR_EVENT })
    }
}

export function submitEvents() {
    return async (dispatch) => {
        dispatch({ type: ActionTypes.tracking.SUBMIT_EVENTS })
    }
}